(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3aac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3aac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gnS5A", function(module, exports) {

$parcel$export(module.exports, "rotation", function () { return ye; });

var $6qd2L = parcelRequire("6qd2L");

var $3aNd6 = parcelRequire("3aNd6");
var $49decdd7c8e65498$require$Buffer = $3aNd6.Buffer;
function e(e, t, s) {
    return t in e ? Object.defineProperty(e, t, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : $parcel$global;
const s = "undefined" != typeof navigator, i = s && "undefined" == typeof HTMLImageElement, n = !("undefined" == typeof $parcel$global || "undefined" == typeof $6qd2L || !$6qd2L.versions || !$6qd2L.versions.node), r = t.Buffer, a = !!r, h = (e)=>void 0 !== e;
function f(e) {
    return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
    let t = new Error(e);
    throw delete t.stack, t;
}
function o(e) {
    let t = function(e) {
        let t = 0;
        return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
    }(e);
    return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
const u = (e)=>String.fromCharCode.apply(null, e), d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
class c {
    static from(e, t) {
        return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
    constructor(e, t = 0, s, i){
        if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
        else if (e instanceof ArrayBuffer) {
            void 0 === s && (s = e.byteLength - t);
            let i = new DataView(e, t, s);
            this._swapDataView(i);
        } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
            void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
            let i = new DataView(e.buffer, t, s);
            this._swapDataView(i);
        } else if ("number" == typeof e) {
            let t = new DataView(new ArrayBuffer(e));
            this._swapDataView(t);
        } else l("Invalid input argument for BufferView: " + e);
    }
    _swapArrayBuffer(e) {
        this._swapDataView(new DataView(e));
    }
    _swapBuffer(e) {
        this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
    _swapDataView(e) {
        this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
    _lengthToEnd(e) {
        return this.byteLength - e;
    }
    set(e, t, s = c) {
        return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
    subarray(e, t) {
        return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
    toUint8() {
        return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
    getUint8Array(e, t) {
        return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
    getString(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        var i;
        return i = s, d ? d.decode(i) : a ? $49decdd7c8e65498$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
    }
    getLatin1String(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        return u(s);
    }
    getUnicodeString(e = 0, t = this.byteLength) {
        const s = [];
        for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
        return u(s);
    }
    getInt8(e) {
        return this.dataView.getInt8(e);
    }
    getUint8(e) {
        return this.dataView.getUint8(e);
    }
    getInt16(e, t = this.le) {
        return this.dataView.getInt16(e, t);
    }
    getInt32(e, t = this.le) {
        return this.dataView.getInt32(e, t);
    }
    getUint16(e, t = this.le) {
        return this.dataView.getUint16(e, t);
    }
    getUint32(e, t = this.le) {
        return this.dataView.getUint32(e, t);
    }
    getFloat32(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getFloat64(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getFloat(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getDouble(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getUintBytes(e, t, s) {
        switch(t){
            case 1:
                return this.getUint8(e, s);
            case 2:
                return this.getUint16(e, s);
            case 4:
                return this.getUint32(e, s);
            case 8:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    getUint(e, t, s) {
        switch(t){
            case 8:
                return this.getUint8(e, s);
            case 16:
                return this.getUint16(e, s);
            case 32:
                return this.getUint32(e, s);
            case 64:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    toString(e) {
        return this.dataView.toString(e, this.constructor.name);
    }
    ensureChunk() {}
}
function p(e, t) {
    l(`${e} '${t}' was not loaded, try using full build of exifr.`);
}
class g extends Map {
    constructor(e){
        super(), this.kind = e;
    }
    get(e, t) {
        return this.has(e) || p(this.kind, e), t && (e in t || function(e, t) {
            l(`Unknown ${e} '${t}'.`);
        }(this.kind, e), t[e].enabled || p(this.kind, e)), super.get(e);
    }
    keyList() {
        return Array.from(this.keys());
    }
}
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e, t) {
    var i;
    return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
}
async function O(e, t, s, i) {
    return b.has(s) ? v(e, t, s) : i ? async function(e, t) {
        let s = await t(e);
        return new c(s);
    }(e, i) : void l(`Parser ${s} is not loaded`);
}
async function v(e, t, s) {
    let i = new (b.get(s))(e, t);
    return await i.read(), i;
}
const S = (e)=>w(e).then((e)=>e.arrayBuffer()), A = (e)=>new Promise((t, s)=>{
        let i = new FileReader;
        i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
    });
class U extends Map {
    get tagKeys() {
        return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
    get tagValues() {
        return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
}
function x(e, t, s) {
    let i = new U;
    for (let [e, t] of s)i.set(e, t);
    if (Array.isArray(t)) for (let s of t)e.set(s, i);
    else e.set(t, i);
    return i;
}
function C(e, t, s) {
    let i, n = e.get(t);
    for (i of s)n.set(i[0], i[1]);
}
const B = new Map, V = new Map, I = new Map, L = [
    "chunked",
    "firstChunkSize",
    "firstChunkSizeNode",
    "firstChunkSizeBrowser",
    "chunkSize",
    "chunkLimit"
], T = [
    "jfif",
    "xmp",
    "icc",
    "iptc",
    "ihdr"
], z = [
    "tiff",
    ...T
], P = [
    "ifd0",
    "ifd1",
    "exif",
    "gps",
    "interop"
], F = [
    ...z,
    ...P
], j = [
    "makerNote",
    "userComment"
], E = [
    "translateKeys",
    "translateValues",
    "reviveValues",
    "multiSegment"
], M = [
    ...E,
    "sanitize",
    "mergeOutput",
    "silentErrors"
];
class _ {
    get translate() {
        return this.translateKeys || this.translateValues || this.reviveValues;
    }
}
class D extends _ {
    get needed() {
        return this.enabled || this.deps.size > 0;
    }
    constructor(t, s, i, n){
        if (super(), e(this, "enabled", !1), e(this, "skip", new Set), e(this, "pick", new Set), e(this, "deps", new Set), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = P.includes(t), this.canBeFiltered && (this.dict = B.get(t)), void 0 !== i) {
            if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
            else if ("object" == typeof i) {
                if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                    let { pick: e, skip: t } = i;
                    e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                }
                this.applyInheritables(i);
            } else !0 === i || !1 === i ? this.parse = this.enabled = i : l(`Invalid options argument: ${i}`);
        }
    }
    applyInheritables(e) {
        let t, s;
        for (t of E)s = e[t], void 0 !== s && (this[t] = s);
    }
    translateTagSet(e, t) {
        if (this.dict) {
            let s, i, { tagKeys: n, tagValues: r } = this.dict;
            for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
        } else for (let s of e)t.add(s);
    }
    finalizeFilters() {
        !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
}
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
}, $ = new Map;
class R extends _ {
    static useCached(e) {
        let t = $.get(e);
        return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
    constructor(e){
        super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : l(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
    }
    setupFromUndefined() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = N[e];
        for (e of F)this[e] = new D(e, N[e], void 0, this);
    }
    setupFromTrue() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = !0;
        for (e of F)this[e] = new D(e, !0, void 0, this);
    }
    setupFromArray(e) {
        let t;
        for (t of L)this[t] = N[t];
        for (t of M)this[t] = N[t];
        for (t of j)this[t] = N[t];
        for (t of F)this[t] = new D(t, !1, void 0, this);
        this.setupGlobalFilters(e, void 0, P);
    }
    setupFromObject(e) {
        let t;
        for (t of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L))this[t] = W(e[t], N[t]);
        for (t of M)this[t] = W(e[t], N[t]);
        for (t of j)this[t] = W(e[t], N[t]);
        for (t of z)this[t] = new D(t, N[t], e[t], this);
        for (t of P)this[t] = new D(t, N[t], e[t], this.tiff);
        this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
    batchEnableWithBool(e, t) {
        for (let s of e)this[s].enabled = t;
    }
    batchEnableWithUserValue(e, t) {
        for (let s of e){
            let e = t[s];
            this[s].enabled = !1 !== e && void 0 !== e;
        }
    }
    setupGlobalFilters(e, t, s, i = s) {
        if (e && e.length) {
            for (let e of i)this[e].enabled = !1;
            let t = K(e, s);
            for (let [e, s] of t)X(this[e].pick, s), this[e].enabled = !0;
        } else if (t && t.length) {
            let e = K(t, s);
            for (let [t, s] of e)X(this[t].skip, s);
        }
    }
    filterNestedSegmentTags() {
        let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
        this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
    traverseTiffDependencyTree() {
        let { ifd0: e, exif: t, gps: s, interop: i } = this;
        i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
        for (let e of P)this[e].finalizeFilters();
    }
    get onlyTiff() {
        return !T.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
    }
    checkLoadedPlugins() {
        for (let e of z)this[e].enabled && !y.has(e) && p("segment parser", e);
    }
}
function K(e, t) {
    let s, i, n, r, a = [];
    for (n of t){
        for (r of (s = B.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        i.length && a.push([
            n,
            i
        ]);
    }
    return a;
}
function W(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
    for (let s of t)e.add(s);
}
e(R, "default", N);
class H {
    constructor(t){
        e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = R.useCached(t);
    }
    async read(e) {
        this.file = await function(e, t) {
            return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
        }(e, this.options);
    }
    setup() {
        if (this.fileParser) return;
        let { file: e } = this, t = e.getUint16(0);
        for (let [s, i] of m)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
        this.file.close && this.file.close(), l("Unknown file format");
    }
    async parse() {
        let { output: e, errors: t } = this;
        var s;
        return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), f(s = e) ? void 0 : s;
    }
    async executeParsers() {
        let { output: e } = this;
        await this.fileParser.parse();
        let t = Object.values(this.parsers).map(async (t)=>{
            let s = await t.parse();
            t.assignToOutput(e, s);
        });
        this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
    }
    async extractThumbnail() {
        this.setup();
        let { options: e, file: t } = this, s = y.get("tiff", e);
        var i;
        if (t.tiff ? i = {
            start: 0,
            type: "tiff"
        } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
        let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
        return t.close && t.close(), a;
    }
}
async function Y(e, t) {
    let s = new H(t);
    return await s.read(e), s.parse();
}
var G = Object.freeze({
    __proto__: null,
    parse: Y,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R
});
class J {
    static findPosition(e, t) {
        let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
        return {
            offset: t,
            length: s,
            headerLength: i,
            start: n,
            size: r,
            end: n + r
        };
    }
    static parse(e, t = {}) {
        return new this(e, new R({
            [this.type]: t
        }), e).parse();
    }
    normalizeInput(e) {
        return e instanceof c ? e : new c(e);
    }
    constructor(t, s = {}, i){
        e(this, "errors", []), e(this, "raw", new Map), e(this, "handleError", (e)=>{
            if (!this.options.silentErrors) throw e;
            this.errors.push(e.message);
        }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
    }
    translate() {
        this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
    get output() {
        return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
    translateBlock(e, t) {
        let s = I.get(t), i = V.get(t), n = B.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
        for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
        return l;
    }
    translateValue(e, t) {
        return t[e] || t.DEFAULT || e;
    }
    assignToOutput(e, t) {
        this.assignObjectToOutput(e, this.constructor.type, t);
    }
    assignObjectToOutput(e, t, s) {
        if (this.globalOptions.mergeOutput) return Object.assign(e, s);
        e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
}
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", ()=>!1);
function q(e) {
    return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
    return e >= 224 && e <= 239;
}
function Z(e, t, s) {
    for (let [i, n] of y)if (n.canHandle(e, t, s)) return i;
}
class ee extends class {
    constructor(t, s, i){
        e(this, "errors", []), e(this, "ensureSegmentChunk", async (e)=>{
            let t = e.start, s = e.size || 65536;
            if (this.file.chunked) {
                if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                else try {
                    e.chunk = await this.file.readChunk(t, s);
                } catch (t) {
                    l(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                }
            } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            return e.chunk;
        }), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
    }
    injectSegment(e, t) {
        this.options[e].enabled && this.createParser(e, t);
    }
    createParser(e, t) {
        let s = new (y.get(e))(t, this.options, this.file);
        return this.parsers[e] = s;
    }
    createParsers(e) {
        for (let t of e){
            let { type: e, chunk: s } = t, i = this.options[e];
            if (i && i.enabled) {
                let t = this.parsers[e];
                t && t.append || t || this.createParser(e, s);
            }
        }
    }
    async readSegments(e) {
        let t = e.map(this.ensureSegmentChunk);
        await Promise.all(t);
    }
} {
    constructor(...t){
        super(...t), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
    }
    static canHandle(e, t) {
        return 65496 === t;
    }
    async parse() {
        await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
    }
    setupSegmentFinderArgs(e) {
        !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && y.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
    async findAppSegments(e = 0, t) {
        this.setupSegmentFinderArgs(t);
        let { file: s, findAll: i, wanted: n, remaining: r } = this;
        if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
            let t = y.get(e), s = this.options[e];
            return t.multiSegment && s.multiSegment;
        }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
            let t = !1;
            for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
            }
        }
    }
    findAppSegmentsInRange(e, t) {
        t -= 2;
        let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
        for(; e < t; e++)if (255 === f.getUint8(e)) {
            if (s = f.getUint8(e + 1), Q(s)) {
                if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
            } else if (q(s)) {
                if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                d.recordJpegSegments && this.jpegSegments.push({
                    offset: e,
                    length: i,
                    marker: s
                }), e += i + 1;
            }
        }
        return e;
    }
    mergeMultiSegments() {
        if (!this.appSegments.some((e)=>e.multiSegment)) return;
        let e = function(e, t) {
            let s, i, n, r = new Map;
            for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
            return Array.from(r);
        }(this.appSegments, "type");
        this.mergedAppSegments = e.map(([e, t])=>{
            let s = y.get(e, this.options);
            if (s.handleMultiSegments) return {
                type: e,
                chunk: s.handleMultiSegments(t)
            };
            return t[0];
        });
    }
    getSegment(e) {
        return this.appSegments.find((t)=>t.type === e);
    }
    async getOrFindSegment(e) {
        let t = this.getSegment(e);
        return void 0 === t && (await this.findAppSegments(0, [
            e
        ]), t = this.getSegment(e)), t;
    }
}
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [
    void 0,
    1,
    1,
    2,
    4,
    8,
    1,
    1,
    2,
    4,
    8,
    4,
    8,
    4
];
class se extends J {
    parseHeader() {
        var e = this.chunk.getUint16();
        18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
    parseTags(e, t, s = new Map) {
        let { pick: i, skip: n } = this.options[t];
        i = new Set(i);
        let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
        e += 2;
        for(let f = 0; f < h; f++){
            let h = this.chunk.getUint16(e);
            if (r) {
                if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
            } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
            e += 12;
        }
        return s;
    }
    parseTag(e, t, s) {
        let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = te[n];
        if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && l(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
        if (2 === n) return "" === (h = (function(e) {
            for(; e.endsWith("\0");)e = e.slice(0, -1);
            return e;
        })(h = i.getString(e, r)).trim()) ? void 0 : h;
        var h;
        if (7 === n) return i.getUint8Array(e, r);
        if (1 === r) return this.parseTagValue(n, e);
        {
            let t = new (function(e) {
                switch(e){
                    case 1:
                        return Uint8Array;
                    case 3:
                        return Uint16Array;
                    case 4:
                        return Uint32Array;
                    case 5:
                        return Array;
                    case 6:
                        return Int8Array;
                    case 8:
                        return Int16Array;
                    case 9:
                        return Int32Array;
                    case 10:
                        return Array;
                    case 11:
                        return Float32Array;
                    case 12:
                        return Float64Array;
                    default:
                        return Array;
                }
            }(n))(r), s = a;
            for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
            return t;
        }
    }
    parseTagValue(e, t) {
        let { chunk: s } = this;
        switch(e){
            case 1:
                return s.getUint8(t);
            case 3:
                return s.getUint16(t);
            case 4:
                return s.getUint32(t);
            case 5:
                return s.getUint32(t) / s.getUint32(t + 4);
            case 6:
                return s.getInt8(t);
            case 8:
                return s.getInt16(t);
            case 9:
                return s.getInt32(t);
            case 10:
                return s.getInt32(t) / s.getInt32(t + 4);
            case 11:
                return s.getFloat(t);
            case 12:
                return s.getDouble(t);
            case 13:
                return s.getUint32(t);
            default:
                l(`Invalid tiff type ${e}`);
        }
    }
}
class ie extends se {
    static canHandle(e, t) {
        return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
    async parse() {
        this.parseHeader();
        let { options: e } = this;
        return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
    }
    safeParse(e) {
        let t = this[e]();
        return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
    findIfd0Offset() {
        void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
    findIfd1Offset() {
        if (void 0 === this.ifd1Offset) {
            this.findIfd0Offset();
            let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
            this.ifd1Offset = this.chunk.getUint32(t);
        }
    }
    parseBlock(e, t) {
        let s = new Map;
        return this[t] = s, this.parseTags(e, t, s), s;
    }
    async parseIfd0Block() {
        if (this.ifd0) return;
        let { file: e } = this;
        this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && l(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, o(this.options));
        let t = this.parseBlock(this.ifd0Offset, "ifd0");
        return 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0;
    }
    async parseExifBlock() {
        if (this.exif) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
        this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
        let e = this.parseBlock(this.exifOffset, "exif");
        return this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e;
    }
    unpack(e, t) {
        let s = e.get(t);
        s && 1 === s.length && e.set(t, s[0]);
    }
    async parseGpsBlock() {
        if (this.gps) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
        let e = this.parseBlock(this.gpsOffset, "gps");
        return e && e.has(2) && e.has(4) && (e.set("latitude", ne(...e.get(2), e.get(1))), e.set("longitude", ne(...e.get(4), e.get(3)))), e;
    }
    async parseInteropBlock() {
        if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
    }
    async parseThumbnailBlock(e = !1) {
        if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
    }
    async extractThumbnail() {
        if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
        let e = this.ifd1.get(513), t = this.ifd1.get(514);
        return this.chunk.getUint8Array(e, t);
    }
    get image() {
        return this.ifd0;
    }
    get thumbnail() {
        return this.ifd1;
    }
    createOutput() {
        let e, t, s, i = {};
        for (t of P)if (e = this[t], !f(e)) {
            if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                if ("ifd1" === t) continue;
                Object.assign(i, s);
            } else i[t] = s;
        }
        return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
    assignToOutput(e, t) {
        if (this.globalOptions.mergeOutput) Object.assign(e, t);
        else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
    }
}
function ne(e, t, s, i) {
    var n = e + t / 60 + s / 3600;
    return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
    __proto__: null,
    default: G,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R,
    parse: Y
});
const ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
}, he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [
        1,
        2,
        3,
        4
    ]
});
async function fe(e) {
    let t = new H(he);
    await t.read(e);
    let s = await t.parse();
    if (s && s.gps) {
        let { latitude: e, longitude: t } = s.gps;
        return {
            latitude: e,
            longitude: t
        };
    }
}
const le = Object.assign({}, ae, {
    tiff: !1,
    ifd1: !0,
    mergeOutput: !1
});
async function oe(e) {
    let t = new H(le);
    await t.read(e);
    let s = await t.extractThumbnail();
    return s && a ? r.from(s) : s;
}
async function ue(e) {
    let t = await this.thumbnail(e);
    if (void 0 !== t) {
        let e = new Blob([
            t
        ]);
        return URL.createObjectURL(e);
    }
}
const de = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    ifd0: [
        274
    ]
});
async function ce(e) {
    let t = new H(de);
    await t.read(e);
    let s = await t.parse();
    if (s && s.ifd0) return s.ifd0[274];
}
const pe = Object.freeze({
    1: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    2: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    3: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    4: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    5: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    6: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    7: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 270,
        rad: 270 * Math.PI / 180
    },
    8: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 270,
        rad: 270 * Math.PI / 180
    }
});
let ge = !0, me = !0;
if ("object" == typeof navigator) {
    let e = navigator.userAgent;
    if (e.includes("iPad") || e.includes("iPhone")) {
        let t = e.match(/OS (\d+)_(\d+)/);
        if (t) {
            let [, e, s] = t, i = Number(e) + .1 * Number(s);
            ge = i < 13.4, me = !1;
        }
    } else if (e.includes("OS X 10")) {
        let [, t] = e.match(/OS X 10[_.](\d+)/);
        ge = me = Number(t) < 15;
    }
    if (e.includes("Chrome/")) {
        let [, t] = e.match(/Chrome\/(\d+)/);
        ge = me = Number(t) < 81;
    } else if (e.includes("Firefox/")) {
        let [, t] = e.match(/Firefox\/(\d+)/);
        ge = me = Number(t) < 77;
    }
}
async function ye(e) {
    let t = await ce(e);
    return Object.assign({
        canvas: ge,
        css: me
    }, pe[t]);
}
class be extends c {
    constructor(...t){
        super(...t), e(this, "ranges", new we), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
    }
    _tryExtend(e, t, s) {
        if (0 === e && 0 === this.byteLength && s) {
            let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
            this._swapDataView(e);
        } else {
            let s = e + t;
            if (s > this.byteLength) {
                let { dataView: e } = this._extend(s);
                this._swapDataView(e);
            }
        }
    }
    _extend(e) {
        let t;
        t = a ? r.allocUnsafe(e) : new Uint8Array(e);
        let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
        return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
            uintView: t,
            dataView: s
        };
    }
    subarray(e, t, s = !1) {
        return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
    }
    set(e, t, s = !1) {
        s && this._tryExtend(t, e.byteLength, e);
        let i = super.set(e, t);
        return this.ranges.add(t, i.byteLength), i;
    }
    async ensureChunk(e, t) {
        this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
    }
    available(e, t) {
        return this.ranges.available(e, t);
    }
}
class we {
    constructor(){
        e(this, "list", []);
    }
    get length() {
        return this.list.length;
    }
    add(e, t, s = 0) {
        let i = e + t, n = this.list.filter((t)=>ke(e, t.offset, i) || ke(e, t.end, i));
        if (n.length > 0) {
            e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
            let s = n.shift();
            s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
        } else this.list.push({
            offset: e,
            length: t,
            end: i
        });
    }
    available(e, t) {
        let s = e + t;
        return this.list.some((t)=>t.offset <= e && s <= t.end);
    }
}
function ke(e, t, s) {
    return e <= t && t <= s;
}
class Oe extends be {
    constructor(t, s){
        super(0), e(this, "chunksRead", 0), this.input = t, this.options = s;
    }
    async readWhole() {
        this.chunked = !1, await this.readChunk(this.nextChunkOffset);
    }
    async readChunked() {
        this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
    }
    async readNextChunk(e = this.nextChunkOffset) {
        if (this.fullyRead) return this.chunksRead++, !1;
        let t = this.options.chunkSize, s = await this.readChunk(e, t);
        return !!s && s.byteLength === t;
    }
    async readChunk(e, t) {
        if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
    }
    safeWrapAddress(e, t) {
        return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
    get nextChunkOffset() {
        if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
    get canReadNextChunk() {
        return this.chunksRead < this.options.chunkLimit;
    }
    get fullyRead() {
        return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
    read() {
        return this.options.chunked ? this.readChunked() : this.readWhole();
    }
    close() {}
}
b.set("blob", class extends Oe {
    async readWhole() {
        this.chunked = !1;
        let e = await A(this.input);
        this._swapArrayBuffer(e);
    }
    readChunked() {
        return this.chunked = !0, this.size = this.input.size, super.readChunked();
    }
    async _readChunk(e, t) {
        let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await A(i);
        return this.set(n, e, !0);
    }
});
var $49decdd7c8e65498$export$2e2bcd8739ae039 = re;

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("dc6El", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99b18dd98d1424fc$export$2e2bcd8739ae039; });
// packages/alpinejs/src/scheduler.js
var $99b18dd98d1424fc$var$flushPending = false;
var $99b18dd98d1424fc$var$flushing = false;
var $99b18dd98d1424fc$var$queue = [];
var $99b18dd98d1424fc$var$lastFlushedIndex = -1;
function $99b18dd98d1424fc$var$scheduler(callback) {
    $99b18dd98d1424fc$var$queueJob(callback);
}
function $99b18dd98d1424fc$var$queueJob(job) {
    if (!$99b18dd98d1424fc$var$queue.includes(job)) $99b18dd98d1424fc$var$queue.push(job);
    $99b18dd98d1424fc$var$queueFlush();
}
function $99b18dd98d1424fc$var$dequeueJob(job) {
    let index = $99b18dd98d1424fc$var$queue.indexOf(job);
    if (index !== -1 && index > $99b18dd98d1424fc$var$lastFlushedIndex) $99b18dd98d1424fc$var$queue.splice(index, 1);
}
function $99b18dd98d1424fc$var$queueFlush() {
    if (!$99b18dd98d1424fc$var$flushing && !$99b18dd98d1424fc$var$flushPending) {
        $99b18dd98d1424fc$var$flushPending = true;
        queueMicrotask($99b18dd98d1424fc$var$flushJobs);
    }
}
function $99b18dd98d1424fc$var$flushJobs() {
    $99b18dd98d1424fc$var$flushPending = false;
    $99b18dd98d1424fc$var$flushing = true;
    for(let i = 0; i < $99b18dd98d1424fc$var$queue.length; i++){
        $99b18dd98d1424fc$var$queue[i]();
        $99b18dd98d1424fc$var$lastFlushedIndex = i;
    }
    $99b18dd98d1424fc$var$queue.length = 0;
    $99b18dd98d1424fc$var$lastFlushedIndex = -1;
    $99b18dd98d1424fc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $99b18dd98d1424fc$var$reactive;
var $99b18dd98d1424fc$var$effect;
var $99b18dd98d1424fc$var$release;
var $99b18dd98d1424fc$var$raw;
var $99b18dd98d1424fc$var$shouldSchedule = true;
function $99b18dd98d1424fc$var$disableEffectScheduling(callback) {
    $99b18dd98d1424fc$var$shouldSchedule = false;
    callback();
    $99b18dd98d1424fc$var$shouldSchedule = true;
}
function $99b18dd98d1424fc$var$setReactivityEngine(engine) {
    $99b18dd98d1424fc$var$reactive = engine.reactive;
    $99b18dd98d1424fc$var$release = engine.release;
    $99b18dd98d1424fc$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($99b18dd98d1424fc$var$shouldSchedule) $99b18dd98d1424fc$var$scheduler(task);
                else task();
            }
        });
    $99b18dd98d1424fc$var$raw = engine.raw;
}
function $99b18dd98d1424fc$var$overrideEffect(override) {
    $99b18dd98d1424fc$var$effect = override;
}
function $99b18dd98d1424fc$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $99b18dd98d1424fc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $99b18dd98d1424fc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $99b18dd98d1424fc$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $99b18dd98d1424fc$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$99b18dd98d1424fc$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $99b18dd98d1424fc$var$onAttributeAddeds = [];
var $99b18dd98d1424fc$var$onElRemoveds = [];
var $99b18dd98d1424fc$var$onElAddeds = [];
function $99b18dd98d1424fc$var$onElAdded(callback) {
    $99b18dd98d1424fc$var$onElAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $99b18dd98d1424fc$var$onElRemoveds.push(callback);
    }
}
function $99b18dd98d1424fc$var$onAttributesAdded(callback) {
    $99b18dd98d1424fc$var$onAttributeAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $99b18dd98d1424fc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $99b18dd98d1424fc$var$cleanupElement(el) {
    el._x_effects?.forEach($99b18dd98d1424fc$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $99b18dd98d1424fc$var$observer = new MutationObserver($99b18dd98d1424fc$var$onMutate);
var $99b18dd98d1424fc$var$currentlyObserving = false;
function $99b18dd98d1424fc$var$startObservingMutations() {
    $99b18dd98d1424fc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $99b18dd98d1424fc$var$currentlyObserving = true;
}
function $99b18dd98d1424fc$var$stopObservingMutations() {
    $99b18dd98d1424fc$var$flushObserver();
    $99b18dd98d1424fc$var$observer.disconnect();
    $99b18dd98d1424fc$var$currentlyObserving = false;
}
var $99b18dd98d1424fc$var$queuedMutations = [];
function $99b18dd98d1424fc$var$flushObserver() {
    let records = $99b18dd98d1424fc$var$observer.takeRecords();
    $99b18dd98d1424fc$var$queuedMutations.push(()=>records.length > 0 && $99b18dd98d1424fc$var$onMutate(records));
    let queueLengthWhenTriggered = $99b18dd98d1424fc$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($99b18dd98d1424fc$var$queuedMutations.length === queueLengthWhenTriggered) while($99b18dd98d1424fc$var$queuedMutations.length > 0)$99b18dd98d1424fc$var$queuedMutations.shift()();
    });
}
function $99b18dd98d1424fc$var$mutateDom(callback) {
    if (!$99b18dd98d1424fc$var$currentlyObserving) return callback();
    $99b18dd98d1424fc$var$stopObservingMutations();
    let result = callback();
    $99b18dd98d1424fc$var$startObservingMutations();
    return result;
}
var $99b18dd98d1424fc$var$isCollecting = false;
var $99b18dd98d1424fc$var$deferredMutations = [];
function $99b18dd98d1424fc$var$deferMutations() {
    $99b18dd98d1424fc$var$isCollecting = true;
}
function $99b18dd98d1424fc$var$flushAndStopDeferringMutations() {
    $99b18dd98d1424fc$var$isCollecting = false;
    $99b18dd98d1424fc$var$onMutate($99b18dd98d1424fc$var$deferredMutations);
    $99b18dd98d1424fc$var$deferredMutations = [];
}
function $99b18dd98d1424fc$var$onMutate(mutations) {
    if ($99b18dd98d1424fc$var$isCollecting) {
        $99b18dd98d1424fc$var$deferredMutations = $99b18dd98d1424fc$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $99b18dd98d1424fc$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $99b18dd98d1424fc$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $99b18dd98d1424fc$var$scope(node) {
    return $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$closestDataStack(node));
}
function $99b18dd98d1424fc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$99b18dd98d1424fc$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $99b18dd98d1424fc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $99b18dd98d1424fc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $99b18dd98d1424fc$var$closestDataStack(node.parentNode);
}
function $99b18dd98d1424fc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $99b18dd98d1424fc$var$mergeProxyTrap);
}
var $99b18dd98d1424fc$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $99b18dd98d1424fc$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $99b18dd98d1424fc$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $99b18dd98d1424fc$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $99b18dd98d1424fc$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$99b18dd98d1424fc$var$get(data2, path), (value)=>$99b18dd98d1424fc$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $99b18dd98d1424fc$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $99b18dd98d1424fc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $99b18dd98d1424fc$var$magics = {};
function $99b18dd98d1424fc$var$magic(name, callback) {
    $99b18dd98d1424fc$var$magics[name] = callback;
}
function $99b18dd98d1424fc$var$injectMagics(obj, el) {
    let memoizedUtilities = $99b18dd98d1424fc$var$getUtilities(el);
    Object.entries($99b18dd98d1424fc$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$getUtilities(el) {
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $99b18dd98d1424fc$var$interceptor,
        ...utilities
    };
    $99b18dd98d1424fc$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $99b18dd98d1424fc$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $99b18dd98d1424fc$var$handleError(e, el, expression);
    }
}
function $99b18dd98d1424fc$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = true;
function $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(callback) {
    let cache = $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions;
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $99b18dd98d1424fc$var$evaluate(el, expression, extras = {}) {
    let result;
    $99b18dd98d1424fc$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $99b18dd98d1424fc$var$evaluateLater(...args) {
    return $99b18dd98d1424fc$var$theEvaluatorFunction(...args);
}
var $99b18dd98d1424fc$var$theEvaluatorFunction = $99b18dd98d1424fc$var$normalEvaluator;
function $99b18dd98d1424fc$var$setEvaluator(newEvaluator) {
    $99b18dd98d1424fc$var$theEvaluatorFunction = newEvaluator;
}
function $99b18dd98d1424fc$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $99b18dd98d1424fc$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$99b18dd98d1424fc$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, expression) : $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $99b18dd98d1424fc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $99b18dd98d1424fc$var$evaluatorMemo = {};
function $99b18dd98d1424fc$var$generateFunctionFromString(expression, el) {
    if ($99b18dd98d1424fc$var$evaluatorMemo[expression]) return $99b18dd98d1424fc$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $99b18dd98d1424fc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $99b18dd98d1424fc$var$evaluatorMemo[expression] = func;
    return func;
}
function $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $99b18dd98d1424fc$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression));
            if (func.finished) {
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($99b18dd98d1424fc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $99b18dd98d1424fc$var$prefixAsString = "x-";
function $99b18dd98d1424fc$var$prefix(subject = "") {
    return $99b18dd98d1424fc$var$prefixAsString + subject;
}
function $99b18dd98d1424fc$var$setPrefix(newPrefix) {
    $99b18dd98d1424fc$var$prefixAsString = newPrefix;
}
var $99b18dd98d1424fc$var$directiveHandlers = {};
function $99b18dd98d1424fc$var$directive(name, callback) {
    $99b18dd98d1424fc$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$99b18dd98d1424fc$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $99b18dd98d1424fc$var$directiveOrder.indexOf(directive2);
            $99b18dd98d1424fc$var$directiveOrder.splice(pos >= 0 ? pos : $99b18dd98d1424fc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $99b18dd98d1424fc$var$directiveExists(name) {
    return Object.keys($99b18dd98d1424fc$var$directiveHandlers).includes(name);
}
function $99b18dd98d1424fc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($99b18dd98d1424fc$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($99b18dd98d1424fc$var$outNonAlpineAttributes).map($99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($99b18dd98d1424fc$var$byPriority);
    return directives2.map((directive2)=>{
        return $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2);
    });
}
function $99b18dd98d1424fc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($99b18dd98d1424fc$var$toTransformedAttributes()).filter((attr)=>!$99b18dd98d1424fc$var$outNonAlpineAttributes(attr));
}
var $99b18dd98d1424fc$var$isDeferringHandlers = false;
var $99b18dd98d1424fc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $99b18dd98d1424fc$var$currentHandlerStackKey = Symbol();
function $99b18dd98d1424fc$var$deferHandlingDirectives(callback) {
    $99b18dd98d1424fc$var$isDeferringHandlers = true;
    let key = Symbol();
    $99b18dd98d1424fc$var$currentHandlerStackKey = key;
    $99b18dd98d1424fc$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($99b18dd98d1424fc$var$directiveHandlerStacks.get(key).length)$99b18dd98d1424fc$var$directiveHandlerStacks.get(key).shift()();
        $99b18dd98d1424fc$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $99b18dd98d1424fc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $99b18dd98d1424fc$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $99b18dd98d1424fc$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $99b18dd98d1424fc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $99b18dd98d1424fc$var$evaluateLater.bind($99b18dd98d1424fc$var$evaluateLater, el),
        evaluate: $99b18dd98d1424fc$var$evaluate.bind($99b18dd98d1424fc$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $99b18dd98d1424fc$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    $99b18dd98d1424fc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $99b18dd98d1424fc$var$isDeferringHandlers ? $99b18dd98d1424fc$var$directiveHandlerStacks.get($99b18dd98d1424fc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $99b18dd98d1424fc$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $99b18dd98d1424fc$var$into = (i)=>i;
function $99b18dd98d1424fc$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $99b18dd98d1424fc$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $99b18dd98d1424fc$var$attributeTransformers = [];
function $99b18dd98d1424fc$var$mapAttributes(callback) {
    $99b18dd98d1424fc$var$attributeTransformers.push(callback);
}
function $99b18dd98d1424fc$var$outNonAlpineAttributes({ name: name }) {
    return $99b18dd98d1424fc$var$alpineAttributeRegex().test(name);
}
var $99b18dd98d1424fc$var$alpineAttributeRegex = ()=>new RegExp(`^${$99b18dd98d1424fc$var$prefixAsString}([^:^.]+)\\b`);
function $99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($99b18dd98d1424fc$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $99b18dd98d1424fc$var$DEFAULT = "DEFAULT";
var $99b18dd98d1424fc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $99b18dd98d1424fc$var$DEFAULT,
    "teleport"
];
function $99b18dd98d1424fc$var$byPriority(a, b) {
    let typeA = $99b18dd98d1424fc$var$directiveOrder.indexOf(a.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : a.type;
    let typeB = $99b18dd98d1424fc$var$directiveOrder.indexOf(b.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : b.type;
    return $99b18dd98d1424fc$var$directiveOrder.indexOf(typeA) - $99b18dd98d1424fc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $99b18dd98d1424fc$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $99b18dd98d1424fc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$99b18dd98d1424fc$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $99b18dd98d1424fc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $99b18dd98d1424fc$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $99b18dd98d1424fc$var$started = false;
function $99b18dd98d1424fc$var$start() {
    if ($99b18dd98d1424fc$var$started) $99b18dd98d1424fc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $99b18dd98d1424fc$var$started = true;
    if (!document.body) $99b18dd98d1424fc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:init");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initializing");
    $99b18dd98d1424fc$var$startObservingMutations();
    $99b18dd98d1424fc$var$onElAdded((el)=>$99b18dd98d1424fc$var$initTree(el, $99b18dd98d1424fc$var$walk));
    $99b18dd98d1424fc$var$onElRemoved((el)=>$99b18dd98d1424fc$var$destroyTree(el));
    $99b18dd98d1424fc$var$onAttributesAdded((el, attrs)=>{
        $99b18dd98d1424fc$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$99b18dd98d1424fc$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($99b18dd98d1424fc$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $99b18dd98d1424fc$var$initTree(el);
    });
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $99b18dd98d1424fc$var$warnAboutMissingPlugins();
    });
}
var $99b18dd98d1424fc$var$rootSelectorCallbacks = [];
var $99b18dd98d1424fc$var$initSelectorCallbacks = [];
function $99b18dd98d1424fc$var$rootSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $99b18dd98d1424fc$var$allSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.concat($99b18dd98d1424fc$var$initSelectorCallbacks).map((fn)=>fn());
}
function $99b18dd98d1424fc$var$addRootSelector(selectorCallback) {
    $99b18dd98d1424fc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$addInitSelector(selectorCallback) {
    $99b18dd98d1424fc$var$initSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$closestRoot(el, includeInitSelectors = false) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $99b18dd98d1424fc$var$allSelectors() : $99b18dd98d1424fc$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $99b18dd98d1424fc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $99b18dd98d1424fc$var$findClosest(el.parentElement, callback);
}
function $99b18dd98d1424fc$var$isRoot(el) {
    return $99b18dd98d1424fc$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $99b18dd98d1424fc$var$initInterceptors2 = [];
function $99b18dd98d1424fc$var$interceptInit(callback) {
    $99b18dd98d1424fc$var$initInterceptors2.push(callback);
}
var $99b18dd98d1424fc$var$markerDispenser = 1;
function $99b18dd98d1424fc$var$initTree(el, walker = $99b18dd98d1424fc$var$walk, intercept = ()=>{}) {
    if ($99b18dd98d1424fc$var$findClosest(el, (i)=>i._x_ignore)) return;
    $99b18dd98d1424fc$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $99b18dd98d1424fc$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $99b18dd98d1424fc$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $99b18dd98d1424fc$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $99b18dd98d1424fc$var$destroyTree(root, walker = $99b18dd98d1424fc$var$walk) {
    walker(root, (el)=>{
        $99b18dd98d1424fc$var$cleanupElement(el);
        $99b18dd98d1424fc$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $99b18dd98d1424fc$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($99b18dd98d1424fc$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $99b18dd98d1424fc$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $99b18dd98d1424fc$var$tickStack = [];
var $99b18dd98d1424fc$var$isHolding = false;
function $99b18dd98d1424fc$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $99b18dd98d1424fc$var$isHolding || setTimeout(()=>{
            $99b18dd98d1424fc$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $99b18dd98d1424fc$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $99b18dd98d1424fc$var$releaseNextTicks() {
    $99b18dd98d1424fc$var$isHolding = false;
    while($99b18dd98d1424fc$var$tickStack.length)$99b18dd98d1424fc$var$tickStack.shift()();
}
function $99b18dd98d1424fc$var$holdNextTicks() {
    $99b18dd98d1424fc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $99b18dd98d1424fc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $99b18dd98d1424fc$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $99b18dd98d1424fc$var$setClasses(el, value());
    return $99b18dd98d1424fc$var$setClassesFromString(el, value);
}
function $99b18dd98d1424fc$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $99b18dd98d1424fc$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $99b18dd98d1424fc$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setStylesFromObject(el, value);
    return $99b18dd98d1424fc$var$setStylesFromString(el, value);
}
function $99b18dd98d1424fc$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $99b18dd98d1424fc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $99b18dd98d1424fc$var$setStyles(el, previousStyles);
    };
}
function $99b18dd98d1424fc$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $99b18dd98d1424fc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $99b18dd98d1424fc$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$99b18dd98d1424fc$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, expression, value);
});
function $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, classString, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $99b18dd98d1424fc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $99b18dd98d1424fc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $99b18dd98d1424fc$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $99b18dd98d1424fc$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $99b18dd98d1424fc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $99b18dd98d1424fc$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $99b18dd98d1424fc$var$closestHide(parent);
}
function $99b18dd98d1424fc$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $99b18dd98d1424fc$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $99b18dd98d1424fc$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $99b18dd98d1424fc$var$once(()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $99b18dd98d1424fc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $99b18dd98d1424fc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $99b18dd98d1424fc$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $99b18dd98d1424fc$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                stages.end();
            });
            $99b18dd98d1424fc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $99b18dd98d1424fc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $99b18dd98d1424fc$var$isCloning = false;
function $99b18dd98d1424fc$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning ? fallback(...args) : callback(...args);
}
function $99b18dd98d1424fc$var$onlyDuringClone(callback) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning && callback(...args);
}
var $99b18dd98d1424fc$var$interceptors = [];
function $99b18dd98d1424fc$var$interceptClone(callback) {
    $99b18dd98d1424fc$var$interceptors.push(callback);
}
function $99b18dd98d1424fc$var$cloneNode(from, to) {
    $99b18dd98d1424fc$var$interceptors.forEach((i)=>i(from, to));
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $99b18dd98d1424fc$var$isCloning = false;
}
var $99b18dd98d1424fc$var$isCloningLegacy = false;
function $99b18dd98d1424fc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$isCloningLegacy = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$cloneTree(newEl);
    });
    $99b18dd98d1424fc$var$isCloning = false;
    $99b18dd98d1424fc$var$isCloningLegacy = false;
}
function $99b18dd98d1424fc$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $99b18dd98d1424fc$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $99b18dd98d1424fc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $99b18dd98d1424fc$var$initTree(el, shallowWalker);
}
function $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $99b18dd98d1424fc$var$effect;
    $99b18dd98d1424fc$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $99b18dd98d1424fc$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $99b18dd98d1424fc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $99b18dd98d1424fc$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $99b18dd98d1424fc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $99b18dd98d1424fc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $99b18dd98d1424fc$var$bindInputValue(el, value);
            break;
        case "style":
            $99b18dd98d1424fc$var$bindStyles(el, value);
            break;
        case "class":
            $99b18dd98d1424fc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $99b18dd98d1424fc$var$bindAttribute(el, name, value);
            break;
    }
}
function $99b18dd98d1424fc$var$bindInputValue(el, value) {
    if ($99b18dd98d1424fc$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $99b18dd98d1424fc$var$safeParseBoolean(el.value) === value;
            else el.checked = $99b18dd98d1424fc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$99b18dd98d1424fc$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $99b18dd98d1424fc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $99b18dd98d1424fc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $99b18dd98d1424fc$var$setClasses(el, value);
}
function $99b18dd98d1424fc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $99b18dd98d1424fc$var$setStyles(el, value);
}
function $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value) {
    $99b18dd98d1424fc$var$bindAttribute(el, name, value);
    $99b18dd98d1424fc$var$setPropertyIfChanged(el, name, value);
}
function $99b18dd98d1424fc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($99b18dd98d1424fc$var$isBooleanAttr(name)) value = name;
        $99b18dd98d1424fc$var$setIfChanged(el, name, value);
    }
}
function $99b18dd98d1424fc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $99b18dd98d1424fc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $99b18dd98d1424fc$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $99b18dd98d1424fc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $99b18dd98d1424fc$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $99b18dd98d1424fc$var$isBooleanAttr(attrName) {
    return $99b18dd98d1424fc$var$booleanAttributes.has(attrName);
}
function $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $99b18dd98d1424fc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(()=>{
            return $99b18dd98d1424fc$var$evaluate(el, binding.expression);
        });
    }
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($99b18dd98d1424fc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $99b18dd98d1424fc$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $99b18dd98d1424fc$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $99b18dd98d1424fc$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $99b18dd98d1424fc$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $99b18dd98d1424fc$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $99b18dd98d1424fc$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($99b18dd98d1424fc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $99b18dd98d1424fc$var$release(reference);
    };
}
function $99b18dd98d1424fc$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $99b18dd98d1424fc$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($99b18dd98d1424fc$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $99b18dd98d1424fc$var$stores = {};
var $99b18dd98d1424fc$var$isReactive = false;
function $99b18dd98d1424fc$var$store(name, value) {
    if (!$99b18dd98d1424fc$var$isReactive) {
        $99b18dd98d1424fc$var$stores = $99b18dd98d1424fc$var$reactive($99b18dd98d1424fc$var$stores);
        $99b18dd98d1424fc$var$isReactive = true;
    }
    if (value === void 0) return $99b18dd98d1424fc$var$stores[name];
    $99b18dd98d1424fc$var$stores[name] = value;
    $99b18dd98d1424fc$var$initInterceptors($99b18dd98d1424fc$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $99b18dd98d1424fc$var$stores[name].init();
}
function $99b18dd98d1424fc$var$getStores() {
    return $99b18dd98d1424fc$var$stores;
}
// packages/alpinejs/src/binds.js
var $99b18dd98d1424fc$var$binds = {};
function $99b18dd98d1424fc$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $99b18dd98d1424fc$var$applyBindingsObject(name, getBindings());
    else $99b18dd98d1424fc$var$binds[name] = getBindings;
    return ()=>{};
}
function $99b18dd98d1424fc$var$injectBindingProviders(obj) {
    Object.entries($99b18dd98d1424fc$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $99b18dd98d1424fc$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $99b18dd98d1424fc$var$datas = {};
function $99b18dd98d1424fc$var$data(name, callback) {
    $99b18dd98d1424fc$var$datas[name] = callback;
}
function $99b18dd98d1424fc$var$injectDataProviders(obj, context) {
    Object.entries($99b18dd98d1424fc$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $99b18dd98d1424fc$var$Alpine = {
    get reactive () {
        return $99b18dd98d1424fc$var$reactive;
    },
    get release () {
        return $99b18dd98d1424fc$var$release;
    },
    get effect () {
        return $99b18dd98d1424fc$var$effect;
    },
    get raw () {
        return $99b18dd98d1424fc$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $99b18dd98d1424fc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $99b18dd98d1424fc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $99b18dd98d1424fc$var$disableEffectScheduling,
    startObservingMutations: $99b18dd98d1424fc$var$startObservingMutations,
    stopObservingMutations: $99b18dd98d1424fc$var$stopObservingMutations,
    setReactivityEngine: $99b18dd98d1424fc$var$setReactivityEngine,
    onAttributeRemoved: $99b18dd98d1424fc$var$onAttributeRemoved,
    onAttributesAdded: $99b18dd98d1424fc$var$onAttributesAdded,
    closestDataStack: $99b18dd98d1424fc$var$closestDataStack,
    skipDuringClone: $99b18dd98d1424fc$var$skipDuringClone,
    onlyDuringClone: $99b18dd98d1424fc$var$onlyDuringClone,
    addRootSelector: $99b18dd98d1424fc$var$addRootSelector,
    addInitSelector: $99b18dd98d1424fc$var$addInitSelector,
    interceptClone: $99b18dd98d1424fc$var$interceptClone,
    addScopeToNode: $99b18dd98d1424fc$var$addScopeToNode,
    deferMutations: $99b18dd98d1424fc$var$deferMutations,
    mapAttributes: $99b18dd98d1424fc$var$mapAttributes,
    evaluateLater: $99b18dd98d1424fc$var$evaluateLater,
    interceptInit: $99b18dd98d1424fc$var$interceptInit,
    setEvaluator: $99b18dd98d1424fc$var$setEvaluator,
    mergeProxies: $99b18dd98d1424fc$var$mergeProxies,
    extractProp: $99b18dd98d1424fc$var$extractProp,
    findClosest: $99b18dd98d1424fc$var$findClosest,
    onElRemoved: $99b18dd98d1424fc$var$onElRemoved,
    closestRoot: $99b18dd98d1424fc$var$closestRoot,
    destroyTree: $99b18dd98d1424fc$var$destroyTree,
    interceptor: $99b18dd98d1424fc$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $99b18dd98d1424fc$var$transition,
    setStyles: // INTERNAL
    $99b18dd98d1424fc$var$setStyles,
    mutateDom: // INTERNAL
    $99b18dd98d1424fc$var$mutateDom,
    directive: $99b18dd98d1424fc$var$directive,
    entangle: $99b18dd98d1424fc$var$entangle,
    throttle: $99b18dd98d1424fc$var$throttle,
    debounce: $99b18dd98d1424fc$var$debounce,
    evaluate: $99b18dd98d1424fc$var$evaluate,
    initTree: $99b18dd98d1424fc$var$initTree,
    nextTick: $99b18dd98d1424fc$var$nextTick,
    prefixed: $99b18dd98d1424fc$var$prefix,
    prefix: $99b18dd98d1424fc$var$setPrefix,
    plugin: $99b18dd98d1424fc$var$plugin,
    magic: $99b18dd98d1424fc$var$magic,
    store: $99b18dd98d1424fc$var$store,
    start: $99b18dd98d1424fc$var$start,
    clone: $99b18dd98d1424fc$var$clone,
    cloneNode: // INTERNAL
    $99b18dd98d1424fc$var$cloneNode,
    // INTERNAL
    bound: $99b18dd98d1424fc$var$getBinding,
    $data: $99b18dd98d1424fc$var$scope,
    watch: $99b18dd98d1424fc$var$watch,
    walk: $99b18dd98d1424fc$var$walk,
    data: $99b18dd98d1424fc$var$data,
    bind: $99b18dd98d1424fc$var$bind2
};
var $99b18dd98d1424fc$var$alpine_default = $99b18dd98d1424fc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $99b18dd98d1424fc$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $99b18dd98d1424fc$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $99b18dd98d1424fc$var$isBooleanAttr2 = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap($99b18dd98d1424fc$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $99b18dd98d1424fc$var$EMPTY_OBJ = Object.freeze({});
var $99b18dd98d1424fc$var$EMPTY_ARR = Object.freeze([]);
var $99b18dd98d1424fc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $99b18dd98d1424fc$var$hasOwn = (val, key)=>$99b18dd98d1424fc$var$hasOwnProperty.call(val, key);
var $99b18dd98d1424fc$var$isArray = Array.isArray;
var $99b18dd98d1424fc$var$isMap = (val)=>$99b18dd98d1424fc$var$toTypeString(val) === "[object Map]";
var $99b18dd98d1424fc$var$isString = (val)=>typeof val === "string";
var $99b18dd98d1424fc$var$isSymbol = (val)=>typeof val === "symbol";
var $99b18dd98d1424fc$var$isObject = (val)=>val !== null && typeof val === "object";
var $99b18dd98d1424fc$var$objectToString = Object.prototype.toString;
var $99b18dd98d1424fc$var$toTypeString = (value)=>$99b18dd98d1424fc$var$objectToString.call(value);
var $99b18dd98d1424fc$var$toRawType = (value)=>{
    return $99b18dd98d1424fc$var$toTypeString(value).slice(8, -1);
};
var $99b18dd98d1424fc$var$isIntegerKey = (key)=>$99b18dd98d1424fc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $99b18dd98d1424fc$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $99b18dd98d1424fc$var$camelizeRE = /-(\w)/g;
var $99b18dd98d1424fc$var$camelize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>{
    return str.replace($99b18dd98d1424fc$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $99b18dd98d1424fc$var$hyphenateRE = /\B([A-Z])/g;
var $99b18dd98d1424fc$var$hyphenate = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.replace($99b18dd98d1424fc$var$hyphenateRE, "-$1").toLowerCase());
var $99b18dd98d1424fc$var$capitalize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $99b18dd98d1424fc$var$toHandlerKey = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str ? `on${$99b18dd98d1424fc$var$capitalize(str)}` : ``);
var $99b18dd98d1424fc$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $99b18dd98d1424fc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$effectStack = [];
var $99b18dd98d1424fc$var$activeEffect;
var $99b18dd98d1424fc$var$ITERATE_KEY = Symbol("iterate");
var $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $99b18dd98d1424fc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $99b18dd98d1424fc$var$effect2(fn, options = $99b18dd98d1424fc$var$EMPTY_OBJ) {
    if ($99b18dd98d1424fc$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $99b18dd98d1424fc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $99b18dd98d1424fc$var$stop(effect3) {
    if (effect3.active) {
        $99b18dd98d1424fc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $99b18dd98d1424fc$var$uid = 0;
function $99b18dd98d1424fc$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$99b18dd98d1424fc$var$effectStack.includes(effect3)) {
            $99b18dd98d1424fc$var$cleanup(effect3);
            try {
                $99b18dd98d1424fc$var$enableTracking();
                $99b18dd98d1424fc$var$effectStack.push(effect3);
                $99b18dd98d1424fc$var$activeEffect = effect3;
                return fn();
            } finally{
                $99b18dd98d1424fc$var$effectStack.pop();
                $99b18dd98d1424fc$var$resetTracking();
                $99b18dd98d1424fc$var$activeEffect = $99b18dd98d1424fc$var$effectStack[$99b18dd98d1424fc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $99b18dd98d1424fc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $99b18dd98d1424fc$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $99b18dd98d1424fc$var$shouldTrack = true;
var $99b18dd98d1424fc$var$trackStack = [];
function $99b18dd98d1424fc$var$pauseTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = false;
}
function $99b18dd98d1424fc$var$enableTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = true;
}
function $99b18dd98d1424fc$var$resetTracking() {
    const last = $99b18dd98d1424fc$var$trackStack.pop();
    $99b18dd98d1424fc$var$shouldTrack = last === void 0 ? true : last;
}
function $99b18dd98d1424fc$var$track(target, type, key) {
    if (!$99b18dd98d1424fc$var$shouldTrack || $99b18dd98d1424fc$var$activeEffect === void 0) return;
    let depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) $99b18dd98d1424fc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($99b18dd98d1424fc$var$activeEffect)) {
        dep.add($99b18dd98d1424fc$var$activeEffect);
        $99b18dd98d1424fc$var$activeEffect.deps.push(dep);
        if ($99b18dd98d1424fc$var$activeEffect.options.onTrack) $99b18dd98d1424fc$var$activeEffect.options.onTrack({
            effect: $99b18dd98d1424fc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $99b18dd98d1424fc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $99b18dd98d1424fc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $99b18dd98d1424fc$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                } else if ($99b18dd98d1424fc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $99b18dd98d1424fc$var$isNonTrackableKeys = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $99b18dd98d1424fc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($99b18dd98d1424fc$var$isSymbol));
var $99b18dd98d1424fc$var$get2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter();
var $99b18dd98d1424fc$var$readonlyGet = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter(true);
var $99b18dd98d1424fc$var$arrayInstrumentations = /* @__PURE__ */ $99b18dd98d1424fc$var$createArrayInstrumentations();
function $99b18dd98d1424fc$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $99b18dd98d1424fc$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$99b18dd98d1424fc$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($99b18dd98d1424fc$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $99b18dd98d1424fc$var$pauseTracking();
            const res = $99b18dd98d1424fc$var$toRaw(this)[key].apply(this, args);
            $99b18dd98d1424fc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $99b18dd98d1424fc$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $99b18dd98d1424fc$var$shallowReadonlyMap : $99b18dd98d1424fc$var$readonlyMap : shallow ? $99b18dd98d1424fc$var$shallowReactiveMap : $99b18dd98d1424fc$var$reactiveMap).get(target)) return target;
        const targetIsArray = $99b18dd98d1424fc$var$isArray(target);
        if (!isReadonly && targetIsArray && $99b18dd98d1424fc$var$hasOwn($99b18dd98d1424fc$var$arrayInstrumentations, key)) return Reflect.get($99b18dd98d1424fc$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($99b18dd98d1424fc$var$isSymbol(key) ? $99b18dd98d1424fc$var$builtInSymbols.has(key) : $99b18dd98d1424fc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $99b18dd98d1424fc$var$track(target, "get", key);
        if (shallow) return res;
        if ($99b18dd98d1424fc$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$99b18dd98d1424fc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($99b18dd98d1424fc$var$isObject(res)) return isReadonly ? $99b18dd98d1424fc$var$readonly(res) : $99b18dd98d1424fc$var$reactive2(res);
        return res;
    };
}
var $99b18dd98d1424fc$var$set2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createSetter();
function $99b18dd98d1424fc$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $99b18dd98d1424fc$var$toRaw(value);
            oldValue = $99b18dd98d1424fc$var$toRaw(oldValue);
            if (!$99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isRef(oldValue) && !$99b18dd98d1424fc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isIntegerKey(key) ? Number(key) < target.length : $99b18dd98d1424fc$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $99b18dd98d1424fc$var$toRaw(receiver)) {
            if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
            else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $99b18dd98d1424fc$var$deleteProperty(target, key) {
    const hadKey = $99b18dd98d1424fc$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$99b18dd98d1424fc$var$isSymbol(key) || !$99b18dd98d1424fc$var$builtInSymbols.has(key)) $99b18dd98d1424fc$var$track(target, "has", key);
    return result;
}
function $99b18dd98d1424fc$var$ownKeys(target) {
    $99b18dd98d1424fc$var$track(target, "iterate", $99b18dd98d1424fc$var$isArray(target) ? "length" : $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $99b18dd98d1424fc$var$mutableHandlers = {
    get: $99b18dd98d1424fc$var$get2,
    set: $99b18dd98d1424fc$var$set2,
    deleteProperty: $99b18dd98d1424fc$var$deleteProperty,
    has: $99b18dd98d1424fc$var$has,
    ownKeys: $99b18dd98d1424fc$var$ownKeys
};
var $99b18dd98d1424fc$var$readonlyHandlers = {
    get: $99b18dd98d1424fc$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $99b18dd98d1424fc$var$toReactive = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$reactive2(value) : value;
var $99b18dd98d1424fc$var$toReadonly = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$readonly(value) : value;
var $99b18dd98d1424fc$var$toShallow = (value)=>value;
var $99b18dd98d1424fc$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $99b18dd98d1424fc$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $99b18dd98d1424fc$var$getProto(rawTarget);
    const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $99b18dd98d1424fc$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $99b18dd98d1424fc$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $99b18dd98d1424fc$var$track($99b18dd98d1424fc$var$toRaw(target), "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $99b18dd98d1424fc$var$add(value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const proto = $99b18dd98d1424fc$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $99b18dd98d1424fc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $99b18dd98d1424fc$var$set$1(key, value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
    else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $99b18dd98d1424fc$var$deleteEntry(key) {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$clear() {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $99b18dd98d1424fc$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $99b18dd98d1424fc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $99b18dd98d1424fc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $99b18dd98d1424fc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const targetIsMap = $99b18dd98d1424fc$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", isKeyOnly ? $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY : $99b18dd98d1424fc$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $99b18dd98d1424fc$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$99b18dd98d1424fc$var$capitalize(type)} operation ${key}failed: target is readonly.`, $99b18dd98d1424fc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $99b18dd98d1424fc$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, false, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$99b18dd98d1424fc$var$mutableInstrumentations, $99b18dd98d1424fc$var$readonlyInstrumentations, $99b18dd98d1424fc$var$shallowInstrumentations, $99b18dd98d1424fc$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentations();
function $99b18dd98d1424fc$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $99b18dd98d1424fc$var$shallowReadonlyInstrumentations : $99b18dd98d1424fc$var$shallowInstrumentations : isReadonly ? $99b18dd98d1424fc$var$readonlyInstrumentations : $99b18dd98d1424fc$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($99b18dd98d1424fc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $99b18dd98d1424fc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(false, false)
};
var $99b18dd98d1424fc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(true, false)
};
function $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $99b18dd98d1424fc$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $99b18dd98d1424fc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $99b18dd98d1424fc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $99b18dd98d1424fc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $99b18dd98d1424fc$var$targetTypeMap($99b18dd98d1424fc$var$toRawType(value));
}
function $99b18dd98d1424fc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $99b18dd98d1424fc$var$createReactiveObject(target, false, $99b18dd98d1424fc$var$mutableHandlers, $99b18dd98d1424fc$var$mutableCollectionHandlers, $99b18dd98d1424fc$var$reactiveMap);
}
function $99b18dd98d1424fc$var$readonly(target) {
    return $99b18dd98d1424fc$var$createReactiveObject(target, true, $99b18dd98d1424fc$var$readonlyHandlers, $99b18dd98d1424fc$var$readonlyCollectionHandlers, $99b18dd98d1424fc$var$readonlyMap);
}
function $99b18dd98d1424fc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$99b18dd98d1424fc$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $99b18dd98d1424fc$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $99b18dd98d1424fc$var$toRaw(observed) {
    return observed && $99b18dd98d1424fc$var$toRaw(observed["__v_raw"]) || observed;
}
function $99b18dd98d1424fc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$99b18dd98d1424fc$var$magic("nextTick", ()=>$99b18dd98d1424fc$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$99b18dd98d1424fc$var$magic("dispatch", (el)=>$99b18dd98d1424fc$var$dispatch.bind($99b18dd98d1424fc$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$99b18dd98d1424fc$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $99b18dd98d1424fc$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$99b18dd98d1424fc$var$magic("store", $99b18dd98d1424fc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$99b18dd98d1424fc$var$magic("data", (el)=>$99b18dd98d1424fc$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$99b18dd98d1424fc$var$magic("root", (el)=>$99b18dd98d1424fc$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$99b18dd98d1424fc$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $99b18dd98d1424fc$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $99b18dd98d1424fc$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $99b18dd98d1424fc$var$globalIdMemo = {};
function $99b18dd98d1424fc$var$findAndIncrementId(name) {
    if (!$99b18dd98d1424fc$var$globalIdMemo[name]) $99b18dd98d1424fc$var$globalIdMemo[name] = 0;
    return ++$99b18dd98d1424fc$var$globalIdMemo[name];
}
function $99b18dd98d1424fc$var$closestIdRoot(el, name) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $99b18dd98d1424fc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $99b18dd98d1424fc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$99b18dd98d1424fc$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $99b18dd98d1424fc$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $99b18dd98d1424fc$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$99b18dd98d1424fc$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$99b18dd98d1424fc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$99b18dd98d1424fc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $99b18dd98d1424fc$var$warnMissingPluginMagic(name, magicName, slug) {
    $99b18dd98d1424fc$var$magic(magicName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$99b18dd98d1424fc$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $99b18dd98d1424fc$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$99b18dd98d1424fc$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $99b18dd98d1424fc$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $99b18dd98d1424fc$var$skipDuringClone(()=>{
            $99b18dd98d1424fc$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $99b18dd98d1424fc$var$getTarget(expression);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$99b18dd98d1424fc$var$mutateDom(()=>{
            clone2.remove();
            $99b18dd98d1424fc$var$destroyTree(clone2);
        }));
});
var $99b18dd98d1424fc$var$teleportContainerDuringClone = document.createElement("div");
function $99b18dd98d1424fc$var$getTarget(expression) {
    let target = $99b18dd98d1424fc$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $99b18dd98d1424fc$var$teleportContainerDuringClone;
    })();
    if (!target) $99b18dd98d1424fc$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $99b18dd98d1424fc$var$handler = ()=>{};
$99b18dd98d1424fc$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$99b18dd98d1424fc$var$directive("ignore", $99b18dd98d1424fc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$99b18dd98d1424fc$var$directive("effect", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($99b18dd98d1424fc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $99b18dd98d1424fc$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $99b18dd98d1424fc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $99b18dd98d1424fc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($99b18dd98d1424fc$var$isKeyEvent(event) || $99b18dd98d1424fc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $99b18dd98d1424fc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $99b18dd98d1424fc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $99b18dd98d1424fc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $99b18dd98d1424fc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($99b18dd98d1424fc$var$isClickEvent(e.type)) return false;
            if ($99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $99b18dd98d1424fc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $99b18dd98d1424fc$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$99b18dd98d1424fc$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $99b18dd98d1424fc$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($99b18dd98d1424fc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $99b18dd98d1424fc$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $99b18dd98d1424fc$var$isCloning ? ()=>{} : $99b18dd98d1424fc$var$on(el, event, modifiers, (e)=>{
        setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $99b18dd98d1424fc$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $99b18dd98d1424fc$var$on(el.form, "reset", [], (e)=>{
            $99b18dd98d1424fc$var$nextTick(()=>el._x_model && el._x_model.set($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $99b18dd98d1424fc$var$getInputValue(el, modifiers, event, currentValue) {
    return $99b18dd98d1424fc$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $99b18dd98d1424fc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $99b18dd98d1424fc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$99b18dd98d1424fc$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($99b18dd98d1424fc$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $99b18dd98d1424fc$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $99b18dd98d1424fc$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $99b18dd98d1424fc$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $99b18dd98d1424fc$var$isNumeric2(number) ? number : rawValue;
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$99b18dd98d1424fc$var$directive("cloak", (el)=>queueMicrotask(()=>$99b18dd98d1424fc$var$mutateDom(()=>el.removeAttribute($99b18dd98d1424fc$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$99b18dd98d1424fc$var$addInitSelector(()=>`[${$99b18dd98d1424fc$var$prefix("init")}]`);
$99b18dd98d1424fc$var$directive("init", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$99b18dd98d1424fc$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$99b18dd98d1424fc$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $99b18dd98d1424fc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith(":", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("bind:"))));
var $99b18dd98d1424fc$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $99b18dd98d1424fc$var$injectBindingProviders(bindingProviders);
        let getBindings = $99b18dd98d1424fc$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $99b18dd98d1424fc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $99b18dd98d1424fc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$99b18dd98d1424fc$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$99b18dd98d1424fc$var$directive("bind", $99b18dd98d1424fc$var$handler2);
function $99b18dd98d1424fc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$99b18dd98d1424fc$var$addRootSelector(()=>`[${$99b18dd98d1424fc$var$prefix("data")}]`);
$99b18dd98d1424fc$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $99b18dd98d1424fc$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $99b18dd98d1424fc$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $99b18dd98d1424fc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $99b18dd98d1424fc$var$injectMagics(data2, el);
    let reactiveData = $99b18dd98d1424fc$var$reactive(data2);
    $99b18dd98d1424fc$var$initInterceptors(reactiveData);
    let undo = $99b18dd98d1424fc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$99b18dd98d1424fc$var$isCloning) return false;
    if ($99b18dd98d1424fc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$99b18dd98d1424fc$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $99b18dd98d1424fc$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$99b18dd98d1424fc$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $99b18dd98d1424fc$var$parseForExpression(expression);
    let evaluateItems = $99b18dd98d1424fc$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $99b18dd98d1424fc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($99b18dd98d1424fc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $99b18dd98d1424fc$var$mutateDom(()=>{
                if (!elForSpot) $99b18dd98d1424fc$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $99b18dd98d1424fc$var$reactive(scope2);
            $99b18dd98d1424fc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $99b18dd98d1424fc$var$mutateDom(()=>{
                lastEl.after(clone2);
                $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
            });
            if (typeof key === "object") $99b18dd98d1424fc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $99b18dd98d1424fc$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $99b18dd98d1424fc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $99b18dd98d1424fc$var$handler3() {}
$99b18dd98d1424fc$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $99b18dd98d1424fc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$99b18dd98d1424fc$var$directive("ref", $99b18dd98d1424fc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$99b18dd98d1424fc$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.after(clone2);
            $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$99b18dd98d1424fc$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$99b18dd98d1424fc$var$setIdRoot(el, name));
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith("@", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("on:"))));
$99b18dd98d1424fc$var$directive("on", $99b18dd98d1424fc$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $99b18dd98d1424fc$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $99b18dd98d1424fc$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$99b18dd98d1424fc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $99b18dd98d1424fc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $99b18dd98d1424fc$var$directive(directiveName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$99b18dd98d1424fc$var$alpine_default.setEvaluator($99b18dd98d1424fc$var$normalEvaluator);
$99b18dd98d1424fc$var$alpine_default.setReactivityEngine({
    reactive: $99b18dd98d1424fc$var$reactive2,
    effect: $99b18dd98d1424fc$var$effect2,
    release: $99b18dd98d1424fc$var$stop,
    raw: $99b18dd98d1424fc$var$toRaw
});
var $99b18dd98d1424fc$export$b7ee041e4ad2afec = $99b18dd98d1424fc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $99b18dd98d1424fc$export$2e2bcd8739ae039 = $99b18dd98d1424fc$export$b7ee041e4ad2afec;

});

parcelRegister("jjFgX", function(module, exports) {

$parcel$export(module.exports, "focus", function () { return src_default; });
$parcel$export(module.exports, "default", function () { return module_default; });
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (nodeIsAttached) return !node.getClientRects().length;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false;
        }
        return true;
    });
    return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus");
        if (node === false) return false;
        if (node === void 0) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return void 0;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus2(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    };
    var checkTab = function checkTab2(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (e.shiftKey) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        }
    };
    var checkKey = function checkKey2(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return;
        activeFocusTraps.activateTrap(trap);
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation2() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    };
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        let trap = createFocusTrap(el, options);
        let undoInert = ()=>{};
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    if (modifiers.includes("inert")) undoInert = setInert(el);
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/ 
});

parcelRegister("6CDrG", function(module, exports) {

$parcel$export(module.exports, "nip19", function () { return $4d24e3c498996220$export$10660ae21dbef115; });
$parcel$export(module.exports, "nip98", function () { return $4d24e3c498996220$export$dbfcdd2f6b6e41d9; });

var $lPiFO = parcelRequire("lPiFO");

var $9mdbq = parcelRequire("9mdbq");

var $kHnZL = parcelRequire("kHnZL");

var $7i98v = parcelRequire("7i98v");

var $3njOQ = parcelRequire("3njOQ");

var $9zClU = parcelRequire("9zClU");

var $ltMLs = parcelRequire("ltMLs");

var $b24L2 = parcelRequire("b24L2");

var $9KVQy = parcelRequire("9KVQy");
var $4d24e3c498996220$var$__defProp = Object.defineProperty;
var $4d24e3c498996220$var$__export = (target, all)=>{
    for(var name in all)$4d24e3c498996220$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// core.ts
var $4d24e3c498996220$export$31a1b605a7b8e0bf = Symbol("verified");
var $4d24e3c498996220$var$isRecord = (obj)=>obj instanceof Object;
function $4d24e3c498996220$export$d08d852dd562b1ce(event) {
    if (!$4d24e3c498996220$var$isRecord(event)) return false;
    if (typeof event.kind !== "number") return false;
    if (typeof event.content !== "string") return false;
    if (typeof event.created_at !== "number") return false;
    if (typeof event.pubkey !== "string") return false;
    if (!event.pubkey.match(/^[a-f0-9]{64}$/)) return false;
    if (!Array.isArray(event.tags)) return false;
    for(let i2 = 0; i2 < event.tags.length; i2++){
        let tag = event.tags[i2];
        if (!Array.isArray(tag)) return false;
        for(let j = 0; j < tag.length; j++){
            if (typeof tag[j] === "object") return false;
        }
    }
    return true;
}
function $4d24e3c498996220$export$d425309ca6befbaf(events) {
    return events.sort((a, b)=>{
        if (a.created_at !== b.created_at) return b.created_at - a.created_at;
        return a.id.localeCompare(b.id);
    });
}
// utils.ts
var $4d24e3c498996220$export$eab97d15b1788b8d = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$eab97d15b1788b8d, {
    Queue: ()=>$4d24e3c498996220$var$Queue,
    QueueNode: ()=>$4d24e3c498996220$var$QueueNode,
    binarySearch: ()=>$4d24e3c498996220$var$binarySearch,
    insertEventIntoAscendingList: ()=>$4d24e3c498996220$var$insertEventIntoAscendingList,
    insertEventIntoDescendingList: ()=>$4d24e3c498996220$var$insertEventIntoDescendingList,
    normalizeURL: ()=>$4d24e3c498996220$var$normalizeURL,
    utf8Decoder: ()=>$4d24e3c498996220$var$utf8Decoder,
    utf8Encoder: ()=>$4d24e3c498996220$var$utf8Encoder
});
var $4d24e3c498996220$var$utf8Decoder = new TextDecoder("utf-8");
var $4d24e3c498996220$var$utf8Encoder = new TextEncoder();
function $4d24e3c498996220$var$normalizeURL(url) {
    if (url.indexOf("://") === -1) url = "wss://" + url;
    let p = new URL(url);
    p.pathname = p.pathname.replace(/\/+/g, "/");
    if (p.pathname.endsWith("/")) p.pathname = p.pathname.slice(0, -1);
    if (p.port === "80" && p.protocol === "ws:" || p.port === "443" && p.protocol === "wss:") p.port = "";
    p.searchParams.sort();
    p.hash = "";
    return p.toString();
}
function $4d24e3c498996220$var$insertEventIntoDescendingList(sortedArray, event) {
    const [idx, found] = $4d24e3c498996220$var$binarySearch(sortedArray, (b)=>{
        if (event.id === b.id) return 0;
        if (event.created_at === b.created_at) return -1;
        return b.created_at - event.created_at;
    });
    if (!found) sortedArray.splice(idx, 0, event);
    return sortedArray;
}
function $4d24e3c498996220$var$insertEventIntoAscendingList(sortedArray, event) {
    const [idx, found] = $4d24e3c498996220$var$binarySearch(sortedArray, (b)=>{
        if (event.id === b.id) return 0;
        if (event.created_at === b.created_at) return -1;
        return event.created_at - b.created_at;
    });
    if (!found) sortedArray.splice(idx, 0, event);
    return sortedArray;
}
function $4d24e3c498996220$var$binarySearch(arr, compare) {
    let start = 0;
    let end = arr.length - 1;
    while(start <= end){
        const mid = Math.floor((start + end) / 2);
        const cmp = compare(arr[mid]);
        if (cmp === 0) return [
            mid,
            true
        ];
        if (cmp < 0) end = mid - 1;
        else start = mid + 1;
    }
    return [
        start,
        false
    ];
}
var $4d24e3c498996220$var$QueueNode = class {
    value;
    next = null;
    prev = null;
    constructor(message){
        this.value = message;
    }
};
var $4d24e3c498996220$var$Queue = class {
    first;
    last;
    constructor(){
        this.first = null;
        this.last = null;
    }
    enqueue(value) {
        const newNode = new $4d24e3c498996220$var$QueueNode(value);
        if (!this.last) {
            this.first = newNode;
            this.last = newNode;
        } else if (this.last === this.first) {
            this.last = newNode;
            this.last.prev = this.first;
            this.first.next = newNode;
        } else {
            newNode.prev = this.last;
            this.last.next = newNode;
            this.last = newNode;
        }
        return true;
    }
    dequeue() {
        if (!this.first) return null;
        if (this.first === this.last) {
            const target2 = this.first;
            this.first = null;
            this.last = null;
            return target2.value;
        }
        const target = this.first;
        this.first = target.next;
        return target.value;
    }
};
// pure.ts
var $4d24e3c498996220$var$JS = class {
    generateSecretKey() {
        return (0, $lPiFO.schnorr).utils.randomPrivateKey();
    }
    getPublicKey(secretKey) {
        return (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).getPublicKey(secretKey));
    }
    finalizeEvent(t, secretKey) {
        const event = t;
        event.pubkey = (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).getPublicKey(secretKey));
        event.id = $4d24e3c498996220$export$11a838ad4e557e0e(event);
        event.sig = (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).sign($4d24e3c498996220$export$11a838ad4e557e0e(event), secretKey));
        event[$4d24e3c498996220$export$31a1b605a7b8e0bf] = true;
        return event;
    }
    verifyEvent(event) {
        if (typeof event[$4d24e3c498996220$export$31a1b605a7b8e0bf] === "boolean") return event[$4d24e3c498996220$export$31a1b605a7b8e0bf];
        const hash = $4d24e3c498996220$export$11a838ad4e557e0e(event);
        if (hash !== event.id) {
            event[$4d24e3c498996220$export$31a1b605a7b8e0bf] = false;
            return false;
        }
        try {
            const valid = (0, $lPiFO.schnorr).verify(event.sig, hash, event.pubkey);
            event[$4d24e3c498996220$export$31a1b605a7b8e0bf] = valid;
            return valid;
        } catch (err) {
            event[$4d24e3c498996220$export$31a1b605a7b8e0bf] = false;
            return false;
        }
    }
};
function $4d24e3c498996220$export$d32d86987f616a9e(evt) {
    if (!$4d24e3c498996220$export$d08d852dd562b1ce(evt)) throw new Error("can't serialize event with wrong or missing properties");
    return JSON.stringify([
        0,
        evt.pubkey,
        evt.created_at,
        evt.kind,
        evt.tags,
        evt.content
    ]);
}
function $4d24e3c498996220$export$11a838ad4e557e0e(event) {
    let eventHash = (0, $kHnZL.sha256)($4d24e3c498996220$var$utf8Encoder.encode($4d24e3c498996220$export$d32d86987f616a9e(event)));
    return (0, $9mdbq.bytesToHex)(eventHash);
}
var $4d24e3c498996220$var$i = new $4d24e3c498996220$var$JS();
var $4d24e3c498996220$export$16ca411381fc81c8 = $4d24e3c498996220$var$i.generateSecretKey;
var $4d24e3c498996220$export$889def73691f9837 = $4d24e3c498996220$var$i.getPublicKey;
var $4d24e3c498996220$export$bc33d3bdc1ddcd20 = $4d24e3c498996220$var$i.finalizeEvent;
var $4d24e3c498996220$export$909d658b5069e986 = $4d24e3c498996220$var$i.verifyEvent;
// kinds.ts
var $4d24e3c498996220$export$9ef7793a01f1f377 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$9ef7793a01f1f377, {
    Application: ()=>$4d24e3c498996220$var$Application,
    BadgeAward: ()=>$4d24e3c498996220$var$BadgeAward,
    BadgeDefinition: ()=>$4d24e3c498996220$var$BadgeDefinition,
    BlockedRelaysList: ()=>$4d24e3c498996220$var$BlockedRelaysList,
    BookmarkList: ()=>$4d24e3c498996220$var$BookmarkList,
    Bookmarksets: ()=>$4d24e3c498996220$var$Bookmarksets,
    Calendar: ()=>$4d24e3c498996220$var$Calendar,
    CalendarEventRSVP: ()=>$4d24e3c498996220$var$CalendarEventRSVP,
    ChannelCreation: ()=>$4d24e3c498996220$var$ChannelCreation,
    ChannelHideMessage: ()=>$4d24e3c498996220$var$ChannelHideMessage,
    ChannelMessage: ()=>$4d24e3c498996220$var$ChannelMessage,
    ChannelMetadata: ()=>$4d24e3c498996220$var$ChannelMetadata,
    ChannelMuteUser: ()=>$4d24e3c498996220$var$ChannelMuteUser,
    ClassifiedListing: ()=>$4d24e3c498996220$var$ClassifiedListing,
    ClientAuth: ()=>$4d24e3c498996220$var$ClientAuth,
    CommunitiesList: ()=>$4d24e3c498996220$var$CommunitiesList,
    CommunityDefinition: ()=>$4d24e3c498996220$var$CommunityDefinition,
    CommunityPostApproval: ()=>$4d24e3c498996220$var$CommunityPostApproval,
    Contacts: ()=>$4d24e3c498996220$var$Contacts,
    CreateOrUpdateProduct: ()=>$4d24e3c498996220$var$CreateOrUpdateProduct,
    CreateOrUpdateStall: ()=>$4d24e3c498996220$var$CreateOrUpdateStall,
    Curationsets: ()=>$4d24e3c498996220$var$Curationsets,
    Date: ()=>$4d24e3c498996220$var$Date2,
    DirectMessageRelaysList: ()=>$4d24e3c498996220$var$DirectMessageRelaysList,
    DraftClassifiedListing: ()=>$4d24e3c498996220$var$DraftClassifiedListing,
    DraftLong: ()=>$4d24e3c498996220$var$DraftLong,
    Emojisets: ()=>$4d24e3c498996220$var$Emojisets,
    EncryptedDirectMessage: ()=>$4d24e3c498996220$var$EncryptedDirectMessage,
    EventDeletion: ()=>$4d24e3c498996220$var$EventDeletion,
    FileMetadata: ()=>$4d24e3c498996220$var$FileMetadata,
    FileServerPreference: ()=>$4d24e3c498996220$var$FileServerPreference,
    Followsets: ()=>$4d24e3c498996220$var$Followsets,
    GenericRepost: ()=>$4d24e3c498996220$var$GenericRepost,
    Genericlists: ()=>$4d24e3c498996220$var$Genericlists,
    GiftWrap: ()=>$4d24e3c498996220$var$GiftWrap,
    HTTPAuth: ()=>$4d24e3c498996220$var$HTTPAuth,
    Handlerinformation: ()=>$4d24e3c498996220$var$Handlerinformation,
    Handlerrecommendation: ()=>$4d24e3c498996220$var$Handlerrecommendation,
    Highlights: ()=>$4d24e3c498996220$var$Highlights,
    InterestsList: ()=>$4d24e3c498996220$var$InterestsList,
    Interestsets: ()=>$4d24e3c498996220$var$Interestsets,
    JobFeedback: ()=>$4d24e3c498996220$var$JobFeedback,
    JobRequest: ()=>$4d24e3c498996220$var$JobRequest,
    JobResult: ()=>$4d24e3c498996220$var$JobResult,
    Label: ()=>$4d24e3c498996220$var$Label,
    LightningPubRPC: ()=>$4d24e3c498996220$var$LightningPubRPC,
    LiveChatMessage: ()=>$4d24e3c498996220$var$LiveChatMessage,
    LiveEvent: ()=>$4d24e3c498996220$var$LiveEvent,
    LongFormArticle: ()=>$4d24e3c498996220$var$LongFormArticle,
    Metadata: ()=>$4d24e3c498996220$var$Metadata,
    Mutelist: ()=>$4d24e3c498996220$var$Mutelist,
    NWCWalletInfo: ()=>$4d24e3c498996220$var$NWCWalletInfo,
    NWCWalletRequest: ()=>$4d24e3c498996220$var$NWCWalletRequest,
    NWCWalletResponse: ()=>$4d24e3c498996220$var$NWCWalletResponse,
    NostrConnect: ()=>$4d24e3c498996220$var$NostrConnect,
    OpenTimestamps: ()=>$4d24e3c498996220$var$OpenTimestamps,
    Pinlist: ()=>$4d24e3c498996220$var$Pinlist,
    PrivateDirectMessage: ()=>$4d24e3c498996220$var$PrivateDirectMessage,
    ProblemTracker: ()=>$4d24e3c498996220$var$ProblemTracker,
    ProfileBadges: ()=>$4d24e3c498996220$var$ProfileBadges,
    PublicChatsList: ()=>$4d24e3c498996220$var$PublicChatsList,
    Reaction: ()=>$4d24e3c498996220$var$Reaction,
    RecommendRelay: ()=>$4d24e3c498996220$var$RecommendRelay,
    RelayList: ()=>$4d24e3c498996220$var$RelayList,
    Relaysets: ()=>$4d24e3c498996220$var$Relaysets,
    Report: ()=>$4d24e3c498996220$var$Report,
    Reporting: ()=>$4d24e3c498996220$var$Reporting,
    Repost: ()=>$4d24e3c498996220$var$Repost,
    Seal: ()=>$4d24e3c498996220$var$Seal,
    SearchRelaysList: ()=>$4d24e3c498996220$var$SearchRelaysList,
    ShortTextNote: ()=>$4d24e3c498996220$var$ShortTextNote,
    Time: ()=>$4d24e3c498996220$var$Time,
    UserEmojiList: ()=>$4d24e3c498996220$var$UserEmojiList,
    UserStatuses: ()=>$4d24e3c498996220$var$UserStatuses,
    Zap: ()=>$4d24e3c498996220$var$Zap,
    ZapGoal: ()=>$4d24e3c498996220$var$ZapGoal,
    ZapRequest: ()=>$4d24e3c498996220$var$ZapRequest,
    classifyKind: ()=>$4d24e3c498996220$var$classifyKind,
    isAddressableKind: ()=>$4d24e3c498996220$var$isAddressableKind,
    isEphemeralKind: ()=>$4d24e3c498996220$var$isEphemeralKind,
    isKind: ()=>$4d24e3c498996220$var$isKind,
    isParameterizedReplaceableKind: ()=>$4d24e3c498996220$var$isParameterizedReplaceableKind,
    isRegularKind: ()=>$4d24e3c498996220$var$isRegularKind,
    isReplaceableKind: ()=>$4d24e3c498996220$var$isReplaceableKind
});
function $4d24e3c498996220$var$isRegularKind(kind) {
    return 1e3 <= kind && kind < 1e4 || [
        1,
        2,
        4,
        5,
        6,
        7,
        8,
        16,
        40,
        41,
        42,
        43,
        44
    ].includes(kind);
}
function $4d24e3c498996220$var$isReplaceableKind(kind) {
    return [
        0,
        3
    ].includes(kind) || 1e4 <= kind && kind < 2e4;
}
function $4d24e3c498996220$var$isEphemeralKind(kind) {
    return 2e4 <= kind && kind < 3e4;
}
function $4d24e3c498996220$var$isAddressableKind(kind) {
    return 3e4 <= kind && kind < 4e4;
}
var $4d24e3c498996220$var$isParameterizedReplaceableKind = $4d24e3c498996220$var$isAddressableKind;
function $4d24e3c498996220$var$classifyKind(kind) {
    if ($4d24e3c498996220$var$isRegularKind(kind)) return "regular";
    if ($4d24e3c498996220$var$isReplaceableKind(kind)) return "replaceable";
    if ($4d24e3c498996220$var$isEphemeralKind(kind)) return "ephemeral";
    if ($4d24e3c498996220$var$isAddressableKind(kind)) return "parameterized";
    return "unknown";
}
function $4d24e3c498996220$var$isKind(event, kind) {
    const kindAsArray = kind instanceof Array ? kind : [
        kind
    ];
    return $4d24e3c498996220$export$d08d852dd562b1ce(event) && kindAsArray.includes(event.kind) || false;
}
var $4d24e3c498996220$var$Metadata = 0;
var $4d24e3c498996220$var$ShortTextNote = 1;
var $4d24e3c498996220$var$RecommendRelay = 2;
var $4d24e3c498996220$var$Contacts = 3;
var $4d24e3c498996220$var$EncryptedDirectMessage = 4;
var $4d24e3c498996220$var$EventDeletion = 5;
var $4d24e3c498996220$var$Repost = 6;
var $4d24e3c498996220$var$Reaction = 7;
var $4d24e3c498996220$var$BadgeAward = 8;
var $4d24e3c498996220$var$Seal = 13;
var $4d24e3c498996220$var$PrivateDirectMessage = 14;
var $4d24e3c498996220$var$GenericRepost = 16;
var $4d24e3c498996220$var$ChannelCreation = 40;
var $4d24e3c498996220$var$ChannelMetadata = 41;
var $4d24e3c498996220$var$ChannelMessage = 42;
var $4d24e3c498996220$var$ChannelHideMessage = 43;
var $4d24e3c498996220$var$ChannelMuteUser = 44;
var $4d24e3c498996220$var$OpenTimestamps = 1040;
var $4d24e3c498996220$var$GiftWrap = 1059;
var $4d24e3c498996220$var$FileMetadata = 1063;
var $4d24e3c498996220$var$LiveChatMessage = 1311;
var $4d24e3c498996220$var$ProblemTracker = 1971;
var $4d24e3c498996220$var$Report = 1984;
var $4d24e3c498996220$var$Reporting = 1984;
var $4d24e3c498996220$var$Label = 1985;
var $4d24e3c498996220$var$CommunityPostApproval = 4550;
var $4d24e3c498996220$var$JobRequest = 5999;
var $4d24e3c498996220$var$JobResult = 6999;
var $4d24e3c498996220$var$JobFeedback = 7e3;
var $4d24e3c498996220$var$ZapGoal = 9041;
var $4d24e3c498996220$var$ZapRequest = 9734;
var $4d24e3c498996220$var$Zap = 9735;
var $4d24e3c498996220$var$Highlights = 9802;
var $4d24e3c498996220$var$Mutelist = 1e4;
var $4d24e3c498996220$var$Pinlist = 10001;
var $4d24e3c498996220$var$RelayList = 10002;
var $4d24e3c498996220$var$BookmarkList = 10003;
var $4d24e3c498996220$var$CommunitiesList = 10004;
var $4d24e3c498996220$var$PublicChatsList = 10005;
var $4d24e3c498996220$var$BlockedRelaysList = 10006;
var $4d24e3c498996220$var$SearchRelaysList = 10007;
var $4d24e3c498996220$var$InterestsList = 10015;
var $4d24e3c498996220$var$UserEmojiList = 10030;
var $4d24e3c498996220$var$DirectMessageRelaysList = 10050;
var $4d24e3c498996220$var$FileServerPreference = 10096;
var $4d24e3c498996220$var$NWCWalletInfo = 13194;
var $4d24e3c498996220$var$LightningPubRPC = 21e3;
var $4d24e3c498996220$var$ClientAuth = 22242;
var $4d24e3c498996220$var$NWCWalletRequest = 23194;
var $4d24e3c498996220$var$NWCWalletResponse = 23195;
var $4d24e3c498996220$var$NostrConnect = 24133;
var $4d24e3c498996220$var$HTTPAuth = 27235;
var $4d24e3c498996220$var$Followsets = 3e4;
var $4d24e3c498996220$var$Genericlists = 30001;
var $4d24e3c498996220$var$Relaysets = 30002;
var $4d24e3c498996220$var$Bookmarksets = 30003;
var $4d24e3c498996220$var$Curationsets = 30004;
var $4d24e3c498996220$var$ProfileBadges = 30008;
var $4d24e3c498996220$var$BadgeDefinition = 30009;
var $4d24e3c498996220$var$Interestsets = 30015;
var $4d24e3c498996220$var$CreateOrUpdateStall = 30017;
var $4d24e3c498996220$var$CreateOrUpdateProduct = 30018;
var $4d24e3c498996220$var$LongFormArticle = 30023;
var $4d24e3c498996220$var$DraftLong = 30024;
var $4d24e3c498996220$var$Emojisets = 30030;
var $4d24e3c498996220$var$Application = 30078;
var $4d24e3c498996220$var$LiveEvent = 30311;
var $4d24e3c498996220$var$UserStatuses = 30315;
var $4d24e3c498996220$var$ClassifiedListing = 30402;
var $4d24e3c498996220$var$DraftClassifiedListing = 30403;
var $4d24e3c498996220$var$Date2 = 31922;
var $4d24e3c498996220$var$Time = 31923;
var $4d24e3c498996220$var$Calendar = 31924;
var $4d24e3c498996220$var$CalendarEventRSVP = 31925;
var $4d24e3c498996220$var$Handlerrecommendation = 31989;
var $4d24e3c498996220$var$Handlerinformation = 31990;
var $4d24e3c498996220$var$CommunityDefinition = 34550;
// filter.ts
function $4d24e3c498996220$export$c6f8482e724e56c5(filter, event) {
    if (filter.ids && filter.ids.indexOf(event.id) === -1) return false;
    if (filter.kinds && filter.kinds.indexOf(event.kind) === -1) return false;
    if (filter.authors && filter.authors.indexOf(event.pubkey) === -1) return false;
    for(let f in filter)if (f[0] === "#") {
        let tagName = f.slice(1);
        let values = filter[`#${tagName}`];
        if (values && !event.tags.find(([t, v])=>t === f.slice(1) && values.indexOf(v) !== -1)) return false;
    }
    if (filter.since && event.created_at < filter.since) return false;
    if (filter.until && event.created_at > filter.until) return false;
    return true;
}
function $4d24e3c498996220$export$4bbf3f173cb9a4eb(filters, event) {
    for(let i2 = 0; i2 < filters.length; i2++){
        if ($4d24e3c498996220$export$c6f8482e724e56c5(filters[i2], event)) return true;
    }
    return false;
}
function $4d24e3c498996220$export$aa787302ec03bf2a(...filters) {
    let result = {};
    for(let i2 = 0; i2 < filters.length; i2++){
        let filter = filters[i2];
        Object.entries(filter).forEach(([property, values])=>{
            if (property === "kinds" || property === "ids" || property === "authors" || property[0] === "#") {
                result[property] = result[property] || [];
                for(let v = 0; v < values.length; v++){
                    let value = values[v];
                    if (!result[property].includes(value)) result[property].push(value);
                }
            }
        });
        if (filter.limit && (!result.limit || filter.limit > result.limit)) result.limit = filter.limit;
        if (filter.until && (!result.until || filter.until > result.until)) result.until = filter.until;
        if (filter.since && (!result.since || filter.since < result.since)) result.since = filter.since;
    }
    return result;
}
function $4d24e3c498996220$export$74b8728d117779ba(filter) {
    if (filter.ids && !filter.ids.length) return 0;
    if (filter.kinds && !filter.kinds.length) return 0;
    if (filter.authors && !filter.authors.length) return 0;
    for (const [key, value] of Object.entries(filter)){
        if (key[0] === "#" && Array.isArray(value) && !value.length) return 0;
    }
    return Math.min(Math.max(0, filter.limit ?? Infinity), filter.ids?.length ?? Infinity, filter.authors?.length && filter.kinds?.every((kind)=>$4d24e3c498996220$var$isReplaceableKind(kind)) ? filter.authors.length * filter.kinds.length : Infinity, filter.authors?.length && filter.kinds?.every((kind)=>$4d24e3c498996220$var$isAddressableKind(kind)) && filter["#d"]?.length ? filter.authors.length * filter.kinds.length * filter["#d"].length : Infinity);
}
// fakejson.ts
var $4d24e3c498996220$export$7712baafc4f0e06e = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$7712baafc4f0e06e, {
    getHex64: ()=>$4d24e3c498996220$var$getHex64,
    getInt: ()=>$4d24e3c498996220$var$getInt,
    getSubscriptionId: ()=>$4d24e3c498996220$var$getSubscriptionId,
    matchEventId: ()=>$4d24e3c498996220$var$matchEventId,
    matchEventKind: ()=>$4d24e3c498996220$var$matchEventKind,
    matchEventPubkey: ()=>$4d24e3c498996220$var$matchEventPubkey
});
function $4d24e3c498996220$var$getHex64(json, field) {
    let len = field.length + 3;
    let idx = json.indexOf(`"${field}":`) + len;
    let s = json.slice(idx).indexOf(`"`) + idx + 1;
    return json.slice(s, s + 64);
}
function $4d24e3c498996220$var$getInt(json, field) {
    let len = field.length;
    let idx = json.indexOf(`"${field}":`) + len + 3;
    let sliced = json.slice(idx);
    let end = Math.min(sliced.indexOf(","), sliced.indexOf("}"));
    return parseInt(sliced.slice(0, end), 10);
}
function $4d24e3c498996220$var$getSubscriptionId(json) {
    let idx = json.slice(0, 22).indexOf(`"EVENT"`);
    if (idx === -1) return null;
    let pstart = json.slice(idx + 7 + 1).indexOf(`"`);
    if (pstart === -1) return null;
    let start = idx + 7 + 1 + pstart;
    let pend = json.slice(start + 1, 80).indexOf(`"`);
    if (pend === -1) return null;
    let end = start + 1 + pend;
    return json.slice(start + 1, end);
}
function $4d24e3c498996220$var$matchEventId(json, id) {
    return id === $4d24e3c498996220$var$getHex64(json, "id");
}
function $4d24e3c498996220$var$matchEventPubkey(json, pubkey) {
    return pubkey === $4d24e3c498996220$var$getHex64(json, "pubkey");
}
function $4d24e3c498996220$var$matchEventKind(json, kind) {
    return kind === $4d24e3c498996220$var$getInt(json, "kind");
}
// nip42.ts
var $4d24e3c498996220$export$900cb248cdec72b = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$900cb248cdec72b, {
    makeAuthEvent: ()=>$4d24e3c498996220$var$makeAuthEvent
});
function $4d24e3c498996220$var$makeAuthEvent(relayURL, challenge) {
    return {
        kind: $4d24e3c498996220$var$ClientAuth,
        created_at: Math.floor(Date.now() / 1e3),
        tags: [
            [
                "relay",
                relayURL
            ],
            [
                "challenge",
                challenge
            ]
        ],
        content: ""
    };
}
// helpers.ts
async function $4d24e3c498996220$var$yieldThread() {
    return new Promise((resolve)=>{
        const ch = new MessageChannel();
        const handler = ()=>{
            ch.port1.removeEventListener("message", handler);
            resolve();
        };
        ch.port1.addEventListener("message", handler);
        ch.port2.postMessage(0);
        ch.port1.start();
    });
}
var $4d24e3c498996220$var$alwaysTrue = (t)=>{
    t[$4d24e3c498996220$export$31a1b605a7b8e0bf] = true;
    return true;
};
// abstract-relay.ts
var $4d24e3c498996220$var$AbstractRelay = class {
    url;
    _connected = false;
    onclose = null;
    onnotice = (msg)=>console.debug(`NOTICE from ${this.url}: ${msg}`);
    _onauth = null;
    baseEoseTimeout = 4400;
    connectionTimeout = 4400;
    publishTimeout = 4400;
    openSubs = /* @__PURE__ */ new Map();
    connectionTimeoutHandle;
    connectionPromise;
    openCountRequests = /* @__PURE__ */ new Map();
    openEventPublishes = /* @__PURE__ */ new Map();
    ws;
    incomingMessageQueue = new $4d24e3c498996220$var$Queue();
    queueRunning = false;
    challenge;
    authPromise;
    serial = 0;
    verifyEvent;
    _WebSocket;
    constructor(url, opts){
        this.url = $4d24e3c498996220$var$normalizeURL(url);
        this.verifyEvent = opts.verifyEvent;
        this._WebSocket = opts.websocketImplementation || WebSocket;
    }
    static async connect(url, opts) {
        const relay = new $4d24e3c498996220$var$AbstractRelay(url, opts);
        await relay.connect();
        return relay;
    }
    closeAllSubscriptions(reason) {
        for (let [_, sub] of this.openSubs)sub.close(reason);
        this.openSubs.clear();
        for (let [_, ep] of this.openEventPublishes)ep.reject(new Error(reason));
        this.openEventPublishes.clear();
        for (let [_, cr] of this.openCountRequests)cr.reject(new Error(reason));
        this.openCountRequests.clear();
    }
    get connected() {
        return this._connected;
    }
    async connect() {
        if (this.connectionPromise) return this.connectionPromise;
        this.challenge = void 0;
        this.authPromise = void 0;
        this.connectionPromise = new Promise((resolve, reject)=>{
            this.connectionTimeoutHandle = setTimeout(()=>{
                reject("connection timed out");
                this.connectionPromise = void 0;
                this.onclose?.();
                this.closeAllSubscriptions("relay connection timed out");
            }, this.connectionTimeout);
            try {
                this.ws = new this._WebSocket(this.url);
            } catch (err) {
                reject(err);
                return;
            }
            this.ws.onopen = ()=>{
                clearTimeout(this.connectionTimeoutHandle);
                this._connected = true;
                resolve();
            };
            this.ws.onerror = (ev)=>{
                reject(ev.message || "websocket error");
                if (this._connected) {
                    this._connected = false;
                    this.connectionPromise = void 0;
                    this.onclose?.();
                    this.closeAllSubscriptions("relay connection errored");
                }
            };
            this.ws.onclose = async ()=>{
                if (this._connected) {
                    this._connected = false;
                    this.connectionPromise = void 0;
                    this.onclose?.();
                    this.closeAllSubscriptions("relay connection closed");
                }
            };
            this.ws.onmessage = this._onmessage.bind(this);
        });
        return this.connectionPromise;
    }
    async runQueue() {
        this.queueRunning = true;
        while(true){
            if (false === this.handleNext()) break;
            await $4d24e3c498996220$var$yieldThread();
        }
        this.queueRunning = false;
    }
    handleNext() {
        const json = this.incomingMessageQueue.dequeue();
        if (!json) return false;
        const subid = $4d24e3c498996220$var$getSubscriptionId(json);
        if (subid) {
            const so = this.openSubs.get(subid);
            if (!so) return;
            const id = $4d24e3c498996220$var$getHex64(json, "id");
            const alreadyHave = so.alreadyHaveEvent?.(id);
            so.receivedEvent?.(this, id);
            if (alreadyHave) return;
        }
        try {
            let data = JSON.parse(json);
            switch(data[0]){
                case "EVENT":
                    {
                        const so = this.openSubs.get(data[1]);
                        const event = data[2];
                        if (this.verifyEvent(event) && $4d24e3c498996220$export$4bbf3f173cb9a4eb(so.filters, event)) so.onevent(event);
                        return;
                    }
                case "COUNT":
                    {
                        const id = data[1];
                        const payload = data[2];
                        const cr = this.openCountRequests.get(id);
                        if (cr) {
                            cr.resolve(payload.count);
                            this.openCountRequests.delete(id);
                        }
                        return;
                    }
                case "EOSE":
                    {
                        const so = this.openSubs.get(data[1]);
                        if (!so) return;
                        so.receivedEose();
                        return;
                    }
                case "OK":
                    {
                        const id = data[1];
                        const ok = data[2];
                        const reason = data[3];
                        const ep = this.openEventPublishes.get(id);
                        if (ep) {
                            clearTimeout(ep.timeout);
                            if (ok) ep.resolve(reason);
                            else ep.reject(new Error(reason));
                            this.openEventPublishes.delete(id);
                        }
                        return;
                    }
                case "CLOSED":
                    {
                        const id = data[1];
                        const so = this.openSubs.get(id);
                        if (!so) return;
                        so.closed = true;
                        so.close(data[2]);
                        return;
                    }
                case "NOTICE":
                    this.onnotice(data[1]);
                    return;
                case "AUTH":
                    this.challenge = data[1];
                    this.authPromise = void 0;
                    this._onauth?.(data[1]);
                    return;
            }
        } catch (err) {
            return;
        }
    }
    async send(message) {
        if (!this.connectionPromise) throw new Error("sending on closed connection");
        this.connectionPromise.then(()=>{
            this.ws?.send(message);
        });
    }
    async auth(signAuthEvent) {
        if (!this.challenge) throw new Error("can't perform auth, no challenge was received");
        if (this.authPromise) return this.authPromise;
        const evt = await signAuthEvent($4d24e3c498996220$var$makeAuthEvent(this.url, this.challenge));
        this.authPromise = new Promise((resolve, reject)=>{
            const timeout = setTimeout(()=>{
                const ep = this.openEventPublishes.get(evt.id);
                if (ep) {
                    ep.reject(new Error("auth timed out"));
                    this.openEventPublishes.delete(evt.id);
                }
            }, this.publishTimeout);
            this.openEventPublishes.set(evt.id, {
                resolve: resolve,
                reject: reject,
                timeout: timeout
            });
        });
        this.send('["AUTH",' + JSON.stringify(evt) + "]");
        return this.authPromise;
    }
    async publish(event) {
        const ret = new Promise((resolve, reject)=>{
            const timeout = setTimeout(()=>{
                const ep = this.openEventPublishes.get(event.id);
                if (ep) {
                    ep.reject(new Error("publish timed out"));
                    this.openEventPublishes.delete(event.id);
                }
            }, this.publishTimeout);
            this.openEventPublishes.set(event.id, {
                resolve: resolve,
                reject: reject,
                timeout: timeout
            });
        });
        this.send('["EVENT",' + JSON.stringify(event) + "]");
        return ret;
    }
    async count(filters, params) {
        this.serial++;
        const id = params?.id || "count:" + this.serial;
        const ret = new Promise((resolve, reject)=>{
            this.openCountRequests.set(id, {
                resolve: resolve,
                reject: reject
            });
        });
        this.send('["COUNT","' + id + '",' + JSON.stringify(filters).substring(1));
        return ret;
    }
    subscribe(filters, params) {
        const subscription = this.prepareSubscription(filters, params);
        subscription.fire();
        return subscription;
    }
    prepareSubscription(filters, params) {
        this.serial++;
        const id = params.id || (params.label ? params.label + ":" : "sub:") + this.serial;
        const subscription = new $4d24e3c498996220$var$Subscription(this, id, filters, params);
        this.openSubs.set(id, subscription);
        return subscription;
    }
    close() {
        this.closeAllSubscriptions("relay connection closed by us");
        this._connected = false;
        this.ws?.close();
    }
    _onmessage(ev) {
        this.incomingMessageQueue.enqueue(ev.data);
        if (!this.queueRunning) this.runQueue();
    }
};
var $4d24e3c498996220$var$Subscription = class {
    relay;
    id;
    closed = false;
    eosed = false;
    filters;
    alreadyHaveEvent;
    receivedEvent;
    onevent;
    oneose;
    onclose;
    eoseTimeout;
    eoseTimeoutHandle;
    constructor(relay, id, filters, params){
        this.relay = relay;
        this.filters = filters;
        this.id = id;
        this.alreadyHaveEvent = params.alreadyHaveEvent;
        this.receivedEvent = params.receivedEvent;
        this.eoseTimeout = params.eoseTimeout || relay.baseEoseTimeout;
        this.oneose = params.oneose;
        this.onclose = params.onclose;
        this.onevent = params.onevent || ((event)=>{
            console.warn(`onevent() callback not defined for subscription '${this.id}' in relay ${this.relay.url}. event received:`, event);
        });
    }
    fire() {
        this.relay.send('["REQ","' + this.id + '",' + JSON.stringify(this.filters).substring(1));
        this.eoseTimeoutHandle = setTimeout(this.receivedEose.bind(this), this.eoseTimeout);
    }
    receivedEose() {
        if (this.eosed) return;
        clearTimeout(this.eoseTimeoutHandle);
        this.eosed = true;
        this.oneose?.();
    }
    close(reason = "closed by caller") {
        if (!this.closed && this.relay.connected) {
            this.relay.send('["CLOSE",' + JSON.stringify(this.id) + "]");
            this.closed = true;
        }
        this.relay.openSubs.delete(this.id);
        this.onclose?.(reason);
    }
};
// relay.ts
var $4d24e3c498996220$var$_WebSocket;
try {
    $4d24e3c498996220$var$_WebSocket = WebSocket;
} catch  {}
var $4d24e3c498996220$export$325be0d991c73dc2 = class extends $4d24e3c498996220$var$AbstractRelay {
    constructor(url){
        super(url, {
            verifyEvent: $4d24e3c498996220$export$909d658b5069e986,
            websocketImplementation: $4d24e3c498996220$var$_WebSocket
        });
    }
    static async connect(url) {
        const relay = new $4d24e3c498996220$export$325be0d991c73dc2(url);
        await relay.connect();
        return relay;
    }
};
// abstract-pool.ts
var $4d24e3c498996220$var$AbstractSimplePool = class {
    relays = /* @__PURE__ */ new Map();
    seenOn = /* @__PURE__ */ new Map();
    trackRelays = false;
    verifyEvent;
    trustedRelayURLs = /* @__PURE__ */ new Set();
    _WebSocket;
    constructor(opts){
        this.verifyEvent = opts.verifyEvent;
        this._WebSocket = opts.websocketImplementation;
    }
    async ensureRelay(url, params) {
        url = $4d24e3c498996220$var$normalizeURL(url);
        let relay = this.relays.get(url);
        if (!relay) {
            relay = new $4d24e3c498996220$var$AbstractRelay(url, {
                verifyEvent: this.trustedRelayURLs.has(url) ? $4d24e3c498996220$var$alwaysTrue : this.verifyEvent,
                websocketImplementation: this._WebSocket
            });
            if (params?.connectionTimeout) relay.connectionTimeout = params.connectionTimeout;
            this.relays.set(url, relay);
        }
        await relay.connect();
        return relay;
    }
    close(relays) {
        relays.map($4d24e3c498996220$var$normalizeURL).forEach((url)=>{
            this.relays.get(url)?.close();
        });
    }
    subscribe(relays, filter, params) {
        return this.subscribeMap(relays.map((url)=>({
                url: url,
                filter: filter
            })), params);
    }
    subscribeMany(relays, filters, params) {
        return this.subscribeMap(relays.flatMap((url)=>filters.map((filter)=>({
                    url: url,
                    filter: filter
                }))), params);
    }
    subscribeMap(requests, params) {
        if (this.trackRelays) params.receivedEvent = (relay, id)=>{
            let set = this.seenOn.get(id);
            if (!set) {
                set = /* @__PURE__ */ new Set();
                this.seenOn.set(id, set);
            }
            set.add(relay);
        };
        const _knownIds = /* @__PURE__ */ new Set();
        const subs = [];
        const eosesReceived = [];
        let handleEose = (i2)=>{
            if (eosesReceived[i2]) return;
            eosesReceived[i2] = true;
            if (eosesReceived.filter((a)=>a).length === requests.length) {
                params.oneose?.();
                handleEose = ()=>{};
            }
        };
        const closesReceived = [];
        let handleClose = (i2, reason)=>{
            if (closesReceived[i2]) return;
            handleEose(i2);
            closesReceived[i2] = reason;
            if (closesReceived.filter((a)=>a).length === requests.length) {
                params.onclose?.(closesReceived);
                handleClose = ()=>{};
            }
        };
        const localAlreadyHaveEventHandler = (id)=>{
            if (params.alreadyHaveEvent?.(id)) return true;
            const have = _knownIds.has(id);
            _knownIds.add(id);
            return have;
        };
        const allOpened = Promise.all(requests.map(async ({ url: url, filter: filter }, i2)=>{
            url = $4d24e3c498996220$var$normalizeURL(url);
            let relay;
            try {
                relay = await this.ensureRelay(url, {
                    connectionTimeout: params.maxWait ? Math.max(params.maxWait * 0.8, params.maxWait - 1e3) : void 0
                });
            } catch (err) {
                handleClose(i2, err?.message || String(err));
                return;
            }
            let subscription = relay.subscribe([
                filter
            ], {
                ...params,
                oneose: ()=>handleEose(i2),
                onclose: (reason)=>{
                    if (reason.startsWith("auth-required:") && params.doauth) relay.auth(params.doauth).then(()=>{
                        relay.subscribe([
                            filter
                        ], {
                            ...params,
                            oneose: ()=>handleEose(i2),
                            onclose: (reason2)=>{
                                handleClose(i2, reason2);
                            },
                            alreadyHaveEvent: localAlreadyHaveEventHandler,
                            eoseTimeout: params.maxWait
                        });
                    }).catch((err)=>{
                        handleClose(i2, `auth was required and attempted, but failed with: ${err}`);
                    });
                    else handleClose(i2, reason);
                },
                alreadyHaveEvent: localAlreadyHaveEventHandler,
                eoseTimeout: params.maxWait
            });
            subs.push(subscription);
        }));
        return {
            async close () {
                await allOpened;
                subs.forEach((sub)=>{
                    sub.close();
                });
            }
        };
    }
    subscribeManyMap(requests, params) {
        if (this.trackRelays) params.receivedEvent = (relay, id)=>{
            let set = this.seenOn.get(id);
            if (!set) {
                set = /* @__PURE__ */ new Set();
                this.seenOn.set(id, set);
            }
            set.add(relay);
        };
        const _knownIds = /* @__PURE__ */ new Set();
        const subs = [];
        const relaysLength = Object.keys(requests).length;
        const eosesReceived = [];
        let handleEose = (i2)=>{
            if (eosesReceived[i2]) return;
            eosesReceived[i2] = true;
            if (eosesReceived.filter((a)=>a).length === relaysLength) {
                params.oneose?.();
                handleEose = ()=>{};
            }
        };
        const closesReceived = [];
        let handleClose = (i2, reason)=>{
            if (closesReceived[i2]) return;
            handleEose(i2);
            closesReceived[i2] = reason;
            if (closesReceived.filter((a)=>a).length === relaysLength) {
                params.onclose?.(closesReceived);
                handleClose = ()=>{};
            }
        };
        const localAlreadyHaveEventHandler = (id)=>{
            if (params.alreadyHaveEvent?.(id)) return true;
            const have = _knownIds.has(id);
            _knownIds.add(id);
            return have;
        };
        const allOpened = Promise.all(Object.entries(requests).map(async (req, i2, arr)=>{
            if (arr.indexOf(req) !== i2) {
                handleClose(i2, "duplicate url");
                return;
            }
            let [url, filters] = req;
            url = $4d24e3c498996220$var$normalizeURL(url);
            let relay;
            try {
                relay = await this.ensureRelay(url, {
                    connectionTimeout: params.maxWait ? Math.max(params.maxWait * 0.8, params.maxWait - 1e3) : void 0
                });
            } catch (err) {
                handleClose(i2, err?.message || String(err));
                return;
            }
            let subscription = relay.subscribe(filters, {
                ...params,
                oneose: ()=>handleEose(i2),
                onclose: (reason)=>{
                    if (reason.startsWith("auth-required:") && params.doauth) relay.auth(params.doauth).then(()=>{
                        relay.subscribe(filters, {
                            ...params,
                            oneose: ()=>handleEose(i2),
                            onclose: (reason2)=>{
                                handleClose(i2, reason2);
                            },
                            alreadyHaveEvent: localAlreadyHaveEventHandler,
                            eoseTimeout: params.maxWait
                        });
                    }).catch((err)=>{
                        handleClose(i2, `auth was required and attempted, but failed with: ${err}`);
                    });
                    else handleClose(i2, reason);
                },
                alreadyHaveEvent: localAlreadyHaveEventHandler,
                eoseTimeout: params.maxWait
            });
            subs.push(subscription);
        }));
        return {
            async close () {
                await allOpened;
                subs.forEach((sub)=>{
                    sub.close();
                });
            }
        };
    }
    subscribeEose(relays, filter, params) {
        const subcloser = this.subscribe(relays, filter, {
            ...params,
            oneose () {
                subcloser.close();
            }
        });
        return subcloser;
    }
    subscribeManyEose(relays, filters, params) {
        const subcloser = this.subscribeMany(relays, filters, {
            ...params,
            oneose () {
                subcloser.close();
            }
        });
        return subcloser;
    }
    async querySync(relays, filter, params) {
        return new Promise(async (resolve)=>{
            const events = [];
            this.subscribeEose(relays, filter, {
                ...params,
                onevent (event) {
                    events.push(event);
                },
                onclose (_) {
                    resolve(events);
                }
            });
        });
    }
    async get(relays, filter, params) {
        filter.limit = 1;
        const events = await this.querySync(relays, filter, params);
        events.sort((a, b)=>b.created_at - a.created_at);
        return events[0] || null;
    }
    publish(relays, event) {
        return relays.map($4d24e3c498996220$var$normalizeURL).map(async (url, i2, arr)=>{
            if (arr.indexOf(url) !== i2) return Promise.reject("duplicate url");
            let r = await this.ensureRelay(url);
            return r.publish(event).then((reason)=>{
                if (this.trackRelays) {
                    let set = this.seenOn.get(event.id);
                    if (!set) {
                        set = /* @__PURE__ */ new Set();
                        this.seenOn.set(event.id, set);
                    }
                    set.add(r);
                }
                return reason;
            });
        });
    }
    listConnectionStatus() {
        const map = /* @__PURE__ */ new Map();
        this.relays.forEach((relay, url)=>map.set(url, relay.connected));
        return map;
    }
    destroy() {
        this.relays.forEach((conn)=>conn.close());
        this.relays = /* @__PURE__ */ new Map();
    }
};
// pool.ts
var $4d24e3c498996220$var$_WebSocket2;
try {
    $4d24e3c498996220$var$_WebSocket2 = WebSocket;
} catch  {}
var $4d24e3c498996220$export$db45add7d1880f0c = class extends $4d24e3c498996220$var$AbstractSimplePool {
    constructor(){
        super({
            verifyEvent: $4d24e3c498996220$export$909d658b5069e986,
            websocketImplementation: $4d24e3c498996220$var$_WebSocket2
        });
    }
};
// nip19.ts
var $4d24e3c498996220$export$10660ae21dbef115 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$10660ae21dbef115, {
    BECH32_REGEX: ()=>$4d24e3c498996220$var$BECH32_REGEX,
    Bech32MaxSize: ()=>$4d24e3c498996220$var$Bech32MaxSize,
    NostrTypeGuard: ()=>$4d24e3c498996220$var$NostrTypeGuard,
    decode: ()=>$4d24e3c498996220$var$decode,
    decodeNostrURI: ()=>$4d24e3c498996220$var$decodeNostrURI,
    encodeBytes: ()=>$4d24e3c498996220$var$encodeBytes,
    naddrEncode: ()=>$4d24e3c498996220$var$naddrEncode,
    neventEncode: ()=>$4d24e3c498996220$var$neventEncode,
    noteEncode: ()=>$4d24e3c498996220$var$noteEncode,
    nprofileEncode: ()=>$4d24e3c498996220$var$nprofileEncode,
    npubEncode: ()=>$4d24e3c498996220$var$npubEncode,
    nsecEncode: ()=>$4d24e3c498996220$var$nsecEncode
});
var $4d24e3c498996220$var$NostrTypeGuard = {
    isNProfile: (value)=>/^nprofile1[a-z\d]+$/.test(value || ""),
    isNEvent: (value)=>/^nevent1[a-z\d]+$/.test(value || ""),
    isNAddr: (value)=>/^naddr1[a-z\d]+$/.test(value || ""),
    isNSec: (value)=>/^nsec1[a-z\d]{58}$/.test(value || ""),
    isNPub: (value)=>/^npub1[a-z\d]{58}$/.test(value || ""),
    isNote: (value)=>/^note1[a-z\d]+$/.test(value || ""),
    isNcryptsec: (value)=>/^ncryptsec1[a-z\d]+$/.test(value || "")
};
var $4d24e3c498996220$var$Bech32MaxSize = 5e3;
var $4d24e3c498996220$var$BECH32_REGEX = /[\x21-\x7E]{1,83}1[023456789acdefghjklmnpqrstuvwxyz]{6,}/;
function $4d24e3c498996220$var$integerToUint8Array(number) {
    const uint8Array = new Uint8Array(4);
    uint8Array[0] = number >> 24 & 255;
    uint8Array[1] = number >> 16 & 255;
    uint8Array[2] = number >> 8 & 255;
    uint8Array[3] = number & 255;
    return uint8Array;
}
function $4d24e3c498996220$var$decodeNostrURI(nip19code) {
    try {
        if (nip19code.startsWith("nostr:")) nip19code = nip19code.substring(6);
        return $4d24e3c498996220$var$decode(nip19code);
    } catch (_err) {
        return {
            type: "invalid",
            data: null
        };
    }
}
function $4d24e3c498996220$var$decode(nip19) {
    let { prefix: prefix, words: words } = (0, $7i98v.bech32).decode(nip19, $4d24e3c498996220$var$Bech32MaxSize);
    let data = new Uint8Array((0, $7i98v.bech32).fromWords(words));
    switch(prefix){
        case "nprofile":
            {
                let tlv = $4d24e3c498996220$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for nprofile");
                if (tlv[0][0].length !== 32) throw new Error("TLV 0 should be 32 bytes");
                return {
                    type: "nprofile",
                    data: {
                        pubkey: (0, $9mdbq.bytesToHex)(tlv[0][0]),
                        relays: tlv[1] ? tlv[1].map((d)=>$4d24e3c498996220$var$utf8Decoder.decode(d)) : []
                    }
                };
            }
        case "nevent":
            {
                let tlv = $4d24e3c498996220$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for nevent");
                if (tlv[0][0].length !== 32) throw new Error("TLV 0 should be 32 bytes");
                if (tlv[2] && tlv[2][0].length !== 32) throw new Error("TLV 2 should be 32 bytes");
                if (tlv[3] && tlv[3][0].length !== 4) throw new Error("TLV 3 should be 4 bytes");
                return {
                    type: "nevent",
                    data: {
                        id: (0, $9mdbq.bytesToHex)(tlv[0][0]),
                        relays: tlv[1] ? tlv[1].map((d)=>$4d24e3c498996220$var$utf8Decoder.decode(d)) : [],
                        author: tlv[2]?.[0] ? (0, $9mdbq.bytesToHex)(tlv[2][0]) : void 0,
                        kind: tlv[3]?.[0] ? parseInt((0, $9mdbq.bytesToHex)(tlv[3][0]), 16) : void 0
                    }
                };
            }
        case "naddr":
            {
                let tlv = $4d24e3c498996220$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for naddr");
                if (!tlv[2]?.[0]) throw new Error("missing TLV 2 for naddr");
                if (tlv[2][0].length !== 32) throw new Error("TLV 2 should be 32 bytes");
                if (!tlv[3]?.[0]) throw new Error("missing TLV 3 for naddr");
                if (tlv[3][0].length !== 4) throw new Error("TLV 3 should be 4 bytes");
                return {
                    type: "naddr",
                    data: {
                        identifier: $4d24e3c498996220$var$utf8Decoder.decode(tlv[0][0]),
                        pubkey: (0, $9mdbq.bytesToHex)(tlv[2][0]),
                        kind: parseInt((0, $9mdbq.bytesToHex)(tlv[3][0]), 16),
                        relays: tlv[1] ? tlv[1].map((d)=>$4d24e3c498996220$var$utf8Decoder.decode(d)) : []
                    }
                };
            }
        case "nsec":
            return {
                type: prefix,
                data: data
            };
        case "npub":
        case "note":
            return {
                type: prefix,
                data: (0, $9mdbq.bytesToHex)(data)
            };
        default:
            throw new Error(`unknown prefix ${prefix}`);
    }
}
function $4d24e3c498996220$var$parseTLV(data) {
    let result = {};
    let rest = data;
    while(rest.length > 0){
        let t = rest[0];
        let l = rest[1];
        let v = rest.slice(2, 2 + l);
        rest = rest.slice(2 + l);
        if (v.length < l) throw new Error(`not enough data to read on TLV ${t}`);
        result[t] = result[t] || [];
        result[t].push(v);
    }
    return result;
}
function $4d24e3c498996220$var$nsecEncode(key) {
    return $4d24e3c498996220$var$encodeBytes("nsec", key);
}
function $4d24e3c498996220$var$npubEncode(hex) {
    return $4d24e3c498996220$var$encodeBytes("npub", (0, $9mdbq.hexToBytes)(hex));
}
function $4d24e3c498996220$var$noteEncode(hex) {
    return $4d24e3c498996220$var$encodeBytes("note", (0, $9mdbq.hexToBytes)(hex));
}
function $4d24e3c498996220$var$encodeBech32(prefix, data) {
    let words = (0, $7i98v.bech32).toWords(data);
    return (0, $7i98v.bech32).encode(prefix, words, $4d24e3c498996220$var$Bech32MaxSize);
}
function $4d24e3c498996220$var$encodeBytes(prefix, bytes) {
    return $4d24e3c498996220$var$encodeBech32(prefix, bytes);
}
function $4d24e3c498996220$var$nprofileEncode(profile) {
    let data = $4d24e3c498996220$var$encodeTLV({
        0: [
            (0, $9mdbq.hexToBytes)(profile.pubkey)
        ],
        1: (profile.relays || []).map((url)=>$4d24e3c498996220$var$utf8Encoder.encode(url))
    });
    return $4d24e3c498996220$var$encodeBech32("nprofile", data);
}
function $4d24e3c498996220$var$neventEncode(event) {
    let kindArray;
    if (event.kind !== void 0) kindArray = $4d24e3c498996220$var$integerToUint8Array(event.kind);
    let data = $4d24e3c498996220$var$encodeTLV({
        0: [
            (0, $9mdbq.hexToBytes)(event.id)
        ],
        1: (event.relays || []).map((url)=>$4d24e3c498996220$var$utf8Encoder.encode(url)),
        2: event.author ? [
            (0, $9mdbq.hexToBytes)(event.author)
        ] : [],
        3: kindArray ? [
            new Uint8Array(kindArray)
        ] : []
    });
    return $4d24e3c498996220$var$encodeBech32("nevent", data);
}
function $4d24e3c498996220$var$naddrEncode(addr) {
    let kind = new ArrayBuffer(4);
    new DataView(kind).setUint32(0, addr.kind, false);
    let data = $4d24e3c498996220$var$encodeTLV({
        0: [
            $4d24e3c498996220$var$utf8Encoder.encode(addr.identifier)
        ],
        1: (addr.relays || []).map((url)=>$4d24e3c498996220$var$utf8Encoder.encode(url)),
        2: [
            (0, $9mdbq.hexToBytes)(addr.pubkey)
        ],
        3: [
            new Uint8Array(kind)
        ]
    });
    return $4d24e3c498996220$var$encodeBech32("naddr", data);
}
function $4d24e3c498996220$var$encodeTLV(tlv) {
    let entries = [];
    Object.entries(tlv).reverse().forEach(([t, vs])=>{
        vs.forEach((v)=>{
            let entry = new Uint8Array(v.length + 2);
            entry.set([
                parseInt(t)
            ], 0);
            entry.set([
                v.length
            ], 1);
            entry.set(v, 2);
            entries.push(entry);
        });
    });
    return (0, $9mdbq.concatBytes)(...entries);
}
// references.ts
var $4d24e3c498996220$var$mentionRegex = /\bnostr:((note|npub|naddr|nevent|nprofile)1\w+)\b|#\[(\d+)\]/g;
function $4d24e3c498996220$export$2b054a310b694903(evt) {
    let references = [];
    for (let ref of evt.content.matchAll($4d24e3c498996220$var$mentionRegex)){
        if (ref[2]) try {
            let { type: type, data: data } = $4d24e3c498996220$var$decode(ref[1]);
            switch(type){
                case "npub":
                    references.push({
                        text: ref[0],
                        profile: {
                            pubkey: data,
                            relays: []
                        }
                    });
                    break;
                case "nprofile":
                    references.push({
                        text: ref[0],
                        profile: data
                    });
                    break;
                case "note":
                    references.push({
                        text: ref[0],
                        event: {
                            id: data,
                            relays: []
                        }
                    });
                    break;
                case "nevent":
                    references.push({
                        text: ref[0],
                        event: data
                    });
                    break;
                case "naddr":
                    references.push({
                        text: ref[0],
                        address: data
                    });
                    break;
            }
        } catch (err) {}
        else if (ref[3]) {
            let idx = parseInt(ref[3], 10);
            let tag = evt.tags[idx];
            if (!tag) continue;
            switch(tag[0]){
                case "p":
                    references.push({
                        text: ref[0],
                        profile: {
                            pubkey: tag[1],
                            relays: tag[2] ? [
                                tag[2]
                            ] : []
                        }
                    });
                    break;
                case "e":
                    references.push({
                        text: ref[0],
                        event: {
                            id: tag[1],
                            relays: tag[2] ? [
                                tag[2]
                            ] : []
                        }
                    });
                    break;
                case "a":
                    try {
                        let [kind, pubkey, identifier] = tag[1].split(":");
                        references.push({
                            text: ref[0],
                            address: {
                                identifier: identifier,
                                pubkey: pubkey,
                                kind: parseInt(kind, 10),
                                relays: tag[2] ? [
                                    tag[2]
                                ] : []
                            }
                        });
                    } catch (err) {}
                    break;
            }
        }
    }
    return references;
}
// nip04.ts
var $4d24e3c498996220$export$4793e42c2cc9b120 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$4793e42c2cc9b120, {
    decrypt: ()=>$4d24e3c498996220$var$decrypt,
    encrypt: ()=>$4d24e3c498996220$var$encrypt
});
function $4d24e3c498996220$var$encrypt(secretKey, pubkey, text) {
    const privkey = secretKey instanceof Uint8Array ? (0, $9mdbq.bytesToHex)(secretKey) : secretKey;
    const key = (0, $lPiFO.secp256k1).getSharedSecret(privkey, "02" + pubkey);
    const normalizedKey = $4d24e3c498996220$var$getNormalizedX(key);
    let iv = Uint8Array.from((0, $9mdbq.randomBytes)(16));
    let plaintext = $4d24e3c498996220$var$utf8Encoder.encode(text);
    let ciphertext = (0, $3njOQ.cbc)(normalizedKey, iv).encrypt(plaintext);
    let ctb64 = (0, $7i98v.base64).encode(new Uint8Array(ciphertext));
    let ivb64 = (0, $7i98v.base64).encode(new Uint8Array(iv.buffer));
    return `${ctb64}?iv=${ivb64}`;
}
function $4d24e3c498996220$var$decrypt(secretKey, pubkey, data) {
    const privkey = secretKey instanceof Uint8Array ? (0, $9mdbq.bytesToHex)(secretKey) : secretKey;
    let [ctb64, ivb64] = data.split("?iv=");
    let key = (0, $lPiFO.secp256k1).getSharedSecret(privkey, "02" + pubkey);
    let normalizedKey = $4d24e3c498996220$var$getNormalizedX(key);
    let iv = (0, $7i98v.base64).decode(ivb64);
    let ciphertext = (0, $7i98v.base64).decode(ctb64);
    let plaintext = (0, $3njOQ.cbc)(normalizedKey, iv).decrypt(ciphertext);
    return $4d24e3c498996220$var$utf8Decoder.decode(plaintext);
}
function $4d24e3c498996220$var$getNormalizedX(key) {
    return key.slice(1, 33);
}
// nip05.ts
var $4d24e3c498996220$export$a60e5b740ad8d13e = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$a60e5b740ad8d13e, {
    NIP05_REGEX: ()=>$4d24e3c498996220$var$NIP05_REGEX,
    isNip05: ()=>$4d24e3c498996220$var$isNip05,
    isValid: ()=>$4d24e3c498996220$var$isValid,
    queryProfile: ()=>$4d24e3c498996220$var$queryProfile,
    searchDomain: ()=>$4d24e3c498996220$var$searchDomain,
    useFetchImplementation: ()=>$4d24e3c498996220$var$useFetchImplementation
});
var $4d24e3c498996220$var$NIP05_REGEX = /^(?:([\w.+-]+)@)?([\w_-]+(\.[\w_-]+)+)$/;
var $4d24e3c498996220$var$isNip05 = (value)=>$4d24e3c498996220$var$NIP05_REGEX.test(value || "");
var $4d24e3c498996220$var$_fetch;
try {
    $4d24e3c498996220$var$_fetch = fetch;
} catch (_) {}
function $4d24e3c498996220$var$useFetchImplementation(fetchImplementation) {
    $4d24e3c498996220$var$_fetch = fetchImplementation;
}
async function $4d24e3c498996220$var$searchDomain(domain, query = "") {
    try {
        const url = `https://${domain}/.well-known/nostr.json?name=${query}`;
        const res = await $4d24e3c498996220$var$_fetch(url, {
            redirect: "manual"
        });
        if (res.status !== 200) throw Error("Wrong response code");
        const json = await res.json();
        return json.names;
    } catch (_) {
        return {};
    }
}
async function $4d24e3c498996220$var$queryProfile(fullname) {
    const match = fullname.match($4d24e3c498996220$var$NIP05_REGEX);
    if (!match) return null;
    const [, name = "_", domain] = match;
    try {
        const url = `https://${domain}/.well-known/nostr.json?name=${name}`;
        const res = await $4d24e3c498996220$var$_fetch(url, {
            redirect: "manual"
        });
        if (res.status !== 200) throw Error("Wrong response code");
        const json = await res.json();
        const pubkey = json.names[name];
        return pubkey ? {
            pubkey: pubkey,
            relays: json.relays?.[pubkey]
        } : null;
    } catch (_e) {
        return null;
    }
}
async function $4d24e3c498996220$var$isValid(pubkey, nip05) {
    const res = await $4d24e3c498996220$var$queryProfile(nip05);
    return res ? res.pubkey === pubkey : false;
}
// nip10.ts
var $4d24e3c498996220$export$ce5090ce1281ef76 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$ce5090ce1281ef76, {
    parse: ()=>$4d24e3c498996220$var$parse
});
function $4d24e3c498996220$var$parse(event) {
    const result = {
        reply: void 0,
        root: void 0,
        mentions: [],
        profiles: [],
        quotes: []
    };
    let maybeParent;
    let maybeRoot;
    for(let i2 = event.tags.length - 1; i2 >= 0; i2--){
        const tag = event.tags[i2];
        if (tag[0] === "e" && tag[1]) {
            const [_, eTagEventId, eTagRelayUrl, eTagMarker, eTagAuthor] = tag;
            const eventPointer = {
                id: eTagEventId,
                relays: eTagRelayUrl ? [
                    eTagRelayUrl
                ] : [],
                author: eTagAuthor
            };
            if (eTagMarker === "root") {
                result.root = eventPointer;
                continue;
            }
            if (eTagMarker === "reply") {
                result.reply = eventPointer;
                continue;
            }
            if (eTagMarker === "mention") {
                result.mentions.push(eventPointer);
                continue;
            }
            if (!maybeParent) maybeParent = eventPointer;
            else maybeRoot = eventPointer;
            result.mentions.push(eventPointer);
            continue;
        }
        if (tag[0] === "q" && tag[1]) {
            const [_, eTagEventId, eTagRelayUrl] = tag;
            result.quotes.push({
                id: eTagEventId,
                relays: eTagRelayUrl ? [
                    eTagRelayUrl
                ] : []
            });
        }
        if (tag[0] === "p" && tag[1]) {
            result.profiles.push({
                pubkey: tag[1],
                relays: tag[2] ? [
                    tag[2]
                ] : []
            });
            continue;
        }
    }
    if (!result.root) result.root = maybeRoot || maybeParent || result.reply;
    if (!result.reply) result.reply = maybeParent || result.root;
    [
        result.reply,
        result.root
    ].forEach((ref)=>{
        if (!ref) return;
        let idx = result.mentions.indexOf(ref);
        if (idx !== -1) result.mentions.splice(idx, 1);
        if (ref.author) {
            let author = result.profiles.find((p)=>p.pubkey === ref.author);
            if (author && author.relays) {
                if (!ref.relays) ref.relays = [];
                author.relays.forEach((url)=>{
                    if (ref.relays?.indexOf(url) === -1) ref.relays.push(url);
                });
                author.relays = ref.relays;
            }
        }
    });
    result.mentions.forEach((ref)=>{
        if (ref.author) {
            let author = result.profiles.find((p)=>p.pubkey === ref.author);
            if (author && author.relays) {
                if (!ref.relays) ref.relays = [];
                author.relays.forEach((url)=>{
                    if (ref.relays.indexOf(url) === -1) ref.relays.push(url);
                });
                author.relays = ref.relays;
            }
        }
    });
    return result;
}
// nip11.ts
var $4d24e3c498996220$export$86cbe01fda153e74 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$86cbe01fda153e74, {
    fetchRelayInformation: ()=>$4d24e3c498996220$var$fetchRelayInformation,
    useFetchImplementation: ()=>$4d24e3c498996220$var$useFetchImplementation2
});
var $4d24e3c498996220$var$_fetch2;
try {
    $4d24e3c498996220$var$_fetch2 = fetch;
} catch  {}
function $4d24e3c498996220$var$useFetchImplementation2(fetchImplementation) {
    $4d24e3c498996220$var$_fetch2 = fetchImplementation;
}
async function $4d24e3c498996220$var$fetchRelayInformation(url) {
    return await (await fetch(url.replace("ws://", "http://").replace("wss://", "https://"), {
        headers: {
            Accept: "application/nostr+json"
        }
    })).json();
}
// nip13.ts
var $4d24e3c498996220$export$215f75f26b6c95fe = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$215f75f26b6c95fe, {
    fastEventHash: ()=>$4d24e3c498996220$var$fastEventHash,
    getPow: ()=>$4d24e3c498996220$var$getPow,
    minePow: ()=>$4d24e3c498996220$var$minePow
});
function $4d24e3c498996220$var$getPow(hex) {
    let count = 0;
    for(let i2 = 0; i2 < 64; i2 += 8){
        const nibble = parseInt(hex.substring(i2, i2 + 8), 16);
        if (nibble === 0) count += 32;
        else {
            count += Math.clz32(nibble);
            break;
        }
    }
    return count;
}
function $4d24e3c498996220$var$minePow(unsigned, difficulty) {
    let count = 0;
    const event = unsigned;
    const tag = [
        "nonce",
        count.toString(),
        difficulty.toString()
    ];
    event.tags.push(tag);
    while(true){
        const now2 = Math.floor(new Date().getTime() / 1e3);
        if (now2 !== event.created_at) {
            count = 0;
            event.created_at = now2;
        }
        tag[1] = (++count).toString();
        event.id = $4d24e3c498996220$var$fastEventHash(event);
        if ($4d24e3c498996220$var$getPow(event.id) >= difficulty) break;
    }
    return event;
}
function $4d24e3c498996220$var$fastEventHash(evt) {
    return (0, $9mdbq.bytesToHex)((0, $kHnZL.sha256)($4d24e3c498996220$var$utf8Encoder.encode(JSON.stringify([
        0,
        evt.pubkey,
        evt.created_at,
        evt.kind,
        evt.tags,
        evt.content
    ]))));
}
// nip17.ts
var $4d24e3c498996220$export$b2365d93b6f57df6 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$b2365d93b6f57df6, {
    unwrapEvent: ()=>$4d24e3c498996220$var$unwrapEvent2,
    unwrapManyEvents: ()=>$4d24e3c498996220$var$unwrapManyEvents2,
    wrapEvent: ()=>$4d24e3c498996220$var$wrapEvent2,
    wrapManyEvents: ()=>$4d24e3c498996220$var$wrapManyEvents2
});
// nip59.ts
var $4d24e3c498996220$export$c928dafb9718f202 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$c928dafb9718f202, {
    createRumor: ()=>$4d24e3c498996220$var$createRumor,
    createSeal: ()=>$4d24e3c498996220$var$createSeal,
    createWrap: ()=>$4d24e3c498996220$var$createWrap,
    unwrapEvent: ()=>$4d24e3c498996220$var$unwrapEvent,
    unwrapManyEvents: ()=>$4d24e3c498996220$var$unwrapManyEvents,
    wrapEvent: ()=>$4d24e3c498996220$var$wrapEvent,
    wrapManyEvents: ()=>$4d24e3c498996220$var$wrapManyEvents
});
// nip44.ts
var $4d24e3c498996220$export$7f3384dd63301b54 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$7f3384dd63301b54, {
    decrypt: ()=>$4d24e3c498996220$var$decrypt2,
    encrypt: ()=>$4d24e3c498996220$var$encrypt2,
    getConversationKey: ()=>$4d24e3c498996220$var$getConversationKey,
    v2: ()=>$4d24e3c498996220$var$v2
});
var $4d24e3c498996220$var$minPlaintextSize = 1;
var $4d24e3c498996220$var$maxPlaintextSize = 65535;
function $4d24e3c498996220$var$getConversationKey(privkeyA, pubkeyB) {
    const sharedX = (0, $lPiFO.secp256k1).getSharedSecret(privkeyA, "02" + pubkeyB).subarray(1, 33);
    return (0, $b24L2.extract)((0, $kHnZL.sha256), sharedX, "nip44-v2");
}
function $4d24e3c498996220$var$getMessageKeys(conversationKey, nonce) {
    const keys = (0, $b24L2.expand)((0, $kHnZL.sha256), conversationKey, nonce, 76);
    return {
        chacha_key: keys.subarray(0, 32),
        chacha_nonce: keys.subarray(32, 44),
        hmac_key: keys.subarray(44, 76)
    };
}
function $4d24e3c498996220$var$calcPaddedLen(len) {
    if (!Number.isSafeInteger(len) || len < 1) throw new Error("expected positive integer");
    if (len <= 32) return 32;
    const nextPower = 1 << Math.floor(Math.log2(len - 1)) + 1;
    const chunk = nextPower <= 256 ? 32 : nextPower / 8;
    return chunk * (Math.floor((len - 1) / chunk) + 1);
}
function $4d24e3c498996220$var$writeU16BE(num) {
    if (!Number.isSafeInteger(num) || num < $4d24e3c498996220$var$minPlaintextSize || num > $4d24e3c498996220$var$maxPlaintextSize) throw new Error("invalid plaintext size: must be between 1 and 65535 bytes");
    const arr = new Uint8Array(2);
    new DataView(arr.buffer).setUint16(0, num, false);
    return arr;
}
function $4d24e3c498996220$var$pad(plaintext) {
    const unpadded = $4d24e3c498996220$var$utf8Encoder.encode(plaintext);
    const unpaddedLen = unpadded.length;
    const prefix = $4d24e3c498996220$var$writeU16BE(unpaddedLen);
    const suffix = new Uint8Array($4d24e3c498996220$var$calcPaddedLen(unpaddedLen) - unpaddedLen);
    return (0, $9mdbq.concatBytes)(prefix, unpadded, suffix);
}
function $4d24e3c498996220$var$unpad(padded) {
    const unpaddedLen = new DataView(padded.buffer).getUint16(0);
    const unpadded = padded.subarray(2, 2 + unpaddedLen);
    if (unpaddedLen < $4d24e3c498996220$var$minPlaintextSize || unpaddedLen > $4d24e3c498996220$var$maxPlaintextSize || unpadded.length !== unpaddedLen || padded.length !== 2 + $4d24e3c498996220$var$calcPaddedLen(unpaddedLen)) throw new Error("invalid padding");
    return $4d24e3c498996220$var$utf8Decoder.decode(unpadded);
}
function $4d24e3c498996220$var$hmacAad(key, message, aad) {
    if (aad.length !== 32) throw new Error("AAD associated data must be 32 bytes");
    const combined = (0, $9mdbq.concatBytes)(aad, message);
    return (0, $9KVQy.hmac)((0, $kHnZL.sha256), key, combined);
}
function $4d24e3c498996220$var$decodePayload(payload) {
    if (typeof payload !== "string") throw new Error("payload must be a valid string");
    const plen = payload.length;
    if (plen < 132 || plen > 87472) throw new Error("invalid payload length: " + plen);
    if (payload[0] === "#") throw new Error("unknown encryption version");
    let data;
    try {
        data = (0, $7i98v.base64).decode(payload);
    } catch (error) {
        throw new Error("invalid base64: " + error.message);
    }
    const dlen = data.length;
    if (dlen < 99 || dlen > 65603) throw new Error("invalid data length: " + dlen);
    const vers = data[0];
    if (vers !== 2) throw new Error("unknown encryption version " + vers);
    return {
        nonce: data.subarray(1, 33),
        ciphertext: data.subarray(33, -32),
        mac: data.subarray(-32)
    };
}
function $4d24e3c498996220$var$encrypt2(plaintext, conversationKey, nonce = (0, $9mdbq.randomBytes)(32)) {
    const { chacha_key: chacha_key, chacha_nonce: chacha_nonce, hmac_key: hmac_key } = $4d24e3c498996220$var$getMessageKeys(conversationKey, nonce);
    const padded = $4d24e3c498996220$var$pad(plaintext);
    const ciphertext = (0, $9zClU.chacha20)(chacha_key, chacha_nonce, padded);
    const mac = $4d24e3c498996220$var$hmacAad(hmac_key, ciphertext, nonce);
    return (0, $7i98v.base64).encode((0, $9mdbq.concatBytes)(new Uint8Array([
        2
    ]), nonce, ciphertext, mac));
}
function $4d24e3c498996220$var$decrypt2(payload, conversationKey) {
    const { nonce: nonce, ciphertext: ciphertext, mac: mac } = $4d24e3c498996220$var$decodePayload(payload);
    const { chacha_key: chacha_key, chacha_nonce: chacha_nonce, hmac_key: hmac_key } = $4d24e3c498996220$var$getMessageKeys(conversationKey, nonce);
    const calculatedMac = $4d24e3c498996220$var$hmacAad(hmac_key, ciphertext, nonce);
    if (!(0, $ltMLs.equalBytes)(calculatedMac, mac)) throw new Error("invalid MAC");
    const padded = (0, $9zClU.chacha20)(chacha_key, chacha_nonce, ciphertext);
    return $4d24e3c498996220$var$unpad(padded);
}
var $4d24e3c498996220$var$v2 = {
    utils: {
        getConversationKey: $4d24e3c498996220$var$getConversationKey,
        calcPaddedLen: $4d24e3c498996220$var$calcPaddedLen
    },
    encrypt: $4d24e3c498996220$var$encrypt2,
    decrypt: $4d24e3c498996220$var$decrypt2
};
// nip59.ts
var $4d24e3c498996220$var$TWO_DAYS = 172800;
var $4d24e3c498996220$var$now = ()=>Math.round(Date.now() / 1e3);
var $4d24e3c498996220$var$randomNow = ()=>Math.round($4d24e3c498996220$var$now() - Math.random() * $4d24e3c498996220$var$TWO_DAYS);
var $4d24e3c498996220$var$nip44ConversationKey = (privateKey, publicKey)=>$4d24e3c498996220$var$getConversationKey(privateKey, publicKey);
var $4d24e3c498996220$var$nip44Encrypt = (data, privateKey, publicKey)=>$4d24e3c498996220$var$encrypt2(JSON.stringify(data), $4d24e3c498996220$var$nip44ConversationKey(privateKey, publicKey));
var $4d24e3c498996220$var$nip44Decrypt = (data, privateKey)=>JSON.parse($4d24e3c498996220$var$decrypt2(data.content, $4d24e3c498996220$var$nip44ConversationKey(privateKey, data.pubkey)));
function $4d24e3c498996220$var$createRumor(event, privateKey) {
    const rumor = {
        created_at: $4d24e3c498996220$var$now(),
        content: "",
        tags: [],
        ...event,
        pubkey: $4d24e3c498996220$export$889def73691f9837(privateKey)
    };
    rumor.id = $4d24e3c498996220$export$11a838ad4e557e0e(rumor);
    return rumor;
}
function $4d24e3c498996220$var$createSeal(rumor, privateKey, recipientPublicKey) {
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$Seal,
        content: $4d24e3c498996220$var$nip44Encrypt(rumor, privateKey, recipientPublicKey),
        created_at: $4d24e3c498996220$var$randomNow(),
        tags: []
    }, privateKey);
}
function $4d24e3c498996220$var$createWrap(seal, recipientPublicKey) {
    const randomKey = $4d24e3c498996220$export$16ca411381fc81c8();
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$GiftWrap,
        content: $4d24e3c498996220$var$nip44Encrypt(seal, randomKey, recipientPublicKey),
        created_at: $4d24e3c498996220$var$randomNow(),
        tags: [
            [
                "p",
                recipientPublicKey
            ]
        ]
    }, randomKey);
}
function $4d24e3c498996220$var$wrapEvent(event, senderPrivateKey, recipientPublicKey) {
    const rumor = $4d24e3c498996220$var$createRumor(event, senderPrivateKey);
    const seal = $4d24e3c498996220$var$createSeal(rumor, senderPrivateKey, recipientPublicKey);
    return $4d24e3c498996220$var$createWrap(seal, recipientPublicKey);
}
function $4d24e3c498996220$var$wrapManyEvents(event, senderPrivateKey, recipientsPublicKeys) {
    if (!recipientsPublicKeys || recipientsPublicKeys.length === 0) throw new Error("At least one recipient is required.");
    const senderPublicKey = $4d24e3c498996220$export$889def73691f9837(senderPrivateKey);
    const wrappeds = [
        $4d24e3c498996220$var$wrapEvent(event, senderPrivateKey, senderPublicKey)
    ];
    recipientsPublicKeys.forEach((recipientPublicKey)=>{
        wrappeds.push($4d24e3c498996220$var$wrapEvent(event, senderPrivateKey, recipientPublicKey));
    });
    return wrappeds;
}
function $4d24e3c498996220$var$unwrapEvent(wrap, recipientPrivateKey) {
    const unwrappedSeal = $4d24e3c498996220$var$nip44Decrypt(wrap, recipientPrivateKey);
    return $4d24e3c498996220$var$nip44Decrypt(unwrappedSeal, recipientPrivateKey);
}
function $4d24e3c498996220$var$unwrapManyEvents(wrappedEvents, recipientPrivateKey) {
    let unwrappedEvents = [];
    wrappedEvents.forEach((e)=>{
        unwrappedEvents.push($4d24e3c498996220$var$unwrapEvent(e, recipientPrivateKey));
    });
    unwrappedEvents.sort((a, b)=>a.created_at - b.created_at);
    return unwrappedEvents;
}
// nip17.ts
function $4d24e3c498996220$var$createEvent(recipients, message, conversationTitle, replyTo) {
    const baseEvent = {
        created_at: Math.ceil(Date.now() / 1e3),
        kind: $4d24e3c498996220$var$PrivateDirectMessage,
        tags: [],
        content: message
    };
    const recipientsArray = Array.isArray(recipients) ? recipients : [
        recipients
    ];
    recipientsArray.forEach(({ publicKey: publicKey, relayUrl: relayUrl })=>{
        baseEvent.tags.push(relayUrl ? [
            "p",
            publicKey,
            relayUrl
        ] : [
            "p",
            publicKey
        ]);
    });
    if (replyTo) baseEvent.tags.push([
        "e",
        replyTo.eventId,
        replyTo.relayUrl || "",
        "reply"
    ]);
    if (conversationTitle) baseEvent.tags.push([
        "subject",
        conversationTitle
    ]);
    return baseEvent;
}
function $4d24e3c498996220$var$wrapEvent2(senderPrivateKey, recipient, message, conversationTitle, replyTo) {
    const event = $4d24e3c498996220$var$createEvent(recipient, message, conversationTitle, replyTo);
    return $4d24e3c498996220$var$wrapEvent(event, senderPrivateKey, recipient.publicKey);
}
function $4d24e3c498996220$var$wrapManyEvents2(senderPrivateKey, recipients, message, conversationTitle, replyTo) {
    if (!recipients || recipients.length === 0) throw new Error("At least one recipient is required.");
    const senderPublicKey = $4d24e3c498996220$export$889def73691f9837(senderPrivateKey);
    return [
        {
            publicKey: senderPublicKey
        },
        ...recipients
    ].map((recipient)=>$4d24e3c498996220$var$wrapEvent2(senderPrivateKey, recipient, message, conversationTitle, replyTo));
}
var $4d24e3c498996220$var$unwrapEvent2 = $4d24e3c498996220$var$unwrapEvent;
var $4d24e3c498996220$var$unwrapManyEvents2 = $4d24e3c498996220$var$unwrapManyEvents;
// nip18.ts
var $4d24e3c498996220$export$4ea8e35b5adc7369 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$4ea8e35b5adc7369, {
    finishRepostEvent: ()=>$4d24e3c498996220$var$finishRepostEvent,
    getRepostedEvent: ()=>$4d24e3c498996220$var$getRepostedEvent,
    getRepostedEventPointer: ()=>$4d24e3c498996220$var$getRepostedEventPointer
});
function $4d24e3c498996220$var$finishRepostEvent(t, reposted, relayUrl, privateKey) {
    let kind;
    const tags = [
        ...t.tags ?? [],
        [
            "e",
            reposted.id,
            relayUrl
        ],
        [
            "p",
            reposted.pubkey
        ]
    ];
    if (reposted.kind === $4d24e3c498996220$var$ShortTextNote) kind = $4d24e3c498996220$var$Repost;
    else {
        kind = $4d24e3c498996220$var$GenericRepost;
        tags.push([
            "k",
            String(reposted.kind)
        ]);
    }
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: kind,
        tags: tags,
        content: t.content === "" || reposted.tags?.find((tag)=>tag[0] === "-") ? "" : JSON.stringify(reposted),
        created_at: t.created_at
    }, privateKey);
}
function $4d24e3c498996220$var$getRepostedEventPointer(event) {
    if (![
        $4d24e3c498996220$var$Repost,
        $4d24e3c498996220$var$GenericRepost
    ].includes(event.kind)) return void 0;
    let lastETag;
    let lastPTag;
    for(let i2 = event.tags.length - 1; i2 >= 0 && (lastETag === void 0 || lastPTag === void 0); i2--){
        const tag = event.tags[i2];
        if (tag.length >= 2) {
            if (tag[0] === "e" && lastETag === void 0) lastETag = tag;
            else if (tag[0] === "p" && lastPTag === void 0) lastPTag = tag;
        }
    }
    if (lastETag === void 0) return void 0;
    return {
        id: lastETag[1],
        relays: [
            lastETag[2],
            lastPTag?.[2]
        ].filter((x)=>typeof x === "string"),
        author: lastPTag?.[1]
    };
}
function $4d24e3c498996220$var$getRepostedEvent(event, { skipVerification: skipVerification } = {}) {
    const pointer = $4d24e3c498996220$var$getRepostedEventPointer(event);
    if (pointer === void 0 || event.content === "") return void 0;
    let repostedEvent;
    try {
        repostedEvent = JSON.parse(event.content);
    } catch (error) {
        return void 0;
    }
    if (repostedEvent.id !== pointer.id) return void 0;
    if (!skipVerification && !$4d24e3c498996220$export$909d658b5069e986(repostedEvent)) return void 0;
    return repostedEvent;
}
// nip21.ts
var $4d24e3c498996220$export$60e8a8091cb0f224 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$60e8a8091cb0f224, {
    NOSTR_URI_REGEX: ()=>$4d24e3c498996220$var$NOSTR_URI_REGEX,
    parse: ()=>$4d24e3c498996220$var$parse2,
    test: ()=>$4d24e3c498996220$var$test
});
var $4d24e3c498996220$var$NOSTR_URI_REGEX = new RegExp(`nostr:(${$4d24e3c498996220$var$BECH32_REGEX.source})`);
function $4d24e3c498996220$var$test(value) {
    return typeof value === "string" && new RegExp(`^${$4d24e3c498996220$var$NOSTR_URI_REGEX.source}$`).test(value);
}
function $4d24e3c498996220$var$parse2(uri) {
    const match = uri.match(new RegExp(`^${$4d24e3c498996220$var$NOSTR_URI_REGEX.source}$`));
    if (!match) throw new Error(`Invalid Nostr URI: ${uri}`);
    return {
        uri: match[0],
        value: match[1],
        decoded: $4d24e3c498996220$var$decode(match[1])
    };
}
// nip25.ts
var $4d24e3c498996220$export$b1c1f2c9e30679b1 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$b1c1f2c9e30679b1, {
    finishReactionEvent: ()=>$4d24e3c498996220$var$finishReactionEvent,
    getReactedEventPointer: ()=>$4d24e3c498996220$var$getReactedEventPointer
});
function $4d24e3c498996220$var$finishReactionEvent(t, reacted, privateKey) {
    const inheritedTags = reacted.tags.filter((tag)=>tag.length >= 2 && (tag[0] === "e" || tag[0] === "p"));
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        ...t,
        kind: $4d24e3c498996220$var$Reaction,
        tags: [
            ...t.tags ?? [],
            ...inheritedTags,
            [
                "e",
                reacted.id
            ],
            [
                "p",
                reacted.pubkey
            ]
        ],
        content: t.content ?? "+"
    }, privateKey);
}
function $4d24e3c498996220$var$getReactedEventPointer(event) {
    if (event.kind !== $4d24e3c498996220$var$Reaction) return void 0;
    let lastETag;
    let lastPTag;
    for(let i2 = event.tags.length - 1; i2 >= 0 && (lastETag === void 0 || lastPTag === void 0); i2--){
        const tag = event.tags[i2];
        if (tag.length >= 2) {
            if (tag[0] === "e" && lastETag === void 0) lastETag = tag;
            else if (tag[0] === "p" && lastPTag === void 0) lastPTag = tag;
        }
    }
    if (lastETag === void 0 || lastPTag === void 0) return void 0;
    return {
        id: lastETag[1],
        relays: [
            lastETag[2],
            lastPTag[2]
        ].filter((x)=>x !== void 0),
        author: lastPTag[1]
    };
}
// nip27.ts
var $4d24e3c498996220$export$9ccc31c93a561269 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$9ccc31c93a561269, {
    parse: ()=>$4d24e3c498996220$var$parse3
});
var $4d24e3c498996220$var$noCharacter = /\W/m;
var $4d24e3c498996220$var$noURLCharacter = /\W |\W$|$|,| /m;
function* $4d24e3c498996220$var$parse3(content) {
    const max = content.length;
    let prevIndex = 0;
    let index = 0;
    while(index < max){
        let u = content.indexOf(":", index);
        if (u === -1) break;
        if (content.substring(u - 5, u) === "nostr") {
            const m = content.substring(u + 60).match($4d24e3c498996220$var$noCharacter);
            const end = m ? u + 60 + m.index : max;
            try {
                let pointer;
                let { data: data, type: type } = $4d24e3c498996220$var$decode(content.substring(u + 1, end));
                switch(type){
                    case "npub":
                        pointer = {
                            pubkey: data
                        };
                        break;
                    case "nsec":
                    case "note":
                        index = end + 1;
                        continue;
                    default:
                        pointer = data;
                }
                if (prevIndex !== u - 5) yield {
                    type: "text",
                    text: content.substring(prevIndex, u - 5)
                };
                yield {
                    type: "reference",
                    pointer: pointer
                };
                index = end;
                prevIndex = index;
                continue;
            } catch (_err) {
                index = u + 1;
                continue;
            }
        } else if (content.substring(u - 5, u) === "https" || content.substring(u - 4, u) === "http") {
            const m = content.substring(u + 4).match($4d24e3c498996220$var$noURLCharacter);
            const end = m ? u + 4 + m.index : max;
            const prefixLen = content[u - 1] === "s" ? 5 : 4;
            try {
                let url = new URL(content.substring(u - prefixLen, end));
                if (url.hostname.indexOf(".") === -1) throw new Error("invalid url");
                if (prevIndex !== u - prefixLen) yield {
                    type: "text",
                    text: content.substring(prevIndex, u - prefixLen)
                };
                if (url.pathname.endsWith(".png") || url.pathname.endsWith(".jpg") || url.pathname.endsWith(".jpeg") || url.pathname.endsWith(".gif") || url.pathname.endsWith(".webp")) {
                    yield {
                        type: "image",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue;
                }
                if (url.pathname.endsWith(".mp4") || url.pathname.endsWith(".avi") || url.pathname.endsWith(".webm") || url.pathname.endsWith(".mkv")) {
                    yield {
                        type: "video",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue;
                }
                if (url.pathname.endsWith(".mp3") || url.pathname.endsWith(".aac") || url.pathname.endsWith(".ogg") || url.pathname.endsWith(".opus")) {
                    yield {
                        type: "audio",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue;
                }
                yield {
                    type: "url",
                    url: url.toString()
                };
                index = end;
                prevIndex = index;
                continue;
            } catch (_err) {
                index = end + 1;
                continue;
            }
        } else if (content.substring(u - 3, u) === "wss" || content.substring(u - 2, u) === "ws") {
            const m = content.substring(u + 4).match($4d24e3c498996220$var$noURLCharacter);
            const end = m ? u + 4 + m.index : max;
            const prefixLen = content[u - 1] === "s" ? 3 : 2;
            try {
                let url = new URL(content.substring(u - prefixLen, end));
                if (url.hostname.indexOf(".") === -1) throw new Error("invalid ws url");
                if (prevIndex !== u - prefixLen) yield {
                    type: "text",
                    text: content.substring(prevIndex, u - prefixLen)
                };
                yield {
                    type: "relay",
                    url: url.toString()
                };
                index = end;
                prevIndex = index;
                continue;
            } catch (_err) {
                index = end + 1;
                continue;
            }
        } else {
            index = u + 1;
            continue;
        }
    }
    if (prevIndex !== max) yield {
        type: "text",
        text: content.substring(prevIndex)
    };
}
// nip28.ts
var $4d24e3c498996220$export$7071f77a07a6a6f4 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$7071f77a07a6a6f4, {
    channelCreateEvent: ()=>$4d24e3c498996220$var$channelCreateEvent,
    channelHideMessageEvent: ()=>$4d24e3c498996220$var$channelHideMessageEvent,
    channelMessageEvent: ()=>$4d24e3c498996220$var$channelMessageEvent,
    channelMetadataEvent: ()=>$4d24e3c498996220$var$channelMetadataEvent,
    channelMuteUserEvent: ()=>$4d24e3c498996220$var$channelMuteUserEvent
});
var $4d24e3c498996220$var$channelCreateEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$ChannelCreation,
        tags: [
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $4d24e3c498996220$var$channelMetadataEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$ChannelMetadata,
        tags: [
            [
                "e",
                t.channel_create_event_id
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $4d24e3c498996220$var$channelMessageEvent = (t, privateKey)=>{
    const tags = [
        [
            "e",
            t.channel_create_event_id,
            t.relay_url,
            "root"
        ]
    ];
    if (t.reply_to_channel_message_event_id) tags.push([
        "e",
        t.reply_to_channel_message_event_id,
        t.relay_url,
        "reply"
    ]);
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$ChannelMessage,
        tags: [
            ...tags,
            ...t.tags ?? []
        ],
        content: t.content,
        created_at: t.created_at
    }, privateKey);
};
var $4d24e3c498996220$var$channelHideMessageEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$ChannelHideMessage,
        tags: [
            [
                "e",
                t.channel_message_event_id
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $4d24e3c498996220$var$channelMuteUserEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20({
        kind: $4d24e3c498996220$var$ChannelMuteUser,
        tags: [
            [
                "p",
                t.pubkey_to_mute
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
// nip30.ts
var $4d24e3c498996220$export$66c1afb78a5c4d11 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$66c1afb78a5c4d11, {
    EMOJI_SHORTCODE_REGEX: ()=>$4d24e3c498996220$var$EMOJI_SHORTCODE_REGEX,
    matchAll: ()=>$4d24e3c498996220$var$matchAll,
    regex: ()=>$4d24e3c498996220$var$regex,
    replaceAll: ()=>$4d24e3c498996220$var$replaceAll
});
var $4d24e3c498996220$var$EMOJI_SHORTCODE_REGEX = /:(\w+):/;
var $4d24e3c498996220$var$regex = ()=>new RegExp(`\\B${$4d24e3c498996220$var$EMOJI_SHORTCODE_REGEX.source}\\B`, "g");
function* $4d24e3c498996220$var$matchAll(content) {
    const matches = content.matchAll($4d24e3c498996220$var$regex());
    for (const match of matches)try {
        const [shortcode, name] = match;
        yield {
            shortcode: shortcode,
            name: name,
            start: match.index,
            end: match.index + shortcode.length
        };
    } catch (_e) {}
}
function $4d24e3c498996220$var$replaceAll(content, replacer) {
    return content.replaceAll($4d24e3c498996220$var$regex(), (shortcode, name)=>{
        return replacer({
            shortcode: shortcode,
            name: name
        });
    });
}
// nip39.ts
var $4d24e3c498996220$export$13ad325f8a2de8f7 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$13ad325f8a2de8f7, {
    useFetchImplementation: ()=>$4d24e3c498996220$var$useFetchImplementation3,
    validateGithub: ()=>$4d24e3c498996220$var$validateGithub
});
var $4d24e3c498996220$var$_fetch3;
try {
    $4d24e3c498996220$var$_fetch3 = fetch;
} catch  {}
function $4d24e3c498996220$var$useFetchImplementation3(fetchImplementation) {
    $4d24e3c498996220$var$_fetch3 = fetchImplementation;
}
async function $4d24e3c498996220$var$validateGithub(pubkey, username, proof) {
    try {
        let res = await (await $4d24e3c498996220$var$_fetch3(`https://gist.github.com/${username}/${proof}/raw`)).text();
        return res === `Verifying that I control the following Nostr public key: ${pubkey}`;
    } catch (_) {
        return false;
    }
}
// nip47.ts
var $4d24e3c498996220$export$ae4a1ae308afd39c = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$ae4a1ae308afd39c, {
    makeNwcRequestEvent: ()=>$4d24e3c498996220$var$makeNwcRequestEvent,
    parseConnectionString: ()=>$4d24e3c498996220$var$parseConnectionString
});
function $4d24e3c498996220$var$parseConnectionString(connectionString) {
    const { pathname: pathname, searchParams: searchParams } = new URL(connectionString);
    const pubkey = pathname;
    const relay = searchParams.get("relay");
    const secret = searchParams.get("secret");
    if (!pubkey || !relay || !secret) throw new Error("invalid connection string");
    return {
        pubkey: pubkey,
        relay: relay,
        secret: secret
    };
}
async function $4d24e3c498996220$var$makeNwcRequestEvent(pubkey, secretKey, invoice) {
    const content = {
        method: "pay_invoice",
        params: {
            invoice: invoice
        }
    };
    const encryptedContent = await $4d24e3c498996220$var$encrypt(secretKey, pubkey, JSON.stringify(content));
    const eventTemplate = {
        kind: $4d24e3c498996220$var$NWCWalletRequest,
        created_at: Math.round(Date.now() / 1e3),
        content: encryptedContent,
        tags: [
            [
                "p",
                pubkey
            ]
        ]
    };
    return $4d24e3c498996220$export$bc33d3bdc1ddcd20(eventTemplate, secretKey);
}
// nip54.ts
var $4d24e3c498996220$export$bfde88566f6f2a51 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$bfde88566f6f2a51, {
    normalizeIdentifier: ()=>$4d24e3c498996220$var$normalizeIdentifier
});
function $4d24e3c498996220$var$normalizeIdentifier(name) {
    name = name.trim().toLowerCase();
    name = name.normalize("NFKC");
    return Array.from(name).map((char)=>{
        if (/\p{Letter}/u.test(char) || /\p{Number}/u.test(char)) return char;
        return "-";
    }).join("");
}
// nip57.ts
var $4d24e3c498996220$export$14e0982e3a536e29 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$14e0982e3a536e29, {
    getZapEndpoint: ()=>$4d24e3c498996220$var$getZapEndpoint,
    makeZapReceipt: ()=>$4d24e3c498996220$var$makeZapReceipt,
    makeZapRequest: ()=>$4d24e3c498996220$var$makeZapRequest,
    useFetchImplementation: ()=>$4d24e3c498996220$var$useFetchImplementation4,
    validateZapRequest: ()=>$4d24e3c498996220$var$validateZapRequest
});
var $4d24e3c498996220$var$_fetch4;
try {
    $4d24e3c498996220$var$_fetch4 = fetch;
} catch  {}
function $4d24e3c498996220$var$useFetchImplementation4(fetchImplementation) {
    $4d24e3c498996220$var$_fetch4 = fetchImplementation;
}
async function $4d24e3c498996220$var$getZapEndpoint(metadata) {
    try {
        let lnurl = "";
        let { lud06: lud06, lud16: lud16 } = JSON.parse(metadata.content);
        if (lud06) {
            let { words: words } = (0, $7i98v.bech32).decode(lud06, 1e3);
            let data = (0, $7i98v.bech32).fromWords(words);
            lnurl = $4d24e3c498996220$var$utf8Decoder.decode(data);
        } else if (lud16) {
            let [name, domain] = lud16.split("@");
            lnurl = new URL(`/.well-known/lnurlp/${name}`, `https://${domain}`).toString();
        } else return null;
        let res = await $4d24e3c498996220$var$_fetch4(lnurl);
        let body = await res.json();
        if (body.allowsNostr && body.nostrPubkey) return body.callback;
    } catch (err) {}
    return null;
}
function $4d24e3c498996220$var$makeZapRequest({ profile: profile, event: event, amount: amount, relays: relays, comment: comment = "" }) {
    if (!amount) throw new Error("amount not given");
    if (!profile) throw new Error("profile not given");
    let zr = {
        kind: 9734,
        created_at: Math.round(Date.now() / 1e3),
        content: comment,
        tags: [
            [
                "p",
                profile
            ],
            [
                "amount",
                amount.toString()
            ],
            [
                "relays",
                ...relays
            ]
        ]
    };
    if (event && typeof event === "string") zr.tags.push([
        "e",
        event
    ]);
    if (event && typeof event === "object") {
        if ($4d24e3c498996220$var$isReplaceableKind(event.kind)) {
            const a = [
                "a",
                `${event.kind}:${event.pubkey}:`
            ];
            zr.tags.push(a);
        } else if ($4d24e3c498996220$var$isAddressableKind(event.kind)) {
            let d = event.tags.find(([t, v])=>t === "d" && v);
            if (!d) throw new Error("d tag not found or is empty");
            const a = [
                "a",
                `${event.kind}:${event.pubkey}:${d[1]}`
            ];
            zr.tags.push(a);
        }
    }
    return zr;
}
function $4d24e3c498996220$var$validateZapRequest(zapRequestString) {
    let zapRequest;
    try {
        zapRequest = JSON.parse(zapRequestString);
    } catch (err) {
        return "Invalid zap request JSON.";
    }
    if (!$4d24e3c498996220$export$d08d852dd562b1ce(zapRequest)) return "Zap request is not a valid Nostr event.";
    if (!$4d24e3c498996220$export$909d658b5069e986(zapRequest)) return "Invalid signature on zap request.";
    let p = zapRequest.tags.find(([t, v])=>t === "p" && v);
    if (!p) return "Zap request doesn't have a 'p' tag.";
    if (!p[1].match(/^[a-f0-9]{64}$/)) return "Zap request 'p' tag is not valid hex.";
    let e = zapRequest.tags.find(([t, v])=>t === "e" && v);
    if (e && !e[1].match(/^[a-f0-9]{64}$/)) return "Zap request 'e' tag is not valid hex.";
    let relays = zapRequest.tags.find(([t, v])=>t === "relays" && v);
    if (!relays) return "Zap request doesn't have a 'relays' tag.";
    return null;
}
function $4d24e3c498996220$var$makeZapReceipt({ zapRequest: zapRequest, preimage: preimage, bolt11: bolt11, paidAt: paidAt }) {
    let zr = JSON.parse(zapRequest);
    let tagsFromZapRequest = zr.tags.filter(([t])=>t === "e" || t === "p" || t === "a");
    let zap = {
        kind: 9735,
        created_at: Math.round(paidAt.getTime() / 1e3),
        content: "",
        tags: [
            ...tagsFromZapRequest,
            [
                "P",
                zr.pubkey
            ],
            [
                "bolt11",
                bolt11
            ],
            [
                "description",
                zapRequest
            ]
        ]
    };
    if (preimage) zap.tags.push([
        "preimage",
        preimage
    ]);
    return zap;
}
// nip98.ts
var $4d24e3c498996220$export$dbfcdd2f6b6e41d9 = {};
$4d24e3c498996220$var$__export($4d24e3c498996220$export$dbfcdd2f6b6e41d9, {
    getToken: ()=>$4d24e3c498996220$var$getToken,
    hashPayload: ()=>$4d24e3c498996220$var$hashPayload,
    unpackEventFromToken: ()=>$4d24e3c498996220$var$unpackEventFromToken,
    validateEvent: ()=>$4d24e3c498996220$var$validateEvent2,
    validateEventKind: ()=>$4d24e3c498996220$var$validateEventKind,
    validateEventMethodTag: ()=>$4d24e3c498996220$var$validateEventMethodTag,
    validateEventPayloadTag: ()=>$4d24e3c498996220$var$validateEventPayloadTag,
    validateEventTimestamp: ()=>$4d24e3c498996220$var$validateEventTimestamp,
    validateEventUrlTag: ()=>$4d24e3c498996220$var$validateEventUrlTag,
    validateToken: ()=>$4d24e3c498996220$var$validateToken
});
var $4d24e3c498996220$var$_authorizationScheme = "Nostr ";
async function $4d24e3c498996220$var$getToken(loginUrl, httpMethod, sign, includeAuthorizationScheme = false, payload) {
    const event = {
        kind: $4d24e3c498996220$var$HTTPAuth,
        tags: [
            [
                "u",
                loginUrl
            ],
            [
                "method",
                httpMethod
            ]
        ],
        created_at: Math.round(new Date().getTime() / 1e3),
        content: ""
    };
    if (payload) event.tags.push([
        "payload",
        $4d24e3c498996220$var$hashPayload(payload)
    ]);
    const signedEvent = await sign(event);
    const authorizationScheme = includeAuthorizationScheme ? $4d24e3c498996220$var$_authorizationScheme : "";
    return authorizationScheme + (0, $7i98v.base64).encode($4d24e3c498996220$var$utf8Encoder.encode(JSON.stringify(signedEvent)));
}
async function $4d24e3c498996220$var$validateToken(token, url, method) {
    const event = await $4d24e3c498996220$var$unpackEventFromToken(token).catch((error)=>{
        throw error;
    });
    const valid = await $4d24e3c498996220$var$validateEvent2(event, url, method).catch((error)=>{
        throw error;
    });
    return valid;
}
async function $4d24e3c498996220$var$unpackEventFromToken(token) {
    if (!token) throw new Error("Missing token");
    token = token.replace($4d24e3c498996220$var$_authorizationScheme, "");
    const eventB64 = $4d24e3c498996220$var$utf8Decoder.decode((0, $7i98v.base64).decode(token));
    if (!eventB64 || eventB64.length === 0 || !eventB64.startsWith("{")) throw new Error("Invalid token");
    const event = JSON.parse(eventB64);
    return event;
}
function $4d24e3c498996220$var$validateEventTimestamp(event) {
    if (!event.created_at) return false;
    return Math.round(new Date().getTime() / 1e3) - event.created_at < 60;
}
function $4d24e3c498996220$var$validateEventKind(event) {
    return event.kind === $4d24e3c498996220$var$HTTPAuth;
}
function $4d24e3c498996220$var$validateEventUrlTag(event, url) {
    const urlTag = event.tags.find((t)=>t[0] === "u");
    if (!urlTag) return false;
    return urlTag.length > 0 && urlTag[1] === url;
}
function $4d24e3c498996220$var$validateEventMethodTag(event, method) {
    const methodTag = event.tags.find((t)=>t[0] === "method");
    if (!methodTag) return false;
    return methodTag.length > 0 && methodTag[1].toLowerCase() === method.toLowerCase();
}
function $4d24e3c498996220$var$hashPayload(payload) {
    const hash = (0, $kHnZL.sha256)($4d24e3c498996220$var$utf8Encoder.encode(JSON.stringify(payload)));
    return (0, $9mdbq.bytesToHex)(hash);
}
function $4d24e3c498996220$var$validateEventPayloadTag(event, payload) {
    const payloadTag = event.tags.find((t)=>t[0] === "payload");
    if (!payloadTag) return false;
    const payloadHash = $4d24e3c498996220$var$hashPayload(payload);
    return payloadTag.length > 0 && payloadTag[1] === payloadHash;
}
async function $4d24e3c498996220$var$validateEvent2(event, url, method, body) {
    if (!$4d24e3c498996220$export$909d658b5069e986(event)) throw new Error("Invalid nostr event, signature invalid");
    if (!$4d24e3c498996220$var$validateEventKind(event)) throw new Error("Invalid nostr event, kind invalid");
    if (!$4d24e3c498996220$var$validateEventTimestamp(event)) throw new Error("Invalid nostr event, created_at timestamp invalid");
    if (!$4d24e3c498996220$var$validateEventUrlTag(event, url)) throw new Error("Invalid nostr event, url tag invalid");
    if (!$4d24e3c498996220$var$validateEventMethodTag(event, method)) throw new Error("Invalid nostr event, method tag invalid");
    if (Boolean(body) && typeof body === "object" && Object.keys(body).length > 0) {
        if (!$4d24e3c498996220$var$validateEventPayloadTag(event, body)) throw new Error("Invalid nostr event, payload tag does not match request body hash");
    }
    return true;
}

});
parcelRegister("lPiFO", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $fe3cd88c751d9c9f$export$529e6123e9353a90; });
$parcel$export(module.exports, "schnorr", function () { return $fe3cd88c751d9c9f$export$1f2401df071be9f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $e4M0B = parcelRequire("e4M0B");

var $enX28 = parcelRequire("enX28");

var $bY3t9 = parcelRequire("bY3t9");

var $hSGv7 = parcelRequire("hSGv7");

var $fXSBq = parcelRequire("fXSBq");

var $d70Fk = parcelRequire("d70Fk");

var $9jCG1 = parcelRequire("9jCG1");
const $fe3cd88c751d9c9f$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $fe3cd88c751d9c9f$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $fe3cd88c751d9c9f$var$_1n = BigInt(1);
const $fe3cd88c751d9c9f$var$_2n = BigInt(2);
const $fe3cd88c751d9c9f$var$divNearest = (a, b)=>(a + b / $fe3cd88c751d9c9f$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $fe3cd88c751d9c9f$var$sqrtMod(y) {
    const P = $fe3cd88c751d9c9f$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $bY3t9.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $bY3t9.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $bY3t9.pow2)(b9, $fe3cd88c751d9c9f$var$_2n, P) * b2 % P;
    const b22 = (0, $bY3t9.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $bY3t9.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $bY3t9.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $bY3t9.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $bY3t9.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $bY3t9.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $bY3t9.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $bY3t9.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $bY3t9.pow2)(t2, $fe3cd88c751d9c9f$var$_2n, P);
    if (!$fe3cd88c751d9c9f$var$Fp.eql($fe3cd88c751d9c9f$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $fe3cd88c751d9c9f$var$Fp = (0, $bY3t9.Field)($fe3cd88c751d9c9f$var$secp256k1P, undefined, undefined, {
    sqrt: $fe3cd88c751d9c9f$var$sqrtMod
});
const $fe3cd88c751d9c9f$export$529e6123e9353a90 = (0, $9jCG1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $fe3cd88c751d9c9f$var$Fp,
    n: $fe3cd88c751d9c9f$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $fe3cd88c751d9c9f$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$fe3cd88c751d9c9f$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $fe3cd88c751d9c9f$var$divNearest(b2 * k, n);
            const c2 = $fe3cd88c751d9c9f$var$divNearest(-b1 * k, n);
            let k1 = (0, $bY3t9.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $bY3t9.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $e4M0B.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $fe3cd88c751d9c9f$var$_0n = BigInt(0);
const $fe3cd88c751d9c9f$var$fe = (x)=>typeof x === "bigint" && $fe3cd88c751d9c9f$var$_0n < x && x < $fe3cd88c751d9c9f$var$secp256k1P;
const $fe3cd88c751d9c9f$var$ge = (x)=>typeof x === "bigint" && $fe3cd88c751d9c9f$var$_0n < x && x < $fe3cd88c751d9c9f$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES = {};
function $fe3cd88c751d9c9f$var$taggedHash(tag, ...messages) {
    let tagP = $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $e4M0B.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $fXSBq.concatBytes)(tagH, tagH);
        $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $e4M0B.sha256)((0, $fXSBq.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $fe3cd88c751d9c9f$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $fe3cd88c751d9c9f$var$numTo32b = (n)=>(0, $fXSBq.numberToBytesBE)(n, 32);
const $fe3cd88c751d9c9f$var$modP = (x)=>(0, $bY3t9.mod)(x, $fe3cd88c751d9c9f$var$secp256k1P);
const $fe3cd88c751d9c9f$var$modN = (x)=>(0, $bY3t9.mod)(x, $fe3cd88c751d9c9f$var$secp256k1N);
const $fe3cd88c751d9c9f$var$Point = $fe3cd88c751d9c9f$export$529e6123e9353a90.ProjectivePoint;
const $fe3cd88c751d9c9f$var$GmulAdd = (Q, a, b)=>$fe3cd88c751d9c9f$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(priv) {
    let d_ = $fe3cd88c751d9c9f$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $fe3cd88c751d9c9f$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $fe3cd88c751d9c9f$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $fe3cd88c751d9c9f$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $fe3cd88c751d9c9f$var$lift_x(x) {
    if (!$fe3cd88c751d9c9f$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $fe3cd88c751d9c9f$var$modP(x * x);
    const c = $fe3cd88c751d9c9f$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $fe3cd88c751d9c9f$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $fe3cd88c751d9c9f$var$_2n !== $fe3cd88c751d9c9f$var$_0n) y = $fe3cd88c751d9c9f$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $fe3cd88c751d9c9f$var$Point(x, y, $fe3cd88c751d9c9f$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $fe3cd88c751d9c9f$var$challenge(...args) {
    return $fe3cd88c751d9c9f$var$modN((0, $fXSBq.bytesToNumberBE)($fe3cd88c751d9c9f$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $fe3cd88c751d9c9f$var$schnorrGetPublicKey(privateKey) {
    return $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $fe3cd88c751d9c9f$var$schnorrSign(message, privateKey, auxRand = (0, $enX28.randomBytes)(32)) {
    const m = (0, $fXSBq.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $fXSBq.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $fe3cd88c751d9c9f$var$numTo32b(d ^ (0, $fXSBq.bytesToNumberBE)($fe3cd88c751d9c9f$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $fe3cd88c751d9c9f$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $fe3cd88c751d9c9f$var$modN((0, $fXSBq.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $fe3cd88c751d9c9f$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $fe3cd88c751d9c9f$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($fe3cd88c751d9c9f$var$numTo32b($fe3cd88c751d9c9f$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$fe3cd88c751d9c9f$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $fe3cd88c751d9c9f$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $fXSBq.ensureBytes)("signature", signature, 64);
    const m = (0, $fXSBq.ensureBytes)("message", message);
    const pub = (0, $fXSBq.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $fe3cd88c751d9c9f$var$lift_x((0, $fXSBq.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $fXSBq.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$fe3cd88c751d9c9f$var$fe(r)) return false;
        const s = (0, $fXSBq.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$fe3cd88c751d9c9f$var$ge(s)) return false;
        const e = $fe3cd88c751d9c9f$var$challenge($fe3cd88c751d9c9f$var$numTo32b(r), $fe3cd88c751d9c9f$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $fe3cd88c751d9c9f$var$GmulAdd(P, s, $fe3cd88c751d9c9f$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $fe3cd88c751d9c9f$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $fe3cd88c751d9c9f$var$schnorrGetPublicKey,
        sign: $fe3cd88c751d9c9f$var$schnorrSign,
        verify: $fe3cd88c751d9c9f$var$schnorrVerify,
        utils: {
            randomPrivateKey: $fe3cd88c751d9c9f$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $fe3cd88c751d9c9f$var$lift_x,
            pointToBytes: $fe3cd88c751d9c9f$var$pointToBytes,
            numberToBytesBE: $fXSBq.numberToBytesBE,
            bytesToNumberBE: $fXSBq.bytesToNumberBE,
            taggedHash: $fe3cd88c751d9c9f$var$taggedHash,
            mod: $bY3t9.mod
        }
    }))();
const $fe3cd88c751d9c9f$var$isoMap = /* @__PURE__ */ (()=>(0, $d70Fk.isogenyMap)($fe3cd88c751d9c9f$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $fe3cd88c751d9c9f$var$mapSWU = /* @__PURE__ */ (()=>(0, $hSGv7.mapToCurveSimpleSWU)($fe3cd88c751d9c9f$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $fe3cd88c751d9c9f$var$Fp.create(BigInt("-11"))
    }))();
const $fe3cd88c751d9c9f$var$htf = /* @__PURE__ */ (()=>(0, $d70Fk.createHasher)($fe3cd88c751d9c9f$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $fe3cd88c751d9c9f$var$mapSWU($fe3cd88c751d9c9f$var$Fp.create(scalars[0]));
        return $fe3cd88c751d9c9f$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $fe3cd88c751d9c9f$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $e4M0B.sha256)
    }))();
const $fe3cd88c751d9c9f$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$fe3cd88c751d9c9f$var$htf.hashToCurve)();
const $fe3cd88c751d9c9f$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$fe3cd88c751d9c9f$var$htf.encodeToCurve)();

});
parcelRegister("e4M0B", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $a3f6adf0136b3cb2$export$bced8d2aada2d1c9; });

var $kROaS = parcelRequire("kROaS");

var $enX28 = parcelRequire("enX28");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $a3f6adf0136b3cb2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $a3f6adf0136b3cb2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $a3f6adf0136b3cb2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $a3f6adf0136b3cb2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $a3f6adf0136b3cb2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $a3f6adf0136b3cb2$var$SHA256 extends (0, $kROaS.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $a3f6adf0136b3cb2$var$IV[0] | 0;
        this.B = $a3f6adf0136b3cb2$var$IV[1] | 0;
        this.C = $a3f6adf0136b3cb2$var$IV[2] | 0;
        this.D = $a3f6adf0136b3cb2$var$IV[3] | 0;
        this.E = $a3f6adf0136b3cb2$var$IV[4] | 0;
        this.F = $a3f6adf0136b3cb2$var$IV[5] | 0;
        this.G = $a3f6adf0136b3cb2$var$IV[6] | 0;
        this.H = $a3f6adf0136b3cb2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$a3f6adf0136b3cb2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $a3f6adf0136b3cb2$var$SHA256_W[i - 15];
            const W2 = $a3f6adf0136b3cb2$var$SHA256_W[i - 2];
            const s0 = (0, $enX28.rotr)(W15, 7) ^ (0, $enX28.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $enX28.rotr)(W2, 17) ^ (0, $enX28.rotr)(W2, 19) ^ W2 >>> 10;
            $a3f6adf0136b3cb2$var$SHA256_W[i] = s1 + $a3f6adf0136b3cb2$var$SHA256_W[i - 7] + s0 + $a3f6adf0136b3cb2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $enX28.rotr)(E, 6) ^ (0, $enX28.rotr)(E, 11) ^ (0, $enX28.rotr)(E, 25);
            const T1 = H + sigma1 + $a3f6adf0136b3cb2$var$Chi(E, F, G) + $a3f6adf0136b3cb2$var$SHA256_K[i] + $a3f6adf0136b3cb2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $enX28.rotr)(A, 2) ^ (0, $enX28.rotr)(A, 13) ^ (0, $enX28.rotr)(A, 22);
            const T2 = sigma0 + $a3f6adf0136b3cb2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $a3f6adf0136b3cb2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $a3f6adf0136b3cb2$var$SHA224 extends $a3f6adf0136b3cb2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $a3f6adf0136b3cb2$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $enX28.wrapConstructor)(()=>new $a3f6adf0136b3cb2$var$SHA256());
const $a3f6adf0136b3cb2$export$97b70509d4e397ea = /* @__PURE__ */ (0, $enX28.wrapConstructor)(()=>new $a3f6adf0136b3cb2$var$SHA224());

});
parcelRegister("kROaS", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $f30fad763fa14c67$export$ebbe38f24b9a0856; });

var $3r5uY = parcelRequire("3r5uY");

var $enX28 = parcelRequire("enX28");
// Polyfill for Safari 14
function $f30fad763fa14c67$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $f30fad763fa14c67$export$ebbe38f24b9a0856 extends (0, $enX28.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $enX28.createView)(this.buffer);
    }
    update(data) {
        (0, $3r5uY.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $enX28.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $enX28.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3r5uY.exists)(this);
        (0, $3r5uY.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $f30fad763fa14c67$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $enX28.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("3r5uY", function(module, exports) {

$parcel$export(module.exports, "bytes", function () { return $2808289d360d4aed$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $2808289d360d4aed$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $2808289d360d4aed$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $2808289d360d4aed$export$c789db2c85949867; });
function $2808289d360d4aed$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $2808289d360d4aed$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $2808289d360d4aed$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $2808289d360d4aed$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $2808289d360d4aed$export$98e628dec113755e(hash.outputLen);
    $2808289d360d4aed$export$98e628dec113755e(hash.blockLen);
}
function $2808289d360d4aed$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $2808289d360d4aed$export$c789db2c85949867(out, instance) {
    $2808289d360d4aed$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $2808289d360d4aed$var$assert = {
    number: $2808289d360d4aed$export$98e628dec113755e,
    bool: $2808289d360d4aed$export$87b259aa03e3d267,
    bytes: $2808289d360d4aed$export$b3317979f9250576,
    hash: $2808289d360d4aed$export$d6af199866bfb566,
    exists: $2808289d360d4aed$export$f7e9f41ea797a17,
    output: $2808289d360d4aed$export$c789db2c85949867
};
var $2808289d360d4aed$export$2e2bcd8739ae039 = $2808289d360d4aed$var$assert;

});

parcelRegister("enX28", function(module, exports) {

$parcel$export(module.exports, "createView", function () { return $a7910176f6626945$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $a7910176f6626945$export$466993d7d0d272aa; });
$parcel$export(module.exports, "toBytes", function () { return $a7910176f6626945$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $a7910176f6626945$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $a7910176f6626945$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $a7910176f6626945$export$f081816339df1972; });
$parcel$export(module.exports, "randomBytes", function () { return $a7910176f6626945$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $KZzgK = parcelRequire("KZzgK");
const $a7910176f6626945$var$u8a = (a)=>a instanceof Uint8Array;
const $a7910176f6626945$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $a7910176f6626945$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $a7910176f6626945$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $a7910176f6626945$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $a7910176f6626945$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$a7910176f6626945$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $a7910176f6626945$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $a7910176f6626945$export$58b867e287a802c8(bytes) {
    if (!$a7910176f6626945$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a7910176f6626945$var$hexes[bytes[i]];
    return hex;
}
function $a7910176f6626945$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $a7910176f6626945$export$bdd553fddd433dcb = async ()=>{};
async function $a7910176f6626945$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $a7910176f6626945$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $a7910176f6626945$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $a7910176f6626945$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $a7910176f6626945$export$3df70a15530b5e81(data);
    if (!$a7910176f6626945$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $a7910176f6626945$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a7910176f6626945$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $a7910176f6626945$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $a7910176f6626945$var$toStr = {}.toString;
function $a7910176f6626945$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $a7910176f6626945$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $a7910176f6626945$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $a7910176f6626945$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a7910176f6626945$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a7910176f6626945$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $KZzgK.crypto) && typeof (0, $KZzgK.crypto).getRandomValues === "function") return (0, $KZzgK.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("KZzgK", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $08d40e160ceb103e$export$7effb53edfc7fa2d; });
const $08d40e160ceb103e$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("bY3t9", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $8b67fd3be4c8950a$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow2", function () { return $8b67fd3be4c8950a$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $8b67fd3be4c8950a$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "validateField", function () { return $8b67fd3be4c8950a$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $8b67fd3be4c8950a$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $8b67fd3be4c8950a$export$a455218a85c89869; });
$parcel$export(module.exports, "getMinHashLength", function () { return $8b67fd3be4c8950a$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $8b67fd3be4c8950a$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $fXSBq = parcelRequire("fXSBq");
// prettier-ignore
const $8b67fd3be4c8950a$var$_0n = BigInt(0), $8b67fd3be4c8950a$var$_1n = BigInt(1), $8b67fd3be4c8950a$var$_2n = BigInt(2), $8b67fd3be4c8950a$var$_3n = BigInt(3);
// prettier-ignore
const $8b67fd3be4c8950a$var$_4n = BigInt(4), $8b67fd3be4c8950a$var$_5n = BigInt(5), $8b67fd3be4c8950a$var$_8n = BigInt(8);
// prettier-ignore
const $8b67fd3be4c8950a$var$_9n = BigInt(9), $8b67fd3be4c8950a$var$_16n = BigInt(16);
function $8b67fd3be4c8950a$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $8b67fd3be4c8950a$var$_0n ? result : b + result;
}
function $8b67fd3be4c8950a$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8b67fd3be4c8950a$var$_0n || power < $8b67fd3be4c8950a$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $8b67fd3be4c8950a$var$_1n) return $8b67fd3be4c8950a$var$_0n;
    let res = $8b67fd3be4c8950a$var$_1n;
    while(power > $8b67fd3be4c8950a$var$_0n){
        if (power & $8b67fd3be4c8950a$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8b67fd3be4c8950a$var$_1n;
    }
    return res;
}
function $8b67fd3be4c8950a$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $8b67fd3be4c8950a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8b67fd3be4c8950a$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8b67fd3be4c8950a$var$_0n || modulo <= $8b67fd3be4c8950a$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8b67fd3be4c8950a$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8b67fd3be4c8950a$var$_0n, y = $8b67fd3be4c8950a$var$_1n, u = $8b67fd3be4c8950a$var$_1n, v = $8b67fd3be4c8950a$var$_0n;
    while(a !== $8b67fd3be4c8950a$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8b67fd3be4c8950a$var$_1n) throw new Error("invert: does not exist");
    return $8b67fd3be4c8950a$export$842a2cf37af977e1(x, modulo);
}
function $8b67fd3be4c8950a$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8b67fd3be4c8950a$var$_1n, S = 0; Q % $8b67fd3be4c8950a$var$_2n === $8b67fd3be4c8950a$var$_0n; Q /= $8b67fd3be4c8950a$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8b67fd3be4c8950a$var$_2n; Z < P && $8b67fd3be4c8950a$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8b67fd3be4c8950a$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8b67fd3be4c8950a$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8b67fd3be4c8950a$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8b67fd3be4c8950a$var$_4n === $8b67fd3be4c8950a$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8b67fd3be4c8950a$var$_8n === $8b67fd3be4c8950a$var$_5n) {
        const c1 = (P - $8b67fd3be4c8950a$var$_5n) / $8b67fd3be4c8950a$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8b67fd3be4c8950a$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8b67fd3be4c8950a$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8b67fd3be4c8950a$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8b67fd3be4c8950a$export$69f29ab1f3e9a234(P);
}
const $8b67fd3be4c8950a$export$7806f13ad5078b2f = (num, modulo)=>($8b67fd3be4c8950a$export$842a2cf37af977e1(num, modulo) & $8b67fd3be4c8950a$var$_1n) === $8b67fd3be4c8950a$var$_1n;
// prettier-ignore
const $8b67fd3be4c8950a$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $8b67fd3be4c8950a$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $8b67fd3be4c8950a$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $fXSBq.validateObject)(field, opts);
}
function $8b67fd3be4c8950a$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8b67fd3be4c8950a$var$_0n) throw new Error("Expected power > 0");
    if (power === $8b67fd3be4c8950a$var$_0n) return f.ONE;
    if (power === $8b67fd3be4c8950a$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8b67fd3be4c8950a$var$_0n){
        if (power & $8b67fd3be4c8950a$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8b67fd3be4c8950a$var$_1n;
    }
    return p;
}
function $8b67fd3be4c8950a$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8b67fd3be4c8950a$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $8b67fd3be4c8950a$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8b67fd3be4c8950a$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8b67fd3be4c8950a$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8b67fd3be4c8950a$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8b67fd3be4c8950a$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $8b67fd3be4c8950a$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $8b67fd3be4c8950a$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $fXSBq.bitMask)(BITS),
        ZERO: $8b67fd3be4c8950a$var$_0n,
        ONE: $8b67fd3be4c8950a$var$_1n,
        create: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $8b67fd3be4c8950a$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8b67fd3be4c8950a$var$_0n,
        isOdd: (num)=>(num & $8b67fd3be4c8950a$var$_1n) === $8b67fd3be4c8950a$var$_1n,
        neg: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$8b67fd3be4c8950a$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs * $8b67fd3be4c8950a$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8b67fd3be4c8950a$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$8b67fd3be4c8950a$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $fXSBq.numberToBytesLE)(num, BYTES) : (0, $fXSBq.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $fXSBq.bytesToNumberLE)(bytes) : (0, $fXSBq.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8b67fd3be4c8950a$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8b67fd3be4c8950a$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8b67fd3be4c8950a$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $fXSBq.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $8b67fd3be4c8950a$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $fXSBq.bytesToNumberLE)(hash) : (0, $fXSBq.bytesToNumberBE)(hash);
    return $8b67fd3be4c8950a$export$842a2cf37af977e1(num, groupOrder - $8b67fd3be4c8950a$var$_1n) + $8b67fd3be4c8950a$var$_1n;
}
function $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8b67fd3be4c8950a$export$d058763b563056af(fieldOrder) {
    const length = $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8b67fd3be4c8950a$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $8b67fd3be4c8950a$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $fXSBq.bytesToNumberBE)(key) : (0, $fXSBq.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8b67fd3be4c8950a$export$842a2cf37af977e1(num, fieldOrder - $8b67fd3be4c8950a$var$_1n) + $8b67fd3be4c8950a$var$_1n;
    return isLE ? (0, $fXSBq.numberToBytesLE)(reduced, fieldLen) : (0, $fXSBq.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("fXSBq", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $b9f6b8a8ad1eccc7$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $b9f6b8a8ad1eccc7$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $b9f6b8a8ad1eccc7$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $b9f6b8a8ad1eccc7$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $b9f6b8a8ad1eccc7$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $b9f6b8a8ad1eccc7$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $b9f6b8a8ad1eccc7$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $b9f6b8a8ad1eccc7$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $b9f6b8a8ad1eccc7$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $b9f6b8a8ad1eccc7$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $b9f6b8a8ad1eccc7$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $b9f6b8a8ad1eccc7$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $b9f6b8a8ad1eccc7$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $b9f6b8a8ad1eccc7$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $b9f6b8a8ad1eccc7$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $b9f6b8a8ad1eccc7$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $b9f6b8a8ad1eccc7$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $b9f6b8a8ad1eccc7$var$_0n = BigInt(0);
const $b9f6b8a8ad1eccc7$var$_1n = BigInt(1);
const $b9f6b8a8ad1eccc7$var$_2n = BigInt(2);
const $b9f6b8a8ad1eccc7$var$u8a = (a)=>a instanceof Uint8Array;
const $b9f6b8a8ad1eccc7$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $b9f6b8a8ad1eccc7$export$58b867e287a802c8(bytes) {
    if (!$b9f6b8a8ad1eccc7$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $b9f6b8a8ad1eccc7$var$hexes[bytes[i]];
    return hex;
}
function $b9f6b8a8ad1eccc7$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $b9f6b8a8ad1eccc7$export$d609354794974f8(bytes) {
    return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249($b9f6b8a8ad1eccc7$export$58b867e287a802c8(bytes));
}
function $b9f6b8a8ad1eccc7$export$d67b1d03392107e7(bytes) {
    if (!$b9f6b8a8ad1eccc7$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249($b9f6b8a8ad1eccc7$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $b9f6b8a8ad1eccc7$export$1459dafd057611cb(n, len) {
    return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $b9f6b8a8ad1eccc7$export$ba2172e58d139f6d(n, len) {
    return $b9f6b8a8ad1eccc7$export$1459dafd057611cb(n, len).reverse();
}
function $b9f6b8a8ad1eccc7$export$80ee8c1914de6dde(n) {
    return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4($b9f6b8a8ad1eccc7$export$4ed2545b622827c1(n));
}
function $b9f6b8a8ad1eccc7$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($b9f6b8a8ad1eccc7$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $b9f6b8a8ad1eccc7$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$b9f6b8a8ad1eccc7$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $b9f6b8a8ad1eccc7$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $b9f6b8a8ad1eccc7$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $b9f6b8a8ad1eccc7$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $b9f6b8a8ad1eccc7$var$_0n; n >>= $b9f6b8a8ad1eccc7$var$_1n, len += 1);
    return len;
}
function $b9f6b8a8ad1eccc7$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $b9f6b8a8ad1eccc7$var$_1n;
}
const $b9f6b8a8ad1eccc7$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $b9f6b8a8ad1eccc7$var$_1n : $b9f6b8a8ad1eccc7$var$_0n) << BigInt(pos);
};
const $b9f6b8a8ad1eccc7$export$803efa2fa1c7279 = (n)=>($b9f6b8a8ad1eccc7$var$_2n << BigInt(n - 1)) - $b9f6b8a8ad1eccc7$var$_1n;
// DRBG
const $b9f6b8a8ad1eccc7$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $b9f6b8a8ad1eccc7$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $b9f6b8a8ad1eccc7$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $b9f6b8a8ad1eccc7$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $b9f6b8a8ad1eccc7$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $b9f6b8a8ad1eccc7$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($b9f6b8a8ad1eccc7$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($b9f6b8a8ad1eccc7$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $b9f6b8a8ad1eccc7$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $b9f6b8a8ad1eccc7$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $b9f6b8a8ad1eccc7$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $b9f6b8a8ad1eccc7$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("hSGv7", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $d048729b0f3a361e$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $d048729b0f3a361e$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");

var $d14TS = parcelRequire("d14TS");
function $d048729b0f3a361e$var$validatePointOpts(curve) {
    const opts = (0, $d14TS.validateBasic)(curve);
    $fXSBq.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $d048729b0f3a361e$var$b2n, hexToBytes: $d048729b0f3a361e$var$h2b } = $fXSBq;
const $d048729b0f3a361e$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $d048729b0f3a361e$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $d048729b0f3a361e$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $d048729b0f3a361e$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $d048729b0f3a361e$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $d048729b0f3a361e$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $d048729b0f3a361e$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $d048729b0f3a361e$var$_0n = BigInt(0), $d048729b0f3a361e$var$_1n = BigInt(1), $d048729b0f3a361e$var$_2n = BigInt(2), $d048729b0f3a361e$var$_3n = BigInt(3), $d048729b0f3a361e$var$_4n = BigInt(4);
function $d048729b0f3a361e$export$fa783af82e4fe0fc(opts) {
    const CURVE = $d048729b0f3a361e$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $fXSBq.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $d048729b0f3a361e$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $fXSBq.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $fXSBq.bytesToNumberBE((0, $fXSBq.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $bY3t9.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $fXSBq.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $d048729b0f3a361e$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $d048729b0f3a361e$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $d048729b0f3a361e$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $d048729b0f3a361e$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $d048729b0f3a361e$var$_0n || k2 > $d048729b0f3a361e$var$_0n){
                if (k1 & $d048729b0f3a361e$var$_1n) k1p = k1p.add(d);
                if (k2 & $d048729b0f3a361e$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $d048729b0f3a361e$var$_1n;
                k2 >>= $d048729b0f3a361e$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $d048729b0f3a361e$var$_0n || a === $d048729b0f3a361e$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $d048729b0f3a361e$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $d048729b0f3a361e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $fXSBq.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $d14TS.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $d048729b0f3a361e$var$validateOpts(curve) {
    const opts = (0, $d14TS.validateBasic)(curve);
    $fXSBq.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $d048729b0f3a361e$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $d048729b0f3a361e$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $d048729b0f3a361e$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $bY3t9.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $bY3t9.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $d048729b0f3a361e$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $fXSBq.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $fXSBq.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $d048729b0f3a361e$var$_1n) === $d048729b0f3a361e$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$fXSBq.bytesToHex($fXSBq.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $d048729b0f3a361e$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$fXSBq.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $fXSBq.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $d048729b0f3a361e$export$56ac33195d7076db.toSig((0, $fXSBq.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $fXSBq.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $fXSBq.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $d048729b0f3a361e$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $fXSBq.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $bY3t9.getMinHashLength(CURVE.n);
            return $bY3t9.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $fXSBq.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $fXSBq.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($d048729b0f3a361e$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $fXSBq.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $fXSBq.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $fXSBq.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $fXSBq.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $fXSBq.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $d048729b0f3a361e$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $d048729b0f3a361e$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $d048729b0f3a361e$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $fXSBq.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $fXSBq.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $fXSBq.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $d048729b0f3a361e$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $d048729b0f3a361e$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $d048729b0f3a361e$var$_0n;
    for(let o = q - $d048729b0f3a361e$var$_1n; o % $d048729b0f3a361e$var$_2n === $d048729b0f3a361e$var$_0n; o /= $d048729b0f3a361e$var$_2n)l += $d048729b0f3a361e$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $d048729b0f3a361e$var$_2n << c1 - $d048729b0f3a361e$var$_1n - $d048729b0f3a361e$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $d048729b0f3a361e$var$_2n;
    const c2 = (q - $d048729b0f3a361e$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $d048729b0f3a361e$var$_1n) / $d048729b0f3a361e$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $d048729b0f3a361e$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $d048729b0f3a361e$var$_1n) / $d048729b0f3a361e$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $d048729b0f3a361e$var$_1n; i--){
            let tv5 = i - $d048729b0f3a361e$var$_2n; // 18.    tv5 = i - 2
            tv5 = $d048729b0f3a361e$var$_2n << tv5 - $d048729b0f3a361e$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $d048729b0f3a361e$var$_4n === $d048729b0f3a361e$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $d048729b0f3a361e$var$_3n) / $d048729b0f3a361e$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $d048729b0f3a361e$export$cc7fea9756a17416(Fp, opts) {
    $bY3t9.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $d048729b0f3a361e$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("d14TS", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $bY3t9.validateField)(curve.Fp);
    (0, $fXSBq.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $bY3t9.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("d70Fk", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", function () { return $98bc71fbece483b9$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $98bc71fbece483b9$export$14b114effbc08b6b; });

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");
function $98bc71fbece483b9$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $fXSBq.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $98bc71fbece483b9$var$os2ip = (0, $fXSBq.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $98bc71fbece483b9$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $98bc71fbece483b9$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $98bc71fbece483b9$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $98bc71fbece483b9$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $98bc71fbece483b9$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isBytes(DST);
    $98bc71fbece483b9$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $fXSBq.concatBytes)((0, $fXSBq.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $fXSBq.concatBytes)(DST, $98bc71fbece483b9$var$i2osp(DST.length, 1));
    const Z_pad = $98bc71fbece483b9$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $98bc71fbece483b9$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $fXSBq.concatBytes)(Z_pad, msg, l_i_b_str, $98bc71fbece483b9$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $fXSBq.concatBytes)(b_0, $98bc71fbece483b9$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $98bc71fbece483b9$var$strxor(b_0, b[i - 1]),
            $98bc71fbece483b9$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $fXSBq.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $fXSBq.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $98bc71fbece483b9$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isBytes(DST);
    $98bc71fbece483b9$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $fXSBq.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($98bc71fbece483b9$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($98bc71fbece483b9$var$i2osp(DST.length, 1)).digest();
}
function $98bc71fbece483b9$export$97cdd5ee18de8172(msg, count, options) {
    (0, $fXSBq.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isNum(count);
    const DST = $98bc71fbece483b9$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $98bc71fbece483b9$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $98bc71fbece483b9$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $bY3t9.mod)($98bc71fbece483b9$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $98bc71fbece483b9$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $98bc71fbece483b9$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $98bc71fbece483b9$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $98bc71fbece483b9$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("9jCG1", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $6c83e3d022918030$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $lVwA3 = parcelRequire("lVwA3");

var $enX28 = parcelRequire("enX28");

var $hSGv7 = parcelRequire("hSGv7");
function $6c83e3d022918030$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $lVwA3.hmac)(hash, key, (0, $enX28.concatBytes)(...msgs)),
        randomBytes: $enX28.randomBytes
    };
}
function $6c83e3d022918030$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $hSGv7.weierstrass)({
            ...curveDef,
            ...$6c83e3d022918030$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});
parcelRegister("lVwA3", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $ff6831a1f76c6081$export$355af40f8ab02f34; });

var $3r5uY = parcelRequire("3r5uY");

var $enX28 = parcelRequire("enX28");
class $ff6831a1f76c6081$export$7b9cf41ebec74f45 extends (0, $enX28.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $3r5uY.hash)(hash);
        const key = (0, $enX28.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $3r5uY.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3r5uY.exists)(this);
        (0, $3r5uY.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $ff6831a1f76c6081$export$355af40f8ab02f34 = (hash, key, message)=>new $ff6831a1f76c6081$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$ff6831a1f76c6081$export$355af40f8ab02f34.create = (hash, key)=>new $ff6831a1f76c6081$export$7b9cf41ebec74f45(hash, key);

});



parcelRegister("9mdbq", function(module, exports) {

$parcel$export(module.exports, "createView", function () { return $6d0065097d5215bf$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $6d0065097d5215bf$export$466993d7d0d272aa; });
$parcel$export(module.exports, "bytesToHex", function () { return $6d0065097d5215bf$export$58b867e287a802c8; });
$parcel$export(module.exports, "hexToBytes", function () { return $6d0065097d5215bf$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "toBytes", function () { return $6d0065097d5215bf$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $6d0065097d5215bf$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $6d0065097d5215bf$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $6d0065097d5215bf$export$f081816339df1972; });
$parcel$export(module.exports, "randomBytes", function () { return $6d0065097d5215bf$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $9hV6m = parcelRequire("9hV6m");
const $6d0065097d5215bf$var$u8a = (a)=>a instanceof Uint8Array;
const $6d0065097d5215bf$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $6d0065097d5215bf$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $6d0065097d5215bf$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$6d0065097d5215bf$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $6d0065097d5215bf$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
function $6d0065097d5215bf$export$58b867e287a802c8(bytes) {
    if (!$6d0065097d5215bf$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6d0065097d5215bf$var$hexes[bytes[i]];
    return hex;
}
function $6d0065097d5215bf$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $6d0065097d5215bf$export$bdd553fddd433dcb = async ()=>{};
async function $6d0065097d5215bf$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $6d0065097d5215bf$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $6d0065097d5215bf$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $6d0065097d5215bf$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $6d0065097d5215bf$export$3df70a15530b5e81(data);
    if (!$6d0065097d5215bf$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $6d0065097d5215bf$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6d0065097d5215bf$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $6d0065097d5215bf$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $6d0065097d5215bf$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $6d0065097d5215bf$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$6d0065097d5215bf$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $6d0065097d5215bf$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $6d0065097d5215bf$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $9hV6m.crypto) && typeof (0, $9hV6m.crypto).getRandomValues === "function") return (0, $9hV6m.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("9hV6m", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $6c31fecb2de06915$export$7effb53edfc7fa2d; });
const $6c31fecb2de06915$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});


parcelRegister("kHnZL", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $f11a6fbc065abd4a$export$bced8d2aada2d1c9; });

var $GWdd1 = parcelRequire("GWdd1");

var $9mdbq = parcelRequire("9mdbq");
// Choice: a ? b : c
const $f11a6fbc065abd4a$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f11a6fbc065abd4a$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f11a6fbc065abd4a$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f11a6fbc065abd4a$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f11a6fbc065abd4a$var$SHA256_W = new Uint32Array(64);
class $f11a6fbc065abd4a$var$SHA256 extends (0, $GWdd1.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f11a6fbc065abd4a$var$IV[0] | 0;
        this.B = $f11a6fbc065abd4a$var$IV[1] | 0;
        this.C = $f11a6fbc065abd4a$var$IV[2] | 0;
        this.D = $f11a6fbc065abd4a$var$IV[3] | 0;
        this.E = $f11a6fbc065abd4a$var$IV[4] | 0;
        this.F = $f11a6fbc065abd4a$var$IV[5] | 0;
        this.G = $f11a6fbc065abd4a$var$IV[6] | 0;
        this.H = $f11a6fbc065abd4a$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f11a6fbc065abd4a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f11a6fbc065abd4a$var$SHA256_W[i - 15];
            const W2 = $f11a6fbc065abd4a$var$SHA256_W[i - 2];
            const s0 = (0, $9mdbq.rotr)(W15, 7) ^ (0, $9mdbq.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9mdbq.rotr)(W2, 17) ^ (0, $9mdbq.rotr)(W2, 19) ^ W2 >>> 10;
            $f11a6fbc065abd4a$var$SHA256_W[i] = s1 + $f11a6fbc065abd4a$var$SHA256_W[i - 7] + s0 + $f11a6fbc065abd4a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9mdbq.rotr)(E, 6) ^ (0, $9mdbq.rotr)(E, 11) ^ (0, $9mdbq.rotr)(E, 25);
            const T1 = H + sigma1 + $f11a6fbc065abd4a$var$Chi(E, F, G) + $f11a6fbc065abd4a$var$SHA256_K[i] + $f11a6fbc065abd4a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9mdbq.rotr)(A, 2) ^ (0, $9mdbq.rotr)(A, 13) ^ (0, $9mdbq.rotr)(A, 22);
            const T2 = sigma0 + $f11a6fbc065abd4a$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f11a6fbc065abd4a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f11a6fbc065abd4a$var$SHA224 extends $f11a6fbc065abd4a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $f11a6fbc065abd4a$export$bced8d2aada2d1c9 = (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA256());
const $f11a6fbc065abd4a$export$97b70509d4e397ea = (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA224());

});
parcelRegister("GWdd1", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $0811140f03d50e93$export$ebbe38f24b9a0856; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");
// Polyfill for Safari 14
function $0811140f03d50e93$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $0811140f03d50e93$export$ebbe38f24b9a0856 extends (0, $9mdbq.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9mdbq.createView)(this.buffer);
    }
    update(data) {
        (0, $kW2j6.default).exists(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9mdbq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9mdbq.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kW2j6.default).exists(this);
        (0, $kW2j6.default).output(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $0811140f03d50e93$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9mdbq.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("kW2j6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3db038be156b7eb$export$2e2bcd8739ae039; });
function $f3db038be156b7eb$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $f3db038be156b7eb$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $f3db038be156b7eb$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $f3db038be156b7eb$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $f3db038be156b7eb$export$98e628dec113755e(hash.outputLen);
    $f3db038be156b7eb$export$98e628dec113755e(hash.blockLen);
}
function $f3db038be156b7eb$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $f3db038be156b7eb$export$c789db2c85949867(out, instance) {
    $f3db038be156b7eb$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $f3db038be156b7eb$var$assert = {
    number: $f3db038be156b7eb$export$98e628dec113755e,
    bool: $f3db038be156b7eb$export$87b259aa03e3d267,
    bytes: $f3db038be156b7eb$export$b3317979f9250576,
    hash: $f3db038be156b7eb$export$d6af199866bfb566,
    exists: $f3db038be156b7eb$export$f7e9f41ea797a17,
    output: $f3db038be156b7eb$export$c789db2c85949867
};
var $f3db038be156b7eb$export$2e2bcd8739ae039 = $f3db038be156b7eb$var$assert;

});



parcelRegister("7i98v", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $54f14d15482dd6fe$export$b3b2de96497acc47; });
$parcel$export(module.exports, "bech32", function () { return $54f14d15482dd6fe$export$27c42482533637da; });
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $54f14d15482dd6fe$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
function $54f14d15482dd6fe$var$chain(...args) {
    const wrap = (a, b)=>(c)=>a(b(c));
    const encode = Array.from(args).reverse().reduce((acc, i)=>acc ? wrap(acc, i.encode) : i.encode, undefined);
    const decode = args.reduce((acc, i)=>acc ? wrap(acc, i.decode) : i.decode, undefined);
    return {
        encode: encode,
        decode: decode
    };
}
function $54f14d15482dd6fe$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $54f14d15482dd6fe$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
function $54f14d15482dd6fe$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
function $54f14d15482dd6fe$var$padding(bits, chr = "=") {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
function $54f14d15482dd6fe$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
function $54f14d15482dd6fe$var$convertRadix(data, from, to) {
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $54f14d15482dd6fe$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            digits[i] = Math.floor(digitBase / to);
            if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!digits[i]) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $54f14d15482dd6fe$var$gcd = (a, b)=>!b ? a : $54f14d15482dd6fe$var$gcd(b, a % b);
const $54f14d15482dd6fe$var$radix2carry = (from, to)=>from + (to - $54f14d15482dd6fe$var$gcd(from, to));
function $54f14d15482dd6fe$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($54f14d15482dd6fe$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$54f14d15482dd6fe$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0;
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $54f14d15482dd6fe$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1;
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
function $54f14d15482dd6fe$var$radix(num) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
            return $54f14d15482dd6fe$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of strings");
            return Uint8Array.from($54f14d15482dd6fe$var$convertRadix(digits, num, 256));
        }
    };
}
function $54f14d15482dd6fe$var$radix2(bits, revPadding = false) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($54f14d15482dd6fe$var$radix2carry(8, bits) > 32 || $54f14d15482dd6fe$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
            return $54f14d15482dd6fe$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of strings");
            return Uint8Array.from($54f14d15482dd6fe$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $54f14d15482dd6fe$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $54f14d15482dd6fe$var$checksum(len, fn) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $54f14d15482dd6fe$export$eab97d15b1788b8d = {
    alphabet: $54f14d15482dd6fe$var$alphabet,
    chain: $54f14d15482dd6fe$var$chain,
    checksum: $54f14d15482dd6fe$var$checksum,
    radix: $54f14d15482dd6fe$var$radix,
    radix2: $54f14d15482dd6fe$var$radix2,
    join: $54f14d15482dd6fe$var$join,
    padding: $54f14d15482dd6fe$var$padding
};
const $54f14d15482dd6fe$export$586f61c71cb02fe4 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(4), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEF"), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$4a4d5965e2738b2a = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $54f14d15482dd6fe$var$padding(5), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$c57d6760d519c8ac = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $54f14d15482dd6fe$var$padding(5), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$5fbcb08925249358 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $54f14d15482dd6fe$var$join(""), $54f14d15482dd6fe$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $54f14d15482dd6fe$export$b3b2de96497acc47 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(6), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $54f14d15482dd6fe$var$padding(6), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$7d21597c7bc64465 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(6), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $54f14d15482dd6fe$var$padding(6), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$var$genBase58 = (abc)=>$54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix(58), $54f14d15482dd6fe$var$alphabet(abc), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$61f53211c069eefb = $54f14d15482dd6fe$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $54f14d15482dd6fe$export$c6a7baed2941aad2 = $54f14d15482dd6fe$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $54f14d15482dd6fe$export$cbd4c72942a9201d = $54f14d15482dd6fe$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
const $54f14d15482dd6fe$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $54f14d15482dd6fe$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $54f14d15482dd6fe$export$61f53211c069eefb.encode(block).padStart($54f14d15482dd6fe$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $54f14d15482dd6fe$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $54f14d15482dd6fe$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $54f14d15482dd6fe$export$fff625c574161df6 = (sha256)=>$54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$checksum(4, (data)=>sha256(sha256(data))), $54f14d15482dd6fe$export$61f53211c069eefb);
const $54f14d15482dd6fe$var$BECH_ALPHABET = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $54f14d15482dd6fe$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $54f14d15482dd6fe$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $54f14d15482dd6fe$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $54f14d15482dd6fe$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $54f14d15482dd6fe$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $54f14d15482dd6fe$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $54f14d15482dd6fe$var$BECH_ALPHABET.encode($54f14d15482dd6fe$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
function $54f14d15482dd6fe$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $54f14d15482dd6fe$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $54f14d15482dd6fe$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        prefix = prefix.toLowerCase();
        return `${prefix}1${$54f14d15482dd6fe$var$BECH_ALPHABET.encode(words)}${$54f14d15482dd6fe$var$bechChecksum(prefix, words, ENCODING_CONST)}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        str = lowered;
        const sepIndex = str.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = str.slice(0, sepIndex);
        const _words = str.slice(sepIndex + 1);
        if (_words.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $54f14d15482dd6fe$var$BECH_ALPHABET.decode(_words).slice(0, -6);
        const sum = $54f14d15482dd6fe$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!_words.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $54f14d15482dd6fe$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $54f14d15482dd6fe$export$27c42482533637da = $54f14d15482dd6fe$var$genBech32("bech32");
const $54f14d15482dd6fe$export$4963f7e473ccf819 = $54f14d15482dd6fe$var$genBech32("bech32m");
const $54f14d15482dd6fe$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $54f14d15482dd6fe$export$834dfc94dde4b3d8 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(4), $54f14d15482dd6fe$var$alphabet("0123456789abcdef"), $54f14d15482dd6fe$var$join(""), $54f14d15482dd6fe$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
const $54f14d15482dd6fe$var$CODERS = {
    utf8: $54f14d15482dd6fe$export$74329b762b589566,
    hex: $54f14d15482dd6fe$export$834dfc94dde4b3d8,
    base16: $54f14d15482dd6fe$export$586f61c71cb02fe4,
    base32: $54f14d15482dd6fe$export$4a4d5965e2738b2a,
    base64: $54f14d15482dd6fe$export$b3b2de96497acc47,
    base64url: $54f14d15482dd6fe$export$7d21597c7bc64465,
    base58: $54f14d15482dd6fe$export$61f53211c069eefb,
    base58xmr: $54f14d15482dd6fe$export$e86cd8e7f8cff4a6
};
const $54f14d15482dd6fe$var$coderTypeError = `Invalid encoding type. Available types: ${Object.keys($54f14d15482dd6fe$var$CODERS).join(", ")}`;
const $54f14d15482dd6fe$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$54f14d15482dd6fe$var$CODERS.hasOwnProperty(type)) throw new TypeError($54f14d15482dd6fe$var$coderTypeError);
    if (!(bytes instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
    return $54f14d15482dd6fe$var$CODERS[type].encode(bytes);
};
const $54f14d15482dd6fe$export$42d51816ce590c93 = $54f14d15482dd6fe$export$7c746b75f47c9c7d;
const $54f14d15482dd6fe$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$54f14d15482dd6fe$var$CODERS.hasOwnProperty(type)) throw new TypeError($54f14d15482dd6fe$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $54f14d15482dd6fe$var$CODERS[type].decode(str);
};
const $54f14d15482dd6fe$export$b3317979f9250576 = $54f14d15482dd6fe$export$c8dd6bc66a63753c;

});

parcelRegister("3njOQ", function(module, exports) {

$parcel$export(module.exports, "cbc", function () { return $2752e4ba20b58b2b$export$f98efb84b25ee206; });
// prettier-ignore

var $ltMLs = parcelRequire("ltMLs");

var $hmGd5 = parcelRequire("hmGd5");

var $3mYRO = parcelRequire("3mYRO");
/*
AES (Advanced Encryption Standard) aka Rijndael block cipher.

Data is split into 128-bit blocks. Encrypted in 10/12/14 rounds (128/192/256 bits). In every round:
1. **S-box**, table substitution
2. **Shift rows**, cyclic shift left of all rows of data array
3. **Mix columns**, multiplying every column by fixed polynomial
4. **Add round key**, round_key xor i-th column of array

Resources:
- FIPS-197 https://csrc.nist.gov/files/pubs/fips/197/final/docs/fips-197.pdf
- Original proposal: https://csrc.nist.gov/csrc/media/projects/cryptographic-standards-and-guidelines/documents/aes-development/rijndael-ammended.pdf
*/ const $2752e4ba20b58b2b$var$BLOCK_SIZE = 16;
const $2752e4ba20b58b2b$var$BLOCK_SIZE32 = 4;
const $2752e4ba20b58b2b$var$EMPTY_BLOCK = new Uint8Array($2752e4ba20b58b2b$var$BLOCK_SIZE);
const $2752e4ba20b58b2b$var$POLY = 0x11b; // 1 + x + x**3 + x**4 + x**8
// TODO: remove multiplication, binary ops only
function $2752e4ba20b58b2b$var$mul2(n) {
    return n << 1 ^ $2752e4ba20b58b2b$var$POLY & -(n >> 7);
}
function $2752e4ba20b58b2b$var$mul(a, b) {
    let res = 0;
    for(; b > 0; b >>= 1){
        // Montgomery ladder
        res ^= a & -(b & 1); // if (b&1) res ^=a (but const-time).
        a = $2752e4ba20b58b2b$var$mul2(a); // a = 2*a
    }
    return res;
}
// AES S-box is generated using finite field inversion,
// an affine transform, and xor of a constant 0x63.
const $2752e4ba20b58b2b$var$sbox = /* @__PURE__ */ (()=>{
    let t = new Uint8Array(256);
    for(let i = 0, x = 1; i < 256; i++, x ^= $2752e4ba20b58b2b$var$mul2(x))t[i] = x;
    const box = new Uint8Array(256);
    box[0] = 0x63; // first elm
    for(let i = 0; i < 255; i++){
        let x = t[255 - i];
        x |= x << 8;
        box[t[i]] = (x ^ x >> 4 ^ x >> 5 ^ x >> 6 ^ x >> 7 ^ 0x63) & 0xff;
    }
    return box;
})();
// Inverted S-box
const $2752e4ba20b58b2b$var$invSbox = /* @__PURE__ */ $2752e4ba20b58b2b$var$sbox.map((_, j)=>$2752e4ba20b58b2b$var$sbox.indexOf(j));
// Rotate u32 by 8
const $2752e4ba20b58b2b$var$rotr32_8 = (n)=>n << 24 | n >>> 8;
const $2752e4ba20b58b2b$var$rotl32_8 = (n)=>n << 8 | n >>> 24;
// T-table is optimization suggested in 5.2 of original proposal (missed from FIPS-197). Changes:
// - LE instead of BE
// - bigger tables: T0 and T1 are merged into T01 table and T2 & T3 into T23;
//   so index is u16, instead of u8. This speeds up things, unexpectedly
function $2752e4ba20b58b2b$var$genTtable(sbox, fn) {
    if (sbox.length !== 256) throw new Error("Wrong sbox length");
    const T0 = new Uint32Array(256).map((_, j)=>fn(sbox[j]));
    const T1 = T0.map($2752e4ba20b58b2b$var$rotl32_8);
    const T2 = T1.map($2752e4ba20b58b2b$var$rotl32_8);
    const T3 = T2.map($2752e4ba20b58b2b$var$rotl32_8);
    const T01 = new Uint32Array(65536);
    const T23 = new Uint32Array(65536);
    const sbox2 = new Uint16Array(65536);
    for(let i = 0; i < 256; i++)for(let j = 0; j < 256; j++){
        const idx = i * 256 + j;
        T01[idx] = T0[i] ^ T1[j];
        T23[idx] = T2[i] ^ T3[j];
        sbox2[idx] = sbox[i] << 8 | sbox[j];
    }
    return {
        sbox: sbox,
        sbox2: sbox2,
        T0: T0,
        T1: T1,
        T2: T2,
        T3: T3,
        T01: T01,
        T23: T23
    };
}
const $2752e4ba20b58b2b$var$tableEncoding = /* @__PURE__ */ $2752e4ba20b58b2b$var$genTtable($2752e4ba20b58b2b$var$sbox, (s)=>$2752e4ba20b58b2b$var$mul(s, 3) << 24 | s << 16 | s << 8 | $2752e4ba20b58b2b$var$mul(s, 2));
const $2752e4ba20b58b2b$var$tableDecoding = /* @__PURE__ */ $2752e4ba20b58b2b$var$genTtable($2752e4ba20b58b2b$var$invSbox, (s)=>$2752e4ba20b58b2b$var$mul(s, 11) << 24 | $2752e4ba20b58b2b$var$mul(s, 13) << 16 | $2752e4ba20b58b2b$var$mul(s, 9) << 8 | $2752e4ba20b58b2b$var$mul(s, 14));
const $2752e4ba20b58b2b$var$xPowers = /* @__PURE__ */ (()=>{
    const p = new Uint8Array(16);
    for(let i = 0, x = 1; i < 16; i++, x = $2752e4ba20b58b2b$var$mul2(x))p[i] = x;
    return p;
})();
function $2752e4ba20b58b2b$export$9cab40a494b78c75(key) {
    (0, $3mYRO.bytes)(key);
    const len = key.length;
    if (![
        16,
        24,
        32
    ].includes(len)) throw new Error(`aes: wrong key size: should be 16, 24 or 32, got: ${len}`);
    const { sbox2: sbox2 } = $2752e4ba20b58b2b$var$tableEncoding;
    const k32 = (0, $ltMLs.u32)(key);
    const Nk = k32.length;
    const subByte = (n)=>$2752e4ba20b58b2b$var$applySbox(sbox2, n, n, n, n);
    const xk = new Uint32Array(len + 28); // expanded key
    xk.set(k32);
    // 4.3.1 Key expansion
    for(let i = Nk; i < xk.length; i++){
        let t = xk[i - 1];
        if (i % Nk === 0) t = subByte($2752e4ba20b58b2b$var$rotr32_8(t)) ^ $2752e4ba20b58b2b$var$xPowers[i / Nk - 1];
        else if (Nk > 6 && i % Nk === 4) t = subByte(t);
        xk[i] = xk[i - Nk] ^ t;
    }
    return xk;
}
function $2752e4ba20b58b2b$export$a5606923022117ad(key) {
    const encKey = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
    const xk = encKey.slice();
    const Nk = encKey.length;
    const { sbox2: sbox2 } = $2752e4ba20b58b2b$var$tableEncoding;
    const { T0: T0, T1: T1, T2: T2, T3: T3 } = $2752e4ba20b58b2b$var$tableDecoding;
    // Inverse key by chunks of 4 (rounds)
    for(let i = 0; i < Nk; i += 4)for(let j = 0; j < 4; j++)xk[i + j] = encKey[Nk - i - 4 + j];
    encKey.fill(0);
    // apply InvMixColumn except first & last round
    for(let i = 4; i < Nk - 4; i++){
        const x = xk[i];
        const w = $2752e4ba20b58b2b$var$applySbox(sbox2, x, x, x, x);
        xk[i] = T0[w & 0xff] ^ T1[w >>> 8 & 0xff] ^ T2[w >>> 16 & 0xff] ^ T3[w >>> 24];
    }
    return xk;
}
// Apply tables
function $2752e4ba20b58b2b$var$apply0123(T01, T23, s0, s1, s2, s3) {
    return T01[s0 << 8 & 0xff00 | s1 >>> 8 & 0xff] ^ T23[s2 >>> 8 & 0xff00 | s3 >>> 24 & 0xff];
}
function $2752e4ba20b58b2b$var$applySbox(sbox2, s0, s1, s2, s3) {
    return sbox2[s0 & 0xff | s1 & 0xff00] | sbox2[s2 >>> 16 & 0xff | s3 >>> 16 & 0xff00] << 16;
}
function $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2752e4ba20b58b2b$var$tableEncoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s0, s1, s2, s3);
        const t1 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s1, s2, s3, s0);
        const t2 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s2, s3, s0, s1);
        const t3 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s3, s0, s1, s2);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // last round (without mixcolumns, so using SBOX2 table)
    const t0 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s0, s1, s2, s3);
    const t1 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s1, s2, s3, s0);
    const t2 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s2, s3, s0, s1);
    const t3 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s3, s0, s1, s2);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
function $2752e4ba20b58b2b$var$decrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2752e4ba20b58b2b$var$tableDecoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s0, s3, s2, s1);
        const t1 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s1, s0, s3, s2);
        const t2 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s2, s1, s0, s3);
        const t3 = xk[k++] ^ $2752e4ba20b58b2b$var$apply0123(T01, T23, s3, s2, s1, s0);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // Last round
    const t0 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s0, s3, s2, s1);
    const t1 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s1, s0, s3, s2);
    const t2 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s2, s1, s0, s3);
    const t3 = xk[k++] ^ $2752e4ba20b58b2b$var$applySbox(sbox2, s3, s2, s1, s0);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
function $2752e4ba20b58b2b$var$getDst(len, dst) {
    if (!dst) return new Uint8Array(len);
    (0, $3mYRO.bytes)(dst);
    if (dst.length < len) throw new Error(`aes: wrong destination length, expected at least ${len}, got: ${dst.length}`);
    return dst;
}
// TODO: investigate merging with ctr32
function $2752e4ba20b58b2b$var$ctrCounter(xk, nonce, src, dst) {
    (0, $3mYRO.bytes)(nonce, $2752e4ba20b58b2b$var$BLOCK_SIZE);
    (0, $3mYRO.bytes)(src);
    const srcLen = src.length;
    dst = $2752e4ba20b58b2b$var$getDst(srcLen, dst);
    const ctr = nonce;
    const c32 = (0, $ltMLs.u32)(ctr);
    // Fill block (empty, ctr=0)
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    const src32 = (0, $ltMLs.u32)(src);
    const dst32 = (0, $ltMLs.u32)(dst);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        // Full 128 bit counter with wrap around
        let carry = 1;
        for(let i = ctr.length - 1; i >= 0; i--){
            carry = carry + (ctr[i] & 0xff) | 0;
            ctr[i] = carry & 0xff;
            carry >>>= 8;
        }
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than block)
    // It's possible to handle > u32 fast, but is it worth it?
    const start = $2752e4ba20b58b2b$var$BLOCK_SIZE * Math.floor(src32.length / $2752e4ba20b58b2b$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $ltMLs.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
    }
    return dst;
}
// AES CTR with overflowing 32 bit counter
// It's possible to do 32le significantly simpler (and probably faster) by using u32.
// But, we need both, and perf bottleneck is in ghash anyway.
function $2752e4ba20b58b2b$var$ctr32(xk, isLE, nonce, src, dst) {
    (0, $3mYRO.bytes)(nonce, $2752e4ba20b58b2b$var$BLOCK_SIZE);
    (0, $3mYRO.bytes)(src);
    dst = $2752e4ba20b58b2b$var$getDst(src.length, dst);
    const ctr = nonce; // write new value to nonce, so it can be re-used
    const c32 = (0, $ltMLs.u32)(ctr);
    const view = (0, $ltMLs.createView)(ctr);
    const src32 = (0, $ltMLs.u32)(src);
    const dst32 = (0, $ltMLs.u32)(dst);
    const ctrPos = isLE ? 0 : 12;
    const srcLen = src.length;
    // Fill block (empty, ctr=0)
    let ctrNum = view.getUint32(ctrPos, isLE); // read current counter value
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        ctrNum = ctrNum + 1 >>> 0; // u32 wrap
        view.setUint32(ctrPos, ctrNum, isLE);
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than a block)
    const start = $2752e4ba20b58b2b$var$BLOCK_SIZE * Math.floor(src32.length / $2752e4ba20b58b2b$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $ltMLs.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
    }
    return dst;
}
const $2752e4ba20b58b2b$export$5f70e4be40e1a294 = (0, $ltMLs.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function ctr(key, nonce) {
    (0, $3mYRO.bytes)(key);
    (0, $3mYRO.bytes)(nonce, $2752e4ba20b58b2b$var$BLOCK_SIZE);
    function processCtr(buf, dst) {
        const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
        const n = nonce.slice();
        const out = $2752e4ba20b58b2b$var$ctrCounter(xk, n, buf, dst);
        xk.fill(0);
        n.fill(0);
        return out;
    }
    return {
        encrypt: (plaintext, dst)=>processCtr(plaintext, dst),
        decrypt: (ciphertext, dst)=>processCtr(ciphertext, dst)
    };
});
function $2752e4ba20b58b2b$var$validateBlockDecrypt(data) {
    (0, $3mYRO.bytes)(data);
    if (data.length % $2752e4ba20b58b2b$var$BLOCK_SIZE !== 0) throw new Error(`aes/(cbc-ecb).decrypt ciphertext should consist of blocks with size ${$2752e4ba20b58b2b$var$BLOCK_SIZE}`);
}
function $2752e4ba20b58b2b$var$validateBlockEncrypt(plaintext, pcks5, dst) {
    let outLen = plaintext.length;
    const remaining = outLen % $2752e4ba20b58b2b$var$BLOCK_SIZE;
    if (!pcks5 && remaining !== 0) throw new Error("aec/(cbc-ecb): unpadded plaintext with disabled padding");
    const b = (0, $ltMLs.u32)(plaintext);
    if (pcks5) {
        let left = $2752e4ba20b58b2b$var$BLOCK_SIZE - remaining;
        if (!left) left = $2752e4ba20b58b2b$var$BLOCK_SIZE; // if no bytes left, create empty padding block
        outLen = outLen + left;
    }
    const out = $2752e4ba20b58b2b$var$getDst(outLen, dst);
    const o = (0, $ltMLs.u32)(out);
    return {
        b: b,
        o: o,
        out: out
    };
}
function $2752e4ba20b58b2b$var$validatePCKS(data, pcks5) {
    if (!pcks5) return data;
    const len = data.length;
    if (!len) throw new Error(`aes/pcks5: empty ciphertext not allowed`);
    const lastByte = data[len - 1];
    if (lastByte <= 0 || lastByte > 16) throw new Error(`aes/pcks5: wrong padding byte: ${lastByte}`);
    const out = data.subarray(0, -lastByte);
    for(let i = 0; i < lastByte; i++)if (data[len - i - 1] !== lastByte) throw new Error(`aes/pcks5: wrong padding`);
    return out;
}
function $2752e4ba20b58b2b$var$padPCKS(left) {
    const tmp = new Uint8Array(16);
    const tmp32 = (0, $ltMLs.u32)(tmp);
    tmp.set(left);
    const paddingByte = $2752e4ba20b58b2b$var$BLOCK_SIZE - left.length;
    for(let i = $2752e4ba20b58b2b$var$BLOCK_SIZE - paddingByte; i < $2752e4ba20b58b2b$var$BLOCK_SIZE; i++)tmp[i] = paddingByte;
    return tmp32;
}
const $2752e4ba20b58b2b$export$bf364bd2354bf4a = (0, $ltMLs.wrapCipher)({
    blockSize: 16
}, function ecb(key, opts = {}) {
    (0, $3mYRO.bytes)(key);
    const pcks5 = !opts.disablePadding;
    return {
        encrypt: (plaintext, dst)=>{
            (0, $3mYRO.bytes)(plaintext);
            const { b: b, o: o, out: _out } = $2752e4ba20b58b2b$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
            let i = 0;
            for(; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2752e4ba20b58b2b$var$padPCKS(plaintext.subarray(i * 4));
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, tmp32[0], tmp32[1], tmp32[2], tmp32[3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            xk.fill(0);
            return _out;
        },
        decrypt: (ciphertext, dst)=>{
            $2752e4ba20b58b2b$var$validateBlockDecrypt(ciphertext);
            const xk = $2752e4ba20b58b2b$export$a5606923022117ad(key);
            const out = $2752e4ba20b58b2b$var$getDst(ciphertext.length, dst);
            const b = (0, $ltMLs.u32)(ciphertext);
            const o = (0, $ltMLs.u32)(out);
            for(let i = 0; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$decrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            xk.fill(0);
            return $2752e4ba20b58b2b$var$validatePCKS(out, pcks5);
        }
    };
});
const $2752e4ba20b58b2b$export$f98efb84b25ee206 = (0, $ltMLs.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function cbc(key, iv, opts = {}) {
    (0, $3mYRO.bytes)(key);
    (0, $3mYRO.bytes)(iv, 16);
    const pcks5 = !opts.disablePadding;
    return {
        encrypt: (plaintext, dst)=>{
            const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
            const { b: b, o: o, out: _out } = $2752e4ba20b58b2b$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const n32 = (0, $ltMLs.u32)(iv);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            let i = 0;
            for(; i + 4 <= b.length;){
                s0 ^= b[i + 0], s1 ^= b[i + 1], s2 ^= b[i + 2], s3 ^= b[i + 3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2752e4ba20b58b2b$var$padPCKS(plaintext.subarray(i * 4));
                s0 ^= tmp32[0], s1 ^= tmp32[1], s2 ^= tmp32[2], s3 ^= tmp32[3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            xk.fill(0);
            return _out;
        },
        decrypt: (ciphertext, dst)=>{
            $2752e4ba20b58b2b$var$validateBlockDecrypt(ciphertext);
            const xk = $2752e4ba20b58b2b$export$a5606923022117ad(key);
            const n32 = (0, $ltMLs.u32)(iv);
            const out = $2752e4ba20b58b2b$var$getDst(ciphertext.length, dst);
            const b = (0, $ltMLs.u32)(ciphertext);
            const o = (0, $ltMLs.u32)(out);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            for(let i = 0; i + 4 <= b.length;){
                // prettier-ignore
                const ps0 = s0, ps1 = s1, ps2 = s2, ps3 = s3;
                s0 = b[i + 0], s1 = b[i + 1], s2 = b[i + 2], s3 = b[i + 3];
                const { s0: o0, s1: o1, s2: o2, s3: o3 } = $2752e4ba20b58b2b$var$decrypt(xk, s0, s1, s2, s3);
                o[i++] = o0 ^ ps0, o[i++] = o1 ^ ps1, o[i++] = o2 ^ ps2, o[i++] = o3 ^ ps3;
            }
            xk.fill(0);
            return $2752e4ba20b58b2b$var$validatePCKS(out, pcks5);
        }
    };
});
const $2752e4ba20b58b2b$export$385fe64256455ced = (0, $ltMLs.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function cfb(key, iv) {
    (0, $3mYRO.bytes)(key);
    (0, $3mYRO.bytes)(iv, 16);
    function processCfb(src, isEncrypt, dst) {
        const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
        const srcLen = src.length;
        dst = $2752e4ba20b58b2b$var$getDst(srcLen, dst);
        const src32 = (0, $ltMLs.u32)(src);
        const dst32 = (0, $ltMLs.u32)(dst);
        const next32 = isEncrypt ? dst32 : src32;
        const n32 = (0, $ltMLs.u32)(iv);
        // prettier-ignore
        let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
        for(let i = 0; i + 4 <= src32.length;){
            const { s0: e0, s1: e1, s2: e2, s3: e3 } = $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3);
            dst32[i + 0] = src32[i + 0] ^ e0;
            dst32[i + 1] = src32[i + 1] ^ e1;
            dst32[i + 2] = src32[i + 2] ^ e2;
            dst32[i + 3] = src32[i + 3] ^ e3;
            s0 = next32[i++], s1 = next32[i++], s2 = next32[i++], s3 = next32[i++];
        }
        // leftovers (less than block)
        const start = $2752e4ba20b58b2b$var$BLOCK_SIZE * Math.floor(src32.length / $2752e4ba20b58b2b$var$BLOCK_SIZE32);
        if (start < srcLen) {
            ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3));
            const buf = (0, $ltMLs.u8)(new Uint32Array([
                s0,
                s1,
                s2,
                s3
            ]));
            for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
            buf.fill(0);
        }
        xk.fill(0);
        return dst;
    }
    return {
        encrypt: (plaintext, dst)=>processCfb(plaintext, true, dst),
        decrypt: (ciphertext, dst)=>processCfb(ciphertext, false, dst)
    };
});
// TODO: merge with chacha, however gcm has bitLen while chacha has byteLen
function $2752e4ba20b58b2b$var$computeTag(fn, isLE, key, data, AAD) {
    const h = fn.create(key, data.length + (AAD?.length || 0));
    if (AAD) h.update(AAD);
    h.update(data);
    const num = new Uint8Array(16);
    const view = (0, $ltMLs.createView)(num);
    if (AAD) (0, $ltMLs.setBigUint64)(view, 0, BigInt(AAD.length * 8), isLE);
    (0, $ltMLs.setBigUint64)(view, 8, BigInt(data.length * 8), isLE);
    h.update(num);
    return h.digest();
}
const $2752e4ba20b58b2b$export$1c2d3f5179fe12a4 = (0, $ltMLs.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16
}, function gcm(key, nonce, AAD) {
    (0, $3mYRO.bytes)(nonce);
    // Nonce can be pretty much anything (even 1 byte). But smaller nonces less secure.
    if (nonce.length === 0) throw new Error("aes/gcm: empty nonce");
    const tagLength = 16;
    function _computeTag(authKey, tagMask, data) {
        const tag = $2752e4ba20b58b2b$var$computeTag((0, $hmGd5.ghash), false, authKey, data, AAD);
        for(let i = 0; i < tagMask.length; i++)tag[i] ^= tagMask[i];
        return tag;
    }
    function deriveKeys() {
        const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
        const authKey = $2752e4ba20b58b2b$var$EMPTY_BLOCK.slice();
        const counter = $2752e4ba20b58b2b$var$EMPTY_BLOCK.slice();
        $2752e4ba20b58b2b$var$ctr32(xk, false, counter, counter, authKey);
        if (nonce.length === 12) counter.set(nonce);
        else {
            // Spec (NIST 800-38d) supports variable size nonce.
            // Not supported for now, but can be useful.
            const nonceLen = $2752e4ba20b58b2b$var$EMPTY_BLOCK.slice();
            const view = (0, $ltMLs.createView)(nonceLen);
            (0, $ltMLs.setBigUint64)(view, 8, BigInt(nonce.length * 8), false);
            // ghash(nonce || u64be(0) || u64be(nonceLen*8))
            (0, $hmGd5.ghash).create(authKey).update(nonce).update(nonceLen).digestInto(counter);
        }
        const tagMask = $2752e4ba20b58b2b$var$ctr32(xk, false, counter, $2752e4ba20b58b2b$var$EMPTY_BLOCK);
        return {
            xk: xk,
            authKey: authKey,
            counter: counter,
            tagMask: tagMask
        };
    }
    return {
        encrypt: (plaintext)=>{
            (0, $3mYRO.bytes)(plaintext);
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const out = new Uint8Array(plaintext.length + tagLength);
            $2752e4ba20b58b2b$var$ctr32(xk, false, counter, plaintext, out);
            const tag = _computeTag(authKey, tagMask, out.subarray(0, out.length - tagLength));
            out.set(tag, plaintext.length);
            xk.fill(0);
            return out;
        },
        decrypt: (ciphertext)=>{
            (0, $3mYRO.bytes)(ciphertext);
            if (ciphertext.length < tagLength) throw new Error(`aes/gcm: ciphertext less than tagLen (${tagLength})`);
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const data = ciphertext.subarray(0, -tagLength);
            const passedTag = ciphertext.subarray(-tagLength);
            const tag = _computeTag(authKey, tagMask, data);
            if (!(0, $ltMLs.equalBytes)(tag, passedTag)) throw new Error("aes/gcm: invalid ghash tag");
            const out = $2752e4ba20b58b2b$var$ctr32(xk, false, counter, data);
            authKey.fill(0);
            tagMask.fill(0);
            xk.fill(0);
            return out;
        }
    };
});
const $2752e4ba20b58b2b$var$limit = (name, min, max)=>(value)=>{
        if (!Number.isSafeInteger(value) || min > value || value > max) throw new Error(`${name}: invalid value=${value}, must be [${min}..${max}]`);
    };
const $2752e4ba20b58b2b$export$f45e8835a0f9974d = (0, $ltMLs.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16
}, function siv(key, nonce, AAD) {
    const tagLength = 16;
    // From RFC 8452: Section 6
    const AAD_LIMIT = $2752e4ba20b58b2b$var$limit("AAD", 0, 2 ** 36);
    const PLAIN_LIMIT = $2752e4ba20b58b2b$var$limit("plaintext", 0, 2 ** 36);
    const NONCE_LIMIT = $2752e4ba20b58b2b$var$limit("nonce", 12, 12);
    const CIPHER_LIMIT = $2752e4ba20b58b2b$var$limit("ciphertext", 16, 2 ** 36 + 16);
    (0, $3mYRO.bytes)(nonce);
    NONCE_LIMIT(nonce.length);
    if (AAD) {
        (0, $3mYRO.bytes)(AAD);
        AAD_LIMIT(AAD.length);
    }
    function deriveKeys() {
        const len = key.length;
        if (len !== 16 && len !== 24 && len !== 32) throw new Error(`key length must be 16, 24 or 32 bytes, got: ${len} bytes`);
        const xk = $2752e4ba20b58b2b$export$9cab40a494b78c75(key);
        const encKey = new Uint8Array(len);
        const authKey = new Uint8Array(16);
        const n32 = (0, $ltMLs.u32)(nonce);
        // prettier-ignore
        let s0 = 0, s1 = n32[0], s2 = n32[1], s3 = n32[2];
        let counter = 0;
        for (const derivedKey of [
            authKey,
            encKey
        ].map((0, $ltMLs.u32))){
            const d32 = (0, $ltMLs.u32)(derivedKey);
            for(let i = 0; i < d32.length; i += 2){
                // aes(u32le(0) || nonce)[:8] || aes(u32le(1) || nonce)[:8] ...
                const { s0: o0, s1: o1 } = $2752e4ba20b58b2b$var$encrypt(xk, s0, s1, s2, s3);
                d32[i + 0] = o0;
                d32[i + 1] = o1;
                s0 = ++counter; // increment counter inside state
            }
        }
        xk.fill(0);
        return {
            authKey: authKey,
            encKey: $2752e4ba20b58b2b$export$9cab40a494b78c75(encKey)
        };
    }
    function _computeTag(encKey, authKey, data) {
        const tag = $2752e4ba20b58b2b$var$computeTag((0, $hmGd5.polyval), true, authKey, data, AAD);
        // Compute the expected tag by XORing S_s and the nonce, clearing the
        // most significant bit of the last byte and encrypting with the
        // message-encryption key.
        for(let i = 0; i < 12; i++)tag[i] ^= nonce[i];
        tag[15] &= 0x7f; // Clear the highest bit
        // encrypt tag as block
        const t32 = (0, $ltMLs.u32)(tag);
        // prettier-ignore
        let s0 = t32[0], s1 = t32[1], s2 = t32[2], s3 = t32[3];
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(encKey, s0, s1, s2, s3));
        t32[0] = s0, t32[1] = s1, t32[2] = s2, t32[3] = s3;
        return tag;
    }
    // actual decrypt/encrypt of message.
    function processSiv(encKey, tag, input) {
        let block = tag.slice();
        block[15] |= 0x80; // Force highest bit
        return $2752e4ba20b58b2b$var$ctr32(encKey, true, block, input);
    }
    return {
        encrypt: (plaintext)=>{
            (0, $3mYRO.bytes)(plaintext);
            PLAIN_LIMIT(plaintext.length);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const tag = _computeTag(encKey, authKey, plaintext);
            const out = new Uint8Array(plaintext.length + tagLength);
            out.set(tag, plaintext.length);
            out.set(processSiv(encKey, tag, plaintext));
            encKey.fill(0);
            authKey.fill(0);
            return out;
        },
        decrypt: (ciphertext)=>{
            (0, $3mYRO.bytes)(ciphertext);
            CIPHER_LIMIT(ciphertext.length);
            const tag = ciphertext.subarray(-tagLength);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const plaintext = processSiv(encKey, tag, ciphertext.subarray(0, -tagLength));
            const expectedTag = _computeTag(encKey, authKey, plaintext);
            encKey.fill(0);
            authKey.fill(0);
            if (!(0, $ltMLs.equalBytes)(tag, expectedTag)) throw new Error("invalid polyval tag");
            return plaintext;
        }
    };
});
function $2752e4ba20b58b2b$var$isBytes32(a) {
    return a != null && typeof a === "object" && (a instanceof Uint32Array || a.constructor.name === "Uint32Array");
}
function $2752e4ba20b58b2b$var$encryptBlock(xk, block) {
    (0, $3mYRO.bytes)(block, 16);
    if (!$2752e4ba20b58b2b$var$isBytes32(xk)) throw new Error("_encryptBlock accepts result of expandKeyLE");
    const b32 = (0, $ltMLs.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$encrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
function $2752e4ba20b58b2b$var$decryptBlock(xk, block) {
    (0, $3mYRO.bytes)(block, 16);
    if (!$2752e4ba20b58b2b$var$isBytes32(xk)) throw new Error("_decryptBlock accepts result of expandKeyLE");
    const b32 = (0, $ltMLs.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2752e4ba20b58b2b$var$decrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
const $2752e4ba20b58b2b$export$aa1c11b655786597 = {
    expandKeyLE: $2752e4ba20b58b2b$export$9cab40a494b78c75,
    expandKeyDecLE: $2752e4ba20b58b2b$export$a5606923022117ad,
    encrypt: $2752e4ba20b58b2b$var$encrypt,
    decrypt: $2752e4ba20b58b2b$var$decrypt,
    encryptBlock: $2752e4ba20b58b2b$var$encryptBlock,
    decryptBlock: $2752e4ba20b58b2b$var$decryptBlock,
    ctrCounter: $2752e4ba20b58b2b$var$ctrCounter,
    ctr32: $2752e4ba20b58b2b$var$ctr32
};

});
parcelRegister("ltMLs", function(module, exports) {

$parcel$export(module.exports, "u8", function () { return $fa3222049d5660f7$export$9813fca58c0b9f71; });
$parcel$export(module.exports, "u32", function () { return $fa3222049d5660f7$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $fa3222049d5660f7$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "toBytes", function () { return $fa3222049d5660f7$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "checkOpts", function () { return $fa3222049d5660f7$export$6fcee72895eceb1e; });
$parcel$export(module.exports, "equalBytes", function () { return $fa3222049d5660f7$export$2aa59cef064b0333; });
$parcel$export(module.exports, "wrapCipher", function () { return $fa3222049d5660f7$export$9a6138f9eba70f82; });
$parcel$export(module.exports, "setBigUint64", function () { return $fa3222049d5660f7$export$b13f930c762582ab; });
/*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */ 
var $3mYRO = parcelRequire("3mYRO");
const $fa3222049d5660f7$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $fa3222049d5660f7$export$73c443a9dbe0d04a = (arr)=>new Uint16Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 2));
const $fa3222049d5660f7$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $fa3222049d5660f7$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $fa3222049d5660f7$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$fa3222049d5660f7$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $fa3222049d5660f7$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $fa3222049d5660f7$export$58b867e287a802c8(bytes) {
    (0, $3mYRO.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $fa3222049d5660f7$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $fa3222049d5660f7$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $fa3222049d5660f7$var$asciiToBase16(char) {
    if (char >= $fa3222049d5660f7$var$asciis._0 && char <= $fa3222049d5660f7$var$asciis._9) return char - $fa3222049d5660f7$var$asciis._0;
    if (char >= $fa3222049d5660f7$var$asciis._A && char <= $fa3222049d5660f7$var$asciis._F) return char - ($fa3222049d5660f7$var$asciis._A - 10);
    if (char >= $fa3222049d5660f7$var$asciis._a && char <= $fa3222049d5660f7$var$asciis._f) return char - ($fa3222049d5660f7$var$asciis._a - 10);
    return;
}
function $fa3222049d5660f7$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $fa3222049d5660f7$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $fa3222049d5660f7$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $fa3222049d5660f7$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $fa3222049d5660f7$export$d609354794974f8(bytes) {
    return $fa3222049d5660f7$export$d57f2bacc26b4249($fa3222049d5660f7$export$58b867e287a802c8(bytes));
}
function $fa3222049d5660f7$export$1459dafd057611cb(n, len) {
    return $fa3222049d5660f7$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
const $fa3222049d5660f7$export$bdd553fddd433dcb = async ()=>{};
async function $fa3222049d5660f7$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $fa3222049d5660f7$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $fa3222049d5660f7$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`string expected, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $fa3222049d5660f7$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $fa3222049d5660f7$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $fa3222049d5660f7$export$3df70a15530b5e81(data);
    else if ((0, $3mYRO.isBytes)(data)) data = data.slice();
    else throw new Error(`Uint8Array expected, got ${typeof data}`);
    return data;
}
function $fa3222049d5660f7$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $3mYRO.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $fa3222049d5660f7$export$6fcee72895eceb1e(defaults, opts) {
    if (opts == null || typeof opts !== "object") throw new Error("options must be defined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $fa3222049d5660f7$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
class $fa3222049d5660f7$export$ab85ecd77ce6a5cd {
}
const $fa3222049d5660f7$export$9a6138f9eba70f82 = (params, c)=>{
    Object.assign(c, params);
    return c;
};
function $fa3222049d5660f7$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $fa3222049d5660f7$export$342c09f6517ae3b8(ciphertext, AAD) {
    const num = new Uint8Array(16);
    const view = $fa3222049d5660f7$export$d7febe7b891e79f0(num);
    $fa3222049d5660f7$export$b13f930c762582ab(view, 0, BigInt(AAD ? AAD.length : 0), true);
    $fa3222049d5660f7$export$b13f930c762582ab(view, 8, BigInt(ciphertext.length), true);
    return num;
}

});
parcelRegister("3mYRO", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $2742a419b52364d4$export$98e628dec113755e; });
$parcel$export(module.exports, "bool", function () { return $2742a419b52364d4$export$87b259aa03e3d267; });
$parcel$export(module.exports, "isBytes", function () { return $2742a419b52364d4$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "bytes", function () { return $2742a419b52364d4$export$b3317979f9250576; });
$parcel$export(module.exports, "exists", function () { return $2742a419b52364d4$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $2742a419b52364d4$export$c789db2c85949867; });
function $2742a419b52364d4$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $2742a419b52364d4$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $2742a419b52364d4$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $2742a419b52364d4$export$b3317979f9250576(b, ...lengths) {
    if (!$2742a419b52364d4$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $2742a419b52364d4$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("hash must be wrapped by utils.wrapConstructor");
    $2742a419b52364d4$export$98e628dec113755e(hash.outputLen);
    $2742a419b52364d4$export$98e628dec113755e(hash.blockLen);
}
function $2742a419b52364d4$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $2742a419b52364d4$export$c789db2c85949867(out, instance) {
    $2742a419b52364d4$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $2742a419b52364d4$var$assert = {
    number: $2742a419b52364d4$export$98e628dec113755e,
    bool: $2742a419b52364d4$export$87b259aa03e3d267,
    bytes: $2742a419b52364d4$export$b3317979f9250576,
    hash: $2742a419b52364d4$export$d6af199866bfb566,
    exists: $2742a419b52364d4$export$f7e9f41ea797a17,
    output: $2742a419b52364d4$export$c789db2c85949867
};
var $2742a419b52364d4$export$2e2bcd8739ae039 = $2742a419b52364d4$var$assert;

});


parcelRegister("hmGd5", function(module, exports) {

$parcel$export(module.exports, "ghash", function () { return $ca453bc4d211b908$export$f562b99c67f83a33; });
$parcel$export(module.exports, "polyval", function () { return $ca453bc4d211b908$export$4dd5f33d13f59946; });

var $ltMLs = parcelRequire("ltMLs");

var $3mYRO = parcelRequire("3mYRO");
// GHash from AES-GCM and its little-endian "mirror image" Polyval from AES-SIV.
// Implemented in terms of GHash with conversion function for keys
// GCM GHASH from NIST SP800-38d, SIV from RFC 8452.
// https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-38d.pdf
// GHASH   modulo: x^128 + x^7   + x^2   + x     + 1
// POLYVAL modulo: x^128 + x^127 + x^126 + x^121 + 1
const $ca453bc4d211b908$var$BLOCK_SIZE = 16;
// TODO: rewrite
// temporary padding buffer
const $ca453bc4d211b908$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
const $ca453bc4d211b908$var$ZEROS32 = (0, $ltMLs.u32)($ca453bc4d211b908$var$ZEROS16);
const $ca453bc4d211b908$var$POLY = 0xe1; // v = 2*v % POLY
// v = 2*v % POLY
// NOTE: because x + x = 0 (add/sub is same), mul2(x) != x+x
// We can multiply any number using montgomery ladder and this function (works as double, add is simple xor)
const $ca453bc4d211b908$var$mul2 = (s0, s1, s2, s3)=>{
    const hiBit = s3 & 1;
    return {
        s3: s2 << 31 | s3 >>> 1,
        s2: s1 << 31 | s2 >>> 1,
        s1: s0 << 31 | s1 >>> 1,
        s0: s0 >>> 1 ^ $ca453bc4d211b908$var$POLY << 24 & -(hiBit & 1)
    };
};
const $ca453bc4d211b908$var$swapLE = (n)=>(n >>> 0 & 0xff) << 24 | (n >>> 8 & 0xff) << 16 | (n >>> 16 & 0xff) << 8 | n >>> 24 & 0xff | 0;
function $ca453bc4d211b908$export$9517f61de5da9b07(k) {
    k.reverse();
    const hiBit = k[15] & 1;
    // k >>= 1
    let carry = 0;
    for(let i = 0; i < k.length; i++){
        const t = k[i];
        k[i] = t >>> 1 | carry;
        carry = (t & 1) << 7;
    }
    k[0] ^= -hiBit & 0xe1; // if (hiBit) n ^= 0xe1000000000000000000000000000000;
    return k;
}
const $ca453bc4d211b908$var$estimateWindow = (bytes)=>{
    if (bytes > 65536) return 8;
    if (bytes > 1024) return 4;
    return 2;
};
class $ca453bc4d211b908$var$GHASH {
    // We select bits per window adaptively based on expectedLength
    constructor(key, expectedLength){
        this.blockLen = $ca453bc4d211b908$var$BLOCK_SIZE;
        this.outputLen = $ca453bc4d211b908$var$BLOCK_SIZE;
        this.s0 = 0;
        this.s1 = 0;
        this.s2 = 0;
        this.s3 = 0;
        this.finished = false;
        key = (0, $ltMLs.toBytes)(key);
        (0, $3mYRO.bytes)(key, 16);
        const kView = (0, $ltMLs.createView)(key);
        let k0 = kView.getUint32(0, false);
        let k1 = kView.getUint32(4, false);
        let k2 = kView.getUint32(8, false);
        let k3 = kView.getUint32(12, false);
        // generate table of doubled keys (half of montgomery ladder)
        const doubles = [];
        for(let i = 0; i < 128; i++){
            doubles.push({
                s0: $ca453bc4d211b908$var$swapLE(k0),
                s1: $ca453bc4d211b908$var$swapLE(k1),
                s2: $ca453bc4d211b908$var$swapLE(k2),
                s3: $ca453bc4d211b908$var$swapLE(k3)
            });
            ({ s0: k0, s1: k1, s2: k2, s3: k3 } = $ca453bc4d211b908$var$mul2(k0, k1, k2, k3));
        }
        const W = $ca453bc4d211b908$var$estimateWindow(expectedLength || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(W)) throw new Error(`ghash: wrong window size=${W}, should be 2, 4 or 8`);
        this.W = W;
        const bits = 128; // always 128 bits;
        const windows = bits / W;
        const windowSize = this.windowSize = 2 ** W;
        const items = [];
        // Create precompute table for window of W bits
        for(let w = 0; w < windows; w++)// truth table: 00, 01, 10, 11
        for(let byte = 0; byte < windowSize; byte++){
            // prettier-ignore
            let s0 = 0, s1 = 0, s2 = 0, s3 = 0;
            for(let j = 0; j < W; j++){
                const bit = byte >>> W - j - 1 & 1;
                if (!bit) continue;
                const { s0: d0, s1: d1, s2: d2, s3: d3 } = doubles[W * w + j];
                s0 ^= d0, s1 ^= d1, s2 ^= d2, s3 ^= d3;
            }
            items.push({
                s0: s0,
                s1: s1,
                s2: s2,
                s3: s3
            });
        }
        this.t = items;
    }
    _updateBlock(s0, s1, s2, s3) {
        s0 ^= this.s0, s1 ^= this.s1, s2 ^= this.s2, s3 ^= this.s3;
        const { W: W, t: t, windowSize: windowSize } = this;
        // prettier-ignore
        let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
        const mask = (1 << W) - 1; // 2**W will kill performance.
        let w = 0;
        for (const num of [
            s0,
            s1,
            s2,
            s3
        ])for(let bytePos = 0; bytePos < 4; bytePos++){
            const byte = num >>> 8 * bytePos & 0xff;
            for(let bitPos = 8 / W - 1; bitPos >= 0; bitPos--){
                const bit = byte >>> W * bitPos & mask;
                const { s0: e0, s1: e1, s2: e2, s3: e3 } = t[w * windowSize + bit];
                o0 ^= e0, o1 ^= e1, o2 ^= e2, o3 ^= e3;
                w += 1;
            }
        }
        this.s0 = o0;
        this.s1 = o1;
        this.s2 = o2;
        this.s3 = o3;
    }
    update(data) {
        data = (0, $ltMLs.toBytes)(data);
        (0, $3mYRO.exists)(this);
        const b32 = (0, $ltMLs.u32)(data);
        const blocks = Math.floor(data.length / $ca453bc4d211b908$var$BLOCK_SIZE);
        const left = data.length % $ca453bc4d211b908$var$BLOCK_SIZE;
        for(let i = 0; i < blocks; i++)this._updateBlock(b32[i * 4 + 0], b32[i * 4 + 1], b32[i * 4 + 2], b32[i * 4 + 3]);
        if (left) {
            $ca453bc4d211b908$var$ZEROS16.set(data.subarray(blocks * $ca453bc4d211b908$var$BLOCK_SIZE));
            this._updateBlock($ca453bc4d211b908$var$ZEROS32[0], $ca453bc4d211b908$var$ZEROS32[1], $ca453bc4d211b908$var$ZEROS32[2], $ca453bc4d211b908$var$ZEROS32[3]);
            $ca453bc4d211b908$var$ZEROS32.fill(0); // clean tmp buffer
        }
        return this;
    }
    destroy() {
        const { t: t } = this;
        // clean precompute table
        for (const elm of t)elm.s0 = 0, elm.s1 = 0, elm.s2 = 0, elm.s3 = 0;
    }
    digestInto(out) {
        (0, $3mYRO.exists)(this);
        (0, $3mYRO.output)(out, this);
        this.finished = true;
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $ltMLs.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out;
    }
    digest() {
        const res = new Uint8Array($ca453bc4d211b908$var$BLOCK_SIZE);
        this.digestInto(res);
        this.destroy();
        return res;
    }
}
class $ca453bc4d211b908$var$Polyval extends $ca453bc4d211b908$var$GHASH {
    constructor(key, expectedLength){
        key = (0, $ltMLs.toBytes)(key);
        const ghKey = $ca453bc4d211b908$export$9517f61de5da9b07(key.slice());
        super(ghKey, expectedLength);
        ghKey.fill(0);
    }
    update(data) {
        data = (0, $ltMLs.toBytes)(data);
        (0, $3mYRO.exists)(this);
        const b32 = (0, $ltMLs.u32)(data);
        const left = data.length % $ca453bc4d211b908$var$BLOCK_SIZE;
        const blocks = Math.floor(data.length / $ca453bc4d211b908$var$BLOCK_SIZE);
        for(let i = 0; i < blocks; i++)this._updateBlock($ca453bc4d211b908$var$swapLE(b32[i * 4 + 3]), $ca453bc4d211b908$var$swapLE(b32[i * 4 + 2]), $ca453bc4d211b908$var$swapLE(b32[i * 4 + 1]), $ca453bc4d211b908$var$swapLE(b32[i * 4 + 0]));
        if (left) {
            $ca453bc4d211b908$var$ZEROS16.set(data.subarray(blocks * $ca453bc4d211b908$var$BLOCK_SIZE));
            this._updateBlock($ca453bc4d211b908$var$swapLE($ca453bc4d211b908$var$ZEROS32[3]), $ca453bc4d211b908$var$swapLE($ca453bc4d211b908$var$ZEROS32[2]), $ca453bc4d211b908$var$swapLE($ca453bc4d211b908$var$ZEROS32[1]), $ca453bc4d211b908$var$swapLE($ca453bc4d211b908$var$ZEROS32[0]));
            $ca453bc4d211b908$var$ZEROS32.fill(0); // clean tmp buffer
        }
        return this;
    }
    digestInto(out) {
        (0, $3mYRO.exists)(this);
        (0, $3mYRO.output)(out, this);
        this.finished = true;
        // tmp ugly hack
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $ltMLs.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out.reverse();
    }
}
function $ca453bc4d211b908$var$wrapConstructorWithKey(hashCons) {
    const hashC = (msg, key)=>hashCons(key, msg.length).update((0, $ltMLs.toBytes)(msg)).digest();
    const tmp = hashCons(new Uint8Array(16), 0);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key, expectedLength)=>hashCons(key, expectedLength);
    return hashC;
}
const $ca453bc4d211b908$export$f562b99c67f83a33 = $ca453bc4d211b908$var$wrapConstructorWithKey((key, expectedLength)=>new $ca453bc4d211b908$var$GHASH(key, expectedLength));
const $ca453bc4d211b908$export$4dd5f33d13f59946 = $ca453bc4d211b908$var$wrapConstructorWithKey((key, expectedLength)=>new $ca453bc4d211b908$var$Polyval(key, expectedLength));

});


parcelRegister("9zClU", function(module, exports) {

$parcel$export(module.exports, "chacha20", function () { return $6f8521f1212a85c3$export$8e0a42fdbca06555; });
// prettier-ignore

var $ltMLs = parcelRequire("ltMLs");

var $jkfIt = parcelRequire("jkfIt");

var $jZHN9 = parcelRequire("jZHN9");

var $3mYRO = parcelRequire("3mYRO");
// ChaCha20 stream cipher was released in 2008. ChaCha aims to increase
// the diffusion per round, but had slightly less cryptanalysis.
// https://cr.yp.to/chacha.html, http://cr.yp.to/chacha/chacha-20080128.pdf
/**
 * ChaCha core function.
 */ // prettier-ignore
function $6f8521f1212a85c3$var$chachaCore(s, k, n, out, cnt, rounds = 20) {
    let y00 = s[0], y01 = s[1], y02 = s[2], y03 = s[3], y04 = k[0], y05 = k[1], y06 = k[2], y07 = k[3], y08 = k[4], y09 = k[5], y10 = k[6], y11 = k[7], y12 = cnt, y13 = n[0], y14 = n[1], y15 = n[2]; // Counter  Counter	Nonce   Nonce
    // Save state to temporary variables
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    for(let r = 0; r < rounds; r += 2){
        x00 = x00 + x04 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x00, 16);
        x08 = x08 + x12 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x08, 12);
        x00 = x00 + x04 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x00, 8);
        x08 = x08 + x12 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x08, 7);
        x01 = x01 + x05 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x01, 16);
        x09 = x09 + x13 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x09, 12);
        x01 = x01 + x05 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x01, 8);
        x09 = x09 + x13 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x09, 7);
        x02 = x02 + x06 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x02, 16);
        x10 = x10 + x14 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x10, 12);
        x02 = x02 + x06 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x02, 8);
        x10 = x10 + x14 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x10, 7);
        x03 = x03 + x07 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x03, 16);
        x11 = x11 + x15 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x11, 12);
        x03 = x03 + x07 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x03, 8);
        x11 = x11 + x15 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x11, 7);
        x00 = x00 + x05 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x00, 16);
        x10 = x10 + x15 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x10, 12);
        x00 = x00 + x05 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x00, 8);
        x10 = x10 + x15 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x10, 7);
        x01 = x01 + x06 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x01, 16);
        x11 = x11 + x12 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x11, 12);
        x01 = x01 + x06 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x01, 8);
        x11 = x11 + x12 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x11, 7);
        x02 = x02 + x07 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x02, 16);
        x08 = x08 + x13 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x08, 12);
        x02 = x02 + x07 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x02, 8);
        x08 = x08 + x13 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x08, 7);
        x03 = x03 + x04 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x03, 16);
        x09 = x09 + x14 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x09, 12);
        x03 = x03 + x04 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x03, 8);
        x09 = x09 + x14 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x09, 7);
    }
    // Write output
    let oi = 0;
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $6f8521f1212a85c3$export$81d7140ca2e77b3d(s, k, i, o32) {
    let x00 = s[0], x01 = s[1], x02 = s[2], x03 = s[3], x04 = k[0], x05 = k[1], x06 = k[2], x07 = k[3], x08 = k[4], x09 = k[5], x10 = k[6], x11 = k[7], x12 = i[0], x13 = i[1], x14 = i[2], x15 = i[3];
    for(let r = 0; r < 20; r += 2){
        x00 = x00 + x04 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x00, 16);
        x08 = x08 + x12 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x08, 12);
        x00 = x00 + x04 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x00, 8);
        x08 = x08 + x12 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x08, 7);
        x01 = x01 + x05 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x01, 16);
        x09 = x09 + x13 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x09, 12);
        x01 = x01 + x05 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x01, 8);
        x09 = x09 + x13 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x09, 7);
        x02 = x02 + x06 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x02, 16);
        x10 = x10 + x14 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x10, 12);
        x02 = x02 + x06 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x02, 8);
        x10 = x10 + x14 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x10, 7);
        x03 = x03 + x07 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x03, 16);
        x11 = x11 + x15 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x11, 12);
        x03 = x03 + x07 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x03, 8);
        x11 = x11 + x15 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x11, 7);
        x00 = x00 + x05 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x00, 16);
        x10 = x10 + x15 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x10, 12);
        x00 = x00 + x05 | 0;
        x15 = (0, $jZHN9.rotl)(x15 ^ x00, 8);
        x10 = x10 + x15 | 0;
        x05 = (0, $jZHN9.rotl)(x05 ^ x10, 7);
        x01 = x01 + x06 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x01, 16);
        x11 = x11 + x12 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x11, 12);
        x01 = x01 + x06 | 0;
        x12 = (0, $jZHN9.rotl)(x12 ^ x01, 8);
        x11 = x11 + x12 | 0;
        x06 = (0, $jZHN9.rotl)(x06 ^ x11, 7);
        x02 = x02 + x07 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x02, 16);
        x08 = x08 + x13 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x08, 12);
        x02 = x02 + x07 | 0;
        x13 = (0, $jZHN9.rotl)(x13 ^ x02, 8);
        x08 = x08 + x13 | 0;
        x07 = (0, $jZHN9.rotl)(x07 ^ x08, 7);
        x03 = x03 + x04 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x03, 16);
        x09 = x09 + x14 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x09, 12);
        x03 = x03 + x04 | 0;
        x14 = (0, $jZHN9.rotl)(x14 ^ x03, 8);
        x09 = x09 + x14 | 0;
        x04 = (0, $jZHN9.rotl)(x04 ^ x09, 7);
    }
    let oi = 0;
    o32[oi++] = x00;
    o32[oi++] = x01;
    o32[oi++] = x02;
    o32[oi++] = x03;
    o32[oi++] = x12;
    o32[oi++] = x13;
    o32[oi++] = x14;
    o32[oi++] = x15;
}
const $6f8521f1212a85c3$export$b55a45dabc2febcc = /* @__PURE__ */ (0, $jZHN9.createCipher)($6f8521f1212a85c3$var$chachaCore, {
    counterRight: false,
    counterLength: 8,
    allowShortKeys: true
});
const $6f8521f1212a85c3$export$8e0a42fdbca06555 = /* @__PURE__ */ (0, $jZHN9.createCipher)($6f8521f1212a85c3$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    allowShortKeys: false
});
const $6f8521f1212a85c3$export$f4c63d095e1b0ecd = /* @__PURE__ */ (0, $jZHN9.createCipher)($6f8521f1212a85c3$var$chachaCore, {
    counterRight: false,
    counterLength: 8,
    extendNonceFn: $6f8521f1212a85c3$export$81d7140ca2e77b3d,
    allowShortKeys: false
});
const $6f8521f1212a85c3$export$5da3e887d4315063 = /* @__PURE__ */ (0, $jZHN9.createCipher)($6f8521f1212a85c3$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    rounds: 8
});
const $6f8521f1212a85c3$export$d86f240838b738bc = /* @__PURE__ */ (0, $jZHN9.createCipher)($6f8521f1212a85c3$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    rounds: 12
});
const $6f8521f1212a85c3$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
// Pad to digest size with zeros
const $6f8521f1212a85c3$var$updatePadded = (h, msg)=>{
    h.update(msg);
    const left = msg.length % 16;
    if (left) h.update($6f8521f1212a85c3$var$ZEROS16.subarray(left));
};
const $6f8521f1212a85c3$var$ZEROS32 = /* @__PURE__ */ new Uint8Array(32);
function $6f8521f1212a85c3$var$computeTag(fn, key, nonce, data, AAD) {
    const authKey = fn(key, nonce, $6f8521f1212a85c3$var$ZEROS32);
    const h = (0, $jkfIt.poly1305).create(authKey);
    if (AAD) $6f8521f1212a85c3$var$updatePadded(h, AAD);
    $6f8521f1212a85c3$var$updatePadded(h, data);
    const num = new Uint8Array(16);
    const view = (0, $ltMLs.createView)(num);
    (0, $ltMLs.setBigUint64)(view, 0, BigInt(AAD ? AAD.length : 0), true);
    (0, $ltMLs.setBigUint64)(view, 8, BigInt(data.length), true);
    h.update(num);
    const res = h.digest();
    authKey.fill(0);
    return res;
}
const $6f8521f1212a85c3$export$393d77349b0943d5 = (xorStream)=>(key, nonce, AAD)=>{
        const tagLength = 16;
        (0, $3mYRO.bytes)(key, 32);
        (0, $3mYRO.bytes)(nonce);
        return {
            encrypt: (plaintext, output)=>{
                const plength = plaintext.length;
                const clength = plength + tagLength;
                if (output) (0, $3mYRO.bytes)(output, clength);
                else output = new Uint8Array(clength);
                xorStream(key, nonce, plaintext, output, 1);
                const tag = $6f8521f1212a85c3$var$computeTag(xorStream, key, nonce, output.subarray(0, -tagLength), AAD);
                output.set(tag, plength); // append tag
                return output;
            },
            decrypt: (ciphertext, output)=>{
                const clength = ciphertext.length;
                const plength = clength - tagLength;
                if (clength < tagLength) throw new Error(`encrypted data must be at least ${tagLength} bytes`);
                if (output) (0, $3mYRO.bytes)(output, plength);
                else output = new Uint8Array(plength);
                const data = ciphertext.subarray(0, -tagLength);
                const passedTag = ciphertext.subarray(-tagLength);
                const tag = $6f8521f1212a85c3$var$computeTag(xorStream, key, nonce, data, AAD);
                if (!(0, $ltMLs.equalBytes)(passedTag, tag)) throw new Error("invalid tag");
                xorStream(key, nonce, data, output, 1);
                return output;
            }
        };
    };
const $6f8521f1212a85c3$export$c29357eacf2310e7 = /* @__PURE__ */ (0, $ltMLs.wrapCipher)({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, $6f8521f1212a85c3$export$393d77349b0943d5($6f8521f1212a85c3$export$8e0a42fdbca06555));
const $6f8521f1212a85c3$export$52d6b418bf85cef8 = /* @__PURE__ */ (0, $ltMLs.wrapCipher)({
    blockSize: 64,
    nonceLength: 24,
    tagLength: 16
}, $6f8521f1212a85c3$export$393d77349b0943d5($6f8521f1212a85c3$export$f4c63d095e1b0ecd));

});
parcelRegister("jkfIt", function(module, exports) {

$parcel$export(module.exports, "poly1305", function () { return $e11c137fb102193d$export$7228b37eebb44175; });

var $3mYRO = parcelRequire("3mYRO");

var $ltMLs = parcelRequire("ltMLs");
// Poly1305 is a fast and parallel secret-key message-authentication code.
// https://cr.yp.to/mac.html, https://cr.yp.to/mac/poly1305-20050329.pdf
// https://datatracker.ietf.org/doc/html/rfc8439
// Based on Public Domain poly1305-donna https://github.com/floodyberry/poly1305-donna
const $e11c137fb102193d$var$u8to16 = (a, i)=>a[i++] & 0xff | (a[i++] & 0xff) << 8;
class $e11c137fb102193d$var$Poly1305 {
    constructor(key){
        this.blockLen = 16;
        this.outputLen = 16;
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.pos = 0;
        this.finished = false;
        key = (0, $ltMLs.toBytes)(key);
        (0, $3mYRO.bytes)(key, 32);
        const t0 = $e11c137fb102193d$var$u8to16(key, 0);
        const t1 = $e11c137fb102193d$var$u8to16(key, 2);
        const t2 = $e11c137fb102193d$var$u8to16(key, 4);
        const t3 = $e11c137fb102193d$var$u8to16(key, 6);
        const t4 = $e11c137fb102193d$var$u8to16(key, 8);
        const t5 = $e11c137fb102193d$var$u8to16(key, 10);
        const t6 = $e11c137fb102193d$var$u8to16(key, 12);
        const t7 = $e11c137fb102193d$var$u8to16(key, 14);
        // https://github.com/floodyberry/poly1305-donna/blob/e6ad6e091d30d7f4ec2d4f978be1fcfcbce72781/poly1305-donna-16.h#L47
        this.r[0] = t0 & 0x1fff;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        for(let i = 0; i < 8; i++)this.pad[i] = $e11c137fb102193d$var$u8to16(key, 16 + 2 * i);
    }
    process(data, offset, isLast = false) {
        const hibit = isLast ? 0 : 2048;
        const { h: h, r: r } = this;
        const r0 = r[0];
        const r1 = r[1];
        const r2 = r[2];
        const r3 = r[3];
        const r4 = r[4];
        const r5 = r[5];
        const r6 = r[6];
        const r7 = r[7];
        const r8 = r[8];
        const r9 = r[9];
        const t0 = $e11c137fb102193d$var$u8to16(data, offset + 0);
        const t1 = $e11c137fb102193d$var$u8to16(data, offset + 2);
        const t2 = $e11c137fb102193d$var$u8to16(data, offset + 4);
        const t3 = $e11c137fb102193d$var$u8to16(data, offset + 6);
        const t4 = $e11c137fb102193d$var$u8to16(data, offset + 8);
        const t5 = $e11c137fb102193d$var$u8to16(data, offset + 10);
        const t6 = $e11c137fb102193d$var$u8to16(data, offset + 12);
        const t7 = $e11c137fb102193d$var$u8to16(data, offset + 14);
        let h0 = h[0] + (t0 & 0x1fff);
        let h1 = h[1] + ((t0 >>> 13 | t1 << 3) & 0x1fff);
        let h2 = h[2] + ((t1 >>> 10 | t2 << 6) & 0x1fff);
        let h3 = h[3] + ((t2 >>> 7 | t3 << 9) & 0x1fff);
        let h4 = h[4] + ((t3 >>> 4 | t4 << 12) & 0x1fff);
        let h5 = h[5] + (t4 >>> 1 & 0x1fff);
        let h6 = h[6] + ((t4 >>> 14 | t5 << 2) & 0x1fff);
        let h7 = h[7] + ((t5 >>> 11 | t6 << 5) & 0x1fff);
        let h8 = h[8] + ((t6 >>> 8 | t7 << 8) & 0x1fff);
        let h9 = h[9] + (t7 >>> 5 | hibit);
        let c = 0;
        let d0 = c + h0 * r0 + h1 * (5 * r9) + h2 * (5 * r8) + h3 * (5 * r7) + h4 * (5 * r6);
        c = d0 >>> 13;
        d0 &= 0x1fff;
        d0 += h5 * (5 * r5) + h6 * (5 * r4) + h7 * (5 * r3) + h8 * (5 * r2) + h9 * (5 * r1);
        c += d0 >>> 13;
        d0 &= 0x1fff;
        let d1 = c + h0 * r1 + h1 * r0 + h2 * (5 * r9) + h3 * (5 * r8) + h4 * (5 * r7);
        c = d1 >>> 13;
        d1 &= 0x1fff;
        d1 += h5 * (5 * r6) + h6 * (5 * r5) + h7 * (5 * r4) + h8 * (5 * r3) + h9 * (5 * r2);
        c += d1 >>> 13;
        d1 &= 0x1fff;
        let d2 = c + h0 * r2 + h1 * r1 + h2 * r0 + h3 * (5 * r9) + h4 * (5 * r8);
        c = d2 >>> 13;
        d2 &= 0x1fff;
        d2 += h5 * (5 * r7) + h6 * (5 * r6) + h7 * (5 * r5) + h8 * (5 * r4) + h9 * (5 * r3);
        c += d2 >>> 13;
        d2 &= 0x1fff;
        let d3 = c + h0 * r3 + h1 * r2 + h2 * r1 + h3 * r0 + h4 * (5 * r9);
        c = d3 >>> 13;
        d3 &= 0x1fff;
        d3 += h5 * (5 * r8) + h6 * (5 * r7) + h7 * (5 * r6) + h8 * (5 * r5) + h9 * (5 * r4);
        c += d3 >>> 13;
        d3 &= 0x1fff;
        let d4 = c + h0 * r4 + h1 * r3 + h2 * r2 + h3 * r1 + h4 * r0;
        c = d4 >>> 13;
        d4 &= 0x1fff;
        d4 += h5 * (5 * r9) + h6 * (5 * r8) + h7 * (5 * r7) + h8 * (5 * r6) + h9 * (5 * r5);
        c += d4 >>> 13;
        d4 &= 0x1fff;
        let d5 = c + h0 * r5 + h1 * r4 + h2 * r3 + h3 * r2 + h4 * r1;
        c = d5 >>> 13;
        d5 &= 0x1fff;
        d5 += h5 * r0 + h6 * (5 * r9) + h7 * (5 * r8) + h8 * (5 * r7) + h9 * (5 * r6);
        c += d5 >>> 13;
        d5 &= 0x1fff;
        let d6 = c + h0 * r6 + h1 * r5 + h2 * r4 + h3 * r3 + h4 * r2;
        c = d6 >>> 13;
        d6 &= 0x1fff;
        d6 += h5 * r1 + h6 * r0 + h7 * (5 * r9) + h8 * (5 * r8) + h9 * (5 * r7);
        c += d6 >>> 13;
        d6 &= 0x1fff;
        let d7 = c + h0 * r7 + h1 * r6 + h2 * r5 + h3 * r4 + h4 * r3;
        c = d7 >>> 13;
        d7 &= 0x1fff;
        d7 += h5 * r2 + h6 * r1 + h7 * r0 + h8 * (5 * r9) + h9 * (5 * r8);
        c += d7 >>> 13;
        d7 &= 0x1fff;
        let d8 = c + h0 * r8 + h1 * r7 + h2 * r6 + h3 * r5 + h4 * r4;
        c = d8 >>> 13;
        d8 &= 0x1fff;
        d8 += h5 * r3 + h6 * r2 + h7 * r1 + h8 * r0 + h9 * (5 * r9);
        c += d8 >>> 13;
        d8 &= 0x1fff;
        let d9 = c + h0 * r9 + h1 * r8 + h2 * r7 + h3 * r6 + h4 * r5;
        c = d9 >>> 13;
        d9 &= 0x1fff;
        d9 += h5 * r4 + h6 * r3 + h7 * r2 + h8 * r1 + h9 * r0;
        c += d9 >>> 13;
        d9 &= 0x1fff;
        c = (c << 2) + c | 0;
        c = c + d0 | 0;
        d0 = c & 0x1fff;
        c = c >>> 13;
        d1 += c;
        h[0] = d0;
        h[1] = d1;
        h[2] = d2;
        h[3] = d3;
        h[4] = d4;
        h[5] = d5;
        h[6] = d6;
        h[7] = d7;
        h[8] = d8;
        h[9] = d9;
    }
    finalize() {
        const { h: h, pad: pad } = this;
        const g = new Uint16Array(10);
        let c = h[1] >>> 13;
        h[1] &= 0x1fff;
        for(let i = 2; i < 10; i++){
            h[i] += c;
            c = h[i] >>> 13;
            h[i] &= 0x1fff;
        }
        h[0] += c * 5;
        c = h[0] >>> 13;
        h[0] &= 0x1fff;
        h[1] += c;
        c = h[1] >>> 13;
        h[1] &= 0x1fff;
        h[2] += c;
        g[0] = h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(let i = 1; i < 10; i++){
            g[i] = h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        let mask = (c ^ 1) - 1;
        for(let i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(let i = 0; i < 10; i++)h[i] = h[i] & mask | g[i];
        h[0] = (h[0] | h[1] << 13) & 0xffff;
        h[1] = (h[1] >>> 3 | h[2] << 10) & 0xffff;
        h[2] = (h[2] >>> 6 | h[3] << 7) & 0xffff;
        h[3] = (h[3] >>> 9 | h[4] << 4) & 0xffff;
        h[4] = (h[4] >>> 12 | h[5] << 1 | h[6] << 14) & 0xffff;
        h[5] = (h[6] >>> 2 | h[7] << 11) & 0xffff;
        h[6] = (h[7] >>> 5 | h[8] << 8) & 0xffff;
        h[7] = (h[8] >>> 8 | h[9] << 5) & 0xffff;
        let f = h[0] + pad[0];
        h[0] = f & 0xffff;
        for(let i = 1; i < 8; i++){
            f = (h[i] + pad[i] | 0) + (f >>> 16) | 0;
            h[i] = f & 0xffff;
        }
    }
    update(data) {
        (0, $3mYRO.exists)(this);
        const { buffer: buffer, blockLen: blockLen } = this;
        data = (0, $ltMLs.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input
            if (take === blockLen) {
                for(; blockLen <= len - pos; pos += blockLen)this.process(data, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(buffer, 0, false);
                this.pos = 0;
            }
        }
        return this;
    }
    destroy() {
        this.h.fill(0);
        this.r.fill(0);
        this.buffer.fill(0);
        this.pad.fill(0);
    }
    digestInto(out) {
        (0, $3mYRO.exists)(this);
        (0, $3mYRO.output)(out, this);
        this.finished = true;
        const { buffer: buffer, h: h } = this;
        let { pos: pos } = this;
        if (pos) {
            buffer[pos++] = 1;
            // buffer.subarray(pos).fill(0);
            for(; pos < 16; pos++)buffer[pos] = 0;
            this.process(buffer, 0, true);
        }
        this.finalize();
        let opos = 0;
        for(let i = 0; i < 8; i++){
            out[opos++] = h[i] >>> 0;
            out[opos++] = h[i] >>> 8;
        }
        return out;
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
}
function $e11c137fb102193d$export$1fd745bcb2f0b7a8(hashCons) {
    const hashC = (msg, key)=>hashCons(key).update((0, $ltMLs.toBytes)(msg)).digest();
    const tmp = hashCons(new Uint8Array(32));
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key)=>hashCons(key);
    return hashC;
}
const $e11c137fb102193d$export$7228b37eebb44175 = $e11c137fb102193d$export$1fd745bcb2f0b7a8((key)=>new $e11c137fb102193d$var$Poly1305(key));

});

parcelRegister("jZHN9", function(module, exports) {

$parcel$export(module.exports, "rotl", function () { return $e8e5aeef86cc6753$export$ac5e39599698b562; });
$parcel$export(module.exports, "createCipher", function () { return $e8e5aeef86cc6753$export$bdd223f16383713e; });
// Basic utils for ARX (add-rotate-xor) salsa and chacha ciphers.

var $3mYRO = parcelRequire("3mYRO");

var $ltMLs = parcelRequire("ltMLs");
/*
RFC8439 requires multi-step cipher stream, where
authKey starts with counter: 0, actual msg with counter: 1.

For this, we need a way to re-use nonce / counter:

    const counter = new Uint8Array(4);
    chacha(..., counter, ...); // counter is now 1
    chacha(..., counter, ...); // counter is now 2

This is complicated:

- 32-bit counters are enough, no need for 64-bit: max ArrayBuffer size in JS is 4GB
- Original papers don't allow mutating counters
- Counter overflow is undefined [^1]
- Idea A: allow providing (nonce | counter) instead of just nonce, re-use it
- Caveat: Cannot be re-used through all cases:
- * chacha has (counter | nonce)
- * xchacha has (nonce16 | counter | nonce16)
- Idea B: separate nonce / counter and provide separate API for counter re-use
- Caveat: there are different counter sizes depending on an algorithm.
- salsa & chacha also differ in structures of key & sigma:
  salsa20:      s[0] | k(4) | s[1] | nonce(2) | ctr(2) | s[2] | k(4) | s[3]
  chacha:       s(4) | k(8) | ctr(1) | nonce(3)
  chacha20orig: s(4) | k(8) | ctr(2) | nonce(2)
- Idea C: helper method such as `setSalsaState(key, nonce, sigma, data)`
- Caveat: we can't re-use counter array

xchacha [^2] uses the subkey and remaining 8 byte nonce with ChaCha20 as normal
(prefixed by 4 NUL bytes, since [RFC8439] specifies a 12-byte nonce).

[^1]: https://mailarchive.ietf.org/arch/msg/cfrg/gsOnTJzcbgG6OqD8Sc0GO5aR_tU/
[^2]: https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-xchacha#appendix-A.2
*/ // We can't make top-level var depend on utils.utf8ToBytes
// because it's not present in all envs. Creating a similar fn here
const $e8e5aeef86cc6753$var$_utf8ToBytes = (str)=>Uint8Array.from(str.split("").map((c)=>c.charCodeAt(0)));
const $e8e5aeef86cc6753$var$sigma16 = $e8e5aeef86cc6753$var$_utf8ToBytes("expand 16-byte k");
const $e8e5aeef86cc6753$var$sigma32 = $e8e5aeef86cc6753$var$_utf8ToBytes("expand 32-byte k");
const $e8e5aeef86cc6753$var$sigma16_32 = (0, $ltMLs.u32)($e8e5aeef86cc6753$var$sigma16);
const $e8e5aeef86cc6753$var$sigma32_32 = (0, $ltMLs.u32)($e8e5aeef86cc6753$var$sigma32);
const $e8e5aeef86cc6753$export$7c54ac83b7882e76 = $e8e5aeef86cc6753$var$sigma32_32.slice();
function $e8e5aeef86cc6753$export$ac5e39599698b562(a, b) {
    return a << b | a >>> 32 - b;
}
// Is byte array aligned to 4 byte offset (u32)?
function $e8e5aeef86cc6753$var$isAligned32(b) {
    return b.byteOffset % 4 === 0;
}
// Salsa and Chacha block length is always 512-bit
const $e8e5aeef86cc6753$var$BLOCK_LEN = 64;
const $e8e5aeef86cc6753$var$BLOCK_LEN32 = 16;
// new Uint32Array([2**32])   // => Uint32Array(1) [ 0 ]
// new Uint32Array([2**32-1]) // => Uint32Array(1) [ 4294967295 ]
const $e8e5aeef86cc6753$var$MAX_COUNTER = 2 ** 32 - 1;
const $e8e5aeef86cc6753$var$U32_EMPTY = new Uint32Array();
function $e8e5aeef86cc6753$var$runCipher(core, sigma, key, nonce, data, output, counter, rounds) {
    const len = data.length;
    const block = new Uint8Array($e8e5aeef86cc6753$var$BLOCK_LEN);
    const b32 = (0, $ltMLs.u32)(block);
    // Make sure that buffers aligned to 4 bytes
    const isAligned = $e8e5aeef86cc6753$var$isAligned32(data) && $e8e5aeef86cc6753$var$isAligned32(output);
    const d32 = isAligned ? (0, $ltMLs.u32)(data) : $e8e5aeef86cc6753$var$U32_EMPTY;
    const o32 = isAligned ? (0, $ltMLs.u32)(output) : $e8e5aeef86cc6753$var$U32_EMPTY;
    for(let pos = 0; pos < len; counter++){
        core(sigma, key, nonce, b32, counter, rounds);
        if (counter >= $e8e5aeef86cc6753$var$MAX_COUNTER) throw new Error("arx: counter overflow");
        const take = Math.min($e8e5aeef86cc6753$var$BLOCK_LEN, len - pos);
        // aligned to 4 bytes
        if (isAligned && take === $e8e5aeef86cc6753$var$BLOCK_LEN) {
            const pos32 = pos / 4;
            if (pos % 4 !== 0) throw new Error("arx: invalid block position");
            for(let j = 0, posj; j < $e8e5aeef86cc6753$var$BLOCK_LEN32; j++){
                posj = pos32 + j;
                o32[posj] = d32[posj] ^ b32[j];
            }
            pos += $e8e5aeef86cc6753$var$BLOCK_LEN;
            continue;
        }
        for(let j = 0, posj; j < take; j++){
            posj = pos + j;
            output[posj] = data[posj] ^ block[j];
        }
        pos += take;
    }
}
function $e8e5aeef86cc6753$export$bdd223f16383713e(core, opts) {
    const { allowShortKeys: allowShortKeys, extendNonceFn: extendNonceFn, counterLength: counterLength, counterRight: counterRight, rounds: rounds } = (0, $ltMLs.checkOpts)({
        allowShortKeys: false,
        counterLength: 8,
        counterRight: false,
        rounds: 20
    }, opts);
    if (typeof core !== "function") throw new Error("core must be a function");
    (0, $3mYRO.number)(counterLength);
    (0, $3mYRO.number)(rounds);
    (0, $3mYRO.bool)(counterRight);
    (0, $3mYRO.bool)(allowShortKeys);
    return (key, nonce, data, output, counter = 0)=>{
        (0, $3mYRO.bytes)(key);
        (0, $3mYRO.bytes)(nonce);
        (0, $3mYRO.bytes)(data);
        const len = data.length;
        if (!output) output = new Uint8Array(len);
        (0, $3mYRO.bytes)(output);
        (0, $3mYRO.number)(counter);
        if (counter < 0 || counter >= $e8e5aeef86cc6753$var$MAX_COUNTER) throw new Error("arx: counter overflow");
        if (output.length < len) throw new Error(`arx: output (${output.length}) is shorter than data (${len})`);
        const toClean = [];
        // Key & sigma
        // key=16 -> sigma16, k=key|key
        // key=32 -> sigma32, k=key
        let l = key.length, k, sigma;
        if (l === 32) {
            k = key.slice();
            toClean.push(k);
            sigma = $e8e5aeef86cc6753$var$sigma32_32;
        } else if (l === 16 && allowShortKeys) {
            k = new Uint8Array(32);
            k.set(key);
            k.set(key, 16);
            sigma = $e8e5aeef86cc6753$var$sigma16_32;
            toClean.push(k);
        } else throw new Error(`arx: invalid 32-byte key, got length=${l}`);
        // Nonce
        // salsa20:      8   (8-byte counter)
        // chacha20orig: 8   (8-byte counter)
        // chacha20:     12  (4-byte counter)
        // xsalsa20:     24  (16 -> hsalsa,  8 -> old nonce)
        // xchacha20:    24  (16 -> hchacha, 8 -> old nonce)
        // Align nonce to 4 bytes
        if (!$e8e5aeef86cc6753$var$isAligned32(nonce)) {
            nonce = nonce.slice();
            toClean.push(nonce);
        }
        const k32 = (0, $ltMLs.u32)(k);
        // hsalsa & hchacha: handle extended nonce
        if (extendNonceFn) {
            if (nonce.length !== 24) throw new Error(`arx: extended nonce must be 24 bytes`);
            extendNonceFn(sigma, k32, (0, $ltMLs.u32)(nonce.subarray(0, 16)), k32);
            nonce = nonce.subarray(16);
        }
        // Handle nonce counter
        const nonceNcLen = 16 - counterLength;
        if (nonceNcLen !== nonce.length) throw new Error(`arx: nonce must be ${nonceNcLen} or 16 bytes`);
        // Pad counter when nonce is 64 bit
        if (nonceNcLen !== 12) {
            const nc = new Uint8Array(12);
            nc.set(nonce, counterRight ? 0 : 12 - nonce.length);
            nonce = nc;
            toClean.push(nonce);
        }
        const n32 = (0, $ltMLs.u32)(nonce);
        $e8e5aeef86cc6753$var$runCipher(core, sigma, k32, n32, data, output, counter, rounds);
        while(toClean.length > 0)toClean.pop().fill(0);
        return output;
    };
}

});


parcelRegister("b24L2", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $808392657deaec00$export$f9380c9a627682d3; });
$parcel$export(module.exports, "expand", function () { return $808392657deaec00$export$9f77e0932fb78f72; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");

var $9KVQy = parcelRequire("9KVQy");
function $808392657deaec00$export$f9380c9a627682d3(hash, ikm, salt) {
    (0, $kW2j6.default).hash(hash);
    // NOTE: some libraries treat zero-length array as 'not provided';
    // we don't, since we have undefined as 'not provided'
    // https://github.com/RustCrypto/KDFs/issues/15
    if (salt === undefined) salt = new Uint8Array(hash.outputLen); // if not provided, it is set to a string of HashLen zeros
    return (0, $9KVQy.hmac)(hash, (0, $9mdbq.toBytes)(salt), (0, $9mdbq.toBytes)(ikm));
}
// HKDF-Expand(PRK, info, L) -> OKM
const $808392657deaec00$var$HKDF_COUNTER = new Uint8Array([
    0
]);
const $808392657deaec00$var$EMPTY_BUFFER = new Uint8Array();
function $808392657deaec00$export$9f77e0932fb78f72(hash, prk, info, length = 32) {
    (0, $kW2j6.default).hash(hash);
    (0, $kW2j6.default).number(length);
    if (length > 255 * hash.outputLen) throw new Error("Length should be <= 255*HashLen");
    const blocks = Math.ceil(length / hash.outputLen);
    if (info === undefined) info = $808392657deaec00$var$EMPTY_BUFFER;
    // first L(ength) octets of T
    const okm = new Uint8Array(blocks * hash.outputLen);
    // Re-use HMAC instance between blocks
    const HMAC = (0, $9KVQy.hmac).create(hash, prk);
    const HMACTmp = HMAC._cloneInto();
    const T = new Uint8Array(HMAC.outputLen);
    for(let counter = 0; counter < blocks; counter++){
        $808392657deaec00$var$HKDF_COUNTER[0] = counter + 1;
        // T(0) = empty string (zero length)
        // T(N) = HMAC-Hash(PRK, T(N-1) | info | N)
        HMACTmp.update(counter === 0 ? $808392657deaec00$var$EMPTY_BUFFER : T).update(info).update($808392657deaec00$var$HKDF_COUNTER).digestInto(T);
        okm.set(T, hash.outputLen * counter);
        HMAC._cloneInto(HMACTmp);
    }
    HMAC.destroy();
    HMACTmp.destroy();
    T.fill(0);
    $808392657deaec00$var$HKDF_COUNTER.fill(0);
    return okm.slice(0, length);
}
const $808392657deaec00$export$223341ca60fa42e2 = (hash, ikm, salt, info, length)=>$808392657deaec00$export$9f77e0932fb78f72(hash, $808392657deaec00$export$f9380c9a627682d3(hash, ikm, salt), info, length);

});
parcelRegister("9KVQy", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $71a54815d4b0fbfc$export$355af40f8ab02f34; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");
class $71a54815d4b0fbfc$export$7b9cf41ebec74f45 extends (0, $9mdbq.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $kW2j6.default).hash(hash);
        const key = (0, $9mdbq.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $kW2j6.default).exists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $kW2j6.default).exists(this);
        (0, $kW2j6.default).bytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $71a54815d4b0fbfc$export$355af40f8ab02f34 = (hash, key, message)=>new $71a54815d4b0fbfc$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$71a54815d4b0fbfc$export$355af40f8ab02f34.create = (hash, key)=>new $71a54815d4b0fbfc$export$7b9cf41ebec74f45(hash, key);

});



function $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $a85fd1efd23057e0$var$id = 0;
function $a85fd1efd23057e0$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $a85fd1efd23057e0$var$id++ + "_" + e;
}
// We're using a generic because languages have different plural rules.
// eslint-disable-next-line no-use-before-define
function $a85fd1efd23057e0$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== "string") return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== "") newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $a85fd1efd23057e0$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = "$$$$";
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== "_") {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === "string") replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $a85fd1efd23057e0$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
    return interpolated;
}
const $a85fd1efd23057e0$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $a85fd1efd23057e0$var$_onMissingKey = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("onMissingKey");
var $a85fd1efd23057e0$var$_apply = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("apply");
class $a85fd1efd23057e0$export$2e2bcd8739ae039 {
    constructor(locales, _temp){
        let { onMissingKey: onMissingKey = $a85fd1efd23057e0$var$defaultOnMissingKey } = _temp === void 0 ? {} : _temp;
        Object.defineProperty(this, $a85fd1efd23057e0$var$_apply, {
            value: $a85fd1efd23057e0$var$_apply2
        });
        Object.defineProperty(this, $a85fd1efd23057e0$var$_onMissingKey, {
            writable: true,
            value: void 0
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply], this);
        else $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply](locales);
        $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey] = onMissingKey;
    }
    /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join("");
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey](key);
            string = key;
        }
        const hasPluralForms = typeof string === "object";
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== "undefined") {
                const plural = this.locale.pluralize(options.smart_count);
                return $a85fd1efd23057e0$var$interpolate(string[plural], options);
            }
            throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
        }
        if (typeof string !== "string") throw new Error(`string was not a string`);
        return $a85fd1efd23057e0$var$interpolate(string, options);
    }
}
function $a85fd1efd23057e0$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    Object.assign(this.locale, {
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        },
        pluralize: locale.pluralize || prevLocale.pluralize
    });
}


var $1713863f3a962559$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $1713863f3a962559$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(":");
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === "*") out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


/* @ts-self-types="./index.d.ts" */ let $af5278daf92376ec$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $af5278daf92376ec$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $af5278daf92376ec$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size | 0;
    while(i--)id += $af5278daf92376ec$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $a50c1ad1c2867517$exports = {};
var $8284bc2b60dc4bc4$exports = {};
var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


var $1c50bd4ee78fb504$exports = {};
var $67910ad3df1b1086$exports = {};
var $fb170ba8a9c2191f$exports = {};
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$fb170ba8a9c2191f$exports = $fb170ba8a9c2191f$var$freeGlobal;


/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $fb170ba8a9c2191f$exports || $67910ad3df1b1086$var$freeSelf || Function("return this")();
$67910ad3df1b1086$exports = $67910ad3df1b1086$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c50bd4ee78fb504$var$now = function() {
    return $67910ad3df1b1086$exports.Date.now();
};
$1c50bd4ee78fb504$exports = $1c50bd4ee78fb504$var$now;


var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, "") : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $67910ad3df1b1086$exports.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Error message constants. */ var $8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8284bc2b60dc4bc4$var$nativeMax = Math.max, $8284bc2b60dc4bc4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8284bc2b60dc4bc4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT);
    wait = $e588870a06e690e1$exports(wait) || 0;
    if ($db5dfd0661742a1a$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $8284bc2b60dc4bc4$var$nativeMax($e588870a06e690e1$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8284bc2b60dc4bc4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c50bd4ee78fb504$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c50bd4ee78fb504$exports());
    }
    function debounced() {
        var time = $1c50bd4ee78fb504$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8284bc2b60dc4bc4$exports = $8284bc2b60dc4bc4$var$debounce;



/** Error message constants. */ var $a50c1ad1c2867517$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a50c1ad1c2867517$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($a50c1ad1c2867517$var$FUNC_ERROR_TEXT);
    if ($db5dfd0661742a1a$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $8284bc2b60dc4bc4$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$a50c1ad1c2867517$exports = $a50c1ad1c2867517$var$throttle;


function $f790bad313c52a0f$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $f790bad313c52a0f$var$id = 0;
function $f790bad313c52a0f$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $f790bad313c52a0f$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f790bad313c52a0f$var$packageJson = {
    "version": "4.2.0"
};
var $f790bad313c52a0f$var$_callbacks = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("callbacks");
var $f790bad313c52a0f$var$_publish = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("publish");
/**
 * Default store that keeps state in a simple object.
 */ class $f790bad313c52a0f$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $f790bad313c52a0f$var$_publish, {
            value: $f790bad313c52a0f$var$_publish2
        });
        this.state = {};
        Object.defineProperty(this, $f790bad313c52a0f$var$_callbacks, {
            writable: true,
            value: new Set()
        });
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_publish)[$f790bad313c52a0f$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].add(listener);
        return ()=>{
            $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].delete(listener);
        };
    }
}
function $f790bad313c52a0f$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].forEach((listener)=>{
        listener(...args);
    });
}
$f790bad313c52a0f$var$DefaultStore.VERSION = $f790bad313c52a0f$var$packageJson.version;
var $f790bad313c52a0f$export$2e2bcd8739ae039 = $f790bad313c52a0f$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $09afbe8d004816d5$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf(".");
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $92507ee89880573c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: "text/markdown",
    markdown: "text/markdown",
    mp4: "video/mp4",
    mp3: "audio/mp3",
    svg: "image/svg+xml",
    jpg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
    gif: "image/gif",
    heic: "image/heic",
    heif: "image/heif",
    yaml: "text/yaml",
    yml: "text/yaml",
    csv: "text/csv",
    tsv: "text/tab-separated-values",
    tab: "text/tab-separated-values",
    avi: "video/x-msvideo",
    mks: "video/x-matroska",
    mkv: "video/x-matroska",
    mov: "video/quicktime",
    dicom: "application/dicom",
    doc: "application/msword",
    msg: "application/vnd.ms-outlook",
    docm: "application/vnd.ms-word.document.macroenabled.12",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    dot: "application/msword",
    dotm: "application/vnd.ms-word.template.macroenabled.12",
    dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    xla: "application/vnd.ms-excel",
    xlam: "application/vnd.ms-excel.addin.macroenabled.12",
    xlc: "application/vnd.ms-excel",
    xlf: "application/x-xliff+xml",
    xlm: "application/vnd.ms-excel",
    xls: "application/vnd.ms-excel",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xlt: "application/vnd.ms-excel",
    xltm: "application/vnd.ms-excel.template.macroenabled.12",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    xlw: "application/vnd.ms-excel",
    txt: "text/plain",
    text: "text/plain",
    conf: "text/plain",
    log: "text/plain",
    pdf: "application/pdf",
    zip: "application/zip",
    "7z": "application/x-7z-compressed",
    rar: "application/x-rar-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
    dmg: "application/x-apple-diskimage"
};


function $d70a5ddc0e61f36b$export$2e2bcd8739ae039(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $92507ee89880573c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return "application/octet-stream";
}




function $d67267bb9859462b$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $d67267bb9859462b$var$encodeFilename(name) {
    let suffix = "";
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$d67267bb9859462b$var$encodeCharacter(character)}`;
        return "/";
    }) + suffix;
}
function $d67267bb9859462b$export$2e2bcd8739ae039(file, instanceId) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = instanceId || "uppy";
    if (typeof file.name === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $d67267bb9859462b$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        "box",
        "dropbox",
        "drive",
        "facebook",
        "unsplash"
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $d67267bb9859462b$export$2ff5b23440673856(file, instanceId) {
    if ($d67267bb9859462b$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    return $d67267bb9859462b$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    }, instanceId);
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $d0281443a9bf1cf1$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== "undefined") // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split(".", 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


function $77bbd1edc6b4e0f3$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split("/")[0] === "image") return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
    return "noname";
}


/* eslint-disable no-console */ /**
 * Adds zero to strings shorter than two characters.
 */ function $cd89119ba1e2ad9d$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $cd89119ba1e2ad9d$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $cd89119ba1e2ad9d$var$pad(date.getHours());
    const minutes = $cd89119ba1e2ad9d$var$pad(date.getMinutes());
    const seconds = $cd89119ba1e2ad9d$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $b03b26a8a191c595$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $b03b26a8a191c595$export$e6a390ea6399b7d8 = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};


/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ var $06e80194017bcce5$exports = {};
"use strict";
$06e80194017bcce5$exports = function prettierBytes(input) {
    if (typeof input !== "number" || Number.isNaN(input)) throw new TypeError(`Expected a number, got ${typeof input}`);
    const neg = input < 0;
    let num = Math.abs(input);
    if (neg) num = -num;
    if (num === 0) return "0 B";
    const units = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    const value = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    return `${value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1)} ${unit}`;
};


var $34b5d77a3aae6147$exports = {};
var $bf27c8b296b096af$exports = {};
/* jshint node: true */ "use strict";
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $bf27c8b296b096af$var$WildcardMatcher(text, separator) {
    this.text = text = text || "";
    this.hasWild = ~text.indexOf("*");
    this.separator = separator;
    this.parts = text.split(separator);
}
$bf27c8b296b096af$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || "").split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === "*") continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == "function") {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == "object") {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$bf27c8b296b096af$exports = function(text, test, separator) {
    var matcher = new $bf27c8b296b096af$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != "undefined") return matcher.match(test);
    return matcher;
};


var $34b5d77a3aae6147$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $34b5d77a3aae6147$exports = function(target, pattern) {
    function test(pattern) {
        var result = $bf27c8b296b096af$exports(pattern, target, $34b5d77a3aae6147$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(";")[0]) : test;
};


/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */ const $3044940369c0f03d$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $3044940369c0f03d$export$e4d147272ce048a7 extends Error {
    constructor(message, opts){
        var _opts$isUserFacing;
        super(message);
        this.isRestriction = true;
        this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
        if (opts != null && opts.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
}
class $3044940369c0f03d$export$c464a380a24dd3b8 {
    constructor(getOpts, getI18n){
        this.getI18n = getI18n;
        this.getOpts = ()=>{
            var _opts$restrictions;
            const opts = getOpts();
            if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(`${this.getI18n()("youCanOnlyUploadX", {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            const totalFilesSize = [
                ...existingFiles,
                ...addingFiles
            ].reduce((total, f)=>{
                var _f$size;
                return total + ((_f$size = f.size) != null ? _f$size : 0);
            }, 0);
            if (totalFilesSize > maxTotalFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("aggregateExceedsSize", {
                sizeAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxTotalFileSize),
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalFilesSize)
            }));
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes("/")) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($34b5d77a3aae6147$exports)))(file.type.replace(/;.*?$/, ""), type);
                }
                // otherwise this is likely an extension
                if (type[0] === "." && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(", ");
                throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("youCanOnlyUploadFileTypes", {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) {
            var _file$name;
            throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("exceedsSize", {
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxFileSize),
                file: (_file$name = file.name) != null ? _file$name : this.getI18n()("unnamed")
            }), {
                file: file
            });
        }
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("inferiorSize", {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("youHaveToAtLeastSelectX", {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        var _file$name2;
        const error = new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("missingRequiredMetaFieldOnFile", {
            fileName: (_file$name2 = file.name) != null ? _file$name2 : this.getI18n()("unnamed")
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === "") missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


var $721644b39e57ffe9$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: "Failed to add %{smart_count} file due to an internal error",
            1: "Failed to add %{smart_count} files due to internal errors"
        },
        youCanOnlyUploadX: {
            0: "You can only upload %{smart_count} file",
            1: "You can only upload %{smart_count} files"
        },
        youHaveToAtLeastSelectX: {
            0: "You have to select at least %{smart_count} file",
            1: "You have to select at least %{smart_count} files"
        },
        aggregateExceedsSize: "You selected %{size} of files, but maximum allowed size is %{sizeAllowed}",
        exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
        missingRequiredMetaField: "Missing required meta fields",
        missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
        inferiorSize: "This file is smaller than the allowed size of %{size}",
        youCanOnlyUploadFileTypes: "You can only upload: %{types}",
        noMoreFilesAllowed: "Cannot add more files",
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: "Connection with Companion failed",
        authAborted: "Authentication aborted",
        companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
        failedToUpload: "Failed to upload %{file}",
        noInternetConnection: "No Internet connection",
        connectedToInternet: "Connected to the Internet",
        // Strings for remote providers
        noFilesFound: "You have no files or folders here",
        noSearchResults: "Unfortunately, there are no results for this search",
        selectX: {
            0: "Select %{smart_count}",
            1: "Select %{smart_count}"
        },
        allFilesFromFolderNamed: "All files from folder %{name}",
        openFolderNamed: "Open folder %{name}",
        cancel: "Cancel",
        logOut: "Log out",
        logIn: "Log in",
        pickFiles: "Pick files",
        pickPhotos: "Pick photos",
        filter: "Filter",
        resetFilter: "Reset filter",
        loading: "Loading...",
        loadedXFiles: "Loaded %{numFiles} files",
        authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
        authenticateWith: "Connect to %{pluginName}",
        signInWithGoogle: "Sign in with Google",
        searchImages: "Search for images",
        enterTextToSearch: "Enter text to search for images",
        search: "Search",
        resetSearch: "Reset search",
        emptyFolderAdded: "No files were added from empty folder",
        addedNumFiles: "Added %{numFiles} file(s)",
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: "Added %{smart_count} file from %{folder}",
            1: "Added %{smart_count} files from %{folder}"
        },
        additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled",
        unnamed: "Unnamed",
        pleaseWait: "Please wait"
    }
};


function $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $b16b91c7840d3bff$var$id = 0;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $b16b91c7840d3bff$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b16b91c7840d3bff$var$packageJson = {
    "version": "4.4.4"
};
/**
 * ids are always `string`s, except the root folder's id can be `null`
 */ /**
 * PartialTree has the following structure.
 *
 *           FolderRoot
 *         ┌─────┴─────┐
 *     FolderNode     File
 *   ┌─────┴────┐
 *  File      File
 *
 * Root folder is called `PartialTreeFolderRoot`,
 * all other folders are called `PartialTreeFolderNode`, because they are "internal nodes".
 *
 * It's possible for `PartialTreeFolderNode` to be a leaf node if it doesn't contain any files.
 */ /**
 * This is a base for a provider that does not necessarily use the Companion-assisted OAuth2 flow
 */ /*
 * UnknownProviderPlugin can be any Companion plugin (such as Google Drive)
 * that uses the Companion-assisted OAuth flow.
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `storage`
 * will error in the `Provider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `Provider` class.
 * `Provider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ /*
 * UnknownSearchProviderPlugin can be any search Companion plugin (such as Unsplash).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `title`
 * will error in the `SearchProvider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `SearchProvider` class.
 * `SearchProvider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ // TODO: can we use namespaces in other plugins to populate this?
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// The user facing type for UppyOptions used in uppy.setOptions()
/** `OmitFirstArg<typeof someArray>` is the type of the returned value of `someArray.slice(1)`. */ const $b16b91c7840d3bff$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $b16b91c7840d3bff$var$_plugins = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("plugins");
var $b16b91c7840d3bff$var$_restricter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("restricter");
var $b16b91c7840d3bff$var$_storeUnsubscribe = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $b16b91c7840d3bff$var$_emitter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("emitter");
var $b16b91c7840d3bff$var$_preProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("preProcessors");
var $b16b91c7840d3bff$var$_uploaders = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("uploaders");
var $b16b91c7840d3bff$var$_postProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("postProcessors");
var $b16b91c7840d3bff$var$_informAndEmit = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("informAndEmit");
var $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $b16b91c7840d3bff$var$_checkRequiredMetaFields = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $b16b91c7840d3bff$var$_assertNewUploadAllowed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $b16b91c7840d3bff$var$_transformFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("transformFile");
var $b16b91c7840d3bff$var$_startIfAutoProceed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $b16b91c7840d3bff$var$_checkAndUpdateFileState = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkAndUpdateFileState");
var $b16b91c7840d3bff$var$_getFilesToRetry = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getFilesToRetry");
var $b16b91c7840d3bff$var$_doRetryAll = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("doRetryAll");
var $b16b91c7840d3bff$var$_handleUploadProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("handleUploadProgress");
var $b16b91c7840d3bff$var$_updateTotalProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateTotalProgress");
var $b16b91c7840d3bff$var$_updateTotalProgressThrottled = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateTotalProgressThrottled");
var $b16b91c7840d3bff$var$_calculateTotalProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("calculateTotalProgress");
var $b16b91c7840d3bff$var$_addListeners = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("addListeners");
var $b16b91c7840d3bff$var$_updateOnlineStatus = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $b16b91c7840d3bff$var$_requestClientById = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("requestClientById");
var $b16b91c7840d3bff$var$_createUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("createUpload");
var $b16b91c7840d3bff$var$_getUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getUpload");
var $b16b91c7840d3bff$var$_removeUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("removeUpload");
var $b16b91c7840d3bff$var$_runUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("runUpload");
class $b16b91c7840d3bff$export$1c95bea2669f592b {
    /**
   * Instantiate Uppy
   */ constructor(_opts){
        /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_runUpload, {
            value: $b16b91c7840d3bff$var$_runUpload2
        });
        /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_removeUpload, {
            value: $b16b91c7840d3bff$var$_removeUpload2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getUpload, {
            value: $b16b91c7840d3bff$var$_getUpload2
        });
        /**
     * Create an upload for a bunch of files.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_createUpload, {
            value: $b16b91c7840d3bff$var$_createUpload2
        });
        /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_addListeners, {
            value: $b16b91c7840d3bff$var$_addListeners2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_calculateTotalProgress, {
            value: $b16b91c7840d3bff$var$_calculateTotalProgress2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateTotalProgress, {
            value: $b16b91c7840d3bff$var$_updateTotalProgress2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_doRetryAll, {
            value: $b16b91c7840d3bff$var$_doRetryAll2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getFilesToRetry, {
            value: $b16b91c7840d3bff$var$_getFilesToRetry2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState, {
            value: $b16b91c7840d3bff$var$_checkAndUpdateFileState2
        });
        // Schedule an upload if `autoProceed` is enabled.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_startIfAutoProceed, {
            value: $b16b91c7840d3bff$var$_startIfAutoProceed2
        });
        /**
     * Create a file state object based on user-provided `addFile()` options.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_transformFile, {
            value: $b16b91c7840d3bff$var$_transformFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed, {
            value: $b16b91c7840d3bff$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_informAndEmit, {
            value: $b16b91c7840d3bff$var$_informAndEmit2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_emitter, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1713863f3a962559$exports)))()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        this.scheduledAutoProceed = null;
        this.wasOffline = false;
        Object.defineProperty(this, $b16b91c7840d3bff$var$_handleUploadProgress, {
            writable: true,
            value: (file, progress)=>{
                const fileInState = file ? this.getFile(file.id) : undefined;
                if (file == null || !fileInState) {
                    this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
                    return;
                }
                if (fileInState.progress.percentage === 100) {
                    this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
                    return;
                }
                const newProgress = {
                    bytesTotal: progress.bytesTotal,
                    // bytesTotal may be null or zero; in that case we can't divide by it
                    percentage: progress.bytesTotal != null && Number.isFinite(progress.bytesTotal) && progress.bytesTotal > 0 ? Math.round(progress.bytesUploaded / progress.bytesTotal * 100) : undefined
                };
                if (fileInState.progress.uploadStarted != null) this.setFileState(file.id, {
                    progress: {
                        ...fileInState.progress,
                        ...newProgress,
                        bytesUploaded: progress.bytesUploaded
                    }
                });
                else this.setFileState(file.id, {
                    progress: {
                        ...fileInState.progress,
                        ...newProgress
                    }
                });
                $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
            }
        });
        // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($a50c1ad1c2867517$exports)))(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgress)[$b16b91c7840d3bff$var$_updateTotalProgress](), 500, {
                leading: true,
                trailing: true
            })
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        // We need to store request clients by a unique ID, so we can share RequestClient instances across files
        // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
        // example: refreshing tokens: if each file has their own requestclient,
        // we don't have any way to synchronize all requests in order to
        // - block all requests
        // - refresh the token
        // - unblock all requests and allow them to run with a the new access token
        // back when we had a requestclient per file, once an access token expired,
        // all 6 files would go ahead and refresh the token at the same time
        // (calling /refresh-token up to 6 times), which will probably fail for some providers
        Object.defineProperty(this, $b16b91c7840d3bff$var$_requestClientById, {
            writable: true,
            value: new Map()
        });
        this.defaultLocale = (0, $721644b39e57ffe9$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: "uppy",
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $3044940369c0f03d$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $f790bad313c52a0f$export$2e2bcd8739ae039)(),
            logger: (0, $b03b26a8a191c595$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ..._opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
        else if (_opts && _opts.debug) this.opts.logger = (0, $b03b26a8a191c595$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $d0281443a9bf1cf1$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter] = new (0, $3044940369c0f03d$export$c464a380a24dd3b8)(()=>this.opts, ()=>this.i18n);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe] = this.store.subscribe((prevState, nextState, patch)=>{
            this.emit("state-update", prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_addListeners)[$b16b91c7840d3bff$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   */ setState(patch) {
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   */ getState() {
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref)=>{
                    let [fileID, newFileState] = _ref;
                    return [
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ];
                }))
            }
        });
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, "error");
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts == null ? void 0 : newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: false,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = Object.create(null);
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                },
                // @ts-expect-error these typed are inserted
                // into the namespace in their respective packages
                // but core isn't ware of those
                tus: undefined,
                transloadit: undefined
            };
        });
        this.setState({
            files: updatedFiles,
            ...$b16b91c7840d3bff$var$defaultUploadState
        });
    }
    clear() {
        const { capabilities: capabilities, currentUploads: currentUploads } = this.getState();
        if (Object.keys(currentUploads).length > 0 && !capabilities.individualCancellation) throw new Error("The installed uploader plugin does not allow removing files during an upload.");
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log("Adding metadata:");
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log(`Was trying to set metadata for a file that has been removed: ${fileID}`);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = [];
        const newFiles = [];
        const startedFiles = [];
        const uploadStartedFiles = [];
        const pausedFiles = [];
        const completeFiles = [];
        const erroredFiles = [];
        const inProgressNotPausedFiles = [];
        const processingFiles = [];
        for (const file of files){
            const { progress: progress } = file;
            if (!progress.uploadComplete && progress.uploadStarted) {
                inProgressFiles.push(file);
                if (!file.isPaused) inProgressNotPausedFiles.push(file);
            }
            if (!progress.uploadStarted) newFiles.push(file);
            if (progress.uploadStarted || progress.preprocess || progress.postprocess) startedFiles.push(file);
            if (progress.uploadStarted) uploadStartedFiles.push(file);
            if (file.isPaused) pausedFiles.push(file);
            if (progress.uploadComplete) completeFiles.push(file);
            if (file.error) erroredFiles.push(file);
            if (progress.preprocess || progress.postprocess) processingFiles.push(file);
        }
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    validateSingleFile(file) {
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(file);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    validateAggregateRestrictions(files) {
        const existingFiles = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(existingFiles, files);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */ addFile(file) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed](file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState]([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit("file-added", firstValidFileToAdd);
        this.emit("files-added", validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
        return firstValidFileToAdd.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed]();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState](fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = "Multiple errors occurred while adding files:\n";
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n("addBulkFilesFailed", {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, "error", this.opts.infoTimeout);
            if (typeof AggregateError === "function") throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit("file-added", file);
        });
        this.emit("files-added", validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
    }
    removeFiles(fileIDs) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error("The installed uploader plugin does not allow removing files during an upload.");
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit("file-removed", removedFiles[fileID]);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
    removeFile(fileID) {
        this.removeFiles([
            fileID
        ]);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const file = this.getFile(fileID);
        const wasPaused = file.isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit("upload-pause", file, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("pause-all");
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("resume-all");
    }
    async retryAll() {
        const result = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_doRetryAll)[$b16b91c7840d3bff$var$_doRetryAll]();
        this.emit("complete", result);
        return result;
    }
    cancelAll() {
        this.emit("cancel-all");
        const { files: files } = this.getState();
        const fileIDs = Object.keys(files);
        if (fileIDs.length) this.removeFiles(fileIDs);
        this.setState($b16b91c7840d3bff$var$defaultUploadState);
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit("upload-retry", this.getFile(fileID));
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            var _provider;
            (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
        });
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/explicit-module-boundary-types
    [Symbol.for("uppy test: updateTotalProgress")]() {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgress)[$b16b91c7840d3bff$var$_updateTotalProgress]();
    }
    updateOnlineStatus() {
        var _window$navigator$onL;
        const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
        if (!online) {
            this.emit("is-offline");
            this.info(this.i18n("noInternetConnection"), "error", 0);
            this.wasOffline = true;
        } else {
            this.emit("is-online");
            if (this.wasOffline) {
                this.emit("back-online");
                this.info(this.i18n("connectedToInternet"), "success", 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   */ use(Plugin) {
        if (typeof Plugin !== "function") {
            const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}.` + " Please verify that the plugin was imported and spelled correctly.";
            throw new TypeError(msg);
        }
        // Instantiate
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        const plugin = new Plugin(this, ...args);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error("Your plugin must have an id");
        if (!plugin.type) throw new Error("Your plugin must have a type");
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + "Uppy plugins must have unique `id` options.";
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type].push(plugin);
        else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit("plugin-added", plugin);
        return this;
    }
    /**
   * Find one Plugin by name.
   */ getPlugin(id) {
        for (const plugins of Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [Symbol.for("uppy test: getPlugins")](type) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   */ iteratePlugins(method) {
        Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit("plugin-remove", instance);
        if (instance.uninstall) instance.uninstall();
        const list = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ destroy() {
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll();
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
            window.removeEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit("info-hidden");
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */ info(message, type, duration) {
        if (type === void 0) type = "info";
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === "object";
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit("info-visible");
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case "error":
                logger.error(message);
                break;
            case "warning":
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    registerRequestClient(id, client) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
            return Promise.reject(new Error("Nonexistent upload"));
        }
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    [Symbol.for("uppy test: createUpload")]() {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   */ addResultData(uploadID, data) {
        if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getUpload)[$b16b91c7840d3bff$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Start an upload for all the files that are not currently being uploaded.
   */ async upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]["uploader"]) != null && _classPrivateFieldLoo.length)) this.log("No uploader type plugins are used", "warning");
        let { files: files } = this.getState();
        // retry any failed files from a previous upload() call
        const filesToRetry = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getFilesToRetry)[$b16b91c7840d3bff$var$_getFilesToRetry]();
        if (filesToRetry.length > 0) {
            const retryResult = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_doRetryAll)[$b16b91c7840d3bff$var$_doRetryAll](); // we don't want the complete event to fire
            const hasNewFiles = this.getFiles().filter((file)=>file.progress.uploadStarted == null).length > 0;
            // if no new files, make it idempotent and return
            if (!hasNewFiles) {
                this.emit("complete", retryResult);
                return retryResult;
            }
            ({ files: files } = this.getState());
        }
        // If no files to retry, proceed with original upload() behavior for new files
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields)[$b16b91c7840d3bff$var$_checkRequiredMetaFields](files)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("missingRequiredMetaField"));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(async ()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](waitingFileIDs);
            const result = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
            this.emit("complete", result);
            return result;
        }).catch((err)=>{
            this.emit("error", err);
            this.log(err, "error");
            throw err;
        });
    }
}
function $b16b91c7840d3bff$var$_informAndEmit2(errors) {
    for (const error of errors){
        if (error.isRestriction) this.emit("restriction-failed", error.file, error);
        else this.emit("error", error, error.file);
        this.log(error, "warning");
    }
    const userFacingErrors = errors.filter((error)=>error.isUserFacing);
    // don't flood the user: only show the first 4 toasts
    const maxNumToShow = 4;
    const firstErrors = userFacingErrors.slice(0, maxNumToShow);
    const additionalErrors = userFacingErrors.slice(maxNumToShow);
    firstErrors.forEach((_ref2)=>{
        let { message: message, details: details = "" } = _ref2;
        this.info({
            message: message,
            details: details
        }, "error", this.opts.infoTimeout);
    });
    if (additionalErrors.length > 0) this.info({
        message: this.i18n("additionalRestrictionsFailed", {
            count: additionalErrors.length
        })
    });
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit("restriction-failed", file, error);
        return false;
    }
    return true;
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $b16b91c7840d3bff$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noMoreFilesAllowed"), {
            file: file
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
        throw error;
    }
}
function $b16b91c7840d3bff$var$_transformFile2(fileDescriptorOrFile) {
    // Uppy expects files in { name, type, size, data } format.
    // If the actual File object is passed from input[type=file] or drag-drop,
    // we normalize it to match Uppy file object
    const file = fileDescriptorOrFile instanceof File ? {
        name: fileDescriptorOrFile.name,
        type: fileDescriptorOrFile.type,
        size: fileDescriptorOrFile.size,
        data: fileDescriptorOrFile
    } : fileDescriptorOrFile;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    const fileName = (0, $77bbd1edc6b4e0f3$export$2e2bcd8739ae039)(fileType, file);
    const fileExtension = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(fileName).extension;
    const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(file, this.getID());
    const meta = file.meta || {};
    meta.name = fileName;
    meta.type = fileType;
    // `null` means the size is unknown.
    const size = Number.isFinite(file.data.size) ? file.data.size : null;
    return {
        source: file.source || "",
        id: id,
        name: fileName,
        extension: fileExtension || "",
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: file.data,
        progress: {
            percentage: 0,
            bytesUploaded: false,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isGhost: false,
        isRemote: file.isRemote || false,
        remote: file.remote,
        preview: file.preview
    };
}
function $b16b91c7840d3bff$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $b16b91c7840d3bff$var$_checkAndUpdateFileState2(filesToAdd) {
    const { files: existingFiles } = this.getState();
    // create a copy of the files object only once
    const nextFilesState = {
        ...existingFiles
    };
    const validFilesToAdd = [];
    const errors = [];
    for (const fileToAdd of filesToAdd)try {
        var _existingFiles$newFil;
        let newFile = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_transformFile)[$b16b91c7840d3bff$var$_transformFile](fileToAdd);
        // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everything else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
        const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
        if (isGhost) {
            const existingFileState = existingFiles[newFile.id];
            newFile = {
                ...existingFileState,
                isGhost: false,
                data: fileToAdd.data
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
        if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) {
            var _newFile$name;
            throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noDuplicates", {
                fileName: (_newFile$name = newFile.name) != null ? _newFile$name : this.i18n("unnamed")
            }), {
                file: fileToAdd
            });
        }
        // Pass through reselected files from Golden Retriever
        if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
        throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)("Cannot add the file because onBeforeFileAdded returned false.", {
            isUserFacing: false,
            file: fileToAdd
        });
        else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(newFile);
        // need to add it to the new local state immediately, so we can use the state to validate the next files too
        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
    } catch (err) {
        errors.push(err);
    }
    try {
        // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
        // when many files are added
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
    } catch (err) {
        errors.push(err);
        // If we have any aggregate error, don't allow adding this batch
        return {
            nextFilesState: existingFiles,
            validFilesToAdd: [],
            errors: errors
        };
    }
    return {
        nextFilesState: nextFilesState,
        validFilesToAdd: validFilesToAdd,
        errors: errors
    };
}
function $b16b91c7840d3bff$var$_getFilesToRetry2() {
    const { files: files } = this.getState();
    return Object.keys(files).filter((file)=>{
        return files[file].error;
    });
}
async function $b16b91c7840d3bff$var$_doRetryAll2() {
    const filesToRetry = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getFilesToRetry)[$b16b91c7840d3bff$var$_getFilesToRetry]();
    const updatedFiles = {
        ...this.getState().files
    };
    filesToRetry.forEach((fileID)=>{
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            isPaused: false,
            error: null
        };
    });
    this.setState({
        files: updatedFiles,
        error: null
    });
    this.emit("retry-all", this.getFilesByIds(filesToRetry));
    if (filesToRetry.length === 0) return {
        successful: [],
        failed: []
    };
    const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](filesToRetry, {
        forceAllowNewUpload: true // create new upload even if allowNewUpload: false
    });
    return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
}
function $b16b91c7840d3bff$var$_updateTotalProgress2() {
    var _totalProgressPercent, _totalProgressPercent2;
    const totalProgress = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_calculateTotalProgress)[$b16b91c7840d3bff$var$_calculateTotalProgress]();
    let totalProgressPercent = null;
    if (totalProgress != null) {
        totalProgressPercent = Math.round(totalProgress * 100);
        if (totalProgressPercent > 100) totalProgressPercent = 100;
        else if (totalProgressPercent < 0) totalProgressPercent = 0;
    }
    this.emit("progress", (_totalProgressPercent = totalProgressPercent) != null ? _totalProgressPercent : 0);
    this.setState({
        totalProgress: (_totalProgressPercent2 = totalProgressPercent) != null ? _totalProgressPercent2 : 0
    });
}
function $b16b91c7840d3bff$var$_calculateTotalProgress2() {
    // calculate total progress, using the number of files currently uploading,
    // between 0 and 1 and sum of individual progress of each file
    const files = this.getFiles();
    // note: also includes files that have completed uploading:
    const filesInProgress = files.filter((file)=>{
        return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
    });
    if (filesInProgress.length === 0) return 0;
    if (filesInProgress.every((file)=>file.progress.uploadComplete)) // If every uploading file is complete, and we're still getting progress, it probably means
    // there's a bug somewhere in some progress reporting code (maybe not even our code)
    // and we're still getting progress, so let's just assume it means a 100% progress
    return 1;
    const isSizedFile = (file)=>file.progress.bytesTotal != null && file.progress.bytesTotal !== 0;
    const sizedFilesInProgress = filesInProgress.filter(isSizedFile);
    const unsizedFilesInProgress = filesInProgress.filter((file)=>!isSizedFile(file));
    if (sizedFilesInProgress.every((file)=>file.progress.uploadComplete) && unsizedFilesInProgress.length > 0 && !unsizedFilesInProgress.every((file)=>file.progress.uploadComplete)) // we are done with uploading all files of known size, however
    // there is at least one file with unknown size still uploading,
    // and we cannot say anything about their progress
    // In any case, return null because it doesn't make any sense to show a progress
    return null;
    const totalFilesSize = sizedFilesInProgress.reduce((acc, file)=>{
        var _file$progress$bytesT;
        return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
    }, 0);
    const totalUploadedSize = sizedFilesInProgress.reduce((acc, file)=>acc + (file.progress.bytesUploaded || 0), 0);
    return totalFilesSize === 0 ? 0 : totalUploadedSize / totalFilesSize;
}
function $b16b91c7840d3bff$var$_addListeners2() {
    // Type inference only works for inline functions so we have to type it again
    const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || "Unknown error";
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on("error", errorHandler);
    this.on("upload-error", (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === "object" && error.message) {
            var _file$name;
            this.log(error.message, "error");
            const newError = new Error(this.i18n("failedToUpload", {
                file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ""
            })); // we may want a new custom error here
            newError.isUserFacing = true; // todo maybe don't do this with all errors?
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                newError
            ]);
        } else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
    });
    let uploadStalledWarningRecentlyEmitted = null;
    this.on("upload-stalled", (error, files)=>{
        const { message: message } = error;
        const details = files.map((file)=>file.meta.name).join(", ");
        if (!uploadStalledWarningRecentlyEmitted) {
            this.info({
                message: message,
                details: details
            }, "warning", this.opts.infoTimeout);
            uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                uploadStalledWarningRecentlyEmitted = null;
            }, this.opts.infoTimeout);
        }
        this.log(`${message} ${details}`.trim(), "warning");
    });
    this.on("upload", ()=>{
        this.setState({
            error: null
        });
    });
    const onUploadStarted = (files)=>{
        const filesFiltered = files.filter((file)=>{
            const exists = file != null && this.getFile(file.id);
            if (!exists) this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return exists;
        });
        const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                file.id,
                {
                    progress: {
                        uploadStarted: Date.now(),
                        uploadComplete: false,
                        bytesUploaded: 0,
                        bytesTotal: file.size
                    }
                }
            ]));
        this.patchFilesState(filesState);
    };
    this.on("upload-start", onUploadStarted);
    this.on("upload-progress", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_handleUploadProgress)[$b16b91c7840d3bff$var$_handleUploadProgress]);
    this.on("upload-success", (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].size > 0 ? {
                    mode: "indeterminate"
                } : undefined,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        });
        // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
    });
    this.on("preprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on("preprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on("postprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on("postprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on("restored", ()=>{
        // Files may have changed--ensure progress is still accurate.
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
    });
    // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
    this.on("dashboard:file-edit-complete", (file)=>{
        if (file) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file);
    });
    // show informer if offline
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        window.addEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        setTimeout($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus], 3000);
    }
}
function $b16b91c7840d3bff$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error("Cannot create a new upload: already uploading.");
    const uploadID = (0, $af5278daf92376ec$export$ac4959f4f1338dfc)();
    this.emit("upload", uploadID, this.getFilesByIds(fileIDs));
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $b16b91c7840d3bff$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $b16b91c7840d3bff$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $b16b91c7840d3bff$var$_runUpload2(uploadID) {
    const getCurrentUpload = ()=>{
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    };
    let currentUpload = getCurrentUpload();
    const steps = [
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors]
    ];
    try {
        for(let step = currentUpload.step || 0; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            this.setState({
                currentUploads: {
                    ...this.getState().currentUploads,
                    [uploadID]: {
                        ...currentUpload,
                        step: step
                    }
                }
            });
            const { fileIDs: fileIDs } = currentUpload;
            // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(fileIDs, uploadID);
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
    } catch (err) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
        throw err;
    }
    // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit("postprocess-complete", file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        });
        // Update currentUpload value in case it was modified asynchronously.
        currentUpload = getCurrentUpload();
    }
    // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
    }
    if (result == null) this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
    return result;
}
$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION = $b16b91c7840d3bff$var$packageJson.version;
var $b16b91c7840d3bff$export$2e2bcd8739ae039 = $b16b91c7840d3bff$export$1c95bea2669f592b;


var $4d2e93495e50cc85$var$n, $4d2e93495e50cc85$export$41c562ebe57d11e2, $4d2e93495e50cc85$var$u, $4d2e93495e50cc85$export$a8257692ac88316c, $4d2e93495e50cc85$var$i, $4d2e93495e50cc85$var$r, $4d2e93495e50cc85$var$o, $4d2e93495e50cc85$var$e, $4d2e93495e50cc85$var$f, $4d2e93495e50cc85$var$c, $4d2e93495e50cc85$var$s, $4d2e93495e50cc85$var$a, $4d2e93495e50cc85$var$h, $4d2e93495e50cc85$var$p = {}, $4d2e93495e50cc85$var$y = [], $4d2e93495e50cc85$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d2e93495e50cc85$var$w = Array.isArray;
function $4d2e93495e50cc85$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d2e93495e50cc85$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $4d2e93495e50cc85$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)null == e[o] && (e[o] = l.defaultProps[o]);
    return $4d2e93495e50cc85$var$m(l, e, i, r, null);
}
function $4d2e93495e50cc85$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$4d2e93495e50cc85$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(e), e;
}
function $4d2e93495e50cc85$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d2e93495e50cc85$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d2e93495e50cc85$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d2e93495e50cc85$var$S(n, l) {
    if (null == l) return n.__ ? $4d2e93495e50cc85$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d2e93495e50cc85$var$S(n) : null;
}
function $4d2e93495e50cc85$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d2e93495e50cc85$var$C(n);
    }
}
function $4d2e93495e50cc85$var$M(n) {
    (!n.__d && (n.__d = !0) && $4d2e93495e50cc85$var$i.push(n) && !$4d2e93495e50cc85$var$$.__r++ || $4d2e93495e50cc85$var$r != $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) && (($4d2e93495e50cc85$var$r = $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) || $4d2e93495e50cc85$var$o)($4d2e93495e50cc85$var$$);
}
function $4d2e93495e50cc85$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $4d2e93495e50cc85$var$i.length;)$4d2e93495e50cc85$var$i.length > s && $4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$e), n = $4d2e93495e50cc85$var$i.shift(), s = $4d2e93495e50cc85$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $4d2e93495e50cc85$var$d({}, r)).__v = r.__v + 1, $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(t), $4d2e93495e50cc85$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $4d2e93495e50cc85$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $4d2e93495e50cc85$var$z(f, t, c), t.__e != o && $4d2e93495e50cc85$var$C(t)));
    $4d2e93495e50cc85$var$$.__r = 0;
}
function $4d2e93495e50cc85$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, v, w, d, g, _ = t && t.__k || $4d2e93495e50cc85$var$y, m = l.length;
    for(f = $4d2e93495e50cc85$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (v = u.__k[a]) && (h = -1 == v.__i ? $4d2e93495e50cc85$var$p : _[v.__i] || $4d2e93495e50cc85$var$p, v.__i = a, g = $4d2e93495e50cc85$var$O(n, v, h, i, r, o, e, f, c, s), w = v.__e, v.ref && h.ref != v.ref && (h.ref && $4d2e93495e50cc85$var$q(h.ref, null, v), s.push(v.ref, v.__c || w, v)), null == d && null != w && (d = w), 4 & v.__u || h.__k === v.__k ? f = $4d2e93495e50cc85$var$A(v, f, n) : "function" == typeof v.type && void 0 !== g ? f = g : w && (f = w.nextSibling), v.__u &= -7);
    return u.__e = d, f;
}
function $4d2e93495e50cc85$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $4d2e93495e50cc85$var$m(null, o, null, null, null) : $4d2e93495e50cc85$var$w(o) ? $4d2e93495e50cc85$var$m($4d2e93495e50cc85$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $4d2e93495e50cc85$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $4d2e93495e50cc85$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $4d2e93495e50cc85$var$S(e)), $4d2e93495e50cc85$var$B(e, e));
    return t;
}
function $4d2e93495e50cc85$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $4d2e93495e50cc85$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $4d2e93495e50cc85$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $4d2e93495e50cc85$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d2e93495e50cc85$var$w(n) ? n.some(function(n) {
        $4d2e93495e50cc85$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d2e93495e50cc85$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f && null == n.key || f && o == f.key && e == f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return r;
            r++;
        }
    }
    return -1;
}
function $4d2e93495e50cc85$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d2e93495e50cc85$var$v.test(l) ? u : u + "px";
}
function $4d2e93495e50cc85$var$j(n, l, u, t, i) {
    var r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d2e93495e50cc85$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $4d2e93495e50cc85$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($4d2e93495e50cc85$var$f, "$1")), l = l.toLowerCase() in n || "onFocusOut" == l || "onFocusIn" == l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $4d2e93495e50cc85$var$c, n.addEventListener(l, r ? $4d2e93495e50cc85$var$a : $4d2e93495e50cc85$var$s, r)) : n.removeEventListener(l, r ? $4d2e93495e50cc85$var$a : $4d2e93495e50cc85$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $4d2e93495e50cc85$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $4d2e93495e50cc85$var$c++;
            else if (u.t < t.u) return;
            return t($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $4d2e93495e50cc85$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, v, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $4d2e93495e50cc85$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $4d2e93495e50cc85$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $4d2e93495e50cc85$var$d({}, h.__s)), $4d2e93495e50cc85$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), y = h.props, v = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, v, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $4d2e93495e50cc85$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $4d2e93495e50cc85$var$d($4d2e93495e50cc85$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(y, v)), L = a, null != a && a.type === $4d2e93495e50cc85$export$ffb0004e005737fa && null == a.key && (L = $4d2e93495e50cc85$var$N(a.props.children)), f = $4d2e93495e50cc85$var$I(n, $4d2e93495e50cc85$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$4d2e93495e50cc85$var$g(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $4d2e93495e50cc85$var$V(t.__e, u, t, i, r, o, e, c, s);
    return (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $4d2e93495e50cc85$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$4d2e93495e50cc85$var$q(t[i], t[++i], t[++i]);
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d2e93495e50cc85$var$N(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $4d2e93495e50cc85$var$w(n) ? n.map($4d2e93495e50cc85$var$N) : $4d2e93495e50cc85$var$d({}, n);
}
function $4d2e93495e50cc85$var$V(u, t, i, r, o, e, f, c, s) {
    var a, h, y, v, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($4d2e93495e50cc85$export$41c562ebe57d11e2.__m && $4d2e93495e50cc85$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $4d2e93495e50cc85$var$n.call(u.childNodes), b = i.props || $4d2e93495e50cc85$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) y = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $4d2e93495e50cc85$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? v = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $4d2e93495e50cc85$var$j(u, a, d, b[a], o);
        if (h) c || y && (h.__html == y.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (y && (u.innerHTML = ""), $4d2e93495e50cc85$var$I("template" == t.type ? u.content : u, $4d2e93495e50cc85$var$w(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $4d2e93495e50cc85$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$4d2e93495e50cc85$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $4d2e93495e50cc85$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $4d2e93495e50cc85$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $4d2e93495e50cc85$var$q(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d2e93495e50cc85$var$B(n, u, t) {
    var i, r;
    if ($4d2e93495e50cc85$export$41c562ebe57d11e2.unmount && $4d2e93495e50cc85$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $4d2e93495e50cc85$var$q(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $4d2e93495e50cc85$var$B(i[r], u, t || "function" != typeof n.type);
    t || $4d2e93495e50cc85$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $4d2e93495e50cc85$var$D(n, l, u) {
    return this.constructor(n, u);
}
function $4d2e93495e50cc85$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $4d2e93495e50cc85$export$41c562ebe57d11e2.__ && $4d2e93495e50cc85$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $4d2e93495e50cc85$var$O(t, u = (!r && i || t).__k = $4d2e93495e50cc85$export$c8a8987d4410bf2d($4d2e93495e50cc85$export$ffb0004e005737fa, null, [
        u
    ]), o || $4d2e93495e50cc85$var$p, $4d2e93495e50cc85$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $4d2e93495e50cc85$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $4d2e93495e50cc85$var$z(e, u, f);
}
function $4d2e93495e50cc85$export$fa8d919ba61d84db(n, l) {
    $4d2e93495e50cc85$export$b3890eb0ae9dca99(n, l, $4d2e93495e50cc85$export$fa8d919ba61d84db);
}
function $4d2e93495e50cc85$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $4d2e93495e50cc85$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = null == u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), $4d2e93495e50cc85$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $4d2e93495e50cc85$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $4d2e93495e50cc85$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $4d2e93495e50cc85$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$4d2e93495e50cc85$var$n = $4d2e93495e50cc85$var$y.slice, $4d2e93495e50cc85$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d2e93495e50cc85$var$u = 0, $4d2e93495e50cc85$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $4d2e93495e50cc85$var$d({}, this.state), "function" == typeof n && (n = n($4d2e93495e50cc85$var$d({}, u), this.props)), n && $4d2e93495e50cc85$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $4d2e93495e50cc85$var$M(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d2e93495e50cc85$var$M(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.render = $4d2e93495e50cc85$export$ffb0004e005737fa, $4d2e93495e50cc85$var$i = [], $4d2e93495e50cc85$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d2e93495e50cc85$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d2e93495e50cc85$var$$.__r = 0, $4d2e93495e50cc85$var$f = /(PointerCapture)$|Capture$/i, $4d2e93495e50cc85$var$c = 0, $4d2e93495e50cc85$var$s = $4d2e93495e50cc85$var$F(!1), $4d2e93495e50cc85$var$a = $4d2e93495e50cc85$var$F(!0), $4d2e93495e50cc85$var$h = 0;


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $dcdea5a9bf8353ff$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    if (!("nodeType" in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $1866f8238923bb5d$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === "string") return context.querySelector(element);
    if ((0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $1866f8238923bb5d$export$2e2bcd8739ae039 = $1866f8238923bb5d$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $82cce0c04a5d7a26$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
var $82cce0c04a5d7a26$export$2e2bcd8739ae039 = $82cce0c04a5d7a26$var$getTextDirection;


/* eslint-disable class-methods-use-this */ /**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $336df15d01030489$export$2e2bcd8739ae039 {
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts != null ? opts : {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


function $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $5d08dd66a9cc6899$var$id = 0;
function $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $5d08dd66a9cc6899$var$id++ + "_" + e;
}
/**
 * Defer a frequent call to the microtask queue.
 */ function $5d08dd66a9cc6899$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $5d08dd66a9cc6899$var$_updateUI = /*#__PURE__*/ $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey("updateUI");
class $5d08dd66a9cc6899$var$UIPlugin extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $5d08dd66a9cc6899$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    getTargetPlugin(target // eslint-disable-line no-use-before-define
    ) {
        let targetPlugin;
        if (typeof (target == null ? void 0 : target.addTarget) === "function") {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $5d08dd66a9cc6899$var$UIPlugin)) // eslint-disable-next-line no-console
            console.warn(new Error("The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.", {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $5d08dd66a9cc6899$var$UIPlugin
                }
            }));
        } else if (typeof target === "function") {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, // eslint-disable-line no-use-before-define
    plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $1866f8238923bb5d$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement("div");
            uppyRootElement.classList.add("uppy-Root");
            // API for plugins that require a synchronous rerender.
            $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI)[$5d08dd66a9cc6899$var$_updateUI] = $5d08dd66a9cc6899$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.destroy
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(state, uppyRootElement), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = "";
            (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(this.uppy.getState(), uppyRootElement), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(uppyRootElement) || "ltr";
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === "function") message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    state, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    container) {
        throw new Error("Extend the render method to add your plugin to a DOM element");
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI))[$5d08dd66a9cc6899$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $5d08dd66a9cc6899$export$2e2bcd8739ae039 = $5d08dd66a9cc6899$var$UIPlugin;



/**
 * Low-pass filter using Exponential Moving Averages (aka exponential smoothing)
 * Filters a sequence of values by updating the mixing the previous output value
 * with the new input using the exponential window function
 *
 * @param newValue the n-th value of the sequence
 * @param previousSmoothedValue the exponential average of the first n-1 values
 * @param halfLife value of `dt` to move the smoothed value halfway between `previousFilteredValue` and `newValue`
 * @param dt time elapsed between adding the (n-1)th and the n-th values
 * @returns the exponential average of the first n values
 */ function $4e5b770b58150a1e$export$2e2bcd8739ae039(newValue, previousSmoothedValue, halfLife, dt) {
    if (halfLife === 0 || newValue === previousSmoothedValue) return newValue;
    if (dt === 0) return previousSmoothedValue;
    return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}



var $5278b2bb79ab63f5$export$2e2bcd8739ae039 = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete"
};



var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



function $3d16a6a6f033a885$export$2e2bcd8739ae039(files) {
    const values = [];
    let mode = "indeterminate";
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress;
        // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if ((preprocess == null ? void 0 : preprocess.mode) === "determinate") values.push(preprocess.value);
        if ((postprocess == null ? void 0 : postprocess.mode) === "determinate") values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}





function $1bd6564471caa0d9$export$2e2bcd8739ae039(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}


function $cf4f21df8a3b103f$export$2e2bcd8739ae039(seconds) {
    const time = (0, $1bd6564471caa0d9$export$2e2bcd8739ae039)(seconds);
    // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
    const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}



const $c0c4f933fc4ac9a2$var$DOT = `\u00B7`;
const $c0c4f933fc4ac9a2$var$renderDot = ()=>` ${$c0c4f933fc4ac9a2$var$DOT} `;
function $c0c4f933fc4ac9a2$export$8fd979504d9f59d1(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
        "uppy-c-btn-primary": uploadState === (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING
    }, {
        "uppy-StatusBar-actionBtn--disabled": isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
        smart_count: newFiles
    }) : i18n("uploadXFiles", {
        smart_count: newFiles
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true
    }, uploadBtnText);
}
function $c0c4f933fc4ac9a2$export$d0263dca13d9e524(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n("retryUpload"),
        onClick: ()=>uppy.retryAll().catch(()=>{
            /* Error reported and handled via an event */ }),
        "data-uppy-super-focusable": true,
        "data-cy": "retry"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "8",
        height: "10",
        viewBox: "0 0 8 10"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
    })), i18n("retry"));
}
function $c0c4f933fc4ac9a2$export$bda6e5e4654fa168(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n("cancel"),
        "aria-label": i18n("cancel"),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
    }))));
}
function $c0c4f933fc4ac9a2$export$f8fda1be68e432db(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n("resume") : i18n("pause");
    function togglePauseResume() {
        if (isAllComplete) return;
        if (!resumableUploads) {
            uppy.cancelAll();
            return;
        }
        if (isAllPaused) {
            uppy.resumeAll();
            return;
        }
        uppy.pauseAll();
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-cy": "togglePauseResume",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
    }))));
}
function $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true
    }, i18n("done"));
}
function $c0c4f933fc4ac9a2$export$b08b517936747730() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
        fillRule: "evenodd"
    }));
}
function $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const dot = `\u00B7`;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function $c0c4f933fc4ac9a2$export$511da99642518663(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    const totalUploadedSizeStr = (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalUploadedSize);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-StatusBar-additionalInfo"
    }, ifShowFilesUploadedOfTotal && $c0c4f933fc4ac9a2$var$renderDot(), totalSize != null ? i18n("dataUploadedOfTotal", {
        complete: totalUploadedSizeStr,
        total: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalSize)
    }) : i18n("dataUploadedOfUnknown", {
        complete: totalUploadedSizeStr
    }), $c0c4f933fc4ac9a2$var$renderDot(), totalETA != null && i18n("xTimeLeft", {
        time: (0, $cf4f21df8a3b103f$export$2e2bcd8739ae039)(totalETA)
    })));
}
function $c0c4f933fc4ac9a2$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }));
}
function $c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondaryHint"
    }, i18n("xMoreFilesAdded", {
        smart_count: newFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload
    }, i18n("upload")));
}
function $c0c4f933fc4ac9a2$export$2d75d7371a967988(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n("paused") : i18n("uploading");
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$511da99642518663, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        "aria-label": title,
        title: title
    }, !isAllPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, supportsUploadProgress && totalProgress !== 0 ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles, {
        i18n: i18n,
        newFiles: newFiles,
        startUpload: startUpload
    }) : null));
}
function $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        role: "status",
        title: i18n("complete")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
    })), i18n("complete"))));
}
function $c0c4f933fc4ac9a2$export$7331502eb9534bdb(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n("uploadFailed")} \n\n ${error}`;
        // eslint-disable-next-line no-alert
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        title: i18n("uploadFailed")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, i18n("uploadFailed"), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-StatusBar-details",
        "aria-label": i18n("showErrorDetails"),
        "data-microtip-position": "top-right",
        "data-microtip-size": "medium",
        onClick: displayErrorAlert,
        type: "button"
    }, "?")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
    })));
}


const { STATE_ERROR: $4af84b49d740c94f$var$STATE_ERROR, STATE_WAITING: $4af84b49d740c94f$var$STATE_WAITING, STATE_PREPROCESSING: $4af84b49d740c94f$var$STATE_PREPROCESSING, STATE_UPLOADING: $4af84b49d740c94f$var$STATE_UPLOADING, STATE_POSTPROCESSING: $4af84b49d740c94f$var$STATE_POSTPROCESSING, STATE_COMPLETE: $4af84b49d740c94f$var$STATE_COMPLETE } = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039);
function $4af84b49d740c94f$export$2e2bcd8739ae039(_ref) {
    let { newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton = false, hideCancelButton: hideCancelButton = false, hideRetryButton: hideRetryButton = false, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish = false, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize } = _ref;
    function getProgressValue() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const progress = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    if (progress.mode === "determinate") return progress.value * 100;
                    return totalProgress;
                }
            case $4af84b49d740c94f$var$STATE_ERROR:
                return null;
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    return mode === "indeterminate";
                }
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const width = progressValue != null ? progressValue : 100;
    const showUploadBtn = !error && newFiles && (!isUploadInProgress && !isAllPaused || recoveredState) && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $4af84b49d740c94f$var$STATE_WAITING && uploadState !== $4af84b49d740c94f$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $4af84b49d740c94f$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $4af84b49d740c94f$var$STATE_COMPLETE;
    const progressClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar-progress", {
        "is-indeterminate": getIsIndeterminate()
    });
    const statusBarClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar", `is-${uploadState}`, {
        "has-ghosts": isSomeGhost
    });
    const progressBarStateEl = (()=>{
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8), {
                    progress: (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files)
                });
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e), {
                    i18n: i18n
                });
            case $4af84b49d740c94f$var$STATE_ERROR:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$7331502eb9534bdb), {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$2d75d7371a967988), {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })();
    const atLeastOneAction = showUploadBtn || showRetryBtn || showPauseResumeBtn || showCancelBtn || showDoneBtn;
    const thereIsNothingInside = !atLeastOneAction && !progressBarStateEl;
    const isHidden = thereIsNothingInside || uploadState === $4af84b49d740c94f$var$STATE_COMPLETE && hideAfterFinish;
    if (isHidden) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: statusBarClassNames
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: progressClassNames,
        style: {
            width: `${width}%`
        },
        role: "progressbar",
        "aria-label": `${width}%`,
        "aria-valuetext": `${width}%`,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": progressValue
    }), progressBarStateEl, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-actions"
    }, showUploadBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8fd979504d9f59d1), {
        newFiles: newFiles,
        isUploadStarted: isUploadStarted,
        recoveredState: recoveredState,
        i18n: i18n,
        isSomeGhost: isSomeGhost,
        startUpload: startUpload,
        uploadState: uploadState
    }) : null, showRetryBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$d0263dca13d9e524), {
        i18n: i18n,
        uppy: uppy
    }) : null, showPauseResumeBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f8fda1be68e432db), {
        isAllPaused: isAllPaused,
        i18n: i18n,
        isAllComplete: isAllComplete,
        resumableUploads: resumableUploads,
        uppy: uppy
    }) : null, showCancelBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$bda6e5e4654fa168), {
        i18n: i18n,
        uppy: uppy
    }) : null, showDoneBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a), {
        i18n: i18n,
        doneButtonHandler: doneButtonHandler
    }) : null));
}


var $f9ab456b3e2aaacb$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: "Uploading",
        // Shown in the status bar once all files have been uploaded.
        complete: "Complete",
        // Shown in the status bar if an upload failed.
        uploadFailed: "Upload failed",
        // Shown in the status bar while the upload is paused.
        paused: "Paused",
        // Used as the label for the button that retries an upload.
        retry: "Retry",
        // Used as the label for the button that cancels an upload.
        cancel: "Cancel",
        // Used as the label for the button that pauses an upload.
        pause: "Pause",
        // Used as the label for the button that resumes an upload.
        resume: "Resume",
        // Used as the label for the button that resets the upload state after an upload
        done: "Done",
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: "%{complete} of %{smart_count} file uploaded",
            1: "%{complete} of %{smart_count} files uploaded"
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: "%{complete} of %{total}",
        dataUploadedOfUnknown: "%{complete} of unknown",
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: "%{time} left",
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: "Upload %{smart_count} file",
            1: "Upload %{smart_count} files"
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: "Upload +%{smart_count} file",
            1: "Upload +%{smart_count} files"
        },
        upload: "Upload",
        retryUpload: "Retry upload",
        xMoreFilesAdded: {
            0: "%{smart_count} more file added",
            1: "%{smart_count} more files added"
        },
        showErrorDetails: "Show error details"
    }
};


function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $f22a72e7b80fdb1a$var$id = 0;
function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $f22a72e7b80fdb1a$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f22a72e7b80fdb1a$var$packageJson = {
    "version": "4.1.3"
};
const $f22a72e7b80fdb1a$var$speedFilterHalfLife = 2000;
const $f22a72e7b80fdb1a$var$ETAFilterHalfLife = 2000;
function $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_ERROR;
    if (isAllComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_COMPLETE;
    if (recoveredState) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    let state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_POSTPROCESSING;
    }
    return state;
}
const $f22a72e7b80fdb1a$var$defaultOptions = {
    hideUploadButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideCancelButton: false,
    showProgressDetails: false,
    hideAfterFinish: true,
    doneButtonHandler: null
};
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */ var $f22a72e7b80fdb1a$var$_lastUpdateTime = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("lastUpdateTime");
var $f22a72e7b80fdb1a$var$_previousUploadedBytes = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousUploadedBytes");
var $f22a72e7b80fdb1a$var$_previousSpeed = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousSpeed");
var $f22a72e7b80fdb1a$var$_previousETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousETA");
var $f22a72e7b80fdb1a$var$_computeSmoothETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("computeSmoothETA");
var $f22a72e7b80fdb1a$var$_onUploadStart = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("onUploadStart");
class $f22a72e7b80fdb1a$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f22a72e7b80fdb1a$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_computeSmoothETA, {
            value: $f22a72e7b80fdb1a$var$_computeSmoothETA2
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_lastUpdateTime, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousSpeed, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousETA, {
            writable: true,
            value: void 0
        });
        this.startUpload = ()=>{
            return this.uppy.upload().catch(()=>{
            // Error logged in Core
            });
        };
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_onUploadStart, {
            writable: true,
            value: ()=>{
                const { recoveredState: recoveredState } = this.uppy.getState();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = null;
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = null;
                if (recoveredState) {
                    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref)=>{
                        let { progress: progress } = _ref;
                        return pv + progress.bytesUploaded;
                    }, 0);
                    // We don't set `#lastUpdateTime` at this point because the upload won't
                    // actually resume until the user asks for it.
                    this.uppy.emit("restore-confirmed");
                    return;
                }
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = 0;
            }
        });
        this.id = this.opts.id || "StatusBar";
        this.title = "StatusBar";
        this.type = "progressindicator";
        this.defaultLocale = (0, $f9ab456b3e2aaacb$export$2e2bcd8739ae039);
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState();
        // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = null;
        let totalUploadedSize = 0;
        // Only if all files have a known size, does it make sense to display a total size
        if (startedFiles.every((f)=>f.progress.bytesTotal != null && f.progress.bytesTotal !== 0)) {
            totalSize = 0;
            startedFiles.forEach((file)=>{
                totalSize += file.progress.bytesTotal || 0;
                totalUploadedSize += file.progress.bytesUploaded || 0;
            });
        } else // however uploaded size we will always have
        startedFiles.forEach((file)=>{
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        const totalETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_computeSmoothETA)[$f22a72e7b80fdb1a$var$_computeSmoothETA]({
            uploaded: totalUploadedSize,
            total: totalSize
        });
        return (0, $4af84b49d740c94f$export$2e2bcd8739ae039)({
            error: error,
            uploadState: $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(element);
        if (!direction) element.dir = "ltr";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        this.uppy.on("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
        // To cover the use case where the status bar is installed while the upload
        // has started, we set `lastUpdateTime` right away.
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file)=>pv + file.progress.bytesUploaded, 0);
    }
    uninstall() {
        this.unmount();
        this.uppy.off("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
    }
}
function $f22a72e7b80fdb1a$var$_computeSmoothETA2(totalBytes) {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    if (totalBytes.total == null || totalBytes.total === 0) return null;
    const remaining = totalBytes.total - totalBytes.uploaded;
    if (remaining <= 0) return null;
    // When state is restored, lastUpdateTime is still nullish at this point.
    (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime))[$f22a72e7b80fdb1a$var$_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    const dt = performance.now() - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime];
    if (dt === 0) {
        var _classPrivateFieldLoo3;
        return Math.round(((_classPrivateFieldLoo3 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
    }
    const uploadedBytesSinceLastTick = totalBytes.uploaded - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes];
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = totalBytes.uploaded;
    // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
    // in which case, we wait for next tick to update ETA.
    if (uploadedBytesSinceLastTick <= 0) {
        var _classPrivateFieldLoo4;
        return Math.round(((_classPrivateFieldLoo4 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
    }
    const currentSpeed = uploadedBytesSinceLastTick / dt;
    const filteredSpeed = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] == null ? currentSpeed : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(currentSpeed, $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed], $f22a72e7b80fdb1a$var$speedFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = filteredSpeed;
    const instantETA = remaining / filteredSpeed;
    const updatedPreviousETA = Math.max($f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] - dt, 0);
    const filteredETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] == null ? instantETA : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(instantETA, updatedPreviousETA, $f22a72e7b80fdb1a$var$ETAFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = filteredETA;
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    return Math.round(filteredETA / 100) / 10;
}
$f22a72e7b80fdb1a$export$2e2bcd8739ae039.VERSION = $f22a72e7b80fdb1a$var$packageJson.version;




/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 


const $aaa56faedf37f661$var$TRANSITION_MS = 300;
class $aaa56faedf37f661$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.ref = (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43)();
    }
    componentWillEnter(callback) {
        this.ref.current.style.opacity = "1";
        this.ref.current.style.transform = "none";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = "0";
        this.ref.current.style.transform = "translateY(350%)";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref
        }, children);
    }
}


// INFO: not typing copy pasted libarary code
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */ /**
 * @source https://github.com/developit/preact-transition-group
 */ 
function $39136bc8da03ed4c$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $39136bc8da03ed4c$var$getKey(vnode, fallback) {
    var _vnode$key;
    return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function $39136bc8da03ed4c$var$linkRef(component, name) {
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $39136bc8da03ed4c$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $39136bc8da03ed4c$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $39136bc8da03ed4c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>next.hasOwnProperty(key) ? next[key] : prev[key];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $39136bc8da03ed4c$var$identity = (i)=>i;
class $39136bc8da03ed4c$var$TransitionGroup extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $39136bc8da03ed4c$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (nextChildMapping.hasOwnProperty(key)) {
            const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (prevChildMapping.hasOwnProperty(key)) {
            const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component != null && component.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $39136bc8da03ed4c$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render(_ref, _ref2) {
        let { childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props } = _ref;
        let { children: children } = _ref2;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = Object.entries(children).map((_ref3)=>{
            let [key, child] = _ref3;
            if (!child) return undefined;
            const ref = $39136bc8da03ed4c$var$linkRef(this, key);
            return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(childFactory(child), {
                ref: ref,
                key: key
            });
        }).filter(Boolean);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(component, props, childrenToRender);
    }
}
$39136bc8da03ed4c$var$TransitionGroup.defaultProps = {
    component: "span",
    childFactory: $39136bc8da03ed4c$var$identity
};
var $39136bc8da03ed4c$export$2e2bcd8739ae039 = $39136bc8da03ed4c$var$TransitionGroup;


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $2d1e3e0d76faae78$var$packageJson = {
    "version": "4.2.1"
};
class $2d1e3e0d76faae78$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        this.render = (state)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy uppy-Informer"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $39136bc8da03ed4c$export$2e2bcd8739ae039), null, state.info.map((info)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aaa56faedf37f661$export$2e2bcd8739ae039), {
                    key: info.message
                }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("p", {
                    role: "alert"
                }, info.message, " ", info.details && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                    "aria-label": info.details,
                    "data-microtip-position": "top-left",
                    "data-microtip-size": "medium",
                    role: "tooltip",
                    onClick: ()=>// eslint-disable-next-line no-alert
                        alert(`${info.message} \n\n ${info.details}`)
                }, "?"))))));
        };
        this.type = "progressindicator";
        this.id = this.opts.id || "Informer";
        this.title = "Informer";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}
$2d1e3e0d76faae78$export$2e2bcd8739ae039.VERSION = $2d1e3e0d76faae78$var$packageJson.version;





const $8f6efe9c4afa65c2$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $8f6efe9c4afa65c2$var$dataURItoBlob(dataURI, opts, toFile) {
    var _ref, _opts$mimeType;
    // get the base64 data
    const dataURIData = $8f6efe9c4afa65c2$var$DATA_URL_PATTERN.exec(dataURI);
    // user may provide mime type, if not get it from data URI
    const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
    let data; // We add `!` to tell TS we're OK with `data` being not defined when the dataURI is invalid.
    if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) data = [
        decodeURIComponent(dataURIData[3])
    ];
    // Convert to a File?
    if (toFile) return new File(data, opts.name || "", {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}
var $8f6efe9c4afa65c2$export$2e2bcd8739ae039 = $8f6efe9c4afa65c2$var$dataURItoBlob;


/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */ function $3b72dc28c9f79a38$export$2e2bcd8739ae039(url) {
    return url.startsWith("blob:");
}


function $2e3a76623b3bbcc9$export$2e2bcd8739ae039(fileType) {
    if (!fileType) return false;
    // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}



var $gnS5A = parcelRequire("gnS5A");
var $7785655e028eb2bd$export$2e2bcd8739ae039 = {
    strings: {
        generatingThumbnails: "Generating thumbnails..."
    }
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f92c4ad36d89e394$var$packageJson = {
    "version": "4.1.1"
};
/**
 * Save a <canvas> element's content to a Blob object.
 *
 */ function $f92c4ad36d89e394$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext("2d").getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error("cannot read image, probably an svg with external resources");
        return blob;
    });
    return Promise.resolve().then(()=>{
        return (0, $8f6efe9c4afa65c2$export$2e2bcd8739ae039)(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error("could not extract blob, probably an old browser");
        return blob;
    });
}
function $f92c4ad36d89e394$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $f92c4ad36d89e394$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement("canvas");
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
const $f92c4ad36d89e394$var$defaultOptions = {
    thumbnailWidth: null,
    thumbnailHeight: null,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    lazy: false
};
class $f92c4ad36d89e394$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f92c4ad36d89e394$var$defaultOptions,
            ...opts
        });
        this.onFileAdded = (file)=>{
            if (!file.preview && file.data && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) this.addToQueue(file.id);
        };
        /**
     * Cancel a lazy request for a thumbnail if the thumbnail has not yet been generated.
     */ this.onCancelRequest = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
        };
        /**
     * Clean up the thumbnail for a file. Cancel lazy requests and free the thumbnail URL.
     */ this.onFileRemoved = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
            // Clean up object URLs.
            if (file.preview && (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) URL.revokeObjectURL(file.preview);
        };
        this.onRestored = ()=>{
            const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
            restoredFiles.forEach((file)=>{
                // Only add blob URLs; they are likely invalid after being restored.
                if (!file.preview || (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) this.addToQueue(file.id);
            });
        };
        this.onAllFilesRemoved = ()=>{
            this.queue = [];
        };
        this.waitUntilAllProcessed = (fileIDs)=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("preprocess-progress", file, {
                    mode: "indeterminate",
                    message: this.i18n("generatingThumbnails")
                });
            });
            const emitPreprocessCompleteForAll = ()=>{
                fileIDs.forEach((fileID)=>{
                    const file = this.uppy.getFile(fileID);
                    this.uppy.emit("preprocess-complete", file);
                });
            };
            return new Promise((resolve)=>{
                if (this.queueProcessing) this.uppy.once("thumbnail:all-generated", ()=>{
                    emitPreprocessCompleteForAll();
                    resolve();
                });
                else {
                    emitPreprocessCompleteForAll();
                    resolve();
                }
            });
        };
        this.type = "modifier";
        this.id = this.opts.id || "ThumbnailGenerator";
        this.title = "Thumbnail Generator";
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType;
        this.defaultLocale = (0, $7785655e028eb2bd$export$2e2bcd8739ae039);
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
    createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener("load", ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener("error", (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error("Could not create thumbnail"));
            });
        });
        const orientationPromise = (0, $gnS5A.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then((_ref)=>{
            let [image, orientation] = _ref;
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = $f92c4ad36d89e394$var$rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return $f92c4ad36d89e394$var$canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */ getProportionalDimensions(img, width, height, deg) {
        // eslint-disable-line no-shadow
        let aspect = img.width / img.height;
        if (deg === 90 || deg === 270) aspect = img.height / img.width;
        if (width != null) return {
            width: width,
            height: Math.round(width / aspect)
        };
        if (height != null) return {
            width: Math.round(height * aspect),
            height: height
        };
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */ // eslint-disable-next-line class-methods-use-this
    resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = $f92c4ad36d89e394$var$protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement("canvas");
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
   * Set the preview URL for a file.
   */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(fileID) {
        this.queue.push(fileID);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}) // eslint-disable-line node/handle-callback-err
            .then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
        this.uppy.emit("thumbnail:all-generated");
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ((0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
            this.uppy.log(err, "warning");
            this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    install() {
        this.uppy.on("file-removed", this.onFileRemoved);
        this.uppy.on("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("file-added", this.onFileAdded);
            this.uppy.on("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off("file-removed", this.onFileRemoved);
        this.uppy.off("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("file-added", this.onFileAdded);
            this.uppy.off("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}
$f92c4ad36d89e394$export$2e2bcd8739ae039.VERSION = $f92c4ad36d89e394$var$packageJson.version;



/**
 * Find one or more DOM elements.
 */ function $3da4efa7f88c23a6$var$findAllDOMElements(element) {
    if (typeof element === "string") {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === "object" && (0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return [
        element
    ];
    return null;
}
var $3da4efa7f88c23a6$export$2e2bcd8739ae039 = $3da4efa7f88c23a6$var$findAllDOMElements;


/**
 * Converts list into array
 */ var $d737086ca91a9c7d$export$2e2bcd8739ae039 = Array.from;


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: // eslint-disable-next-line no-nested-ternary
        entry.isFile ? "file" : entry.isDirectory ? "directory" : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b08bd893356e01b1$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
function $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    try {
        if (lastResortFile === void 0) lastResortFile = undefined;
        return async function*() {
            const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
            // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (entry.kind === "file") {
                const file = await entry.getFile();
                if (file != null) {
                    file.relativePath = relativePath ? getNextRelativePath() : null;
                    yield file;
                } else if (lastResortFile != null) yield lastResortFile;
            } else if (entry.kind === "directory") for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
            else if (lastResortFile != null) yield lastResortFile;
        }();
    } catch (e) {
        return Promise.reject(e);
    }
}
async function* $e30d9f0f4292db6d$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        var _fileSystemHandle;
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
        // eslint-disable-next-line prefer-const
        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}



function $d5d92a586549e3b5$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


async function $954bacbcaff60289$export$2e2bcd8739ae039(dataTransfer, options) {
    var _options$logDropError;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $e30d9f0f4292db6d$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $d5d92a586549e3b5$export$2e2bcd8739ae039)(dataTransfer);
    }
}





function $d0cca3c9705b0857$export$2e2bcd8739ae039(file) {
    return {
        ...file,
        type: file.mimeType,
        extension: file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension : null
    };
}




var $e28f05d17e052ff9$var$t, $e28f05d17e052ff9$var$r, $e28f05d17e052ff9$var$u, $e28f05d17e052ff9$var$i, $e28f05d17e052ff9$var$o = 0, $e28f05d17e052ff9$var$f = [], $e28f05d17e052ff9$var$c = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2), $e28f05d17e052ff9$var$e = $e28f05d17e052ff9$var$c.__b, $e28f05d17e052ff9$var$a = $e28f05d17e052ff9$var$c.__r, $e28f05d17e052ff9$var$v = $e28f05d17e052ff9$var$c.diffed, $e28f05d17e052ff9$var$l = $e28f05d17e052ff9$var$c.__c, $e28f05d17e052ff9$var$m = $e28f05d17e052ff9$var$c.unmount, $e28f05d17e052ff9$var$s = $e28f05d17e052ff9$var$c.__;
function $e28f05d17e052ff9$var$p(n, t) {
    $e28f05d17e052ff9$var$c.__h && $e28f05d17e052ff9$var$c.__h($e28f05d17e052ff9$var$r, n, $e28f05d17e052ff9$var$o || t), $e28f05d17e052ff9$var$o = 0;
    var u = $e28f05d17e052ff9$var$r.__H || ($e28f05d17e052ff9$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $e28f05d17e052ff9$export$60241385465d0a34(n) {
    return $e28f05d17e052ff9$var$o = 1, $e28f05d17e052ff9$export$13e3392192263954($e28f05d17e052ff9$var$D, n);
}
function $e28f05d17e052ff9$export$13e3392192263954(n, u, i) {
    var o = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e28f05d17e052ff9$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e28f05d17e052ff9$var$r, !$e28f05d17e052ff9$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $e28f05d17e052ff9$var$r.__f = !0;
        var c = $e28f05d17e052ff9$var$r.shouldComponentUpdate, e = $e28f05d17e052ff9$var$r.componentWillUpdate;
        $e28f05d17e052ff9$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e28f05d17e052ff9$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e28f05d17e052ff9$export$6d9c69b0de29b591(n, u) {
    var i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 3);
    !$e28f05d17e052ff9$var$c.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.u = u, $e28f05d17e052ff9$var$r.__H.__h.push(i));
}
function $e28f05d17e052ff9$export$e5c5a5f917a5871c(n, u) {
    var i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 4);
    !$e28f05d17e052ff9$var$c.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.u = u, $e28f05d17e052ff9$var$r.__h.push(i));
}
function $e28f05d17e052ff9$export$b8f5890fc79d6aca(n) {
    return $e28f05d17e052ff9$var$o = 5, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e28f05d17e052ff9$export$d5a552a76deda3c2(n, t, r) {
    $e28f05d17e052ff9$var$o = 6, $e28f05d17e052ff9$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $e28f05d17e052ff9$export$1538c33de8887b59(n, r) {
    var u = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 7);
    return $e28f05d17e052ff9$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $e28f05d17e052ff9$export$35808ee640e87ca7(n, t) {
    return $e28f05d17e052ff9$var$o = 8, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e28f05d17e052ff9$export$fae74005e78b1a27(n) {
    var u = $e28f05d17e052ff9$var$r.context[n.__c], i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e28f05d17e052ff9$var$r)), u.props.value) : n.__;
}
function $e28f05d17e052ff9$export$dc8fbce3eb94dc1e(n, t) {
    $e28f05d17e052ff9$var$c.useDebugValue && $e28f05d17e052ff9$var$c.useDebugValue(t ? t(n) : n);
}
function $e28f05d17e052ff9$export$c052f6604b7d51fe(n) {
    var u = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 10), i = $e28f05d17e052ff9$export$60241385465d0a34();
    return u.__ = n, $e28f05d17e052ff9$var$r.componentDidCatch || ($e28f05d17e052ff9$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e28f05d17e052ff9$export$f680877a34711e37() {
    var n = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 11);
    if (!n.__) {
        for(var u = $e28f05d17e052ff9$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e28f05d17e052ff9$var$j() {
    for(var n; n = $e28f05d17e052ff9$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($e28f05d17e052ff9$var$z), n.__H.__h.forEach($e28f05d17e052ff9$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $e28f05d17e052ff9$var$c.__e(t, n.__v);
    }
}
$e28f05d17e052ff9$var$c.__b = function(n) {
    $e28f05d17e052ff9$var$r = null, $e28f05d17e052ff9$var$e && $e28f05d17e052ff9$var$e(n);
}, $e28f05d17e052ff9$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e28f05d17e052ff9$var$s && $e28f05d17e052ff9$var$s(n, t);
}, $e28f05d17e052ff9$var$c.__r = function(n) {
    $e28f05d17e052ff9$var$a && $e28f05d17e052ff9$var$a(n), $e28f05d17e052ff9$var$t = 0;
    var i = ($e28f05d17e052ff9$var$r = n.__c).__H;
    i && ($e28f05d17e052ff9$var$u === $e28f05d17e052ff9$var$r ? (i.__h = [], $e28f05d17e052ff9$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($e28f05d17e052ff9$var$z), i.__h.forEach($e28f05d17e052ff9$var$B), i.__h = [], $e28f05d17e052ff9$var$t = 0)), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r;
}, $e28f05d17e052ff9$var$c.diffed = function(n) {
    $e28f05d17e052ff9$var$v && $e28f05d17e052ff9$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e28f05d17e052ff9$var$f.push(t) && $e28f05d17e052ff9$var$i === $e28f05d17e052ff9$var$c.requestAnimationFrame || (($e28f05d17e052ff9$var$i = $e28f05d17e052ff9$var$c.requestAnimationFrame) || $e28f05d17e052ff9$var$w)($e28f05d17e052ff9$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r = null;
}, $e28f05d17e052ff9$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($e28f05d17e052ff9$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e28f05d17e052ff9$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e28f05d17e052ff9$var$c.__e(r, n.__v);
        }
    }), $e28f05d17e052ff9$var$l && $e28f05d17e052ff9$var$l(n, t);
}, $e28f05d17e052ff9$var$c.unmount = function(n) {
    $e28f05d17e052ff9$var$m && $e28f05d17e052ff9$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $e28f05d17e052ff9$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e28f05d17e052ff9$var$c.__e(t, r.__v));
};
var $e28f05d17e052ff9$var$k = "function" == typeof requestAnimationFrame;
function $e28f05d17e052ff9$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e28f05d17e052ff9$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $e28f05d17e052ff9$var$k && (t = requestAnimationFrame(r));
}
function $e28f05d17e052ff9$var$z(n) {
    var t = $e28f05d17e052ff9$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$B(n) {
    var t = $e28f05d17e052ff9$var$r;
    n.__c = n.__(), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e28f05d17e052ff9$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $616f0acd28bd0dc4$var$GoogleIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        "fill-rule": "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#FFF",
        cx: "13",
        cy: "13",
        r: "13"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
        fill: "#4285F4",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
        fill: "#34A853",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
        fill: "#FBBC05",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
        fill: "#EA4335",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 4h18v18H4z"
    })));
}
function $616f0acd28bd0dc4$var$DefaultForm(_ref) {
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref;
    // In order to comply with Google's brand we need to create a different button
    // for the Google Drive plugin
    const isGoogleDrive = pluginName === "Google Drive";
    const onSubmit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        onAuth();
    }, [
        onAuth
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("form", {
        onSubmit: onSubmit
    }, isGoogleDrive ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$GoogleIcon, null), i18n("signInWithGoogle")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
        "data-uppy-super-focusable": true
    }, i18n("authenticateWith", {
        pluginName: pluginName
    })));
}
const $616f0acd28bd0dc4$var$defaultRenderForm = (_ref2)=>{
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$DefaultForm, {
        pluginName: pluginName,
        i18n: i18n,
        onAuth: onAuth
    });
};
function $616f0acd28bd0dc4$export$2e2bcd8739ae039(_ref3) {
    let { loading: loading, pluginName: pluginName, pluginIcon: pluginIcon, i18n: i18n, handleAuth: handleAuth, renderForm: renderForm = $616f0acd28bd0dc4$var$defaultRenderForm } = _ref3;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-auth"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authIcon"
    }, pluginIcon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authTitle"
    }, i18n("authenticateWithTitle", {
        pluginName: pluginName
    })), renderForm({
        pluginName: pluginName,
        i18n: i18n,
        loading: loading,
        onAuth: handleAuth
    }));
}


/* eslint-disable react/destructuring-assignment */ 


function $4ee9dcacd7f26785$export$2e2bcd8739ae039(_ref) {
    let { i18n: i18n, logout: logout, username: username } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, username && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-ProviderBrowser-user",
        key: "username"
    }, username), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        onClick: logout,
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
        key: "logout"
    }, i18n("logOut")));
}



function $48839592a474f204$export$2e2bcd8739ae039(props) {
    const { openFolder: openFolder, title: title, breadcrumbsIcon: breadcrumbsIcon, breadcrumbs: breadcrumbs, i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbs"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbsIcon"
    }, breadcrumbsIcon), breadcrumbs.map((folder, index)=>{
        var _folder$data$name;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
            key: folder.id,
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            onClick: ()=>openFolder(folder.id)
        }, folder.type === "root" ? title : (_folder$data$name = folder.data.name) != null ? _folder$data$name : i18n("unnamed")), breadcrumbs.length === index + 1 ? "" : " / ");
    }));
}


function $6b1b801e011f359f$export$2e2bcd8739ae039(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-header"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser-headerBar", !props.showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
    }, props.showBreadcrumbs && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $48839592a474f204$export$2e2bcd8739ae039), {
        openFolder: props.openFolder,
        breadcrumbs: props.breadcrumbs,
        breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
        title: props.title,
        i18n: props.i18n
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ee9dcacd7f26785$export$2e2bcd8739ae039), {
        logout: props.logout,
        username: props.username,
        i18n: props.i18n
    })));
}




function $aba06cd85441b3f8$var$_extends() {
    return $aba06cd85441b3f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aba06cd85441b3f8$var$_extends.apply(null, arguments);
}
const $aba06cd85441b3f8$var$STYLE_INNER = {
    position: "relative",
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: "100%",
    minHeight: "100%"
};
const $aba06cd85441b3f8$var$STYLE_CONTENT = {
    position: "absolute",
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: "100%",
    overflow: "visible"
};
class $aba06cd85441b3f8$var$VirtualList extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.handleScroll = ()=>{
            this.setState({
                offset: this.base.scrollTop
            });
        };
        this.handleResize = ()=>{
            this.resize();
        };
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener("resize", this.handleResize);
    }
    // TODO: refactor to stable lifecycle method
    // eslint-disable-next-line
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render(_ref) {
        let { data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props } = _ref;
        const { offset: offset, height: height } = this.state;
        // first visible row index
        let start = Math.floor(offset / rowHeight);
        // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight);
        // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        }
        // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4;
        // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$aba06cd85441b3f8$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$aba06cd85441b3f8$var$STYLE_CONTENT,
            top: start * rowHeight
        };
        // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return(// eslint-disable-next-line react/jsx-props-no-spreading
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", $aba06cd85441b3f8$var$_extends({
            onScroll: this.handleScroll
        }, props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleInner
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleContent
        }, selection.map(renderRow)))));
    }
}
var $aba06cd85441b3f8$export$2e2bcd8739ae039 = $aba06cd85441b3f8$var$VirtualList;



/* eslint-disable react/jsx-props-no-spreading */ 



function $eeb730e0d52603b2$var$FileIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: 11,
        height: 14.5,
        viewBox: "0 0 44 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
    }));
}
function $eeb730e0d52603b2$var$FolderIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        style: {
            minWidth: 16,
            marginRight: 3
        },
        viewBox: "0 0 276.157 276.157"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
    }));
}
function $eeb730e0d52603b2$var$VideoIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        style: {
            width: 16,
            marginRight: 4
        },
        viewBox: "0 0 58 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
    }));
}
function $eeb730e0d52603b2$export$2e2bcd8739ae039(_ref) {
    let { itemIconString: itemIconString, alt: alt } = _ref;
    if (itemIconString === null) return null;
    switch(itemIconString){
        case "file":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FileIcon, null);
        case "folder":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FolderIcon, null);
        case "video":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$VideoIcon, null);
        default:
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
                src: itemIconString,
                alt: alt,
                referrerPolicy: "no-referrer",
                loading: "lazy",
                width: 16,
                height: 16
            });
    }
}


function $79441ec2d5893efa$var$GridItem(_ref) {
    var _file$data$name, _file$data$name2;
    let { file: file, toggleCheckbox: toggleCheckbox, className: className, isDisabled: isDisabled, restrictionError: restrictionError, showTitles: showTitles, children: children = null, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled && restrictionError ? restrictionError : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox uppy-ProviderBrowserItem-checkbox--grid",
        onChange: toggleCheckbox,
        name: "listitem",
        id: file.id,
        checked: file.status === "checked",
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: file.id,
        "aria-label": (_file$data$name = file.data.name) != null ? _file$data$name : i18n("unnamed"),
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.thumbnail || file.data.icon
    }), showTitles && ((_file$data$name2 = file.data.name) != null ? _file$data$name2 : i18n("unnamed")), children));
}
var $79441ec2d5893efa$export$2e2bcd8739ae039 = $79441ec2d5893efa$var$GridItem;




function $9b946df2ba2b33d0$export$2e2bcd8739ae039(_ref) {
    var _file$data$name, _file$data$name2, _file$data$name3;
    let { file: file, openFolder: openFolder, className: className, isDisabled: isDisabled, restrictionError: restrictionError, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: file.status !== "checked" && restrictionError ? restrictionError : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox",
        onChange: toggleCheckbox,
        name: "listitem",
        id: file.id,
        checked: file.status === "checked",
        "aria-label": file.data.isFolder ? i18n("allFilesFromFolderNamed", {
            name: (_file$data$name = file.data.name) != null ? _file$data$name : i18n("unnamed")
        }) : null,
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), file.data.isFolder ? // button to open a folder
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
        onClick: ()=>openFolder(file.id),
        "aria-label": i18n("openFolderNamed", {
            name: (_file$data$name2 = file.data.name) != null ? _file$data$name2 : i18n("unnamed")
        })
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.icon
    })), showTitles && file.data.name ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, file.data.name) : i18n("unnamed")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: file.id,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.icon
    })), showTitles && ((_file$data$name3 = file.data.name) != null ? _file$data$name3 : i18n("unnamed"))));
}


function $7f388d6d579fe299$export$2e2bcd8739ae039(props) {
    const { viewType: viewType, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n, openFolder: openFolder, file: file, utmSource: utmSource } = props;
    const restrictionError = file.type === "folder" ? null : file.restrictionError;
    const isDisabled = !!restrictionError && file.status !== "checked";
    const ourProps = {
        file: file,
        openFolder: openFolder,
        toggleCheckbox: toggleCheckbox,
        utmSource: utmSource,
        i18n: i18n,
        viewType: viewType,
        showTitles: showTitles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowserItem", {
            "uppy-ProviderBrowserItem--disabled": isDisabled
        }, {
            "uppy-ProviderBrowserItem--noPreview": file.data.icon === "video"
        }, {
            "uppy-ProviderBrowserItem--is-checked": file.status === "checked"
        }, {
            "uppy-ProviderBrowserItem--is-partial": file.status === "partial"
        }),
        isDisabled: isDisabled,
        restrictionError: restrictionError
    };
    switch(viewType){
        case "grid":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), ourProps);
        case "list":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9b946df2ba2b33d0$export$2e2bcd8739ae039), ourProps);
        case "unsplash":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), ourProps, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
                href: `${file.data.author.url}?utm_source=${utmSource}&utm_medium=referral`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "uppy-ProviderBrowserItem-author",
                tabIndex: -1
            }, file.data.author.name));
        default:
            throw new Error(`There is no such type ${viewType}`);
    }
}


function $ffc120143b595bcb$var$Browser(props) {
    const { displayedPartialTree: displayedPartialTree, viewType: viewType, toggleCheckbox: toggleCheckbox, handleScroll: handleScroll, showTitles: showTitles, i18n: i18n, isLoading: isLoading, openFolder: openFolder, noResultsLabel: noResultsLabel, virtualList: virtualList, utmSource: utmSource } = props;
    const [isShiftKeyPressed, setIsShiftKeyPressed] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(false);
    // This records whether the user is holding the SHIFT key this very moment.
    // Typically, this is implemented using `onClick((e) => e.shiftKey)` -
    // however we can't use that, because for accessibility reasons
    // we're using html tags that don't support `e.shiftKey` property (see #3768).
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const handleKeyUp = (e)=>{
            if (e.key === "Shift") setIsShiftKeyPressed(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === "Shift") setIsShiftKeyPressed(true);
        };
        document.addEventListener("keyup", handleKeyUp);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keyup", handleKeyUp);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    if (isLoading) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-loading"
    }, typeof isLoading === "string" ? isLoading : i18n("loading"));
    if (displayedPartialTree.length === 0) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-empty"
    }, noResultsLabel);
    const renderItem = (item)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7f388d6d579fe299$export$2e2bcd8739ae039), {
            viewType: viewType,
            toggleCheckbox: (event)=>{
                var _document$getSelectio;
                event.stopPropagation();
                event.preventDefault();
                // Prevent shift-clicking from highlighting file names
                // (https://stackoverflow.com/a/1527797/3192470)
                (_document$getSelectio = document.getSelection()) == null || _document$getSelectio.removeAllRanges();
                toggleCheckbox(item, isShiftKeyPressed);
            },
            showTitles: showTitles,
            i18n: i18n,
            openFolder: openFolder,
            file: item,
            utmSource: utmSource
        });
    if (virtualList) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-body"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
        className: "uppy-ProviderBrowser-list"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        data: displayedPartialTree,
        renderRow: renderItem,
        rowHeight: 31
    })));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-body"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
        className: "uppy-ProviderBrowser-list",
        onScroll: handleScroll,
        role: "listbox",
        tabIndex: -1
    }, displayedPartialTree.map(renderItem)));
}
var $ffc120143b595bcb$export$2e2bcd8739ae039 = $ffc120143b595bcb$var$Browser;


const $75b69938e29d602a$var$afterOpenFolder = (oldPartialTree, discoveredItems, clickedFolder, currentPagePath, validateSingleFile)=>{
    const discoveredFolders = discoveredItems.filter((i)=>i.isFolder === true);
    const discoveredFiles = discoveredItems.filter((i)=>i.isFolder === false);
    const isParentFolderChecked = clickedFolder.type === "folder" && clickedFolder.status === "checked";
    const folders = discoveredFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? "checked" : "unchecked",
            parentId: clickedFolder.id,
            data: folder
        }));
    const files = discoveredFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? "checked" : "unchecked",
            parentId: clickedFolder.id,
            data: file
        };
    });
    // just doing `clickedFolder.cached = true` in a non-mutating way
    const updatedClickedFolder = {
        ...clickedFolder,
        cached: true,
        nextPagePath: currentPagePath
    };
    const partialTreeWithUpdatedClickedFolder = oldPartialTree.map((folder)=>folder.id === updatedClickedFolder.id ? updatedClickedFolder : folder);
    const newPartialTree = [
        ...partialTreeWithUpdatedClickedFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $75b69938e29d602a$export$2e2bcd8739ae039 = $75b69938e29d602a$var$afterOpenFolder;


const $6157a596a45fd763$var$afterScrollFolder = (oldPartialTree, currentFolderId, items, nextPagePath, validateSingleFile)=>{
    const currentFolder = oldPartialTree.find((i)=>i.id === currentFolderId);
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    // just doing `scrolledFolder.nextPagePath = ...` in a non-mutating way
    const scrolledFolder = {
        ...currentFolder,
        nextPagePath: nextPagePath
    };
    const partialTreeWithUpdatedScrolledFolder = oldPartialTree.map((folder)=>folder.id === scrolledFolder.id ? scrolledFolder : folder);
    const isParentFolderChecked = scrolledFolder.type === "folder" && scrolledFolder.status === "checked";
    const folders = newFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? "checked" : "unchecked",
            parentId: scrolledFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? "checked" : "unchecked",
            parentId: scrolledFolder.id,
            data: file
        };
    });
    const newPartialTree = [
        ...partialTreeWithUpdatedScrolledFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $6157a596a45fd763$export$2e2bcd8739ae039 = $6157a596a45fd763$var$afterScrollFolder;


/* eslint-disable no-param-reassign */ /**
 * One-level copying is sufficient as mutations within our `partialTree` are limited to properties
 * such as `.status`, `.cached`, `.nextPagePath`, and not `.data = { THIS }`.
 */ const $ca2a09feaf67815d$var$shallowClone = (partialTree)=>{
    return partialTree.map((item)=>({
            ...item
        }));
};
var $ca2a09feaf67815d$export$2e2bcd8739ae039 = $ca2a09feaf67815d$var$shallowClone;


/*
  FROM        | TO

  root        |  root
    folder    |    folder
    folder ✅︎  |    folder ✅︎
      file    |      file ✅︎
      file    |      file ✅︎
      folder  |      folder ✅︎
        file  |        file ✅︎
    file      |    file
    file      |    file
*/ const $28868daa484a498f$var$percolateDown = (tree, id, shouldMarkAsChecked)=>{
    const children = tree.filter((item)=>item.type !== "root" && item.parentId === id);
    children.forEach((item)=>{
        item.status = shouldMarkAsChecked && !(item.type === "file" && item.restrictionError) ? "checked" : "unchecked";
        $28868daa484a498f$var$percolateDown(tree, item.id, shouldMarkAsChecked);
    });
};
/*
  FROM         | TO

  root         |  root
    folder     |    folder
    folder     |    folder [▬] ('partial' status)
      file     |      file
      folder   |      folder ✅︎
        file ✅︎ |       file ✅︎
    file       |    file
    file       |    file
*/ const $28868daa484a498f$var$percolateUp = (tree, id)=>{
    const folder = tree.find((item)=>item.id === id);
    if (folder.type === "root") return;
    const validChildren = tree.filter((item)=>// is a child
        item.type !== "root" && item.parentId === folder.id && // does pass validations
        !(item.type === "file" && item.restrictionError));
    const areAllChildrenChecked = validChildren.every((item)=>item.status === "checked");
    const areAllChildrenUnchecked = validChildren.every((item)=>item.status === "unchecked");
    if (areAllChildrenChecked) folder.status = "checked";
    else if (areAllChildrenUnchecked) folder.status = "unchecked";
    else folder.status = "partial";
    $28868daa484a498f$var$percolateUp(tree, folder.parentId);
};
const $28868daa484a498f$var$afterToggleCheckbox = (oldTree, clickedRange)=>{
    const tree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(oldTree);
    if (clickedRange.length >= 2) {
        // We checked two or more items
        const newlyCheckedItems = tree.filter((item)=>item.type !== "root" && clickedRange.includes(item.id));
        newlyCheckedItems.forEach((item)=>{
            if (item.type === "file") item.status = item.restrictionError ? "unchecked" : "checked";
            else item.status = "checked";
        });
        newlyCheckedItems.forEach((item)=>{
            $28868daa484a498f$var$percolateDown(tree, item.id, true);
        });
        $28868daa484a498f$var$percolateUp(tree, newlyCheckedItems[0].parentId);
    } else {
        // We checked exactly one item
        const clickedItem = tree.find((item)=>item.id === clickedRange[0]);
        clickedItem.status = clickedItem.status === "checked" ? "unchecked" : "checked";
        $28868daa484a498f$var$percolateDown(tree, clickedItem.id, clickedItem.status === "checked");
        $28868daa484a498f$var$percolateUp(tree, clickedItem.parentId);
    }
    return tree;
};
var $28868daa484a498f$export$2e2bcd8739ae039 = $28868daa484a498f$var$afterToggleCheckbox;


/* eslint-disable no-param-reassign */ // p-queue does not have a `"main"` field in its `package.json`, and that makes `import/no-unresolved` freak out.
// We can safely ignore it because bundlers will happily use the `"exports"` field instead.
// eslint-disable-next-line import/no-unresolved
var $d71e659823218cf6$exports = {};
"use strict";
var $d71e659823218cf6$var$has = Object.prototype.hasOwnProperty, $d71e659823218cf6$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d71e659823218cf6$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d71e659823218cf6$var$Events().__proto__) $d71e659823218cf6$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d71e659823218cf6$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $d71e659823218cf6$var$EE(fn, context || emitter, once), evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d71e659823218cf6$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d71e659823218cf6$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d71e659823218cf6$var$EventEmitter() {
    this._events = new $d71e659823218cf6$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d71e659823218cf6$var$has.call(events, name)) names.push($d71e659823218cf6$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d71e659823218cf6$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d71e659823218cf6$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
        if (this._events[evt]) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        this._events = new $d71e659823218cf6$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d71e659823218cf6$var$EventEmitter.prototype.off = $d71e659823218cf6$var$EventEmitter.prototype.removeListener;
$d71e659823218cf6$var$EventEmitter.prototype.addListener = $d71e659823218cf6$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d71e659823218cf6$var$EventEmitter.prefixed = $d71e659823218cf6$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d71e659823218cf6$var$EventEmitter.EventEmitter = $d71e659823218cf6$var$EventEmitter;
$d71e659823218cf6$exports = $d71e659823218cf6$var$EventEmitter;


var $d2ed3f8017184c07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($d71e659823218cf6$exports)));


class $46025477665dcc7c$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
}
class $46025477665dcc7c$export$18b052ffd8c84d7 extends Error {
    constructor(message){
        super();
        this.name = "AbortError";
        this.message = message;
    }
}
/**
TODO: Remove AbortError and just throw DOMException when targeting Node 18.
*/ const $46025477665dcc7c$var$getDOMException = (errorMessage)=>globalThis.DOMException === undefined ? new $46025477665dcc7c$export$18b052ffd8c84d7(errorMessage) : new DOMException(errorMessage);
/**
TODO: Remove below function and just 'reject(signal.reason)' when targeting Node 18.
*/ const $46025477665dcc7c$var$getAbortedReason = (signal)=>{
    const reason = signal.reason === undefined ? $46025477665dcc7c$var$getDOMException("This operation was aborted.") : signal.reason;
    return reason instanceof Error ? reason : $46025477665dcc7c$var$getDOMException(reason);
};
function $46025477665dcc7c$export$2e2bcd8739ae039(promise, options) {
    const { milliseconds: milliseconds, fallback: fallback, message: message, customTimers: customTimers = {
        setTimeout: setTimeout,
        clearTimeout: clearTimeout
    } } = options;
    let timer;
    let abortHandler;
    const wrappedPromise = new Promise((resolve, reject)=>{
        if (typeof milliseconds !== "number" || Math.sign(milliseconds) !== 1) throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
        if (options.signal) {
            const { signal: signal } = options;
            if (signal.aborted) reject($46025477665dcc7c$var$getAbortedReason(signal));
            abortHandler = ()=>{
                reject($46025477665dcc7c$var$getAbortedReason(signal));
            };
            signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
        if (milliseconds === Number.POSITIVE_INFINITY) {
            promise.then(resolve, reject);
            return;
        }
        // We create the error outside of `setTimeout` to preserve the stack trace.
        const timeoutError = new $46025477665dcc7c$export$66d311bf29d5c89c();
        timer = customTimers.setTimeout.call(undefined, ()=>{
            if (fallback) {
                try {
                    resolve(fallback());
                } catch (error) {
                    reject(error);
                }
                return;
            }
            if (typeof promise.cancel === "function") promise.cancel();
            if (message === false) resolve();
            else if (message instanceof Error) reject(message);
            else {
                timeoutError.message = message ?? `Promise timed out after ${milliseconds} milliseconds`;
                reject(timeoutError);
            }
        }, milliseconds);
        (async ()=>{
            try {
                resolve(await promise);
            } catch (error) {
                reject(error);
            }
        })();
    });
    const cancelablePromise = wrappedPromise.finally(()=>{
        cancelablePromise.clear();
        if (abortHandler && options.signal) options.signal.removeEventListener("abort", abortHandler);
    });
    cancelablePromise.clear = ()=>{
        customTimers.clearTimeout.call(undefined, timer);
        timer = undefined;
    };
    return cancelablePromise;
}


// Port of lower_bound from https://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion
function $6829868fc187eefd$export$2e2bcd8739ae039(array, value, comparator) {
    let first = 0;
    let count = array.length;
    while(count > 0){
        const step = Math.trunc(count / 2);
        let it = first + step;
        if (comparator(array[it], value) <= 0) {
            first = ++it;
            count -= step + 1;
        } else count = step;
    }
    return first;
}


class $17cf7ddbaf767759$export$2e2bcd8739ae039 {
    #queue = [];
    enqueue(run, options) {
        options = {
            priority: 0,
            ...options
        };
        const element = {
            priority: options.priority,
            id: options.id,
            run: run
        };
        if (this.size === 0 || this.#queue[this.size - 1].priority >= options.priority) {
            this.#queue.push(element);
            return;
        }
        const index = (0, $6829868fc187eefd$export$2e2bcd8739ae039)(this.#queue, element, (a, b)=>b.priority - a.priority);
        this.#queue.splice(index, 0, element);
    }
    setPriority(id, priority) {
        const index = this.#queue.findIndex((element)=>element.id === id);
        if (index === -1) throw new ReferenceError(`No promise function with the id "${id}" exists in the queue.`);
        const [item] = this.#queue.splice(index, 1);
        this.enqueue(item.run, {
            priority: priority,
            id: id
        });
    }
    dequeue() {
        const item = this.#queue.shift();
        return item?.run;
    }
    filter(options) {
        return this.#queue.filter((element)=>element.priority === options.priority).map((element)=>element.run);
    }
    get size() {
        return this.#queue.length;
    }
}


class $d92c5526fb6f64bf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($d71e659823218cf6$exports))) {
    #carryoverConcurrencyCount;
    #isIntervalIgnored;
    #intervalCount = 0;
    #intervalCap;
    #interval;
    #intervalEnd = 0;
    #intervalId;
    #timeoutId;
    #queue;
    #queueClass;
    #pending = 0;
    // The `!` is needed because of https://github.com/microsoft/TypeScript/issues/32194
    #concurrency;
    #isPaused;
    #throwOnTimeout;
    // Use to assign a unique identifier to a promise function, if not explicitly specified
    #idAssigner = 1n;
    /**
    Per-operation timeout in milliseconds. Operations fulfill once `timeout` elapses if they haven't already.

    Applies to each future operation.
    */ timeout;
    // TODO: The `throwOnTimeout` option should affect the return types of `add()` and `addAll()`
    constructor(options){
        super();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        options = {
            carryoverConcurrencyCount: false,
            intervalCap: Number.POSITIVE_INFINITY,
            interval: 0,
            concurrency: Number.POSITIVE_INFINITY,
            autoStart: true,
            queueClass: (0, $17cf7ddbaf767759$export$2e2bcd8739ae039),
            ...options
        };
        if (!(typeof options.intervalCap === "number" && options.intervalCap >= 1)) throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${options.intervalCap?.toString() ?? ""}\` (${typeof options.intervalCap})`);
        if (options.interval === undefined || !(Number.isFinite(options.interval) && options.interval >= 0)) throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${options.interval?.toString() ?? ""}\` (${typeof options.interval})`);
        this.#carryoverConcurrencyCount = options.carryoverConcurrencyCount;
        this.#isIntervalIgnored = options.intervalCap === Number.POSITIVE_INFINITY || options.interval === 0;
        this.#intervalCap = options.intervalCap;
        this.#interval = options.interval;
        this.#queue = new options.queueClass();
        this.#queueClass = options.queueClass;
        this.concurrency = options.concurrency;
        this.timeout = options.timeout;
        this.#throwOnTimeout = options.throwOnTimeout === true;
        this.#isPaused = options.autoStart === false;
    }
    get #doesIntervalAllowAnother() {
        return this.#isIntervalIgnored || this.#intervalCount < this.#intervalCap;
    }
    get #doesConcurrentAllowAnother() {
        return this.#pending < this.#concurrency;
    }
    #next() {
        this.#pending--;
        this.#tryToStartAnother();
        this.emit("next");
    }
    #onResumeInterval() {
        this.#onInterval();
        this.#initializeIntervalIfNeeded();
        this.#timeoutId = undefined;
    }
    get #isIntervalPaused() {
        const now = Date.now();
        if (this.#intervalId === undefined) {
            const delay = this.#intervalEnd - now;
            if (delay < 0) // Act as the interval was done
            // We don't need to resume it here because it will be resumed on line 160
            this.#intervalCount = this.#carryoverConcurrencyCount ? this.#pending : 0;
            else {
                // Act as the interval is pending
                if (this.#timeoutId === undefined) this.#timeoutId = setTimeout(()=>{
                    this.#onResumeInterval();
                }, delay);
                return true;
            }
        }
        return false;
    }
    #tryToStartAnother() {
        if (this.#queue.size === 0) {
            // We can clear the interval ("pause")
            // Because we can redo it later ("resume")
            if (this.#intervalId) clearInterval(this.#intervalId);
            this.#intervalId = undefined;
            this.emit("empty");
            if (this.#pending === 0) this.emit("idle");
            return false;
        }
        if (!this.#isPaused) {
            const canInitializeInterval = !this.#isIntervalPaused;
            if (this.#doesIntervalAllowAnother && this.#doesConcurrentAllowAnother) {
                const job = this.#queue.dequeue();
                if (!job) return false;
                this.emit("active");
                job();
                if (canInitializeInterval) this.#initializeIntervalIfNeeded();
                return true;
            }
        }
        return false;
    }
    #initializeIntervalIfNeeded() {
        if (this.#isIntervalIgnored || this.#intervalId !== undefined) return;
        this.#intervalId = setInterval(()=>{
            this.#onInterval();
        }, this.#interval);
        this.#intervalEnd = Date.now() + this.#interval;
    }
    #onInterval() {
        if (this.#intervalCount === 0 && this.#pending === 0 && this.#intervalId) {
            clearInterval(this.#intervalId);
            this.#intervalId = undefined;
        }
        this.#intervalCount = this.#carryoverConcurrencyCount ? this.#pending : 0;
        this.#processQueue();
    }
    /**
    Executes all queued functions until it reaches the limit.
    */ #processQueue() {
        // eslint-disable-next-line no-empty
        while(this.#tryToStartAnother());
    }
    get concurrency() {
        return this.#concurrency;
    }
    set concurrency(newConcurrency) {
        if (!(typeof newConcurrency === "number" && newConcurrency >= 1)) throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
        this.#concurrency = newConcurrency;
        this.#processQueue();
    }
    async #throwOnAbort(signal) {
        return new Promise((_resolve, reject)=>{
            signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            }, {
                once: true
            });
        });
    }
    /**
    Updates the priority of a promise function by its id, affecting its execution order. Requires a defined concurrency limit to take effect.

    For example, this can be used to prioritize a promise function to run earlier.

    ```js
    import PQueue from 'p-queue';

    const queue = new PQueue({concurrency: 1});

    queue.add(async () => '🦄', {priority: 1});
    queue.add(async () => '🦀', {priority: 0, id: '🦀'});
    queue.add(async () => '🦄', {priority: 1});
    queue.add(async () => '🦄', {priority: 1});

    queue.setPriority('🦀', 2);
    ```

    In this case, the promise function with `id: '🦀'` runs second.

    You can also deprioritize a promise function to delay its execution:

    ```js
    import PQueue from 'p-queue';

    const queue = new PQueue({concurrency: 1});

    queue.add(async () => '🦄', {priority: 1});
    queue.add(async () => '🦀', {priority: 1, id: '🦀'});
    queue.add(async () => '🦄');
    queue.add(async () => '🦄', {priority: 0});

    queue.setPriority('🦀', -1);
    ```
    Here, the promise function with `id: '🦀'` executes last.
    */ setPriority(id, priority) {
        this.#queue.setPriority(id, priority);
    }
    async add(function_, options = {}) {
        // In case `id` is not defined.
        options.id ??= (this.#idAssigner++).toString();
        options = {
            timeout: this.timeout,
            throwOnTimeout: this.#throwOnTimeout,
            ...options
        };
        return new Promise((resolve, reject)=>{
            this.#queue.enqueue(async ()=>{
                this.#pending++;
                this.#intervalCount++;
                try {
                    options.signal?.throwIfAborted();
                    let operation = function_({
                        signal: options.signal
                    });
                    if (options.timeout) operation = (0, $46025477665dcc7c$export$2e2bcd8739ae039)(Promise.resolve(operation), {
                        milliseconds: options.timeout
                    });
                    if (options.signal) operation = Promise.race([
                        operation,
                        this.#throwOnAbort(options.signal)
                    ]);
                    const result = await operation;
                    resolve(result);
                    this.emit("completed", result);
                } catch (error) {
                    if (error instanceof (0, $46025477665dcc7c$export$66d311bf29d5c89c) && !options.throwOnTimeout) {
                        resolve();
                        return;
                    }
                    reject(error);
                    this.emit("error", error);
                } finally{
                    this.#next();
                }
            }, options);
            this.emit("add");
            this.#tryToStartAnother();
        });
    }
    async addAll(functions, options) {
        return Promise.all(functions.map(async (function_)=>this.add(function_, options)));
    }
    /**
    Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
    */ start() {
        if (!this.#isPaused) return this;
        this.#isPaused = false;
        this.#processQueue();
        return this;
    }
    /**
    Put queue execution on hold.
    */ pause() {
        this.#isPaused = true;
    }
    /**
    Clear the queue.
    */ clear() {
        this.#queue = new this.#queueClass();
    }
    /**
    Can be called multiple times. Useful if you for example add additional items at a later time.

    @returns A promise that settles when the queue becomes empty.
    */ async onEmpty() {
        // Instantly resolve if the queue is empty
        if (this.#queue.size === 0) return;
        await this.#onEvent("empty");
    }
    /**
    @returns A promise that settles when the queue size is less than the given limit: `queue.size < limit`.

    If you want to avoid having the queue grow beyond a certain size you can `await queue.onSizeLessThan()` before adding a new item.

    Note that this only limits the number of items waiting to start. There could still be up to `concurrency` jobs already running that this call does not include in its calculation.
    */ async onSizeLessThan(limit) {
        // Instantly resolve if the queue is empty.
        if (this.#queue.size < limit) return;
        await this.#onEvent("next", ()=>this.#queue.size < limit);
    }
    /**
    The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.

    @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
    */ async onIdle() {
        // Instantly resolve if none pending and if nothing else is queued
        if (this.#pending === 0 && this.#queue.size === 0) return;
        await this.#onEvent("idle");
    }
    async #onEvent(event, filter) {
        return new Promise((resolve)=>{
            const listener = ()=>{
                if (filter && !filter()) return;
                this.off(event, listener);
                resolve();
            };
            this.on(event, listener);
        });
    }
    /**
    Size of the queue, the number of queued items waiting to run.
    */ get size() {
        return this.#queue.size;
    }
    /**
    Size of the queue, filtered by the given options.

    For example, this can be used to find the number of items remaining in the queue with a specific priority level.
    */ sizeBy(options) {
        // eslint-disable-next-line unicorn/no-array-callback-reference
        return this.#queue.filter(options).length;
    }
    /**
    Number of running items (no longer in the queue).
    */ get pending() {
        return this.#pending;
    }
    /**
    Whether the queue is currently paused.
    */ get isPaused() {
        return this.#isPaused;
    }
}



const $742a2dde4df138bd$var$recursivelyFetch = async (queue, poorTree, poorFolder, apiList, validateSingleFile)=>{
    let items = [];
    let currentPath = poorFolder.cached ? poorFolder.nextPagePath : poorFolder.id;
    while(currentPath){
        const response = await apiList(currentPath);
        items = items.concat(response.items);
        currentPath = response.nextPagePath;
    }
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    const folders = newFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: "checked",
            parentId: poorFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: restrictionError ? "unchecked" : "checked",
            parentId: poorFolder.id,
            data: file
        };
    });
    poorFolder.cached = true;
    poorFolder.nextPagePath = null;
    poorTree.push(...files, ...folders);
    folders.forEach(async (folder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, folder, apiList, validateSingleFile));
    });
};
const $742a2dde4df138bd$var$afterFill = async (partialTree, apiList, validateSingleFile, reportProgress)=>{
    const queue = new (0, $d92c5526fb6f64bf$export$2e2bcd8739ae039)({
        concurrency: 6
    });
    // fill up the missing parts of a partialTree!
    const poorTree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(partialTree);
    const poorFolders = poorTree.filter((item)=>item.type === "folder" && item.status === "checked" && // either "not yet cached at all" or "some pages are left to fetch"
        (item.cached === false || item.nextPagePath));
    // per each poor folder, recursively fetch all files and make them .checked!
    poorFolders.forEach((poorFolder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, poorFolder, apiList, validateSingleFile));
    });
    queue.on("completed", ()=>{
        const nOfFilesChecked = poorTree.filter((i)=>i.type === "file" && i.status === "checked").length;
        reportProgress(nOfFilesChecked);
    });
    await queue.onIdle();
    return poorTree;
};
var $742a2dde4df138bd$export$2e2bcd8739ae039 = $742a2dde4df138bd$var$afterFill;


var $561f5272d8ac5b76$export$2e2bcd8739ae039 = {
    afterOpenFolder: $75b69938e29d602a$export$2e2bcd8739ae039,
    afterScrollFolder: $6157a596a45fd763$export$2e2bcd8739ae039,
    afterToggleCheckbox: $28868daa484a498f$export$2e2bcd8739ae039,
    afterFill: $742a2dde4df138bd$export$2e2bcd8739ae039
};


const $b5a8e6b281aacb12$var$shouldHandleScroll = (event)=>{
    const { scrollHeight: scrollHeight, scrollTop: scrollTop, offsetHeight: offsetHeight } = event.target;
    const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
    return scrollPosition < 50;
};
var $b5a8e6b281aacb12$export$2e2bcd8739ae039 = $b5a8e6b281aacb12$var$shouldHandleScroll;


const $4ac650d5250ead28$var$handleError = (uppy)=>(error)=>{
        // authError just means we're not authenticated, don't report it
        if (error.isAuthError) return;
        // AbortError means the user has clicked "cancel" on an operation
        if (error.name === "AbortError") {
            uppy.log("Aborting request", "warning");
            return;
        }
        uppy.log(error, "error");
        if (error.name === "UserFacingApiError") uppy.info({
            message: uppy.i18n("companionError"),
            details: uppy.i18n(error.message)
        }, "warning", 5000);
    };
var $4ac650d5250ead28$export$2e2bcd8739ae039 = $4ac650d5250ead28$var$handleError;


// Shift-clicking selects a single consecutive list of items
// starting at the previous click.
const $3af8f69ec184395c$var$getClickedRange = (clickedId, displayedPartialTree, isShiftKeyPressed, lastCheckbox)=>{
    const lastCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === lastCheckbox);
    if (lastCheckboxIndex !== -1 && isShiftKeyPressed) {
        const newCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === clickedId);
        const clickedRange = displayedPartialTree.slice(Math.min(lastCheckboxIndex, newCheckboxIndex), Math.max(lastCheckboxIndex, newCheckboxIndex) + 1);
        return clickedRange.map((item)=>item.id);
    }
    return [
        clickedId
    ];
};
var $3af8f69ec184395c$export$2e2bcd8739ae039 = $3af8f69ec184395c$var$getClickedRange;





function $f173600a8ed11ef3$var$SearchInput(_ref) {
    let { searchString: searchString, setSearchString: setSearchString, submitSearchString: submitSearchString, wrapperClassName: wrapperClassName, inputClassName: inputClassName, inputLabel: inputLabel, clearSearchLabel: clearSearchLabel = "", showButton: showButton = false, buttonLabel: buttonLabel = "", buttonCSSClassName: buttonCSSClassName = "" } = _ref;
    const onInput = (e)=>{
        setSearchString(e.target.value);
    };
    const submit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        submitSearchString();
    }, [
        submitSearchString
    ]);
    // We do this to avoid nested <form>s
    // (See https://github.com/transloadit/uppy/pull/5050#discussion_r1640392516)
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $af5278daf92376ec$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", submit);
        return ()=>{
            form.removeEventListener("submit", submit);
            document.body.removeChild(form);
        };
    }, [
        form,
        submit
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("section", {
        className: wrapperClassName
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        className: `uppy-u-reset ${inputClassName}`,
        type: "search",
        "aria-label": inputLabel,
        placeholder: inputLabel,
        value: searchString,
        onInput: onInput,
        form: form.id,
        "data-uppy-super-focusable": true
    }), !showButton && // 🔍
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
    })), !showButton && searchString && // ❌
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
        type: "button",
        "aria-label": clearSearchLabel,
        title: clearSearchLabel,
        onClick: ()=>setSearchString("")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        viewBox: "0 0 19 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
    }))), showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
        type: "submit",
        form: form.id
    }, buttonLabel));
}
var $f173600a8ed11ef3$export$2e2bcd8739ae039 = $f173600a8ed11ef3$var$SearchInput;





/**
 * We're interested in all 'checked' leaves of this tree,
 * but we don't yet know how many files there are inside of each checked folder.
 * `getNumberOfSelectedFiles()` returns the most intuitive number we can show to the user
 * in this situation.
 */ const $3599f082ce07508f$var$getNumberOfSelectedFiles = (partialTree)=>{
    const checkedLeaves = partialTree.filter((item)=>{
        if (item.type === "file" && item.status === "checked") return true;
        if (item.type === "folder" && item.status === "checked") {
            const doesItHaveChildren = partialTree.some((i)=>i.type !== "root" && i.parentId === item.id);
            return !doesItHaveChildren;
        }
        return false;
    });
    return checkedLeaves.length;
};
var $3599f082ce07508f$export$2e2bcd8739ae039 = $3599f082ce07508f$var$getNumberOfSelectedFiles;


function $4ab2a94a3ee5ad67$export$2e2bcd8739ae039(_ref) {
    let { cancelSelection: cancelSelection, donePicking: donePicking, i18n: i18n, partialTree: partialTree, validateAggregateRestrictions: validateAggregateRestrictions } = _ref;
    const aggregateRestrictionError = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return validateAggregateRestrictions(partialTree);
    }, [
        partialTree,
        validateAggregateRestrictions
    ]);
    const nOfSelectedFiles = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return (0, $3599f082ce07508f$export$2e2bcd8739ae039)(partialTree);
    }, [
        partialTree
    ]);
    if (nOfSelectedFiles === 0) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer-buttons"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset uppy-c-btn uppy-c-btn-primary", {
            "uppy-c-btn--disabled": aggregateRestrictionError
        }),
        disabled: !!aggregateRestrictionError,
        onClick: donePicking,
        type: "button"
    }, i18n("selectX", {
        smart_count: nOfSelectedFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
        onClick: cancelSelection,
        type: "button"
    }, i18n("cancel"))), aggregateRestrictionError && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer-error"
    }, aggregateRestrictionError));
}



// TODO: document what is a "tagFile" or get rid of this concept
const $67e1a0ee3f34a25a$var$getTagFile = (file, plugin, provider)=>{
    var _file$author, _file$author2;
    const tagFile = {
        id: file.id,
        source: plugin.id,
        name: file.name || file.id,
        type: file.mimeType,
        isRemote: true,
        data: file,
        preview: file.thumbnail || undefined,
        meta: {
            authorName: (_file$author = file.author) == null ? void 0 : _file$author.name,
            authorUrl: (_file$author2 = file.author) == null ? void 0 : _file$author2.url,
            // We need to do this `|| null` check, because null value
            // for .relDirPath is `undefined` and for .relativePath is `null`.
            // I do think we should just use `null` everywhere.
            relativePath: file.relDirPath || null,
            absolutePath: file.absDirPath
        },
        body: {
            fileId: file.id
        },
        remote: {
            companionUrl: plugin.opts.companionUrl,
            url: `${provider.fileUrl(file.requestPath)}`,
            body: {
                fileId: file.id
            },
            providerName: provider.name,
            provider: provider.provider,
            requestClientId: provider.provider
        }
    };
    return tagFile;
};
var $67e1a0ee3f34a25a$export$2e2bcd8739ae039 = $67e1a0ee3f34a25a$var$getTagFile;


const $8e91ea798ebec2b3$var$addFiles = (companionFiles, plugin, provider)=>{
    const tagFiles = companionFiles.map((f)=>(0, $67e1a0ee3f34a25a$export$2e2bcd8739ae039)(f, plugin, provider));
    const filesToAdd = [];
    const filesAlreadyAdded = [];
    tagFiles.forEach((tagFile)=>{
        if (plugin.uppy.checkIfFileAlreadyExists((0, $d67267bb9859462b$export$2ff5b23440673856)(tagFile, plugin.uppy.getID()))) filesAlreadyAdded.push(tagFile);
        else filesToAdd.push(tagFile);
    });
    if (filesToAdd.length > 0) plugin.uppy.info(plugin.uppy.i18n("addedNumFiles", {
        numFiles: filesToAdd.length
    }));
    if (filesAlreadyAdded.length > 0) plugin.uppy.info(`Not adding ${filesAlreadyAdded.length} files because they already exist`);
    plugin.uppy.addFiles(filesToAdd);
};
var $8e91ea798ebec2b3$export$2e2bcd8739ae039 = $8e91ea798ebec2b3$var$addFiles;


/* eslint-disable no-param-reassign */ const $9b79bc726c3450f4$var$getPath = (partialTree, id, cache)=>{
    const sId = id === null ? "null" : id;
    if (cache[sId]) return cache[sId];
    const file = partialTree.find((f)=>f.id === id);
    if (file.type === "root") return [];
    const meAndParentPath = [
        ...$9b79bc726c3450f4$var$getPath(partialTree, file.parentId, cache),
        file
    ];
    cache[sId] = meAndParentPath;
    return meAndParentPath;
};
// See "Uppy file properties" documentation for `.absolutePath` and `.relativePath`
// (https://uppy.io/docs/uppy/#working-with-uppy-files)
const $9b79bc726c3450f4$var$getCheckedFilesWithPaths = (partialTree)=>{
    // Equivalent to `const cache = {}`, but makes keys such as 'hasOwnProperty' safe too
    const cache = Object.create(null);
    // We're only interested in injecting paths into 'checked' files
    const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
    const companionFilesWithInjectedPaths = checkedFiles.map((file)=>{
        const absFolders = $9b79bc726c3450f4$var$getPath(partialTree, file.id, cache);
        const firstCheckedFolderIndex = absFolders.findIndex((i)=>i.type === "folder" && i.status === "checked");
        const relFolders = absFolders.slice(firstCheckedFolderIndex);
        const absDirPath = `/${absFolders.map((i)=>i.data.name).join("/")}`;
        const relDirPath = relFolders.length === 1 ? // Must return `undefined` (which later turns into `null` in `.getTagFile()`)
        // (https://github.com/transloadit/uppy/pull/4537#issuecomment-1629136652)
        undefined : relFolders.map((i)=>i.data.name).join("/");
        return {
            ...file.data,
            absDirPath: absDirPath,
            relDirPath: relDirPath
        };
    });
    return companionFilesWithInjectedPaths;
};
var $9b79bc726c3450f4$export$2e2bcd8739ae039 = $9b79bc726c3450f4$var$getCheckedFilesWithPaths;


const $15f8d756dc46e018$var$getBreadcrumbs = (partialTree, currentFolderId)=>{
    let folder = partialTree.find((f)=>f.id === currentFolderId);
    let breadcrumbs = [];
    // eslint-disable-next-line no-constant-condition
    while(true){
        breadcrumbs = [
            folder,
            ...breadcrumbs
        ];
        if (folder.type === "root") break;
        const currentParentId = folder.parentId;
        folder = partialTree.find((f)=>f.id === currentParentId);
    }
    return breadcrumbs;
};
var $15f8d756dc46e018$export$2e2bcd8739ae039 = $15f8d756dc46e018$var$getBreadcrumbs;


function $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $671181bcc8a0cf10$var$id = 0;
function $671181bcc8a0cf10$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $671181bcc8a0cf10$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $671181bcc8a0cf10$var$packageJson = {
    "version": "4.4.3"
};
function $671181bcc8a0cf10$export$b9ab270927e310e4() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
    }));
}
const $671181bcc8a0cf10$var$getDefaultState = (rootFolderId)=>({
        authenticated: undefined,
        // we don't know yet
        partialTree: [
            {
                type: "root",
                id: rootFolderId,
                cached: false,
                nextPagePath: null
            }
        ],
        currentFolderId: rootFolderId,
        searchString: "",
        didFirstRender: false,
        username: null,
        loading: false
    });
var $671181bcc8a0cf10$var$_abortController = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("abortController");
var $671181bcc8a0cf10$var$_withAbort = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("withAbort");
class $671181bcc8a0cf10$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        Object.defineProperty(this, $671181bcc8a0cf10$var$_withAbort, {
            value: $671181bcc8a0cf10$var$_withAbort2
        });
        this.isHandlingScroll = false;
        this.lastCheckbox = null;
        Object.defineProperty(this, $671181bcc8a0cf10$var$_abortController, {
            writable: true,
            value: void 0
        });
        this.validateSingleFile = (file)=>{
            const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
            const result = this.plugin.uppy.validateSingleFile(companionFile);
            return result;
        };
        this.getDisplayedPartialTree = ()=>{
            const { partialTree: partialTree, currentFolderId: currentFolderId, searchString: searchString } = this.plugin.getPluginState();
            const inThisFolder = partialTree.filter((item)=>item.type !== "root" && item.parentId === currentFolderId);
            const filtered = searchString === "" ? inThisFolder : inThisFolder.filter((item)=>{
                var _item$data$name;
                return ((_item$data$name = item.data.name) != null ? _item$data$name : this.plugin.uppy.i18n("unnamed")).toLowerCase().indexOf(searchString.toLowerCase()) !== -1;
            });
            return filtered;
        };
        this.validateAggregateRestrictions = (partialTree)=>{
            const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
            const uppyFiles = checkedFiles.map((file)=>file.data);
            return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        const defaultOptions = {
            viewType: "list",
            showTitles: true,
            showFilter: true,
            showBreadcrumbs: true,
            loadAllFiles: false,
            virtualList: false
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.openFolder = this.openFolder.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.render = this.render.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // todo
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on("dashboard:close-panel", this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    resetPluginState() {
        this.plugin.setPluginState($671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId));
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === "root" ? item : {
                ...item,
                status: "unchecked"
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    async openFolder(folderId) {
        this.lastCheckbox = null;
        // Returning cached folder
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedFolder = partialTree.find((folder)=>folder.id === folderId);
        if (clickedFolder.cached) {
            this.plugin.setPluginState({
                currentFolderId: folderId,
                searchString: ""
            });
            return;
        }
        this.setLoading(true);
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            let currentPagePath = folderId;
            let currentItems = [];
            do {
                const { username: username, nextPagePath: nextPagePath, items: items } = await this.provider.list(currentPagePath, {
                    signal: signal
                });
                // It's important to set the username during one of our first fetches
                this.plugin.setPluginState({
                    username: username
                });
                currentPagePath = nextPagePath;
                currentItems = currentItems.concat(items);
                this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
                    numFiles: currentItems.length
                }));
            }while (this.opts.loadAllFiles && currentPagePath);
            const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterOpenFolder(partialTree, currentItems, clickedFolder, currentPagePath, this.validateSingleFile);
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                currentFolderId: folderId,
                searchString: ""
            });
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    /**
   * Removes session token on client side.
   */ async logout() {
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            const res = await this.provider.logout({
                signal: signal
            });
            // res.ok is from the JSON body, not to be confused with Response.ok
            if (res.ok) {
                if (!res.revoked) {
                    const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
                        provider: this.plugin.title,
                        url: res.manual_revoke_url
                    });
                    this.plugin.uppy.info(message, "info", 7000);
                }
                this.plugin.setPluginState({
                    ...$671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId),
                    authenticated: false
                });
            }
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
    }
    async handleAuth(authFormData) {
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            this.setLoading(true);
            await this.provider.login({
                authFormData: authFormData,
                signal: signal
            });
            this.plugin.setPluginState({
                authenticated: true
            });
            await Promise.all([
                this.provider.fetchPreAuthToken(),
                this.openFolder(this.plugin.rootFolderId)
            ]);
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, currentFolderId: currentFolderId } = this.plugin.getPluginState();
        const currentFolder = partialTree.find((i)=>i.id === currentFolderId);
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && currentFolder.nextPagePath) {
            this.isHandlingScroll = true;
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const { nextPagePath: nextPagePath, items: items } = await this.provider.list(currentFolder.nextPagePath, {
                    signal: signal
                });
                const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterScrollFolder(partialTree, currentFolderId, items, nextPagePath, this.validateSingleFile);
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
            this.isHandlingScroll = false;
        }
    }
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        this.setLoading(true);
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            // 1. Enrich our partialTree by fetching all 'checked' but not-yet-fetched folders
            const enrichedTree = await (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterFill(partialTree, (path)=>this.provider.list(path, {
                    signal: signal
                }), this.validateSingleFile, (n)=>{
                this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                    numFiles: n
                }));
            });
            // 2. Now that we know how many files there are - recheck aggregateRestrictions!
            const aggregateRestrictionError = this.validateAggregateRestrictions(enrichedTree);
            if (aggregateRestrictionError) {
                this.plugin.setPluginState({
                    partialTree: enrichedTree
                });
                return;
            }
            // 3. Add files
            const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(enrichedTree);
            (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
            // 4. Reset state
            this.resetPluginState();
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    render(state, viewOptions) {
        if (viewOptions === void 0) viewOptions = {};
        const { didFirstRender: didFirstRender } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) {
            this.plugin.setPluginState({
                didFirstRender: true
            });
            this.provider.fetchPreAuthToken();
            this.openFolder(this.plugin.rootFolderId);
        }
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        const { authenticated: authenticated, loading: loading } = this.plugin.getPluginState();
        const pluginIcon = this.plugin.icon || $671181bcc8a0cf10$export$b9ab270927e310e4;
        if (authenticated === false) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
            pluginName: this.plugin.title,
            pluginIcon: pluginIcon,
            handleAuth: this.handleAuth,
            i18n: this.plugin.uppy.i18n,
            renderForm: opts.renderAuthForm,
            loading: loading
        });
        const { partialTree: partialTree, currentFolderId: currentFolderId, username: username, searchString: searchString } = this.plugin.getPluginState();
        const breadcrumbs = (0, $15f8d756dc46e018$export$2e2bcd8739ae039)(partialTree, currentFolderId);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${opts.viewType}`)
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $6b1b801e011f359f$export$2e2bcd8739ae039), {
            showBreadcrumbs: opts.showBreadcrumbs,
            openFolder: this.openFolder,
            breadcrumbs: breadcrumbs,
            pluginIcon: pluginIcon,
            title: this.plugin.title,
            logout: this.logout,
            username: username,
            i18n: i18n
        }), opts.showFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: (s)=>{
                this.plugin.setPluginState({
                    searchString: s
                });
            },
            submitSearchString: ()=>{},
            inputLabel: i18n("filter"),
            clearSearchLabel: i18n("resetFilter"),
            wrapperClassName: "uppy-ProviderBrowser-searchFilter",
            inputClassName: "uppy-ProviderBrowser-searchFilterInput"
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
            toggleCheckbox: this.toggleCheckbox,
            displayedPartialTree: this.getDisplayedPartialTree(),
            openFolder: this.openFolder,
            virtualList: opts.virtualList,
            noResultsLabel: i18n("noFilesFound"),
            handleScroll: this.handleScroll,
            viewType: opts.viewType,
            showTitles: opts.showTitles,
            i18n: this.plugin.uppy.i18n,
            isLoading: loading,
            utmSource: "Companion"
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
            partialTree: partialTree,
            donePicking: this.donePicking,
            cancelSelection: this.cancelSelection,
            i18n: i18n,
            validateAggregateRestrictions: this.validateAggregateRestrictions
        }));
    }
}
async function $671181bcc8a0cf10$var$_withAbort2(op) {
    var _classPrivateFieldLoo;
    // prevent multiple requests in parallel from causing race conditions
    (_classPrivateFieldLoo = $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController]) == null || _classPrivateFieldLoo.abort();
    const abortController = new AbortController();
    $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = abortController;
    const cancelRequest = ()=>{
        abortController.abort();
    };
    try {
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.on("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.on("cancel-all", cancelRequest);
        await op(abortController.signal);
    } finally{
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.off("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.off("cancel-all", cancelRequest);
        $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = undefined;
    }
}
$671181bcc8a0cf10$export$2e2bcd8739ae039.VERSION = $671181bcc8a0cf10$var$packageJson.version;
















// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $3174b53b600a62c5$var$packageJson = {
    "version": "4.4.3"
};
const $3174b53b600a62c5$var$defaultState = {
    loading: false,
    searchString: "",
    partialTree: [
        {
            type: "root",
            id: null,
            cached: false,
            nextPagePath: null
        }
    ],
    currentFolderId: null,
    isInputMode: true
};
const $3174b53b600a62c5$var$defaultOptions = {
    viewType: "grid",
    showTitles: true,
    showFilter: true,
    utmSource: "Companion"
};
class $3174b53b600a62c5$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        this.isHandlingScroll = false;
        this.lastCheckbox = null;
        this.validateSingleFile = (file)=>{
            const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
            const result = this.plugin.uppy.validateSingleFile(companionFile);
            return result;
        };
        this.getDisplayedPartialTree = ()=>{
            const { partialTree: partialTree } = this.plugin.getPluginState();
            return partialTree.filter((item)=>item.type !== "root");
        };
        this.setSearchString = (searchString)=>{
            this.plugin.setPluginState({
                searchString: searchString
            });
            if (searchString === "") this.plugin.setPluginState({
                partialTree: []
            });
        };
        this.validateAggregateRestrictions = (partialTree)=>{
            const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
            const uppyFiles = checkedFiles.map((file)=>file.data);
            return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        this.opts = {
            ...$3174b53b600a62c5$var$defaultOptions,
            ...opts
        };
        this.setSearchString = this.setSearchString.bind(this);
        this.search = this.search.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.render = this.render.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on("dashboard:close-panel", this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    resetPluginState() {
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === "root" ? item : {
                ...item,
                status: "unchecked"
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    async search() {
        const { searchString: searchString } = this.plugin.getPluginState();
        if (searchString === "") return;
        this.setLoading(true);
        try {
            const response = await this.provider.search(searchString);
            const newPartialTree = [
                {
                    type: "root",
                    id: null,
                    cached: false,
                    nextPagePath: response.nextPageQuery
                },
                ...response.items.map((item)=>({
                        type: "file",
                        id: item.requestPath,
                        status: "unchecked",
                        parentId: null,
                        data: item
                    }))
            ];
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                isInputMode: false
            });
        } catch (error) {
            (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
        }
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, searchString: searchString } = this.plugin.getPluginState();
        const root = partialTree.find((i)=>i.type === "root");
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && root.nextPagePath) {
            this.isHandlingScroll = true;
            try {
                const response = await this.provider.search(searchString, root.nextPagePath);
                const newRoot = {
                    ...root,
                    nextPagePath: response.nextPageQuery
                };
                const oldItems = partialTree.filter((i)=>i.type !== "root");
                const newPartialTree = [
                    newRoot,
                    ...oldItems,
                    ...response.items.map((item)=>({
                            type: "file",
                            id: item.requestPath,
                            status: "unchecked",
                            parentId: null,
                            data: item
                        }))
                ];
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            } catch (error) {
                (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
            }
            this.isHandlingScroll = false;
        }
    }
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        // 1. Add files
        const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(partialTree);
        (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
        // 2. Reset state
        this.resetPluginState();
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    render(state, viewOptions) {
        if (viewOptions === void 0) viewOptions = {};
        const { isInputMode: isInputMode, searchString: searchString, loading: loading, partialTree: partialTree } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        if (isInputMode) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: this.setSearchString,
            submitSearchString: this.search,
            inputLabel: i18n("enterTextToSearch"),
            buttonLabel: i18n("searchImages"),
            wrapperClassName: "uppy-SearchProvider",
            inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
            showButton: true,
            buttonCSSClassName: "uppy-SearchProvider-searchButton"
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${opts.viewType}`)
        }, opts.showFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: this.setSearchString,
            submitSearchString: this.search,
            inputLabel: i18n("search"),
            clearSearchLabel: i18n("resetSearch"),
            wrapperClassName: "uppy-ProviderBrowser-searchFilter",
            inputClassName: "uppy-ProviderBrowser-searchFilterInput"
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
            toggleCheckbox: this.toggleCheckbox,
            displayedPartialTree: this.getDisplayedPartialTree(),
            handleScroll: this.handleScroll,
            openFolder: async ()=>{},
            noResultsLabel: i18n("noSearchResults"),
            viewType: opts.viewType,
            showTitles: opts.showTitles,
            isLoading: loading,
            i18n: i18n,
            virtualList: false,
            utmSource: this.opts.utmSource
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
            partialTree: partialTree,
            donePicking: this.donePicking,
            cancelSelection: this.cancelSelection,
            i18n: i18n,
            validateAggregateRestrictions: this.validateAggregateRestrictions
        }));
    }
}
$3174b53b600a62c5$export$2e2bcd8739ae039.VERSION = $3174b53b600a62c5$var$packageJson.version;







// https://developers.google.com/photos/picker/reference/rest/v1/mediaItems
// https://developers.google.com/photos/picker/reference/rest/v1/sessions
const $e9666b53892dc87f$var$getAuthHeader = (token)=>({
        authorization: `Bearer ${token}`
    });
const $e9666b53892dc87f$var$injectedScripts = new Set();
let $e9666b53892dc87f$var$driveApiLoaded = false;
// https://stackoverflow.com/a/39008859/6519037
async function $e9666b53892dc87f$var$injectScript(src) {
    if ($e9666b53892dc87f$var$injectedScripts.has(src)) return;
    await new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", ()=>resolve());
        script.addEventListener("error", (e)=>reject(e.error));
        document.head.appendChild(script);
    });
    $e9666b53892dc87f$var$injectedScripts.add(src);
}
async function $e9666b53892dc87f$export$854131c89fb1de23(pickerType) {
    await Promise.all([
        $e9666b53892dc87f$var$injectScript("https://accounts.google.com/gsi/client"),
        // Google Identity Services
        (async ()=>{
            await $e9666b53892dc87f$var$injectScript("https://apis.google.com/js/api.js");
            if (pickerType === "drive" && !$e9666b53892dc87f$var$driveApiLoaded) {
                await new Promise((resolve)=>gapi.load("client:picker", ()=>resolve()));
                await gapi.client.load("https://www.googleapis.com/discovery/v1/apis/drive/v3/rest");
                $e9666b53892dc87f$var$driveApiLoaded = true;
            }
        })()
    ]);
}
async function $e9666b53892dc87f$var$isTokenValid(accessToken, signal) {
    const response = await fetch(`https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${encodeURIComponent(accessToken)}`, {
        signal: signal
    });
    if (response.ok) return true;
    // console.warn('Token is invalid or expired:', response.status, await response.text());
    // Token is invalid or expired
    return false;
}
async function $e9666b53892dc87f$export$be1f35f80d3e29cc(_ref) {
    let { pickerType: pickerType, clientId: clientId, accessToken: accessToken } = _ref;
    const response = await new Promise((resolve, reject)=>{
        const scopes = pickerType === "drive" ? [
            "https://www.googleapis.com/auth/drive.file"
        ] : [
            "https://www.googleapis.com/auth/photospicker.mediaitems.readonly"
        ];
        const tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: clientId,
            // Authorization scopes required by the API; multiple scopes can be included, separated by spaces.
            scope: scopes.join(" "),
            callback: resolve,
            error_callback: reject
        });
        if (accessToken === null) // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({
            prompt: "consent"
        });
        else // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({
            prompt: ""
        });
    });
    if (response.error) throw new Error(`OAuth2 error: ${response.error}`);
    return response.access_token;
}
async function $e9666b53892dc87f$export$a0973bcfe11b05c9(accessToken) {
    await new Promise((resolve)=>google.accounts.oauth2.revoke(accessToken, resolve));
}
class $e9666b53892dc87f$export$b9721ef022f71a68 extends Error {
    constructor(){
        super("Invalid or expired token");
        this.name = "InvalidTokenError";
    }
}
async function $e9666b53892dc87f$export$b2a09a28761946e6(_ref2) {
    let { token: token, apiKey: apiKey, appId: appId, onFilesPicked: onFilesPicked, signal: signal } = _ref2;
    // google drive picker will crash hard if given an invalid token, so we need to check it first
    // https://github.com/transloadit/uppy/pull/5443#pullrequestreview-2452439265
    if (!await $e9666b53892dc87f$var$isTokenValid(token, signal)) throw new $e9666b53892dc87f$export$b9721ef022f71a68();
    const onPicked = (picked)=>{
        if (picked.action === google.picker.Action.PICKED) // console.log('Picker response', JSON.stringify(picked, null, 2));
        onFilesPicked(picked["docs"].map((doc)=>({
                platform: "drive",
                id: doc["id"],
                name: doc["name"],
                mimeType: doc["mimeType"]
            })), token);
    };
    const picker = new google.picker.PickerBuilder().enableFeature(google.picker.Feature.NAV_HIDDEN).enableFeature(google.picker.Feature.MULTISELECT_ENABLED).setDeveloperKey(apiKey).setAppId(appId).setOAuthToken(token).addView(new google.picker.DocsView(google.picker.ViewId.DOCS).setIncludeFolders(true)// Note: setEnableDrives doesn't seem to work
    // .setEnableDrives(true)
    .setSelectFolderEnabled(false).setMode(google.picker.DocsViewMode.LIST))// NOTE: photos is broken and results in an error being returned from Google
    // I think it's the old Picasa photos
    // .addView(google.picker.ViewId.PHOTOS)
    .setCallback(onPicked).build();
    picker.setVisible(true);
    signal == null || signal.addEventListener("abort", ()=>picker.dispose());
}
async function $e9666b53892dc87f$export$15c530b5c99413ec(_ref3) {
    let { token: token, pickingSession: pickingSession, onPickingSessionChange: onPickingSessionChange, signal: signal } = _ref3;
    // https://developers.google.com/photos/picker/guides/get-started-picker
    const headers = $e9666b53892dc87f$var$getAuthHeader(token);
    let newPickingSession = pickingSession;
    if (newPickingSession == null) {
        const createSessionResponse = await fetch("https://photospicker.googleapis.com/v1/sessions", {
            method: "post",
            headers: headers,
            signal: signal
        });
        if (createSessionResponse.status === 401) {
            var _resp$error;
            const resp = await createSessionResponse.json();
            if (((_resp$error = resp.error) == null ? void 0 : _resp$error.status) === "UNAUTHENTICATED") throw new $e9666b53892dc87f$export$b9721ef022f71a68();
        }
        if (!createSessionResponse.ok) throw new Error("Failed to create a session");
        newPickingSession = await createSessionResponse.json();
        onPickingSessionChange(newPickingSession);
    }
    const w = window.open(newPickingSession.pickerUri);
    signal == null || signal.addEventListener("abort", ()=>w == null ? void 0 : w.close());
}
async function $e9666b53892dc87f$var$resolvePickedPhotos(_ref4) {
    let { accessToken: accessToken, pickingSession: pickingSession, signal: signal } = _ref4;
    const headers = $e9666b53892dc87f$var$getAuthHeader(accessToken);
    let pageToken;
    let mediaItems = [];
    do {
        const pageSize = 100;
        const response = await fetch(`https://photospicker.googleapis.com/v1/mediaItems?${new URLSearchParams({
            sessionId: pickingSession.id,
            pageSize: String(pageSize)
        }).toString()}`, {
            headers: headers,
            signal: signal
        });
        if (!response.ok) throw new Error("Failed to get a media items");
        const { mediaItems: batchMediaItems, nextPageToken: nextPageToken } = await response.json();
        pageToken = nextPageToken;
        mediaItems.push(...batchMediaItems);
    }while (pageToken);
    // todo show alert instead about invalid picked files?
    mediaItems = mediaItems.flatMap((i)=>i.type === "PHOTO" || i.type === "VIDEO" && i.mediaFile.mediaFileMetadata.videoMetadata.processingStatus === "READY" ? [
            i
        ] : []);
    return mediaItems.map((_ref5)=>{
        let { id: id, type: type, // we want the original resolution, so we don't append any parameter to the baseUrl
        // https://developers.google.com/photos/library/guides/access-media-items#base-urls
        mediaFile: { mimeType: mimeType, filename: filename, baseUrl: baseUrl } } = _ref5;
        return {
            platform: "photos",
            id: id,
            mimeType: mimeType,
            url: type === "VIDEO" ? `${baseUrl}=dv` : `${baseUrl}=d`,
            // dv to download video, d to get original image (non cropped)
            name: filename
        };
    });
}
async function $e9666b53892dc87f$export$3e1980f2a996ac0a(_ref6) {
    let { pickingSessionRef: pickingSessionRef, accessTokenRef: accessTokenRef, signal: signal, onFilesPicked: onFilesPicked, onError: onError } = _ref6;
    // if we have an active session, poll it until it either times out, or the user selects some photos.
    // Note that the user can also just close the page, but we get no indication of that from Google when polling,
    // so we just have to continue polling in the background, so we can react to it
    // in case the user opens the photo selector again. Hence the infinite for loop
    for(let interval = 1;;)try {
        if (pickingSessionRef.current != null) interval = parseFloat(pickingSessionRef.current.pollingConfig.pollInterval);
        else interval = 1;
        await Promise.race([
            new Promise((resolve)=>setTimeout(resolve, interval * 1000)),
            new Promise((_resolve, reject)=>{
                signal.addEventListener("abort", reject);
            })
        ]);
        signal.throwIfAborted();
        const accessToken = accessTokenRef.current;
        const pickingSession = pickingSessionRef.current;
        if (pickingSession != null && accessToken != null) {
            const headers = $e9666b53892dc87f$var$getAuthHeader(accessToken);
            // https://developers.google.com/photos/picker/reference/rest/v1/sessions
            const response = await fetch(`https://photospicker.googleapis.com/v1/sessions/${encodeURIComponent(pickingSession.id)}`, {
                headers: headers,
                signal: signal
            });
            if (!response.ok) throw new Error("Failed to get session");
            const json = await response.json();
            if (json.mediaItemsSet) {
                // console.log('User picked!', json)
                const resolvedPhotos = await $e9666b53892dc87f$var$resolvePickedPhotos({
                    accessToken: accessToken,
                    pickingSession: pickingSession,
                    signal: signal
                });
                // eslint-disable-next-line no-param-reassign
                pickingSessionRef.current = undefined;
                onFilesPicked(resolvedPhotos, accessToken);
            }
            if (pickingSession.pollingConfig.timeoutIn === "0s") // eslint-disable-next-line no-param-reassign
            pickingSessionRef.current = undefined;
        }
    } catch (err) {
        if (err instanceof Error && err.name === "AbortError") return;
        // just report the error and continue polling
        onError(err);
    }
}




const $9705f384a874042e$export$66c805c125a4bed5 = ()=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "-7 -7 73 73"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        "fill-rule": "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M-3-3h64v64H-3z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        "fill-rule": "nonzero"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FBBC04",
        d: "M14.8 13.4c8.1 0 14.7 6.6 14.7 14.8v1.3H1.3c-.7 0-1.3-.6-1.3-1.3C0 20 6.6 13.4 14.8 13.4z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#EA4335",
        d: "M45.6 14.8c0 8.1-6.6 14.7-14.8 14.7h-1.3V1.3c0-.7.6-1.3 1.3-1.3C39 0 45.6 6.6 45.6 14.8z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#4285F4",
        d: "M44.3 45.6c-8.2 0-14.8-6.6-14.8-14.8v-1.3h28.2c.7 0 1.3.6 1.3 1.3 0 8.2-6.6 14.8-14.8 14.8z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#34A853",
        d: "M13.4 44.3c0-8.2 6.6-14.8 14.8-14.8h1.3v28.2c0 .7-.6 1.3-1.3 1.3-8.2 0-14.8-6.6-14.8-14.8z"
    }))));
const $9705f384a874042e$export$e16bd899bb4eebf9 = ()=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fillRule: "nonzero",
        fill: "none"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M6.663 22.284l.97 1.62c.202.34.492.609.832.804l3.465-5.798H5c0 .378.1.755.302 1.096l1.361 2.278z",
        fill: "#0066DA"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 12.09l-3.465-5.798c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 005 18.91h6.93L16 12.09z",
        fill: "#00AC47"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M23.535 24.708c.34-.195.63-.463.832-.804l.403-.67 1.928-3.228c.201-.34.302-.718.302-1.096h-6.93l1.474 2.802 1.991 2.996z",
        fill: "#EA4335"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 12.09l3.465-5.798A2.274 2.274 0 0018.331 6h-4.662c-.403 0-.794.11-1.134.292L16 12.09z",
        fill: "#00832D"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M20.07 18.91h-8.14l-3.465 5.798c.34.195.73.292 1.134.292h12.802c.403 0 .794-.11 1.134-.292L20.07 18.91z",
        fill: "#2684FC"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M23.497 12.455l-3.2-5.359a2.252 2.252 0 00-.832-.804L16 12.09l4.07 6.82h6.917c0-.377-.1-.755-.302-1.096l-3.188-5.359z",
        fill: "#FFBA00"
    })));


function $9b69c11e05f2f8a9$var$useStore(store, key) {
    const [value, setValueState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)();
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        (async ()=>{
            setValueState(await store.getItem(key));
        })();
    }, [
        key,
        store
    ]);
    const setValue = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async (v)=>{
        setValueState(v);
        if (v == null) return store.removeItem(key);
        return store.setItem(key, v);
    }, [
        key,
        store
    ]);
    return [
        value,
        setValue
    ];
}
function $9b69c11e05f2f8a9$export$2e2bcd8739ae039(_ref) {
    let { uppy: uppy, i18n: i18n, clientId: clientId, onFilesPicked: onFilesPicked, pickerType: pickerType, apiKey: apiKey, appId: appId, storage: storage } = _ref;
    const [loading, setLoading] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(false);
    const [accessToken, setAccessTokenStored] = $9b69c11e05f2f8a9$var$useStore(storage, `uppy:google-${pickerType}-picker:accessToken`);
    const pickingSessionRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const accessTokenRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(accessToken);
    const shownPickerRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(false);
    const setAccessToken = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((t)=>{
        uppy.log("Access token updated");
        setAccessTokenStored(t);
        accessTokenRef.current = t;
    }, [
        setAccessTokenStored,
        uppy
    ]);
    // keep access token in sync with the ref
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        accessTokenRef.current = accessToken;
    }, [
        accessToken
    ]);
    const showPicker = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async (signal)=>{
        let newAccessToken = accessToken;
        const doShowPicker = async (token)=>{
            if (pickerType === "drive") await (0, $e9666b53892dc87f$export$b2a09a28761946e6)({
                token: token,
                apiKey: apiKey,
                appId: appId,
                onFilesPicked: onFilesPicked,
                signal: signal
            });
            else {
                // photos
                const onPickingSessionChange = (newPickingSession)=>{
                    pickingSessionRef.current = newPickingSession;
                };
                await (0, $e9666b53892dc87f$export$15c530b5c99413ec)({
                    token: token,
                    pickingSession: pickingSessionRef.current,
                    onPickingSessionChange: onPickingSessionChange,
                    signal: signal
                });
            }
        };
        setLoading(true);
        try {
            try {
                await (0, $e9666b53892dc87f$export$854131c89fb1de23)(pickerType);
                if (newAccessToken == null) newAccessToken = await (0, $e9666b53892dc87f$export$be1f35f80d3e29cc)({
                    clientId: clientId,
                    pickerType: pickerType
                });
                if (newAccessToken == null) throw new Error();
                await doShowPicker(newAccessToken);
                shownPickerRef.current = true;
                setAccessToken(newAccessToken);
            } catch (err) {
                if (err instanceof (0, $e9666b53892dc87f$export$b9721ef022f71a68)) {
                    uppy.log("Token is invalid or expired, reauthenticating");
                    newAccessToken = await (0, $e9666b53892dc87f$export$be1f35f80d3e29cc)({
                        pickerType: pickerType,
                        accessToken: newAccessToken,
                        clientId: clientId
                    });
                    // now try again:
                    await doShowPicker(newAccessToken);
                    shownPickerRef.current = true;
                    setAccessToken(newAccessToken);
                } else throw err;
            }
        } catch (err) {
            if (err instanceof Error && "type" in err && err.type === "popup_closed") ;
            else {
                setAccessToken(null);
                uppy.log(err);
            }
        } finally{
            setLoading(false);
        }
    }, [
        accessToken,
        apiKey,
        appId,
        clientId,
        onFilesPicked,
        pickerType,
        setAccessToken,
        uppy
    ]);
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const abortController = new AbortController();
        (0, $e9666b53892dc87f$export$3e1980f2a996ac0a)({
            pickingSessionRef: pickingSessionRef,
            accessTokenRef: accessTokenRef,
            signal: abortController.signal,
            onFilesPicked: onFilesPicked,
            onError: (err)=>uppy.log(err)
        });
        return ()=>abortController.abort();
    }, [
        onFilesPicked,
        uppy
    ]);
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        // when mounting, once we have a token, be nice to the user and automatically show the picker
        // accessToken === undefined means not yet loaded from storage, so wait for that first
        if (accessToken === undefined || shownPickerRef.current) return undefined;
        const abortController = new AbortController();
        showPicker(abortController.signal);
        return ()=>{
            // only abort the picker if it's not yet shown
            if (!shownPickerRef.current) abortController.abort();
        };
    }, [
        accessToken,
        showPicker
    ]);
    const handleLogoutClick = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async ()=>{
        if (accessToken) {
            await (0, $e9666b53892dc87f$export$a0973bcfe11b05c9)(accessToken);
            setAccessToken(null);
            pickingSessionRef.current = undefined;
        }
    }, [
        accessToken,
        setAccessToken
    ]);
    if (loading) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null, i18n("pleaseWait"), "...");
    if (accessToken == null) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
        pluginName: pickerType === "drive" ? i18n("pluginNameGoogleDrivePicker") : i18n("pluginNameGooglePhotosPicker"),
        pluginIcon: pickerType === "drive" ? (0, $9705f384a874042e$export$e16bd899bb4eebf9) : (0, $9705f384a874042e$export$66c805c125a4bed5),
        handleAuth: showPicker,
        i18n: i18n,
        loading: loading
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        style: {
            textAlign: "center"
        }
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
        style: {
            display: "block",
            marginBottom: "1em"
        },
        disabled: loading,
        onClick: ()=>showPicker()
    }, pickerType === "drive" ? i18n("pickFiles") : i18n("pickPhotos")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        disabled: loading,
        onClick: handleLogoutClick
    }, i18n("logOut")));
}





var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $a6c8757fba02bc34$export$2e2bcd8739ae039 = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    "input:not([disabled]):not([inert]):not([aria-hidden])",
    "select:not([disabled]):not([inert]):not([aria-hidden])",
    "textarea:not([disabled]):not([inert]):not([aria-hidden])",
    "button:not([disabled]):not([inert]):not([aria-hidden])",
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];


/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ function $0a4934e80baa1792$export$2e2bcd8739ae039(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
        // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}


function $f5d602e6112dba3d$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $f5d602e6112dba3d$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
// ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
    const focusableNodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(activeOverlayEl.querySelectorAll((0, $a6c8757fba02bc34$export$2e2bcd8739ae039)));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
    // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl)) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
    else if (event.shiftKey && focusedItemIndex === 0) $f5d602e6112dba3d$var$focusOnLastNode(event, focusableNodes);
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
}
function $f5d602e6112dba3d$export$66fd63158b65050a(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl);
}





function $33dc1dd867a7b8b6$export$2e2bcd8739ae039() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement);
        // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
        // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector((0, $a6c8757fba02bc34$export$2e2bcd8739ae039));
            firstEl == null || firstEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    };
    // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8284bc2b60dc4bc4$exports)))(superFocus, 260);
}




/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $5e3c26e19f70d299$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) return false;
    if (!("FormData" in window)) return false;
    if (!("FileReader" in window)) return false;
    return true;
}





/* eslint-disable react/destructuring-assignment */ 

function $4d35db026571eaa3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $4d35db026571eaa3$export$967a6b9924a689f7(a, b);
    return $4d35db026571eaa3$export$3e67810a3f0e9f1c(a, b);
}





function $7fe1d951359cc6e1$var$iconImage() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#686DE0",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        cx: "7.5",
        cy: "9.5",
        r: "1.5"
    })));
}
function $7fe1d951359cc6e1$var$iconAudio() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
        fill: "#049BCF",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconVideo() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
        fill: "#19AF67",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconPDF() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
        fill: "#E2514A",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconArchive() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
        fill: "#00C469",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconFile() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#A7AFB7",
        fillRule: "nonzero"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
    })));
}
function $7fe1d951359cc6e1$var$iconText() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
        fill: "#5A5E69",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$export$2e2bcd8739ae039(fileType) {
    const defaultChoice = {
        color: "#838999",
        icon: $7fe1d951359cc6e1$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split("/")[0];
    const fileTypeSpecific = fileType.split("/")[1];
    // Text
    if (fileTypeGeneral === "text") return {
        color: "#5a5e69",
        icon: $7fe1d951359cc6e1$var$iconText()
    };
    // Image
    if (fileTypeGeneral === "image") return {
        color: "#686de0",
        icon: $7fe1d951359cc6e1$var$iconImage()
    };
    // Audio
    if (fileTypeGeneral === "audio") return {
        color: "#068dbb",
        icon: $7fe1d951359cc6e1$var$iconAudio()
    };
    // Video
    if (fileTypeGeneral === "video") return {
        color: "#19af67",
        icon: $7fe1d951359cc6e1$var$iconVideo()
    };
    // PDF
    if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") return {
        color: "#e25149",
        icon: $7fe1d951359cc6e1$var$iconPDF()
    };
    // Archive
    const archiveTypes = [
        "zip",
        "x-7z-compressed",
        "x-zip-compressed",
        "x-rar-compressed",
        "x-tar",
        "x-gzip",
        "x-apple-diskimage"
    ];
    if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: "#00C469",
        icon: $7fe1d951359cc6e1$var$iconArchive()
    };
    return defaultChoice;
}


function $9e2af7705a2c15c5$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    if (file.preview) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
        draggable: false,
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-Dashboard-Item-previewIcon",
        style: {
            color: color
        }
    }, icon), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-Dashboard-Item-previewIconBg",
        width: "58",
        height: "76",
        viewBox: "0 0 58 76"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        fill: "#FFF",
        width: "58",
        height: "76",
        rx: "3",
        fillRule: "evenodd"
    })));
}



const $e8c1f4ca43ed49b9$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const fields = typeof metaFields === "function" ? metaFields() : metaFields;
    const field = fields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $e8c1f4ca43ed49b9$export$2e2bcd8739ae039(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$e8c1f4ca43ed49b9$var$metaFieldIdToName(missingMetaField, metaFields)).join(", ");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-errorMessage"
    }, i18n("missingRequiredMetaFields", {
        smart_count: missingRequiredMetaFields.length,
        fields: metaFieldsString
    }), " ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
        onClick: ()=>toggleFileCard(true, file.id)
    }, i18n("editFile")));
}



function $bfd13c8521ef3809$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult } = props;
    const white = "rgba(255, 255, 255, 0.5)";
    const previewBackgroundColor = file.preview ? white : (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: previewBackgroundColor
        }
    }, showLinkToFileUploadResult && file.uploadURL && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        className: "uppy-Dashboard-Item-previewLink",
        href: file.uploadURL,
        rel: "noreferrer noopener",
        target: "_blank",
        "aria-label": file.meta.name
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        hidden: true
    }, file.meta.name)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}


/* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/destructuring-assignment */ 
function $130a6df4f019eb5d$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $130a6df4f019eb5d$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n("uploadComplete");
    if (props.error) return props.i18n("retryUpload");
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n("resumeUpload");
        return props.i18n("pauseUpload");
    }
    if (props.individualCancellation) return props.i18n("cancelUpload");
    return "";
}
function $130a6df4f019eb5d$var$ProgressIndicatorButton(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
        type: "button",
        "aria-label": $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        title: $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        onClick: ()=>$130a6df4f019eb5d$var$onPauseResumeCancelRetry(props)
    }, props.children));
}
function $130a6df4f019eb5d$var$ProgressCircleContainer(_ref) {
    let { children: children } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
    }, children);
}
function $130a6df4f019eb5d$var$ProgressCircle(_ref2) {
    let { progress: progress } = _ref2;
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--bg",
        r: "15",
        cx: "18",
        cy: "18",
        "stroke-width": "2",
        fill: "none"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--progress",
        r: "15",
        cx: "18",
        cy: "18",
        transform: "rotate(-90, 18, 18)",
        fill: "none",
        "stroke-width": "2",
        "stroke-dasharray": circleLength,
        "stroke-dashoffset": circleLength - circleLength / 100 * progress
    }));
}
function $130a6df4f019eb5d$export$2e2bcd8739ae039(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
    if (props.file.progress.percentage === undefined) return null;
    // Green checkmark when complete
    if (props.isUploaded) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        r: "15",
        cx: "18",
        cy: "18",
        fill: "#1bb240"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--check",
        transform: "translate(2, 3)",
        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
    if (props.recoveredState) return null;
    // Retry button for error
    if (props.error && !props.hideRetryButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.9 3H10v2H7.9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
    }))));
    // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), props.file.isPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    })))));
    // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
    }))));
    // Just progress when buttons are disabled
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }))));
}


/* eslint-disable react/destructuring-assignment */ 

/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 */ const $1e7f833197af6f70$var$separator = "...";
function $1e7f833197af6f70$export$2e2bcd8739ae039(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return "";
    // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string;
    // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $1e7f833197af6f70$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $1e7f833197af6f70$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $1e7f833197af6f70$var$separator + string.slice(-backChars);
}



const $35b148ba1db29747$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.isSingleFile && props.containerHeight >= 350) return 90;
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
        // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(name, getMaxNameLength()));
};
const $35b148ba1db29747$var$renderAuthor = (props)=>{
    var _props$file$remote;
    const { author: author } = props.file.meta;
    const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-author"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(author.name, 13)), providerName ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(Fragment, null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
const $35b148ba1db29747$var$renderFileSize = (props)=>props.file.size && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-statusSize"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(props.file.size));
const $35b148ba1db29747$var$ReSelectButton = (props)=>props.file.isGhost && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, " \u2022 ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(true)
    }, props.i18n("reSelect")));
const $35b148ba1db29747$var$ErrorButton = (_ref)=>{
    let { file: file, onClick: onClick } = _ref;
    if (file.error) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button"
    }, "?");
    return null;
};
function $35b148ba1db29747$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, toggleAddFilesPanel: toggleAddFilesPanel, isSingleFile: isSingleFile, containerHeight: containerHeight, containerWidth: containerWidth } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileName"
    }, $35b148ba1db29747$var$renderFileName({
        file: file,
        isSingleFile: isSingleFile,
        containerHeight: containerHeight,
        containerWidth: containerWidth
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($35b148ba1db29747$var$ErrorButton, {
        file: file,
        onClick: ()=>alert(file.error)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-status"
    }, $35b148ba1db29747$var$renderAuthor({
        file: file
    }), $35b148ba1db29747$var$renderFileSize({
        file: file
    }), $35b148ba1db29747$var$ReSelectButton({
        file: file,
        toggleAddFilesPanel: toggleAddFilesPanel,
        i18n: i18n
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}



/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ function $1402db5492a36d8b$export$2e2bcd8739ae039(textToCopy, fallbackString) {
    if (fallbackString === void 0) fallbackString = "Copy the URL below";
    return new Promise((resolve)=>{
        const textArea = document.createElement("textarea");
        textArea.setAttribute("style", {
            position: "fixed",
            top: 0,
            left: 0,
            width: "2em",
            height: "2em",
            padding: 0,
            border: "none",
            outline: "none",
            boxShadow: "none",
            background: "transparent"
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = ()=>{
            document.body.removeChild(textArea);
            // eslint-disable-next-line no-alert
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand("copy");
            if (!successful) return magicCopyFailed();
            document.body.removeChild(textArea);
            return resolve();
        } catch (err) {
            document.body.removeChild(textArea);
            return magicCopyFailed();
        }
    });
}


function $d15239db21f41277$var$EditButton(_ref) {
    let { file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick } = _ref;
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        title: i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "1",
        y: "12.293",
        width: "11",
        height: "1",
        rx: ".5"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fillRule: "nonzero",
        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
    return null;
}
function $d15239db21f41277$var$RemoveButton(_ref2) {
    let { i18n: i18n, onClick: onClick, file: file } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n("removeFile", {
            file: file.meta.name
        }),
        title: i18n("removeFile", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
    })));
}
function $d15239db21f41277$var$CopyLinkButton(_ref3) {
    let { file: file, uppy: uppy, i18n: i18n } = _ref3;
    const copyLinkToClipboard = (event)=>{
        (0, $1402db5492a36d8b$export$2e2bcd8739ae039)(file.uploadURL, i18n("copyLinkToClipboardFallback")).then(()=>{
            uppy.log("Link copied to clipboard.");
            uppy.info(i18n("copyLinkToClipboardSuccess"), "info", 3000);
        }).catch(uppy.log)// avoid losing focus
        .then(()=>event.target.focus({
                preventScroll: true
            }));
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n("copyLink"),
        title: i18n("copyLink"),
        onClick: (event)=>copyLinkToClipboard(event)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
    })));
}
function $d15239db21f41277$export$2e2bcd8739ae039(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-actionWrapper"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$EditButton, {
        i18n: i18n,
        file: file,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        canEditFile: canEditFile,
        metaFields: metaFields,
        onClick: editAction
    }), showLinkToFileUploadResult && file.uploadURL ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$CopyLinkButton, {
        file: file,
        uppy: uppy,
        i18n: i18n
    }) : null, showRemoveButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$RemoveButton, {
        i18n: i18n,
        file: file,
        onClick: ()=>uppy.removeFile(file.id)
    }) : null);
}


class $ed540296fca56761$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, $4d35db026571eaa3$export$3e67810a3f0e9f1c)(this.props, nextProps);
    }
    // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = !!file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = !!file.progress.uploadStarted || !!isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false;
        // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
            "uppy-Dashboard-Item": true,
            "is-inprogress": uploadInProgress && !this.props.recoveredState,
            "is-processing": isProcessing,
            "is-complete": isUploaded,
            "is-error": !!error,
            "is-resumable": this.props.resumableUploads,
            "is-noIndividualCancellation": !this.props.individualCancellation,
            "is-ghost": isGhost
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-preview"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $bfd13c8521ef3809$export$2e2bcd8739ae039), {
            file: file,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            i18n: this.props.i18n,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $130a6df4f019eb5d$export$2e2bcd8739ae039), {
            uppy: this.props.uppy,
            file: file,
            error: error,
            isUploaded: isUploaded,
            hideRetryButton: this.props.hideRetryButton,
            hideCancelButton: this.props.hideCancelButton,
            hidePauseResumeButton: this.props.hidePauseResumeButton,
            recoveredState: this.props.recoveredState,
            resumableUploads: this.props.resumableUploads,
            individualCancellation: this.props.individualCancellation,
            i18n: this.props.i18n
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-fileInfoAndButtons"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35b148ba1db29747$export$2e2bcd8739ae039), {
            file: file,
            containerWidth: this.props.containerWidth,
            containerHeight: this.props.containerHeight,
            i18n: this.props.i18n,
            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields,
            isSingleFile: this.props.isSingleFile
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d15239db21f41277$export$2e2bcd8739ae039), {
            file: file,
            metaFields: this.props.metaFields,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            showRemoveButton: showRemoveButton,
            canEditFile: this.props.canEditFile,
            uploadInProgressOrComplete: uploadInProgressOrComplete,
            toggleFileCard: this.props.toggleFileCard,
            openFileEditor: this.props.openFileEditor,
            uppy: this.props.uppy,
            i18n: this.props.i18n
        })));
    }
}


function $7a578b6cd2206257$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
function $7a578b6cd2206257$export$2e2bcd8739ae039(_ref) {
    let { id: id, i18n: i18n, uppy: uppy, files: files, resumableUploads: resumableUploads, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButtonAfterComplete: showRemoveButtonAfterComplete, metaFields: metaFields, isSingleFile: isSingleFile, toggleFileCard: toggleFileCard, handleRequestThumbnail: handleRequestThumbnail, handleCancelThumbnail: handleCancelThumbnail, recoveredState: recoveredState, individualCancellation: individualCancellation, itemsPerRow: itemsPerRow, openFileEditor: openFileEditor, canEditFile: canEditFile, toggleAddFilesPanel: toggleAddFilesPanel, containerWidth: containerWidth, containerHeight: containerHeight } = _ref;
    // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = itemsPerRow === 1 ? // Mobile
    71 : 200;
    // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        const sortByGhostComesFirst = (file1, file2)=>Number(files[file2].isGhost) - Number(files[file1].isGhost);
        const fileIds = Object.keys(files);
        if (recoveredState) fileIds.sort(sortByGhostComesFirst);
        return $7a578b6cd2206257$var$chunks(fileIds, itemsPerRow);
    }, [
        files,
        itemsPerRow,
        recoveredState
    ]);
    const renderRow = (row)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            class: "uppy-Dashboard-filesInner",
            role: "presentation",
            key: row[0]
        }, row.map((fileID)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ed540296fca56761$export$2e2bcd8739ae039), {
                key: fileID,
                uppy: uppy,
                id: id,
                i18n: i18n,
                resumableUploads: resumableUploads,
                individualCancellation: individualCancellation,
                hideRetryButton: hideRetryButton,
                hidePauseResumeButton: hidePauseResumeButton,
                hideCancelButton: hideCancelButton,
                showLinkToFileUploadResult: showLinkToFileUploadResult,
                showRemoveButtonAfterComplete: showRemoveButtonAfterComplete,
                metaFields: metaFields,
                recoveredState: recoveredState,
                isSingleFile: isSingleFile,
                containerWidth: containerWidth,
                containerHeight: containerHeight,
                toggleFileCard: toggleFileCard,
                handleRequestThumbnail: handleRequestThumbnail,
                handleCancelThumbnail: handleCancelThumbnail,
                role: "listitem",
                openFileEditor: openFileEditor,
                canEditFile: canEditFile,
                toggleAddFilesPanel: toggleAddFilesPanel,
                file: files[fileID]
            })));
    if (isSingleFile) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        class: "uppy-Dashboard-files",
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
}


/* eslint-disable react/destructuring-assignment */ 
class $3f3c0a16d9cbe8a2$var$AddFiles extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.fileInput = null;
        this.folderInput = null;
        this.mobilePhotoFileInput = null;
        this.mobileVideoFileInput = null;
        this.triggerFileInputClick = ()=>{
            var _this$fileInput;
            (_this$fileInput = this.fileInput) == null || _this$fileInput.click();
        };
        this.triggerFolderInputClick = ()=>{
            var _this$folderInput;
            (_this$folderInput = this.folderInput) == null || _this$folderInput.click();
        };
        this.triggerVideoCameraInputClick = ()=>{
            var _this$mobileVideoFile;
            (_this$mobileVideoFile = this.mobileVideoFileInput) == null || _this$mobileVideoFile.click();
        };
        this.triggerPhotoCameraInputClick = ()=>{
            var _this$mobilePhotoFile;
            (_this$mobilePhotoFile = this.mobilePhotoFileInput) == null || _this$mobilePhotoFile.click();
        };
        this.onFileInputChange = (event)=>{
            this.props.handleInputChange(event);
            // Clear the input so that Chrome/Safari/etc. can detect file section when the same file is repeatedly selected
            // (see https://github.com/transloadit/uppy/issues/768#issuecomment-2264902758)
            // eslint-disable-next-line no-param-reassign
            event.currentTarget.value = "";
        };
        this.renderHiddenInput = (isFolder, refCallback)=>{
            var _this$props$allowedFi;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                webkitdirectory: isFolder,
                type: "file",
                name: "files[]",
                multiple: this.props.maxNumberOfFiles !== 1,
                onChange: this.onFileInputChange,
                accept: (_this$props$allowedFi = this.props.allowedFileTypes) == null ? void 0 : _this$props$allowedFi.join(", "),
                ref: refCallback
            });
        };
        this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback)=>{
            const typeToAccept = {
                photo: "image/*",
                video: "video/*"
            };
            const accept = typeToAccept[type];
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                type: "file",
                name: `camera-${type}`,
                onChange: this.onFileInputChange,
                capture: nativeCameraFacingMode,
                accept: accept,
                ref: refCallback
            });
        };
        this.renderMyDeviceAcquirer = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MyDevice"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                className: "uppy-DashboardTab-iconMyDevice",
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
                fill: "currentcolor",
                "fill-rule": "evenodd"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("myDevice"))));
        };
        this.renderPhotoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobilePhotoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerPhotoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                fill: "#02B383",
                "fill-rule": "nonzero"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("takePictureBtn"))));
        };
        this.renderVideoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobileVideoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerVideoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                fill: "#FF675E",
                fillRule: "nonzero",
                d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("recordVideoBtn"))));
        };
        this.renderBrowseButton = (text, onClickFn)=>{
            const numberOfAcquirers = this.props.acquirers.length;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
                onClick: onClickFn,
                "data-uppy-super-focusable": numberOfAcquirers === 0
            }, text);
        };
        this.renderDropPasteBrowseTagline = (numberOfAcquirers)=>{
            const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
            const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick);
            // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
            // to Camel
            const lowerFMSelectionType = this.props.fileManagerSelectionType;
            const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                class: "uppy-Dashboard-AddFiles-title"
            }, // eslint-disable-next-line no-nested-ternary
            this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }));
        };
        this.renderAcquirer = (acquirer)=>{
            var _this$props$activePic;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": acquirer.id
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": ((_this$props$activePic = this.props.activePickerPanel) == null ? void 0 : _this$props$activePic.id) === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id)
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, acquirer.icon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, acquirer.name)));
        };
        this.renderAcquirers = (acquirers)=>{
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const acquirersWithoutLastTwo = [
                ...acquirers
            ];
            const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))));
        };
        this.renderSourcesList = (acquirers, disableLocalFiles)=>{
            const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton } = this.props;
            let list = [];
            const myDeviceKey = "myDevice";
            if (!disableLocalFiles) list.push({
                key: myDeviceKey,
                elements: this.renderMyDeviceAcquirer()
            });
            if (showNativePhotoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderPhotoCamera()
            });
            if (showNativeVideoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderVideoCamera()
            });
            list.push(...acquirers.map((acquirer)=>({
                    key: acquirer.id,
                    elements: this.renderAcquirer(acquirer)
                })));
            // doesn't make sense to show only a lonely "My Device"
            const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
            if (hasOnlyMyDevice) list = [];
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const listWithoutLastTwo = [
                ...list
            ];
            const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, this.renderDropPasteBrowseTagline(list.length), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-Dashboard-AddFiles-list",
                role: "tablist"
            }, listWithoutLastTwo.map((_ref)=>{
                let { key: key, elements: elements } = _ref;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                    key: key
                }, elements);
            }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwo.map((_ref2)=>{
                let { key: key, elements: elements } = _ref2;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                    key: key
                }, elements);
            }))));
        };
    }
    [Symbol.for("uppy test: disable unused locale key warning")]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray("dropPasteBoth");
        this.props.i18nArray("dropPasteFiles");
        this.props.i18nArray("dropPasteFolders");
        this.props.i18nArray("dropPasteImportBoth");
        this.props.i18nArray("dropPasteImportFiles");
        this.props.i18nArray("dropPasteImportFolders");
    }
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
            width: "11",
            height: "11",
            viewBox: "0 0 11 11"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
            d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
            fillRule: "evenodd"
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-Dashboard-poweredByUppy"
        }, "Uppy"));
        const linkText = i18nArray("poweredBy", {
            uppy: uppyBranding
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
            tabIndex: -1,
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy"
        }, linkText);
    }
    render() {
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton, nativeCameraFacingMode: nativeCameraFacingMode } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles"
        }, this.renderHiddenInput(false, (ref)=>{
            this.fileInput = ref;
        }), this.renderHiddenInput(true, (ref)=>{
            this.folderInput = ref;
        }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref)=>{
            this.mobilePhotoFileInput = ref;
        }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref)=>{
            this.mobileVideoFileInput = ref;
        }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles-info"
        }, this.props.note && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-note"
        }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy()));
    }
}
var $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039 = $3f3c0a16d9cbe8a2$var$AddFiles;


/* eslint-disable react/destructuring-assignment */ 


const $175934b4bbc4fb46$var$AddFilesPanel = (props)=>{
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-AddFilesPanel", props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": !props.showAddFilesPanel
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18n("addingMoreFiles")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(false)
    }, props.i18n("back"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), props));
};
var $175934b4bbc4fb46$export$2e2bcd8739ae039 = $175934b4bbc4fb46$var$AddFilesPanel;





// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $cb1052d4a6aa569a$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
var $cb1052d4a6aa569a$export$2e2bcd8739ae039 = $cb1052d4a6aa569a$var$ignoreEvent;


function $e3578ca53f5728a8$var$PickerPanelContent(_ref) {
    let { activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy } = _ref;
    const ref = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(null);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18n("importFrom", {
        name: activePickerPanel.name
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: hideAllPanels
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        ref: ref,
        className: "uppy-DashboardContent-panelBody"
    }, uppy.getPlugin(activePickerPanel.id).render(state, ref.current)));
}
var $e3578ca53f5728a8$export$2e2bcd8739ae039 = $e3578ca53f5728a8$var$PickerPanelContent;


/* eslint-disable react/destructuring-assignment */ 

function $d8360bbc75e6a373$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    const handleCancel = ()=>{
        props.uppy.emit("file-editor:cancel", file);
        props.closeFileEditor();
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: handleCancel
    }, props.i18n("cancel")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-save",
        type: "button",
        onClick: props.saveFileEditor
    }, props.i18n("save"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, props.editors.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })));
}
var $d8360bbc75e6a373$export$2e2bcd8739ae039 = $d8360bbc75e6a373$var$EditorPanel;



const $915070fc553cba86$var$uploadStates = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete",
    STATE_PAUSED: "paused"
};
function $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
    if (files === void 0) files = {};
    if (isAllErrored) return $915070fc553cba86$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $915070fc553cba86$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $915070fc553cba86$var$uploadStates.STATE_PAUSED;
    let state = $915070fc553cba86$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $915070fc553cba86$var$uploadStates.STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING) state = $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING && state !== $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING) state = $915070fc553cba86$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $915070fc553cba86$var$UploadStatus(_ref) {
    let { files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles } = _ref;
    const uploadingState = $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case "uploading":
            return i18n("uploadingXFiles", {
                smart_count: inProgressNotPausedFiles.length
            });
        case "preprocessing":
        case "postprocessing":
            return i18n("processingXFiles", {
                smart_count: processingFiles.length
            });
        case "paused":
            return i18n("uploadPaused");
        case "waiting":
            return i18n("xFilesSelected", {
                smart_count: newFiles.length
            });
        case "complete":
            return i18n("uploadComplete");
        case "error":
            return i18n("error");
        default:
    }
}
function $915070fc553cba86$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props;
    // TODO maybe this should be done in ../Dashboard.jsx, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) // eslint-disable-next-line react/destructuring-assignment
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, !isAllComplete && !hideCancelButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>uppy.cancelAll()
    }, i18n("cancel")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($915070fc553cba86$var$UploadStatus, props)), allowNewUpload ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-addMore",
        type: "button",
        "aria-label": i18n("addMoreFiles"),
        title: i18n("addMoreFiles"),
        onClick: ()=>toggleAddFilesPanel(true)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-DashboardContent-addMoreCaption"
    }, i18n("addMore"))) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null));
}
var $915070fc553cba86$export$2e2bcd8739ae039 = $915070fc553cba86$var$PanelTopBar;










function $fca34f2366194ceb$export$2e2bcd8739ae039(props) {
    const { computedMetaFields: computedMetaFields, requiredMetaFields: requiredMetaFields, updateMeta: updateMeta, form: form, formState: formState } = props;
    const fieldCSSClasses = {
        text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
    };
    return computedMetaFields.map((field)=>{
        const id = `uppy-Dashboard-FileCard-input-${field.id}`;
        const required = requiredMetaFields.includes(field.id);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("fieldset", {
            key: field.id,
            className: "uppy-Dashboard-FileCard-fieldset"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
            className: "uppy-Dashboard-FileCard-label",
            htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
            value: formState[field.id],
            onChange: (newVal)=>updateMeta(newVal, field.id),
            fieldCSSClasses: fieldCSSClasses,
            required: required,
            form: form.id
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
            className: fieldCSSClasses.text,
            id: id,
            form: form.id,
            type: field.type || "text",
            required: required,
            value: formState[field.id],
            placeholder: field.placeholder,
            onInput: (ev)=>updateMeta(ev.target.value, field.id),
            "data-uppy-super-focusable": true
        }));
    });
}


function $af43f3a66035ecee$export$2e2bcd8739ae039(props) {
    var _getMetaFields;
    const { files: files, fileCardFor: fileCardFor, toggleFileCard: toggleFileCard, saveFileCard: saveFileCard, metaFields: metaFields, requiredMetaFields: requiredMetaFields, openFileEditor: openFileEditor, i18n: i18n, i18nArray: i18nArray, className: className, canEditFile: canEditFile } = props;
    const getMetaFields = ()=>{
        return typeof metaFields === "function" ? metaFields(files[fileCardFor]) : metaFields;
    };
    const file = files[fileCardFor];
    const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
    const showEditButton = canEditFile(file);
    const storedMetaData = {};
    computedMetaFields.forEach((field)=>{
        var _file$meta$field$id;
        storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
    });
    const [formState, setFormState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(storedMetaData);
    const handleSave = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        saveFileCard(formState, fileCardFor);
    }, [
        saveFileCard,
        formState,
        fileCardFor
    ]);
    const updateMeta = (newVal, name)=>{
        setFormState({
            ...formState,
            [name]: newVal
        });
    };
    const handleCancel = ()=>{
        toggleFileCard(false);
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $af5278daf92376ec$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", handleSave);
        return ()=>{
            form.removeEventListener("submit", handleSave);
            document.body.removeChild(form);
        };
    }, [
        form,
        handleSave
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-FileCard", className),
        "data-uppy-panelType": "FileCard",
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: form.id,
        title: i18n("finishEditingFile"),
        onClick: handleCancel
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
            backgroundColor: (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color
        }
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), showEditButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: (event)=>{
            // When opening the image editor we want to save any meta fields changes.
            // Otherwise it's confusing for the user to click save in the editor,
            // but the changes here are discarded. This bypasses validation,
            // but we are okay with that.
            handleSave(event);
            openFileEditor(file);
        }
    }, i18n("editImage"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-info"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $fca34f2366194ceb$export$2e2bcd8739ae039), {
        computedMetaFields: computedMetaFields,
        requiredMetaFields: requiredMetaFields,
        updateMeta: updateMeta,
        form: form,
        formState: formState
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-actions"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
        type: "submit",
        form: form.id
    }, i18n("saveChanges")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: handleCancel,
        form: form.id
    }, i18n("cancel")))));
}





const $35cf1967ab48fc35$var$transitionName = "uppy-transition-slideDownUp";
const $35cf1967ab48fc35$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ function $35cf1967ab48fc35$var$Slide(_ref) {
    let { children: children } = _ref;
    const [cachedChildren, setCachedChildren] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(null);
    const [className, setClassName] = (0, $e28f05d17e052ff9$export$60241385465d0a34)("");
    const enterTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const leaveTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const animationFrameRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const handleEnterTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter ${$35cf1967ab48fc35$var$transitionName}-enter-active`);
            enterTimeoutRef.current = setTimeout(()=>{
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    const handleLeaveTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave ${$35cf1967ab48fc35$var$transitionName}-leave-active`);
            leaveTimeoutRef.current = setTimeout(()=>{
                setCachedChildren(null);
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const child = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
        if (cachedChildren === child) return;
        if (child && !cachedChildren) handleEnterTransition();
        else if (cachedChildren && !child && !leaveTimeoutRef.current) handleLeaveTransition();
        setCachedChildren(child);
    }, [
        children,
        cachedChildren
    ]); // Dependency array to trigger effect on children change
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            clearTimeout(enterTimeoutRef.current);
            clearTimeout(leaveTimeoutRef.current);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []); // Cleanup useEffect
    if (!cachedChildren) return null;
    return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(cachedChildren, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))(className, cachedChildren.props.className)
    });
}
var $35cf1967ab48fc35$export$2e2bcd8739ae039 = $35cf1967ab48fc35$var$Slide;


function $8dc96b7f61bbef1d$var$_extends() {
    return $8dc96b7f61bbef1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8dc96b7f61bbef1d$var$_extends.apply(null, arguments);
}
// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal
const $8dc96b7f61bbef1d$var$WIDTH_XL = 900;
const $8dc96b7f61bbef1d$var$WIDTH_LG = 700;
const $8dc96b7f61bbef1d$var$WIDTH_MD = 576;
const $8dc96b7f61bbef1d$var$HEIGHT_MD = 330;
function $8dc96b7f61bbef1d$export$2e2bcd8739ae039(props) {
    const isNoFiles = props.totalFileCount === 0;
    const isSingleFile = props.totalFileCount === 1;
    const isSizeMD = props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD;
    const isSizeHeightMD = props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD;
    const dashboardClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
        "uppy-Dashboard": true,
        "uppy-Dashboard--isDisabled": props.disabled,
        "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
        "uppy-Dashboard--isClosing": props.isClosing,
        "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
        "uppy-Dashboard--modal": !props.inline,
        "uppy-size--md": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD,
        "uppy-size--lg": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG,
        "uppy-size--xl": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL,
        "uppy-size--height-md": props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD,
        // We might want to enable this in the future
        // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
        // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
        "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
        "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
        // Only enable “centered single file” mode when Dashboard is tall enough
        "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
    });
    // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !isNoFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : 0;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n("recoveredXFiles", {
            smart_count: numberOfGhosts
        });
        return props.i18n("recoveredAllFiles");
    };
    const dashboard = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, $5e3c26e19f70d299$export$2e2bcd8739ae039)(),
        "aria-hidden": props.inline ? "false" : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        "aria-hidden": "true",
        className: "uppy-Dashboard-overlay",
        tabIndex: -1,
        onClick: props.handleClickOutside
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-inner",
        "aria-modal": !props.inline && "true",
        role: props.inline ? undefined : "dialog",
        style: {
            width: props.inline && props.width ? props.width : "",
            height: props.inline && props.height ? props.height : ""
        }
    }, !props.inline ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-close",
        type: "button",
        "aria-label": props.i18n("closeModal"),
        title: props.i18n("closeModal"),
        onClick: props.closeModal
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        "aria-hidden": "true"
    }, "\xd7")) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-innerWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-dropFilesHereHint"
    }, props.i18n("dropHint")), showFileList && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $915070fc553cba86$export$2e2bcd8739ae039), props), numberOfFilesForRecovery && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-Dashboard-serviceMsg-icon",
        "aria-hidden": "true",
        focusable: "false",
        width: "21",
        height: "16",
        viewBox: "0 0 24 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        transform: "translate(0 -1)",
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
        fill: "#FFD300"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#000",
        d: "M11 6h2l-.3 8h-1.4z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#000",
        cx: "12",
        cy: "17",
        r: "1"
    }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("strong", {
        className: "uppy-Dashboard-serviceMsg-title"
    }, props.i18n("sessionRestored")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg-text"
    }, renderRestoredText())), showFileList ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7a578b6cd2206257$export$2e2bcd8739ae039), {
        id: props.id,
        i18n: props.i18n,
        uppy: props.uppy,
        files: props.files,
        resumableUploads: props.resumableUploads,
        hideRetryButton: props.hideRetryButton,
        hidePauseResumeButton: props.hidePauseResumeButton,
        hideCancelButton: props.hideCancelButton,
        showLinkToFileUploadResult: props.showLinkToFileUploadResult,
        showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
        metaFields: props.metaFields,
        toggleFileCard: props.toggleFileCard,
        handleRequestThumbnail: props.handleRequestThumbnail,
        handleCancelThumbnail: props.handleCancelThumbnail,
        recoveredState: props.recoveredState,
        individualCancellation: props.individualCancellation,
        openFileEditor: props.openFileEditor,
        canEditFile: props.canEditFile,
        toggleAddFilesPanel: props.toggleAddFilesPanel,
        isSingleFile: isSingleFile,
        itemsPerRow: itemsPerRow,
        containerWidth: props.containerWidth,
        containerHeight: props.containerHeight
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), {
        i18n: props.i18n,
        i18nArray: props.i18nArray,
        acquirers: props.acquirers,
        handleInputChange: props.handleInputChange,
        maxNumberOfFiles: props.maxNumberOfFiles,
        allowedFileTypes: props.allowedFileTypes,
        showNativePhotoCameraButton: props.showNativePhotoCameraButton,
        showNativeVideoCameraButton: props.showNativeVideoCameraButton,
        nativeCameraFacingMode: props.nativeCameraFacingMode,
        showPanel: props.showPanel,
        activePickerPanel: props.activePickerPanel,
        disableLocalFiles: props.disableLocalFiles,
        fileManagerSelectionType: props.fileManagerSelectionType,
        note: props.note,
        proudlyDisplayPoweredByUppy: props.proudlyDisplayPoweredByUppy
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showAddFilesPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $175934b4bbc4fb46$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "AddFiles"
    }, props, {
        isSizeMD: isSizeMD
    })) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.fileCardFor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $af43f3a66035ecee$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "FileCard"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.activePickerPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e3578ca53f5728a8$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Picker"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showFileEditor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d8360bbc75e6a373$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Editor"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-progressindicators"
    }, props.progressindicators.map((target)=>{
        // TODO
        // Here we're telling typescript all `this.type = 'progressindicator'` plugins inherit from `UIPlugin`
        // This is factually true in Uppy right now, but maybe it doesn't have to be
        return props.uppy.getPlugin(target.id).render(props.state);
    })))));
    return dashboard;
}


var $c4158ae05dd76b13$export$2e2bcd8739ae039 = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: "Close Modal",
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: "Add more files",
        addingMoreFiles: "Adding more files",
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: "Import from %{name}",
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: "Uppy Dashboard",
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: "Link copied to clipboard.",
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: "Copy the URL below",
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: "Copy link",
        back: "Back",
        // Used as the screen reader label for buttons that remove a file.
        removeFile: "Remove file",
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: "Edit file",
        editImage: "Edit image",
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: "Editing %{file}",
        // Shown on the main upload screen when an upload error occurs
        error: "Error",
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: "Finish editing file",
        saveChanges: "Save changes",
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: "My Device",
        dropHint: "Drop your files here",
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: "Upload complete",
        uploadPaused: "Upload paused",
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Resume upload",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: "Pause upload",
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: "Retry upload",
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Cancel upload",
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: "%{smart_count} file selected",
            1: "%{smart_count} files selected"
        },
        uploadingXFiles: {
            0: "Uploading %{smart_count} file",
            1: "Uploading %{smart_count} files"
        },
        processingXFiles: {
            0: "Processing %{smart_count} file",
            1: "Processing %{smart_count} files"
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: "Powered by %{uppy}",
        addMore: "Add more",
        editFileWithFilename: "Edit file %{file}",
        save: "Save",
        cancel: "Cancel",
        dropPasteFiles: "Drop files here or %{browseFiles}",
        dropPasteFolders: "Drop files here or %{browseFolders}",
        dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
        dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
        dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
        dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
        importFiles: "Import files from:",
        browseFiles: "browse files",
        browseFolders: "browse folders",
        recoveredXFiles: {
            0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
            1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
        },
        recoveredAllFiles: "We restored all files. You can now resume the upload.",
        sessionRestored: "Session restored",
        reSelect: "Re-select",
        missingRequiredMetaFields: {
            0: "Missing required meta field: %{fields}.",
            1: "Missing required meta fields: %{fields}."
        },
        // Used for native device camera buttons on mobile
        takePictureBtn: "Take Picture",
        recordVideoBtn: "Record Video"
    }
};


function $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $b868dcf7a47332e3$var$id = 0;
function $b868dcf7a47332e3$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $b868dcf7a47332e3$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b868dcf7a47332e3$var$packageJson = {
    "version": "4.3.3"
};
const $b868dcf7a47332e3$var$memoize = (0, $e66b69e563b626e6$export$2e2bcd8739ae039).default || (0, $e66b69e563b626e6$export$2e2bcd8739ae039);
const $b868dcf7a47332e3$var$TAB_KEY = 9;
const $b868dcf7a47332e3$var$ESC_KEY = 27;
function $b868dcf7a47332e3$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
const $b868dcf7a47332e3$var$defaultOptions = {
    target: "body",
    metaFields: [],
    thumbnailWidth: 280,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    defaultPickerIcon: $671181bcc8a0cf10$export$b9ab270927e310e4,
    showLinkToFileUploadResult: false,
    showProgressDetails: false,
    hideUploadButton: false,
    hideCancelButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideProgressAfterFinish: false,
    note: null,
    singleFileFullScreen: true,
    disableStatusBar: false,
    disableInformer: false,
    disableThumbnailGenerator: false,
    fileManagerSelectionType: "files",
    proudlyDisplayPoweredByUppy: true,
    showSelectedFiles: true,
    showRemoveButtonAfterComplete: false,
    showNativePhotoCameraButton: false,
    showNativeVideoCameraButton: false,
    theme: "light",
    autoOpen: null,
    disabled: false,
    disableLocalFiles: false,
    nativeCameraFacingMode: "",
    onDragLeave: ()=>{},
    onDragOver: ()=>{},
    onDrop: ()=>{},
    plugins: [],
    // Dynamic default options, they have to be defined in the constructor (because
    // they require access to the `this` keyword), but we still want them to
    // appear in the default options so TS knows they'll be defined.
    doneButtonHandler: undefined,
    onRequestCloseModal: null,
    // defaultModalOptions
    inline: false,
    animateOpenClose: true,
    browserBackButtonClose: false,
    closeAfterFinish: false,
    closeModalOnClickOutside: false,
    disablePageScrollWhenModalOpen: true,
    trigger: null,
    // defaultInlineOptions
    width: 750,
    height: 550
};
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */ var $b868dcf7a47332e3$var$_disabledNodes = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("disabledNodes");
var $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var $b868dcf7a47332e3$var$_attachRenderFunctionToTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var $b868dcf7a47332e3$var$_isTargetSupported = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("isTargetSupported");
var $b868dcf7a47332e3$var$_getAcquirers = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getAcquirers");
var $b868dcf7a47332e3$var$_getProgressIndicators = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getProgressIndicators");
var $b868dcf7a47332e3$var$_getEditors = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getEditors");
var $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var $b868dcf7a47332e3$var$_autoDiscoverPlugins = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("autoDiscoverPlugins");
var $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
var $b868dcf7a47332e3$var$_getStatusBarOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getStatusBarOpts");
var $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getThumbnailGeneratorOpts");
var $b868dcf7a47332e3$var$_getInformerOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getInformerOpts");
var $b868dcf7a47332e3$var$_getStatusBarId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getStatusBarId");
var $b868dcf7a47332e3$var$_getThumbnailGeneratorId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getThumbnailGeneratorId");
var $b868dcf7a47332e3$var$_getInformerId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getInformerId");
class $b868dcf7a47332e3$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    // Timeouts
    constructor(uppy, _opts){
        var _opts$autoOpen, _this$opts, _this$opts$onRequestC;
        const autoOpen = (_opts$autoOpen = _opts == null ? void 0 : _opts.autoOpen) != null ? _opts$autoOpen : null;
        super(uppy, {
            ...$b868dcf7a47332e3$var$defaultOptions,
            ..._opts,
            autoOpen: autoOpen
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getInformerId, {
            value: $b868dcf7a47332e3$var$_getInformerId2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId, {
            value: $b868dcf7a47332e3$var$_getThumbnailGeneratorId2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getStatusBarId, {
            value: $b868dcf7a47332e3$var$_getStatusBarId2
        });
        // eslint-disable-next-line class-methods-use-this
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getInformerOpts, {
            value: $b868dcf7a47332e3$var$_getInformerOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts, {
            value: $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getStatusBarOpts, {
            value: $b868dcf7a47332e3$var$_getStatusBarOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_disabledNodes, {
            writable: true,
            value: void 0
        });
        this.modalName = `uppy-Dashboard-${(0, $af5278daf92376ec$export$ac4959f4f1338dfc)()}`;
        this.superFocus = (0, $33dc1dd867a7b8b6$export$2e2bcd8739ae039)();
        this.ifFocusedOnUppyRecently = false;
        this.removeTarget = (plugin)=>{
            const pluginState = this.getPluginState();
            // filter out the one we want to remove
            const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
            this.setPluginState({
                targets: newTargets
            });
        };
        this.addTarget = (plugin)=>{
            const callerPluginId = plugin.id || plugin.constructor.name;
            const callerPluginName = plugin.title || callerPluginId;
            const callerPluginType = plugin.type;
            if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
                const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
                this.uppy.log(msg, "error");
                return null;
            }
            const target = {
                id: callerPluginId,
                name: callerPluginName,
                type: callerPluginType
            };
            const state = this.getPluginState();
            const newTargets = state.targets.slice();
            newTargets.push(target);
            this.setPluginState({
                targets: newTargets
            });
            return this.el;
        };
        this.hideAllPanels = ()=>{
            var _state$activePickerPa;
            const state = this.getPluginState();
            const update = {
                activePickerPanel: undefined,
                showAddFilesPanel: false,
                activeOverlayType: null,
                fileCardFor: null,
                showFileEditor: false
            };
            if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
            return;
            this.setPluginState(update);
            this.uppy.emit("dashboard:close-panel", (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
        };
        this.showPanel = (id)=>{
            const { targets: targets } = this.getPluginState();
            const activePickerPanel = targets.find((target)=>{
                return target.type === "acquirer" && target.id === id;
            });
            this.setPluginState({
                activePickerPanel: activePickerPanel,
                activeOverlayType: "PickerPanel"
            });
            this.uppy.emit("dashboard:show-panel", id);
        };
        this.canEditFile = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
        };
        this.openFileEditor = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            this.setPluginState({
                showFileEditor: true,
                fileCardFor: file.id || null,
                activeOverlayType: "FileEditor"
            });
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).selectFile(file);
            });
        };
        this.closeFileEditor = ()=>{
            const { metaFields: metaFields } = this.getPluginState();
            const isMetaEditorEnabled = metaFields && metaFields.length > 0;
            if (isMetaEditorEnabled) this.setPluginState({
                showFileEditor: false,
                activeOverlayType: "FileCard"
            });
            else this.setPluginState({
                showFileEditor: false,
                fileCardFor: null,
                activeOverlayType: "AddFiles"
            });
        };
        this.saveFileEditor = ()=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).save();
            });
            this.closeFileEditor();
        };
        this.openModal = ()=>{
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            // save scroll position
            this.savedScrollPosition = window.pageYOffset;
            // save active element, so we can restore focus when modal is closed
            this.savedActiveElement = document.activeElement;
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: false
                    });
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: false
                });
                resolve();
            }
            if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
            // handle ESC and TAB keys in modal dialog
            document.addEventListener("keydown", this.handleKeyDownInModal);
            this.uppy.emit("dashboard:modal-open");
            return promise;
        };
        this.closeModal = (opts)=>{
            var _opts$manualClose;
            // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
            const manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
            const { isHidden: isHidden, isClosing: isClosing } = this.getPluginState();
            if (isHidden || isClosing) // short-circuit if animation is ongoing
            return undefined;
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose) {
                this.setPluginState({
                    isClosing: true
                });
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: true,
                        isClosing: false
                    });
                    this.superFocus.cancel();
                    this.savedActiveElement.focus();
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: true
                });
                this.superFocus.cancel();
                this.savedActiveElement.focus();
                resolve();
            }
            // handle ESC and TAB keys in modal dialog
            document.removeEventListener("keydown", this.handleKeyDownInModal);
            if (manualClose) {
                if (this.opts.browserBackButtonClose) {
                    var _history$state;
                    // Make sure that the latest entry in the history state is our modal name
                    // eslint-disable-next-line no-restricted-globals
                    if ((_history$state = history.state) != null && _history$state[this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                    // eslint-disable-next-line no-restricted-globals
                    history.back();
                }
            }
            this.uppy.emit("dashboard:modal-closed");
            return promise;
        };
        this.isModalOpen = ()=>{
            return !this.getPluginState().isHidden || false;
        };
        this.requestCloseModal = ()=>{
            if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
            return this.closeModal();
        };
        this.setDarkModeCapability = (isDarkModeOn)=>{
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    darkMode: isDarkModeOn
                }
            });
        };
        this.handleSystemDarkModeChange = (event)=>{
            const isDarkModeOnNow = event.matches;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnNow);
        };
        this.toggleFileCard = (show, fileID)=>{
            const file = this.uppy.getFile(fileID);
            if (show) this.uppy.emit("dashboard:file-edit-start", file);
            else this.uppy.emit("dashboard:file-edit-complete", file);
            this.setPluginState({
                fileCardFor: show ? fileID : null,
                activeOverlayType: show ? "FileCard" : null
            });
        };
        this.toggleAddFilesPanel = (show)=>{
            this.setPluginState({
                showAddFilesPanel: show,
                activeOverlayType: show ? "AddFiles" : null
            });
        };
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || file.webkitRelativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
        //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
        //    another (e.g. in Safari)
        // ___Why not apply visibility property to .uppy-Dashboard-inner?
        //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
        //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
        this.startListeningToResize = ()=>{
            // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
            // and update containerWidth/containerHeight in plugin state accordingly.
            // Emits first event on initialization.
            this.resizeObserver = new ResizeObserver((entries)=>{
                const uppyDashboardInnerEl = entries[0];
                const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
                this.setPluginState({
                    containerWidth: width,
                    containerHeight: height,
                    areInsidesReadyToBeVisible: true
                });
            });
            this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner"));
            // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
            this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
                const pluginState = this.getPluginState();
                const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
                if (// We might want to enable this in the future
                // if ResizeObserver hasn't yet fired,
                !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
                !isModalAndClosed) {
                    this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", "warning");
                    this.setPluginState({
                        areInsidesReadyToBeVisible: true
                    });
                }
            }, 1000);
        };
        this.stopListeningToResize = ()=>{
            this.resizeObserver.disconnect();
            clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
        };
        // Records whether we have been interacting with uppy right now,
        // which is then used to determine whether state updates should trigger a refocusing.
        this.recordIfFocusedOnUppyRecently = (event)=>{
            if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
            else {
                this.ifFocusedOnUppyRecently = false;
                // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
                //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
                //    previously run superFocus sometimes hits and moves focus back to Uppy.
                this.superFocus.cancel();
            }
        };
        this.disableInteractiveElements = (disable)=>{
            var _classPrivateFieldLoo;
            const NODES_TO_DISABLE = [
                "a[href]",
                "input:not([disabled])",
                "select:not([disabled])",
                "textarea:not([disabled])",
                "button:not([disabled])",
                '[role="button"]:not([disabled])'
            ];
            const nodesToDisable = (_classPrivateFieldLoo = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes]) != null ? _classPrivateFieldLoo : (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node)=>!node.classList.contains("uppy-Dashboard-close"));
            for (const node of nodesToDisable)// Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
            if (node.tagName === "A") node.setAttribute("aria-disabled", disable);
            else node.disabled = disable;
            if (disable) $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = nodesToDisable;
            else $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = null;
            this.dashboardIsDisabled = disable;
        };
        this.updateBrowserHistory = ()=>{
            var _history$state2;
            // Ensure history state does not already contain our modal name to avoid double-pushing
            // eslint-disable-next-line no-restricted-globals
            if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) // Push to history so that the page is not lost on browser back button press
            // eslint-disable-next-line no-restricted-globals
            history.pushState({
                // eslint-disable-next-line no-restricted-globals
                ...history.state,
                [this.modalName]: true
            }, "");
            // Listen for back button presses
            window.addEventListener("popstate", this.handlePopState, false);
        };
        this.handlePopState = (event)=>{
            var _event$state;
            // Close the modal if the history state no longer contains our modal name
            if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
                manualClose: false
            });
            // When the browser back button is pressed and uppy is now the latest entry
            // in the history but the modal is closed, fix the history by removing the
            // uppy history entry.
            // This occurs when another entry is added into the history state while the
            // modal is open, and then the modal gets manually closed.
            // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
            if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) // eslint-disable-next-line no-restricted-globals
            history.back();
        };
        this.handleKeyDownInModal = (event)=>{
            // close modal on esc key press
            if (event.keyCode === $b868dcf7a47332e3$var$ESC_KEY) this.requestCloseModal();
            // trap focus on tab key press
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$f41e0874aee57111(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handleClickOutside = ()=>{
            if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
        };
        this.handlePaste = (event)=>{
            // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootPaste == null || plugin.handleRootPaste(event);
            });
            // Add all dropped files
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.clipboardData.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files pasted");
                this.addFiles(files);
            }
        };
        this.handleInputChange = (event)=>{
            event.preventDefault();
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.currentTarget.files || []);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files selected through input");
                this.addFiles(files);
            }
        };
        this.handleDragOver = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            // Check if some plugin can handle the datatransfer without files —
            // for instance, the Url plugin can import a url
            const canSomePluginHandleRootDrop = ()=>{
                let somePluginCanHandleRootDrop = true;
                this.uppy.iteratePlugins((plugin)=>{
                    if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) somePluginCanHandleRootDrop = true;
                });
                return somePluginCanHandleRootDrop;
            };
            // Check if the "type" of the datatransfer object includes files
            const doesEventHaveFiles = ()=>{
                const { types: types } = event.dataTransfer;
                return types.some((type)=>type === "Files");
            };
            // Deny drop, if no plugins can handle datatransfer, there are no files,
            // or when opts.disabled is set, or new uploads are not allowed
            const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
            const hasFiles = doesEventHaveFiles();
            if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
            // can handle the datatransfer
            this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
                event.dataTransfer.dropEffect = "none"; // eslint-disable-line no-param-reassign
                return;
            }
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the
            // browser, https://github.com/transloadit/uppy/issues/1978).
            event.dataTransfer.dropEffect = "copy"; // eslint-disable-line no-param-reassign
            this.setPluginState({
                isDraggingOver: true
            });
            this.opts.onDragOver(event);
        };
        this.handleDragLeave = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.setPluginState({
                isDraggingOver: false
            });
            this.opts.onDragLeave(event);
        };
        this.handleDrop = async (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, "error");
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, "error");
                    executedDropErrorOnce = true;
                }
            };
            this.uppy.log("[Dashboard] Processing dropped files");
            // Add all dropped files
            const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files dropped");
                this.addFiles(files);
            }
            this.opts.onDrop(event);
        };
        this.handleRequestThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:request", file);
        };
        /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */ this.handleCancelThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:cancel", file);
        };
        this.handleKeyDownInInline = (event)=>{
            // Trap focus on tab key press.
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$66fd63158b65050a(event, this.getPluginState().activeOverlayType, this.el);
        };
        // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
        //    or this.el.addEventListener('paste')?
        //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
        //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
        //       particular Uppy instance.
        // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
        //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
        //    standard determination of whether we're pasting into our Uppy instance won't work.
        //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
        this.handlePasteOnBody = (event)=>{
            const isFocusInOverlay = this.el.contains(document.activeElement);
            if (isFocusInOverlay) this.handlePaste(event);
        };
        this.handleComplete = (_ref)=>{
            let { failed: failed } = _ref;
            if (this.opts.closeAfterFinish && !(failed != null && failed.length)) // All uploads are done
            this.requestCloseModal();
        };
        this.handleCancelRestore = ()=>{
            this.uppy.emit("restore-canceled");
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile, {
            writable: true,
            value: ()=>{
                if (this.opts.disableThumbnailGenerator) return;
                const LARGE_THUMBNAIL = 600;
                const files = this.uppy.getFiles();
                if (files.length === 1) {
                    const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                    thumbnailGenerator == null || thumbnailGenerator.setOptions({
                        thumbnailWidth: LARGE_THUMBNAIL
                    });
                    const fileForThumbnail = {
                        ...files[0],
                        preview: undefined
                    };
                    thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(()=>{
                        thumbnailGenerator == null || thumbnailGenerator.setOptions({
                            thumbnailWidth: this.opts.thumbnailWidth
                        });
                    });
                }
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded, {
            writable: true,
            value: (files)=>{
                const firstFile = files[0];
                const { metaFields: metaFields } = this.getPluginState();
                const isMetaEditorEnabled = metaFields && metaFields.length > 0;
                const isImageEditorEnabled = this.canEditFile(firstFile);
                if (isMetaEditorEnabled && this.opts.autoOpen === "metaEditor") this.toggleFileCard(true, firstFile.id);
                else if (isImageEditorEnabled && this.opts.autoOpen === "imageEditor") this.openFileEditor(firstFile);
            }
        });
        this.initEvents = ()=>{
            // Modal open button
            if (this.opts.trigger && !this.opts.inline) {
                const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
                if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener("click", this.openModal));
                else this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
            }
            this.startListeningToResize();
            document.addEventListener("paste", this.handlePasteOnBody);
            this.uppy.on("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.on("plugin-remove", this.removeTarget);
            this.uppy.on("file-added", this.hideAllPanels);
            this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.on("complete", this.handleComplete);
            this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.on("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            // ___Why fire on capture?
            //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
            document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
            document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
            if (this.opts.inline) this.el.addEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.removeEvents = ()=>{
            const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
            if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener("click", this.openModal));
            this.stopListeningToResize();
            document.removeEventListener("paste", this.handlePasteOnBody);
            window.removeEventListener("popstate", this.handlePopState, false);
            this.uppy.off("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.off("plugin-remove", this.removeTarget);
            this.uppy.off("file-added", this.hideAllPanels);
            this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.off("complete", this.handleComplete);
            this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.off("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
            document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
            if (this.opts.inline) this.el.removeEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.superFocusOnEachUpdate = ()=>{
            const isFocusInUppy = this.el.contains(document.activeElement);
            // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
            const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
            const isInformerHidden = this.uppy.getState().info.length === 0;
            const isModal = !this.opts.inline;
            if (// If update is connected to showing the Informer - let the screen reader calmly read it.
            isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
            // on the page (user is unlikely to want to interact with the rest of the page)
            (isModal || // If we are already inside of Uppy, or
            isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
            //   1. We focus when isFocusNowhere, because when the element we were focused
            //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
            //      something somewhere else on the page, - focus won't be 'nowhere'.
            //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
            //      to avoid focus jumps if we do something else on the page.
            //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
            //                     when file is uploading, - navigate via tab to the checkbox,
            //                     try to press space multiple times. Focus will jump to Uppy.
            isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
            else this.superFocus.cancel();
        };
        this.afterUpdate = ()=>{
            if (this.opts.disabled && !this.dashboardIsDisabled) {
                this.disableInteractiveElements(true);
                return;
            }
            if (!this.opts.disabled && this.dashboardIsDisabled) this.disableInteractiveElements(false);
            this.superFocusOnEachUpdate();
        };
        this.saveFileCard = (meta, fileID)=>{
            this.uppy.setFileMeta(fileID, meta);
            this.toggleFileCard(false, fileID);
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                return {
                    ...target,
                    icon: plugin.icon || this.opts.defaultPickerIcon,
                    render: plugin.render
                };
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_isTargetSupported, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
                if (typeof plugin.isSupported !== "function") return true;
                return plugin.isSupported();
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getAcquirers, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "acquirer" && $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_isTargetSupported)[$b868dcf7a47332e3$var$_isTargetSupported](target)).map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getProgressIndicators, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "progressindicator").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getEditors, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "editor").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        this.render = (state)=>{
            const pluginState = this.getPluginState();
            const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
            const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
            const acquirers = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getAcquirers)[$b868dcf7a47332e3$var$_getAcquirers](pluginState.targets);
            const progressindicators = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getProgressIndicators)[$b868dcf7a47332e3$var$_getProgressIndicators](pluginState.targets);
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](pluginState.targets);
            let theme;
            if (this.opts.theme === "auto") theme = capabilities.darkMode ? "dark" : "light";
            else theme = this.opts.theme;
            if ([
                "files",
                "folders",
                "both"
            ].indexOf(this.opts.fileManagerSelectionType) < 0) {
                this.opts.fileManagerSelectionType = "files";
                // eslint-disable-next-line no-console
                console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
            }
            return (0, $8dc96b7f61bbef1d$export$2e2bcd8739ae039)({
                state: state,
                isHidden: pluginState.isHidden,
                files: files,
                newFiles: newFiles,
                uploadStartedFiles: uploadStartedFiles,
                completeFiles: completeFiles,
                erroredFiles: erroredFiles,
                inProgressFiles: inProgressFiles,
                inProgressNotPausedFiles: inProgressNotPausedFiles,
                processingFiles: processingFiles,
                isUploadStarted: isUploadStarted,
                isAllComplete: isAllComplete,
                isAllPaused: isAllPaused,
                totalFileCount: Object.keys(files).length,
                totalProgress: state.totalProgress,
                allowNewUpload: allowNewUpload,
                acquirers: acquirers,
                theme: theme,
                disabled: this.opts.disabled,
                disableLocalFiles: this.opts.disableLocalFiles,
                direction: this.opts.direction,
                activePickerPanel: pluginState.activePickerPanel,
                showFileEditor: pluginState.showFileEditor,
                saveFileEditor: this.saveFileEditor,
                closeFileEditor: this.closeFileEditor,
                disableInteractiveElements: this.disableInteractiveElements,
                animateOpenClose: this.opts.animateOpenClose,
                isClosing: pluginState.isClosing,
                progressindicators: progressindicators,
                editors: editors,
                autoProceed: this.uppy.opts.autoProceed,
                id: this.id,
                closeModal: this.requestCloseModal,
                handleClickOutside: this.handleClickOutside,
                handleInputChange: this.handleInputChange,
                handlePaste: this.handlePaste,
                inline: this.opts.inline,
                showPanel: this.showPanel,
                hideAllPanels: this.hideAllPanels,
                i18n: this.i18n,
                i18nArray: this.i18nArray,
                uppy: this.uppy,
                note: this.opts.note,
                recoveredState: state.recoveredState,
                metaFields: pluginState.metaFields,
                resumableUploads: capabilities.resumableUploads || false,
                individualCancellation: capabilities.individualCancellation,
                isMobileDevice: capabilities.isMobileDevice,
                fileCardFor: pluginState.fileCardFor,
                toggleFileCard: this.toggleFileCard,
                toggleAddFilesPanel: this.toggleAddFilesPanel,
                showAddFilesPanel: pluginState.showAddFilesPanel,
                saveFileCard: this.saveFileCard,
                openFileEditor: this.openFileEditor,
                canEditFile: this.canEditFile,
                width: this.opts.width,
                height: this.opts.height,
                showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
                fileManagerSelectionType: this.opts.fileManagerSelectionType,
                proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
                hideCancelButton: this.opts.hideCancelButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
                containerWidth: pluginState.containerWidth,
                containerHeight: pluginState.containerHeight,
                areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
                parentElement: this.el,
                allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
                maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
                requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
                showSelectedFiles: this.opts.showSelectedFiles,
                showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
                showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
                nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
                singleFileFullScreen: this.opts.singleFileFullScreen,
                handleCancelRestore: this.handleCancelRestore,
                handleRequestThumbnail: this.handleRequestThumbnail,
                handleCancelThumbnail: this.handleCancelThumbnail,
                // drag props
                isDraggingOver: pluginState.isDraggingOver,
                handleDragOver: this.handleDragOver,
                handleDragLeave: this.handleDragLeave,
                handleDrop: this.handleDrop
            });
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions, {
            writable: true,
            value: ()=>{
                const { plugins: plugins } = this.opts;
                plugins.forEach((pluginID)=>{
                    const plugin = this.uppy.getPlugin(pluginID);
                    if (plugin) plugin.mount(this, plugin);
                    else this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, "warning");
                });
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins, {
            writable: true,
            value: ()=>{
                this.uppy.iteratePlugins($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget, {
            writable: true,
            value: (plugin)=>{
                var _plugin$opts;
                // Only these types belong on the Dashboard,
                // we wouldn’t want to try and mount Compressor or Tus, for example.
                const typesAllowed = [
                    "acquirer",
                    "editor"
                ];
                if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
                    const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin)=>plugin.id === installedPlugin.id);
                    if (!pluginAlreadyAdded) plugin.mount(this, plugin);
                }
            }
        });
        this.install = ()=>{
            // Set default state for Dashboard
            this.setPluginState({
                isHidden: true,
                fileCardFor: null,
                activeOverlayType: null,
                showAddFilesPanel: false,
                activePickerPanel: undefined,
                showFileEditor: false,
                metaFields: this.opts.metaFields,
                targets: [],
                // We'll make them visible once .containerWidth is determined
                areInsidesReadyToBeVisible: false,
                isDraggingOver: false
            });
            const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
            if (inline && closeAfterFinish) throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
            const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
            if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
            const { target: target } = this.opts;
            if (target) this.mount(target, this);
            if (!this.opts.disableStatusBar) this.uppy.use((0, $f22a72e7b80fdb1a$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarId)[$b868dcf7a47332e3$var$_getStatusBarId](),
                target: this,
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarOpts)[$b868dcf7a47332e3$var$_getStatusBarOpts]()
            });
            if (!this.opts.disableInformer) this.uppy.use((0, $2d1e3e0d76faae78$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getInformerId)[$b868dcf7a47332e3$var$_getInformerId](),
                target: this,
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getInformerOpts)[$b868dcf7a47332e3$var$_getInformerOpts]()
            });
            if (!this.opts.disableThumbnailGenerator) this.uppy.use((0, $f92c4ad36d89e394$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId)[$b868dcf7a47332e3$var$_getThumbnailGeneratorId](),
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts)[$b868dcf7a47332e3$var$_getThumbnailGeneratorOpts]()
            });
            // Dark Mode / theme
            this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
            const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnFromTheStart);
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu;
                (_this$darkModeMediaQu = this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(this.handleSystemDarkModeChange);
            }
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions)[$b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions]();
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins)[$b868dcf7a47332e3$var$_autoDiscoverPlugins]();
            this.initEvents();
        };
        this.uninstall = ()=>{
            if (!this.opts.disableInformer) {
                const informer = this.uppy.getPlugin(`${this.id}:Informer`);
                // Checking if this plugin exists, in case it was removed by uppy-core
                // before the Dashboard was.
                if (informer) this.uppy.removePlugin(informer);
            }
            if (!this.opts.disableStatusBar) {
                const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
                if (statusBar) this.uppy.removePlugin(statusBar);
            }
            if (!this.opts.disableThumbnailGenerator) {
                const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                if (thumbnail) this.uppy.removePlugin(thumbnail);
            }
            const { plugins: plugins } = this.opts;
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.unmount();
            });
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu2;
                (_this$darkModeMediaQu2 = this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(this.handleSystemDarkModeChange);
            }
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            this.unmount();
            this.removeEvents();
        };
        this.id = this.opts.id || "Dashboard";
        this.title = "Dashboard";
        this.type = "orchestrator";
        this.defaultLocale = (0, $c4158ae05dd76b13$export$2e2bcd8739ae039);
        // Dynamic default options:
        if (this.opts.doneButtonHandler === undefined) // `null` means "do not display a Done button", while `undefined` means
        // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
        this.opts.doneButtonHandler = ()=>{
            this.uppy.clear();
            this.requestCloseModal();
        };
        (_this$opts$onRequestC = (_this$opts = this.opts).onRequestCloseModal) != null ? _this$opts$onRequestC : _this$opts.onRequestCloseModal = ()=>this.closeModal();
        this.i18nInit();
    }
    setOptions(opts) {
        var _this$uppy$getPlugin, _this$uppy$getPlugin2;
        super.setOptions(opts);
        (_this$uppy$getPlugin = this.uppy.getPlugin($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarId)[$b868dcf7a47332e3$var$_getStatusBarId]())) == null || _this$uppy$getPlugin.setOptions($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarOpts)[$b868dcf7a47332e3$var$_getStatusBarOpts]());
        (_this$uppy$getPlugin2 = this.uppy.getPlugin($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId)[$b868dcf7a47332e3$var$_getThumbnailGeneratorId]())) == null || _this$uppy$getPlugin2.setOptions($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts)[$b868dcf7a47332e3$var$_getThumbnailGeneratorOpts]());
    }
}
function $b868dcf7a47332e3$var$_getStatusBarOpts2() {
    const { hideUploadButton: hideUploadButton, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showProgressDetails: showProgressDetails, hideProgressAfterFinish: hideProgressAfterFinish, locale: l, doneButtonHandler: doneButtonHandler } = this.opts;
    return {
        hideUploadButton: hideUploadButton,
        hideRetryButton: hideRetryButton,
        hidePauseResumeButton: hidePauseResumeButton,
        hideCancelButton: hideCancelButton,
        showProgressDetails: showProgressDetails,
        hideAfterFinish: hideProgressAfterFinish,
        locale: l,
        doneButtonHandler: doneButtonHandler
    };
}
function $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts2() {
    const { thumbnailWidth: thumbnailWidth, thumbnailHeight: thumbnailHeight, thumbnailType: thumbnailType, waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload } = this.opts;
    return {
        thumbnailWidth: thumbnailWidth,
        thumbnailHeight: thumbnailHeight,
        thumbnailType: thumbnailType,
        waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload,
        // If we don't block on thumbnails, we can lazily generate them
        lazy: !waitForThumbnailsBeforeUpload
    };
}
function $b868dcf7a47332e3$var$_getInformerOpts2() {
    return {
    };
}
function $b868dcf7a47332e3$var$_getStatusBarId2() {
    return `${this.id}:StatusBar`;
}
function $b868dcf7a47332e3$var$_getThumbnailGeneratorId2() {
    return `${this.id}:ThumbnailGenerator`;
}
function $b868dcf7a47332e3$var$_getInformerId2() {
    return `${this.id}:Informer`;
}
$b868dcf7a47332e3$export$2e2bcd8739ae039.VERSION = $b868dcf7a47332e3$var$packageJson.version;





function $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $c89f32c7d05a95a3$var$id = 0;
function $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $c89f32c7d05a95a3$var$id++ + "_" + e;
}
var $c89f32c7d05a95a3$var$_uppy = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("uppy");
var $c89f32c7d05a95a3$var$_events = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("events");
class $c89f32c7d05a95a3$export$2e2bcd8739ae039 {
    constructor(uppy){
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_uppy, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_events, {
            writable: true,
            value: []
        });
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy] = uppy;
    }
    on(event, fn) {
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].push([
            event,
            fn
        ]);
        return $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].on(event, fn);
    }
    remove() {
        for (const [event, fn] of $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].splice(0))$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].off(event, fn);
    }
    onFilePause(fileID, cb) {
        this.on("upload-pause", (file, isPaused)=>{
            if (fileID === (file == null ? void 0 : file.id)) cb(isPaused);
        });
    }
    onFileRemove(fileID, cb) {
        this.on("file-removed", (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onPause(fileID, cb) {
        this.on("upload-pause", (file, isPaused)=>{
            if (fileID === (file == null ? void 0 : file.id)) // const isPaused = this.#uppy.pauseResume(fileID)
            cb(isPaused);
        });
    }
    onRetry(fileID, cb) {
        this.on("upload-retry", (file)=>{
            if (fileID === (file == null ? void 0 : file.id)) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.on("retry-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onPauseAll(fileID, cb) {
        this.on("pause-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        var _this = this;
        this.on("cancel-all", function() {
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(_this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            eventHandler(...arguments);
        });
    }
    onResumeAll(fileID, cb) {
        this.on("resume-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
}


function $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $6cb886e1a5aec334$var$id = 0;
function $6cb886e1a5aec334$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $6cb886e1a5aec334$var$id++ + "_" + e;
}
function $6cb886e1a5aec334$var$createCancelError(cause) {
    return new Error("Cancelled", {
        cause: cause
    });
}
function $6cb886e1a5aec334$var$abortOn(signal) {
    if (signal != null) {
        var _this$then;
        const abortPromise = ()=>this.abort(signal.reason);
        signal.addEventListener("abort", abortPromise, {
            once: true
        });
        const removeAbortListener = ()=>{
            signal.removeEventListener("abort", abortPromise);
        };
        (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
    }
    return this;
}
var $6cb886e1a5aec334$var$_activeRequests = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("activeRequests");
var $6cb886e1a5aec334$var$_queuedHandlers = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queuedHandlers");
var $6cb886e1a5aec334$var$_paused = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("paused");
var $6cb886e1a5aec334$var$_pauseTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("pauseTimer");
var $6cb886e1a5aec334$var$_downLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("downLimit");
var $6cb886e1a5aec334$var$_upperLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("upperLimit");
var $6cb886e1a5aec334$var$_rateLimitingTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("rateLimitingTimer");
var $6cb886e1a5aec334$var$_call = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("call");
var $6cb886e1a5aec334$var$_queueNext = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queueNext");
var $6cb886e1a5aec334$var$_next = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("next");
var $6cb886e1a5aec334$var$_queue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queue");
var $6cb886e1a5aec334$var$_dequeue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("dequeue");
var $6cb886e1a5aec334$var$_resume = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("resume");
var $6cb886e1a5aec334$var$_increaseLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("increaseLimit");
class $6cb886e1a5aec334$export$32306e81289653bc {
    constructor(limit){
        Object.defineProperty(this, $6cb886e1a5aec334$var$_dequeue, {
            value: $6cb886e1a5aec334$var$_dequeue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queue, {
            value: $6cb886e1a5aec334$var$_queue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_next, {
            value: $6cb886e1a5aec334$var$_next2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queueNext, {
            value: $6cb886e1a5aec334$var$_queueNext2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_call, {
            value: $6cb886e1a5aec334$var$_call2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_activeRequests, {
            writable: true,
            value: 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queuedHandlers, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_paused, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_pauseTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_downLimit, {
            writable: true,
            value: 1
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_upperLimit, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_rateLimitingTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_resume, {
            writable: true,
            value: ()=>this.resume()
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_increaseLimit, {
            writable: true,
            value: ()=>{
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused]) {
                    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 0);
                    return;
                }
                $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = this.limit;
                this.limit = Math.ceil(($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] + $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]) / 2);
                for(let i = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]; i <= this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] - $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] > 3) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 2000);
                else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = Math.floor($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] / 2);
            }
        });
        if (typeof limit !== "number" || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    run(fn, queueOptions) {
        if (!$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] && $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] < this.limit) return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](fn);
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queue)[$6cb886e1a5aec334$var$_queue](fn, queueOptions);
    }
    wrapSyncFunction(fn, queueOptions) {
        var _this = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const queuedRequest = _this.run(()=>{
                fn(...args);
                queueMicrotask(()=>queuedRequest.done());
                return ()=>{};
            }, queueOptions);
            return {
                abortOn: $6cb886e1a5aec334$var$abortOn,
                abort () {
                    queuedRequest.abort();
                }
            };
        };
    }
    wrapPromiseFunction(fn, queueOptions) {
        var _this2 = this;
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = _this2.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return (cause)=>{
                        cancelError = $6cb886e1a5aec334$var$createCancelError(cause);
                    };
                }, queueOptions);
            });
            outerPromise.abort = (cause)=>{
                queuedRequest.abort(cause);
            };
            outerPromise.abortOn = $6cb886e1a5aec334$var$abortOn;
            return outerPromise;
        };
    }
    resume() {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = false;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        for(let i = 0; i < this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
    }
    /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */ pause(duration) {
        if (duration === void 0) duration = null;
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = true;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        if (duration != null) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_resume)[$6cb886e1a5aec334$var$_resume], duration);
    }
    /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */ rateLimit(duration) {
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer]);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] = this.limit - 1;
            this.limit = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit];
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], duration);
        }
    }
    get isPaused() {
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused];
    }
}
function $6cb886e1a5aec334$var$_call2(fn) {
    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] += 1;
    let done = false;
    let cancelActive;
    try {
        cancelActive = fn();
    } catch (err) {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
        throw err;
    }
    return {
        abort: (cause)=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            cancelActive == null || cancelActive(cause);
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        },
        done: ()=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        }
    };
}
function $6cb886e1a5aec334$var$_queueNext2() {
    // Do it soon but not immediately, this allows clearing out the entire queue synchronously
    // one by one without continuously _advancing_ it (and starting new tasks before immediately
    // aborting them)
    queueMicrotask(()=>$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_next)[$6cb886e1a5aec334$var$_next]());
}
function $6cb886e1a5aec334$var$_next2() {
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] || $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] >= this.limit) return;
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].length === 0) return;
    // Dispatch the next request, and update the abort/done handlers
    // so that cancelling it does the Right Thing (and doesn't just try
    // to dequeue an already-running request).
    const next = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].shift();
    if (next == null) throw new Error("Invariant violation: next is null");
    const handler = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](next.fn);
    next.abort = handler.abort;
    next.done = handler.done;
}
function $6cb886e1a5aec334$var$_queue2(fn, options) {
    const handler = {
        fn: fn,
        priority: (options == null ? void 0 : options.priority) || 0,
        abort: ()=>{
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_dequeue)[$6cb886e1a5aec334$var$_dequeue](handler);
        },
        done: ()=>{
            throw new Error("Cannot mark a queued request as done: this indicates a bug");
        }
    };
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].findIndex((other)=>{
        return handler.priority > other.priority;
    });
    if (index === -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].push(handler);
    else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 0, handler);
    return handler;
}
function $6cb886e1a5aec334$var$_dequeue2(handler) {
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].indexOf(handler);
    if (index !== -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 1);
}
const $6cb886e1a5aec334$export$603eb9c93e04437 = Symbol("__queue");


class $0026c55df46f9934$var$NetworkError extends Error {
    constructor(error, xhr){
        if (xhr === void 0) xhr = null;
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
var $0026c55df46f9934$export$2e2bcd8739ae039 = $0026c55df46f9934$var$NetworkError;


function $404d4d8ff4ce3ae1$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var $404d4d8ff4ce3ae1$export$2e2bcd8739ae039 = $404d4d8ff4ce3ae1$var$isNetworkError;



function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $c8d4b79cf5a3269c$var$id = 0;
function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $c8d4b79cf5a3269c$var$id++ + "_" + e;
}
var $c8d4b79cf5a3269c$var$_aliveTimer = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("aliveTimer");
var $c8d4b79cf5a3269c$var$_isDone = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("isDone");
var $c8d4b79cf5a3269c$var$_onTimedOut = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("onTimedOut");
var $c8d4b79cf5a3269c$var$_timeout = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("timeout");
/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $c8d4b79cf5a3269c$var$ProgressTimeout {
    constructor(timeout, // eslint-disable-next-line no-shadow
    timeoutHandler){
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_aliveTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_isDone, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_onTimedOut, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_timeout, {
            writable: true,
            value: void 0
        });
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] = timeout;
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut] = ()=>timeoutHandler(timeout);
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) return;
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] > 0) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = setTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut], $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout]);
        }
    }
    done() {
        if (!$c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = undefined;
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone] = true;
        }
    }
}
var $c8d4b79cf5a3269c$export$2e2bcd8739ae039 = $c8d4b79cf5a3269c$var$ProgressTimeout;


const $e3981d1185f67d50$var$noop = ()=>{};
function $e3981d1185f67d50$export$47fdd40111eda34c(url, options) {
    if (options === void 0) options = {};
    const { body: body = null, headers: headers = {}, method: method = "GET", onBeforeRequest: onBeforeRequest = $e3981d1185f67d50$var$noop, onUploadProgress: onUploadProgress = $e3981d1185f67d50$var$noop, shouldRetry: shouldRetry = ()=>true, onAfterResponse: onAfterResponse = $e3981d1185f67d50$var$noop, onTimeout: onTimeout = $e3981d1185f67d50$var$noop, responseType: responseType, retries: retries = 3, signal: signal = null, timeout: timeout = 30000, withCredentials: withCredentials = false } = options;
    // 300 ms, 600 ms, 1200 ms, 2400 ms, 4800 ms
    const delay = (attempt)=>0.3 * 2 ** (attempt - 1) * 1000;
    const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(timeout, onTimeout);
    function requestWithRetry(retryCount) {
        if (retryCount === void 0) retryCount = 0;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            const onError = (error)=>{
                if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(error);
                }
            };
            xhr.open(method, url, true);
            xhr.withCredentials = withCredentials;
            if (responseType) xhr.responseType = responseType;
            signal == null || signal.addEventListener("abort", ()=>{
                xhr.abort();
                // Using DOMException for abort errors aligns with
                // the convention established by the Fetch API.
                reject(new DOMException("Aborted", "AbortError"));
            });
            xhr.onload = async ()=>{
                try {
                    await onAfterResponse(xhr, retryCount);
                } catch (err) {
                    // This is important as we need to emit the xhr
                    // over the upload-error event.
                    err.request = xhr;
                    onError(err);
                    return;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    timer.done();
                    resolve(xhr);
                } else if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
                }
            };
            xhr.onerror = ()=>onError(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
            xhr.upload.onprogress = (event)=>{
                timer.progress();
                onUploadProgress(event);
            };
            if (headers) Object.keys(headers).forEach((key)=>{
                xhr.setRequestHeader(key, headers[key]);
            });
            await onBeforeRequest(xhr, retryCount);
            xhr.send(body);
        });
    }
    return requestWithRetry();
}


function $169d20dd56f976c7$export$3bd9b1601aad11ac(files) {
    const hasError = (file)=>"error" in file && !!file.error;
    return files.filter((file)=>!hasError(file));
}
function $169d20dd56f976c7$export$9e8ffa0bfbcfeed6(files) {
    return files.filter((file)=>{
        var _file$progress;
        return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
    });
}


function $8e92129945053521$export$2e2bcd8739ae039(fields, meta) {
    if (fields === true) return Object.keys(meta);
    if (Array.isArray(fields)) return fields;
    return [];
}


var $3b2facc875d4722d$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it."
    }
};


function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $cf91058fd9d7f8ee$var$id = 0;
function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $cf91058fd9d7f8ee$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $cf91058fd9d7f8ee$var$packageJson = {
    "version": "4.3.3"
};
function $cf91058fd9d7f8ee$var$buildResponseError(xhr, err) {
    let error = err;
    // No error message
    if (!error) error = new Error("Upload error");
    // Got an error message string
    if (typeof error === "string") error = new Error(error);
    // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error("Upload error"), {
        data: error
    });
    if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(xhr)) {
        error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, xhr);
        return error;
    }
    // @ts-expect-error request can only be set on NetworkError
    // but we use NetworkError to distinguish between errors.
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */ function $cf91058fd9d7f8ee$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
const $cf91058fd9d7f8ee$var$defaultOptions = {
    formData: true,
    fieldName: "file",
    method: "post",
    allowedMetaFields: true,
    bundle: false,
    headers: {},
    timeout: 30000,
    limit: 5,
    withCredentials: false,
    responseType: ""
};
var $cf91058fd9d7f8ee$var$_getFetcher = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getFetcher");
var $cf91058fd9d7f8ee$var$_uploadLocalFile = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadLocalFile");
var $cf91058fd9d7f8ee$var$_uploadBundle = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadBundle");
var $cf91058fd9d7f8ee$var$_getCompanionClientArgs = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getCompanionClientArgs");
var $cf91058fd9d7f8ee$var$_uploadFiles = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadFiles");
var $cf91058fd9d7f8ee$var$_handleUpload = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("handleUpload");
class $cf91058fd9d7f8ee$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, _opts){
        super(uppy, {
            ...$cf91058fd9d7f8ee$var$defaultOptions,
            fieldName: _opts.bundle ? "files[]" : "file",
            ..._opts
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadFiles, {
            value: $cf91058fd9d7f8ee$var$_uploadFiles2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs, {
            value: $cf91058fd9d7f8ee$var$_getCompanionClientArgs2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadBundle, {
            value: $cf91058fd9d7f8ee$var$_uploadBundle2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadLocalFile, {
            value: $cf91058fd9d7f8ee$var$_uploadLocalFile2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getFetcher, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_handleUpload, {
            writable: true,
            value: async (fileIDs)=>{
                if (fileIDs.length === 0) {
                    this.uppy.log("[XHRUpload] No files to upload!");
                    return;
                }
                // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
                // (basically just AwsS3) using the internal symbol
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore untyped internal
                if (this.opts.limit === 0 && !this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437]) this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning");
                this.uppy.log("[XHRUpload] Uploading...");
                const files = this.uppy.getFilesByIds(fileIDs);
                const filesFiltered = (0, $169d20dd56f976c7$export$3bd9b1601aad11ac)(files);
                const filesToEmit = (0, $169d20dd56f976c7$export$9e8ffa0bfbcfeed6)(filesFiltered);
                this.uppy.emit("upload-start", filesToEmit);
                if (this.opts.bundle) {
                    // if bundle: true, we don’t support remote uploads
                    const isSomeFileRemote = filesFiltered.some((file)=>file.isRemote);
                    if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
                    if (typeof this.opts.headers === "function") throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
                    await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadBundle)[$cf91058fd9d7f8ee$var$_uploadBundle](filesFiltered);
                } else await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadFiles)[$cf91058fd9d7f8ee$var$_uploadFiles](filesFiltered);
            }
        });
        this.type = "uploader";
        this.id = this.opts.id || "XHRUpload";
        this.defaultLocale = (0, $3b2facc875d4722d$export$2e2bcd8739ae039);
        this.i18nInit();
        // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ((0, $6cb886e1a5aec334$export$603eb9c93e04437) in this.opts) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore untyped internal
        this.requests = this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437];
        else this.requests = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
        if (this.opts.bundle && typeof this.opts.headers === "function") throw new Error("`opts.headers` can not be a function when the `bundle: true` option is set.");
        if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && "metaFields" in this.opts) throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
        this.uploaderEvents = Object.create(null);
        /**
     * xhr-upload wrapper for `fetcher` to handle user options
     * `validateStatus`, `getResponseError`, `getResponseData`
     * and to emit `upload-progress`, `upload-error`, and `upload-success` events.
     */ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher] = (files)=>{
            return async (url, options)=>{
                try {
                    var _this$opts$getRespons, _this$opts2, _body3;
                    const res = await (0, $e3981d1185f67d50$export$47fdd40111eda34c)(url, {
                        ...options,
                        onBeforeRequest: (xhr, retryCount)=>{
                            var _this$opts$onBeforeRe, _this$opts;
                            return (_this$opts$onBeforeRe = (_this$opts = this.opts).onBeforeRequest) == null ? void 0 : _this$opts$onBeforeRe.call(_this$opts, xhr, retryCount, files);
                        },
                        shouldRetry: this.opts.shouldRetry,
                        onAfterResponse: this.opts.onAfterResponse,
                        onTimeout: (timeout)=>{
                            const seconds = Math.ceil(timeout / 1000);
                            const error = new Error(this.i18n("uploadStalled", {
                                seconds: seconds
                            }));
                            this.uppy.emit("upload-stalled", error, files);
                        },
                        onUploadProgress: (event)=>{
                            if (event.lengthComputable) for (const { id: id } of files){
                                var _file$progress$upload;
                                const file = this.uppy.getFile(id);
                                this.uppy.emit("upload-progress", file, {
                                    uploadStarted: (_file$progress$upload = file.progress.uploadStarted) != null ? _file$progress$upload : 0,
                                    bytesUploaded: event.loaded / event.total * file.size,
                                    bytesTotal: file.size
                                });
                            }
                        }
                    });
                    let body = await ((_this$opts$getRespons = (_this$opts2 = this.opts).getResponseData) == null ? void 0 : _this$opts$getRespons.call(_this$opts2, res));
                    if (res.responseType === "json") {
                        var _body;
                        (_body = body) != null ? _body : body = res.response;
                    } else try {
                        var _body2;
                        (_body2 = body) != null ? _body2 : body = JSON.parse(res.responseText);
                    } catch (cause) {
                        throw new Error("@uppy/xhr-upload expects a JSON response (with a `url` property). To parse non-JSON responses, use `getResponseData` to turn your response into JSON.", {
                            cause: cause
                        });
                    }
                    const uploadURL = typeof ((_body3 = body) == null ? void 0 : _body3.url) === "string" ? body.url : undefined;
                    for (const { id: id } of files)this.uppy.emit("upload-success", this.uppy.getFile(id), {
                        status: res.status,
                        body: body,
                        uploadURL: uploadURL
                    });
                    return res;
                } catch (error) {
                    if (error.name === "AbortError") return undefined;
                    const request = error.request;
                    for (const file of files)this.uppy.emit("upload-error", this.uppy.getFile(file.id), $cf91058fd9d7f8ee$var$buildResponseError(request, error), request);
                    throw error;
                }
            };
        };
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        };
        // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === "function") opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    // eslint-disable-next-line class-methods-use-this
    addMetadata(formData, meta, opts) {
        const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, meta);
        allowedMetaFields.forEach((item)=>{
            const value = meta[item];
            if (Array.isArray(value)) // In this case we don't transform `item` to add brackets, it's up to
            // the user to add the brackets so it won't be overridden.
            value.forEach((subItem)=>formData.append(item, subItem));
            else formData.append(item, value);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
}
async function $cf91058fd9d7f8ee$var$_uploadLocalFile2(file) {
    const events = new (0, $c89f32c7d05a95a3$export$2e2bcd8739ae039)(this.uppy);
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        const opts = this.getOptions(file);
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher]([
            file
        ]);
        const body = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
        return fetch(opts.endpoint, {
            ...opts,
            body: body,
            signal: controller.signal
        });
    });
    events.onFileRemove(file.id, ()=>controller.abort());
    events.onCancelAll(file.id, ()=>{
        controller.abort();
    });
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== "Cancelled") throw error;
    } finally{
        events.remove();
    }
}
async function $cf91058fd9d7f8ee$var$_uploadBundle2(files) {
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        var _this$uppy$getState$x;
        const optsFromState = (_this$uppy$getState$x = this.uppy.getState().xhrUpload) != null ? _this$uppy$getState$x : {};
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher](files);
        const body = this.createBundledUpload(files, {
            ...this.opts,
            ...optsFromState
        });
        return fetch(this.opts.endpoint, {
            // headers can't be a function with bundle: true
            ...this.opts,
            body: body,
            signal: controller.signal
        });
    });
    function abort() {
        controller.abort();
    }
    // We only need to abort on cancel all because
    // individual cancellations are not possible with bundle: true
    this.uppy.once("cancel-all", abort);
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== "Cancelled") throw error;
    } finally{
        this.uppy.off("cancel-all", abort);
    }
}
function $cf91058fd9d7f8ee$var$_getCompanionClientArgs2(file) {
    var _file$remote;
    const opts = this.getOptions(file);
    const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, file.meta);
    return {
        ...(_file$remote = file.remote) == null ? void 0 : _file$remote.body,
        protocol: "multipart",
        endpoint: opts.endpoint,
        size: file.data.size,
        fieldname: opts.fieldName,
        metadata: Object.fromEntries(allowedMetaFields.map((name)=>[
                name,
                file.meta[name]
            ])),
        httpMethod: opts.method,
        useFormData: opts.formData,
        headers: opts.headers
    };
}
async function $cf91058fd9d7f8ee$var$_uploadFiles2(files) {
    await Promise.allSettled(files.map((file)=>{
        if (file.isRemote) {
            const getQueue = ()=>this.requests;
            const controller = new AbortController();
            const removedHandler = (removedFile)=>{
                if (removedFile.id === file.id) controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs)[$cf91058fd9d7f8ee$var$_getCompanionClientArgs](file), {
                signal: controller.signal,
                getQueue: getQueue
            });
            this.requests.wrapSyncFunction(()=>{
                this.uppy.off("file-removed", removedHandler);
            }, {
                priority: -1
            })();
            return uploadPromise;
        }
        return $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadLocalFile)[$cf91058fd9d7f8ee$var$_uploadLocalFile](file);
    }));
}
// eslint-disable-next-line global-require
$cf91058fd9d7f8ee$export$2e2bcd8739ae039.VERSION = $cf91058fd9d7f8ee$var$packageJson.version;




const $02bf16315accd34b$var$mimeToExtensions = {
    __proto__: null,
    "audio/mp3": "mp3",
    "audio/mp4": "mp4",
    "audio/ogg": "ogg",
    "audio/webm": "webm",
    "image/gif": "gif",
    "image/heic": "heic",
    "image/heif": "heif",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/svg+xml": "svg",
    "video/mp4": "mp4",
    "video/ogg": "ogv",
    "video/quicktime": "mov",
    "video/webm": "webm",
    "video/x-matroska": "mkv",
    "video/x-msvideo": "avi"
};
function $02bf16315accd34b$export$2e2bcd8739ae039(mimeType) {
    [mimeType] = mimeType.split(";", 1);
    return $02bf16315accd34b$var$mimeToExtensions[mimeType] || null;
}



var $021998eb446a914f$exports = {};
"use strict";
$021998eb446a914f$exports = $021998eb446a914f$var$isMobile;
$021998eb446a914f$exports.isMobile = $021998eb446a914f$var$isMobile;
$021998eb446a914f$exports.default = $021998eb446a914f$var$isMobile;
const $021998eb446a914f$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $021998eb446a914f$var$notMobileRE = /CrOS/;
const $021998eb446a914f$var$tabletRE = /android|ipad|playbook|silk/i;
function $021998eb446a914f$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") ua = ua.headers["user-agent"];
    if (typeof ua !== "string") return false;
    let result = $021998eb446a914f$var$mobileRE.test(ua) && !$021998eb446a914f$var$notMobileRE.test(ua) || !!opts.tablet && $021998eb446a914f$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) result = true;
    return result;
}


/**
 * Save a <canvas> element's content to a Blob object.
 *
 * @param {HTMLCanvasElement} canvas
 * @returns {Promise}
 */ function $6eb49ffe149480f4$export$2e2bcd8739ae039(canvas, type, quality) {
    return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    });
}


function $9467c5a2e8688091$export$2e2bcd8739ae039() {
    /* eslint-disable compat/compat */ return typeof MediaRecorder === "function" && !!MediaRecorder.prototype && typeof MediaRecorder.prototype.start === "function";
/* eslint-enable compat/compat */ }



function $99948036f31c1ff8$export$2e2bcd8739ae039() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        fill: "#0097DC",
        width: "66",
        height: "55",
        viewBox: "0 0 66 55"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M57.3 8.433c4.59 0 8.1 3.51 8.1 8.1v29.7c0 4.59-3.51 8.1-8.1 8.1H8.7c-4.59 0-8.1-3.51-8.1-8.1v-29.7c0-4.59 3.51-8.1 8.1-8.1h9.45l4.59-7.02c.54-.54 1.35-1.08 2.16-1.08h16.2c.81 0 1.62.54 2.16 1.08l4.59 7.02h9.45zM33 14.64c-8.62 0-15.393 6.773-15.393 15.393 0 8.62 6.773 15.393 15.393 15.393 8.62 0 15.393-6.773 15.393-15.393 0-8.62-6.773-15.393-15.393-15.393zM33 40c-5.648 0-9.966-4.319-9.966-9.967 0-5.647 4.318-9.966 9.966-9.966s9.966 4.319 9.966 9.966C42.966 35.681 38.648 40 33 40z",
        fillRule: "evenodd"
    }));
}





function $03d5be17ba97047d$export$2e2bcd8739ae039(_ref) {
    let { onSnapshot: onSnapshot, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--picture",
        type: "button",
        title: i18n("takePicture"),
        "aria-label": i18n("takePicture"),
        onClick: onSnapshot,
        "data-uppy-super-focusable": true
    }, (0, $99948036f31c1ff8$export$2e2bcd8739ae039)());
}



function $8924b8d6564ff777$export$2e2bcd8739ae039(_ref) {
    let { recording: recording, onStartRecording: onStartRecording, onStopRecording: onStopRecording, i18n: i18n } = _ref;
    if (recording) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Webcam-button",
        type: "button",
        title: i18n("stopRecording"),
        "aria-label": i18n("stopRecording"),
        onClick: onStopRecording,
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "15",
        y: "15",
        width: "70",
        height: "70"
    })));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Webcam-button",
        type: "button",
        title: i18n("startRecording"),
        "aria-label": i18n("startRecording"),
        onClick: onStartRecording,
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        cx: "50",
        cy: "50",
        r: "40"
    })));
}



/**
 * Takes an Integer value of seconds (e.g. 83) and converts it into a human-readable formatted string (e.g. '1:23').
 *
 */ function $a4c51377819f33bc$export$2e2bcd8739ae039(seconds) {
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}


function $ef7ac7ec019a8c7f$export$2e2bcd8739ae039(_ref) {
    let { recordingLengthSeconds: recordingLengthSeconds, i18n: i18n } = _ref;
    const formattedRecordingLengthSeconds = (0, $a4c51377819f33bc$export$2e2bcd8739ae039)(recordingLengthSeconds);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        "aria-label": i18n("recordingLength", {
            recording_length: formattedRecordingLengthSeconds
        })
    }, formattedRecordingLengthSeconds);
}



function $4ce36466e272d2f2$export$2e2bcd8739ae039(_ref) {
    let { currentDeviceId: currentDeviceId, videoSources: videoSources, onChangeVideoSource: onChangeVideoSource } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Webcam-videoSource"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("select", {
        className: "uppy-u-reset uppy-Webcam-videoSource-select",
        onChange: (event)=>{
            onChangeVideoSource(event.target.value);
        }
    }, videoSources.map((videoSource)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("option", {
            key: videoSource.deviceId,
            value: videoSource.deviceId,
            selected: videoSource.deviceId === currentDeviceId
        }, videoSource.label))));
}



function $45cdb028224daeeb$var$SubmitButton(_ref) {
    let { onSubmit: onSubmit, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--submit",
        type: "button",
        title: i18n("submitRecordedFile"),
        "aria-label": i18n("submitRecordedFile"),
        onClick: onSubmit,
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "12",
        height: "9",
        viewBox: "0 0 12 9",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#fff",
        fillRule: "nonzero",
        d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z"
    })));
}
var $45cdb028224daeeb$export$2e2bcd8739ae039 = $45cdb028224daeeb$var$SubmitButton;



function $783cbf0c02ecff10$var$DiscardButton(_ref) {
    let { onDiscard: onDiscard, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--discard",
        type: "button",
        title: i18n("discardRecordedFile"),
        "aria-label": i18n("discardRecordedFile"),
        onClick: onDiscard,
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#FFF",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M.496 11.367L11.103.76l1.414 1.414L1.911 12.781z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M11.104 12.782L.497 2.175 1.911.76l10.607 10.606z"
    }))));
}
var $783cbf0c02ecff10$export$2e2bcd8739ae039 = $783cbf0c02ecff10$var$DiscardButton;


function $83d272fc408761b9$var$_extends() {
    return $83d272fc408761b9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83d272fc408761b9$var$_extends.apply(null, arguments);
}
function $83d272fc408761b9$var$isModeAvailable(modes, mode) {
    return modes.includes(mode);
}
class $83d272fc408761b9$var$CameraScreen extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { onFocus: onFocus } = this.props;
        onFocus();
    }
    componentWillUnmount() {
        const { onStop: onStop } = this.props;
        onStop();
    }
    render() {
        const { src: src, recordedVideo: recordedVideo, recording: recording, modes: modes, supportsRecording: supportsRecording, videoSources: videoSources, showVideoSourceDropdown: showVideoSourceDropdown, showRecordingLength: showRecordingLength, onSubmit: onSubmit, i18n: i18n, mirror: mirror, onSnapshot: onSnapshot, onStartRecording: onStartRecording, onStopRecording: onStopRecording, onDiscardRecordedVideo: onDiscardRecordedVideo, recordingLengthSeconds: recordingLengthSeconds } = this.props;
        const hasRecordedVideo = !!recordedVideo;
        const shouldShowRecordButton = !hasRecordedVideo && supportsRecording && ($83d272fc408761b9$var$isModeAvailable(modes, "video-only") || $83d272fc408761b9$var$isModeAvailable(modes, "audio-only") || $83d272fc408761b9$var$isModeAvailable(modes, "video-audio"));
        const shouldShowSnapshotButton = !hasRecordedVideo && $83d272fc408761b9$var$isModeAvailable(modes, "picture");
        const shouldShowRecordingLength = supportsRecording && showRecordingLength && !hasRecordedVideo;
        const shouldShowVideoSourceDropdown = showVideoSourceDropdown && videoSources && videoSources.length > 1;
        const videoProps = {
            playsInline: true
        };
        if (recordedVideo) {
            videoProps.muted = false;
            videoProps.controls = true;
            videoProps.src = recordedVideo;
            // reset srcObject in dom. If not resetted, stream sticks in element
            if (this.videoElement) this.videoElement.srcObject = null;
        } else {
            videoProps.muted = true;
            videoProps.autoPlay = true;
            // @ts-expect-error srcObject does not exist on <video> props
            videoProps.srcObject = src;
        }
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy uppy-Webcam-container"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Webcam-videoContainer"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("video", $83d272fc408761b9$var$_extends({
            /* eslint-disable-next-line no-return-assign */ ref: (videoElement)=>this.videoElement = videoElement,
            className: `uppy-Webcam-video  ${mirror ? "uppy-Webcam-video--mirrored" : ""}`
        }, videoProps))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Webcam-footer"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Webcam-videoSourceContainer"
        }, shouldShowVideoSourceDropdown ? (0, $4ce36466e272d2f2$export$2e2bcd8739ae039)(this.props) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Webcam-buttonContainer"
        }, shouldShowSnapshotButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $03d5be17ba97047d$export$2e2bcd8739ae039), {
            onSnapshot: onSnapshot,
            i18n: i18n
        }), shouldShowRecordButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $8924b8d6564ff777$export$2e2bcd8739ae039), {
            recording: recording,
            onStartRecording: onStartRecording,
            onStopRecording: onStopRecording,
            i18n: i18n
        }), hasRecordedVideo && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $45cdb028224daeeb$export$2e2bcd8739ae039), {
            onSubmit: onSubmit,
            i18n: i18n
        }), hasRecordedVideo && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $783cbf0c02ecff10$export$2e2bcd8739ae039), {
            onDiscard: onDiscardRecordedVideo,
            i18n: i18n
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Webcam-recordingLength"
        }, shouldShowRecordingLength && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ef7ac7ec019a8c7f$export$2e2bcd8739ae039), {
            recordingLengthSeconds: recordingLengthSeconds,
            i18n: i18n
        }))));
    }
}
var $83d272fc408761b9$export$2e2bcd8739ae039 = $83d272fc408761b9$var$CameraScreen;



function $71fac5ac3dcc963a$export$2e2bcd8739ae039(_ref) {
    let { icon: icon, i18n: i18n, hasCamera: hasCamera } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Webcam-permissons"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Webcam-permissonsIcon"
    }, icon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Webcam-title"
    }, hasCamera ? i18n("allowAccessTitle") : i18n("noCameraTitle")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("p", null, hasCamera ? i18n("allowAccessDescription") : i18n("noCameraDescription")));
}


var $33ca93abcf994518$export$2e2bcd8739ae039 = {
    strings: {
        pluginNameCamera: "Camera",
        noCameraTitle: "Camera Not Available",
        noCameraDescription: "In order to take pictures or record video, please connect a camera device",
        recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit",
        submitRecordedFile: "Submit recorded file",
        discardRecordedFile: "Discard recorded file",
        // Shown before a picture is taken when the `countdown` option is set.
        smile: "Smile!",
        // Used as the label for the button that takes a picture.
        // This is not visibly rendered but is picked up by screen readers.
        takePicture: "Take a picture",
        // Used as the label for the button that starts a video recording.
        // This is not visibly rendered but is picked up by screen readers.
        startRecording: "Begin video recording",
        // Used as the label for the button that stops a video recording.
        // This is not visibly rendered but is picked up by screen readers.
        stopRecording: "Stop video recording",
        // Used as the label for the recording length counter. See the showRecordingLength option.
        // This is not visibly rendered but is picked up by screen readers.
        recordingLength: "Recording length %{recording_length}",
        // Title on the “allow access” screen
        allowAccessTitle: "Please allow access to your camera",
        // Description on the “allow access” screen
        allowAccessDescription: "In order to take pictures or record video with your camera, please allow camera access for this site."
    }
};


function $a4ffb8658443fda4$var$_extends() {
    return $a4ffb8658443fda4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a4ffb8658443fda4$var$_extends.apply(null, arguments);
}
function $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $a4ffb8658443fda4$var$id = 0;
function $a4ffb8658443fda4$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $a4ffb8658443fda4$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $a4ffb8658443fda4$var$packageJson = {
    "version": "4.1.2"
};
/**
 * Normalize a MIME type or file extension into a MIME type.
 *
 * @param fileType - MIME type or a file extension prefixed with `.`.
 * @returns The MIME type or `undefined` if the fileType is an extension and is not known.
 */ function $a4ffb8658443fda4$var$toMimeType(fileType) {
    if (fileType[0] === ".") return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileType.slice(1)];
    return fileType;
}
/**
 * Is this MIME type a video?
 */ function $a4ffb8658443fda4$var$isVideoMimeType(mimeType) {
    return /^video\/[^*]+$/.test(mimeType);
}
/**
 * Is this MIME type an image?
 */ function $a4ffb8658443fda4$var$isImageMimeType(mimeType) {
    return /^image\/[^*]+$/.test(mimeType);
}
function $a4ffb8658443fda4$var$getMediaDevices() {
    // bug in the compatibility data
    // eslint-disable-next-line compat/compat
    return navigator.mediaDevices;
}
function $a4ffb8658443fda4$var$isModeAvailable(modes, mode) {
    return modes.includes(mode);
}
// set default options
const $a4ffb8658443fda4$var$defaultOptions = {
    onBeforeSnapshot: ()=>Promise.resolve(),
    countdown: false,
    modes: [
        "video-audio",
        "video-only",
        "audio-only",
        "picture"
    ],
    mirror: true,
    showVideoSourceDropdown: false,
    preferredImageMimeType: null,
    preferredVideoMimeType: null,
    showRecordingLength: false,
    mobileNativeCamera: (0, (/*@__PURE__*/$parcel$interopDefault($021998eb446a914f$exports)))({
        tablet: true
    })
};
/**
 * Webcam
 */ var $a4ffb8658443fda4$var$_enableMirror = /*#__PURE__*/ $a4ffb8658443fda4$var$_classPrivateFieldLooseKey("enableMirror");
class $a4ffb8658443fda4$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$a4ffb8658443fda4$var$defaultOptions,
            ...opts
        });
        // enableMirror is used to toggle mirroring, for instance when discarding the video,
        // while `opts.mirror` is used to remember the initial user setting
        Object.defineProperty(this, $a4ffb8658443fda4$var$_enableMirror, {
            writable: true,
            value: void 0
        });
        this.stream = null;
        this.recorder = null;
        this.recordingChunks = null;
        this.captureInProgress = false;
        this.mediaDevices = $a4ffb8658443fda4$var$getMediaDevices();
        this.supportsUserMedia = !!this.mediaDevices;
        // eslint-disable-next-line no-restricted-globals
        this.protocol = location.protocol.match(/https/i) ? "https" : "http";
        this.id = this.opts.id || "Webcam";
        this.type = "acquirer";
        this.capturedMediaFile = null;
        this.icon = ()=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                fill: "#02B383",
                fillRule: "nonzero"
            }));
        this.defaultLocale = (0, $33ca93abcf994518$export$2e2bcd8739ae039);
        this.i18nInit();
        this.title = this.i18n("pluginNameCamera");
        $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(this, $a4ffb8658443fda4$var$_enableMirror)[$a4ffb8658443fda4$var$_enableMirror] = this.opts.mirror;
        this.install = this.install.bind(this);
        this.setPluginState = this.setPluginState.bind(this);
        this.render = this.render.bind(this);
        // Camera controls
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.takeSnapshot = this.takeSnapshot.bind(this);
        this.startRecording = this.startRecording.bind(this);
        this.stopRecording = this.stopRecording.bind(this);
        this.discardRecordedVideo = this.discardRecordedVideo.bind(this);
        this.submit = this.submit.bind(this);
        this.oneTwoThreeSmile = this.oneTwoThreeSmile.bind(this);
        this.focus = this.focus.bind(this);
        this.changeVideoSource = this.changeVideoSource.bind(this);
        this.webcamActive = false;
        if (this.opts.countdown) this.opts.onBeforeSnapshot = this.oneTwoThreeSmile;
        this.setPluginState({
            hasCamera: false,
            cameraReady: false,
            cameraError: null,
            recordingLengthSeconds: 0,
            videoSources: [],
            currentDeviceId: null
        });
    }
    setOptions(newOpts) {
        super.setOptions({
            ...newOpts,
            videoConstraints: {
                // May be undefined but ... handles that
                ...this.opts.videoConstraints,
                ...newOpts == null ? void 0 : newOpts.videoConstraints
            }
        });
    }
    hasCameraCheck() {
        if (!this.mediaDevices) return Promise.resolve(false);
        return this.mediaDevices.enumerateDevices().then((devices)=>{
            return devices.some((device)=>device.kind === "videoinput");
        });
    }
    isAudioOnly() {
        return this.opts.modes.length === 1 && this.opts.modes[0] === "audio-only";
    }
    getConstraints(deviceId) {
        if (deviceId === void 0) deviceId = null;
        const acceptsAudio = this.opts.modes.indexOf("video-audio") !== -1 || this.opts.modes.indexOf("audio-only") !== -1;
        const acceptsVideo = !this.isAudioOnly() && (this.opts.modes.indexOf("video-audio") !== -1 || this.opts.modes.indexOf("video-only") !== -1 || this.opts.modes.indexOf("picture") !== -1);
        const videoConstraints = {
            ...this.opts.videoConstraints || {},
            ...deviceId != null && {
                deviceId: deviceId
            }
        };
        return {
            audio: acceptsAudio,
            video: acceptsVideo ? videoConstraints : false
        };
    }
    // eslint-disable-next-line consistent-return
    start(options) {
        var _options;
        if (options === void 0) options = null;
        if (!this.supportsUserMedia) return Promise.reject(new Error("Webcam access not supported"));
        this.webcamActive = true;
        if (this.opts.mirror) $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(this, $a4ffb8658443fda4$var$_enableMirror)[$a4ffb8658443fda4$var$_enableMirror] = true;
        const constraints = this.getConstraints((_options = options) == null ? void 0 : _options.deviceId);
        // TODO: add a return and/or convert this to async/await
        this.hasCameraCheck().then((hasCamera)=>{
            this.setPluginState({
                hasCamera: hasCamera
            });
            // ask user for access to their camera
            return this.mediaDevices.getUserMedia(constraints).then((stream)=>{
                this.stream = stream;
                let currentDeviceId = null;
                const tracks = this.isAudioOnly() ? stream.getAudioTracks() : stream.getVideoTracks();
                if (!options || !options.deviceId) currentDeviceId = tracks[0].getSettings().deviceId;
                else tracks.forEach((track)=>{
                    if (track.getSettings().deviceId === options.deviceId) currentDeviceId = track.getSettings().deviceId;
                });
                // Update the sources now, so we can access the names.
                this.updateVideoSources();
                this.setPluginState({
                    currentDeviceId: currentDeviceId,
                    cameraReady: true
                });
            }).catch((err)=>{
                this.setPluginState({
                    cameraReady: false,
                    cameraError: err
                });
                this.uppy.info(err.message, "error");
            });
        });
    }
    getMediaRecorderOptions() {
        const options = {};
        // Try to use the `opts.preferredVideoMimeType` or one of the `allowedFileTypes` for the recording.
        // If the browser doesn't support it, we'll fall back to the browser default instead.
        // Safari doesn't have the `isTypeSupported` API.
        if (MediaRecorder.isTypeSupported) {
            const { restrictions: restrictions } = this.uppy.opts;
            let preferredVideoMimeTypes = [];
            if (this.opts.preferredVideoMimeType) preferredVideoMimeTypes = [
                this.opts.preferredVideoMimeType
            ];
            else if (restrictions.allowedFileTypes) preferredVideoMimeTypes = restrictions.allowedFileTypes.map($a4ffb8658443fda4$var$toMimeType).filter($a4ffb8658443fda4$var$isVideoMimeType);
            const filterSupportedTypes = (candidateType)=>MediaRecorder.isTypeSupported(candidateType) && (0, $02bf16315accd34b$export$2e2bcd8739ae039)(candidateType);
            const acceptableMimeTypes = preferredVideoMimeTypes.filter(filterSupportedTypes);
            if (acceptableMimeTypes.length > 0) // eslint-disable-next-line prefer-destructuring
            options.mimeType = acceptableMimeTypes[0];
        }
        return options;
    }
    startRecording() {
        // only used if supportsMediaRecorder() returned true
        // eslint-disable-next-line compat/compat
        this.recorder = new MediaRecorder(this.stream, this.getMediaRecorderOptions());
        this.recordingChunks = [];
        let stoppingBecauseOfMaxSize = false;
        this.recorder.addEventListener("dataavailable", (event)=>{
            this.recordingChunks.push(event.data);
            const { restrictions: restrictions } = this.uppy.opts;
            if (this.recordingChunks.length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
                const totalSize = this.recordingChunks.reduce((acc, chunk)=>acc + chunk.size, 0);
                // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier
                const averageChunkSize = (totalSize - this.recordingChunks[0].size) / (this.recordingChunks.length - 1);
                const expectedEndChunkSize = averageChunkSize * 3;
                const maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);
                if (totalSize > maxSize) {
                    stoppingBecauseOfMaxSize = true;
                    this.uppy.info(this.i18n("recordingStoppedMaxSize"), "warning", 4000);
                    this.stopRecording();
                }
            }
        });
        // use a "time slice" of 500ms: ondataavailable will be called each 500ms
        // smaller time slices mean we can more accurately check the max file size restriction
        this.recorder.start(500);
        if (this.opts.showRecordingLength) // Start the recordingLengthTimer if we are showing the recording length.
        this.recordingLengthTimer = setInterval(()=>{
            const currentRecordingLength = this.getPluginState().recordingLengthSeconds;
            this.setPluginState({
                recordingLengthSeconds: currentRecordingLength + 1
            });
        }, 1000);
        this.setPluginState({
            isRecording: true
        });
    }
    stopRecording() {
        const stopped = new Promise((resolve)=>{
            this.recorder.addEventListener("stop", ()=>{
                resolve();
            });
            this.recorder.stop();
            if (this.opts.showRecordingLength) {
                // Stop the recordingLengthTimer if we are showing the recording length.
                clearInterval(this.recordingLengthTimer);
                this.setPluginState({
                    recordingLengthSeconds: 0
                });
            }
        });
        return stopped.then(()=>{
            this.setPluginState({
                isRecording: false
            });
            return this.getVideo();
        }).then((file)=>{
            try {
                this.capturedMediaFile = file;
                // create object url for capture result preview
                this.setPluginState({
                    // eslint-disable-next-line compat/compat
                    recordedVideo: URL.createObjectURL(file.data)
                });
                $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(this, $a4ffb8658443fda4$var$_enableMirror)[$a4ffb8658443fda4$var$_enableMirror] = false;
            } catch (err) {
                // Logging the error, exept restrictions, which is handled in Core
                if (!err.isRestriction) this.uppy.log(err);
            }
        }).then(()=>{
            this.recordingChunks = null;
            this.recorder = null;
        }, (error)=>{
            this.recordingChunks = null;
            this.recorder = null;
            throw error;
        });
    }
    discardRecordedVideo() {
        this.setPluginState({
            recordedVideo: null
        });
        if (this.opts.mirror) $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(this, $a4ffb8658443fda4$var$_enableMirror)[$a4ffb8658443fda4$var$_enableMirror] = true;
        this.capturedMediaFile = null;
    }
    submit() {
        try {
            if (this.capturedMediaFile) this.uppy.addFile(this.capturedMediaFile);
        } catch (err) {
            // Logging the error, exept restrictions, which is handled in Core
            if (!err.isRestriction) this.uppy.log(err, "error");
        }
    }
    async stop() {
        if (this.stream) {
            const audioTracks = this.stream.getAudioTracks();
            const videoTracks = this.stream.getVideoTracks();
            audioTracks.concat(videoTracks).forEach((track)=>track.stop());
        }
        if (this.recorder) await new Promise((resolve)=>{
            this.recorder.addEventListener("stop", resolve, {
                once: true
            });
            this.recorder.stop();
            if (this.opts.showRecordingLength) clearInterval(this.recordingLengthTimer);
        });
        this.recordingChunks = null;
        this.recorder = null;
        this.webcamActive = false;
        this.stream = null;
        this.setPluginState({
            recordedVideo: null,
            isRecording: false,
            recordingLengthSeconds: 0
        });
    }
    getVideoElement() {
        return this.el.querySelector(".uppy-Webcam-video");
    }
    oneTwoThreeSmile() {
        return new Promise((resolve, reject)=>{
            let count = this.opts.countdown;
            // eslint-disable-next-line consistent-return
            const countDown = setInterval(()=>{
                if (!this.webcamActive) {
                    clearInterval(countDown);
                    this.captureInProgress = false;
                    return reject(new Error("Webcam is not active"));
                }
                if (count) {
                    this.uppy.info(`${count}...`, "warning", 800);
                    count--;
                } else {
                    clearInterval(countDown);
                    this.uppy.info(this.i18n("smile"), "success", 1500);
                    setTimeout(()=>resolve(), 1500);
                }
            }, 1000);
        });
    }
    takeSnapshot() {
        if (this.captureInProgress) return;
        this.captureInProgress = true;
        this.opts.onBeforeSnapshot().catch((err)=>{
            const message = typeof err === "object" ? err.message : err;
            this.uppy.info(message, "error", 5000);
            return Promise.reject(new Error(`onBeforeSnapshot: ${message}`));
        }).then(()=>{
            return this.getImage();
        }).then((tagFile)=>{
            this.captureInProgress = false;
            try {
                this.uppy.addFile(tagFile);
            } catch (err) {
                // Logging the error, except restrictions, which is handled in Core
                if (!err.isRestriction) this.uppy.log(err);
            }
        }, (error)=>{
            this.captureInProgress = false;
            throw error;
        });
    }
    getImage() {
        const video = this.getVideoElement();
        if (!video) return Promise.reject(new Error("No video element found, likely due to the Webcam tab being closed."));
        const width = video.videoWidth;
        const height = video.videoHeight;
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);
        const { restrictions: restrictions } = this.uppy.opts;
        let preferredImageMimeTypes = [];
        if (this.opts.preferredImageMimeType) preferredImageMimeTypes = [
            this.opts.preferredImageMimeType
        ];
        else if (restrictions.allowedFileTypes) preferredImageMimeTypes = restrictions.allowedFileTypes.map($a4ffb8658443fda4$var$toMimeType).filter($a4ffb8658443fda4$var$isImageMimeType);
        const mimeType = preferredImageMimeTypes[0] || "image/jpeg";
        const ext = (0, $02bf16315accd34b$export$2e2bcd8739ae039)(mimeType) || "jpg";
        const name = `cam-${Date.now()}.${ext}`;
        return (0, $6eb49ffe149480f4$export$2e2bcd8739ae039)(canvas, mimeType).then((blob)=>{
            return {
                source: this.id,
                name: name,
                data: new Blob([
                    blob
                ], {
                    type: mimeType
                }),
                type: mimeType
            };
        });
    }
    getVideo() {
        // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
        // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
        // attribute in order to determine the correct MIME type.
        const mimeType = this.recordingChunks.find((blob)=>{
            var _blob$type;
            return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
        }).type;
        const fileExtension = (0, $02bf16315accd34b$export$2e2bcd8739ae039)(mimeType);
        if (!fileExtension) return Promise.reject(new Error(`Could not retrieve recording: Unsupported media type "${mimeType}"`));
        const name = `webcam-${Date.now()}.${fileExtension}`;
        const blob = new Blob(this.recordingChunks, {
            type: mimeType
        });
        const file = {
            source: this.id,
            name: name,
            data: new Blob([
                blob
            ], {
                type: mimeType
            }),
            type: mimeType
        };
        return Promise.resolve(file);
    }
    focus() {
        if (!this.opts.countdown) return;
        setTimeout(()=>{
            this.uppy.info(this.i18n("smile"), "success", 1500);
        }, 1000);
    }
    changeVideoSource(deviceId) {
        this.stop();
        this.start({
            deviceId: deviceId
        });
    }
    updateVideoSources() {
        this.mediaDevices.enumerateDevices().then((devices)=>{
            this.setPluginState({
                videoSources: devices.filter((device)=>device.kind === "videoinput")
            });
        });
    }
    render() {
        if (!this.webcamActive) this.start();
        const webcamState = this.getPluginState();
        if (!webcamState.cameraReady || !webcamState.hasCamera) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $71fac5ac3dcc963a$export$2e2bcd8739ae039), {
            icon: (0, $99948036f31c1ff8$export$2e2bcd8739ae039),
            i18n: this.i18n,
            hasCamera: webcamState.hasCamera
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $83d272fc408761b9$export$2e2bcd8739ae039), $a4ffb8658443fda4$var$_extends({}, webcamState, {
            onChangeVideoSource: this.changeVideoSource,
            onSnapshot: this.takeSnapshot,
            onStartRecording: this.startRecording,
            onStopRecording: this.stopRecording,
            onDiscardRecordedVideo: this.discardRecordedVideo,
            onSubmit: this.submit,
            onFocus: this.focus,
            onStop: this.stop,
            i18n: this.i18n,
            modes: this.opts.modes,
            showRecordingLength: this.opts.showRecordingLength,
            showVideoSourceDropdown: this.opts.showVideoSourceDropdown,
            supportsRecording: (0, $9467c5a2e8688091$export$2e2bcd8739ae039)(),
            recording: webcamState.isRecording,
            mirror: $a4ffb8658443fda4$var$_classPrivateFieldLooseBase(this, $a4ffb8658443fda4$var$_enableMirror)[$a4ffb8658443fda4$var$_enableMirror],
            src: this.stream
        }));
    }
    install() {
        const { mobileNativeCamera: mobileNativeCamera, modes: modes, videoConstraints: videoConstraints } = this.opts;
        const { target: target } = this.opts;
        if (mobileNativeCamera && target) {
            var _this$getTargetPlugin;
            (_this$getTargetPlugin = this.getTargetPlugin(target)) == null || _this$getTargetPlugin.setOptions({
                showNativeVideoCameraButton: $a4ffb8658443fda4$var$isModeAvailable(modes, "video-only") || $a4ffb8658443fda4$var$isModeAvailable(modes, "video-audio"),
                showNativePhotoCameraButton: $a4ffb8658443fda4$var$isModeAvailable(modes, "picture"),
                nativeCameraFacingMode: videoConstraints == null ? void 0 : videoConstraints.facingMode
            });
            return;
        }
        this.setPluginState({
            cameraReady: false,
            recordingLengthSeconds: 0
        });
        if (target) this.mount(target, this);
        if (this.mediaDevices) {
            this.updateVideoSources();
            this.mediaDevices.ondevicechange = ()=>{
                this.updateVideoSources();
                if (this.stream) {
                    let restartStream = true;
                    const { videoSources: videoSources, currentDeviceId: currentDeviceId } = this.getPluginState();
                    videoSources.forEach((videoSource)=>{
                        if (currentDeviceId === videoSource.deviceId) restartStream = false;
                    });
                    if (restartStream) {
                        this.stop();
                        this.start();
                    }
                }
            };
        }
    }
    uninstall() {
        this.stop();
        this.unmount();
    }
    onUnmount() {
        this.stop();
    }
}
$a4ffb8658443fda4$export$2e2bcd8739ae039.VERSION = $a4ffb8658443fda4$var$packageJson.version;







// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $48e067fa1f2b2231$var$packageJson = {
    "version": "3.1.1"
};
// Default options
const $48e067fa1f2b2231$var$defaultOpts = {
    target: null
};
function $48e067fa1f2b2231$var$isFileTransfer(event) {
    var _event$dataTransfer$t, _event$dataTransfer;
    return (_event$dataTransfer$t = (_event$dataTransfer = event.dataTransfer) == null || (_event$dataTransfer = _event$dataTransfer.types) == null ? void 0 : _event$dataTransfer.some((type)=>type === "Files")) != null ? _event$dataTransfer$t : false;
}
class $48e067fa1f2b2231$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$48e067fa1f2b2231$var$defaultOpts,
            ...opts
        });
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        this.handleDrop = async (event)=>{
            var _event$currentTarget, _this$opts$onDrop, _this$opts;
            if (!$48e067fa1f2b2231$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            (_event$currentTarget = event.currentTarget) == null || _event$currentTarget.classList.remove("uppy-is-drag-over");
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") // @ts-expect-error Every Plugin with .type acquirer can define handleRootDrop(event)
                plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files, handle errors
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, "error");
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, "error");
                    executedDropErrorOnce = true;
                }
            };
            const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[DropTarget] Files were dropped");
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts, event);
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts2;
            if (!$48e067fa1f2b2231$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the browser,
            // https://github.com/transloadit/uppy/issues/1978)
            event.dataTransfer.dropEffect = "copy" // eslint-disable-line no-param-reassign
            ;
            event.currentTarget.classList.add("uppy-is-drag-over");
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts2, event);
        };
        this.handleDragLeave = (event)=>{
            var _event$currentTarget2, _this$opts$onDragLeav, _this$opts3;
            if (!$48e067fa1f2b2231$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            this.setPluginState({
                isDraggingOver: false
            });
            (_event$currentTarget2 = event.currentTarget) == null || _event$currentTarget2.classList.remove("uppy-is-drag-over");
            (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts3, event);
        };
        this.addListeners = ()=>{
            const { target: target } = this.opts;
            if (target instanceof Element) this.nodes = [
                target
            ];
            else if (typeof target === "string") this.nodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(document.querySelectorAll(target));
            if (!this.nodes || this.nodes.length === 0) throw new Error(`"${target}" does not match any HTML elements`);
            this.nodes.forEach((node)=>{
                node.addEventListener("dragover", this.handleDragOver, false);
                node.addEventListener("dragleave", this.handleDragLeave, false);
                node.addEventListener("drop", this.handleDrop, false);
            });
        };
        this.removeListeners = ()=>{
            if (this.nodes) this.nodes.forEach((node)=>{
                node.removeEventListener("dragover", this.handleDragOver, false);
                node.removeEventListener("dragleave", this.handleDragLeave, false);
                node.removeEventListener("drop", this.handleDrop, false);
            });
        };
        this.type = "acquirer";
        this.id = this.opts.id || "DropTarget";
    }
    install() {
        this.setPluginState({
            isDraggingOver: false
        });
        this.addListeners();
    }
    uninstall() {
        this.removeListeners();
    }
}
$48e067fa1f2b2231$export$2e2bcd8739ae039.VERSION = $48e067fa1f2b2231$var$packageJson.version;






/**
 * tua-body-scroll-lock v1.5.3
 * (c) 2024 Evinma, BuptStEve
 * @license MIT
 */ var $3fdfb4a389f15bd9$var$isServer = function isServer() {
    return typeof window === "undefined";
};
var $3fdfb4a389f15bd9$var$detectOS = function detectOS(ua) {
    ua = ua || navigator.userAgent;
    var ipad = /(iPad).*OS\s([\d_]+)/.test(ua);
    var iphone = !ipad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
    var android = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    var ios = iphone || ipad;
    return {
        ios: ios,
        android: android
    };
};
function $3fdfb4a389f15bd9$var$getEventListenerOptions(options) {
    /* istanbul ignore if */ if ($3fdfb4a389f15bd9$var$isServer()) return false;
    if (!options) throw new Error("options must be provided");
    var isSupportOptions = false;
    var listenerOptions = {
        get passive () {
            isSupportOptions = true;
            return undefined;
        }
    };
    /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    var noop = function noop() {};
    var testEvent = "__TUA_BSL_TEST_PASSIVE__";
    window.addEventListener(testEvent, noop, listenerOptions);
    window.removeEventListener(testEvent, noop, listenerOptions);
    var capture = options.capture;
    /* istanbul ignore next */ return isSupportOptions ? options : typeof capture !== "undefined" ? capture : false;
}
function $3fdfb4a389f15bd9$var$noticeRequiredTargetElement(targetElement) {
    if (targetElement) return false;
    if (targetElement === null) return false;
    return false;
}
/**
 * Get global function that calls preventDefault
 */ function $3fdfb4a389f15bd9$var$getPreventEventDefault() {
    if ("__BSL_PREVENT_DEFAULT__" in window) return window.__BSL_PREVENT_DEFAULT__;
    window.__BSL_PREVENT_DEFAULT__ = function(event) {
        if (!event.cancelable) return;
        event.preventDefault();
    };
    return window.__BSL_PREVENT_DEFAULT__;
}
function $3fdfb4a389f15bd9$var$toArray(x) {
    if (!x) return [];
    return Array.isArray(x) ? x : [
        x
    ];
}
var $3fdfb4a389f15bd9$var$initialLockState = {
    lockedNum: 0,
    lockedElements: [],
    unLockCallback: null,
    documentListenerAdded: false,
    initialClientPos: {
        clientX: 0,
        clientY: 0
    }
};
/**
 * get current lockState
 * @param options
 * @returns lockState
 */ function $3fdfb4a389f15bd9$export$59e505b1065981fb(options) {
    if ($3fdfb4a389f15bd9$var$isServer()) return $3fdfb4a389f15bd9$var$initialLockState;
    /** use local lockState */ if (!(options === null || options === void 0 ? void 0 : options.useGlobalLockState)) return $3fdfb4a389f15bd9$export$59e505b1065981fb.lockState;
    /** use global lockState */ var lockState = "__BSL_LOCK_STATE__" in window ? Object.assign(Object.assign({}, $3fdfb4a389f15bd9$var$initialLockState), window.__BSL_LOCK_STATE__) : $3fdfb4a389f15bd9$var$initialLockState;
    /** assign to global */ window.__BSL_LOCK_STATE__ = lockState;
    return lockState;
}
$3fdfb4a389f15bd9$export$59e505b1065981fb.lockState = $3fdfb4a389f15bd9$var$initialLockState;
function $3fdfb4a389f15bd9$var$handleScroll(event, targetElement, initialClientPos) {
    if (targetElement) {
        var scrollTop = targetElement.scrollTop, scrollLeft = targetElement.scrollLeft, scrollWidth = targetElement.scrollWidth, scrollHeight = targetElement.scrollHeight, clientWidth = targetElement.clientWidth, clientHeight = targetElement.clientHeight;
        var clientX = event.targetTouches[0].clientX - initialClientPos.clientX;
        var clientY = event.targetTouches[0].clientY - initialClientPos.clientY;
        var isVertical = Math.abs(clientY) > Math.abs(clientX);
        var isOnTop = clientY > 0 && scrollTop === 0;
        var isOnLeft = clientX > 0 && scrollLeft === 0;
        var isOnRight = clientX < 0 && scrollLeft + clientWidth + 1 >= scrollWidth;
        var isOnBottom = clientY < 0 && scrollTop + clientHeight + 1 >= scrollHeight;
        if (isVertical && (isOnTop || isOnBottom) || !isVertical && (isOnLeft || isOnRight)) return $3fdfb4a389f15bd9$var$getPreventEventDefault()(event);
    }
    event.stopPropagation();
    return true;
}
function $3fdfb4a389f15bd9$var$setOverflowHiddenPc() {
    var $html = document.documentElement;
    var htmlStyle = Object.assign({}, $html.style);
    var scrollBarWidth = window.innerWidth - $html.clientWidth;
    var previousPaddingRight = parseInt(window.getComputedStyle($html).paddingRight, 10);
    $html.style.overflow = "hidden";
    $html.style.boxSizing = "border-box";
    $html.style.paddingRight = "".concat(scrollBarWidth + previousPaddingRight, "px");
    return function() {
        [
            "overflow",
            "boxSizing",
            "paddingRight"
        ].forEach(function(x) {
            $html.style[x] = htmlStyle[x] || "";
        });
    };
}
function $3fdfb4a389f15bd9$var$setOverflowHiddenMobile(options) {
    var $html = document.documentElement;
    var $body = document.body;
    var scrollTop = $html.scrollTop || $body.scrollTop;
    var htmlStyle = Object.assign({}, $html.style);
    var bodyStyle = Object.assign({}, $body.style);
    $html.style.height = "100%";
    $html.style.overflow = "hidden";
    $body.style.top = "-".concat(scrollTop, "px");
    $body.style.width = "100%";
    $body.style.height = "auto";
    $body.style.position = "fixed";
    $body.style.overflow = (options === null || options === void 0 ? void 0 : options.overflowType) || "hidden";
    return function() {
        $html.style.height = htmlStyle.height || "";
        $html.style.overflow = htmlStyle.overflow || "";
        [
            "top",
            "width",
            "height",
            "overflow",
            "position"
        ].forEach(function(x) {
            $body.style[x] = bodyStyle[x] || "";
        });
        var supportsNativeSmoothScroll = "scrollBehavior" in document.documentElement.style;
        if (supportsNativeSmoothScroll) window.scrollTo({
            top: scrollTop,
            behavior: "instant"
        });
        else window.scrollTo(0, scrollTop);
    };
}
/**
 * lock body scroll
 * @param targetElement the element(s) still needs scrolling（iOS only）
 * @param options
 */ function $3fdfb4a389f15bd9$export$6a9f04c98a658ecb(targetElement, options) {
    if ($3fdfb4a389f15bd9$var$isServer()) return;
    $3fdfb4a389f15bd9$var$noticeRequiredTargetElement(targetElement);
    var detectRes = $3fdfb4a389f15bd9$var$detectOS();
    var lockState = $3fdfb4a389f15bd9$export$59e505b1065981fb(options);
    if (detectRes.ios) {
        $3fdfb4a389f15bd9$var$toArray(targetElement).filter(function(e) {
            return e && lockState.lockedElements.indexOf(e) === -1;
        }).forEach(function(element) {
            element.ontouchstart = function(event) {
                var _event$targetTouches$ = event.targetTouches[0], clientX = _event$targetTouches$.clientX, clientY = _event$targetTouches$.clientY;
                lockState.initialClientPos = {
                    clientX: clientX,
                    clientY: clientY
                };
            };
            element.ontouchmove = function(event) {
                $3fdfb4a389f15bd9$var$handleScroll(event, element, lockState.initialClientPos);
            };
            lockState.lockedElements.push(element);
        });
        $3fdfb4a389f15bd9$var$addTouchMoveListener(lockState);
    } else if (lockState.lockedNum <= 0) lockState.unLockCallback = detectRes.android ? $3fdfb4a389f15bd9$var$setOverflowHiddenMobile(options) : $3fdfb4a389f15bd9$var$setOverflowHiddenPc();
    lockState.lockedNum += 1;
}
/**
 * unlock body scroll
 * @param targetElement the element(s) still needs scrolling（iOS only）
 * @param options
 */ function $3fdfb4a389f15bd9$export$eccddd504975e05d(targetElement, options) {
    if ($3fdfb4a389f15bd9$var$isServer()) return;
    $3fdfb4a389f15bd9$var$noticeRequiredTargetElement(targetElement);
    var lockState = $3fdfb4a389f15bd9$export$59e505b1065981fb(options);
    lockState.lockedNum -= 1;
    if (lockState.lockedNum > 0) return;
    if ($3fdfb4a389f15bd9$var$unlockByCallback(lockState)) return;
    $3fdfb4a389f15bd9$var$toArray(targetElement).forEach(function(element) {
        var index = lockState.lockedElements.indexOf(element);
        if (element && index !== -1) {
            element.ontouchmove = null;
            element.ontouchstart = null;
            lockState.lockedElements.splice(index, 1);
        }
    });
    $3fdfb4a389f15bd9$var$removeTouchMoveListener(lockState);
}
/**
 * clear all body locks
 * @param options
 */ function $3fdfb4a389f15bd9$export$22f1f1f07a1ac788(options) {
    if ($3fdfb4a389f15bd9$var$isServer()) return;
    var lockState = $3fdfb4a389f15bd9$export$59e505b1065981fb(options);
    lockState.lockedNum = 0;
    if ($3fdfb4a389f15bd9$var$unlockByCallback(lockState)) return;
    if (lockState.lockedElements.length) {
        var element = lockState.lockedElements.pop();
        while(element){
            element.ontouchmove = null;
            element.ontouchstart = null;
            element = lockState.lockedElements.pop();
        }
    }
    $3fdfb4a389f15bd9$var$removeTouchMoveListener(lockState);
}
function $3fdfb4a389f15bd9$var$unlockByCallback(lockState) {
    if ($3fdfb4a389f15bd9$var$detectOS().ios) return false;
    if (typeof lockState.unLockCallback !== "function") return false;
    lockState.unLockCallback();
    return true;
}
function $3fdfb4a389f15bd9$var$addTouchMoveListener(lockState) {
    if (!$3fdfb4a389f15bd9$var$detectOS().ios) return;
    if (lockState.documentListenerAdded) return;
    document.addEventListener("touchmove", $3fdfb4a389f15bd9$var$getPreventEventDefault(), $3fdfb4a389f15bd9$var$getEventListenerOptions({
        passive: false
    }));
    lockState.documentListenerAdded = true;
}
function $3fdfb4a389f15bd9$var$removeTouchMoveListener(lockState) {
    if (!lockState.documentListenerAdded) return;
    document.removeEventListener("touchmove", $3fdfb4a389f15bd9$var$getPreventEventDefault(), $3fdfb4a389f15bd9$var$getEventListenerOptions({
        passive: false
    }));
    lockState.documentListenerAdded = false;
}


"use strict";
function $fc8f2e2c969d032f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $6qd2L = parcelRequire("6qd2L");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $8ca3655f37d9652c$var$toString } = Object.prototype;
const { getPrototypeOf: $8ca3655f37d9652c$var$getPrototypeOf } = Object;
const { iterator: $8ca3655f37d9652c$var$iterator, toStringTag: $8ca3655f37d9652c$var$toStringTag } = Symbol;
const $8ca3655f37d9652c$var$kindOf = ((cache)=>(thing)=>{
        const str = $8ca3655f37d9652c$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $8ca3655f37d9652c$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$8ca3655f37d9652c$var$kindOf(thing) === type;
};
const $8ca3655f37d9652c$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $8ca3655f37d9652c$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $8ca3655f37d9652c$var$isUndefined = $8ca3655f37d9652c$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ca3655f37d9652c$var$isBuffer(val) {
    return val !== null && !$8ca3655f37d9652c$var$isUndefined(val) && val.constructor !== null && !$8ca3655f37d9652c$var$isUndefined(val.constructor) && $8ca3655f37d9652c$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $8ca3655f37d9652c$var$isArrayBuffer = $8ca3655f37d9652c$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ca3655f37d9652c$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8ca3655f37d9652c$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $8ca3655f37d9652c$var$isString = $8ca3655f37d9652c$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $8ca3655f37d9652c$var$isFunction = $8ca3655f37d9652c$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $8ca3655f37d9652c$var$isNumber = $8ca3655f37d9652c$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $8ca3655f37d9652c$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $8ca3655f37d9652c$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $8ca3655f37d9652c$var$isPlainObject = (val)=>{
    if ($8ca3655f37d9652c$var$kindOf(val) !== "object") return false;
    const prototype = $8ca3655f37d9652c$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($8ca3655f37d9652c$var$toStringTag in val) && !($8ca3655f37d9652c$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $8ca3655f37d9652c$var$isDate = $8ca3655f37d9652c$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFile = $8ca3655f37d9652c$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $8ca3655f37d9652c$var$isBlob = $8ca3655f37d9652c$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFileList = $8ca3655f37d9652c$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $8ca3655f37d9652c$var$isStream = (val)=>$8ca3655f37d9652c$var$isObject(val) && $8ca3655f37d9652c$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $8ca3655f37d9652c$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $8ca3655f37d9652c$var$isFunction(thing.append) && ((kind = $8ca3655f37d9652c$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $8ca3655f37d9652c$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $8ca3655f37d9652c$var$isURLSearchParams = $8ca3655f37d9652c$var$kindOfTest("URLSearchParams");
const [$8ca3655f37d9652c$var$isReadableStream, $8ca3655f37d9652c$var$isRequest, $8ca3655f37d9652c$var$isResponse, $8ca3655f37d9652c$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($8ca3655f37d9652c$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $8ca3655f37d9652c$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8ca3655f37d9652c$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ca3655f37d9652c$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8ca3655f37d9652c$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $8ca3655f37d9652c$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $8ca3655f37d9652c$var$isContextDefined = (context)=>!$8ca3655f37d9652c$var$isUndefined(context) && context !== $8ca3655f37d9652c$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8ca3655f37d9652c$var$merge() {
    const { caseless: caseless } = $8ca3655f37d9652c$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $8ca3655f37d9652c$var$findKey(result, key) || key;
        if ($8ca3655f37d9652c$var$isPlainObject(result[targetKey]) && $8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge(result[targetKey], val);
        else if ($8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge({}, val);
        else if ($8ca3655f37d9652c$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $8ca3655f37d9652c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $8ca3655f37d9652c$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $8ca3655f37d9652c$var$forEach(b, (val, key)=>{
        if (thisArg && $8ca3655f37d9652c$var$isFunction(val)) a[key] = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $8ca3655f37d9652c$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $8ca3655f37d9652c$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8ca3655f37d9652c$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $8ca3655f37d9652c$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $8ca3655f37d9652c$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($8ca3655f37d9652c$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$8ca3655f37d9652c$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $8ca3655f37d9652c$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $8ca3655f37d9652c$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$8ca3655f37d9652c$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $8ca3655f37d9652c$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $8ca3655f37d9652c$var$isHTMLForm = $8ca3655f37d9652c$var$kindOfTest("HTMLFormElement");
const $8ca3655f37d9652c$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $8ca3655f37d9652c$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $8ca3655f37d9652c$var$isRegExp = $8ca3655f37d9652c$var$kindOfTest("RegExp");
const $8ca3655f37d9652c$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $8ca3655f37d9652c$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $8ca3655f37d9652c$var$freezeMethods = (obj)=>{
    $8ca3655f37d9652c$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($8ca3655f37d9652c$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$8ca3655f37d9652c$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $8ca3655f37d9652c$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $8ca3655f37d9652c$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $8ca3655f37d9652c$var$noop = ()=>{};
const $8ca3655f37d9652c$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8ca3655f37d9652c$var$isSpecCompliantForm(thing) {
    return !!(thing && $8ca3655f37d9652c$var$isFunction(thing.append) && thing[$8ca3655f37d9652c$var$toStringTag] === "FormData" && thing[$8ca3655f37d9652c$var$iterator]);
}
const $8ca3655f37d9652c$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($8ca3655f37d9652c$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $8ca3655f37d9652c$var$isArray(source) ? [] : {};
                $8ca3655f37d9652c$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$8ca3655f37d9652c$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $8ca3655f37d9652c$var$isAsyncFn = $8ca3655f37d9652c$var$kindOfTest("AsyncFunction");
const $8ca3655f37d9652c$var$isThenable = (thing)=>thing && ($8ca3655f37d9652c$var$isObject(thing) || $8ca3655f37d9652c$var$isFunction(thing)) && $8ca3655f37d9652c$var$isFunction(thing.then) && $8ca3655f37d9652c$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $8ca3655f37d9652c$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $8ca3655f37d9652c$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $8ca3655f37d9652c$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $8ca3655f37d9652c$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $8ca3655f37d9652c$var$isFunction($8ca3655f37d9652c$var$_global.postMessage));
const $8ca3655f37d9652c$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($8ca3655f37d9652c$var$_global) : typeof $6qd2L !== "undefined" && $6qd2L.nextTick || $8ca3655f37d9652c$var$_setImmediate;
// *********************
const $8ca3655f37d9652c$var$isIterable = (thing)=>thing != null && $8ca3655f37d9652c$var$isFunction(thing[$8ca3655f37d9652c$var$iterator]);
var $8ca3655f37d9652c$export$2e2bcd8739ae039 = {
    isArray: $8ca3655f37d9652c$var$isArray,
    isArrayBuffer: $8ca3655f37d9652c$var$isArrayBuffer,
    isBuffer: $8ca3655f37d9652c$var$isBuffer,
    isFormData: $8ca3655f37d9652c$var$isFormData,
    isArrayBufferView: $8ca3655f37d9652c$var$isArrayBufferView,
    isString: $8ca3655f37d9652c$var$isString,
    isNumber: $8ca3655f37d9652c$var$isNumber,
    isBoolean: $8ca3655f37d9652c$var$isBoolean,
    isObject: $8ca3655f37d9652c$var$isObject,
    isPlainObject: $8ca3655f37d9652c$var$isPlainObject,
    isReadableStream: $8ca3655f37d9652c$var$isReadableStream,
    isRequest: $8ca3655f37d9652c$var$isRequest,
    isResponse: $8ca3655f37d9652c$var$isResponse,
    isHeaders: $8ca3655f37d9652c$var$isHeaders,
    isUndefined: $8ca3655f37d9652c$var$isUndefined,
    isDate: $8ca3655f37d9652c$var$isDate,
    isFile: $8ca3655f37d9652c$var$isFile,
    isBlob: $8ca3655f37d9652c$var$isBlob,
    isRegExp: $8ca3655f37d9652c$var$isRegExp,
    isFunction: $8ca3655f37d9652c$var$isFunction,
    isStream: $8ca3655f37d9652c$var$isStream,
    isURLSearchParams: $8ca3655f37d9652c$var$isURLSearchParams,
    isTypedArray: $8ca3655f37d9652c$var$isTypedArray,
    isFileList: $8ca3655f37d9652c$var$isFileList,
    forEach: $8ca3655f37d9652c$var$forEach,
    merge: $8ca3655f37d9652c$var$merge,
    extend: $8ca3655f37d9652c$var$extend,
    trim: $8ca3655f37d9652c$var$trim,
    stripBOM: $8ca3655f37d9652c$var$stripBOM,
    inherits: $8ca3655f37d9652c$var$inherits,
    toFlatObject: $8ca3655f37d9652c$var$toFlatObject,
    kindOf: $8ca3655f37d9652c$var$kindOf,
    kindOfTest: $8ca3655f37d9652c$var$kindOfTest,
    endsWith: $8ca3655f37d9652c$var$endsWith,
    toArray: $8ca3655f37d9652c$var$toArray,
    forEachEntry: $8ca3655f37d9652c$var$forEachEntry,
    matchAll: $8ca3655f37d9652c$var$matchAll,
    isHTMLForm: $8ca3655f37d9652c$var$isHTMLForm,
    hasOwnProperty: $8ca3655f37d9652c$var$hasOwnProperty,
    hasOwnProp: $8ca3655f37d9652c$var$hasOwnProperty,
    reduceDescriptors: $8ca3655f37d9652c$var$reduceDescriptors,
    freezeMethods: $8ca3655f37d9652c$var$freezeMethods,
    toObjectSet: $8ca3655f37d9652c$var$toObjectSet,
    toCamelCase: $8ca3655f37d9652c$var$toCamelCase,
    noop: $8ca3655f37d9652c$var$noop,
    toFiniteNumber: $8ca3655f37d9652c$var$toFiniteNumber,
    findKey: $8ca3655f37d9652c$var$findKey,
    global: $8ca3655f37d9652c$var$_global,
    isContextDefined: $8ca3655f37d9652c$var$isContextDefined,
    isSpecCompliantForm: $8ca3655f37d9652c$var$isSpecCompliantForm,
    toJSONObject: $8ca3655f37d9652c$var$toJSONObject,
    isAsyncFn: $8ca3655f37d9652c$var$isAsyncFn,
    isThenable: $8ca3655f37d9652c$var$isThenable,
    setImmediate: $8ca3655f37d9652c$var$_setImmediate,
    asap: $8ca3655f37d9652c$var$asap,
    isIterable: $8ca3655f37d9652c$var$isIterable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $44aee3fe793a4c74$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($44aee3fe793a4c74$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $44aee3fe793a4c74$var$prototype = $44aee3fe793a4c74$var$AxiosError.prototype;
const $44aee3fe793a4c74$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $44aee3fe793a4c74$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($44aee3fe793a4c74$var$AxiosError, $44aee3fe793a4c74$var$descriptors);
Object.defineProperty($44aee3fe793a4c74$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$44aee3fe793a4c74$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($44aee3fe793a4c74$var$prototype);
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $44aee3fe793a4c74$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $44aee3fe793a4c74$export$2e2bcd8739ae039 = $44aee3fe793a4c74$var$AxiosError;


// eslint-disable-next-line strict
var $82d0d0537dc0bac3$export$2e2bcd8739ae039 = null;



var $3aNd6 = parcelRequire("3aNd6");
var $0c29ca57d54f85e9$require$Buffer = $3aNd6.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isVisitable(thing) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0c29ca57d54f85e9$var$removeBrackets(key) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0c29ca57d54f85e9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0c29ca57d54f85e9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isFlatArray(arr) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0c29ca57d54f85e9$var$isVisitable);
}
const $0c29ca57d54f85e9$var$predicates = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject((0, $8ca3655f37d9652c$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0c29ca57d54f85e9$var$toFormData(obj, formData, options) {
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $82d0d0537dc0bac3$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $0c29ca57d54f85e9$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) && $0c29ca57d54f85e9$var$isFlatArray(value) || ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0c29ca57d54f85e9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0c29ca57d54f85e9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($0c29ca57d54f85e9$var$isVisitable(value)) return true;
        formData.append($0c29ca57d54f85e9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0c29ca57d54f85e9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0c29ca57d54f85e9$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $0c29ca57d54f85e9$export$2e2bcd8739ae039 = $0c29ca57d54f85e9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $63e4e0dff2b7ef1a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $63e4e0dff2b7ef1a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(params, this, options);
}
const $63e4e0dff2b7ef1a$var$prototype = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams.prototype;
$63e4e0dff2b7ef1a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$63e4e0dff2b7ef1a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $63e4e0dff2b7ef1a$var$encode);
    } : $63e4e0dff2b7ef1a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $63e4e0dff2b7ef1a$export$2e2bcd8739ae039 = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4858799f155a4706$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4858799f155a4706$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4858799f155a4706$var$encode;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $089e14d5c08cea15$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $089e14d5c08cea15$export$2e2bcd8739ae039 = $089e14d5c08cea15$var$InterceptorManager;





"use strict";
var $c54b4d6d29e2eb6b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $d2ba66411c13cc9b$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039);


"use strict";
var $7cdf1698dc68a071$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e86ffb493d13ed1$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $97999e9cdfd9bdaf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d2ba66411c13cc9b$export$2e2bcd8739ae039,
        FormData: $7cdf1698dc68a071$export$2e2bcd8739ae039,
        Blob: $2e86ffb493d13ed1$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $dcb238ff33d5089b$exports = {};

$parcel$export($dcb238ff33d5089b$exports, "hasBrowserEnv", function () { return $dcb238ff33d5089b$export$c4996c4b7b93b0bf; });
$parcel$export($dcb238ff33d5089b$exports, "navigator", function () { return $dcb238ff33d5089b$export$ec7c8efa7f5790ae; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserEnv", function () { return $dcb238ff33d5089b$export$c0bcc9250309d66; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserWebWorkerEnv", function () { return $dcb238ff33d5089b$export$c81692cf5af97dac; });
$parcel$export($dcb238ff33d5089b$exports, "origin", function () { return $dcb238ff33d5089b$export$f710a83a91838a36; });
const $dcb238ff33d5089b$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $dcb238ff33d5089b$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $dcb238ff33d5089b$export$c0bcc9250309d66 = $dcb238ff33d5089b$export$c4996c4b7b93b0bf && (!$dcb238ff33d5089b$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($dcb238ff33d5089b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $dcb238ff33d5089b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $dcb238ff33d5089b$export$f710a83a91838a36 = $dcb238ff33d5089b$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $96659b0ab5a2bc56$export$2e2bcd8739ae039 = {
    ...$dcb238ff33d5089b$exports,
    ...(0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039)
};


"use strict";
function $3444de215011fd2b$export$2e2bcd8739ae039(data, options) {
    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(data, new (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).isNode && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $bdd273a6ec9f935e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $bdd273a6ec9f935e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $bdd273a6ec9f935e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $bdd273a6ec9f935e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(formData) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($bdd273a6ec9f935e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $bdd273a6ec9f935e$export$2e2bcd8739ae039 = $bdd273a6ec9f935e$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $8d19883a18ea96be$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $8d19883a18ea96be$var$defaults = {
    transitional: (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isStream(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFile(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $3444de215011fd2b$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $8d19883a18ea96be$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $8d19883a18ea96be$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isResponse(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(e, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $8d19883a18ea96be$var$defaults.headers[method] = {};
});
var $8d19883a18ea96be$export$2e2bcd8739ae039 = $8d19883a18ea96be$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $102410410d0dc09d$var$ignoreDuplicateOf = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $102410410d0dc09d$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $102410410d0dc09d$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c2923f037e2bae4f$var$$internals = Symbol("internals");
function $c2923f037e2bae4f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c2923f037e2bae4f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.map($c2923f037e2bae4f$var$normalizeValue) : String(value);
}
function $c2923f037e2bae4f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c2923f037e2bae4f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c2923f037e2bae4f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c2923f037e2bae4f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c2923f037e2bae4f$var$buildAccessors(obj, header) {
    const accessorName = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c2923f037e2bae4f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c2923f037e2bae4f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c2923f037e2bae4f$var$isValidHeaderName(header)) setHeaders((0, $102410410d0dc09d$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(header) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(entry)) throw TypeError("Object iterator must return a key-value pair");
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c2923f037e2bae4f$var$parseTokens(value);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c2923f037e2bae4f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c2923f037e2bae4f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c2923f037e2bae4f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c2923f037e2bae4f$var$$internals] = this[$c2923f037e2bae4f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c2923f037e2bae4f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c2923f037e2bae4f$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).reduceDescriptors($c2923f037e2bae4f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).freezeMethods($c2923f037e2bae4f$var$AxiosHeaders);
var $c2923f037e2bae4f$export$2e2bcd8739ae039 = $c2923f037e2bae4f$var$AxiosHeaders;


"use strict";
function $e27ce2658796d30f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $8d19883a18ea96be$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $ffcdf0443516cf49$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a251e9fa67c89486$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($a251e9fa67c89486$var$CanceledError, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a251e9fa67c89486$export$2e2bcd8739ae039 = $a251e9fa67c89486$var$CanceledError;







"use strict";
function $df046ee58fb378eb$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $39416e5131ec2dd8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1af1a7f806b22ba$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1af1a7f806b22ba$export$2e2bcd8739ae039 = $a1af1a7f806b22ba$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8ecc9a2101455cbb$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $8ecc9a2101455cbb$export$2e2bcd8739ae039 = $8ecc9a2101455cbb$var$throttle;



const $4d12b2770b9a110e$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $a1af1a7f806b22ba$export$2e2bcd8739ae039)(50, 250);
    return (0, $8ecc9a2101455cbb$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $4d12b2770b9a110e$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $4d12b2770b9a110e$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $6c85e22328488296$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin), (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $e52288d5ced91a0f$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $57cabc98a428ac0d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b453718e09262365$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $c5c7eeec01fb8b89$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $57cabc98a428ac0d$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b453718e09262365$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $ed738da9502ca495$var$headersToObject = (thing)=>thing instanceof (0, $c2923f037e2bae4f$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $ed738da9502ca495$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($ed738da9502ca495$var$headersToObject(a), $ed738da9502ca495$var$headersToObject(b), prop, true)
    };
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f17e6a7b4883a134$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4858799f155a4706$export$2e2bcd8739ae039)((0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $6c85e22328488296$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $e52288d5ced91a0f$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $85bd0ac91b9e9771$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $85bd0ac91b9e9771$export$2e2bcd8739ae039 = $85bd0ac91b9e9771$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f17e6a7b4883a134$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request aborted", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Network Error", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT : (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $4d12b2770b9a110e$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $4d12b2770b9a110e$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $39416e5131ec2dd8$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $622ea438e7cb5cf5$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $44aee3fe793a4c74$export$2e2bcd8739ae039) ? err : new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $622ea438e7cb5cf5$export$2e2bcd8739ae039 = $622ea438e7cb5cf5$var$composeSignals;


const $f43abe8046874bdd$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $f43abe8046874bdd$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $f43abe8046874bdd$var$readStream(iterable))yield* $f43abe8046874bdd$export$71b051935044bd5d(chunk, chunkSize);
};
const $f43abe8046874bdd$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $f43abe8046874bdd$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $f43abe8046874bdd$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $3477ac01bee1324a$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $3477ac01bee1324a$var$isReadableStreamSupported = $3477ac01bee1324a$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $3477ac01bee1324a$var$encodeText = $3477ac01bee1324a$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $3477ac01bee1324a$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $3477ac01bee1324a$var$supportsRequestStream = $3477ac01bee1324a$var$isReadableStreamSupported && $3477ac01bee1324a$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE = 65536;
const $3477ac01bee1324a$var$supportsResponseStream = $3477ac01bee1324a$var$isReadableStreamSupported && $3477ac01bee1324a$var$test(()=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $3477ac01bee1324a$var$resolvers = {
    stream: $3477ac01bee1324a$var$supportsResponseStream && ((res)=>res.body)
};
$3477ac01bee1324a$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$3477ac01bee1324a$var$resolvers[type] && ($3477ac01bee1324a$var$resolvers[type] = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $3477ac01bee1324a$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(body)) return (await $3477ac01bee1324a$var$encodeText(body)).byteLength;
};
const $3477ac01bee1324a$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $3477ac01bee1324a$var$getBodyLength(body) : length;
};
var $3477ac01bee1324a$export$2e2bcd8739ae039 = $3477ac01bee1324a$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $f17e6a7b4883a134$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $622ea438e7cb5cf5$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $3477ac01bee1324a$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $3477ac01bee1324a$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $4d12b2770b9a110e$export$d9fadd12586c18d6)(requestContentLength, (0, $4d12b2770b9a110e$export$c1b28109d46c3592)((0, $4d12b2770b9a110e$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $f43abe8046874bdd$export$b0119225647bd83)(_request.body, $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $3477ac01bee1324a$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($3477ac01bee1324a$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $4d12b2770b9a110e$export$d9fadd12586c18d6)(responseContentLength, (0, $4d12b2770b9a110e$export$c1b28109d46c3592)((0, $4d12b2770b9a110e$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $f43abe8046874bdd$export$b0119225647bd83)(response.body, $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $3477ac01bee1324a$var$resolvers[(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey($3477ac01bee1324a$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Network Error", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $b57d5c296e05dd0f$var$knownAdapters = {
    http: (0, $82d0d0537dc0bac3$export$2e2bcd8739ae039),
    xhr: (0, $85bd0ac91b9e9771$export$2e2bcd8739ae039),
    fetch: (0, $3477ac01bee1324a$export$2e2bcd8739ae039)
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach($b57d5c296e05dd0f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $b57d5c296e05dd0f$var$renderReason = (reason)=>`- ${reason}`;
const $b57d5c296e05dd0f$var$isResolvedHandle = (adapter)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $b57d5c296e05dd0f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$b57d5c296e05dd0f$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $b57d5c296e05dd0f$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($b57d5c296e05dd0f$var$renderReason).join("\n") : " " + $b57d5c296e05dd0f$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $b57d5c296e05dd0f$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $03c1ec60679d4a92$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config);
}
function $03c1ec60679d4a92$export$2e2bcd8739ae039(config) {
    $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
    config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $8d19883a18ea96be$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ffcdf0443516cf49$export$2e2bcd8739ae039)(reason)) {
            $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $f1f155cc89389bcb$export$a4ad2735b021c132 = "1.9.0";



"use strict";
const $73047b42f9e782d3$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $73047b42f9e782d3$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $73047b42f9e782d3$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $73047b42f9e782d3$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $f1f155cc89389bcb$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$73047b42f9e782d3$var$deprecatedWarnings[opt]) {
            $73047b42f9e782d3$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$73047b42f9e782d3$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $73047b42f9e782d3$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("options must be an object", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $73047b42f9e782d3$export$2e2bcd8739ae039 = {
    assertOptions: $73047b42f9e782d3$var$assertOptions,
    validators: $73047b42f9e782d3$var$validators
};



"use strict";
const $6c6ea2375c06af66$var$validators = (0, $73047b42f9e782d3$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $6c6ea2375c06af66$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)(),
            response: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            forcedJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            clarifyTimeoutError: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $6c6ea2375c06af66$var$validators.function,
                serialize: $6c6ea2375c06af66$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $6c6ea2375c06af66$var$validators.spelling("baseURL"),
            withXsrfToken: $6c6ea2375c06af66$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6c6ea2375c06af66$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6c6ea2375c06af66$var$Axios.prototype[method] = generateHTTPMethod();
    $6c6ea2375c06af66$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $6c6ea2375c06af66$export$2e2bcd8739ae039 = $6c6ea2375c06af66$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $52ff30ac6ac58fe8$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $52ff30ac6ac58fe8$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $52ff30ac6ac58fe8$export$2e2bcd8739ae039 = $52ff30ac6ac58fe8$var$CancelToken;






"use strict";
function $6fd2256c627864a1$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $eecd01492f51a517$export$2e2bcd8739ae039(payload) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $3f8e319a46440ea5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($3f8e319a46440ea5$var$HttpStatusCode).forEach(([key, value])=>{
    $3f8e319a46440ea5$var$HttpStatusCode[value] = key;
});
var $3f8e319a46440ea5$export$2e2bcd8739ae039 = $3f8e319a46440ea5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $eb999ef253053d6e$var$createInstance(defaultConfig) {
    const context = new (0, $6c6ea2375c06af66$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)((0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, (0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $eb999ef253053d6e$var$createInstance((0, $ed738da9502ca495$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $eb999ef253053d6e$var$axios = $eb999ef253053d6e$var$createInstance((0, $8d19883a18ea96be$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$eb999ef253053d6e$var$axios.Axios = (0, $6c6ea2375c06af66$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$eb999ef253053d6e$var$axios.CanceledError = (0, $a251e9fa67c89486$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.CancelToken = (0, $52ff30ac6ac58fe8$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.isCancel = (0, $ffcdf0443516cf49$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.VERSION = (0, $f1f155cc89389bcb$export$a4ad2735b021c132);
$eb999ef253053d6e$var$axios.toFormData = (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039);
// Expose AxiosError class
$eb999ef253053d6e$var$axios.AxiosError = (0, $44aee3fe793a4c74$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$eb999ef253053d6e$var$axios.Cancel = $eb999ef253053d6e$var$axios.CanceledError;
// Expose all/spread
$eb999ef253053d6e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$eb999ef253053d6e$var$axios.spread = (0, $6fd2256c627864a1$export$2e2bcd8739ae039);
// Expose isAxiosError
$eb999ef253053d6e$var$axios.isAxiosError = (0, $eecd01492f51a517$export$2e2bcd8739ae039);
// Expose mergeConfig
$eb999ef253053d6e$var$axios.mergeConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.AxiosHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.formToJSON = (thing)=>(0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$eb999ef253053d6e$var$axios.getAdapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter;
$eb999ef253053d6e$var$axios.HttpStatusCode = (0, $3f8e319a46440ea5$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.default = $eb999ef253053d6e$var$axios;
var // this module should only have a default export
$eb999ef253053d6e$export$2e2bcd8739ae039 = $eb999ef253053d6e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $9fc967f4cbe5a6f7$export$1c00760e9e5a4e95, AxiosError: $9fc967f4cbe5a6f7$export$c1fbed17c2f6a328, CanceledError: $9fc967f4cbe5a6f7$export$1ab0c6b20d94fa14, isCancel: $9fc967f4cbe5a6f7$export$3b22524397b493c6, CancelToken: $9fc967f4cbe5a6f7$export$fd08e3cb425f0d61, VERSION: $9fc967f4cbe5a6f7$export$a4ad2735b021c132, all: $9fc967f4cbe5a6f7$export$84bf76cd7afc7469, Cancel: $9fc967f4cbe5a6f7$export$848c9b7ead0df967, isAxiosError: $9fc967f4cbe5a6f7$export$fbafdbe06a5b5a9a, spread: $9fc967f4cbe5a6f7$export$3ae0fd4797ed47c8, toFormData: $9fc967f4cbe5a6f7$export$10ae0d317ea97f8b, AxiosHeaders: $9fc967f4cbe5a6f7$export$4e7d6ff0f3e6520, HttpStatusCode: $9fc967f4cbe5a6f7$export$a972f69c851492b3, formToJSON: $9fc967f4cbe5a6f7$export$86d7c59254d6a2c9, getAdapter: $9fc967f4cbe5a6f7$export$17ddc20a97d669e2, mergeConfig: $9fc967f4cbe5a6f7$export$7ec1ebcfa9d8bd6a } = (0, $eb999ef253053d6e$export$2e2bcd8739ae039);


var $eab2d0a3b6fcede1$exports = {};
"use strict";
const $eab2d0a3b6fcede1$var$denyList = new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
]);
// TODO: Use `error?.code` when targeting Node.js 14
$eab2d0a3b6fcede1$exports = (error)=>!$eab2d0a3b6fcede1$var$denyList.has(error && error.code);


const $3a262adf5ef57145$export$76a88f7de6507443 = "axios-retry";
function $3a262adf5ef57145$export$476aa014e2fd89d5(error) {
    const CODE_EXCLUDE_LIST = [
        "ERR_CANCELED",
        "ECONNABORTED"
    ];
    if (error.response) return false;
    if (!error.code) return false;
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) return false;
    // Prevents retrying unsafe errors
    return (0, (/*@__PURE__*/$parcel$interopDefault($eab2d0a3b6fcede1$exports)))(error);
}
const $3a262adf5ef57145$var$SAFE_HTTP_METHODS = [
    "get",
    "head",
    "options"
];
const $3a262adf5ef57145$var$IDEMPOTENT_HTTP_METHODS = $3a262adf5ef57145$var$SAFE_HTTP_METHODS.concat([
    "put",
    "delete"
]);
function $3a262adf5ef57145$export$5f1dc21fa925930b(error) {
    return error.code !== "ECONNABORTED" && (!error.response || error.response.status === 429 || error.response.status >= 500 && error.response.status <= 599);
}
function $3a262adf5ef57145$export$693cf906fd8817e5(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $3a262adf5ef57145$export$5f1dc21fa925930b(error) && $3a262adf5ef57145$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $3a262adf5ef57145$export$d26799ad4978234d(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $3a262adf5ef57145$export$5f1dc21fa925930b(error) && $3a262adf5ef57145$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $3a262adf5ef57145$export$606bf0a2b170eb2(error) {
    return $3a262adf5ef57145$export$476aa014e2fd89d5(error) || $3a262adf5ef57145$export$d26799ad4978234d(error);
}
function $3a262adf5ef57145$export$e981df388f003617(error) {
    const retryAfterHeader = error?.response?.headers["retry-after"];
    if (!retryAfterHeader) return 0;
    // if the retry after header is a number, convert it to milliseconds
    let retryAfterMs = (Number(retryAfterHeader) || 0) * 1000;
    // If the retry after header is a date, get the number of milliseconds until that date
    if (retryAfterMs === 0) retryAfterMs = (new Date(retryAfterHeader).valueOf() || 0) - Date.now();
    return Math.max(0, retryAfterMs);
}
function $3a262adf5ef57145$var$noDelay(_retryNumber = 0, error) {
    return Math.max(0, $3a262adf5ef57145$export$e981df388f003617(error));
}
function $3a262adf5ef57145$export$ce2bf54576c66713(retryNumber = 0, error, delayFactor = 100) {
    const calculatedDelay = 2 ** retryNumber * delayFactor;
    const delay = Math.max(calculatedDelay, $3a262adf5ef57145$export$e981df388f003617(error));
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
function $3a262adf5ef57145$export$384f50abe7b57bc7(delayFactor = 100) {
    return (retryNumber = 0, error)=>{
        const delay = retryNumber * delayFactor;
        return Math.max(delay, $3a262adf5ef57145$export$e981df388f003617(error));
    };
}
const $3a262adf5ef57145$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $3a262adf5ef57145$export$606bf0a2b170eb2,
    retryDelay: $3a262adf5ef57145$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{},
    onMaxRetryTimesExceeded: ()=>{},
    validateResponse: null
};
function $3a262adf5ef57145$var$getRequestOptions(config, defaultOptions) {
    return {
        ...$3a262adf5ef57145$export$93ca5d3f8675ae4c,
        ...defaultOptions,
        ...config[$3a262adf5ef57145$export$76a88f7de6507443]
    };
}
function $3a262adf5ef57145$var$setCurrentState(config, defaultOptions, resetLastRequestTime = false) {
    const currentState = $3a262adf5ef57145$var$getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    if (!currentState.lastRequestTime || resetLastRequestTime) currentState.lastRequestTime = Date.now();
    config[$3a262adf5ef57145$export$76a88f7de6507443] = currentState;
    return currentState;
}
function $3a262adf5ef57145$var$fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) // @ts-ignore
    delete config.agent;
    if (axiosInstance.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
async function $3a262adf5ef57145$var$shouldRetry(currentState, error) {
    const { retries: retries, retryCondition: retryCondition } = currentState;
    const shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
    // This could be a promise
    if (typeof shouldRetryOrPromise === "object") try {
        const shouldRetryPromiseResult = await shouldRetryOrPromise;
        // keep return true unless shouldRetryPromiseResult return false for compatibility
        return shouldRetryPromiseResult !== false;
    } catch (_err) {
        return false;
    }
    return shouldRetryOrPromise;
}
async function $3a262adf5ef57145$var$handleRetry(axiosInstance, currentState, error, config) {
    currentState.retryCount += 1;
    const { retryDelay: retryDelay, shouldResetTimeout: shouldResetTimeout, onRetry: onRetry } = currentState;
    const delay = retryDelay(currentState.retryCount, error);
    // Axios fails merging this configuration to the default configuration because it has an issue
    // with circular structures: https://github.com/mzabriskie/axios/issues/370
    $3a262adf5ef57145$var$fixConfig(axiosInstance, config);
    if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
        const lastRequestDuration = Date.now() - currentState.lastRequestTime;
        const timeout = config.timeout - lastRequestDuration - delay;
        if (timeout <= 0) return Promise.reject(error);
        config.timeout = timeout;
    }
    config.transformRequest = [
        (data)=>data
    ];
    await onRetry(currentState.retryCount, error, config);
    if (config.signal?.aborted) return Promise.resolve(axiosInstance(config));
    return new Promise((resolve)=>{
        const abortListener = ()=>{
            clearTimeout(timeout);
            resolve(axiosInstance(config));
        };
        const timeout = setTimeout(()=>{
            resolve(axiosInstance(config));
            if (config.signal?.removeEventListener) config.signal.removeEventListener("abort", abortListener);
        }, delay);
        if (config.signal?.addEventListener) config.signal.addEventListener("abort", abortListener, {
            once: true
        });
    });
}
async function $3a262adf5ef57145$var$handleMaxRetryTimesExceeded(currentState, error) {
    if (currentState.retryCount >= currentState.retries) await currentState.onMaxRetryTimesExceeded(error, currentState.retryCount);
}
const $3a262adf5ef57145$var$axiosRetry = (axiosInstance, defaultOptions)=>{
    const requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
        $3a262adf5ef57145$var$setCurrentState(config, defaultOptions, true);
        if (config[$3a262adf5ef57145$export$76a88f7de6507443]?.validateResponse) // by setting this, all HTTP responses will be go through the error interceptor first
        config.validateStatus = ()=>false;
        return config;
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use(null, async (error)=>{
        const { config: config } = error;
        // If we have no information to retry the request
        if (!config) return Promise.reject(error);
        const currentState = $3a262adf5ef57145$var$setCurrentState(config, defaultOptions);
        if (error.response && currentState.validateResponse?.(error.response)) // no issue with response
        return error.response;
        if (await $3a262adf5ef57145$var$shouldRetry(currentState, error)) return $3a262adf5ef57145$var$handleRetry(axiosInstance, currentState, error, config);
        await $3a262adf5ef57145$var$handleMaxRetryTimesExceeded(currentState, error);
        return Promise.reject(error);
    });
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
};
// Compatibility with CommonJS
$3a262adf5ef57145$var$axiosRetry.isNetworkError = $3a262adf5ef57145$export$476aa014e2fd89d5;
$3a262adf5ef57145$var$axiosRetry.isSafeRequestError = $3a262adf5ef57145$export$693cf906fd8817e5;
$3a262adf5ef57145$var$axiosRetry.isIdempotentRequestError = $3a262adf5ef57145$export$d26799ad4978234d;
$3a262adf5ef57145$var$axiosRetry.isNetworkOrIdempotentRequestError = $3a262adf5ef57145$export$606bf0a2b170eb2;
$3a262adf5ef57145$var$axiosRetry.exponentialDelay = $3a262adf5ef57145$export$ce2bf54576c66713;
$3a262adf5ef57145$var$axiosRetry.linearDelay = $3a262adf5ef57145$export$384f50abe7b57bc7;
$3a262adf5ef57145$var$axiosRetry.isRetryableError = $3a262adf5ef57145$export$5f1dc21fa925930b;
var $3a262adf5ef57145$export$2e2bcd8739ae039 = $3a262adf5ef57145$var$axiosRetry;



var $dc6El = parcelRequire("dc6El");
// packages/intersect/src/index.js
function $88fc130f586896c1$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $88fc130f586896c1$var$getRootMargin(modifiers),
            threshold: $88fc130f586896c1$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $88fc130f586896c1$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $88fc130f586896c1$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $88fc130f586896c1$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($88fc130f586896c1$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $88fc130f586896c1$export$2e2bcd8739ae039 = $88fc130f586896c1$export$1f4807a235930d45;



var $jjFgX = parcelRequire("jjFgX");
// packages/persist/src/index.js
function $83bfdc0c6067767d$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $83bfdc0c6067767d$var$storageHas(lookup, storage) ? $83bfdc0c6067767d$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $83bfdc0c6067767d$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $83bfdc0c6067767d$var$storageHas(key, storage) ? $83bfdc0c6067767d$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $83bfdc0c6067767d$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $83bfdc0c6067767d$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $83bfdc0c6067767d$var$storageGet(key, storage) {
    let value = storage.getItem(key, storage);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $83bfdc0c6067767d$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $83bfdc0c6067767d$export$2e2bcd8739ae039 = $83bfdc0c6067767d$export$9a6132153fba2e0;


/**
 * SVG Icons utility methods
 */ const $61602e53fa3950f8$var$file = {
    text: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/>`,
    archive: `<path d="M10 12v-1"/><path d="M10 18v-2"/><path d="M10 7V6"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"/><circle cx="10" cy="20" r="2"/>`,
    audio: `<path d="M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0"/>`,
    audioAlt: `<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>`,
    image: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><circle cx="10" cy="12" r="2"/><path d="m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22"/>`,
    images: `<path d="M18 22H4a2 2 0 0 1-2-2V6"/><path d="m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"/><circle cx="12" cy="8" r="2"/><rect width="16" height="16" x="6" y="2" rx="2"/>`,
    gif: `<path d="m11 16-5 5"/><path d="M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5"/><path d="M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z"/><circle cx="9" cy="9" r="2"/>`,
    video: `<path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><rect width="8" height="6" x="2" y="12" rx="1"/><path d="m10 15.5 4 2.5v-6l-4 2.5"/>`,
    videoAlt: `<path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/>`,
    svg: `<path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m5 12-3 3 3 3"/><path d="m9 18 3-3-3-3"/>`,
    spreadsheet: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M8 13h2"/><path d="M14 13h2"/><path d="M8 17h2"/><path d="M14 17h2"/>`,
    file: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/>`,
    warn: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M12 9v4"/><path d="M12 17h.01"/>`,
    //pending: `<path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><circle cx="8" cy="16" r="6"/><path d="M9.5 17.5 8 16.25V14"/>`,
    done: `<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m9 15 2 2 4-4"/>`,
    undefined: `<path d="M12 17h.01"/><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/><path d="M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"/>`,
    // Scan Icons
    pending: `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/>`,
    clean: `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>`,
    infected: `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m4.243 5.21 14.39 12.472"/>`,
    unknown: `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>`,
    // Collections
    stack: `<path d="M21 7h-3a2 2 0 0 1-2-2V2"/><path d="M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z"/><path d="M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"/><path d="M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"/>`,
    files: `<path d="M20 7h-3a2 2 0 0 1-2-2V2"/><path d="M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"/><path d="M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"/>`
};
function $61602e53fa3950f8$export$16b26cd5e98d9100(name, classNames = "", stroke = 1.5) {
    let icon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${stroke}" stroke-linecap="round" stroke-linejoin="round" class="${classNames}">`;
    icon += $61602e53fa3950f8$var$file[name];
    icon += "</svg>";
    return icon;
}
function $61602e53fa3950f8$export$8dd1e18e1afcf33c(mime = "application/octet-stream", className = "", stroke = 1.5, alt = false) {
    let icon = "undefined";
    // Generic Image
    if (mime.startsWith("image/")) icon = "image";
    // Generic Audio
    if (mime.startsWith("audio/")) icon = alt ? "audioAlt" : "audio";
    // Generic Video
    if (mime.startsWith("video/")) icon = alt ? "videoAlt" : "video";
    // SVG
    if (mime.startsWith("image/") && mime.includes("svg")) icon = "svg";
    // GIF
    if (mime.startsWith("image/") && mime.includes("gif")) icon = "gif";
    // PDF
    if (mime.startsWith("application/pdf")) icon = "text";
    // ZIP, TAR
    if (mime.startsWith("application/zip")) icon = "archive";
    if (mime.includes("tar")) icon = "archive";
    // Spreadsheet
    if (mime.includes("spreadsheet")) icon = "spreadsheet";
    // Text
    if (mime.startsWith("text/")) icon = "text";
    const svg = $61602e53fa3950f8$export$16b26cd5e98d9100(icon, className, stroke);
    return svg ?? "";
}



var $6CDrG = parcelRequire("6CDrG");
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $bb2fe5f1eb68b8c6$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(v) {
    return $bb2fe5f1eb68b8c6$export$837ba5c449269406($bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $bb2fe5f1eb68b8c6$export$869b26d4e1bbdb63(v) {
    return $bb2fe5f1eb68b8c6$export$837ba5c449269406($bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6(v) {
    return $bb2fe5f1eb68b8c6$export$837ba5c449269406($bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(v) {
    return $bb2fe5f1eb68b8c6$export$837ba5c449269406($bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $bb2fe5f1eb68b8c6$export$aa35ef1f24408ab9(v) {
    return $bb2fe5f1eb68b8c6$export$837ba5c449269406($bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $bb2fe5f1eb68b8c6$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $bb2fe5f1eb68b8c6$var$hex = [
    ..."0123456789ABCDEF"
];
const $bb2fe5f1eb68b8c6$var$h1 = (b)=>$bb2fe5f1eb68b8c6$var$hex[b & 0xF];
const $bb2fe5f1eb68b8c6$var$h2 = (b)=>$bb2fe5f1eb68b8c6$var$hex[(b & 0xF0) >> 4] + $bb2fe5f1eb68b8c6$var$hex[b & 0xF];
const $bb2fe5f1eb68b8c6$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $bb2fe5f1eb68b8c6$var$isShort = (v)=>$bb2fe5f1eb68b8c6$var$eq(v.r) && $bb2fe5f1eb68b8c6$var$eq(v.g) && $bb2fe5f1eb68b8c6$var$eq(v.b) && $bb2fe5f1eb68b8c6$var$eq(v.a);
function $bb2fe5f1eb68b8c6$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $bb2fe5f1eb68b8c6$var$map$1[str[1]] * 17,
            g: 255 & $bb2fe5f1eb68b8c6$var$map$1[str[2]] * 17,
            b: 255 & $bb2fe5f1eb68b8c6$var$map$1[str[3]] * 17,
            a: len === 5 ? $bb2fe5f1eb68b8c6$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $bb2fe5f1eb68b8c6$var$map$1[str[1]] << 4 | $bb2fe5f1eb68b8c6$var$map$1[str[2]],
            g: $bb2fe5f1eb68b8c6$var$map$1[str[3]] << 4 | $bb2fe5f1eb68b8c6$var$map$1[str[4]],
            b: $bb2fe5f1eb68b8c6$var$map$1[str[5]] << 4 | $bb2fe5f1eb68b8c6$var$map$1[str[6]],
            a: len === 9 ? $bb2fe5f1eb68b8c6$var$map$1[str[7]] << 4 | $bb2fe5f1eb68b8c6$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $bb2fe5f1eb68b8c6$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $bb2fe5f1eb68b8c6$export$1b06654353ef9f67(v) {
    var f = $bb2fe5f1eb68b8c6$var$isShort(v) ? $bb2fe5f1eb68b8c6$var$h1 : $bb2fe5f1eb68b8c6$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $bb2fe5f1eb68b8c6$var$alpha(v.a, f) : undefined;
}
const $bb2fe5f1eb68b8c6$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $bb2fe5f1eb68b8c6$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $bb2fe5f1eb68b8c6$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $bb2fe5f1eb68b8c6$var$hwb2rgbn(h, w, b) {
    const rgb = $bb2fe5f1eb68b8c6$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $bb2fe5f1eb68b8c6$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $bb2fe5f1eb68b8c6$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $bb2fe5f1eb68b8c6$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $bb2fe5f1eb68b8c6$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6);
}
function $bb2fe5f1eb68b8c6$export$4c15bd42559b811d(h, s, l) {
    return $bb2fe5f1eb68b8c6$var$calln($bb2fe5f1eb68b8c6$var$hsl2rgbn, h, s, l);
}
function $bb2fe5f1eb68b8c6$export$e2710022c70fc9ee(h, w, b) {
    return $bb2fe5f1eb68b8c6$var$calln($bb2fe5f1eb68b8c6$var$hwb2rgbn, h, w, b);
}
function $bb2fe5f1eb68b8c6$export$b785a357c84e4a04(h, s, v) {
    return $bb2fe5f1eb68b8c6$var$calln($bb2fe5f1eb68b8c6$var$hsv2rgbn, h, s, v);
}
function $bb2fe5f1eb68b8c6$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $bb2fe5f1eb68b8c6$export$5e91288c399be4f9(str) {
    const m = $bb2fe5f1eb68b8c6$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(+m[5]) : $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $bb2fe5f1eb68b8c6$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $bb2fe5f1eb68b8c6$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === "hsv") v = $bb2fe5f1eb68b8c6$export$b785a357c84e4a04(h, p1, p2);
    else v = $bb2fe5f1eb68b8c6$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $bb2fe5f1eb68b8c6$export$bb628a54ab399bc9(v, deg) {
    var h = $bb2fe5f1eb68b8c6$export$b5ba70b240f8f7f(v);
    h[0] = $bb2fe5f1eb68b8c6$var$hue(h[0] + deg);
    h = $bb2fe5f1eb68b8c6$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $bb2fe5f1eb68b8c6$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $bb2fe5f1eb68b8c6$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $bb2fe5f1eb68b8c6$export$aa35ef1f24408ab9(a[1]);
    const l = $bb2fe5f1eb68b8c6$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $bb2fe5f1eb68b8c6$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $bb2fe5f1eb68b8c6$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $bb2fe5f1eb68b8c6$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($bb2fe5f1eb68b8c6$var$names$1);
    const tkeys = Object.keys($bb2fe5f1eb68b8c6$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $bb2fe5f1eb68b8c6$var$map[k]);
        }
        k = parseInt($bb2fe5f1eb68b8c6$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $bb2fe5f1eb68b8c6$var$names;
function $bb2fe5f1eb68b8c6$export$b2f06b640faad956(str) {
    if (!$bb2fe5f1eb68b8c6$var$names) {
        $bb2fe5f1eb68b8c6$var$names = $bb2fe5f1eb68b8c6$var$unpack();
        $bb2fe5f1eb68b8c6$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $bb2fe5f1eb68b8c6$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $bb2fe5f1eb68b8c6$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $bb2fe5f1eb68b8c6$export$91aedb20f296e541(str) {
    const m = $bb2fe5f1eb68b8c6$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(v) : $bb2fe5f1eb68b8c6$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(r) : $bb2fe5f1eb68b8c6$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(g) : $bb2fe5f1eb68b8c6$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $bb2fe5f1eb68b8c6$export$bcc6e673dfa14d36(b) : $bb2fe5f1eb68b8c6$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $bb2fe5f1eb68b8c6$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $bb2fe5f1eb68b8c6$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $bb2fe5f1eb68b8c6$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $bb2fe5f1eb68b8c6$var$interpolate(rgb1, rgb2, t) {
    const r = $bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb1.r));
    const g = $bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb1.g));
    const b = $bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6($bb2fe5f1eb68b8c6$var$to(r + t * ($bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6($bb2fe5f1eb68b8c6$var$to(g + t * ($bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6($bb2fe5f1eb68b8c6$var$to(b + t * ($bb2fe5f1eb68b8c6$var$from($bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $bb2fe5f1eb68b8c6$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $bb2fe5f1eb68b8c6$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $bb2fe5f1eb68b8c6$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $bb2fe5f1eb68b8c6$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $bb2fe5f1eb68b8c6$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $bb2fe5f1eb68b8c6$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $bb2fe5f1eb68b8c6$var$functionParse(str) {
    if (str.charAt(0) === "r") return $bb2fe5f1eb68b8c6$export$91aedb20f296e541(str);
    return $bb2fe5f1eb68b8c6$export$5e91288c399be4f9(str);
}
class $bb2fe5f1eb68b8c6$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $bb2fe5f1eb68b8c6$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $bb2fe5f1eb68b8c6$var$fromObject(input);
        else if (type === "string") v = $bb2fe5f1eb68b8c6$export$625a38b961e8b5e9(input) || $bb2fe5f1eb68b8c6$export$b2f06b640faad956(input) || $bb2fe5f1eb68b8c6$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $bb2fe5f1eb68b8c6$var$clone(this._rgb);
        if (v) v.a = $bb2fe5f1eb68b8c6$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $bb2fe5f1eb68b8c6$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $bb2fe5f1eb68b8c6$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $bb2fe5f1eb68b8c6$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $bb2fe5f1eb68b8c6$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $bb2fe5f1eb68b8c6$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $bb2fe5f1eb68b8c6$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $bb2fe5f1eb68b8c6$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $bb2fe5f1eb68b8c6$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $bb2fe5f1eb68b8c6$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $bb2fe5f1eb68b8c6$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $bb2fe5f1eb68b8c6$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $bb2fe5f1eb68b8c6$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $bb2fe5f1eb68b8c6$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $bb2fe5f1eb68b8c6$export$2e2bcd8739ae039(input) {
    return new $bb2fe5f1eb68b8c6$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $a130d9e691a5988d$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $a130d9e691a5988d$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $a130d9e691a5988d$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $a130d9e691a5988d$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $a130d9e691a5988d$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $a130d9e691a5988d$export$39b482c5e57630a8(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $a130d9e691a5988d$export$c4ce752e73470fba(value, defaultValue) {
    return $a130d9e691a5988d$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $a130d9e691a5988d$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $a130d9e691a5988d$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const $a130d9e691a5988d$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $a130d9e691a5988d$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $a130d9e691a5988d$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($a130d9e691a5988d$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($a130d9e691a5988d$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $a130d9e691a5988d$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $a130d9e691a5988d$export$667d3bf0c5f83305(source) {
    if ($a130d9e691a5988d$export$8b22cf2602fb60ce(source)) return source.map($a130d9e691a5988d$export$667d3bf0c5f83305);
    if ($a130d9e691a5988d$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $a130d9e691a5988d$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $a130d9e691a5988d$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $a130d9e691a5988d$export$317a3d46287192d8(key, target, source, options) {
    if (!$a130d9e691a5988d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($a130d9e691a5988d$export$23f2a1d2818174ef(tval) && $a130d9e691a5988d$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $a130d9e691a5988d$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $a130d9e691a5988d$export$667d3bf0c5f83305(sval);
}
function $a130d9e691a5988d$export$efca4cbe5dd06740(target, source, options) {
    const sources = $a130d9e691a5988d$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$a130d9e691a5988d$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $a130d9e691a5988d$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$a130d9e691a5988d$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $a130d9e691a5988d$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $a130d9e691a5988d$export$efca4cbe5dd06740(target, source, {
        merger: $a130d9e691a5988d$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $a130d9e691a5988d$export$1ee57be6f6687d2c(key, target, source) {
    if (!$a130d9e691a5988d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($a130d9e691a5988d$export$23f2a1d2818174ef(tval) && $a130d9e691a5988d$export$23f2a1d2818174ef(sval)) $a130d9e691a5988d$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $a130d9e691a5988d$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $a130d9e691a5988d$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $a130d9e691a5988d$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $a130d9e691a5988d$export$1a8f5705751d8277(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $a130d9e691a5988d$var$_getKeyResolver(key) {
    const keys = $a130d9e691a5988d$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $a130d9e691a5988d$export$2d1720544b23b823(obj, key) {
    const resolver = $a130d9e691a5988d$var$keyResolvers[key] || ($a130d9e691a5988d$var$keyResolvers[key] = $a130d9e691a5988d$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $a130d9e691a5988d$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $a130d9e691a5988d$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $a130d9e691a5988d$export$a93c5207d687da10 = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $a130d9e691a5988d$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $a130d9e691a5988d$export$3b513254972cfc9c(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $a130d9e691a5988d$export$56c0d5a1e737357d = Math.PI;
const $a130d9e691a5988d$export$971d5caa766a69d7 = 2 * $a130d9e691a5988d$export$56c0d5a1e737357d;
const $a130d9e691a5988d$export$2ec5befb9e6c97d4 = $a130d9e691a5988d$export$971d5caa766a69d7 + $a130d9e691a5988d$export$56c0d5a1e737357d;
const $a130d9e691a5988d$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $a130d9e691a5988d$export$39c1cc7c062529d4 = $a130d9e691a5988d$export$56c0d5a1e737357d / 180;
const $a130d9e691a5988d$export$7f8ddf7c7c20b3cd = $a130d9e691a5988d$export$56c0d5a1e737357d / 2;
const $a130d9e691a5988d$export$7a0bdf7d4a91ea88 = $a130d9e691a5988d$export$56c0d5a1e737357d / 4;
const $a130d9e691a5988d$export$c18d01048907ea92 = $a130d9e691a5988d$export$56c0d5a1e737357d * 2 / 3;
const $a130d9e691a5988d$export$faec65b429be379 = Math.log10;
const $a130d9e691a5988d$export$2408f22a0fab9ae5 = Math.sign;
function $a130d9e691a5988d$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $a130d9e691a5988d$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $a130d9e691a5988d$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($a130d9e691a5988d$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $a130d9e691a5988d$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $a130d9e691a5988d$var$isNonPrimitive(n) {
    return typeof n === "symbol" || typeof n === "object" && n !== null && !(Symbol.toPrimitive in n || "toString" in n || "valueOf" in n);
}
function $a130d9e691a5988d$export$d141bba7fdc215a3(n) {
    return !$a130d9e691a5988d$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $a130d9e691a5988d$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $a130d9e691a5988d$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $a130d9e691a5988d$export$625550452a3fa3ec(degrees) {
    return degrees * ($a130d9e691a5988d$export$56c0d5a1e737357d / 180);
}
function $a130d9e691a5988d$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $a130d9e691a5988d$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $a130d9e691a5988d$export$91477dc880baac21(x) {
    if (!$a130d9e691a5988d$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $a130d9e691a5988d$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $a130d9e691a5988d$export$56c0d5a1e737357d) angle += $a130d9e691a5988d$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $a130d9e691a5988d$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $a130d9e691a5988d$export$f074adc9fbd50943(a, b) {
    return (a - b + $a130d9e691a5988d$export$2ec5befb9e6c97d4) % $a130d9e691a5988d$export$971d5caa766a69d7 - $a130d9e691a5988d$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $a130d9e691a5988d$export$3d12bd131bb975d1(a) {
    return (a % $a130d9e691a5988d$export$971d5caa766a69d7 + $a130d9e691a5988d$export$971d5caa766a69d7) % $a130d9e691a5988d$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $a130d9e691a5988d$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $a130d9e691a5988d$export$3d12bd131bb975d1(angle);
    const s = $a130d9e691a5988d$export$3d12bd131bb975d1(start);
    const e = $a130d9e691a5988d$export$3d12bd131bb975d1(end);
    const angleToStart = $a130d9e691a5988d$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $a130d9e691a5988d$export$3d12bd131bb975d1(e - a);
    const startToAngle = $a130d9e691a5988d$export$3d12bd131bb975d1(a - s);
    const endToAngle = $a130d9e691a5988d$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $a130d9e691a5988d$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $a130d9e691a5988d$export$71cec2538cb2c617(value) {
    return $a130d9e691a5988d$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $a130d9e691a5988d$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $a130d9e691a5988d$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $a130d9e691a5988d$export$ef35774e6d314e91 = (table, key, value, last)=>$a130d9e691a5988d$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $a130d9e691a5988d$export$ebd11618f299a286 = (table, key, value)=>$a130d9e691a5988d$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $a130d9e691a5988d$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $a130d9e691a5988d$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $a130d9e691a5988d$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $a130d9e691a5988d$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $a130d9e691a5988d$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $a130d9e691a5988d$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $a130d9e691a5988d$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $a130d9e691a5988d$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $a130d9e691a5988d$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const $a130d9e691a5988d$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $a130d9e691a5988d$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $a130d9e691a5988d$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $a130d9e691a5988d$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $a130d9e691a5988d$export$3c2fa207a37baaea = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $a130d9e691a5988d$export$ce26c07117d59d6a = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $a130d9e691a5988d$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $a130d9e691a5988d$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($a130d9e691a5988d$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $a130d9e691a5988d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$a130d9e691a5988d$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $a130d9e691a5988d$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($a130d9e691a5988d$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $a130d9e691a5988d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$a130d9e691a5988d$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $a130d9e691a5988d$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $a130d9e691a5988d$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $a130d9e691a5988d$var$atEdge = (t)=>t === 0 || t === 1;
const $a130d9e691a5988d$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $a130d9e691a5988d$export$971d5caa766a69d7 / p));
const $a130d9e691a5988d$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $a130d9e691a5988d$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $a130d9e691a5988d$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $a130d9e691a5988d$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $a130d9e691a5988d$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($a130d9e691a5988d$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$a130d9e691a5988d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$a130d9e691a5988d$var$atEdge(t) ? t : $a130d9e691a5988d$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$a130d9e691a5988d$var$atEdge(t) ? t : $a130d9e691a5988d$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $a130d9e691a5988d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $a130d9e691a5988d$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $a130d9e691a5988d$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $a130d9e691a5988d$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $a130d9e691a5988d$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $a130d9e691a5988d$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $a130d9e691a5988d$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $a130d9e691a5988d$export$db3b6bfb95261072(value) {
    return $a130d9e691a5988d$export$738ab4df8bf92ae9(value) ? value : new (0, $bb2fe5f1eb68b8c6$export$892596cec99bc70e)(value);
}
function $a130d9e691a5988d$export$d377dcb2b61d6c4e(value) {
    return $a130d9e691a5988d$export$738ab4df8bf92ae9(value) ? value : new (0, $bb2fe5f1eb68b8c6$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $a130d9e691a5988d$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $a130d9e691a5988d$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function $a130d9e691a5988d$var$applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: $a130d9e691a5988d$var$colors
        },
        numbers: {
            type: "number",
            properties: $a130d9e691a5988d$var$numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $a130d9e691a5988d$var$applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $a130d9e691a5988d$var$intlCache = new Map();
function $a130d9e691a5988d$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $a130d9e691a5988d$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $a130d9e691a5988d$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $a130d9e691a5988d$export$ae1af26003f05816(num, locale, options) {
    return $a130d9e691a5988d$var$getNumberFormat(locale, options).format(num);
}
const $a130d9e691a5988d$var$formatters = {
    values (value) {
        return $a130d9e691a5988d$export$8b22cf2602fb60ce(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $a130d9e691a5988d$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $a130d9e691a5988d$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $a130d9e691a5988d$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($a130d9e691a5988d$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $a130d9e691a5988d$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $a130d9e691a5988d$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $a130d9e691a5988d$export$9f4f30ee63539e24 = {
    formatters: $a130d9e691a5988d$var$formatters
};
function $a130d9e691a5988d$var$applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $a130d9e691a5988d$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const $a130d9e691a5988d$export$6559d589eb85fbb6 = Object.create(null);
const $a130d9e691a5988d$export$2e2af4578d910ddf = Object.create(null);
function $a130d9e691a5988d$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $a130d9e691a5988d$var$set(root, scope, values) {
    if (typeof scope === "string") return $a130d9e691a5988d$export$efca4cbe5dd06740($a130d9e691a5988d$var$getScope$1(root, scope), values);
    return $a130d9e691a5988d$export$efca4cbe5dd06740($a130d9e691a5988d$var$getScope$1(root, ""), scope);
}
class $a130d9e691a5988d$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$a130d9e691a5988d$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$a130d9e691a5988d$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$a130d9e691a5988d$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $a130d9e691a5988d$var$set(this, scope, values);
    }
    get(scope) {
        return $a130d9e691a5988d$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $a130d9e691a5988d$var$set($a130d9e691a5988d$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $a130d9e691a5988d$var$set($a130d9e691a5988d$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $a130d9e691a5988d$var$getScope$1(this, scope);
        const targetScopeObject = $a130d9e691a5988d$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($a130d9e691a5988d$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $a130d9e691a5988d$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $a130d9e691a5988d$export$4368d992c4eafac0 = /* #__PURE__ */ new $a130d9e691a5988d$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $a130d9e691a5988d$var$applyAnimationsDefaults,
    $a130d9e691a5988d$var$applyLayoutsDefaults,
    $a130d9e691a5988d$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $a130d9e691a5988d$export$e171bab687b50e0(font) {
    if (!font || $a130d9e691a5988d$export$342063e11d6c3cad(font.size) || $a130d9e691a5988d$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function $a130d9e691a5988d$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $a130d9e691a5988d$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$a130d9e691a5988d$export$8b22cf2602fb60ce(thing)) longest = $a130d9e691a5988d$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($a130d9e691a5988d$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$a130d9e691a5988d$export$8b22cf2602fb60ce(nestedThing)) longest = $a130d9e691a5988d$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $a130d9e691a5988d$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $a130d9e691a5988d$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $a130d9e691a5988d$export$1fbe638ecf81657e(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $a130d9e691a5988d$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $a130d9e691a5988d$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $a130d9e691a5988d$export$39c1cc7c062529d4;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $a130d9e691a5988d$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $a130d9e691a5988d$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $a130d9e691a5988d$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $a130d9e691a5988d$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $a130d9e691a5988d$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $a130d9e691a5988d$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $a130d9e691a5988d$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $a130d9e691a5988d$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $a130d9e691a5988d$export$56c0d5a1e737357d, rad - $a130d9e691a5988d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $a130d9e691a5988d$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $a130d9e691a5988d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $a130d9e691a5988d$export$7f8ddf7c7c20b3cd, rad + $a130d9e691a5988d$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $a130d9e691a5988d$export$7a0bdf7d4a91ea88;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $a130d9e691a5988d$export$7a0bdf7d4a91ea88;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $a130d9e691a5988d$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $a130d9e691a5988d$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $a130d9e691a5988d$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $a130d9e691a5988d$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $a130d9e691a5988d$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $a130d9e691a5988d$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $a130d9e691a5988d$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$a130d9e691a5988d$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $a130d9e691a5988d$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $a130d9e691a5988d$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $a130d9e691a5988d$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $a130d9e691a5988d$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $a130d9e691a5988d$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $a130d9e691a5988d$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$a130d9e691a5988d$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $a130d9e691a5988d$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $a130d9e691a5988d$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $a130d9e691a5988d$export$56c0d5a1e737357d, $a130d9e691a5988d$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $a130d9e691a5988d$export$56c0d5a1e737357d, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$a130d9e691a5988d$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $a130d9e691a5988d$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $a130d9e691a5988d$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $a130d9e691a5988d$export$d29e374196577086(value, size) {
    const matches = ("" + value).match($a130d9e691a5988d$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $a130d9e691a5988d$var$numberOrZero = (v)=>+v || 0;
function $a130d9e691a5988d$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $a130d9e691a5988d$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $a130d9e691a5988d$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$a130d9e691a5988d$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $a130d9e691a5988d$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $a130d9e691a5988d$export$92108d983e8ee699(value) {
    return $a130d9e691a5988d$export$ab83b03e4111b1d0(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $a130d9e691a5988d$export$9fa96a7d116ea3ce(value) {
    return $a130d9e691a5988d$export$ab83b03e4111b1d0(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $a130d9e691a5988d$export$a9c23c6ac3fc3eca(value) {
    const obj = $a130d9e691a5988d$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $a130d9e691a5988d$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $a130d9e691a5988d$export$4368d992c4eafac0.font;
    let size = $a130d9e691a5988d$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $a130d9e691a5988d$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($a130d9e691a5988d$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $a130d9e691a5988d$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $a130d9e691a5988d$export$d29e374196577086($a130d9e691a5988d$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $a130d9e691a5988d$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $a130d9e691a5988d$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $a130d9e691a5988d$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $a130d9e691a5988d$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $a130d9e691a5988d$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $a130d9e691a5988d$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $a130d9e691a5988d$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $a130d9e691a5988d$export$a9c996f45e5784d0(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = $a130d9e691a5988d$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$a130d9e691a5988d$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $a130d9e691a5988d$var$_cached(target, prop, ()=>$a130d9e691a5988d$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $a130d9e691a5988d$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $a130d9e691a5988d$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $a130d9e691a5988d$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $a130d9e691a5988d$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$a130d9e691a5988d$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$a130d9e691a5988d$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $a130d9e691a5988d$var$_cached(target, prop, ()=>$a130d9e691a5988d$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $a130d9e691a5988d$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $a130d9e691a5988d$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $a130d9e691a5988d$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $a130d9e691a5988d$var$readKey = (prefix, name)=>prefix ? prefix + $a130d9e691a5988d$export$a8550f7dbe79f93a(name) : name;
const $a130d9e691a5988d$var$needsSubResolver = (prop, value)=>$a130d9e691a5988d$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $a130d9e691a5988d$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === "constructor") return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $a130d9e691a5988d$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($a130d9e691a5988d$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $a130d9e691a5988d$var$_resolveScriptable(prop, value, target, receiver);
    if ($a130d9e691a5988d$export$8b22cf2602fb60ce(value) && value.length) value = $a130d9e691a5988d$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($a130d9e691a5988d$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $a130d9e691a5988d$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $a130d9e691a5988d$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($a130d9e691a5988d$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $a130d9e691a5988d$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $a130d9e691a5988d$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if ($a130d9e691a5988d$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $a130d9e691a5988d$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($a130d9e691a5988d$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $a130d9e691a5988d$var$resolveFallback(fallback, prop, value) {
    return $a130d9e691a5988d$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $a130d9e691a5988d$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $a130d9e691a5988d$export$2d1720544b23b823(parent, key) : undefined;
function $a130d9e691a5988d$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $a130d9e691a5988d$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $a130d9e691a5988d$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $a130d9e691a5988d$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $a130d9e691a5988d$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $a130d9e691a5988d$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = $a130d9e691a5988d$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $a130d9e691a5988d$export$a9c996f45e5784d0(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$a130d9e691a5988d$var$subGetTarget(resolver, prop, value));
}
function $a130d9e691a5988d$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $a130d9e691a5988d$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $a130d9e691a5988d$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($a130d9e691a5988d$export$8b22cf2602fb60ce(target) && $a130d9e691a5988d$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $a130d9e691a5988d$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $a130d9e691a5988d$var$_resolve($a130d9e691a5988d$var$readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return $a130d9e691a5988d$var$needsSubResolver(prop, value) ? $a130d9e691a5988d$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $a130d9e691a5988d$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function $a130d9e691a5988d$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $a130d9e691a5988d$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $a130d9e691a5988d$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $a130d9e691a5988d$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($a130d9e691a5988d$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $a130d9e691a5988d$var$EPSILON = Number.EPSILON || 1e-14;
const $a130d9e691a5988d$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $a130d9e691a5988d$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $a130d9e691a5988d$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $a130d9e691a5988d$export$cf2f7c5792f80b46(current, previous);
    const d12 = $a130d9e691a5988d$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $a130d9e691a5988d$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $a130d9e691a5988d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $a130d9e691a5988d$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($a130d9e691a5988d$export$23ebac1979863676(deltaK[i], 0, $a130d9e691a5988d$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $a130d9e691a5988d$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $a130d9e691a5988d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $a130d9e691a5988d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $a130d9e691a5988d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $a130d9e691a5988d$export$a17c37559e1db147(points, indexAxis = "x") {
    const valueAxis = $a130d9e691a5988d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $a130d9e691a5988d$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $a130d9e691a5988d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $a130d9e691a5988d$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $a130d9e691a5988d$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $a130d9e691a5988d$var$monotoneAdjust(points, deltaK, mK);
    $a130d9e691a5988d$var$monotoneCompute(points, mK, indexAxis);
}
function $a130d9e691a5988d$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $a130d9e691a5988d$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $a130d9e691a5988d$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $a130d9e691a5988d$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $a130d9e691a5988d$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $a130d9e691a5988d$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $a130d9e691a5988d$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $a130d9e691a5988d$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $a130d9e691a5988d$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $a130d9e691a5988d$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $a130d9e691a5988d$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $a130d9e691a5988d$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $a130d9e691a5988d$export$3a1a48c8f6ef640e() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function $a130d9e691a5988d$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $a130d9e691a5988d$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $a130d9e691a5988d$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $a130d9e691a5988d$export$fef3dfd9bad05307(el, property) {
    return $a130d9e691a5988d$var$getComputedStyle(el).getPropertyValue(property);
}
const $a130d9e691a5988d$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $a130d9e691a5988d$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $a130d9e691a5988d$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $a130d9e691a5988d$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $a130d9e691a5988d$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($a130d9e691a5988d$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $a130d9e691a5988d$export$df995fae86a55f06(event, chart) {
    if ("native" in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $a130d9e691a5988d$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $a130d9e691a5988d$var$getPositionedStyle(style, "padding");
    const borders = $a130d9e691a5988d$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $a130d9e691a5988d$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $a130d9e691a5988d$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $a130d9e691a5988d$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $a130d9e691a5988d$var$getComputedStyle(container);
            const containerBorder = $a130d9e691a5988d$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $a130d9e691a5988d$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $a130d9e691a5988d$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $a130d9e691a5988d$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $a130d9e691a5988d$export$53c86fa97d611818,
        maxHeight: maxHeight || $a130d9e691a5988d$export$53c86fa97d611818
    };
}
const $a130d9e691a5988d$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $a130d9e691a5988d$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $a130d9e691a5988d$var$getComputedStyle(canvas);
    const margins = $a130d9e691a5988d$var$getPositionedStyle(style, "margin");
    const maxWidth = $a130d9e691a5988d$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $a130d9e691a5988d$export$53c86fa97d611818;
    const maxHeight = $a130d9e691a5988d$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $a130d9e691a5988d$export$53c86fa97d611818;
    const containerSize = $a130d9e691a5988d$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $a130d9e691a5988d$var$getPositionedStyle(style, "border", "width");
        const paddings = $a130d9e691a5988d$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $a130d9e691a5988d$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $a130d9e691a5988d$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $a130d9e691a5988d$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $a130d9e691a5988d$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $a130d9e691a5988d$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $a130d9e691a5988d$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($a130d9e691a5988d$export$3a1a48c8f6ef640e()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $a130d9e691a5988d$export$b4171a6734a65d42(element, property) {
    const value = $a130d9e691a5988d$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $a130d9e691a5988d$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $a130d9e691a5988d$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $a130d9e691a5988d$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $a130d9e691a5988d$export$d24c54395ce0c509(p1, cp1, t);
    const b = $a130d9e691a5988d$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $a130d9e691a5988d$export$d24c54395ce0c509(cp2, p2, t);
    const d = $a130d9e691a5988d$export$d24c54395ce0c509(a, b, t);
    const e = $a130d9e691a5988d$export$d24c54395ce0c509(b, c, t);
    return $a130d9e691a5988d$export$d24c54395ce0c509(d, e, t);
}
const $a130d9e691a5988d$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $a130d9e691a5988d$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $a130d9e691a5988d$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $a130d9e691a5988d$var$getRightToLeftAdapter(rectX, width) : $a130d9e691a5988d$var$getLeftToRightAdapter();
}
function $a130d9e691a5988d$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $a130d9e691a5988d$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $a130d9e691a5988d$var$propertyFn(property) {
    if (property === "angle") return {
        between: $a130d9e691a5988d$export$ffb5f4729a158638,
        compare: $a130d9e691a5988d$export$f074adc9fbd50943,
        normalize: $a130d9e691a5988d$export$3d12bd131bb975d1
    };
    return {
        between: $a130d9e691a5988d$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $a130d9e691a5988d$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $a130d9e691a5988d$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $a130d9e691a5988d$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $a130d9e691a5988d$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $a130d9e691a5988d$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $a130d9e691a5988d$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($a130d9e691a5988d$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($a130d9e691a5988d$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $a130d9e691a5988d$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $a130d9e691a5988d$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $a130d9e691a5988d$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $a130d9e691a5988d$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $a130d9e691a5988d$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $a130d9e691a5988d$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $a130d9e691a5988d$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $a130d9e691a5988d$var$splitByStyles(line, $a130d9e691a5988d$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $a130d9e691a5988d$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $a130d9e691a5988d$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $a130d9e691a5988d$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $a130d9e691a5988d$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $a130d9e691a5988d$var$readStyle(segmentOptions.setContext($a130d9e691a5988d$export$35e795649ee09318(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($a130d9e691a5988d$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $a130d9e691a5988d$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $a130d9e691a5988d$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$a130d9e691a5988d$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $a130d9e691a5988d$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $a130d9e691a5988d$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $a130d9e691a5988d$var$getSizeForArea(xScale, chartArea, "left"),
        right: $a130d9e691a5988d$var$getSizeForArea(xScale, chartArea, "right"),
        top: $a130d9e691a5988d$var$getSizeForArea(yScale, chartArea, "top"),
        bottom: $a130d9e691a5988d$var$getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
function $a130d9e691a5988d$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $a130d9e691a5988d$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $367ab585cb12ed65$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $a130d9e691a5988d$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $367ab585cb12ed65$export$a424a0aa8f687495 = /* #__PURE__ */ new $367ab585cb12ed65$var$Animator();
const $367ab585cb12ed65$var$transparent = "transparent";
const $367ab585cb12ed65$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $a130d9e691a5988d$export$db3b6bfb95261072)(from || $367ab585cb12ed65$var$transparent);
        const c1 = c0.valid && (0, $a130d9e691a5988d$export$db3b6bfb95261072)(to || $367ab585cb12ed65$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $367ab585cb12ed65$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $a130d9e691a5988d$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $a130d9e691a5988d$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $367ab585cb12ed65$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $a130d9e691a5988d$export$f1e1789686576879)[cfg.easing] || (0, $a130d9e691a5988d$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $a130d9e691a5988d$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $a130d9e691a5988d$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $367ab585cb12ed65$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $a130d9e691a5988d$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $a130d9e691a5988d$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $a130d9e691a5988d$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $367ab585cb12ed65$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $367ab585cb12ed65$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $367ab585cb12ed65$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $367ab585cb12ed65$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $367ab585cb12ed65$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $367ab585cb12ed65$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $367ab585cb12ed65$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $367ab585cb12ed65$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $367ab585cb12ed65$var$scaleClip(xScale, allowedOverflow);
    const y = $367ab585cb12ed65$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $367ab585cb12ed65$var$toClip(value) {
    let t, r, b, l;
    if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $367ab585cb12ed65$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $367ab585cb12ed65$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $a130d9e691a5988d$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(value) === (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $367ab585cb12ed65$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === "x" ? "x" : "y";
    const vAxisKey = vScale.axis === "x" ? "x" : "y";
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $367ab585cb12ed65$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $367ab585cb12ed65$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $367ab585cb12ed65$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $367ab585cb12ed65$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $367ab585cb12ed65$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $367ab585cb12ed65$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $367ab585cb12ed65$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $367ab585cb12ed65$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $367ab585cb12ed65$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $367ab585cb12ed65$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $367ab585cb12ed65$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $367ab585cb12ed65$var$createDatasetContext(parent, index) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $367ab585cb12ed65$var$createDataContext(parent, index, element) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $367ab585cb12ed65$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $367ab585cb12ed65$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $367ab585cb12ed65$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $367ab585cb12ed65$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $367ab585cb12ed65$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $367ab585cb12ed65$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $367ab585cb12ed65$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $367ab585cb12ed65$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(dataset.xAxisID, $367ab585cb12ed65$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(dataset.yAxisID, $367ab585cb12ed65$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(dataset.rAxisID, $367ab585cb12ed65$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $a130d9e691a5988d$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $367ab585cb12ed65$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $367ab585cb12ed65$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $a130d9e691a5988d$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $367ab585cb12ed65$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $a130d9e691a5988d$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $367ab585cb12ed65$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $367ab585cb12ed65$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $367ab585cb12ed65$var$updateStacks(this, meta._parsed);
            meta._stacked = $367ab585cb12ed65$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $367ab585cb12ed65$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $a130d9e691a5988d$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $a130d9e691a5988d$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $367ab585cb12ed65$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $367ab585cb12ed65$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $367ab585cb12ed65$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $367ab585cb12ed65$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $367ab585cb12ed65$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $a130d9e691a5988d$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $a130d9e691a5988d$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $367ab585cb12ed65$var$toClip((0, $a130d9e691a5988d$export$90a7f3efeed30595)(this.options.clip, $367ab585cb12ed65$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $367ab585cb12ed65$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $367ab585cb12ed65$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $a130d9e691a5988d$export$dda1d9f60106f0e9)(index);
        if (cached) return $367ab585cb12ed65$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $a130d9e691a5988d$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($367ab585cb12ed65$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $367ab585cb12ed65$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $367ab585cb12ed65$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($367ab585cb12ed65$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$367ab585cb12ed65$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $367ab585cb12ed65$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
function $367ab585cb12ed65$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $a130d9e691a5988d$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $367ab585cb12ed65$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $367ab585cb12ed65$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $a130d9e691a5988d$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $367ab585cb12ed65$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $367ab585cb12ed65$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $367ab585cb12ed65$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $367ab585cb12ed65$var$parseValue(entry, item, vScale, i) {
    if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(entry)) $367ab585cb12ed65$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $367ab585cb12ed65$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($367ab585cb12ed65$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $367ab585cb12ed65$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $367ab585cb12ed65$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $367ab585cb12ed65$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $367ab585cb12ed65$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $367ab585cb12ed65$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$367ab585cb12ed65$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$367ab585cb12ed65$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $367ab585cb12ed65$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $367ab585cb12ed65$var$swap(edge, a, b);
        edge = $367ab585cb12ed65$var$startEnd(edge, b, a);
    } else edge = $367ab585cb12ed65$var$startEnd(edge, a, b);
    return edge;
}
function $367ab585cb12ed65$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $367ab585cb12ed65$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $367ab585cb12ed65$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $367ab585cb12ed65$export$e97d5dc64e999004 extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "bar";
    static defaults = {
        datasetElementType: false,
        dataElementType: "bar",
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $367ab585cb12ed65$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $367ab585cb12ed65$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $a130d9e691a5988d$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($367ab585cb12ed65$var$parseValue((0, $a130d9e691a5988d$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $367ab585cb12ed65$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $a130d9e691a5988d$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $367ab585cb12ed65$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $367ab585cb12ed65$var$setBorderSkipped(properties, options, stack, index);
            $367ab585cb12ed65$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $367ab585cb12ed65$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $367ab585cb12ed65$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(value) !== (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $a130d9e691a5988d$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $367ab585cb12ed65$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $367ab585cb12ed65$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $367ab585cb12ed65$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $367ab585cb12ed65$export$19b5c4773f17abe extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "bubble";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $a130d9e691a5988d$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $367ab585cb12ed65$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $a130d9e691a5988d$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $a130d9e691a5988d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $a130d9e691a5988d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $a130d9e691a5988d$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $a130d9e691a5988d$export$56c0d5a1e737357d) + (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $367ab585cb12ed65$export$e04603e7d8b77172 extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "doughnut";
    static defaults = {
        datasetElementType: false,
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    };
    static descriptors = {
        _scriptable: (name)=>name !== "spacing",
        _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $a130d9e691a5988d$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $a130d9e691a5988d$export$971d5caa766a69d7);
        let max = -(0, $a130d9e691a5988d$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $a130d9e691a5988d$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $367ab585cb12ed65$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $a130d9e691a5988d$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $a130d9e691a5988d$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $a130d9e691a5988d$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $a130d9e691a5988d$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $a130d9e691a5988d$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $367ab585cb12ed65$export$3c9b5d28c11cbfd0 extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "line";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $a130d9e691a5988d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $a130d9e691a5988d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $a130d9e691a5988d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $a130d9e691a5988d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $367ab585cb12ed65$export$2a270b3a0d973c85 extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "polarArea";
    static defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $a130d9e691a5988d$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $a130d9e691a5988d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $a130d9e691a5988d$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $367ab585cb12ed65$export$b21a3f1286706191 extends $367ab585cb12ed65$export$e04603e7d8b77172 {
    static id = "pie";
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
}
class $367ab585cb12ed65$export$48dbc6ac651bf8be extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "radar";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: true,
        elements: {
            line: {
                fill: "start"
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $a130d9e691a5988d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $367ab585cb12ed65$export$b2f2bae6713db87 extends $367ab585cb12ed65$export$75572ec5c55b4048 {
    static id = "scatter";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $a130d9e691a5988d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $a130d9e691a5988d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $a130d9e691a5988d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $a130d9e691a5988d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $367ab585cb12ed65$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $367ab585cb12ed65$export$e97d5dc64e999004,
    BubbleController: $367ab585cb12ed65$export$19b5c4773f17abe,
    DoughnutController: $367ab585cb12ed65$export$e04603e7d8b77172,
    LineController: $367ab585cb12ed65$export$3c9b5d28c11cbfd0,
    PieController: $367ab585cb12ed65$export$b21a3f1286706191,
    PolarAreaController: $367ab585cb12ed65$export$2a270b3a0d973c85,
    RadarController: $367ab585cb12ed65$export$48dbc6ac651bf8be,
    ScatterController: $367ab585cb12ed65$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $367ab585cb12ed65$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $367ab585cb12ed65$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($367ab585cb12ed65$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $367ab585cb12ed65$var$abstract();
    }
    parse() {
        return $367ab585cb12ed65$var$abstract();
    }
    format() {
        return $367ab585cb12ed65$var$abstract();
    }
    add() {
        return $367ab585cb12ed65$var$abstract();
    }
    diff() {
        return $367ab585cb12ed65$var$abstract();
    }
    startOf() {
        return $367ab585cb12ed65$var$abstract();
    }
    endOf() {
        return $367ab585cb12ed65$var$abstract();
    }
}
var $367ab585cb12ed65$export$f32766ea09ec8bc4 = {
    _date: $367ab585cb12ed65$var$DateAdapterBase
};
function $367ab585cb12ed65$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $a130d9e691a5988d$export$ebd11618f299a286) : (0, $a130d9e691a5988d$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $367ab585cb12ed65$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $367ab585cb12ed65$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $367ab585cb12ed65$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $367ab585cb12ed65$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $a130d9e691a5988d$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $367ab585cb12ed65$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $367ab585cb12ed65$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $a130d9e691a5988d$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $a130d9e691a5988d$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $367ab585cb12ed65$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $367ab585cb12ed65$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $367ab585cb12ed65$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $367ab585cb12ed65$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $367ab585cb12ed65$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $367ab585cb12ed65$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $367ab585cb12ed65$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $367ab585cb12ed65$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $367ab585cb12ed65$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $367ab585cb12ed65$export$a13296960cae0384 = {
    evaluateInteractionItems: $367ab585cb12ed65$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $367ab585cb12ed65$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $367ab585cb12ed65$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $367ab585cb12ed65$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $367ab585cb12ed65$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $367ab585cb12ed65$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $367ab585cb12ed65$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            return $367ab585cb12ed65$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $a130d9e691a5988d$export$df995fae86a55f06)(e, chart);
            return $367ab585cb12ed65$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $367ab585cb12ed65$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $367ab585cb12ed65$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $367ab585cb12ed65$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$367ab585cb12ed65$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $367ab585cb12ed65$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $367ab585cb12ed65$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $367ab585cb12ed65$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$367ab585cb12ed65$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $367ab585cb12ed65$var$setLayoutDims(layouts, params) {
    const stacks = $367ab585cb12ed65$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $367ab585cb12ed65$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $367ab585cb12ed65$var$wrapBoxes(boxes);
    const fullSize = $367ab585cb12ed65$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $367ab585cb12ed65$var$sortByWeight($367ab585cb12ed65$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $367ab585cb12ed65$var$sortByWeight($367ab585cb12ed65$var$filterByPosition(layoutBoxes, "right"));
    const top = $367ab585cb12ed65$var$sortByWeight($367ab585cb12ed65$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $367ab585cb12ed65$var$sortByWeight($367ab585cb12ed65$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $367ab585cb12ed65$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $367ab585cb12ed65$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $367ab585cb12ed65$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $367ab585cb12ed65$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $367ab585cb12ed65$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $367ab585cb12ed65$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $a130d9e691a5988d$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $367ab585cb12ed65$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $367ab585cb12ed65$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $367ab585cb12ed65$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $367ab585cb12ed65$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $367ab585cb12ed65$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $367ab585cb12ed65$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $367ab585cb12ed65$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $367ab585cb12ed65$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $367ab585cb12ed65$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $367ab585cb12ed65$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $367ab585cb12ed65$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $a130d9e691a5988d$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $367ab585cb12ed65$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $367ab585cb12ed65$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $a130d9e691a5988d$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $367ab585cb12ed65$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $367ab585cb12ed65$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $367ab585cb12ed65$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $367ab585cb12ed65$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $a130d9e691a5988d$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $367ab585cb12ed65$var$updateMaxPadding(maxPadding, (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $367ab585cb12ed65$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $367ab585cb12ed65$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $367ab585cb12ed65$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($367ab585cb12ed65$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $367ab585cb12ed65$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $367ab585cb12ed65$var$handleMaxPadding(chartArea);
        $367ab585cb12ed65$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $367ab585cb12ed65$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $a130d9e691a5988d$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $367ab585cb12ed65$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $367ab585cb12ed65$export$a40a96b24b46cf35 extends $367ab585cb12ed65$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $367ab585cb12ed65$var$EXPANDO_KEY = "$chartjs";
const $367ab585cb12ed65$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $367ab585cb12ed65$var$isNullOrEmpty = (value)=>value === null || value === "";
function $367ab585cb12ed65$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$367ab585cb12ed65$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($367ab585cb12ed65$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $a130d9e691a5988d$export$b4171a6734a65d42)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($367ab585cb12ed65$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $a130d9e691a5988d$export$b4171a6734a65d42)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $367ab585cb12ed65$var$eventListenerOptions = (0, $a130d9e691a5988d$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $367ab585cb12ed65$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $367ab585cb12ed65$var$eventListenerOptions);
}
function $367ab585cb12ed65$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $367ab585cb12ed65$var$eventListenerOptions);
}
function $367ab585cb12ed65$var$fromNativeEvent(event, chart) {
    const type = $367ab585cb12ed65$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $a130d9e691a5988d$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $367ab585cb12ed65$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $367ab585cb12ed65$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $367ab585cb12ed65$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$367ab585cb12ed65$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $367ab585cb12ed65$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $367ab585cb12ed65$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$367ab585cb12ed65$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $367ab585cb12ed65$var$drpListeningCharts = new Map();
let $367ab585cb12ed65$var$oldDevicePixelRatio = 0;
function $367ab585cb12ed65$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $367ab585cb12ed65$var$oldDevicePixelRatio) return;
    $367ab585cb12ed65$var$oldDevicePixelRatio = dpr;
    $367ab585cb12ed65$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $367ab585cb12ed65$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$367ab585cb12ed65$var$drpListeningCharts.size) window.addEventListener("resize", $367ab585cb12ed65$var$onWindowResize);
    $367ab585cb12ed65$var$drpListeningCharts.set(chart, resize);
}
function $367ab585cb12ed65$var$unlistenDevicePixelRatioChanges(chart) {
    $367ab585cb12ed65$var$drpListeningCharts.delete(chart);
    if (!$367ab585cb12ed65$var$drpListeningCharts.size) window.removeEventListener("resize", $367ab585cb12ed65$var$onWindowResize);
}
function $367ab585cb12ed65$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $a130d9e691a5988d$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $a130d9e691a5988d$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $367ab585cb12ed65$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $367ab585cb12ed65$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $367ab585cb12ed65$var$unlistenDevicePixelRatioChanges(chart);
}
function $367ab585cb12ed65$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $a130d9e691a5988d$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($367ab585cb12ed65$var$fromNativeEvent(event, chart));
    }, chart);
    $367ab585cb12ed65$var$addListener(canvas, type, proxy);
    return proxy;
}
class $367ab585cb12ed65$export$f02da7f882cf6b2e extends $367ab585cb12ed65$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $367ab585cb12ed65$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$367ab585cb12ed65$var$EXPANDO_KEY]) return false;
        const initial = canvas[$367ab585cb12ed65$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$367ab585cb12ed65$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $367ab585cb12ed65$var$createAttachObserver,
            detach: $367ab585cb12ed65$var$createDetachObserver,
            resize: $367ab585cb12ed65$var$createResizeObserver
        };
        const handler = handlers[type] || $367ab585cb12ed65$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $367ab585cb12ed65$var$releaseObserver,
            detach: $367ab585cb12ed65$var$releaseObserver,
            resize: $367ab585cb12ed65$var$releaseObserver
        };
        const handler = handlers[type] || $367ab585cb12ed65$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $a130d9e691a5988d$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $a130d9e691a5988d$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $367ab585cb12ed65$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $a130d9e691a5988d$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $367ab585cb12ed65$export$a40a96b24b46cf35;
    return $367ab585cb12ed65$export$f02da7f882cf6b2e;
}
class $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $a130d9e691a5988d$export$d141bba7fdc215a3)(this.x) && (0, $a130d9e691a5988d$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $367ab585cb12ed65$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $367ab585cb12ed65$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $367ab585cb12ed65$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $367ab585cb12ed65$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $367ab585cb12ed65$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $367ab585cb12ed65$var$skip(ticks, newTicks, spacing, (0, $a130d9e691a5988d$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$367ab585cb12ed65$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $367ab585cb12ed65$var$skip(ticks, newTicks, spacing, last, (0, $a130d9e691a5988d$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $367ab585cb12ed65$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $367ab585cb12ed65$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $367ab585cb12ed65$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $367ab585cb12ed65$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $a130d9e691a5988d$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $367ab585cb12ed65$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $367ab585cb12ed65$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $367ab585cb12ed65$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $a130d9e691a5988d$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $367ab585cb12ed65$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $367ab585cb12ed65$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $367ab585cb12ed65$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const $367ab585cb12ed65$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $367ab585cb12ed65$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $367ab585cb12ed65$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $367ab585cb12ed65$var$garbageCollect(caches, length) {
    (0, $a130d9e691a5988d$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $367ab585cb12ed65$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $367ab585cb12ed65$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $367ab585cb12ed65$var$createScaleContext(parent, scale) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $367ab585cb12ed65$var$createTickContext(parent, index, tick) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $367ab585cb12ed65$var$titleAlign(align, position, reverse) {
    let ret = (0, $a130d9e691a5988d$export$3c2fa207a37baaea)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $367ab585cb12ed65$var$reverseAlign(ret);
    return ret;
}
function $367ab585cb12ed65$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $367ab585cb12ed65$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $367ab585cb12ed65$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === "left" ? -(0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd) : (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $367ab585cb12ed65$export$d60cfc58d3c358b6 extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $a130d9e691a5988d$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $a130d9e691a5988d$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $a130d9e691a5988d$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $a130d9e691a5988d$export$c4ce752e73470fba)(min, (0, $a130d9e691a5988d$export$c4ce752e73470fba)(max, min)),
            max: (0, $a130d9e691a5988d$export$c4ce752e73470fba)(max, (0, $a130d9e691a5988d$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $a130d9e691a5988d$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $367ab585cb12ed65$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $367ab585cb12ed65$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $367ab585cb12ed65$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $a130d9e691a5988d$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $367ab585cb12ed65$var$getTickMarkLength(options.grid) - tickOpts.padding - $367ab585cb12ed65$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $a130d9e691a5988d$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $a130d9e691a5988d$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $a130d9e691a5988d$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $a130d9e691a5988d$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $367ab585cb12ed65$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $367ab585cb12ed65$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $367ab585cb12ed65$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $367ab585cb12ed65$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $367ab585cb12ed65$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(label) && !(0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(label)) {
                width = (0, $a130d9e691a5988d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(nestedLabel) && !(0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $a130d9e691a5988d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $367ab585cb12ed65$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $a130d9e691a5988d$export$71cec2538cb2c617)(this._alignToPixels ? (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $367ab585cb12ed65$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $367ab585cb12ed65$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $367ab585cb12ed65$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $367ab585cb12ed65$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $367ab585cb12ed65$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $a130d9e691a5988d$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $a130d9e691a5988d$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $a130d9e691a5988d$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $a130d9e691a5988d$export$34aec0b863436764)(title.font);
        const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $a130d9e691a5988d$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $367ab585cb12ed65$var$titleArgs(this, offset, position, align);
        (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $367ab585cb12ed65$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $367ab585cb12ed65$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $a130d9e691a5988d$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $367ab585cb12ed65$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($367ab585cb12ed65$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $367ab585cb12ed65$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $a130d9e691a5988d$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $a130d9e691a5988d$export$4368d992c4eafac0)[scope]) {
            delete (0, $a130d9e691a5988d$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $a130d9e691a5988d$export$6559d589eb85fbb6)[id];
        }
    }
}
function $367ab585cb12ed65$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $a130d9e691a5988d$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $a130d9e691a5988d$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $a130d9e691a5988d$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $a130d9e691a5988d$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $367ab585cb12ed65$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $a130d9e691a5988d$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $367ab585cb12ed65$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $a130d9e691a5988d$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $367ab585cb12ed65$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $367ab585cb12ed65$var$Registry {
    constructor(){
        this.controllers = new $367ab585cb12ed65$var$TypedRegistry($367ab585cb12ed65$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $367ab585cb12ed65$var$TypedRegistry($367ab585cb12ed65$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $367ab585cb12ed65$var$TypedRegistry(Object, "plugins");
        this.scales = new $367ab585cb12ed65$var$TypedRegistry($367ab585cb12ed65$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $a130d9e691a5988d$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $a130d9e691a5988d$export$a8550f7dbe79f93a)(method);
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $367ab585cb12ed65$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $367ab585cb12ed65$var$Registry();
class $367ab585cb12ed65$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $a130d9e691a5988d$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $367ab585cb12ed65$var$allPlugins(config);
        return options === false && !all ? [] : $367ab585cb12ed65$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $367ab585cb12ed65$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($367ab585cb12ed65$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($367ab585cb12ed65$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $367ab585cb12ed65$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $367ab585cb12ed65$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $367ab585cb12ed65$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $367ab585cb12ed65$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $367ab585cb12ed65$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $367ab585cb12ed65$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $a130d9e691a5988d$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $367ab585cb12ed65$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $367ab585cb12ed65$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $367ab585cb12ed65$var$idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function $367ab585cb12ed65$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $367ab585cb12ed65$var$determineAxis(id, ...scaleOptions) {
    if ($367ab585cb12ed65$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $367ab585cb12ed65$var$axisFromPosition(opts.position) || id.length > 1 && $367ab585cb12ed65$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $367ab585cb12ed65$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis: axis
    };
}
function $367ab585cb12ed65$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $367ab585cb12ed65$var$getAxisFromDataset(id, "x", boundDs[0]) || $367ab585cb12ed65$var$getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function $367ab585cb12ed65$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $a130d9e691a5988d$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $367ab585cb12ed65$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $a130d9e691a5988d$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $367ab585cb12ed65$var$determineAxis(id, scaleConf, $367ab585cb12ed65$var$retrieveAxisFromDatasets(id, config), (0, $a130d9e691a5988d$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $367ab585cb12ed65$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $a130d9e691a5988d$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $367ab585cb12ed65$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $a130d9e691a5988d$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $367ab585cb12ed65$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $a130d9e691a5988d$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $a130d9e691a5988d$export$555508cbc6add439)(scale, [
            (0, $a130d9e691a5988d$export$4368d992c4eafac0).scales[scale.type],
            (0, $a130d9e691a5988d$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $367ab585cb12ed65$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $367ab585cb12ed65$var$mergeScaleConfig(config, options);
}
function $367ab585cb12ed65$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $367ab585cb12ed65$var$initConfig(config) {
    config = config || {};
    config.data = $367ab585cb12ed65$var$initData(config.data);
    $367ab585cb12ed65$var$initOptions(config);
    return config;
}
const $367ab585cb12ed65$var$keyCache = new Map();
const $367ab585cb12ed65$var$keysCached = new Set();
function $367ab585cb12ed65$var$cachedKeys(cacheKey, generate) {
    let keys = $367ab585cb12ed65$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $367ab585cb12ed65$var$keyCache.set(cacheKey, keys);
        $367ab585cb12ed65$var$keysCached.add(keys);
    }
    return keys;
}
const $367ab585cb12ed65$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $a130d9e691a5988d$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $367ab585cb12ed65$var$Config {
    constructor(config){
        this._config = $367ab585cb12ed65$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $367ab585cb12ed65$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $367ab585cb12ed65$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $367ab585cb12ed65$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $367ab585cb12ed65$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $367ab585cb12ed65$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $367ab585cb12ed65$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$367ab585cb12ed65$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$367ab585cb12ed65$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$367ab585cb12ed65$var$addIfFound(scopes, (0, $a130d9e691a5988d$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$367ab585cb12ed65$var$addIfFound(scopes, (0, $a130d9e691a5988d$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$367ab585cb12ed65$var$addIfFound(scopes, (0, $a130d9e691a5988d$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($367ab585cb12ed65$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $a130d9e691a5988d$export$6559d589eb85fbb6)[type] || {},
            (0, $a130d9e691a5988d$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $a130d9e691a5988d$export$4368d992c4eafac0),
            (0, $a130d9e691a5988d$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $367ab585cb12ed65$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($367ab585cb12ed65$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $a130d9e691a5988d$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $a130d9e691a5988d$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $367ab585cb12ed65$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $a130d9e691a5988d$export$23f2a1d2818174ef)(context) ? (0, $a130d9e691a5988d$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $367ab585cb12ed65$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $a130d9e691a5988d$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $367ab585cb12ed65$var$hasFunction = (value)=>(0, $a130d9e691a5988d$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $a130d9e691a5988d$export$a93c5207d687da10)(value[key]));
function $367ab585cb12ed65$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $a130d9e691a5988d$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $a130d9e691a5988d$export$a93c5207d687da10)(value) || $367ab585cb12ed65$var$hasFunction(value)) || indexable && (0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $367ab585cb12ed65$var$version = "4.4.9";
const $367ab585cb12ed65$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $367ab585cb12ed65$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $367ab585cb12ed65$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $367ab585cb12ed65$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $367ab585cb12ed65$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $367ab585cb12ed65$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $367ab585cb12ed65$var$getCanvas(item) {
    if ((0, $a130d9e691a5988d$export$3a1a48c8f6ef640e)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $367ab585cb12ed65$var$instances = {};
const $367ab585cb12ed65$var$getChart = (key)=>{
    const canvas = $367ab585cb12ed65$var$getCanvas(key);
    return Object.values($367ab585cb12ed65$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $367ab585cb12ed65$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $367ab585cb12ed65$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $367ab585cb12ed65$export$acaa6426d77a227e {
    static defaults = (0, $a130d9e691a5988d$export$4368d992c4eafac0);
    static instances = $367ab585cb12ed65$var$instances;
    static overrides = (0, $a130d9e691a5988d$export$6559d589eb85fbb6);
    static registry = $367ab585cb12ed65$export$4bb7493d241fd8a5;
    static version = $367ab585cb12ed65$var$version;
    static getChart = $367ab585cb12ed65$var$getChart;
    static register(...items) {
        $367ab585cb12ed65$export$4bb7493d241fd8a5.add(...items);
        $367ab585cb12ed65$var$invalidatePlugins();
    }
    static unregister(...items) {
        $367ab585cb12ed65$export$4bb7493d241fd8a5.remove(...items);
        $367ab585cb12ed65$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $367ab585cb12ed65$var$Config(userConfig);
        const initialCanvas = $367ab585cb12ed65$var$getCanvas(item);
        const existingChart = $367ab585cb12ed65$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $367ab585cb12ed65$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $a130d9e691a5988d$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $367ab585cb12ed65$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $a130d9e691a5988d$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $367ab585cb12ed65$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $367ab585cb12ed65$export$a424a0aa8f687495.listen(this, "complete", $367ab585cb12ed65$var$onAnimationsComplete);
        $367ab585cb12ed65$export$a424a0aa8f687495.listen(this, "progress", $367ab585cb12ed65$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $367ab585cb12ed65$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $a130d9e691a5988d$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $a130d9e691a5988d$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $367ab585cb12ed65$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$367ab585cb12ed65$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $a130d9e691a5988d$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $a130d9e691a5988d$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $367ab585cb12ed65$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $a130d9e691a5988d$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $367ab585cb12ed65$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $367ab585cb12ed65$var$positionIsHorizontal(scaleOptions.position, axis) !== $367ab585cb12ed65$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $367ab585cb12ed65$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $a130d9e691a5988d$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $a130d9e691a5988d$export$d66501df72047452)(scales, (scale)=>{
            $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $367ab585cb12ed65$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($367ab585cb12ed65$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $367ab585cb12ed65$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $367ab585cb12ed65$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $a130d9e691a5988d$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $367ab585cb12ed65$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $367ab585cb12ed65$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $a130d9e691a5988d$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($367ab585cb12ed65$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.scales, (scale)=>{
            $367ab585cb12ed65$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $a130d9e691a5988d$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $367ab585cb12ed65$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $a130d9e691a5988d$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $367ab585cb12ed65$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $a130d9e691a5988d$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($367ab585cb12ed65$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$367ab585cb12ed65$export$a424a0aa8f687495.running(this)) $367ab585cb12ed65$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $367ab585cb12ed65$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $a130d9e691a5988d$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (clip) (0, $a130d9e691a5988d$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $a130d9e691a5988d$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $a130d9e691a5988d$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $367ab585cb12ed65$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $a130d9e691a5988d$export$35e795649ee09318)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $a130d9e691a5988d$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $367ab585cb12ed65$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $a130d9e691a5988d$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $367ab585cb12ed65$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $a130d9e691a5988d$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $a130d9e691a5988d$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $a130d9e691a5988d$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $a130d9e691a5988d$export$3b513254972cfc9c)(e);
        const lastEvent = $367ab585cb12ed65$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $a130d9e691a5988d$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $367ab585cb12ed65$var$invalidatePlugins() {
    return (0, $a130d9e691a5988d$export$d66501df72047452)($367ab585cb12ed65$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $367ab585cb12ed65$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd), startAngle - (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $367ab585cb12ed65$var$toRadiusCorners(value) {
    return (0, $a130d9e691a5988d$export$ab83b03e4111b1d0)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $367ab585cb12ed65$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $367ab585cb12ed65$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $a130d9e691a5988d$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $a130d9e691a5988d$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $a130d9e691a5988d$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $367ab585cb12ed65$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $367ab585cb12ed65$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $a130d9e691a5988d$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $367ab585cb12ed65$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $367ab585cb12ed65$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $367ab585cb12ed65$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $367ab585cb12ed65$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $367ab585cb12ed65$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $367ab585cb12ed65$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $367ab585cb12ed65$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $367ab585cb12ed65$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $367ab585cb12ed65$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $a130d9e691a5988d$export$971d5caa766a69d7) || (0, $a130d9e691a5988d$export$971d5caa766a69d7));
    }
    $367ab585cb12ed65$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $367ab585cb12ed65$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $367ab585cb12ed65$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $a130d9e691a5988d$export$971d5caa766a69d7) || (0, $a130d9e691a5988d$export$971d5caa766a69d7));
    }
    if (inner) $367ab585cb12ed65$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $367ab585cb12ed65$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $367ab585cb12ed65$export$d48203c759d6a1fc extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static id = "arc";
    static defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash"
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $a130d9e691a5988d$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $a130d9e691a5988d$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $a130d9e691a5988d$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $a130d9e691a5988d$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $a130d9e691a5988d$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $a130d9e691a5988d$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $a130d9e691a5988d$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $367ab585cb12ed65$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $367ab585cb12ed65$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $367ab585cb12ed65$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $367ab585cb12ed65$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $367ab585cb12ed65$var$getLineMethod(options) {
    if (options.stepped) return 0, $a130d9e691a5988d$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $a130d9e691a5988d$export$493d36ec626b6698;
    return $367ab585cb12ed65$var$lineTo;
}
function $367ab585cb12ed65$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $367ab585cb12ed65$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $367ab585cb12ed65$var$pathVars(points, segment, params);
    const lineMethod = $367ab585cb12ed65$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $367ab585cb12ed65$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $367ab585cb12ed65$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $367ab585cb12ed65$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $367ab585cb12ed65$var$fastPathSegment : $367ab585cb12ed65$var$pathSegment;
}
function $367ab585cb12ed65$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $a130d9e691a5988d$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $a130d9e691a5988d$export$8a5498727ef6be21;
    return 0, $a130d9e691a5988d$export$d24c54395ce0c509;
}
function $367ab585cb12ed65$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $367ab585cb12ed65$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $367ab585cb12ed65$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $367ab585cb12ed65$var$_getSegmentMethod(line);
    for (const segment of segments){
        $367ab585cb12ed65$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $367ab585cb12ed65$var$usePath2D = typeof Path2D === "function";
function $367ab585cb12ed65$var$draw(ctx, line, start, count) {
    if ($367ab585cb12ed65$var$usePath2D && !line.options.segment) $367ab585cb12ed65$var$strokePathWithCache(ctx, line, start, count);
    else $367ab585cb12ed65$var$strokePathDirect(ctx, line, start, count);
}
class $367ab585cb12ed65$export$55e463fa7bcd3469 extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static id = "line";
    static defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: "default",
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash" && name !== "fill"
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $a130d9e691a5988d$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $a130d9e691a5988d$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $a130d9e691a5988d$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $367ab585cb12ed65$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $367ab585cb12ed65$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $367ab585cb12ed65$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $367ab585cb12ed65$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $367ab585cb12ed65$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $367ab585cb12ed65$export$bd159b522b230b7a extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static id = "point";
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $367ab585cb12ed65$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $367ab585cb12ed65$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $a130d9e691a5988d$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $a130d9e691a5988d$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $367ab585cb12ed65$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $367ab585cb12ed65$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $a130d9e691a5988d$export$25ce5a424b770e84)(value, min, max);
}
function $367ab585cb12ed65$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $a130d9e691a5988d$export$92108d983e8ee699)(value);
    return {
        t: $367ab585cb12ed65$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $367ab585cb12ed65$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $367ab585cb12ed65$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $367ab585cb12ed65$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $367ab585cb12ed65$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $a130d9e691a5988d$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $367ab585cb12ed65$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $367ab585cb12ed65$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $367ab585cb12ed65$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $367ab585cb12ed65$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $367ab585cb12ed65$var$boundingRects(bar) {
    const bounds = $367ab585cb12ed65$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $367ab585cb12ed65$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $367ab585cb12ed65$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $367ab585cb12ed65$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $367ab585cb12ed65$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $a130d9e691a5988d$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $a130d9e691a5988d$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $367ab585cb12ed65$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $367ab585cb12ed65$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $367ab585cb12ed65$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $367ab585cb12ed65$export$a16ed71bf4b07672 extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static id = "bar";
    static defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $367ab585cb12ed65$var$boundingRects(this);
        const addRectPath = $367ab585cb12ed65$var$hasRadius(outer.radius) ? (0, $a130d9e691a5988d$export$d66dc83d8cfc8dd) : $367ab585cb12ed65$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $367ab585cb12ed65$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $367ab585cb12ed65$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $367ab585cb12ed65$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $367ab585cb12ed65$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $367ab585cb12ed65$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $367ab585cb12ed65$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
var $367ab585cb12ed65$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $367ab585cb12ed65$export$d48203c759d6a1fc,
    BarElement: $367ab585cb12ed65$export$a16ed71bf4b07672,
    LineElement: $367ab585cb12ed65$export$55e463fa7bcd3469,
    PointElement: $367ab585cb12ed65$export$bd159b522b230b7a
});
const $367ab585cb12ed65$var$BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const $367ab585cb12ed65$var$BACKGROUND_COLORS = /* #__PURE__ */ $367ab585cb12ed65$var$BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function $367ab585cb12ed65$var$getBorderColor(i) {
    return $367ab585cb12ed65$var$BORDER_COLORS[i % $367ab585cb12ed65$var$BORDER_COLORS.length];
}
function $367ab585cb12ed65$var$getBackgroundColor(i) {
    return $367ab585cb12ed65$var$BACKGROUND_COLORS[i % $367ab585cb12ed65$var$BACKGROUND_COLORS.length];
}
function $367ab585cb12ed65$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $367ab585cb12ed65$var$getBorderColor(i);
    dataset.backgroundColor = $367ab585cb12ed65$var$getBackgroundColor(i);
    return ++i;
}
function $367ab585cb12ed65$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$367ab585cb12ed65$var$getBorderColor(i++));
    return i;
}
function $367ab585cb12ed65$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$367ab585cb12ed65$var$getBackgroundColor(i++));
    return i;
}
function $367ab585cb12ed65$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $367ab585cb12ed65$export$e04603e7d8b77172) i = $367ab585cb12ed65$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $367ab585cb12ed65$export$2a270b3a0d973c85) i = $367ab585cb12ed65$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $367ab585cb12ed65$var$colorizeDefaultDataset(dataset, i);
    };
}
function $367ab585cb12ed65$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $367ab585cb12ed65$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $367ab585cb12ed65$var$containsDefaultColorsDefenitions() {
    return (0, $a130d9e691a5988d$export$4368d992c4eafac0).borderColor !== "rgba(0,0,0,0.1)" || (0, $a130d9e691a5988d$export$4368d992c4eafac0).backgroundColor !== "rgba(0,0,0,0.1)";
}
var $367ab585cb12ed65$export$c537fa0d021d010b = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $367ab585cb12ed65$var$containsColorsDefinitions(datasets) || $367ab585cb12ed65$var$containsColorsDefinition(chartOptions) || elements && $367ab585cb12ed65$var$containsColorsDefinitions(elements) || $367ab585cb12ed65$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $367ab585cb12ed65$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $367ab585cb12ed65$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $367ab585cb12ed65$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(minIndex) && !(0, $a130d9e691a5988d$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $367ab585cb12ed65$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $367ab585cb12ed65$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $367ab585cb12ed65$var$cleanDecimatedDataset(dataset);
    });
}
function $367ab585cb12ed65$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $a130d9e691a5988d$export$25ce5a424b770e84)((0, $a130d9e691a5988d$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $a130d9e691a5988d$export$25ce5a424b770e84)((0, $a130d9e691a5988d$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $367ab585cb12ed65$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $367ab585cb12ed65$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $a130d9e691a5988d$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $367ab585cb12ed65$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $367ab585cb12ed65$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $367ab585cb12ed65$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $367ab585cb12ed65$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $367ab585cb12ed65$var$cleanDecimatedData(chart);
    }
};
function $367ab585cb12ed65$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $367ab585cb12ed65$var$_findSegmentEnd(start, end, points);
        const bounds = $367ab585cb12ed65$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $a130d9e691a5988d$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $367ab585cb12ed65$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $a130d9e691a5988d$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $367ab585cb12ed65$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $367ab585cb12ed65$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $367ab585cb12ed65$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $a130d9e691a5988d$export$3d12bd131bb975d1)(start);
        end = (0, $a130d9e691a5988d$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $367ab585cb12ed65$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $367ab585cb12ed65$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $367ab585cb12ed65$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $367ab585cb12ed65$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $367ab585cb12ed65$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $367ab585cb12ed65$var$_pointsFromSegments(boundary, line);
    return points.length ? new $367ab585cb12ed65$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $367ab585cb12ed65$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $367ab585cb12ed65$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $a130d9e691a5988d$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $367ab585cb12ed65$var$_decodeFill(line, index, count) {
    const fill = $367ab585cb12ed65$var$parseFillOption(line);
    if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $a130d9e691a5988d$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $367ab585cb12ed65$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $367ab585cb12ed65$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $367ab585cb12ed65$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $367ab585cb12ed65$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $a130d9e691a5988d$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $367ab585cb12ed65$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $367ab585cb12ed65$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $367ab585cb12ed65$var$getLinesBelow(scale, index);
    linesBelow.push($367ab585cb12ed65$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$367ab585cb12ed65$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $367ab585cb12ed65$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $367ab585cb12ed65$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $367ab585cb12ed65$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $367ab585cb12ed65$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $367ab585cb12ed65$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $a130d9e691a5988d$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $367ab585cb12ed65$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $a130d9e691a5988d$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $367ab585cb12ed65$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $a130d9e691a5988d$export$39b482c5e57630a8)(fill)) return $367ab585cb12ed65$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $367ab585cb12ed65$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $367ab585cb12ed65$var$computeBoundary(source);
    if (boundary instanceof $367ab585cb12ed65$var$simpleArc) return boundary;
    return $367ab585cb12ed65$var$_createBoundaryLine(boundary, line);
}
function $367ab585cb12ed65$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $367ab585cb12ed65$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $367ab585cb12ed65$var$computeCircularBoundary(source);
    return $367ab585cb12ed65$var$computeLinearBoundary(source);
}
function $367ab585cb12ed65$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $367ab585cb12ed65$var$_getTargetPixel(fill, scale);
    if ((0, $a130d9e691a5988d$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $367ab585cb12ed65$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $367ab585cb12ed65$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $367ab585cb12ed65$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $367ab585cb12ed65$var$_drawfill(ctx, source, area) {
    const target = $367ab585cb12ed65$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $a130d9e691a5988d$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $a130d9e691a5988d$export$8743009a87fcb00f)(ctx, area);
        $367ab585cb12ed65$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $a130d9e691a5988d$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $367ab585cb12ed65$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $367ab585cb12ed65$var$clipVertical(ctx, target, area.top);
        $367ab585cb12ed65$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property,
            clip: clip
        });
        ctx.restore();
        ctx.save();
        $367ab585cb12ed65$var$clipVertical(ctx, target, area.bottom);
    }
    $367ab585cb12ed65$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $367ab585cb12ed65$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$367ab585cb12ed65$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $367ab585cb12ed65$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $367ab585cb12ed65$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $367ab585cb12ed65$var$clipBounds(ctx, scale, clip, notShape && $367ab585cb12ed65$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $367ab585cb12ed65$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $367ab585cb12ed65$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $367ab585cb12ed65$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x" || property === "y") {
        let left, top, right, bottom;
        if (property === "x") {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $367ab585cb12ed65$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $367ab585cb12ed65$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $367ab585cb12ed65$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $367ab585cb12ed65$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $367ab585cb12ed65$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $367ab585cb12ed65$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($367ab585cb12ed65$var$_shouldApplyFill(source)) $367ab585cb12ed65$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$367ab585cb12ed65$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $367ab585cb12ed65$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $367ab585cb12ed65$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $367ab585cb12ed65$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $367ab585cb12ed65$var$Legend extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $367ab585cb12ed65$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $367ab585cb12ed65$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $a130d9e691a5988d$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $a130d9e691a5988d$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $a130d9e691a5988d$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $367ab585cb12ed65$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $a130d9e691a5988d$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $a130d9e691a5988d$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $a130d9e691a5988d$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $a130d9e691a5988d$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $a130d9e691a5988d$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $367ab585cb12ed65$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $a130d9e691a5988d$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $a130d9e691a5988d$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $a130d9e691a5988d$export$21579262ef46735b)(x, this.left, this.right) && (0, $a130d9e691a5988d$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $a130d9e691a5988d$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $a130d9e691a5988d$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$367ab585cb12ed65$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $367ab585cb12ed65$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $367ab585cb12ed65$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $367ab585cb12ed65$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $367ab585cb12ed65$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $367ab585cb12ed65$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $367ab585cb12ed65$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = $367ab585cb12ed65$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $367ab585cb12ed65$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $367ab585cb12ed65$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $367ab585cb12ed65$export$ed247974535929c7 = {
    id: "legend",
    _element: $367ab585cb12ed65$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $367ab585cb12ed65$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $367ab585cb12ed65$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $367ab585cb12ed65$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $367ab585cb12ed65$var$Title extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $a130d9e691a5988d$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $a130d9e691a5988d$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $a130d9e691a5988d$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $a130d9e691a5988d$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $a130d9e691a5988d$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $a130d9e691a5988d$export$3c2fa207a37baaea)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $367ab585cb12ed65$var$createTitle(chart, titleOpts) {
    const title = new $367ab585cb12ed65$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $367ab585cb12ed65$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $367ab585cb12ed65$export$f99233281efd08a0 = {
    id: "title",
    _element: $367ab585cb12ed65$var$Title,
    start (chart, _args, options) {
        $367ab585cb12ed65$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $367ab585cb12ed65$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $367ab585cb12ed65$var$map = new WeakMap();
var $367ab585cb12ed65$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $367ab585cb12ed65$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, title, options);
        $367ab585cb12ed65$export$1ecca0613f5e56d2.addBox(chart, title);
        $367ab585cb12ed65$var$map.set(chart, title);
    },
    stop (chart) {
        $367ab585cb12ed65$export$1ecca0613f5e56d2.removeBox(chart, $367ab585cb12ed65$var$map.get(chart));
        $367ab585cb12ed65$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $367ab585cb12ed65$var$map.get(chart);
        $367ab585cb12ed65$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $367ab585cb12ed65$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $a130d9e691a5988d$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $367ab585cb12ed65$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $367ab585cb12ed65$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $367ab585cb12ed65$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $367ab585cb12ed65$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $a130d9e691a5988d$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $a130d9e691a5988d$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $a130d9e691a5988d$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $a130d9e691a5988d$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $a130d9e691a5988d$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $a130d9e691a5988d$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $a130d9e691a5988d$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $367ab585cb12ed65$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $367ab585cb12ed65$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $367ab585cb12ed65$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($367ab585cb12ed65$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $367ab585cb12ed65$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $367ab585cb12ed65$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $367ab585cb12ed65$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $367ab585cb12ed65$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $367ab585cb12ed65$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $367ab585cb12ed65$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $367ab585cb12ed65$var$alignX(size, xAlign);
    const y = $367ab585cb12ed65$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $a130d9e691a5988d$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $a130d9e691a5988d$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $367ab585cb12ed65$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $367ab585cb12ed65$var$getBeforeAfterBodyLines(callback) {
    return $367ab585cb12ed65$var$pushOrConcat([], $367ab585cb12ed65$var$splitNewlines(callback));
}
function $367ab585cb12ed65$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $367ab585cb12ed65$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $367ab585cb12ed65$var$defaultCallbacks = {
    beforeTitle: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    beforeBody: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    beforeLabel: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    afterBody: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    beforeFooter: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    footer: (0, $a130d9e691a5988d$export$53a70dd1ebbae346),
    afterFooter: (0, $a130d9e691a5988d$export$53a70dd1ebbae346)
};
function $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return $367ab585cb12ed65$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $367ab585cb12ed65$var$Tooltip extends $367ab585cb12ed65$export$db77ccec0bb4ccac {
    static positioners = $367ab585cb12ed65$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $367ab585cb12ed65$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $367ab585cb12ed65$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(beforeTitle));
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(title));
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $367ab585cb12ed65$var$getBeforeAfterBodyLines($367ab585cb12ed65$var$invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $a130d9e691a5988d$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $367ab585cb12ed65$var$overrideCallbacks(callbacks, context);
            $367ab585cb12ed65$var$pushOrConcat(bodyItem.before, $367ab585cb12ed65$var$splitNewlines($367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            $367ab585cb12ed65$var$pushOrConcat(bodyItem.lines, $367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "label", this, context));
            $367ab585cb12ed65$var$pushOrConcat(bodyItem.after, $367ab585cb12ed65$var$splitNewlines($367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $367ab585cb12ed65$var$getBeforeAfterBodyLines($367ab585cb12ed65$var$invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = $367ab585cb12ed65$var$invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(beforeFooter));
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(footer));
        lines = $367ab585cb12ed65$var$pushOrConcat(lines, $367ab585cb12ed65$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($367ab585cb12ed65$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $a130d9e691a5988d$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $367ab585cb12ed65$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push($367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push($367ab585cb12ed65$var$invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $367ab585cb12ed65$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $367ab585cb12ed65$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $367ab585cb12ed65$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $367ab585cb12ed65$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $367ab585cb12ed65$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.bodyFont);
        const colorX = $367ab585cb12ed65$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $a130d9e691a5988d$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $a130d9e691a5988d$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $a130d9e691a5988d$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $a130d9e691a5988d$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $a130d9e691a5988d$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $367ab585cb12ed65$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $a130d9e691a5988d$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $a130d9e691a5988d$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $a130d9e691a5988d$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $a130d9e691a5988d$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $367ab585cb12ed65$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $367ab585cb12ed65$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $367ab585cb12ed65$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $367ab585cb12ed65$var$determineAlignment(chart, options, positionAndSize);
            const point = $367ab585cb12ed65$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $a130d9e691a5988d$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $a130d9e691a5988d$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $a130d9e691a5988d$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $a130d9e691a5988d$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $367ab585cb12ed65$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $367ab585cb12ed65$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $367ab585cb12ed65$var$Tooltip,
    positioners: $367ab585cb12ed65$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $367ab585cb12ed65$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: $367ab585cb12ed65$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $367ab585cb12ed65$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $367ab585cb12ed65$export$c537fa0d021d010b,
    Decimation: $367ab585cb12ed65$export$be17f937e9aa7533,
    Filler: $367ab585cb12ed65$export$d19ba4d812bed757,
    Legend: $367ab585cb12ed65$export$ed247974535929c7,
    SubTitle: $367ab585cb12ed65$export$d5c56664638992a4,
    Title: $367ab585cb12ed65$export$f99233281efd08a0,
    Tooltip: $367ab585cb12ed65$export$28c660c63b792dea
});
const $367ab585cb12ed65$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $367ab585cb12ed65$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $367ab585cb12ed65$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $367ab585cb12ed65$var$validIndex = (index, max)=>index === null ? null : (0, $a130d9e691a5988d$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $367ab585cb12ed65$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $367ab585cb12ed65$export$29e663ba4d09fe7 extends $367ab585cb12ed65$export$d60cfc58d3c358b6 {
    static id = "category";
    static defaults = {
        ticks: {
            callback: $367ab585cb12ed65$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $367ab585cb12ed65$var$findOrAddLabel(labels, raw, (0, $a130d9e691a5988d$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $367ab585cb12ed65$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $367ab585cb12ed65$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $367ab585cb12ed65$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $a130d9e691a5988d$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $a130d9e691a5988d$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $a130d9e691a5988d$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $a130d9e691a5988d$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $a130d9e691a5988d$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $a130d9e691a5988d$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $a130d9e691a5988d$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $a130d9e691a5988d$export$91477dc880baac21)(spacing), (0, $a130d9e691a5988d$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $a130d9e691a5988d$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $a130d9e691a5988d$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $367ab585cb12ed65$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $a130d9e691a5988d$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $367ab585cb12ed65$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $367ab585cb12ed65$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $a130d9e691a5988d$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $367ab585cb12ed65$var$LinearScaleBase extends $367ab585cb12ed65$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $a130d9e691a5988d$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $367ab585cb12ed65$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $a130d9e691a5988d$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $a130d9e691a5988d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $367ab585cb12ed65$export$e7f4e5e8656f0b93 extends $367ab585cb12ed65$var$LinearScaleBase {
    static id = "linear";
    static defaults = {
        ticks: {
            callback: (0, $a130d9e691a5988d$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $367ab585cb12ed65$var$log10Floor = (v)=>Math.floor((0, $a130d9e691a5988d$export$faec65b429be379)(v));
const $367ab585cb12ed65$var$changeExponent = (v, m)=>Math.pow(10, $367ab585cb12ed65$var$log10Floor(v) + m);
function $367ab585cb12ed65$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $367ab585cb12ed65$var$log10Floor(tickVal));
    return remain === 1;
}
function $367ab585cb12ed65$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $367ab585cb12ed65$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $367ab585cb12ed65$var$log10Floor(range);
    while($367ab585cb12ed65$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($367ab585cb12ed65$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $367ab585cb12ed65$var$log10Floor(min));
}
function $367ab585cb12ed65$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $367ab585cb12ed65$var$log10Floor(min);
    let exp = $367ab585cb12ed65$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $367ab585cb12ed65$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $a130d9e691a5988d$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $367ab585cb12ed65$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $367ab585cb12ed65$export$85295eaf7cb3ac3e extends $367ab585cb12ed65$export$d60cfc58d3c358b6 {
    static id = "logarithmic";
    static defaults = {
        ticks: {
            callback: (0, $a130d9e691a5988d$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $367ab585cb12ed65$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $a130d9e691a5988d$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $a130d9e691a5988d$export$39b482c5e57630a8)(this._userMin)) this.min = min === $367ab585cb12ed65$var$changeExponent(this.min, 0) ? $367ab585cb12ed65$var$changeExponent(this.min, -1) : $367ab585cb12ed65$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($367ab585cb12ed65$var$changeExponent(min, -1));
                setMax($367ab585cb12ed65$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($367ab585cb12ed65$var$changeExponent(max, -1));
        if (max <= 0) setMax($367ab585cb12ed65$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $367ab585cb12ed65$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $a130d9e691a5988d$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $a130d9e691a5988d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $a130d9e691a5988d$export$faec65b429be379)(start);
        this._valueRange = (0, $a130d9e691a5988d$export$faec65b429be379)(this.max) - (0, $a130d9e691a5988d$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $a130d9e691a5988d$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $367ab585cb12ed65$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $a130d9e691a5988d$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $a130d9e691a5988d$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $367ab585cb12ed65$var$measureLabelSize(ctx, font, label) {
    label = (0, $a130d9e691a5988d$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $a130d9e691a5988d$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $367ab585cb12ed65$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $367ab585cb12ed65$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $a130d9e691a5988d$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(opts.font);
        const textSize = $367ab585cb12ed65$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $a130d9e691a5988d$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $a130d9e691a5988d$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $367ab585cb12ed65$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $367ab585cb12ed65$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $367ab585cb12ed65$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $367ab585cb12ed65$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $367ab585cb12ed65$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $367ab585cb12ed65$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $a130d9e691a5988d$export$3a6d5c9ae78a2c08)((0, $a130d9e691a5988d$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd))));
    const y = $367ab585cb12ed65$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $367ab585cb12ed65$var$getTextAlignForAngle(angle);
    const left = $367ab585cb12ed65$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $367ab585cb12ed65$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $a130d9e691a5988d$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $a130d9e691a5988d$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $a130d9e691a5988d$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $a130d9e691a5988d$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $367ab585cb12ed65$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $367ab585cb12ed65$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $a130d9e691a5988d$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $367ab585cb12ed65$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = $367ab585cb12ed65$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $367ab585cb12ed65$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $367ab585cb12ed65$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $367ab585cb12ed65$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $367ab585cb12ed65$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $a130d9e691a5988d$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $a130d9e691a5988d$export$9fa96a7d116ea3ce)(opts.borderRadius);
        const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $a130d9e691a5988d$export$d66dc83d8cfc8dd)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $367ab585cb12ed65$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $367ab585cb12ed65$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $367ab585cb12ed65$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $a130d9e691a5988d$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $367ab585cb12ed65$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $367ab585cb12ed65$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $367ab585cb12ed65$var$createPointLabelContext(parent, index, label) {
    return (0, $a130d9e691a5988d$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $367ab585cb12ed65$export$cfafc36d95386d38 extends $367ab585cb12ed65$var$LinearScaleBase {
    static id = "radialLinear";
    static defaults = {
        display: true,
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $a130d9e691a5988d$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    };
    static descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)($367ab585cb12ed65$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $367ab585cb12ed65$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $367ab585cb12ed65$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $367ab585cb12ed65$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $a130d9e691a5988d$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $a130d9e691a5988d$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $a130d9e691a5988d$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $367ab585cb12ed65$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $a130d9e691a5988d$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $367ab585cb12ed65$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $367ab585cb12ed65$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $367ab585cb12ed65$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $a130d9e691a5988d$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $a130d9e691a5988d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $a130d9e691a5988d$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $367ab585cb12ed65$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $367ab585cb12ed65$var$UNITS = /* #__PURE__ */ Object.keys($367ab585cb12ed65$var$INTERVALS);
function $367ab585cb12ed65$var$sorter(a, b) {
    return a - b;
}
function $367ab585cb12ed65$var$parse(scale, input) {
    if ((0, $a130d9e691a5988d$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $a130d9e691a5988d$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $a130d9e691a5988d$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $367ab585cb12ed65$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $367ab585cb12ed65$var$UNITS.length;
    for(let i = $367ab585cb12ed65$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $367ab585cb12ed65$var$INTERVALS[$367ab585cb12ed65$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $367ab585cb12ed65$var$UNITS[i];
    }
    return $367ab585cb12ed65$var$UNITS[ilen - 1];
}
function $367ab585cb12ed65$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $367ab585cb12ed65$var$UNITS.length - 1; i >= $367ab585cb12ed65$var$UNITS.indexOf(minUnit); i--){
        const unit = $367ab585cb12ed65$var$UNITS[i];
        if ($367ab585cb12ed65$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $367ab585cb12ed65$var$UNITS[minUnit ? $367ab585cb12ed65$var$UNITS.indexOf(minUnit) : 0];
}
function $367ab585cb12ed65$var$determineMajorUnit(unit) {
    for(let i = $367ab585cb12ed65$var$UNITS.indexOf(unit) + 1, ilen = $367ab585cb12ed65$var$UNITS.length; i < ilen; ++i){
        if ($367ab585cb12ed65$var$INTERVALS[$367ab585cb12ed65$var$UNITS[i]].common) return $367ab585cb12ed65$var$UNITS[i];
    }
}
function $367ab585cb12ed65$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $a130d9e691a5988d$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $367ab585cb12ed65$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $367ab585cb12ed65$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $367ab585cb12ed65$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $367ab585cb12ed65$export$a894c72689ff3ec extends $367ab585cb12ed65$export$d60cfc58d3c358b6 {
    static id = "time";
    static defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $367ab585cb12ed65$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $a130d9e691a5988d$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $367ab585cb12ed65$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $a130d9e691a5988d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $a130d9e691a5988d$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $367ab585cb12ed65$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $367ab585cb12ed65$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $367ab585cb12ed65$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $367ab585cb12ed65$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $a130d9e691a5988d$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $a130d9e691a5988d$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $367ab585cb12ed65$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $a130d9e691a5988d$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $a130d9e691a5988d$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$367ab585cb12ed65$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $367ab585cb12ed65$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($367ab585cb12ed65$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $a130d9e691a5988d$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $a130d9e691a5988d$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $367ab585cb12ed65$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($367ab585cb12ed65$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $a130d9e691a5988d$export$71511d61b312f219)(values.sort($367ab585cb12ed65$var$sorter));
    }
}
function $367ab585cb12ed65$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $a130d9e691a5988d$export$ef35774e6d314e91)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $a130d9e691a5988d$export$ef35774e6d314e91)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $367ab585cb12ed65$export$85df64a8eb6dc986 extends $367ab585cb12ed65$export$a894c72689ff3ec {
    static id = "timeseries";
    static defaults = $367ab585cb12ed65$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $367ab585cb12ed65$var$interpolate(table, this.min);
        this._tableRange = $367ab585cb12ed65$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($367ab585cb12ed65$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $367ab585cb12ed65$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $367ab585cb12ed65$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $367ab585cb12ed65$export$29e663ba4d09fe7,
    LinearScale: $367ab585cb12ed65$export$e7f4e5e8656f0b93,
    LogarithmicScale: $367ab585cb12ed65$export$85295eaf7cb3ac3e,
    RadialLinearScale: $367ab585cb12ed65$export$cfafc36d95386d38,
    TimeScale: $367ab585cb12ed65$export$a894c72689ff3ec,
    TimeSeriesScale: $367ab585cb12ed65$export$85df64a8eb6dc986
});
const $367ab585cb12ed65$export$e8959e79e3af550f = [
    $367ab585cb12ed65$export$a6506504f799c5d5,
    $367ab585cb12ed65$export$7a5d735b2ab6389d,
    $367ab585cb12ed65$export$8b3ca321c77fdea6,
    $367ab585cb12ed65$export$bcac1c16f1530ec2
];


(0, $367ab585cb12ed65$export$acaa6426d77a227e).register(...(0, $367ab585cb12ed65$export$e8959e79e3af550f));
var $c3a56386499aaa20$export$2e2bcd8739ae039 = (0, $367ab585cb12ed65$export$acaa6426d77a227e);


// src/index.ts

// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ class $c0605f058d18abbe$var$LuxonError extends Error {
}
class $c0605f058d18abbe$export$aaeef2cf7fd7967f extends $c0605f058d18abbe$var$LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
class $c0605f058d18abbe$export$cdb4559f04a244ae extends $c0605f058d18abbe$var$LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
class $c0605f058d18abbe$export$fa63917b8416fe36 extends $c0605f058d18abbe$var$LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
class $c0605f058d18abbe$export$10234d3be7f66e6a extends $c0605f058d18abbe$var$LuxonError {
}
class $c0605f058d18abbe$export$ac94f561e2d387b4 extends $c0605f058d18abbe$var$LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
class $c0605f058d18abbe$export$9c711d4a95378233 extends $c0605f058d18abbe$var$LuxonError {
}
class $c0605f058d18abbe$export$b0a664b8a649f992 extends $c0605f058d18abbe$var$LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}


/**
 * @private
 */ const $ed5647aebc823d4b$var$n = "numeric", $ed5647aebc823d4b$var$s = "short", $ed5647aebc823d4b$var$l = "long";
const $ed5647aebc823d4b$export$19db5ed0dfbf6b4 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$n,
    day: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$7f19f128b5a661d5 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$s,
    day: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$7afd5e65ff14ad5f = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$s,
    day: $ed5647aebc823d4b$var$n,
    weekday: $ed5647aebc823d4b$var$s
};
const $ed5647aebc823d4b$export$e8af1c0b0290dbe2 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$ab5c0d098dcfe775 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n,
    weekday: $ed5647aebc823d4b$var$l
};
const $ed5647aebc823d4b$export$b4941e7fc62df1ff = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$61c7c50acaa56067 = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$417ed025e483567 = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$s
};
const $ed5647aebc823d4b$export$e0d12640fceb849c = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$l
};
const $ed5647aebc823d4b$export$7333d0894ea2a492 = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    hourCycle: "h23"
};
const $ed5647aebc823d4b$export$2664018dfbf7eca = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    hourCycle: "h23"
};
const $ed5647aebc823d4b$export$3f5c467c8b3c85f6 = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    hourCycle: "h23",
    timeZoneName: $ed5647aebc823d4b$var$s
};
const $ed5647aebc823d4b$export$edc722d6385d5cfa = {
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    hourCycle: "h23",
    timeZoneName: $ed5647aebc823d4b$var$l
};
const $ed5647aebc823d4b$export$434cdda648f6d8ed = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$n,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$115df8ec21cc4422 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$n,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$2a10deefdeef9026 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$s,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$652ead5a5aee93d0 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$s,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$97006f3c2fab9954 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$s,
    day: $ed5647aebc823d4b$var$n,
    weekday: $ed5647aebc823d4b$var$s,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n
};
const $ed5647aebc823d4b$export$6fbcfb06dd40694b = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$s
};
const $ed5647aebc823d4b$export$9ae9ad238dcfe6df = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$s
};
const $ed5647aebc823d4b$export$c01f9be9042ca6d2 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n,
    weekday: $ed5647aebc823d4b$var$l,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$l
};
const $ed5647aebc823d4b$export$c3b12c6a0fb1f516 = {
    year: $ed5647aebc823d4b$var$n,
    month: $ed5647aebc823d4b$var$l,
    day: $ed5647aebc823d4b$var$n,
    weekday: $ed5647aebc823d4b$var$l,
    hour: $ed5647aebc823d4b$var$n,
    minute: $ed5647aebc823d4b$var$n,
    second: $ed5647aebc823d4b$var$n,
    timeZoneName: $ed5647aebc823d4b$var$l
};


/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ 


class $c5ae28e6b238f0c1$export$2e2bcd8739ae039 {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */ get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new (0, $c0605f058d18abbe$export$b0a664b8a649f992)();
    }
}


let $f7fa98580bb0d506$var$singleton = null;
class $f7fa98580bb0d506$export$2e2bcd8739ae039 extends (0, $c5ae28e6b238f0c1$export$2e2bcd8739ae039) {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if ($f7fa98580bb0d506$var$singleton === null) $f7fa98580bb0d506$var$singleton = new $f7fa98580bb0d506$export$2e2bcd8739ae039();
        return $f7fa98580bb0d506$var$singleton;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format: format, locale: locale }) {
        return (0, $f530739b8b53bdfe$export$897bcc5343b25acd)(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return (0, $f530739b8b53bdfe$export$a52dc21079c7600)(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}




const $a04c1328d05994f9$var$dtfCache = new Map();
function $a04c1328d05994f9$var$makeDTF(zoneName) {
    let dtf = $a04c1328d05994f9$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $a04c1328d05994f9$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
const $a04c1328d05994f9$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $a04c1328d05994f9$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $a04c1328d05994f9$var$partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type: type, value: value } = formatted[i];
        const pos = $a04c1328d05994f9$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
const $a04c1328d05994f9$var$ianaZoneCache = new Map();
class $a04c1328d05994f9$export$2e2bcd8739ae039 extends (0, $c5ae28e6b238f0c1$export$2e2bcd8739ae039) {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        let zone = $a04c1328d05994f9$var$ianaZoneCache.get(name);
        if (zone === undefined) $a04c1328d05994f9$var$ianaZoneCache.set(name, zone = new $a04c1328d05994f9$export$2e2bcd8739ae039(name));
        return zone;
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        $a04c1328d05994f9$var$ianaZoneCache.clear();
        $a04c1328d05994f9$var$dtfCache.clear();
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = $a04c1328d05994f9$export$2e2bcd8739ae039.isValidZone(name);
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ get type() {
        return "iana";
    }
    /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */ get name() {
        return this.zoneName;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return false;
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, { format: format, locale: locale }) {
        return (0, $f530739b8b53bdfe$export$897bcc5343b25acd)(ts, format, locale, this.name);
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return (0, $f530739b8b53bdfe$export$a52dc21079c7600)(this.offset(ts), format);
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        if (!this.valid) return NaN;
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = $a04c1328d05994f9$var$makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? $a04c1328d05994f9$var$partsOffset(dtf, date) : $a04c1328d05994f9$var$hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = (0, $f530739b8b53bdfe$export$c7c54c08b29e0736)({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return this.valid;
    }
}







// todo - remap caching
let $775b735bbc6f5e07$var$intlLFCache = {};
function $775b735bbc6f5e07$var$getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $775b735bbc6f5e07$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $775b735bbc6f5e07$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
const $775b735bbc6f5e07$var$intlDTCache = new Map();
function $775b735bbc6f5e07$var$getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $775b735bbc6f5e07$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $775b735bbc6f5e07$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
const $775b735bbc6f5e07$var$intlNumCache = new Map();
function $775b735bbc6f5e07$var$getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = $775b735bbc6f5e07$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $775b735bbc6f5e07$var$intlNumCache.set(key, inf);
    }
    return inf;
}
const $775b735bbc6f5e07$var$intlRelCache = new Map();
function $775b735bbc6f5e07$var$getCachedRTF(locString, opts = {}) {
    const { base: base, ...cacheKeyOpts } = opts; // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = $775b735bbc6f5e07$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $775b735bbc6f5e07$var$intlRelCache.set(key, inf);
    }
    return inf;
}
let $775b735bbc6f5e07$var$sysLocaleCache = null;
function $775b735bbc6f5e07$var$systemLocale() {
    if ($775b735bbc6f5e07$var$sysLocaleCache) return $775b735bbc6f5e07$var$sysLocaleCache;
    else {
        $775b735bbc6f5e07$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $775b735bbc6f5e07$var$sysLocaleCache;
    }
}
const $775b735bbc6f5e07$var$intlResolvedOptionsCache = new Map();
function $775b735bbc6f5e07$var$getCachedIntResolvedOptions(locString) {
    let opts = $775b735bbc6f5e07$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $775b735bbc6f5e07$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
const $775b735bbc6f5e07$var$weekInfoCache = new Map();
function $775b735bbc6f5e07$var$getCachedWeekInfo(locString) {
    let data = $775b735bbc6f5e07$var$weekInfoCache.get(locString);
    if (!data) {
        const locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = {
            ...$775b735bbc6f5e07$var$fallbackWeekSettings,
            ...data
        };
        $775b735bbc6f5e07$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $775b735bbc6f5e07$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    const xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        let selectedStr;
        try {
            options = $775b735bbc6f5e07$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            const smaller = localeStr.substring(0, uIndex);
            options = $775b735bbc6f5e07$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        const { numberingSystem: numberingSystem, calendar: calendar } = options;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $775b735bbc6f5e07$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function $775b735bbc6f5e07$var$mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $775b735bbc6f5e07$var$mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $775b735bbc6f5e07$var$listStuff(loc, length, englishFn, intlFn) {
    const mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $775b735bbc6f5e07$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $775b735bbc6f5e07$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ class $775b735bbc6f5e07$var$PolyNumberFormatter {
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo: padTo, floor: floor, ...otherOpts } = opts;
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = {
                useGrouping: false,
                ...opts
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $775b735bbc6f5e07$var$getCachedINF(intl, intlOpts);
        }
    }
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : (0, $f530739b8b53bdfe$export$7978a6ddf29f4374)(i, 3);
            return (0, $f530739b8b53bdfe$export$36cf564d487b5178)(fixed, this.padTo);
        }
    }
}
/**
 * @private
 */ class $775b735bbc6f5e07$var$PolyDateFormatter {
    constructor(dt, intl, opts){
        this.opts = opts;
        this.originalZone = undefined;
        let z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && (0, $a04c1328d05994f9$export$2e2bcd8739ae039).create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        const intlOpts = {
            ...this.opts
        };
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $775b735bbc6f5e07$var$getCachedDTF(intl, intlOpts);
    }
    format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(({ value: value })=>value).join("");
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        const parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map((part)=>{
            if (part.type === "timeZoneName") {
                const offsetName = this.originalZone.offsetName(this.dt.ts, {
                    locale: this.dt.locale,
                    format: this.opts.timeZoneName
                });
                return {
                    ...part,
                    value: offsetName
                };
            } else return part;
        });
        return parts;
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
}
/**
 * @private
 */ class $775b735bbc6f5e07$var$PolyRelFormatter {
    constructor(intl, isEnglish, opts){
        this.opts = {
            style: "long",
            ...opts
        };
        if (!isEnglish && (0, $f530739b8b53bdfe$export$36c4ef3ee752f47f)()) this.rtf = $775b735bbc6f5e07$var$getCachedRTF(intl, opts);
    }
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $f0e1c06e00207932$export$b4ea3b48dcf921f6(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
}
const $775b735bbc6f5e07$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
class $775b735bbc6f5e07$export$2e2bcd8739ae039 {
    static fromOpts(opts) {
        return $775b735bbc6f5e07$export$2e2bcd8739ae039.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
        const specifiedLocale = locale || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : $775b735bbc6f5e07$var$systemLocale());
        const numberingSystemR = numberingSystem || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultNumberingSystem;
        const outputCalendarR = outputCalendar || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultOutputCalendar;
        const weekSettingsR = (0, $f530739b8b53bdfe$export$68b4772f5ae7dec6)(weekSettings) || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultWeekSettings;
        return new $775b735bbc6f5e07$export$2e2bcd8739ae039(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    }
    static resetCache() {
        $775b735bbc6f5e07$var$sysLocaleCache = null;
        $775b735bbc6f5e07$var$intlDTCache.clear();
        $775b735bbc6f5e07$var$intlNumCache.clear();
        $775b735bbc6f5e07$var$intlRelCache.clear();
        $775b735bbc6f5e07$var$intlResolvedOptionsCache.clear();
        $775b735bbc6f5e07$var$weekInfoCache.clear();
    }
    static fromObject({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar, weekSettings: weekSettings } = {}) {
        return $775b735bbc6f5e07$export$2e2bcd8739ae039.create(locale, numberingSystem, outputCalendar, weekSettings);
    }
    constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = $775b735bbc6f5e07$var$parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $775b735bbc6f5e07$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = $775b735bbc6f5e07$var$supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return $775b735bbc6f5e07$export$2e2bcd8739ae039.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, (0, $f530739b8b53bdfe$export$68b4772f5ae7dec6)(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: true
        });
    }
    redefaultToSystem(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: false
        });
    }
    months(length, format = false) {
        return $775b735bbc6f5e07$var$listStuff(this, length, $f0e1c06e00207932$export$16352d1b10c5eb38, ()=>{
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) this.monthsCache[formatStr][length] = $775b735bbc6f5e07$var$mapMonths((dt)=>this.extract(dt, intl, "month"));
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false) {
        return $775b735bbc6f5e07$var$listStuff(this, length, $f0e1c06e00207932$export$21e30707d27594c3, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = $775b735bbc6f5e07$var$mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems() {
        return $775b735bbc6f5e07$var$listStuff(this, undefined, ()=>$f0e1c06e00207932$export$94f480e07472beac, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(2016, 11, 13, 9),
                    (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length) {
        return $775b735bbc6f5e07$var$listStuff(this, length, $f0e1c06e00207932$export$41e043ce18349ee8, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(-40, 1, 1),
                (0, $f5908f0c310c003f$export$2e2bcd8739ae039).utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $775b735bbc6f5e07$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new $775b735bbc6f5e07$var$PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new $775b735bbc6f5e07$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return $775b735bbc6f5e07$var$getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $775b735bbc6f5e07$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    }
    getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!(0, $f530739b8b53bdfe$export$deee12cd7a09c6e1)()) return $775b735bbc6f5e07$var$fallbackWeekSettings;
        else return $775b735bbc6f5e07$var$getCachedWeekInfo(this.locale);
    }
    getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    }
    getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    }
    getWeekendDays() {
        return this.getWeekSettings().weekend;
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    toString() {
        return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
    }
}



/**
 * @private
 */ 



let $32a49b6c9c34cf62$var$singleton = null;
class $32a49b6c9c34cf62$export$2e2bcd8739ae039 extends (0, $c5ae28e6b238f0c1$export$2e2bcd8739ae039) {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if ($32a49b6c9c34cf62$var$singleton === null) $32a49b6c9c34cf62$var$singleton = new $32a49b6c9c34cf62$export$2e2bcd8739ae039(0);
        return $32a49b6c9c34cf62$var$singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? $32a49b6c9c34cf62$export$2e2bcd8739ae039.utcInstance : new $32a49b6c9c34cf62$export$2e2bcd8739ae039(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new $32a49b6c9c34cf62$export$2e2bcd8739ae039((0, $f530739b8b53bdfe$export$f60aa7c70b05722d)(r[1], r[2]));
        }
        return null;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ get type() {
        return "fixed";
    }
    /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${(0, $f530739b8b53bdfe$export$a52dc21079c7600)(this.fixed, "narrow")}`;
    }
    /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */ get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${(0, $f530739b8b53bdfe$export$a52dc21079c7600)(-this.fixed, "narrow")}`;
    }
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ offsetName() {
        return this.name;
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return (0, $f530739b8b53bdfe$export$a52dc21079c7600)(this.fixed, format);
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return true;
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ offset() {
        return this.fixed;
    }
    /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return true;
    }
}



class $e348e8e27b3cc3de$export$2e2bcd8739ae039 extends (0, $c5ae28e6b238f0c1$export$2e2bcd8739ae039) {
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
}




function $0619280deadc573a$export$4527f24d1e617e9(input, defaultZone) {
    let offset;
    if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(input) || input === null) return defaultZone;
    else if (input instanceof (0, $c5ae28e6b238f0c1$export$2e2bcd8739ae039)) return input;
    else if ((0, $f530739b8b53bdfe$export$844ec244b1367d54)(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return (0, $f7fa98580bb0d506$export$2e2bcd8739ae039).instance;
        else if (lowered === "utc" || lowered === "gmt") return (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).utcInstance;
        else return (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).parseSpecifier(lowered) || (0, $a04c1328d05994f9$export$2e2bcd8739ae039).create(input);
    } else if ((0, $f530739b8b53bdfe$export$7e4aa119212bc614)(input)) return (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new (0, $e348e8e27b3cc3de$export$2e2bcd8739ae039)(input);
}



const $4878391f370a69a1$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const $4878391f370a69a1$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const $4878391f370a69a1$var$hanidecChars = $4878391f370a69a1$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $4878391f370a69a1$export$b37c688a581b2f6b(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search($4878391f370a69a1$var$numberingSystems.hanidec) !== -1) value += $4878391f370a69a1$var$hanidecChars.indexOf(str[i]);
            else for(const key in $4878391f370a69a1$var$numberingSystemsUTF16){
                const [min, max] = $4878391f370a69a1$var$numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
const $4878391f370a69a1$var$digitRegexCache = new Map();
function $4878391f370a69a1$export$3d8a1d77340d0f52() {
    $4878391f370a69a1$var$digitRegexCache.clear();
}
function $4878391f370a69a1$export$79fd8462ddaefe42({ numberingSystem: numberingSystem }, append = "") {
    const ns = numberingSystem || "latn";
    let appendCache = $4878391f370a69a1$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $4878391f370a69a1$var$digitRegexCache.set(ns, appendCache);
    }
    let regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp(`${$4878391f370a69a1$var$numberingSystems[ns]}${append}`);
        appendCache.set(append, regex);
    }
    return regex;
}


let $4f2aa03072c9caa8$var$now = ()=>Date.now(), $4f2aa03072c9caa8$var$defaultZone = "system", $4f2aa03072c9caa8$var$defaultLocale = null, $4f2aa03072c9caa8$var$defaultNumberingSystem = null, $4f2aa03072c9caa8$var$defaultOutputCalendar = null, $4f2aa03072c9caa8$var$twoDigitCutoffYear = 60, $4f2aa03072c9caa8$var$throwOnInvalid, $4f2aa03072c9caa8$var$defaultWeekSettings = null;
class $4f2aa03072c9caa8$export$2e2bcd8739ae039 {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return $4f2aa03072c9caa8$var$now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        $4f2aa03072c9caa8$var$now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        $4f2aa03072c9caa8$var$defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return (0, $0619280deadc573a$export$4527f24d1e617e9)($4f2aa03072c9caa8$var$defaultZone, (0, $f7fa98580bb0d506$export$2e2bcd8739ae039).instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return $4f2aa03072c9caa8$var$defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        $4f2aa03072c9caa8$var$defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return $4f2aa03072c9caa8$var$defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        $4f2aa03072c9caa8$var$defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return $4f2aa03072c9caa8$var$defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        $4f2aa03072c9caa8$var$defaultOutputCalendar = outputCalendar;
    }
    /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */ /**
   * @return {WeekSettings|null}
   */ static get defaultWeekSettings() {
        return $4f2aa03072c9caa8$var$defaultWeekSettings;
    }
    /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */ static set defaultWeekSettings(weekSettings) {
        $4f2aa03072c9caa8$var$defaultWeekSettings = (0, $f530739b8b53bdfe$export$68b4772f5ae7dec6)(weekSettings);
    }
    /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */ static get twoDigitCutoffYear() {
        return $4f2aa03072c9caa8$var$twoDigitCutoffYear;
    }
    /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */ static set twoDigitCutoffYear(cutoffYear) {
        $4f2aa03072c9caa8$var$twoDigitCutoffYear = cutoffYear % 100;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return $4f2aa03072c9caa8$var$throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        $4f2aa03072c9caa8$var$throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).resetCache();
        (0, $a04c1328d05994f9$export$2e2bcd8739ae039).resetCache();
        (0, $f5908f0c310c003f$export$2e2bcd8739ae039).resetCache();
        (0, $4878391f370a69a1$export$3d8a1d77340d0f52)();
    }
}



class $ed8e6d444ff59212$export$2e2bcd8739ae039 {
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
}



const $2e8900d0c3709bba$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $2e8900d0c3709bba$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $2e8900d0c3709bba$var$unitOutOfRange(unit, value) {
    return new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function $2e8900d0c3709bba$export$a24aefd2b69080a9(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $2e8900d0c3709bba$var$computeOrdinal(year, month, day) {
    return day + ((0, $f530739b8b53bdfe$export$553d7fa8e3805fc0)(year) ? $2e8900d0c3709bba$var$leapLadder : $2e8900d0c3709bba$var$nonLeapLadder)[month - 1];
}
function $2e8900d0c3709bba$var$uncomputeOrdinal(year, ordinal) {
    const table = (0, $f530739b8b53bdfe$export$553d7fa8e3805fc0)(year) ? $2e8900d0c3709bba$var$leapLadder : $2e8900d0c3709bba$var$nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $2e8900d0c3709bba$export$3f8e22cccbc0b2cb(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function $2e8900d0c3709bba$export$5f982b63a73e30d5(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { year: year, month: month, day: day } = gregObj, ordinal = $2e8900d0c3709bba$var$computeOrdinal(year, month, day), weekday = $2e8900d0c3709bba$export$3f8e22cccbc0b2cb($2e8900d0c3709bba$export$a24aefd2b69080a9(year, month, day), startOfWeek);
    let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = (0, $f530739b8b53bdfe$export$fcb8e8d76a6f2959)(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > (0, $f530739b8b53bdfe$export$fcb8e8d76a6f2959)(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return {
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday,
        ...(0, $f530739b8b53bdfe$export$4401ec2a884d3d6f)(gregObj)
    };
}
function $2e8900d0c3709bba$export$82dcd477cc9ab67d(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { weekYear: weekYear, weekNumber: weekNumber, weekday: weekday } = weekData, weekdayOfJan4 = $2e8900d0c3709bba$export$3f8e22cccbc0b2cb($2e8900d0c3709bba$export$a24aefd2b69080a9(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = (0, $f530739b8b53bdfe$export$3913210603d8e9ae)(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += (0, $f530739b8b53bdfe$export$3913210603d8e9ae)(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= (0, $f530739b8b53bdfe$export$3913210603d8e9ae)(weekYear);
    } else year = weekYear;
    const { month: month, day: day } = $2e8900d0c3709bba$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...(0, $f530739b8b53bdfe$export$4401ec2a884d3d6f)(weekData)
    };
}
function $2e8900d0c3709bba$export$78dea2ea345b4d9b(gregData) {
    const { year: year, month: month, day: day } = gregData;
    const ordinal = $2e8900d0c3709bba$var$computeOrdinal(year, month, day);
    return {
        year: year,
        ordinal: ordinal,
        ...(0, $f530739b8b53bdfe$export$4401ec2a884d3d6f)(gregData)
    };
}
function $2e8900d0c3709bba$export$4ad8037b9961f2a(ordinalData) {
    const { year: year, ordinal: ordinal } = ordinalData;
    const { month: month, day: day } = $2e8900d0c3709bba$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...(0, $f530739b8b53bdfe$export$4401ec2a884d3d6f)(ordinalData)
    };
}
function $2e8900d0c3709bba$export$527e2948b97774c0(obj, loc) {
    const hasLocaleWeekData = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekday) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekNumber) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekYear);
    if (hasLocaleWeekData) {
        const hasIsoWeekData = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.weekday) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.weekNumber) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.weekYear);
        if (hasIsoWeekData) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Cannot mix locale-based week fields with ISO-based week fields");
        if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $2e8900d0c3709bba$export$48544eeabe120519(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const validYear = (0, $f530739b8b53bdfe$export$a287f47fed4544b8)(obj.weekYear), validWeek = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(obj.weekNumber, 1, (0, $f530739b8b53bdfe$export$fcb8e8d76a6f2959)(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(obj.weekday, 1, 7);
    if (!validYear) return $2e8900d0c3709bba$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $2e8900d0c3709bba$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $2e8900d0c3709bba$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $2e8900d0c3709bba$export$32d428c9a6653964(obj) {
    const validYear = (0, $f530739b8b53bdfe$export$a287f47fed4544b8)(obj.year), validOrdinal = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(obj.ordinal, 1, (0, $f530739b8b53bdfe$export$3913210603d8e9ae)(obj.year));
    if (!validYear) return $2e8900d0c3709bba$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $2e8900d0c3709bba$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $2e8900d0c3709bba$export$b807d5063f9fabd1(obj) {
    const validYear = (0, $f530739b8b53bdfe$export$a287f47fed4544b8)(obj.year), validMonth = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(obj.month, 1, 12), validDay = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(obj.day, 1, (0, $f530739b8b53bdfe$export$4169ecd548fbc13a)(obj.year, obj.month));
    if (!validYear) return $2e8900d0c3709bba$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $2e8900d0c3709bba$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $2e8900d0c3709bba$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $2e8900d0c3709bba$export$f087c0ea5c760b87(obj) {
    const { hour: hour, minute: minute, second: second, millisecond: millisecond } = obj;
    const validHour = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(minute, 0, 59), validSecond = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(second, 0, 59), validMillisecond = (0, $f530739b8b53bdfe$export$9fe178c7471c91db)(millisecond, 0, 999);
    if (!validHour) return $2e8900d0c3709bba$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $2e8900d0c3709bba$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $2e8900d0c3709bba$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $2e8900d0c3709bba$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}


function $f530739b8b53bdfe$export$fce6876652108ab(o) {
    return typeof o === "undefined";
}
function $f530739b8b53bdfe$export$7e4aa119212bc614(o) {
    return typeof o === "number";
}
function $f530739b8b53bdfe$export$a287f47fed4544b8(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $f530739b8b53bdfe$export$844ec244b1367d54(o) {
    return typeof o === "string";
}
function $f530739b8b53bdfe$export$871608497c498473(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
function $f530739b8b53bdfe$export$36c4ef3ee752f47f() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $f530739b8b53bdfe$export$deee12cd7a09c6e1() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
function $f530739b8b53bdfe$export$334480083959f08a(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $f530739b8b53bdfe$export$d322b949ce403225(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $f530739b8b53bdfe$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function $f530739b8b53bdfe$export$5a15a386532a5ea4(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $f530739b8b53bdfe$export$68b4772f5ae7dec6(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("Week settings must be an object");
    else {
        if (!$f530739b8b53bdfe$export$9fe178c7471c91db(settings.firstDay, 1, 7) || !$f530739b8b53bdfe$export$9fe178c7471c91db(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v)=>!$f530739b8b53bdfe$export$9fe178c7471c91db(v, 1, 7))) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
function $f530739b8b53bdfe$export$9fe178c7471c91db(thing, bottom, top) {
    return $f530739b8b53bdfe$export$a287f47fed4544b8(thing) && thing >= bottom && thing <= top;
}
function $f530739b8b53bdfe$export$3b34b3b59ac8ca7e(x, n) {
    return x - n * Math.floor(x / n);
}
function $f530739b8b53bdfe$export$36cf564d487b5178(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $f530739b8b53bdfe$export$7181a16950b3209d(string) {
    if ($f530739b8b53bdfe$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $f530739b8b53bdfe$export$ccc9a81fca9859cb(string) {
    if ($f530739b8b53bdfe$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $f530739b8b53bdfe$export$3989d60cf160c565(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($f530739b8b53bdfe$export$fce6876652108ab(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $f530739b8b53bdfe$export$7978a6ddf29f4374(number, digits, towardZero = false) {
    const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
function $f530739b8b53bdfe$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $f530739b8b53bdfe$export$3913210603d8e9ae(year) {
    return $f530739b8b53bdfe$export$553d7fa8e3805fc0(year) ? 366 : 365;
}
function $f530739b8b53bdfe$export$4169ecd548fbc13a(year, month) {
    const modMonth = $f530739b8b53bdfe$export$3b34b3b59ac8ca7e(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $f530739b8b53bdfe$export$553d7fa8e3805fc0(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
function $f530739b8b53bdfe$export$c7c54c08b29e0736(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $f530739b8b53bdfe$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    const fwdlw = (0, $2e8900d0c3709bba$export$3f8e22cccbc0b2cb)((0, $2e8900d0c3709bba$export$a24aefd2b69080a9)(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $f530739b8b53bdfe$export$fcb8e8d76a6f2959(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const weekOffset = $f530739b8b53bdfe$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    const weekOffsetNext = $f530739b8b53bdfe$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($f530739b8b53bdfe$export$3913210603d8e9ae(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $f530739b8b53bdfe$export$b7a39e2df70cc6be(year) {
    if (year > 99) return year;
    else return year > (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
function $f530739b8b53bdfe$export$897bcc5343b25acd(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = {
        timeZoneName: offsetFormat,
        ...intlOpts
    };
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
function $f530739b8b53bdfe$export$f60aa7c70b05722d(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
function $f530739b8b53bdfe$export$37576b9ba69b50db(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`Invalid unit value ${value}`);
    return numericValue;
}
function $f530739b8b53bdfe$export$ba17feb4405f3f38(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if ($f530739b8b53bdfe$export$5a15a386532a5ea4(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $f530739b8b53bdfe$export$37576b9ba69b50db(v);
    }
    return normalized;
}
function $f530739b8b53bdfe$export$a52dc21079c7600(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${$f530739b8b53bdfe$export$36cf564d487b5178(hours, 2)}:${$f530739b8b53bdfe$export$36cf564d487b5178(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${$f530739b8b53bdfe$export$36cf564d487b5178(hours, 2)}${$f530739b8b53bdfe$export$36cf564d487b5178(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function $f530739b8b53bdfe$export$4401ec2a884d3d6f(obj) {
    return $f530739b8b53bdfe$export$357523c63a2253b9(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}


function $f0e1c06e00207932$var$stringify(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}
const $f0e1c06e00207932$export$2bb3eb27682a776 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $f0e1c06e00207932$export$b4b23bfab2f68498 = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $f0e1c06e00207932$export$db1cae8e85a8ede0 = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $f0e1c06e00207932$export$16352d1b10c5eb38(length) {
    switch(length){
        case "narrow":
            return [
                ...$f0e1c06e00207932$export$db1cae8e85a8ede0
            ];
        case "short":
            return [
                ...$f0e1c06e00207932$export$b4b23bfab2f68498
            ];
        case "long":
            return [
                ...$f0e1c06e00207932$export$2bb3eb27682a776
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const $f0e1c06e00207932$export$406f4855508be663 = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $f0e1c06e00207932$export$d89a20b736c12a21 = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const $f0e1c06e00207932$export$2997fd2e8025c4fc = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $f0e1c06e00207932$export$21e30707d27594c3(length) {
    switch(length){
        case "narrow":
            return [
                ...$f0e1c06e00207932$export$2997fd2e8025c4fc
            ];
        case "short":
            return [
                ...$f0e1c06e00207932$export$d89a20b736c12a21
            ];
        case "long":
            return [
                ...$f0e1c06e00207932$export$406f4855508be663
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const $f0e1c06e00207932$export$94f480e07472beac = [
    "AM",
    "PM"
];
const $f0e1c06e00207932$export$a3539dc50fc6cc47 = [
    "Before Christ",
    "Anno Domini"
];
const $f0e1c06e00207932$export$a8f63c83729947a4 = [
    "BC",
    "AD"
];
const $f0e1c06e00207932$export$2b0880176b7ca6fb = [
    "B",
    "A"
];
function $f0e1c06e00207932$export$41e043ce18349ee8(length) {
    switch(length){
        case "narrow":
            return [
                ...$f0e1c06e00207932$export$2b0880176b7ca6fb
            ];
        case "short":
            return [
                ...$f0e1c06e00207932$export$a8f63c83729947a4
            ];
        case "long":
            return [
                ...$f0e1c06e00207932$export$a3539dc50fc6cc47
            ];
        default:
            return null;
    }
}
function $f0e1c06e00207932$export$fbaec5aff3c47ddc(dt) {
    return $f0e1c06e00207932$export$94f480e07472beac[dt.hour < 12 ? 0 : 1];
}
function $f0e1c06e00207932$export$a48176098d281ad2(dt, length) {
    return $f0e1c06e00207932$export$21e30707d27594c3(length)[dt.weekday - 1];
}
function $f0e1c06e00207932$export$5d07d42a611abcf2(dt, length) {
    return $f0e1c06e00207932$export$16352d1b10c5eb38(length)[dt.month - 1];
}
function $f0e1c06e00207932$export$3394b151c30b498b(dt, length) {
    return $f0e1c06e00207932$export$41e043ce18349ee8(length)[dt.year < 0 ? 0 : 1];
}
function $f0e1c06e00207932$export$b4ea3b48dcf921f6(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
            default:
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function $f0e1c06e00207932$export$1aa7d7568ce4670d(knownFormat) {
    // these all have the offsets removed because we don't have access to them
    // without all the intl stuff this is backfilling
    const filtered = (0, $f530739b8b53bdfe$export$357523c63a2253b9)(knownFormat, [
        "weekday",
        "era",
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "timeZoneName",
        "hourCycle"
    ]), key = $f0e1c06e00207932$var$stringify(filtered), dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
    switch(key){
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$19db5ed0dfbf6b4):
            return "M/d/yyyy";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$7f19f128b5a661d5):
            return "LLL d, yyyy";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$7afd5e65ff14ad5f):
            return "EEE, LLL d, yyyy";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$e8af1c0b0290dbe2):
            return "LLLL d, yyyy";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$ab5c0d098dcfe775):
            return "EEEE, LLLL d, yyyy";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$b4941e7fc62df1ff):
            return "h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$61c7c50acaa56067):
            return "h:mm:ss a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$417ed025e483567):
            return "h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$e0d12640fceb849c):
            return "h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$7333d0894ea2a492):
            return "HH:mm";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$2664018dfbf7eca):
            return "HH:mm:ss";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$3f5c467c8b3c85f6):
            return "HH:mm";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$edc722d6385d5cfa):
            return "HH:mm";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$434cdda648f6d8ed):
            return "M/d/yyyy, h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$2a10deefdeef9026):
            return "LLL d, yyyy, h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$6fbcfb06dd40694b):
            return "LLLL d, yyyy, h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$c01f9be9042ca6d2):
            return dateTimeHuge;
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$115df8ec21cc4422):
            return "M/d/yyyy, h:mm:ss a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$652ead5a5aee93d0):
            return "LLL d, yyyy, h:mm:ss a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$97006f3c2fab9954):
            return "EEE, d LLL yyyy, h:mm a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$9ae9ad238dcfe6df):
            return "LLLL d, yyyy, h:mm:ss a";
        case $f0e1c06e00207932$var$stringify($ed5647aebc823d4b$export$c3b12c6a0fb1f516):
            return "EEEE, LLLL d, yyyy, h:mm:ss a";
        default:
            return dateTimeHuge;
    }
}




function $8944558f9072bf37$var$stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const $8944558f9072bf37$var$macroTokenToFormatOpts = {
    D: $ed5647aebc823d4b$export$19db5ed0dfbf6b4,
    DD: $ed5647aebc823d4b$export$7f19f128b5a661d5,
    DDD: $ed5647aebc823d4b$export$e8af1c0b0290dbe2,
    DDDD: $ed5647aebc823d4b$export$ab5c0d098dcfe775,
    t: $ed5647aebc823d4b$export$b4941e7fc62df1ff,
    tt: $ed5647aebc823d4b$export$61c7c50acaa56067,
    ttt: $ed5647aebc823d4b$export$417ed025e483567,
    tttt: $ed5647aebc823d4b$export$e0d12640fceb849c,
    T: $ed5647aebc823d4b$export$7333d0894ea2a492,
    TT: $ed5647aebc823d4b$export$2664018dfbf7eca,
    TTT: $ed5647aebc823d4b$export$3f5c467c8b3c85f6,
    TTTT: $ed5647aebc823d4b$export$edc722d6385d5cfa,
    f: $ed5647aebc823d4b$export$434cdda648f6d8ed,
    ff: $ed5647aebc823d4b$export$2a10deefdeef9026,
    fff: $ed5647aebc823d4b$export$6fbcfb06dd40694b,
    ffff: $ed5647aebc823d4b$export$c01f9be9042ca6d2,
    F: $ed5647aebc823d4b$export$115df8ec21cc4422,
    FF: $ed5647aebc823d4b$export$652ead5a5aee93d0,
    FFF: $ed5647aebc823d4b$export$9ae9ad238dcfe6df,
    FFFF: $ed5647aebc823d4b$export$c3b12c6a0fb1f516
};
class $8944558f9072bf37$export$2e2bcd8739ae039 {
    static create(locale, opts = {}) {
        return new $8944558f9072bf37$export$2e2bcd8739ae039(locale, opts);
    }
    static parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return $8944558f9072bf37$var$macroTokenToFormatOpts[token];
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
        return df.format();
    }
    dtFormatter(dt, opts = {}) {
        return this.loc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
    }
    formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    }
    formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    }
    formatInterval(interval, opts) {
        const df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    }
    resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    }
    num(n, p = 0) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return (0, $f530739b8b53bdfe$export$36cf564d487b5178)(n, p);
        const opts = {
            ...this.opts
        };
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? $f0e1c06e00207932$export$fbaec5aff3c47ddc(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? $f0e1c06e00207932$export$5d07d42a611abcf2(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? $f0e1c06e00207932$export$a48176098d281ad2(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = $8944558f9072bf37$export$2e2bcd8739ae039.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? $f0e1c06e00207932$export$3394b151c30b498b(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "n":
                    return this.num(dt.localWeekNumber);
                case "nn":
                    return this.num(dt.localWeekNumber, 2);
                case "ii":
                    return this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return this.num(dt.localWeekYear, 4);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $8944558f9072bf37$var$stringifyTokens($8944558f9072bf37$export$2e2bcd8739ae039.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = (lildur)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) return this.num(lildur.get(mapped), token.length);
                else return token;
            }, tokens = $8944558f9072bf37$export$2e2bcd8739ae039.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal, val: val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t));
        return $8944558f9072bf37$var$stringifyTokens(tokens, tokenToString(collapsed));
    }
}








/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ const $ed748d7f7fd7ff04$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $ed748d7f7fd7ff04$var$combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function $ed748d7f7fd7ff04$var$combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                {
                    ...mergedVals,
                    ...val
                },
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function $ed748d7f7fd7ff04$var$parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $ed748d7f7fd7ff04$var$simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = (0, $f530739b8b53bdfe$export$7181a16950b3209d)(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const $ed748d7f7fd7ff04$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const $ed748d7f7fd7ff04$var$isoExtendedZone = `(?:${$ed748d7f7fd7ff04$var$offsetRegex.source}?(?:\\[(${$ed748d7f7fd7ff04$var$ianaRegex.source})\\])?)?`;
const $ed748d7f7fd7ff04$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const $ed748d7f7fd7ff04$var$isoTimeRegex = RegExp(`${$ed748d7f7fd7ff04$var$isoTimeBaseRegex.source}${$ed748d7f7fd7ff04$var$isoExtendedZone}`);
const $ed748d7f7fd7ff04$var$isoTimeExtensionRegex = RegExp(`(?:T${$ed748d7f7fd7ff04$var$isoTimeRegex.source})?`);
const $ed748d7f7fd7ff04$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const $ed748d7f7fd7ff04$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const $ed748d7f7fd7ff04$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const $ed748d7f7fd7ff04$var$extractISOWeekData = $ed748d7f7fd7ff04$var$simpleParse("weekYear", "weekNumber", "weekDay");
const $ed748d7f7fd7ff04$var$extractISOOrdinalData = $ed748d7f7fd7ff04$var$simpleParse("year", "ordinal");
const $ed748d7f7fd7ff04$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const $ed748d7f7fd7ff04$var$sqlTimeRegex = RegExp(`${$ed748d7f7fd7ff04$var$isoTimeBaseRegex.source} ?(?:${$ed748d7f7fd7ff04$var$offsetRegex.source}|(${$ed748d7f7fd7ff04$var$ianaRegex.source}))?`);
const $ed748d7f7fd7ff04$var$sqlTimeExtensionRegex = RegExp(`(?: ${$ed748d7f7fd7ff04$var$sqlTimeRegex.source})?`);
function $ed748d7f7fd7ff04$var$int(match, pos, fallback) {
    const m = match[pos];
    return (0, $f530739b8b53bdfe$export$fce6876652108ab)(m) ? fallback : (0, $f530739b8b53bdfe$export$7181a16950b3209d)(m);
}
function $ed748d7f7fd7ff04$var$extractISOYmd(match, cursor) {
    const item = {
        year: $ed748d7f7fd7ff04$var$int(match, cursor),
        month: $ed748d7f7fd7ff04$var$int(match, cursor + 1, 1),
        day: $ed748d7f7fd7ff04$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $ed748d7f7fd7ff04$var$extractISOTime(match, cursor) {
    const item = {
        hours: $ed748d7f7fd7ff04$var$int(match, cursor, 0),
        minutes: $ed748d7f7fd7ff04$var$int(match, cursor + 1, 0),
        seconds: $ed748d7f7fd7ff04$var$int(match, cursor + 2, 0),
        milliseconds: (0, $f530739b8b53bdfe$export$3989d60cf160c565)(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $ed748d7f7fd7ff04$var$extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = (0, $f530739b8b53bdfe$export$f60aa7c70b05722d)(match[cursor + 1], match[cursor + 2]), zone = local ? null : (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $ed748d7f7fd7ff04$var$extractIANAZone(match, cursor) {
    const zone = match[cursor] ? (0, $a04c1328d05994f9$export$2e2bcd8739ae039).create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const $ed748d7f7fd7ff04$var$isoTimeOnly = RegExp(`^T?${$ed748d7f7fd7ff04$var$isoTimeBaseRegex.source}$`);
// ISO duration parsing
const $ed748d7f7fd7ff04$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $ed748d7f7fd7ff04$var$extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(yearStr)),
            months: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(monthStr)),
            weeks: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(weekStr)),
            days: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(dayStr)),
            hours: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(hourStr)),
            minutes: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(minuteStr)),
            seconds: maybeNegate((0, $f530739b8b53bdfe$export$ccc9a81fca9859cb)(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate((0, $f530739b8b53bdfe$export$3989d60cf160c565)(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const $ed748d7f7fd7ff04$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $ed748d7f7fd7ff04$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? (0, $f530739b8b53bdfe$export$b7a39e2df70cc6be)((0, $f530739b8b53bdfe$export$7181a16950b3209d)(yearStr)) : (0, $f530739b8b53bdfe$export$7181a16950b3209d)(yearStr),
        month: $f0e1c06e00207932$export$b4b23bfab2f68498.indexOf(monthStr) + 1,
        day: (0, $f530739b8b53bdfe$export$7181a16950b3209d)(dayStr),
        hour: (0, $f530739b8b53bdfe$export$7181a16950b3209d)(hourStr),
        minute: (0, $f530739b8b53bdfe$export$7181a16950b3209d)(minuteStr)
    };
    if (secondStr) result.second = (0, $f530739b8b53bdfe$export$7181a16950b3209d)(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $f0e1c06e00207932$export$406f4855508be663.indexOf(weekdayStr) + 1 : $f0e1c06e00207932$export$d89a20b736c12a21.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const $ed748d7f7fd7ff04$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $ed748d7f7fd7ff04$var$extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = $ed748d7f7fd7ff04$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = $ed748d7f7fd7ff04$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = (0, $f530739b8b53bdfe$export$f60aa7c70b05722d)(offHourStr, offMinuteStr);
    return [
        result,
        new (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039)(offset)
    ];
}
function $ed748d7f7fd7ff04$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const $ed748d7f7fd7ff04$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $ed748d7f7fd7ff04$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $ed748d7f7fd7ff04$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $ed748d7f7fd7ff04$var$extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = $ed748d7f7fd7ff04$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).utcInstance
    ];
}
function $ed748d7f7fd7ff04$var$extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = $ed748d7f7fd7ff04$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).utcInstance
    ];
}
const $ed748d7f7fd7ff04$var$isoYmdWithTimeExtensionRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$isoYmdRegex, $ed748d7f7fd7ff04$var$isoTimeExtensionRegex);
const $ed748d7f7fd7ff04$var$isoWeekWithTimeExtensionRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$isoWeekRegex, $ed748d7f7fd7ff04$var$isoTimeExtensionRegex);
const $ed748d7f7fd7ff04$var$isoOrdinalWithTimeExtensionRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$isoOrdinalRegex, $ed748d7f7fd7ff04$var$isoTimeExtensionRegex);
const $ed748d7f7fd7ff04$var$isoTimeCombinedRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$isoTimeRegex);
const $ed748d7f7fd7ff04$var$extractISOYmdTimeAndOffset = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOYmd, $ed748d7f7fd7ff04$var$extractISOTime, $ed748d7f7fd7ff04$var$extractISOOffset, $ed748d7f7fd7ff04$var$extractIANAZone);
const $ed748d7f7fd7ff04$var$extractISOWeekTimeAndOffset = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOWeekData, $ed748d7f7fd7ff04$var$extractISOTime, $ed748d7f7fd7ff04$var$extractISOOffset, $ed748d7f7fd7ff04$var$extractIANAZone);
const $ed748d7f7fd7ff04$var$extractISOOrdinalDateAndTime = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOOrdinalData, $ed748d7f7fd7ff04$var$extractISOTime, $ed748d7f7fd7ff04$var$extractISOOffset, $ed748d7f7fd7ff04$var$extractIANAZone);
const $ed748d7f7fd7ff04$var$extractISOTimeAndOffset = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOTime, $ed748d7f7fd7ff04$var$extractISOOffset, $ed748d7f7fd7ff04$var$extractIANAZone);
function $ed748d7f7fd7ff04$export$ee8e61141c87635a(s) {
    return $ed748d7f7fd7ff04$var$parse(s, [
        $ed748d7f7fd7ff04$var$isoYmdWithTimeExtensionRegex,
        $ed748d7f7fd7ff04$var$extractISOYmdTimeAndOffset
    ], [
        $ed748d7f7fd7ff04$var$isoWeekWithTimeExtensionRegex,
        $ed748d7f7fd7ff04$var$extractISOWeekTimeAndOffset
    ], [
        $ed748d7f7fd7ff04$var$isoOrdinalWithTimeExtensionRegex,
        $ed748d7f7fd7ff04$var$extractISOOrdinalDateAndTime
    ], [
        $ed748d7f7fd7ff04$var$isoTimeCombinedRegex,
        $ed748d7f7fd7ff04$var$extractISOTimeAndOffset
    ]);
}
function $ed748d7f7fd7ff04$export$22671fa29093a82f(s) {
    return $ed748d7f7fd7ff04$var$parse($ed748d7f7fd7ff04$var$preprocessRFC2822(s), [
        $ed748d7f7fd7ff04$var$rfc2822,
        $ed748d7f7fd7ff04$var$extractRFC2822
    ]);
}
function $ed748d7f7fd7ff04$export$6eac75d7e2e61231(s) {
    return $ed748d7f7fd7ff04$var$parse(s, [
        $ed748d7f7fd7ff04$var$rfc1123,
        $ed748d7f7fd7ff04$var$extractRFC1123Or850
    ], [
        $ed748d7f7fd7ff04$var$rfc850,
        $ed748d7f7fd7ff04$var$extractRFC1123Or850
    ], [
        $ed748d7f7fd7ff04$var$ascii,
        $ed748d7f7fd7ff04$var$extractASCII
    ]);
}
function $ed748d7f7fd7ff04$export$87483128cec2621c(s) {
    return $ed748d7f7fd7ff04$var$parse(s, [
        $ed748d7f7fd7ff04$var$isoDuration,
        $ed748d7f7fd7ff04$var$extractISODuration
    ]);
}
const $ed748d7f7fd7ff04$var$extractISOTimeOnly = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOTime);
function $ed748d7f7fd7ff04$export$a8603b5245545f3e(s) {
    return $ed748d7f7fd7ff04$var$parse(s, [
        $ed748d7f7fd7ff04$var$isoTimeOnly,
        $ed748d7f7fd7ff04$var$extractISOTimeOnly
    ]);
}
const $ed748d7f7fd7ff04$var$sqlYmdWithTimeExtensionRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$sqlYmdRegex, $ed748d7f7fd7ff04$var$sqlTimeExtensionRegex);
const $ed748d7f7fd7ff04$var$sqlTimeCombinedRegex = $ed748d7f7fd7ff04$var$combineRegexes($ed748d7f7fd7ff04$var$sqlTimeRegex);
const $ed748d7f7fd7ff04$var$extractISOTimeOffsetAndIANAZone = $ed748d7f7fd7ff04$var$combineExtractors($ed748d7f7fd7ff04$var$extractISOTime, $ed748d7f7fd7ff04$var$extractISOOffset, $ed748d7f7fd7ff04$var$extractIANAZone);
function $ed748d7f7fd7ff04$export$425a58f41d7e6b1e(s) {
    return $ed748d7f7fd7ff04$var$parse(s, [
        $ed748d7f7fd7ff04$var$sqlYmdWithTimeExtensionRegex,
        $ed748d7f7fd7ff04$var$extractISOYmdTimeAndOffset
    ], [
        $ed748d7f7fd7ff04$var$sqlTimeCombinedRegex,
        $ed748d7f7fd7ff04$var$extractISOTimeOffsetAndIANAZone
    ]);
}





const $e4064c9a7bfde1e0$var$INVALID = "Invalid Duration";
const $e4064c9a7bfde1e0$export$b2b4559e62423d84 = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $e4064c9a7bfde1e0$export$66b25084afa3c725 = {
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    },
    ...$e4064c9a7bfde1e0$export$b2b4559e62423d84
}, $e4064c9a7bfde1e0$export$afca50ae33abd78b = 365.2425, $e4064c9a7bfde1e0$export$70cde7cbd78deec8 = 30.436875, $e4064c9a7bfde1e0$export$3a9e77e060440793 = {
    years: {
        quarters: 4,
        months: 12,
        weeks: $e4064c9a7bfde1e0$export$afca50ae33abd78b / 7,
        days: $e4064c9a7bfde1e0$export$afca50ae33abd78b,
        hours: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 24,
        minutes: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 1440,
        seconds: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 86400,
        milliseconds: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 86400000
    },
    quarters: {
        months: 3,
        weeks: $e4064c9a7bfde1e0$export$afca50ae33abd78b / 28,
        days: $e4064c9a7bfde1e0$export$afca50ae33abd78b / 4,
        hours: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 24 / 4,
        minutes: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 1440 / 4,
        seconds: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 86400 / 4,
        milliseconds: $e4064c9a7bfde1e0$export$afca50ae33abd78b * 86400000 / 4
    },
    months: {
        weeks: $e4064c9a7bfde1e0$export$70cde7cbd78deec8 / 7,
        days: $e4064c9a7bfde1e0$export$70cde7cbd78deec8,
        hours: $e4064c9a7bfde1e0$export$70cde7cbd78deec8 * 24,
        minutes: $e4064c9a7bfde1e0$export$70cde7cbd78deec8 * 1440,
        seconds: $e4064c9a7bfde1e0$export$70cde7cbd78deec8 * 86400,
        milliseconds: $e4064c9a7bfde1e0$export$70cde7cbd78deec8 * 86400000
    },
    ...$e4064c9a7bfde1e0$export$b2b4559e62423d84
};
// units ordered by size
const $e4064c9a7bfde1e0$var$orderedUnits = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const $e4064c9a7bfde1e0$var$reverseUnits = $e4064c9a7bfde1e0$var$orderedUnits.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $e4064c9a7bfde1e0$var$clone(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : {
            ...dur.values,
            ...alts.values || {}
        },
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $e4064c9a7bfde1e0$export$2e2bcd8739ae039(conf);
}
function $e4064c9a7bfde1e0$var$durationToMillis(matrix, vals) {
    let sum = vals.milliseconds ?? 0;
    for (const unit of $e4064c9a7bfde1e0$var$reverseUnits.slice(1))if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    return sum;
}
// NB: mutates parameters
function $e4064c9a7bfde1e0$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    const factor = $e4064c9a7bfde1e0$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $e4064c9a7bfde1e0$var$orderedUnits.reduceRight((previous, current)=>{
        if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(vals[current])) {
            if (previous) {
                const previousVal = vals[previous] * factor;
                const conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                const rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $e4064c9a7bfde1e0$var$orderedUnits.reduce((previous, current)=>{
        if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(vals[current])) {
            if (previous) {
                const fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $e4064c9a7bfde1e0$var$removeZeroes(vals) {
    const newVals = {};
    for (const [key, value] of Object.entries(vals))if (value !== 0) newVals[key] = value;
    return newVals;
}
class $e4064c9a7bfde1e0$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        let matrix = accurate ? $e4064c9a7bfde1e0$export$3a9e77e060440793 : $e4064c9a7bfde1e0$export$66b25084afa3c725;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new $e4064c9a7bfde1e0$export$2e2bcd8739ae039({
            values: (0, $f530739b8b53bdfe$export$ba17feb4405f3f38)(obj, $e4064c9a7bfde1e0$export$2e2bcd8739ae039.normalizeUnit),
            loc: (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if ((0, $f530739b8b53bdfe$export$7e4aa119212bc614)(durationLike)) return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromMillis(durationLike);
        else if ($e4064c9a7bfde1e0$export$2e2bcd8739ae039.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromObject(durationLike);
        else throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = (0, $ed748d7f7fd7ff04$export$87483128cec2621c)(text);
        if (parsed) return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = (0, $ed748d7f7fd7ff04$export$a8603b5245545f3e)(text);
        if (parsed) return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $e4064c9a7bfde1e0$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof (0, $ed8e6d444ff59212$export$2e2bcd8739ae039) ? reason : new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $c0605f058d18abbe$export$fa63917b8416fe36)(invalid);
        else return new $e4064c9a7bfde1e0$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new (0, $c0605f058d18abbe$export$ac94f561e2d387b4)(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = {
            ...opts,
            floor: opts.round !== false && opts.floor !== false
        };
        return this.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $e4064c9a7bfde1e0$var$INVALID;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ toHuman(opts = {}) {
        if (!this.isValid) return $e4064c9a7bfde1e0$var$INVALID;
        const l = $e4064c9a7bfde1e0$var$orderedUnits.map((unit)=>{
            const val = this.values[unit];
            if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(val)) return null;
            return this.loc.numberFormatter({
                style: "unit",
                unitDisplay: "long",
                ...opts,
                unit: unit.slice(0, -1)
            }).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter({
            type: "conjunction",
            style: opts.listStyle || "narrow",
            ...opts
        }).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return {
            ...this.values
        };
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += (0, $f530739b8b53bdfe$export$7978a6ddf29f4374)(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = {
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended",
            ...opts,
            includeOffset: false
        };
        const dateTime = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Duration { values: ${JSON.stringify(this.values)} }`;
        else return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        if (!this.isValid) return NaN;
        return $e4064c9a7bfde1e0$var$durationToMillis(this.matrix, this.values);
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromDurationLike(duration), result = {};
        for (const k of $e4064c9a7bfde1e0$var$orderedUnits)if ((0, $f530739b8b53bdfe$export$5a15a386532a5ea4)(dur.values, k) || (0, $f530739b8b53bdfe$export$5a15a386532a5ea4)(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = $e4064c9a7bfde1e0$export$2e2bcd8739ae039.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = (0, $f530739b8b53bdfe$export$37576b9ba69b50db)(fn(this.values[k], k));
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[$e4064c9a7bfde1e0$export$2e2bcd8739ae039.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = {
            ...this.values,
            ...(0, $f530739b8b53bdfe$export$ba17feb4405f3f38)(values, $e4064c9a7bfde1e0$export$2e2bcd8739ae039.normalizeUnit)
        };
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, conversionAccuracy: conversionAccuracy, matrix: matrix } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        const opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $e4064c9a7bfde1e0$var$clone(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        $e4064c9a7bfde1e0$var$normalizeValues(this.matrix, vals);
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: vals
        }, true);
    }
    /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ rescale() {
        if (!this.isValid) return this;
        const vals = $e4064c9a7bfde1e0$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>$e4064c9a7bfde1e0$export$2e2bcd8739ae039.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of $e4064c9a7bfde1e0$var$orderedUnits){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ((0, $f530739b8b53bdfe$export$7e4aa119212bc614)(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ((0, $f530739b8b53bdfe$export$7e4aa119212bc614)(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $e4064c9a7bfde1e0$var$normalizeValues(this.matrix, built);
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: built
        }, true);
    }
    /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return $e4064c9a7bfde1e0$var$clone(this, {
            values: negated
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of $e4064c9a7bfde1e0$var$orderedUnits){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
}









const $87c94714c27800a0$var$INVALID = "Invalid Interval";
// checks if the start is equal to or before the end
function $87c94714c27800a0$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $87c94714c27800a0$export$2e2bcd8739ae039.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $87c94714c27800a0$export$2e2bcd8739ae039.invalid("missing or invalid end");
    else if (end < start) return $87c94714c27800a0$export$2e2bcd8739ae039.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
class $87c94714c27800a0$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof (0, $ed8e6d444ff59212$export$2e2bcd8739ae039) ? reason : new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $c0605f058d18abbe$export$cdb4559f04a244ae)(invalid);
        else return new $87c94714c27800a0$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = (0, $f5908f0c310c003f$export$d207855dff529fc9)(start), builtEnd = (0, $f5908f0c310c003f$export$d207855dff529fc9)(end);
        const validateError = $87c94714c27800a0$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new $87c94714c27800a0$export$2e2bcd8739ae039({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(duration), dt = (0, $f5908f0c310c003f$export$d207855dff529fc9)(start);
        return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(duration), dt = (0, $f5908f0c310c003f$export$d207855dff529fc9)(end);
        return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromISO(e, opts);
                if (dur.isValid) return $87c94714c27800a0$export$2e2bcd8739ae039.after(start, dur);
            } else if (endIsValid) {
                const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromISO(s, opts);
                if (dur.isValid) return $87c94714c27800a0$export$2e2bcd8739ae039.before(end, dur);
            }
        }
        return $87c94714c27800a0$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */ get lastDateTime() {
        return this.isValid ? this.e ? this.e.minus(1) : null : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ count(unit = "milliseconds", opts) {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit, opts);
        let end;
        if (opts?.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start: start, end: end } = {}) {
        if (!this.isValid) return this;
        return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map((0, $f5908f0c310c003f$export$d207855dff529fc9)).filter((d)=>this.contains(d)).sort((a, b)=>a.toMillis() - b.toMillis()), results = [];
        let { s: s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push($87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s: s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push($87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push($87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return $87c94714c27800a0$export$2e2bcd8739ae039.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return $87c94714c27800a0$export$2e2bcd8739ae039.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return $87c94714c27800a0$var$INVALID;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
        else return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ toLocaleString(formatOpts = $ed5647aebc823d4b$export$19db5ed0dfbf6b4, opts = {}) {
        return this.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $87c94714c27800a0$var$INVALID;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return $87c94714c27800a0$var$INVALID;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return $87c94714c27800a0$var$INVALID;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return $87c94714c27800a0$var$INVALID;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ toFormat(dateFormat, { separator: separator = " \u2013 " } = {}) {
        if (!this.isValid) return $87c94714c27800a0$var$INVALID;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return $87c94714c27800a0$export$2e2bcd8739ae039.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
}









class $9096cb41e07f61c5$export$2e2bcd8739ae039 {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone) {
        const proto = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return (0, $a04c1328d05994f9$export$2e2bcd8739ae039).isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return (0, $0619280deadc573a$export$4527f24d1e617e9)(input, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
    }
    /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ static getStartOfWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale)).getStartOfWeek();
    }
    /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ static getMinimumDaysInFirstWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale)).getMinDaysInFirstWeek();
    }
    /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ static getWeekendWeekdays({ locale: locale = null, locObj: locObj = null } = {}) {
        // copy the array, because we cache it internally
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale)).getWeekendDays().slice();
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale: locale = null } = {}) {
        return (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale: locale = null } = {}) {
        return (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ static features() {
        return {
            relative: (0, $f530739b8b53bdfe$export$36c4ef3ee752f47f)(),
            localeWeek: (0, $f530739b8b53bdfe$export$deee12cd7a09c6e1)()
        };
    }
}








function $9a5db5e08e2a13ea$var$dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor((0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromMillis(ms).as("days"));
}
function $9a5db5e08e2a13ea$var$highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter + (b.year - a.year) * 4
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = $9a5db5e08e2a13ea$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $9a5db5e08e2a13ea$var$dayDiff
        ]
    ];
    const results = {};
    const earlier = cursor;
    let lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        results[unit] = differ(cursor, later);
        highWater = earlier.plus(results);
        if (highWater > later) {
            // we overshot the end point, backtrack cursor by 1
            results[unit]--;
            cursor = earlier.plus(results);
            // if we are still overshooting now, we need to backtrack again
            // this happens in certain situations when diffing times in different zones,
            // because this calculation ignores time zones
            if (cursor > later) {
                // keep the "overshot by 1" around as highWater
                highWater = cursor;
                // backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
            }
        } else cursor = highWater;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $9a5db5e08e2a13ea$export$2e2bcd8739ae039(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = $9a5db5e08e2a13ea$var$highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}










const $750ecf6f7a9cc8c5$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $750ecf6f7a9cc8c5$var$intUnit(regex, post = (i)=>i) {
    return {
        regex: regex,
        deser: ([s])=>post((0, $4878391f370a69a1$export$b37c688a581b2f6b)(s))
    };
}
const $750ecf6f7a9cc8c5$var$NBSP = String.fromCharCode(160);
const $750ecf6f7a9cc8c5$var$spaceOrNBSP = `[ ${$750ecf6f7a9cc8c5$var$NBSP}]`;
const $750ecf6f7a9cc8c5$var$spaceOrNBSPRegExp = new RegExp($750ecf6f7a9cc8c5$var$spaceOrNBSP, "g");
function $750ecf6f7a9cc8c5$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($750ecf6f7a9cc8c5$var$spaceOrNBSPRegExp, $750ecf6f7a9cc8c5$var$spaceOrNBSP);
}
function $750ecf6f7a9cc8c5$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($750ecf6f7a9cc8c5$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $750ecf6f7a9cc8c5$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($750ecf6f7a9cc8c5$var$fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>$750ecf6f7a9cc8c5$var$stripInsensitivities(s) === $750ecf6f7a9cc8c5$var$stripInsensitivities(i)) + startIndex
    };
}
function $750ecf6f7a9cc8c5$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: ([, h, m])=>(0, $f530739b8b53bdfe$export$f60aa7c70b05722d)(h, m),
        groups: groups
    };
}
function $750ecf6f7a9cc8c5$var$simple(regex) {
    return {
        regex: regex,
        deser: ([s])=>s
    };
}
function $750ecf6f7a9cc8c5$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $750ecf6f7a9cc8c5$var$unitForToken(token, loc) {
    const one = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc), two = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{2}"), three = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{3}"), four = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{4}"), six = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{6}"), oneOrTwo = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{1,2}"), oneToThree = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{1,3}"), oneToSix = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{1,6}"), oneToNine = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{1,9}"), twoToFour = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{2,4}"), fourToSix = (0, $4878391f370a69a1$export$79fd8462ddaefe42)(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp($750ecf6f7a9cc8c5$var$escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $750ecf6f7a9cc8c5$var$intUnit(oneToSix);
            case "yy":
                return $750ecf6f7a9cc8c5$var$intUnit(twoToFour, (0, $f530739b8b53bdfe$export$b7a39e2df70cc6be));
            case "yyyy":
                return $750ecf6f7a9cc8c5$var$intUnit(four);
            case "yyyyy":
                return $750ecf6f7a9cc8c5$var$intUnit(fourToSix);
            case "yyyyyy":
                return $750ecf6f7a9cc8c5$var$intUnit(six);
            // months
            case "M":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "MM":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "MMM":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "LL":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "LLL":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "dd":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            // ordinals
            case "o":
                return $750ecf6f7a9cc8c5$var$intUnit(oneToThree);
            case "ooo":
                return $750ecf6f7a9cc8c5$var$intUnit(three);
            // time
            case "HH":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "H":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "hh":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "h":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "mm":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "m":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "q":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "qq":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "s":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "ss":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            case "S":
                return $750ecf6f7a9cc8c5$var$intUnit(oneToThree);
            case "SSS":
                return $750ecf6f7a9cc8c5$var$intUnit(three);
            case "u":
                return $750ecf6f7a9cc8c5$var$simple(oneToNine);
            case "uu":
                return $750ecf6f7a9cc8c5$var$simple(oneOrTwo);
            case "uuu":
                return $750ecf6f7a9cc8c5$var$intUnit(one);
            // meridiem
            case "a":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $750ecf6f7a9cc8c5$var$intUnit(four);
            case "kk":
                return $750ecf6f7a9cc8c5$var$intUnit(twoToFour, (0, $f530739b8b53bdfe$export$b7a39e2df70cc6be));
            // weekNumber (W)
            case "W":
                return $750ecf6f7a9cc8c5$var$intUnit(oneOrTwo);
            case "WW":
                return $750ecf6f7a9cc8c5$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $750ecf6f7a9cc8c5$var$intUnit(one);
            case "EEE":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $750ecf6f7a9cc8c5$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $750ecf6f7a9cc8c5$var$offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return $750ecf6f7a9cc8c5$var$offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $750ecf6f7a9cc8c5$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $750ecf6f7a9cc8c5$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: $750ecf6f7a9cc8c5$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const $750ecf6f7a9cc8c5$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $750ecf6f7a9cc8c5$var$tokenForPart(part, formatOpts, resolvedOpts) {
    const { type: type, value: value } = part;
    if (type === "literal") {
        const isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    const style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    let actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    let val = $750ecf6f7a9cc8c5$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $750ecf6f7a9cc8c5$var$buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function $750ecf6f7a9cc8c5$var$match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if ((0, $f530739b8b53bdfe$export$5a15a386532a5ea4)(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $750ecf6f7a9cc8c5$var$dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(matches.z)) zone = (0, $a04c1328d05994f9$export$2e2bcd8739ae039).create(matches.z);
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(matches.Z)) {
        if (!zone) zone = new (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039)(matches.Z);
        specificOffset = matches.Z;
    }
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(matches.u)) matches.S = (0, $f530739b8b53bdfe$export$3989d60cf160c565)(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let $750ecf6f7a9cc8c5$var$dummyDateTimeCache = null;
function $750ecf6f7a9cc8c5$var$getDummyDateTime() {
    if (!$750ecf6f7a9cc8c5$var$dummyDateTimeCache) $750ecf6f7a9cc8c5$var$dummyDateTimeCache = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromMillis(1555555555555);
    return $750ecf6f7a9cc8c5$var$dummyDateTimeCache;
}
function $750ecf6f7a9cc8c5$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = (0, $8944558f9072bf37$export$2e2bcd8739ae039).macroTokenToFormatOpts(token.val);
    const tokens = $750ecf6f7a9cc8c5$export$fb8d7a00a19893f6(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $750ecf6f7a9cc8c5$export$518029bd3d2f8586(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>$750ecf6f7a9cc8c5$var$maybeExpandMacroToken(t, locale)));
}
class $750ecf6f7a9cc8c5$export$c758afbeb88a407b {
    constructor(locale, format){
        this.locale = locale;
        this.format = format;
        this.tokens = $750ecf6f7a9cc8c5$export$518029bd3d2f8586((0, $8944558f9072bf37$export$2e2bcd8739ae039).parseFormat(format), locale);
        this.units = this.tokens.map((t)=>$750ecf6f7a9cc8c5$var$unitForToken(t, locale));
        this.disqualifyingUnit = this.units.find((t)=>t.invalidReason);
        if (!this.disqualifyingUnit) {
            const [regexString, handlers] = $750ecf6f7a9cc8c5$var$buildRegex(this.units);
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            const [rawMatches, matches] = $750ecf6f7a9cc8c5$var$match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? $750ecf6f7a9cc8c5$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ];
            if ((0, $f530739b8b53bdfe$export$5a15a386532a5ea4)(matches, "a") && (0, $f530739b8b53bdfe$export$5a15a386532a5ea4)(matches, "H")) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    }
    get isValid() {
        return !this.disqualifyingUnit;
    }
    get invalidReason() {
        return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
}
function $750ecf6f7a9cc8c5$export$8388bdfbc6b581fa(locale, input, format) {
    const parser = new $750ecf6f7a9cc8c5$export$c758afbeb88a407b(locale, format);
    return parser.explainFromTokens(input);
}
function $750ecf6f7a9cc8c5$export$d3d42e05768c662d(locale, input, format) {
    const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = $750ecf6f7a9cc8c5$export$8388bdfbc6b581fa(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $750ecf6f7a9cc8c5$export$fb8d7a00a19893f6(formatOpts, locale) {
    if (!formatOpts) return null;
    const formatter = (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(locale, formatOpts);
    const df = formatter.dtFormatter($750ecf6f7a9cc8c5$var$getDummyDateTime());
    const parts = df.formatToParts();
    const resolvedOpts = df.resolvedOptions();
    return parts.map((p)=>$750ecf6f7a9cc8c5$var$tokenForPart(p, formatOpts, resolvedOpts));
}






const $f5908f0c310c003f$var$INVALID = "Invalid DateTime";
const $f5908f0c310c003f$var$MAX_DATE = 8.64e15;
function $f5908f0c310c003f$var$unsupportedZone(zone) {
    return new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $f5908f0c310c003f$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = (0, $2e8900d0c3709bba$export$5f982b63a73e30d5)(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $f5908f0c310c003f$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = (0, $2e8900d0c3709bba$export$5f982b63a73e30d5)(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $f5908f0c310c003f$var$clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $f5908f0c310c003f$export$2e2bcd8739ae039({
        ...current,
        ...alts,
        old: current
    });
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $f5908f0c310c003f$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $f5908f0c310c003f$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $f5908f0c310c003f$var$objToTS(obj, offset, zone) {
    return $f5908f0c310c003f$var$fixOffset((0, $f530739b8b53bdfe$export$c7c54c08b29e0736)(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $f5908f0c310c003f$var$adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
        ...inst.c,
        year: year,
        month: month,
        day: Math.min(inst.c.day, (0, $f530739b8b53bdfe$export$4169ecd548fbc13a)(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }, millisToAdd = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = (0, $f530739b8b53bdfe$export$c7c54c08b29e0736)(c);
    let [ts, o] = $f5908f0c310c003f$var$fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $f5908f0c310c003f$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone: setZone, zone: zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        const interpretationZone = parsedZone || zone, inst = $f5908f0c310c003f$export$2e2bcd8739ae039.fromObject(parsed, {
            ...opts,
            zone: interpretationZone,
            specificOffset: specificOffset
        });
        return setZone ? inst : inst.setZone(zone);
    } else return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $f5908f0c310c003f$var$toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create((0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $f5908f0c310c003f$var$toISODate(o, extended) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.month);
        c += "-";
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.day);
    } else {
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.month);
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.day);
    }
    return c;
}
function $f5908f0c310c003f$var$toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    let c = (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.hour);
    if (extended) {
        c += ":";
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(Math.trunc(-o.o / 60));
            c += ":";
            c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(Math.trunc(o.o / 60));
            c += ":";
            c += (0, $f530739b8b53bdfe$export$36cf564d487b5178)(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const $f5908f0c310c003f$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f5908f0c310c003f$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f5908f0c310c003f$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const $f5908f0c310c003f$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f5908f0c310c003f$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f5908f0c310c003f$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $f5908f0c310c003f$var$normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new (0, $c0605f058d18abbe$export$ac94f561e2d387b4)(unit);
    return normalized;
}
function $f5908f0c310c003f$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $f5908f0c310c003f$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $f5908f0c310c003f$var$guessOffsetForZone(zone) {
    if ($f5908f0c310c003f$var$zoneOffsetTs === undefined) $f5908f0c310c003f$var$zoneOffsetTs = (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($f5908f0c310c003f$var$zoneOffsetTs);
    const zoneName = zone.name;
    let offsetGuess = $f5908f0c310c003f$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($f5908f0c310c003f$var$zoneOffsetTs);
        $f5908f0c310c003f$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $f5908f0c310c003f$var$quickDT(obj, opts) {
    const zone = (0, $0619280deadc573a$export$4527f24d1e617e9)(opts.zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
    if (!zone.isValid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid($f5908f0c310c003f$var$unsupportedZone(zone));
    const loc = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(opts);
    let ts, o;
    // assume we have the higher-order units
    if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(obj.year)) {
        for (const u of $f5908f0c310c003f$var$orderedUnits)if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(obj[u])) obj[u] = $f5908f0c310c003f$var$defaultUnitValues[u];
        const invalid = (0, $2e8900d0c3709bba$export$b807d5063f9fabd1)(obj) || (0, $2e8900d0c3709bba$export$f087c0ea5c760b87)(obj);
        if (invalid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(invalid);
        const offsetProvis = $f5908f0c310c003f$var$guessOffsetForZone(zone);
        [ts, o] = $f5908f0c310c003f$var$objToTS(obj, offsetProvis, zone);
    } else ts = (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).now();
    return new $f5908f0c310c003f$export$2e2bcd8739ae039({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $f5908f0c310c003f$var$diffRelative(start, end, opts) {
    const round = (0, $f530739b8b53bdfe$export$fce6876652108ab)(opts.round) ? true : opts.round, format = (c, unit)=>{
        c = (0, $f530739b8b53bdfe$export$7978a6ddf29f4374)(c, round || opts.calendary ? 0 : 2, true);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $f5908f0c310c003f$var$lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ let $f5908f0c310c003f$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ const $f5908f0c310c003f$var$zoneOffsetGuessCache = new Map();
class $f5908f0c310c003f$export$2e2bcd8739ae039 {
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)("invalid input") : null) || (!zone.isValid ? $f5908f0c310c003f$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = (0, $f530739b8b53bdfe$export$fce6876652108ab)(config.ts) ? (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                const ot = (0, $f530739b8b53bdfe$export$7e4aa119212bc614)(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $f5908f0c310c003f$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new $f5908f0c310c003f$export$2e2bcd8739ae039({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = $f5908f0c310c003f$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return $f5908f0c310c003f$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = $f5908f0c310c003f$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = (0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).utcInstance;
        return $f5908f0c310c003f$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = (0, $f530739b8b53bdfe$export$871608497c498473)(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid("invalid input");
        const zoneToUse = (0, $0619280deadc573a$export$4527f24d1e617e9)(options.zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
        if (!zoneToUse.isValid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid($f5908f0c310c003f$var$unsupportedZone(zoneToUse));
        return new $f5908f0c310c003f$export$2e2bcd8739ae039({
            ts: ts,
            zone: zoneToUse,
            loc: (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!(0, $f530739b8b53bdfe$export$7e4aa119212bc614)(milliseconds)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -$f5908f0c310c003f$var$MAX_DATE || milliseconds > $f5908f0c310c003f$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid("Timestamp out of range");
        else return new $f5908f0c310c003f$export$2e2bcd8739ae039({
            ts: milliseconds,
            zone: (0, $0619280deadc573a$export$4527f24d1e617e9)(options.zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone),
            loc: (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!(0, $f530739b8b53bdfe$export$7e4aa119212bc614)(seconds)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("fromSeconds requires a numerical input");
        else return new $f5908f0c310c003f$export$2e2bcd8739ae039({
            ts: seconds * 1000,
            zone: (0, $0619280deadc573a$export$4527f24d1e617e9)(options.zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone),
            loc: (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = (0, $0619280deadc573a$export$4527f24d1e617e9)(opts.zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
        if (!zoneToUse.isValid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid($f5908f0c310c003f$var$unsupportedZone(zoneToUse));
        const loc = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(opts);
        const normalized = (0, $f530739b8b53bdfe$export$ba17feb4405f3f38)(obj, $f5908f0c310c003f$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = (0, $2e8900d0c3709bba$export$527e2948b97774c0)(normalized, loc);
        const tsNow = (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).now(), offsetProvis = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.ordinal), containsGregorYear = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.year), containsGregorMD = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.month) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = $f5908f0c310c003f$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $f5908f0c310c003f$var$orderedWeekUnits;
            defaultValues = $f5908f0c310c003f$var$defaultWeekUnitValues;
            objNow = (0, $2e8900d0c3709bba$export$5f982b63a73e30d5)(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $f5908f0c310c003f$var$orderedOrdinalUnits;
            defaultValues = $f5908f0c310c003f$var$defaultOrdinalUnitValues;
            objNow = (0, $2e8900d0c3709bba$export$78dea2ea345b4d9b)(objNow);
        } else {
            units = $f5908f0c310c003f$var$orderedUnits;
            defaultValues = $f5908f0c310c003f$var$defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? (0, $2e8900d0c3709bba$export$48544eeabe120519)(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? (0, $2e8900d0c3709bba$export$32d428c9a6653964)(normalized) : (0, $2e8900d0c3709bba$export$b807d5063f9fabd1)(normalized), invalid = higherOrderInvalid || (0, $2e8900d0c3709bba$export$f087c0ea5c760b87)(normalized);
        if (invalid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? (0, $2e8900d0c3709bba$export$82dcd477cc9ab67d)(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? (0, $2e8900d0c3709bba$export$4ad8037b9961f2a)(normalized) : normalized, [tsFinal, offsetFinal] = $f5908f0c310c003f$var$objToTS(gregorian, offsetProvis, zoneToUse), inst = new $f5908f0c310c003f$export$2e2bcd8739ae039({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        if (!inst.isValid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(inst.invalid);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = (0, $ed748d7f7fd7ff04$export$ee8e61141c87635a)(text);
        return $f5908f0c310c003f$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = (0, $ed748d7f7fd7ff04$export$22671fa29093a82f)(text);
        return $f5908f0c310c003f$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = (0, $ed748d7f7fd7ff04$export$6eac75d7e2e61231)(text);
        return $f5908f0c310c003f$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(text) || (0, $f530739b8b53bdfe$export$fce6876652108ab)(fmt)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("fromFormat requires an input string and a format");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = (0, $750ecf6f7a9cc8c5$export$d3d42e05768c662d)(localeToUse, text, fmt);
        if (invalid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(invalid);
        else return $f5908f0c310c003f$var$parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return $f5908f0c310c003f$export$2e2bcd8739ae039.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = (0, $ed748d7f7fd7ff04$export$425a58f41d7e6b1e)(text);
        return $f5908f0c310c003f$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof (0, $ed8e6d444ff59212$export$2e2bcd8739ae039) ? reason : new (0, $ed8e6d444ff59212$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $c0605f058d18abbe$export$aaeef2cf7fd7967f)(invalid);
        else return new $f5908f0c310c003f$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ static parseFormatForOpts(formatOpts, localeOpts = {}) {
        const tokenList = (0, $750ecf6f7a9cc8c5$export$fb8d7a00a19893f6)(formatOpts, (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(localeOpts));
        return !tokenList ? null : tokenList.map((t)=>t ? t.val : null).join("");
    }
    /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ static expandFormat(fmt, localeOpts = {}) {
        const expanded = (0, $750ecf6f7a9cc8c5$export$518029bd3d2f8586)((0, $8944558f9072bf37$export$2e2bcd8739ae039).parseFormat(fmt), (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromObject(localeOpts));
        return expanded.map((t)=>t.val).join("");
    }
    static resetCache() {
        $f5908f0c310c003f$var$zoneOffsetTs = undefined;
        $f5908f0c310c003f$var$zoneOffsetGuessCache.clear();
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */ get isWeekend() {
        return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */ get localWeekday() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedLocalWeekData(this).weekday : NaN;
    }
    /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */ get localWeekNumber() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */ get localWeekYear() {
        return this.isValid ? $f5908f0c310c003f$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? (0, $2e8900d0c3709bba$export$78dea2ea345b4d9b)(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? (0, $9096cb41e07f61c5$export$2e2bcd8739ae039).months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? (0, $9096cb41e07f61c5$export$2e2bcd8739ae039).months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? (0, $9096cb41e07f61c5$export$2e2bcd8739ae039).weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? (0, $9096cb41e07f61c5$export$2e2bcd8739ae039).weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        const dayMs = 86400000;
        const minuteMs = 60000;
        const localTS = (0, $f530739b8b53bdfe$export$c7c54c08b29e0736)(this.c);
        const oEarlier = this.zone.offset(localTS - dayMs);
        const oLater = this.zone.offset(localTS + dayMs);
        const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        const o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        const ts1 = localTS - o1 * minuteMs;
        const ts2 = localTS - o2 * minuteMs;
        const c1 = $f5908f0c310c003f$var$tsToObj(ts1, o1);
        const c2 = $f5908f0c310c003f$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $f5908f0c310c003f$var$clone(this, {
                ts: ts1
            }),
            $f5908f0c310c003f$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return (0, $f530739b8b53bdfe$export$553d7fa8e3805fc0)(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return (0, $f530739b8b53bdfe$export$4169ecd548fbc13a)(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? (0, $f530739b8b53bdfe$export$3913210603d8e9ae)(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? (0, $f530739b8b53bdfe$export$fcb8e8d76a6f2959)(this.weekYear) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */ get weeksInLocalWeekYear() {
        return this.isValid ? (0, $f530739b8b53bdfe$export$fcb8e8d76a6f2959)(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale: locale, numberingSystem: numberingSystem, calendar: calendar } = (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone((0, $32a49b6c9c34cf62$export$2e2bcd8739ae039).instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone((0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime: keepLocalTime = false, keepCalendarTime: keepCalendarTime = false } = {}) {
        zone = (0, $0619280deadc573a$export$4527f24d1e617e9)(zone, (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid($f5908f0c310c003f$var$unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = $f5908f0c310c003f$var$objToTS(asObj, offsetGuess, zone);
            }
            return $f5908f0c310c003f$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $f5908f0c310c003f$var$clone(this, {
            loc: loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = (0, $f530739b8b53bdfe$export$ba17feb4405f3f38)(values, $f5908f0c310c003f$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = (0, $2e8900d0c3709bba$export$527e2948b97774c0)(normalized, this.loc);
        const settingWeekStuff = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.weekYear) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.weekNumber) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.weekday), containsOrdinal = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.ordinal), containsGregorYear = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.year), containsGregorMD = !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.month) || !(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $c0605f058d18abbe$export$10234d3be7f66e6a)("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = (0, $2e8900d0c3709bba$export$82dcd477cc9ab67d)({
            ...(0, $2e8900d0c3709bba$export$5f982b63a73e30d5)(this.c, minDaysInFirstWeek, startOfWeek),
            ...normalized
        }, minDaysInFirstWeek, startOfWeek);
        else if (!(0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.ordinal)) mixed = (0, $2e8900d0c3709bba$export$4ad8037b9961f2a)({
            ...(0, $2e8900d0c3709bba$export$78dea2ea345b4d9b)(this.c),
            ...normalized
        });
        else {
            mixed = {
                ...this.toObject(),
                ...normalized
            };
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(normalized.day)) mixed.day = Math.min((0, $f530739b8b53bdfe$export$4169ecd548fbc13a)(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = $f5908f0c310c003f$var$objToTS(mixed, this.o, this.zone);
        return $f5908f0c310c003f$var$clone(this, {
            ts: ts,
            o: o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(duration);
        return $f5908f0c310c003f$var$clone(this, $f5908f0c310c003f$var$adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(duration).negate();
        return $f5908f0c310c003f$var$clone(this, $f5908f0c310c003f$var$adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit, { useLocaleWeeks: useLocaleWeeks = false } = {}) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
            case "milliseconds":
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                const startOfWeek = this.loc.getStartOfWeek();
                const { weekday: weekday } = this;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit, opts) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit, opts).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $f5908f0c310c003f$var$INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = $ed5647aebc823d4b$export$19db5ed0dfbf6b4, opts = {}) {
        return this.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $f5908f0c310c003f$var$INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? (0, $8944558f9072bf37$export$2e2bcd8739ae039).create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string|null}
   */ toISO({ format: format = "extended", suppressSeconds: suppressSeconds = false, suppressMilliseconds: suppressMilliseconds = false, includeOffset: includeOffset = true, extendedZone: extendedZone = false } = {}) {
        if (!this.isValid) return null;
        const ext = format === "extended";
        let c = $f5908f0c310c003f$var$toISODate(this, ext);
        c += "T";
        c += $f5908f0c310c003f$var$toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string|null}
   */ toISODate({ format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        return $f5908f0c310c003f$var$toISODate(this, format === "extended");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return $f5908f0c310c003f$var$toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds: suppressMilliseconds = false, suppressSeconds: suppressSeconds = false, includeOffset: includeOffset = true, includePrefix: includePrefix = false, extendedZone: extendedZone = false, format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        let c = includePrefix ? "T" : "";
        return c + $f5908f0c310c003f$var$toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return $f5908f0c310c003f$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return $f5908f0c310c003f$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return $f5908f0c310c003f$var$toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset: includeOffset = true, includeZone: includeZone = false, includeOffsetSpace: includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $f5908f0c310c003f$var$toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : $f5908f0c310c003f$var$INVALID;
    }
    /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
        else return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = {
            ...this.c
        };
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).invalid("created by diffing an invalid DateTime");
        const durOpts = {
            locale: this.locale,
            numberingSystem: this.numberingSystem,
            ...opts
        };
        const units = (0, $f530739b8b53bdfe$export$334480083959f08a)(unit).map((0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = (0, $9a5db5e08e2a13ea$export$2e2bcd8739ae039)(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff($f5908f0c310c003f$export$2e2bcd8739ae039.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */ until(otherDateTime) {
        return this.isValid ? (0, $87c94714c27800a0$export$2e2bcd8739ae039).fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    }
    /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || $f5908f0c310c003f$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $f5908f0c310c003f$var$diffRelative(base, this.plus(padding), {
            ...options,
            numeric: "always",
            units: units,
            unit: unit
        });
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return $f5908f0c310c003f$var$diffRelative(options.base || $f5908f0c310c003f$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), this, {
            ...options,
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        });
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every($f5908f0c310c003f$export$2e2bcd8739ae039.isDateTime)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("min requires all arguments be DateTimes");
        return (0, $f530739b8b53bdfe$export$d322b949ce403225)(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every($f5908f0c310c003f$export$2e2bcd8739ae039.isDateTime)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("max requires all arguments be DateTimes");
        return (0, $f530739b8b53bdfe$export$d322b949ce403225)(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return (0, $750ecf6f7a9cc8c5$export$8388bdfbc6b581fa)(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return $f5908f0c310c003f$export$2e2bcd8739ae039.fromFormatExplain(text, fmt, options);
    }
    /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ static buildFormatParser(fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new (0, $750ecf6f7a9cc8c5$export$c758afbeb88a407b)(localeToUse, fmt);
    }
    /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ static fromFormatParser(text, formatParser, opts = {}) {
        if ((0, $f530739b8b53bdfe$export$fce6876652108ab)(text) || (0, $f530739b8b53bdfe$export$fce6876652108ab)(formatParser)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)("fromFormatParser requires an input string and a format parser");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = (0, $775b735bbc6f5e07$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
        const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = formatParser.explainFromTokens(text);
        if (invalidReason) return $f5908f0c310c003f$export$2e2bcd8739ae039.invalid(invalidReason);
        else return $f5908f0c310c003f$var$parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return $ed5647aebc823d4b$export$19db5ed0dfbf6b4;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return $ed5647aebc823d4b$export$7f19f128b5a661d5;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return $ed5647aebc823d4b$export$7afd5e65ff14ad5f;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return $ed5647aebc823d4b$export$e8af1c0b0290dbe2;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return $ed5647aebc823d4b$export$ab5c0d098dcfe775;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return $ed5647aebc823d4b$export$b4941e7fc62df1ff;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$61c7c50acaa56067;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return $ed5647aebc823d4b$export$417ed025e483567;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return $ed5647aebc823d4b$export$e0d12640fceb849c;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return $ed5647aebc823d4b$export$7333d0894ea2a492;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$2664018dfbf7eca;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return $ed5647aebc823d4b$export$3f5c467c8b3c85f6;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return $ed5647aebc823d4b$export$edc722d6385d5cfa;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return $ed5647aebc823d4b$export$434cdda648f6d8ed;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$115df8ec21cc4422;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return $ed5647aebc823d4b$export$2a10deefdeef9026;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$652ead5a5aee93d0;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return $ed5647aebc823d4b$export$97006f3c2fab9954;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return $ed5647aebc823d4b$export$6fbcfb06dd40694b;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$9ae9ad238dcfe6df;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return $ed5647aebc823d4b$export$c01f9be9042ca6d2;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return $ed5647aebc823d4b$export$c3b12c6a0fb1f516;
    }
}
function $f5908f0c310c003f$export$d207855dff529fc9(dateTimeish) {
    if ($f5908f0c310c003f$export$2e2bcd8739ae039.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && (0, $f530739b8b53bdfe$export$7e4aa119212bc614)(dateTimeish.valueOf())) return $f5908f0c310c003f$export$2e2bcd8739ae039.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $f5908f0c310c003f$export$2e2bcd8739ae039.fromObject(dateTimeish);
    else throw new (0, $c0605f058d18abbe$export$9c711d4a95378233)(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}











const $88cffcdd415fdf75$export$a4ad2735b021c132 = "3.6.1";


var $36c23fe5ce738543$var$_widest_dates_cache = /* @__PURE__ */ new Map();
var $36c23fe5ce738543$var$_widest_labels_cache = /* @__PURE__ */ new Map();
function $36c23fe5ce738543$var$_pick_widest_sample(ctx, samples, format) {
    let longest = [
        {},
        0
    ];
    for (const dt of samples){
        if (!dt.isValid) throw "invalid datetime";
        const text = dt.toLocaleString(format);
        const width = ctx.measureText(text).width;
        if (width > longest[1]) longest = [
            dt,
            width,
            text
        ];
    }
    return longest[0];
}
function $36c23fe5ce738543$var$find_widest_local_date(key, format, ctx, opts) {
    const id = `${format.month}/${format.weekday}`;
    const cached = $36c23fe5ce738543$var$_widest_dates_cache.get(key);
    if (cached) return cached[id];
    const widest_numeric_date = {
        year: 2024,
        month: 12,
        day: 22,
        hour: 23,
        minute: 59,
        second: 59
    };
    const num = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromObject(widest_numeric_date, opts);
    function* months_candidates(base) {
        for(let i = 1; i <= 12; i++)yield base.set({
            month: i
        });
    }
    const sm = $36c23fe5ce738543$var$_pick_widest_sample(ctx, months_candidates(num), {
        month: "short"
    });
    const lm = $36c23fe5ce738543$var$_pick_widest_sample(ctx, months_candidates(num), {
        month: "long"
    });
    function* weekdays_candidates(base) {
        for(let i = 22; i < 29; i++)yield base.set({
            day: i
        });
    }
    const sm_sw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(sm), {
        weekday: "short"
    });
    const sm_lw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(sm), {
        weekday: "long"
    });
    const sm_nw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(sm), {
        weekday: "narrow"
    });
    const lm_sw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(lm), {
        weekday: "short"
    });
    const lm_lw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(lm), {
        weekday: "long"
    });
    const lm_nw = $36c23fe5ce738543$var$_pick_widest_sample(ctx, weekdays_candidates(lm), {
        weekday: "narrow"
    });
    const perms = {
        "undefined/undefined": num,
        "undefined/short": sm_sw,
        "undefined/long": sm_lw,
        "undefined/narrow": sm_nw,
        "numeric/undefined": num,
        "numeric/short": sm_sw,
        "numeric/long": sm_lw,
        "numeric/narrow": sm_nw,
        "2-digit/undefined": num,
        "2-digit/short": sm_sw,
        "2-digit/long": sm_lw,
        "2-digit/narrow": sm_nw,
        "short/undefined": sm,
        "short/short": sm_sw,
        "short/long": sm_lw,
        "short/narrow": sm_nw,
        "long/undefined": lm,
        "long/short": lm_sw,
        "long/long": lm_lw,
        "long/narrow": lm_nw
    };
    const result = Object.fromEntries(Object.entries(perms).map(([k, v])=>[
            k,
            v.toObject()
        ]));
    $36c23fe5ce738543$var$_widest_dates_cache.set(key, result);
    return result[id];
}
function $36c23fe5ce738543$var$measure_max_label_width(format, ctx, opts) {
    const format_key = JSON.stringify(format);
    const dt_key = `${opts.locale || (0, $4f2aa03072c9caa8$export$2e2bcd8739ae039).defaultLocale}/${ctx.font}`;
    const label_key = `${dt_key}/${format_key}`;
    const cached = $36c23fe5ce738543$var$_widest_labels_cache.get(label_key);
    if (cached) return cached;
    const widest_date = $36c23fe5ce738543$var$find_widest_local_date(dt_key, format, ctx, opts);
    const dt = (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromObject(widest_date, opts);
    const label = dt.toLocaleString(format);
    const res = ctx.measureText(label).width;
    $36c23fe5ce738543$var$_widest_labels_cache.set(label_key, res);
    return res;
}
// src/ticks.ts
var $36c23fe5ce738543$export$4473430daf1d3d2a = class {
    /** Generator yielding (possibly infinite) sequence of _SeqTick-s. It's ok to return the ticks
   * before the 'from'
   */ *seq(from) {}
    constructor(top, bottom){
        this.top = top;
        this.bottom = bottom;
    }
    estimate(range, ctx, opts, may_be_long = true) {
        const top = this.top;
        const bottom = this.bottom;
        const normal = $36c23fe5ce738543$var$measure_max_label_width(top.fmt, ctx, opts);
        const major = top.maj_fmt ? $36c23fe5ce738543$var$measure_max_label_width(top.maj_fmt, ctx, opts) : 0;
        const top_est = {
            nticks: range / top.size,
            label_width: Math.max(normal, major)
        };
        let bottom_est;
        if (bottom) {
            const short = $36c23fe5ce738543$var$measure_max_label_width(bottom.short_fmt, ctx, opts);
            const long = may_be_long && bottom.long_fmt ? $36c23fe5ce738543$var$measure_max_label_width(bottom.long_fmt, ctx, opts) : 0;
            bottom_est = {
                nticks: range / bottom.size,
                label_width: Math.max(short, long)
            };
        }
        return {
            top: top_est,
            bottom: bottom_est
        };
    }
    format(dt, is_major, with_bottom, prefer_long_bottom) {
        const top = dt.toLocaleString(is_major && this.top.maj_fmt ? this.top.maj_fmt : this.top.fmt);
        if (!with_bottom || !this.bottom) return top;
        const bottom = dt.toLocaleString(prefer_long_bottom && this.bottom.long_fmt ? this.bottom.long_fmt : this.bottom.short_fmt);
        return [
            top,
            bottom
        ];
    }
    create(from, to, prefer_long_bottom) {
        const ticks = [];
        for (const { dt: dt, is_major: is_major, with_bottom: with_bottom } of this.seq(from)){
            if (dt < from) continue;
            if (dt >= to) break;
            ticks.push({
                value: dt.toMillis(),
                major: is_major,
                label: this.format(dt, is_major, with_bottom, prefer_long_bottom(dt))
            });
        }
        return ticks;
    }
    create_floating(dt, pos, prefer_long_bottom) {
        const bottom = this.bottom;
        const fmt = bottom ? prefer_long_bottom(dt) && bottom.long_fmt ? bottom.long_fmt : bottom.short_fmt : void 0;
        const text = fmt ? dt.toLocaleString(fmt) : "";
        return {
            value: dt.toMillis(),
            label: [
                "",
                pos === "left" ? "\u2026" + text : text + "\u2026"
            ]
        };
    }
    // Convenience method to apply some global changes to formats.
    // Intended to override hour12, numeric => 2-digit etc
    patch_formats(patch) {
        var _a, _b;
        function apply(dst) {
            for (const e of Object.entries(patch)){
                const k = e[0];
                const v = e[1];
                if (k === "hour12" && dst.hour) dst.hour12 = v;
                if (dst[k]) dst[k] = e[1];
            }
        }
        apply(this.top.fmt);
        this.top.maj_fmt && apply(this.top.maj_fmt);
        ((_a = this.bottom) == null ? void 0 : _a.short_fmt) && apply(this.bottom.short_fmt);
        ((_b = this.bottom) == null ? void 0 : _b.long_fmt) && apply(this.bottom.long_fmt);
    }
};
var $36c23fe5ce738543$var$MonoTickGenerator = class extends $36c23fe5ce738543$export$4473430daf1d3d2a {
    constructor(top, bottom){
        const { fmt: fmt, maj_fmt: maj_fmt, align: align, maj_unit: maj_unit, ...top_duration } = top;
        super({
            fmt: fmt,
            maj_fmt: maj_fmt,
            size: (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromDurationLike(top_duration).toMillis()
        }, bottom && {
            ...bottom,
            size: (0, $e4064c9a7bfde1e0$export$2e2bcd8739ae039).fromObject({
                [bottom.unit]: 1
            }).toMillis()
        });
        this.step = top_duration;
        this.bottom_unit = bottom == null ? void 0 : bottom.unit;
        this.align = align;
        this.maj_unit = maj_unit;
    }
    *seq(from) {
        let dt = from.startOf(this.align);
        while(true){
            const with_bottom = this.bottom_unit ? dt.startOf(this.bottom_unit).equals(dt) : false;
            const is_major = this.maj_unit ? dt.startOf(this.maj_unit).equals(dt) : false;
            yield {
                dt: dt,
                is_major: is_major,
                with_bottom: with_bottom
            };
            dt = dt.plus(this.step);
        }
    }
};
var $36c23fe5ce738543$export$38455841d1ec5553 = class extends $36c23fe5ce738543$export$4473430daf1d3d2a {
    constructor(top, bottom){
        super({
            ...top,
            size: top.step * 86400000
        }, bottom && {
            ...bottom,
            size: 2592000000
        });
        this.days = top.days;
        this.maj_days = top.maj_days ?? [
            1
        ];
        this.bottom_days = bottom ? bottom.days ?? [
            1
        ] : [];
    }
    *seq(from) {
        let mdt = from.startOf("month");
        while(true){
            for (const day of this.days){
                const dt = mdt.set({
                    day: day
                });
                const is_major = this.maj_days.includes(day);
                const with_bottom = this.bottom_days.includes(day);
                yield {
                    dt: dt,
                    is_major: is_major,
                    with_bottom: with_bottom
                };
            }
            mdt = mdt.plus({
                month: 1
            });
        }
    }
};
var $36c23fe5ce738543$export$13bf390462545989 = class extends $36c23fe5ce738543$export$4473430daf1d3d2a {
    constructor(by_years, top){
        super({
            ...top,
            size: by_years * 31536000000
        });
        this.by_years = by_years;
    }
    *seq(from) {
        const start = (from.year / this.by_years | 0) * this.by_years;
        let dt = from.startOf("year").set({
            year: start
        });
        while(true){
            yield {
                dt: dt,
                is_major: false,
                with_bottom: false
            };
            dt = dt.plus({
                year: this.by_years
            });
        }
    }
};
// src/defgens.ts
var $36c23fe5ce738543$export$8ae7ccd057501b8a = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
};
var $36c23fe5ce738543$export$e8ae668e70e7a813 = {
    hour: "numeric",
    minute: "numeric"
};
var $36c23fe5ce738543$export$a30849230926a50d = {
    day: "numeric"
};
var $36c23fe5ce738543$export$7d04837a8b9fcd79 = {
    month: "short"
};
var $36c23fe5ce738543$export$90b88dc425a06a95 = {
    year: "numeric"
};
var $36c23fe5ce738543$export$15f76f95890c1a7 = {
    year: "numeric",
    month: "short",
    day: "numeric"
};
var $36c23fe5ce738543$export$e0f83eb934767bac = {
    year: "numeric",
    month: "short"
};
var $36c23fe5ce738543$export$3c37c3bdb860ae1e = {
    month: "short",
    day: "numeric"
};
var $36c23fe5ce738543$export$b49025510e3cf32 = [
    // seconds
    new $36c23fe5ce738543$var$MonoTickGenerator({
        second: 1,
        align: "second",
        maj_unit: "minute",
        fmt: $36c23fe5ce738543$export$8ae7ccd057501b8a,
        maj_fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        second: 5,
        align: "minute",
        maj_unit: "minute",
        fmt: $36c23fe5ce738543$export$8ae7ccd057501b8a,
        maj_fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        second: 10,
        align: "minute",
        maj_unit: "minute",
        fmt: $36c23fe5ce738543$export$8ae7ccd057501b8a,
        maj_fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        second: 30,
        align: "minute",
        maj_unit: "minute",
        fmt: $36c23fe5ce738543$export$8ae7ccd057501b8a,
        maj_fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    // minutes
    new $36c23fe5ce738543$var$MonoTickGenerator({
        minute: 1,
        align: "minute",
        maj_unit: "hour",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        minute: 5,
        align: "hour",
        maj_unit: "hour",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        minute: 10,
        align: "hour",
        maj_unit: "hour",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        minute: 15,
        align: "hour",
        maj_unit: "hour",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        minute: 30,
        align: "hour",
        maj_unit: "hour",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    // hours
    new $36c23fe5ce738543$var$MonoTickGenerator({
        hour: 1,
        align: "hour",
        maj_unit: "day",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        hour: 3,
        align: "day",
        maj_unit: "day",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        hour: 6,
        align: "day",
        maj_unit: "day",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        hour: 12,
        align: "day",
        maj_unit: "day",
        fmt: $36c23fe5ce738543$export$e8ae668e70e7a813
    }, {
        unit: "day",
        short_fmt: $36c23fe5ce738543$export$3c37c3bdb860ae1e,
        long_fmt: $36c23fe5ce738543$export$15f76f95890c1a7
    }),
    // days
    new $36c23fe5ce738543$var$MonoTickGenerator({
        day: 1,
        align: "day",
        maj_unit: "month",
        fmt: $36c23fe5ce738543$export$a30849230926a50d
    }, {
        unit: "month",
        short_fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79,
        long_fmt: $36c23fe5ce738543$export$e0f83eb934767bac
    }),
    new $36c23fe5ce738543$export$38455841d1ec5553({
        days: [
            1,
            5,
            10,
            15,
            20,
            25
        ],
        step: 5,
        fmt: $36c23fe5ce738543$export$a30849230926a50d
    }, {
        short_fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79,
        long_fmt: $36c23fe5ce738543$export$e0f83eb934767bac
    }),
    new $36c23fe5ce738543$export$38455841d1ec5553({
        days: [
            1,
            10,
            20
        ],
        step: 10,
        fmt: $36c23fe5ce738543$export$a30849230926a50d
    }, {
        short_fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79,
        long_fmt: $36c23fe5ce738543$export$e0f83eb934767bac
    }),
    new $36c23fe5ce738543$export$38455841d1ec5553({
        days: [
            1,
            15
        ],
        step: 15,
        fmt: $36c23fe5ce738543$export$a30849230926a50d
    }, {
        short_fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79,
        long_fmt: $36c23fe5ce738543$export$e0f83eb934767bac
    }),
    // months. luxon threats month duration as 30 days in default 'casual' mode
    new $36c23fe5ce738543$var$MonoTickGenerator({
        month: 1,
        align: "month",
        maj_unit: "year",
        fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79
    }, {
        unit: "year",
        short_fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        month: 3,
        align: "year",
        maj_unit: "year",
        fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79
    }, {
        unit: "year",
        short_fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$var$MonoTickGenerator({
        month: 6,
        align: "year",
        maj_unit: "year",
        fmt: $36c23fe5ce738543$export$7d04837a8b9fcd79
    }, {
        unit: "year",
        short_fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    // years. year duration is 365 days by default
    new $36c23fe5ce738543$export$13bf390462545989(1, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$export$13bf390462545989(5, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$export$13bf390462545989(10, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$export$13bf390462545989(25, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$export$13bf390462545989(50, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    new $36c23fe5ce738543$export$13bf390462545989(100, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    }),
    // fallback )
    new $36c23fe5ce738543$export$13bf390462545989(1e3, {
        fmt: $36c23fe5ce738543$export$90b88dc425a06a95
    })
];
// src/scale.ts
var $36c23fe5ce738543$export$c4b78600b209f738 = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
};
var $36c23fe5ce738543$export$84d073ef2c3acc17 = class extends (0, $367ab585cb12ed65$export$d60cfc58d3c358b6) {
    constructor(cfg){
        var _a, _b, _c, _d, _e;
        super(cfg);
        const opts = (_c = (_b = (_a = cfg.chart) == null ? void 0 : _a.config.options) == null ? void 0 : _b.scales) == null ? void 0 : _c[cfg.id];
        const gens = ((_d = opts == null ? void 0 : opts.timestack) == null ? void 0 : _d.make_tick_generators) ? (_e = opts == null ? void 0 : opts.timestack) == null ? void 0 : _e.make_tick_generators() : $36c23fe5ce738543$export$b49025510e3cf32;
        this._gens = gens;
        if (opts == null ? void 0 : opts.timestack.format_style) for (const gen of gens)gen.patch_formats(opts == null ? void 0 : opts.timestack.format_style);
    }
    init(options) {
        this._dt_opts = options.timestack.datetime ?? {};
        super.init(options);
    }
    determineDataLimits() {
        let { min: min, max: max } = this.getMinMax(false);
        min = isFinite(min) ? min : this._dt_now().startOf("day").toMillis();
        max = isFinite(max) ? max : this._dt_now().endOf("day").toMillis() + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _dt_from_ts(ts) {
        return (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromMillis(ts, this._dt_opts);
    }
    _dt_from_object(obj) {
        return (0, $f5908f0c310c003f$export$2e2bcd8739ae039).fromObject(obj, this._dt_opts);
    }
    _dt_now() {
        return (0, $f5908f0c310c003f$export$2e2bcd8739ae039).local(this._dt_opts);
    }
    // Choosing the generator with density < max density and closest to the wanted one.
    // Then number of ticks is checked against the maxTicksLimit too
    _choose_gen(range) {
        const gens = this._gens;
        const density_limit = this.options.timestack.max_density;
        const want_density = this.options.timestack.density;
        const nticks_limit = this.options.ticks.maxTicksLimit ?? Infinity;
        const candidates = [];
        for (const gen of gens){
            const { top: top, bottom: bottom } = gen.estimate(range, this.ctx, this._dt_opts);
            const max_nticks = Math.max(top.nticks, (bottom == null ? void 0 : bottom.nticks) ?? 0);
            const top_density = top.nticks * top.label_width / this.width;
            const bottom_density = bottom ? bottom.nticks * bottom.label_width / this.width : 0;
            const max_density = Math.max(top_density, bottom_density);
            if (max_density <= density_limit && max_nticks <= nticks_limit) candidates.push([
                gen,
                Math.abs(max_density - want_density)
            ]);
        }
        if (!candidates.length) return void 0;
        const best = candidates.reduce((prev, cur)=>cur[1] < prev[1] ? cur : prev);
        return best[0];
    }
    _need_floating_left_tick(ticks_with_bottoms) {
        const thres = this.options.timestack.left_floating_tick_thres;
        if (thres === false) return false;
        if (!ticks_with_bottoms.length) return true;
        const neigh_rel = (ticks_with_bottoms[0].value - this.min) / (this.max - this.min);
        return neigh_rel > thres;
    }
    _need_floating_right_tick(ticks_with_bottoms) {
        const thres = this.options.timestack.right_floating_tick_thres;
        if (thres === false) return false;
        if (!ticks_with_bottoms.length) return true;
        const neigh_rel = (this.max - ticks_with_bottoms[ticks_with_bottoms.length - 1].value) / (this.max - this.min);
        return neigh_rel > thres;
    }
    _build_ticks() {
        const { min: min, max: max } = this;
        const gen = this._choose_gen(max - min);
        if (!gen) {
            console.warn("Failed to choose the tick generator");
            return [];
        }
        const min_dt = this._dt_from_ts(min);
        const max_dt = this._dt_from_ts(max);
        const now_dt = this._dt_now();
        const prefer_long_bottom = (dt)=>!dt.hasSame(now_dt, "year");
        const ticks = gen.create(min_dt, max_dt, prefer_long_bottom);
        if (!gen.bottom) return ticks;
        const ticks_with_bottoms = ticks.filter((t)=>Array.isArray(t.label) && t.label.length > 1);
        if (this._need_floating_left_tick(ticks_with_bottoms)) {
            let tick;
            tick = gen.create_floating(min_dt, "left", prefer_long_bottom);
            if (ticks_with_bottoms.length) {
                const neigh = ticks_with_bottoms[0];
                const width = this.ctx.measureText(tick.label[1]).width;
                const space = (neigh.value - this.min) * this.width / (this.max - this.min);
                if (width * 2 > space) tick = void 0;
            }
            if (tick) ticks.unshift(tick);
        }
        if (this._need_floating_right_tick(ticks_with_bottoms)) {
            let tick;
            tick = gen.create_floating(max_dt, "right", prefer_long_bottom);
            if (ticks_with_bottoms.length) {
                const neigh = ticks_with_bottoms[ticks_with_bottoms.length - 1];
                const width = this.ctx.measureText(tick.label[1]).width;
                const space = (this.max - neigh.value) * this.width / (this.max - this.min);
                if (width * 2 > space) tick = void 0;
            }
            if (tick) ticks.push(tick);
        }
        return ticks;
    }
    buildTicks() {
        let font;
        try {
            font = this._resolveTickFontOptions(0).string;
        } catch  {
            console.warn("failed to resolve the font");
        }
        this.ctx.save();
        if (font) this.ctx.font = font;
        const ticks = this._build_ticks();
        this.ctx.restore();
        return ticks;
    }
    getLabelForValue(value) {
        return this._dt_from_ts(value).toLocaleString(this.options.timestack.tooltip_format);
    }
    // noop. ticks are already generated in single pass
    generateTickLabels(ticks) {}
    // took these from timescale w/o offsets
    getPixelForValue(value) {
        const pos = value === null ? NaN : (value - this.min) / (this.max - this.min);
        return this.getPixelForDecimal(pos);
    }
    getValueForPixel(pixel) {
        const pos = this.getDecimalForPixel(pixel);
        return this.min + pos * (this.max - this.min);
    }
};
$36c23fe5ce738543$export$84d073ef2c3acc17.id = "timestack";
$36c23fe5ce738543$export$84d073ef2c3acc17.defaults = {
    timestack: {
        tooltip_format: $36c23fe5ce738543$export$c4b78600b209f738,
        density: 0.5,
        max_density: 0.75,
        left_floating_tick_thres: 0.33,
        right_floating_tick_thres: false
    },
    ticks: {
        // @ts-ignore : this one is needed to prevent the autoSkip purging our ticks.
        // otherwise autoSkip=false is ignored by the core Scale class
        source: "",
        maxRotation: 0,
        autoSkip: false
    }
};
// src/index.ts
(0, $367ab585cb12ed65$export$acaa6426d77a227e).register($36c23fe5ce738543$export$84d073ef2c3acc17);


window.getIconByMime = (0, $61602e53fa3950f8$export$8dd1e18e1afcf33c);
window.getIcon = (0, $61602e53fa3950f8$export$16b26cd5e98d9100);
(0, $dc6El.default).plugin((0, $jjFgX.default));
(0, $dc6El.default).plugin((0, $88fc130f586896c1$export$2e2bcd8739ae039));
(0, $dc6El.default).plugin((0, $83bfdc0c6067767d$export$2e2bcd8739ae039));
window.Alpine = (0, $dc6El.default);
window.getApiFetcher = function(baseUrl, contentType = "multipart/form-data", timeout = 30000) {
    const api = (0, $eb999ef253053d6e$export$2e2bcd8739ae039).create({
        baseURL: baseUrl,
        headers: {
            "Content-Type": contentType
        },
        timeout: timeout,
        withCredentials: true
    });
    // Add a response interceptor to handle HTTP 401
    api.interceptors.response.use((response)=>response, (error)=>{
        if (error.response && error.response.status === 401) {
            // Perform special functions for HTTP 401 error
            console.debug("HTTP 401 Unauthorized error encountered");
            (0, $dc6El.default).store("profileStore").unauthenticated = true;
        }
        return Promise.reject(error);
    });
    (0, $3a262adf5ef57145$export$2e2bcd8739ae039)(api, {
        retries: 3,
        //retryDelay: axiosRetry.exponentialDelay,
        retryDelay: (retryNumber = 0, _error, delayFactor = 300 // Slow down there, cowboy
        )=>{
            const delay = 2 ** retryNumber * delayFactor;
            const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
            return delay + randomSum;
        },
        retryCondition: (error)=>{
            return (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isNetworkOrIdempotentRequestError(error) || (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isSafeRequestError(error) || (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isRetryableError(error);
        }
    });
    return api;
};
// Image variants pre-cache
window.imageVariantsPrecache = async (urls)=>{
    const promises = urls.map((url)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>{
                img.onload = null;
                img.onerror = null;
                img.src = "";
                resolve();
            };
            img.onerror = ()=>{
                img.onload = null;
                img.onerror = null;
                img.src = "";
                reject(new Error(`Failed to load image: ${url}`));
            };
            img.src = url;
        });
    });
    try {
        await Promise.all(promises);
        console.log("All images preloaded successfully.");
    } catch (error) {
        console.error("Error preloading images:", error);
    }
};
// Check URLs Virus scanning status
window.checkMediaVirusScanStatus = async (url, mediaType)=>{
    if ([
        "image",
        "video",
        "audio"
    ].includes(mediaType)) // No scan needed for images, videos, and audio
    return null;
    // HEAD request to check the URL
    return fetch(url, {
        method: "HEAD",
        credentials: "include",
        mode: "cors",
        cache: "no-store",
        redirect: "follow",
        referrerPolicy: "no-referrer",
        onerror: (error)=>{
            console.error("Error scanning URL:", error);
            return false;
        }
    }).then((response)=>{
        switch(response.status){
            case 200:
                // If the user is logged in, check the heasders for the virus scan status
                const scanStatus = response.headers.get("x-virus-scan-result") || "pending"; // Default to pending
                const scanMessage = response.headers.get("x-virus-scan-message") || "Pending virus scan"; // Default to pending
                const scanDate = response.headers.get("x-virus-scan-date") || "Pending virus scan"; // Default to pending
                const scanVersion = response.headers.get("x-virus-scan-version") || "Pending virus scan"; // Default to pending
                console.debug("URL scan status:", scanStatus, scanMessage, scanDate, scanVersion);
                return {
                    status: scanStatus,
                    message: scanMessage,
                    date: scanDate,
                    version: scanVersion,
                    previewMessage: ()=>{
                        switch(scanStatus){
                            case "clean":
                                return "Scanned & clean";
                            case "pending":
                                return "Pending virus scan";
                            case "infected":
                                return "Infected with virus";
                            default:
                                return "Unknown status";
                        }
                    }
                };
            case 403:
                return {
                    status: "pending",
                    message: "Pending virus scan",
                    date: "Pending virus scan",
                    version: "Pending virus scan",
                    previewMessage: "Pending virus scan"
                };
            case 451:
                return {
                    status: "infected",
                    message: "Infected with virus",
                    date: "Infected with virus",
                    version: "Infected with virus",
                    previewMessage: "Infected with virus"
                };
            default:
                return {
                    status: "unknown",
                    message: "Unknown status",
                    date: "Unknown status",
                    version: "Unknown status",
                    previewMessage: "Unknown status"
                };
        }
    }).catch((error)=>{
        console.error("Error scanning URL:", error);
        return {
            status: "unknown",
            message: "Unknown status",
            date: "Unknown status",
            version: "Unknown status",
            previewMessage: "Unknown status"
        };
    });
};
window.formatBytes = (bytes)=>{
    if (bytes === 0 || isNaN(bytes)) return "0 Bytes";
    const k = 1024;
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + sizes[i];
};
window.downloadFile = (url, element = document.body)=>{
    url = url + "?download=true";
    const a = document.createElement("a");
    a.href = url;
    element.appendChild(a);
    a.click();
    element.removeChild(a);
};
window.loadBTCPayJS = ()=>{
    // Check if the script is already loaded
    if (!document.querySelector('script[src="https://btcpay.nostr.build/modal/btcpay.js"]')) {
        // Create a new script element
        const script = document.createElement("script");
        script.src = "https://btcpay.nostr.build/modal/btcpay.js";
        script.async = true;
        // Append the script to the body
        document.body.appendChild(script);
        script.onload = function() {
            console.log("Script loaded successfully");
        };
        script.onerror = function() {
            console.log("Failed to load the script");
        };
    }
};
window.abbreviateBech32 = (bech32Address)=>{
    return typeof bech32Address === "string" ? `${bech32Address.substring(0, 15)}...${bech32Address.substring(bech32Address.length - 10)}` : "";
};
const $541ddb8841663b5e$var$captureVideoFrame = (video, scaleFactor, time)=>{
    if (scaleFactor == null) scaleFactor = 1;
    if (time) video.currentTime = time;
    const w = video.videoWidth * scaleFactor;
    const h = video.videoHeight * scaleFactor;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, w, h);
    return canvas.toDataURL("image/jpeg");
};
function $541ddb8841663b5e$var$dataUrlToFile(dataUrl, filename) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--)u8arr[n] = bstr.charCodeAt(n);
    return new File([
        u8arr
    ], filename, {
        type: mime
    });
}
window.uploadVideoPoster = (videoId, fileId, scaleFactor, time, callback, errorCB)=>{
    const video = document.getElementById(videoId);
    const dataUrl = $541ddb8841663b5e$var$captureVideoFrame(video, scaleFactor, time);
    const file = $541ddb8841663b5e$var$dataUrlToFile(dataUrl, "poster.jpg");
    const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
    const formData = new FormData();
    formData.append("action", "upload_video_poster");
    formData.append("fileId", fileId);
    formData.append("file", file);
    api.post("", formData).then((response)=>response.data).then((data1)=>{
        if (data1.error) {
            console.error("Error uploading video poster:", data1.error);
            if (typeof errorCB === "function") errorCB(data1);
            return;
        }
        console.debug("Video poster uploaded:", data1);
        if (typeof callback === "function") callback(data1);
    }).catch((error)=>{
        if (typeof errorCB === "function") errorCB(data);
        console.error("Error uploading video poster:", error);
    });
};
// Function to check if URL returns http-200 using HEAD request, and return that url back,
// or null if any other status
window.checkURL = async (url)=>{
    return fetch(url, {
        method: "HEAD",
        redirect: "manual",
        credentials: "include",
        mode: "cors",
        referrerPolicy: "no-referrer",
        onerror: (error)=>{
            console.error("Error checking URL:", error);
            return null;
        }
    }).then((response)=>{
        if (response.ok && response.status === 200) return url;
        return null;
    }).catch((error)=>{
        console.error("Error checking URL:", error);
        return null;
    });
};
// AlpineJS components and stores
document.addEventListener("alpine:init", ()=>{
    console.debug("Alpine started");
});
document.addEventListener("alpine:initialized", ()=>{
    console.debug("Alpine initialized");
    const menuStore1 = (0, $dc6El.default).store("menuStore");
    menuStore1.alpineInitiated = true;
});
const $541ddb8841663b5e$var$apiUrl = `https://${window.location.hostname}/account/api.php`;
// TODO: Intercept back and forward navigation history
function $541ddb8841663b5e$var$updateHashURL(f, p, replace = false) {
    const params = new URLSearchParams(window.location.hash.slice(1));
    if (f) params.set("f", encodeURIComponent(f));
    if (p) params.set("p", encodeURIComponent(p));
    if (replace) window.history.replaceState(null, null, `#${params.toString()}`);
    else history.pushState(null, null, `#${params.toString()}`);
}
function $541ddb8841663b5e$var$getUpdatedHashLink(f, p) {
    const params = new URLSearchParams(window.location.hash.slice(1));
    if (f) params.set("f", encodeURIComponent(f));
    if (p) params.set("p", encodeURIComponent(p));
    return `#${params.toString()}`;
}
function $541ddb8841663b5e$var$getHashParams() {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const folder = decodeURIComponent(params.get("f"));
    const page = decodeURIComponent(params.get("p"));
    return {
        folder: folder,
        page: page
    };
}
window.logoutAndRedirectHome = ()=>{
    const logoutApi = `https://${window.location.hostname}/api/v2/account/logout`;
    const api = getApiFetcher(logoutApi, "application/json");
    api.get("", {}).then(()=>{
        setTimeout(()=>{
            window.location.href = `https://${window.location.hostname}/`;
        }, 1500);
    }).catch(()=>{
        window.location.href = `https://${window.location.hostname}/`;
    });
};
window.copyUrlToClipboard = (url)=>{
    navigator.clipboard.writeText(url).then(()=>{
        console.debug("URL copied to clipboard:", url);
    }).catch((error)=>{
        console.error("Error copying URL to clipboard:", error);
    });
};
window.copyTextToClipboard = (text, callbackOn = null, callbackOff = null)=>{
    navigator.clipboard.writeText(text).then(()=>{
        console.debug("Text copied to clipboard:", text);
        if (typeof callbackOn === "function") callbackOn();
        if (typeof callbackOff === "function") setTimeout(()=>{
            callbackOff();
        }, 2000);
    }).catch((error)=>{
        console.error("Error copying text to clipboard:", error);
    });
};
// Format number in a human-readable format
window.formatNumber = (num)=>{
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
// Abbreviate number to a human-readable format (e.g. 1k, 1M, 1B)
window.abbreviateNumber = (value)=>{
    const suffixes = [
        "",
        "k",
        "M",
        "B",
        "T"
    ];
    let suffixNum = 0;
    // Ensure the value is a number
    if (typeof value !== "number" || isNaN(value)) return value;
    while(Math.abs(value) >= 1000 && suffixNum < suffixes.length - 1){
        value /= 1000;
        suffixNum++;
    }
    // If the value is a whole number, return it without decimals
    const isWholeNumber = Number.isInteger(value);
    const formattedValue = isWholeNumber ? value.toFixed(0) : value.toFixed(1);
    return formattedValue + suffixes[suffixNum];
};
// Constants
const $541ddb8841663b5e$var$aiImagesFolderName = "AI: Generated Images";
const $541ddb8841663b5e$var$homeFolderName = "Home: Main Folder";
(0, $dc6El.default).store("profileStore", {
    profileDataInitialized: false,
    unauthenticated: false,
    init () {
        if (!this.profileDataInitialized) this.refreshProfileInfo().then(()=>{
            this.profileDataInitialized = true;
        });
    },
    profileInfo: {
        userId: 0,
        name: "",
        npub: "",
        pfpUrl: "",
        wallet: "",
        defaultFolder: "",
        allowNostrLogin: undefined,
        npubVerified: undefined,
        accountLevel: 0,
        accountFlags: {},
        remainingDays: 0,
        subscriptionExpired: null,
        storageUsed: 0,
        storageLimit: 0,
        totalStorageLimit: "",
        availableCredits: 0,
        debitedCredits: 0,
        creditedCredits: 0,
        referralCode: "",
        get creatorPageLink () {
            return `https://${window.location.hostname}/creators/creator/?user=${this.userId}`;
        },
        get storageRemaining () {
            return this.storageLimit - this.storageUsed;
        },
        get storageOverLimit () {
            return this.storageRemaining <= 0;
        },
        get planName () {
            switch(this.accountLevel){
                case 0:
                    return "Free";
                case 1:
                    return "Creator";
                case 2:
                    return "Professional";
                case 3:
                case 4:
                case 5:
                    return "Legacy";
                case 10:
                    return "Advanced";
                case 89:
                    return "Moderator";
                case 99:
                    return "Admin";
                default:
                    return "Unknown";
            }
        },
        get isAdmin () {
            return this.accountLevel === 99;
        },
        get isModerator () {
            return this.accountFlags?.canModerate || this.isAdmin;
        },
        get accountExpired () {
            return this.remainingDays <= 0;
        },
        get accountExpiredDisplay () {
            return this.accountExpired ? "Expired" : "Active";
        },
        get accountEligibleForRenewal () {
            return this.remainingDays <= 180;
        },
        get accountEligibleForUpgrade () {
            return this.accountLevel < 10 || this.accountLevel === 89;
        },
        getNameDisplay () {
            return this.name.substring(0, 15) + (this.name.length > 15 ? "..." : "");
        },
        getNpubDisplay () {
            return this.npub.substring(0, 15) + (this.npub.length > 15 ? "..." : "");
        },
        storageRatio () {
            return Math.min(1, Math.max(0, this.storageUsed / this.storageLimit));
        },
        getStorageRatio () {
            return this.storageOverLimit ? 1 : this.storageRatio();
        },
        // Feature flags. This is enforced on the server side, the following only provides the client side checks
        // AI Studio
        get isAIStudioEligible () {
            return [
                2,
                1,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired && !this.storageOverLimit;
        },
        // AI Studio Models
        // Dream Shaper
        get isAIDreamShaperEligible () {
            return [
                2,
                1,
                10,
                99
            ].includes(this.accountLevel) && this.isAIStudioEligible && !this.accountExpired && !this.storageOverLimit;
        },
        // SDXL-Lightning
        get isAISDXLLightningEligible () {
            return [
                2,
                1,
                10,
                99
            ].includes(this.accountLevel) && this.isAIStudioEligible && !this.accountExpired && !this.storageOverLimit;
        },
        // Stable Diffusion
        get isAISDiffusionEligible () {
            return [
                2,
                1,
                10,
                99
            ].includes(this.accountLevel) && this.isAIStudioEligible && !this.accountExpired && !this.storageOverLimit;
        },
        // FLUX.1 [schnell]
        get isFluxSchnellEligible () {
            return [
                1,
                10,
                99
            ].includes(this.accountLevel) && this.isAIStudioEligible && !this.accountExpired && !this.storageOverLimit;
        },
        // SD Core
        get isSDCoreEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && this.isAIStudioEligible && !this.accountExpired && !this.storageOverLimit;
        },
        // AI Tools
        get isAIToolsEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // Other Features
        // Creators Page
        get isCreatorsPageEligible () {
            return [
                1,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // Nostr Share
        get isNostrShareEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // General upload and URL Import
        get isUploadEligible () {
            // All unexpired accounts can upload with available storage
            return [
                1,
                2,
                5,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired && !this.storageOverLimit;
        },
        // General in-account Sharing
        get isShareEligible () {
            return (this.isCreatorsPageEligible || this.isNostrShareEligible) && !this.accountExpired;
        },
        // Search and Filter
        get isSearchEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // Free uploads gallery
        get isFreeGalleryEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // Referral program
        get isReferralEligible () {
            return [
                1,
                2,
                10
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        // Analytics
        get isAnalyticsEligible () {
            return [
                1,
                2,
                10,
                99
            ].includes(this.accountLevel) && !this.accountExpired;
        },
        allowed (permission) {
            switch(permission){
                case "isAdmin":
                    return this.isAdmin;
                case "isModerator":
                    return this.isModerator;
                case "isAIStudioEligible":
                    return this.isAIStudioEligible;
                case "isAIDreamShaperEligible":
                    return this.isAIDreamShaperEligible;
                case "isAISDXLLightningEligible":
                    return this.isAISDXLLightningEligible;
                case "isFluxSchnellEligible":
                    return this.isFluxSchnellEligible;
                case "isSDCoreEligible":
                    return this.isSDCoreEligible;
                case "isAIToolsEligible":
                    return this.isAIToolsEligible;
                case "isAISDiffusionEligible":
                    return this.isAISDiffusionEligible;
                case "isCreatorsPageEligible":
                    return this.isCreatorsPageEligible;
                case "isNostrShareEligible":
                    return this.isNostrShareEligible;
                case "isUploadEligible":
                    return this.isUploadEligible;
                case "isShareEligible":
                    return this.isShareEligible;
                case "isSearchEligible":
                    return this.isSearchEligible;
                case "isFreeGalleryEligible":
                    return this.isFreeGalleryEligible;
                case "isReferralEligible":
                    return this.isReferralEligible;
                case "isAnalyticsEligible":
                    return this.isAnalyticsEligible;
                default:
                    return false;
            }
        }
    },
    dialogOpen: false,
    dialogLoading: false,
    dialogError: false,
    dialogErrorMessages: [],
    dialogSuccessMessages: [],
    isFormUpdated (nym, phpUrl, password) {
        return this.profileInfo.name !== nym || this.profileInfo.pfpUrl !== phpUrl || password;
    },
    closeDialog (force) {
        if (!this.dialogLoading || force) {
            this.dialogOpen = false;
            this.dialogError = false;
            this.dialogErrorMessages = [];
            // clear password $refs
            if (this.$refs?.currentPassword?.value) this.$refs.currentPassword.value = "";
            if (this.$refs?.newPassword?.value) this.$refs.newPassword.value = "";
            if (this.$refs?.confirmPassword?.value) this.$refs.confirmPassword.value = "";
        }
        // Refresh profile info
        this.refreshProfileInfo();
    },
    openDialog () {
        this.dialogOpen = true;
    },
    hideMessages () {
        setTimeout(()=>{
            this.dialogError = false;
            this.dialogErrorMessages = [];
            this.dialogSuccessMessages = [];
        }, 3000);
    },
    async updateProfileInfo () {
        this.dialogLoading = true;
        const formData = {
            action: "update_profile",
            name: this.profileInfo.name,
            pfpUrl: this.profileInfo.pfpUrl,
            wallet: this.profileInfo.wallet,
            defaultFolder: this.profileInfo.defaultFolder,
            allowNostrLogin: this.profileInfo.allowNostrLogin
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        api.post("", formData).then((response)=>response.data).then((data1)=>{
            // Check if error
            if (data1.error) {
                console.error("Error updating profile:", data1);
                this.dialogError = true;
                this.dialogErrorMessages.push(data1.error);
            } else {
                //console.debug('Profile updated:', data);
                this.dialogSuccessMessages.push("Profile updated.");
                // Update the profile info
                this.updateProfileInfoFromData(data1);
                // Close the dialog
                this.closeDialog(true);
            }
            this.hideMessages();
        }).catch((error)=>{
            console.error("Error updating profile:", error);
            this.dialogError = true;
            this.dialogErrorMessages.push("Error updating profile.");
        }).finally(()=>{
            this.dialogLoading = false;
        });
    },
    async updatePassword (currentPasswordRef, newPasswordRef, confirmPasswordRef) {
        this.dialogLoading = true;
        const current = currentPasswordRef?.value;
        const newPassword = newPasswordRef?.value;
        const confirmPassword = confirmPasswordRef?.value;
        // Check if any of the fields are empty
        if (!current) {
            this.dialogError = true;
            this.dialogLoading = false;
            this.dialogErrorMessages.push("Please enter your current password");
            this.hideMessages();
            return;
        }
        if (!newPassword) {
            this.dialogError = true;
            this.dialogLoading = false;
            this.dialogErrorMessages.push("Please enter a new password");
            this.hideMessages();
            return;
        }
        if (!confirmPassword) {
            this.dialogError = true;
            this.dialogLoading = false;
            this.dialogErrorMessages.push("Please confirm your new password");
            this.hideMessages();
            return;
        }
        // Check if newPassword and confirmPassword match
        if (newPassword !== confirmPassword) {
            console.error("Passwords do not match:", newPassword, confirmPassword);
            this.dialogError = true;
            this.dialogLoading = false;
            this.dialogErrorMessages.push("New password and confirm password do not match");
            this.hideMessages();
            return;
        }
        const formData = {
            action: "update_password",
            password: current,
            newPassword: newPassword
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        api.post("", formData).then((response)=>response.data).then((data1)=>{
            // Check if error
            if (data1.error) {
                console.error("Error updating password:", data1);
                this.dialogError = true;
                this.dialogErrorMessages.push(data1.error);
            } else {
                const success = data1.success;
                if (!success) {
                    console.error("Error updating password:", data1);
                    this.dialogError = true;
                    this.dialogErrorMessages.push("Error updating password.");
                } else //console.debug('Password updated:', data);
                this.dialogSuccessMessages.push("Password updated.");
            }
            this.hideMessages();
        }).catch((error)=>{
            console.error("Error updating password:", error);
            this.dialogError = true;
            this.dialogErrorMessages.push("Error updating password.");
        }).finally(()=>{
            this.dialogLoading = false;
        });
    },
    async refreshProfileInfo () {
        // Updates session profile info and returns authoritatively
        const params = {
            action: "get_profile_info"
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            //console.debug('Profile info:', data);
            if (!data1.error) this.updateProfileInfoFromData(data1);
            else {
                console.error("Error fetching profile info:", data1);
                this.dialogErrorMessages.push(data1.error);
            }
        }).catch((error)=>{
            console.error("Error fetching profile info:", error);
        });
    },
    updateProfileInfoFromData (data1) {
        this.profileInfo.userId = data1.userId;
        this.profileInfo.name = data1.name;
        this.profileInfo.npub = data1.npub;
        this.profileInfo.pfpUrl = data1.pfpUrl;
        this.profileInfo.wallet = data1.wallet;
        this.profileInfo.defaultFolder = data1.defaultFolder;
        this.profileInfo.allowNostrLogin = data1.allowNostrLogin === 1;
        this.profileInfo.npubVerified = data1.npubVerified === 1;
        this.profileInfo.accountLevel = data1.accountLevel;
        this.profileInfo.accountFlags = JSON.parse(data1.accountFlags);
        this.profileInfo.remainingDays = data1.remainingDays;
        this.profileInfo.subscriptionExpired = data1.remainingDays <= 0;
        this.profileInfo.storageUsed = data1.storageUsed;
        this.profileInfo.storageLimit = data1.storageLimit;
        this.profileInfo.totalStorageLimit = data1.totalStorageLimit;
        this.profileInfo.availableCredits = data1.availableCredits;
        this.profileInfo.debitedCredits = data1.debitedCredits;
        this.profileInfo.creditedCredits = data1.creditedCredits;
        this.profileInfo.referralCode = data1.referralCode;
        this.profileInfo.referralLink = `https://getnb.me/${data1.referralCode}`;
    },
    // Credits
    async getCreditHistory (type = "all", limit = 100, offset = 0) {
        const params = {
            action: "get_credits_tx_history",
            type: type,
            limit: limit,
            offset: offset
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            console.debug("Credit history:", data1);
        }).catch((error)=>{
            console.error("Error fetching credit history:", error);
        });
    },
    getCreditsInvoice (credits = 0) {
        const params = {
            action: "get_credits_invoice",
            credits: credits
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            console.debug("Credit invoice:", data1);
        }).catch((error)=>{
            console.error("Error fetching credit invoice:", error);
        });
    },
    getCreditsBalance () {
        const params = {
            action: "get_credits_balance"
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            console.debug("Credit balance:", data1);
        }).catch((error)=>{
            console.error("Error fetching credit balance:", error);
        });
    }
});
(0, $dc6El.default).store("nostrStore", {
    share: {
        isOpen: false,
        isLoading: false,
        isError: false,
        isCriticalError: false,
        isErrorMessages: [],
        selectedIds: [],
        selectedFiles: [],
        callback: null,
        extNpub: "",
        note: "",
        signedEvent: {},
        getDeduplicatedErrors () {
            return Array.from(new Set(this.isErrorMessages));
        },
        remove (fileId) {
            this.selectedIds = this.selectedIds.filter((id)=>id !== fileId);
            this.selectedFiles = this.selectedFiles.filter((file)=>file.id !== fileId);
        },
        open (ids, callback) {
            // Convert single ID to array
            if (!Array.isArray(ids)) ids = [
                ids
            ];
            console.debug("Opening sharing modal:", ids);
            this.selectedIds = ids;
            this.selectedFiles = (0, $dc6El.default).store("fileStore").files.filter((file)=>ids.includes(file.id));
            console.debug("Selected files:", this.selectedFiles);
            this.isOpen = true;
            this.callback = callback;
        },
        close (dontCallback) {
            this.selectedIds = [];
            this.selectedFiles = [];
            this.isError = false;
            this.isErrorMessages = [];
            this.isOpen = false;
            this.isLoading = false;
            this.extNpub = "";
            this.note = "";
            this.signedEvent = {};
            this.isCriticalError = false;
            // execute callback if provided
            if (this.callback && !dontCallback) this.callback();
        },
        async isNostrExtensionEnabled () {
            return await window?.nostr?.getPublicKey() !== null;
        },
        async send (files1 = [], callback = null) {
            const nostrStore = (0, $dc6El.default).store("nostrStore");
            // If mediaIds and note are not provided, use the selected files and note
            if (files1.length > 0) {
                console.debug("Using provided files:", files1);
                this.selectedIds = files1.map((file)=>file.id);
                this.selectedFiles = files1;
                if (typeof callback === "function") this.callback = callback;
            }
            this.isLoading = true;
            this.isError = false;
            this.isErrorMessages = [];
            // Append file URLs to the note
            this.selectedFiles.forEach((file)=>{
                this.note += `\n${file.url}`;
            });
            // TODO: Add support to create and manage badges - https://github.com/nostr-protocol/nips/blob/master/58.md
            // TODO: Add event deletion - https://github.com/nostr-protocol/nips/blob/master/09.md
            // Create imeta tags:
            // NIP-92 https://github.com/nostr-protocol/nips/blob/master/92.md
            const tags = this.selectedFiles.map((file)=>{
                // Build the imeta tags based on available file data
                const imeta = [];
                if (file.blurhash) imeta.push(`blurhash ${file.blurhash}`);
                if (file.width && file.height) imeta.push(`dim ${file.width}x${file.height}`);
                if (file.mime) imeta.push(`m ${file.mime}`);
                return [
                    "imeta",
                    `url ${file.url}`,
                    ...imeta
                ];
            });
            // TODO: NIP-94 https://github.com/nostr-protocol/nips/blob/master/94.md
            // Append the URL r tags
            this.selectedFiles.forEach((file)=>{
                tags.push([
                    "r",
                    file.url
                ]);
            });
            // Parse for the hashtags and add them to the tags as 't'
            // Regular expression to match hashtags, excluding those in URLs
            const hashtagRegex = /(?<!\w|#)#([\p{L}\p{N}\p{M}\p{Emoji_Presentation}\p{Emoji}]+)/gu;
            const matches = this.note.match(hashtagRegex);
            if (matches) matches.forEach((hashtag)=>{
                tags.push([
                    "t",
                    hashtag.toLowerCase()
                ]);
            });
            const event = {
                kind: 1,
                created_at: Math.floor(Date.now() / 1000),
                tags: tags,
                content: this.note
            };
            this.signedEvent = await window.nostr.signEvent(event);
            //console.debug('Signed event:', this.signedEvent);
            nostrStore.publishSignedEvent(this.signedEvent, this.selectedIds).then(()=>{
                console.debug("Published Nostr event:", this.signedEvent);
                this.close();
            }).catch((error)=>{
                console.error("Error publishing Nostr event:", error);
                this.isError = true;
                this.isErrorMessages.push("Error publishing Nostr event.");
            }).finally(()=>{
                this.isLoading = false;
            });
        }
    },
    async publishSignedEvent (signedEvent1, mediaIds = []) {
        const formData = {
            action: "publish_nostr_event",
            event: JSON.stringify(signedEvent1),
            mediaIds: JSON.stringify(mediaIds),
            eventId: signedEvent1.id,
            eventCreatedAt: signedEvent1.created_at,
            eventContent: signedEvent1.content
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            //console.debug('Published Nostr event:', data);
            // Check if noteId is not null and success is true, otherwise throw an error
            if (!data1.noteId || !data1.success) throw new Error("Error publishing Nostr event.");
            // Update shared files with the Nostr event ID
            const fileStore = (0, $dc6El.default).store("fileStore");
            const mediaEvents = data1.mediaEvents || {};
            fileStore.files.forEach((file)=>{
                // Update the associated_notes field with the Nostr event ID
                if (mediaEvents[file.id]) {
                    if (file.associated_notes?.length) file.associated_notes += "," + mediaEvents[file.id];
                    else file.associated_notes = mediaEvents[file.id];
                }
            });
            // Remove the deletedEvents from associated_notes,
            // where the string starts with event ID and followed by unix epoch timestamp, until ','
            const deletedEvents = data1.deletedEvents || [];
            console.debug("Deleted events:", deletedEvents);
            deletedEvents.forEach((eventId)=>{
                fileStore.files.forEach((file)=>{
                    if (file.associated_notes?.includes(eventId)) {
                        // Remove deleted events
                        console.debug("Removing deleted event:", eventId);
                        file.associated_notes = file.associated_notes.split(",").filter((note)=>!note.startsWith(eventId)).join(",");
                        // Debug result
                        console.debug("Updated associated_notes:", file.associated_notes);
                    }
                });
            });
            return data1;
        }).catch((error)=>{
            console.error("Error publishing Nostr event:", error);
        });
    },
    async deleteEvent (eventIds) {
        // Generate the delete event, NIP-09
        eventIds = Array.isArray(eventIds) ? eventIds : [
            eventIds
        ];
        const tags = eventIds.map((eventId)=>[
                "e",
                eventId
            ]);
        const event = {
            kind: 5,
            created_at: Math.floor(Date.now() / 1000),
            tags: tags,
            content: "User requested deletion of these posts"
        };
        signedEvent = await window.nostr.signEvent(event);
        const nostrStore = (0, $dc6El.default).store("nostrStore");
        //console.debug('Signed event:', this.signedEvent);
        return nostrStore.publishSignedEvent(signedEvent).then(()=>{
            console.debug("Published Nostr event:", this.signedEvent);
            nostrStore.share.close();
        }).catch((error)=>{
            console.error("Error publishing Nostr event:", error);
            nostrStore.share.isError = true;
            nostrStore.share.isErrorMessages.push("Error publishing Nostr event.");
        }).finally(()=>{
            nostrStore.share.isLoading = false;
        });
    },
    async nostrGetPublicKey () {
        try {
            const publicKey = await window.nostr.getPublicKey();
            console.debug("Nostr public key:", publicKey);
            return publicKey;
        } catch (error) {
            console.error("Error getting Nostr public key:", error ?? "Unknown error");
            return null;
        }
    },
    async nostrGetBech32Npub () {
        const hexNpub = await this.nostrGetPublicKey();
        if (!hexNpub) {
            console.error("Nostr public key not found.");
            // Set error in the share structure
            this.share.isError = true;
            return;
        }
        const publicKey = (0, $6CDrG.nip19).npubEncode(hexNpub);
        const profileStore1 = (0, $dc6El.default).store("profileStore");
        if (publicKey && publicKey !== profileStore1.profileInfo.npub) {
            console.error("Nostr public keys do not match:", publicKey, profileStore1.profileInfo.npub);
            // Set error in the share structure
            this.share.isError = true;
            this.share.isCriticalError = true;
            this.share.isErrorMessages.push("Your account Nostr public key does not match your extension key.");
        }
        return publicKey;
    }
});
(0, $dc6El.default).store("menuStore", {
    alpineInitiated: false,
    mobileMenuOpen: false,
    menuStoreInitiated: false,
    noTransform: false,
    init () {
        if (this.menuStoreInitiated) return;
        this.refreshFoldersStats().then(()=>{
            this.menuStoreInitiated = true;
        });
        const { folder: folder, page: page } = $541ddb8841663b5e$var$getHashParams();
        this.setActiveFolder(folder);
        this.setActiveMenuFromHash();
        // Set popstate event listener
        window.addEventListener("popstate", ()=>{
            const { folder: folder, page: page } = $541ddb8841663b5e$var$getHashParams();
            if (folder) this.setActiveFolder(folder, false);
            else this.setActiveFolder($541ddb8841663b5e$var$homeFolderName, false);
            this.setActiveMenuFromHash();
            const activeMenu = this.activeMenu;
            const fullWidth = !this.menuItemsAI.some((item)=>item.name === activeMenu);
            (0, $dc6El.default).store("fileStore").fullWidth = fullWidth;
        });
        console.debug("Menu store initiated");
    },
    menuItemsAI: [
        {
            name: "AI Studio",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />',
            route: $541ddb8841663b5e$var$getUpdatedHashLink($541ddb8841663b5e$var$aiImagesFolderName, "gai"),
            routeId: "gai",
            rootFolder: $541ddb8841663b5e$var$aiImagesFolderName
        }
    ],
    menuItems: [
        {
            name: "Account Main Page",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />',
            route: $541ddb8841663b5e$var$getUpdatedHashLink($541ddb8841663b5e$var$homeFolderName, "main"),
            routeId: "main",
            rootFolder: $541ddb8841663b5e$var$homeFolderName
        }
    ],
    externalMenuItems: [
        {
            name: "Free Media Gallery",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />',
            route: "/viewall/",
            routeId: "viewall",
            allowed: "isFreeGalleryEligible"
        }
    ],
    adminMenuItems: [
        {
            name: "Uploads Moderation",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z" />',
            route: "/account/admin/approve.php",
            allowed: "isModerator"
        },
        {
            name: "CSAM Reporting",
            icon: '<path d="M7 18v-6a5 5 0 1 1 10 0v6"/><path d="M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z"/><path d="M21 12h1"/><path d="M18.5 4.5 18 5"/><path d="M2 12h1"/><path d="M12 2v1"/><path d="m4.929 4.929.707.707"/><path d="M12 12v6"/>',
            route: "/account/admin/admin_csam_cases.php",
            allowed: "isAdmin"
        },
        {
            name: "New Accounts",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />',
            route: "/account/admin/newacct.php",
            allowed: "isAdmin"
        },
        {
            name: "Update DB Tables",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />',
            route: "/account/admin/update_db.php",
            allowed: "isAdmin"
        },
        {
            name: "Free Uploads Stats",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" />',
            route: "/account/admin/stats.php",
            allowed: "isAdmin"
        },
        {
            name: "Accounts Stats",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />',
            route: "/account/admin/account_stats.php",
            allowed: "isAdmin"
        },
        {
            name: "Promotions",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605" />',
            route: "/account/admin/promo.php",
            allowed: "isAdmin"
        },
        {
            name: "BTCPayServer",
            icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />',
            route: "https://btcpay.nostr.build/",
            allowed: "isAdmin"
        }
    ],
    folders: [],
    activeFolder: "",
    activeFolderStats: {},
    activeFolderObj: {},
    // Top most folders
    staticFolders: [
        {
            id: 0,
            name: $541ddb8841663b5e$var$homeFolderName,
            icon: "H",
            route: "#",
            allowDelete: false
        },
        {
            name: $541ddb8841663b5e$var$aiImagesFolderName,
            icon: "A",
            route: "#",
            allowDelete: false
        }
    ],
    getFolderObjByName (folderName) {
        return this.folders.find((folder)=>folder.name === folderName);
    },
    getFolderNameById (folderId) {
        return this.folders.find((folder)=>folder.id === folderId)?.name;
    },
    updateFolderStatsFromFile (file, folderName, increment = true) {
        const folder = this.getFolderObjByName(folderName);
        if (!folder) return;
        // Determine file type from media_type
        const fileType = file.media_type;
        console.debug("File type:", fileType);
        switch(fileType){
            case "image":
                // GIF or others
                if (file.mime === "image/gif") {
                    folder.stats.gifs += increment ? 1 : -1;
                    folder.stats.gifsSize += increment ? file.size : -file.size;
                    this.fileStats.totalGifs += increment ? 1 : -1;
                } else {
                    folder.stats.images += increment ? 1 : -1;
                    folder.stats.imagesSize += increment ? file.size : -file.size;
                    this.fileStats.totalImages += increment ? 1 : -1;
                }
                break;
            case "video":
                folder.stats.videos += increment ? 1 : -1;
                folder.stats.videosSize += increment ? file.size : -file.size;
                this.fileStats.totalVideos += increment ? 1 : -1;
                break;
            case "audio":
                folder.stats.audio += increment ? 1 : -1;
                folder.stats.audioSize += increment ? file.size : -file.size;
                this.fileStats.totalVideos += increment ? 1 : -1;
                break;
            case "document":
                folder.stats.documents += increment ? 1 : -1;
                folder.stats.documentsSize += increment ? file.size : -file.size;
                this.fileStats.totalDocuments += increment ? 1 : -1;
                break;
            case "archive":
                folder.stats.archives += increment ? 1 : -1;
                folder.stats.archivesSize += increment ? file.size : -file.size;
                this.fileStats.totalArchives += increment ? 1 : -1;
                break;
            case "other":
                folder.stats.others += increment ? 1 : -1;
                folder.stats.othersSize += increment ? file.size : -file.size;
                this.fileStats.totalOthers += increment ? 1 : -1;
                break;
        }
        // Update the total files and size
        folder.stats.all += increment ? 1 : -1;
        folder.stats.allSize += increment ? file.size : -file.size;
        folder.stats.publicCount += increment ? file.flag : -file.flag;
        this.fileStats.totalFiles += increment ? 1 : -1;
        this.fileStats.totalSize += increment ? file.size : -file.size;
        this.fileStats.creatorCount += increment ? file.flag : -file.flag;
    },
    updateSharedStatsFromFile (file, folderName, increment = true) {
        const folder = this.getFolderObjByName(folderName);
        if (!folder) return;
        // Update the total files and size
        folder.stats.publicCount += increment ? file.flag : -file.flag;
        this.fileStats.creatorCount += increment ? file.flag : -file.flag;
    },
    setActiveMenuFromHash () {
        const params = new URLSearchParams(window.location.hash.slice(1));
        const menu = params.get("p");
        // concat the menuItemsAI with menuItems
        const menuItems = [
            ...this.menuItemsAI,
            ...this.menuItems
        ];
        // Find the menu name based on routeId, i.e., the page
        const activeMenu = menuItems.find((item)=>item.routeId === menu);
        // Set this.activeMenu to the activeMenu.name or the first menu item
        this.activeMenu = activeMenu ? activeMenu.name : this.menuItems[0].name;
    },
    setActiveFolder (folderName, doUpdateHashURL = true) {
        if (!this.foldersFetched || !folderName) return;
        // If already same folder, do nothing
        if (this.activeFolder === folderName) return;
        // Deal with fileStore
        const fileStore = (0, $dc6El.default).store("fileStore");
        const uppyStore = (0, $dc6El.default).store("uppyStore");
        // Close upload dialog
        uppyStore.mainDialog.close();
        // Clear the files list
        fileStore.files = [];
        this.activeFolder = folderName;
        this.activeFolderObj = this.getFolderObjByName(folderName) || {};
        this.activeFolderStats = this.getFolderObjByName(folderName)?.stats || {};
        if (doUpdateHashURL) $541ddb8841663b5e$var$updateHashURL(folderName);
        console.debug("Active folder set:", folderName);
        // Reset filter
        fileStore.currentFilter = "all";
        fileStore.fetchFiles(folderName, true).then(()=>{
            // Update the folder stats
            this.refreshFoldersStats();
        });
    },
    foldersFetched: false,
    async fetchFolders () {
        const params = {
            action: "list_folders"
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "aplication/json");
        await api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            const folders = data1 || [];
            // Deduplicate folders by name property
            // Append fetched folders to this.folders
            this.folders = folders.reduce((acc, folder)=>{
                const existingFolder = acc.find((f)=>f.name === folder.name);
                if (!existingFolder) acc.push(folder);
                else {
                    existingFolder.id = folder.id;
                    existingFolder.route = folder.route;
                    existingFolder.icon = folder.icon;
                    // Update folder stats
                    if (!existingFolder.stats) existingFolder.stats = folder.stats;
                    else Object.assign(existingFolder.stats, folder.stats);
                }
                return acc;
            }, this.folders);
            // Sort the fetched folders by name
            this.folders.sort((a, b)=>a.name.localeCompare(b.name));
            // Update the staticFolders with fetched data and remove existing entries from this.folders
            this.staticFolders = this.staticFolders.map((staticFolder)=>{
                const existingFolder = this.folders.find((f)=>f.name === staticFolder.name);
                if (existingFolder) {
                    Object.assign(staticFolder, existingFolder);
                    this.folders = this.folders.filter((f)=>f.name !== staticFolder.name);
                }
                return staticFolder;
            });
            // Add the staticFolders to the beginning of the folders array
            this.folders = [
                ...this.staticFolders,
                ...this.folders
            ];
            // Folders have been fetched
            this.foldersFetched = true;
            //console.debug('Folders fetched:', this.folders);
            // Set this.activeFolder to the value of URL's # parameter
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.hash.slice(1));
            const activeFolder = decodeURIComponent(params.get("f") || "");
            //console.debug('Active folder:', activeFolder);
            //const defaultFolder = this.folders.length > 0 ? this.folders[0].name : '';
            // Set default folder as the one with id 0
            const defaultFolder = this.folders.find((f)=>f.id === 0).name;
            //console.debug('Default folder:', defaultFolder);
            // If URL hash has a folder, set it as active folder, otherwise use defaul
            const folderToSet = this.folders.find((f)=>f.name === activeFolder) ? activeFolder : defaultFolder;
            //console.debug('Folder to set:', folderToSet);
            this.setActiveFolder(folderToSet);
        }).catch((error)=>{
            console.error("Error fetching folders:", error);
        });
    },
    newFolderNameError: "",
    newFolderName: "",
    newFolderDialog: false,
    newFolderDialogOpen () {
        this.newFolderDialog = true;
    },
    newFolderDialogClose () {
        this.newFolderDialog = false;
        this.newFolderName = "";
        this.newFolderNameError = "";
    },
    newFolderDialogToggle () {
        if (this.newFolderDialog) this.newFolderDialogClose();
        else this.newFolderDialogOpen();
    },
    createFolder (folderName, callback) {
        // Empty?
        if (!folderName.trim()) {
            this.newFolderNameError = "Empty folder name.";
            setTimeout(()=>{
                this.newFolderNameError = "";
            }, 1000);
            return;
        }
        // Check if duplicate folder name
        if (this.folders.some((folder)=>folder.name === folderName)) {
            console.error("Folder already exists:", folderName);
            this.newFolderNameError = "Folder already exists.";
            setTimeout(()=>{
                this.newFolderNameError = "";
            }, 1000);
            return;
        }
        // Create new folder structure
        const folderNameNormalized = folderName.normalize("NFC"); // Normalize the string
        const firstChar = [
            ...folderNameNormalized
        ][0]; // Extract the first character as a string
        const newFolder = {
            name: folderName,
            icon: firstChar.toUpperCase(),
            route: $541ddb8841663b5e$var$getUpdatedHashLink(folderName),
            allowDelete: true
        };
        // Add new folder to the folders array
        this.folders.push(newFolder);
        // Close the dialog
        this.newFolderDialogClose();
        // Close mobile menu
        this.mobileMenuOpen = this.mobileMenuOpen ? false : this.mobileMenuOpen;
        // Ask fetchFiles to refresh the folders
        (0, $dc6El.default).store("fileStore").refreshFoldersAfterFetch = true;
        // Set new folder as active folder
        this.setActiveFolder(folderName);
        if (callback) callback();
        console.debug("Folder created:", folderName);
    },
    showDeleteFolderButtons: false,
    showDeleteFolderModal: false,
    foldersToDeleteIds: [],
    foldersToDelete: [],
    isDeletingFolders: false,
    toggleDeleteFolderButtons () {
        this.showDeleteFolderButtons = !this.showDeleteFolderButtons;
    },
    disableDeleteFolderButtons () {
        this.showDeleteFolderButtons = false;
    },
    openDeleteFolderModal (folderIds) {
        // Check if array or not, and make it an array
        if (!Array.isArray(folderIds)) folderIds = [
            folderIds
        ];
        // Check if array is empty and return if it is
        if (folderIds.length === 0) return;
        // Set folder IDs to delete while checking them agains this.folders
        this.foldersToDeleteIds = folderIds.filter((id)=>this.folders.some((folder)=>folder.id === id));
        this.foldersToDelete = this.folders.filter((folder)=>this.foldersToDeleteIds.includes(folder.id));
        // Check if activeFolder name matches any of the folders to delete
        if (this.foldersToDelete.some((folder)=>folder.name === this.activeFolder)) //console.debug('Cannot delete active folder:', this.activeFolder);
        return;
        this.showDeleteFolderModal = true;
    },
    closeDeleteFolderModal () {
        this.foldersToDeleteIds = [];
        this.showDeleteFolderModal = false;
        this.showDeleteFolderButtons = false;
    },
    deleteFoldersConfirm () {
        if (this.foldersToDeleteIds.length === 0) return;
        // Set folder IDs to delete while checking them agains this.folders
        const folderIds = this.foldersToDeleteIds.filter((id)=>this.folders.some((folder)=>folder.id === id));
        this.isDeletingFolders = true;
        // Send request to delete folders
        this.deleteFolders(folderIds).then(()=>{
            this.closeDeleteFolderModal();
        }).catch((error)=>{
            console.error("Error deleting folders:", error);
        }).finally(()=>{
            this.isDeletingFolders = false; // Reset the flag after folder deletion is complete
            this.fetchFolders(); // Refetch folders
        });
    },
    async deleteFolders (folderIds) {
        console.debug("Deleting folders:", folderIds);
        const formData = {
            action: "delete_folders",
            foldersToDelete: JSON.stringify(folderIds)
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            console.debug("Folders deleted:", data1);
            const deletedFolders = data1.deletedFolders || [];
            // Remove the deleted folders from this.folders
            this.folders = this.folders.filter((folder)=>!deletedFolders.includes(folder.id));
        }).catch((error)=>{
            console.error("Error deleting folders:", error);
        });
    },
    activeMenu: "",
    setActiveMenu (menuName) {
        this.activeMenu = menuName;
        // Find rootFolder from menuItemsAI or menuItems
        const menuItem = this.menuItemsAI.concat(this.menuItems).find((item)=>item.name === menuName);
        const rootFolder = menuItem ? menuItem.rootFolder : "main";
        const routeId = menuItem ? menuItem.routeId : "main";
        console.debug("Active menu set:", menuName);
        // Update fileStore.fullWidth is menuName is in menuItemsAI
        const fileStore = (0, $dc6El.default).store("fileStore");
        fileStore.fullWidth = !this.menuItemsAI.some((item)=>item.name === menuName);
        console.debug("Full width:", fileStore.fullWidth);
        $541ddb8841663b5e$var$updateHashURL(rootFolder, routeId);
        this.setActiveFolder(rootFolder);
    },
    updateTotalUsed (addUsed) {
        (0, $dc6El.default).store("profileStore").profileInfo.storageUsed += addUsed;
    //console.debug('Total used updated:', Alpine.store('profileStore').profileInfo.storageUsed);
    //console.debug('Total used ratio:', Alpine.store('profileStore').profileInfo.getStorageRatio());
    //console.debug('Total used added:', addUsed);
    },
    fileStats: {
        totalFiles: 0,
        totalGifs: 0,
        totalImages: 0,
        totalVideos: 0,
        totalDocuments: 0,
        totalArchives: 0,
        totalOthers: 0,
        creatorCount: 0,
        totalFolders: 0,
        totalSize: 0,
        stats: {}
    },
    async refreshFoldersStats () {
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        const params = {
            action: "get_folders_stats"
        };
        api.get("", {
            params: params
        }).then((response)=>response.data).then((data1)=>{
            this.fileStats.stats = data1;
            // Convert potential strings into numbers
            this.fileStats.totalFiles = parseInt(data1.totalStats?.all);
            this.fileStats.totalGifs = parseInt(data1.totalStats.gifs);
            this.fileStats.totalImages = parseInt(data1.totalStats.images);
            this.fileStats.totalVideos = parseInt(data1.totalStats.videos + data1.totalStats.audio);
            this.fileStats.totalDocuments = parseInt(data1.totalStats.documents);
            this.fileStats.totalArchives = parseInt(data1.totalStats.archives);
            this.fileStats.totalOthers = parseInt(data1.totalStats.others);
            this.fileStats.creatorCount = parseInt(data1.totalStats.publicCount);
            this.fileStats.totalFolders = (0, $dc6El.default).store("menuStore").folders.length;
            this.fileStats.totalSize = parseInt(data1.totalStats.allSize);
        }).catch((error)=>{
            console.error("Error refreshing file stats:", error);
        });
    },
    formatNumberInThousands (number) {
        return number > 999 ? `${(number / 1000).toFixed(1)}k` : number;
    }
});
(0, $dc6El.default).store("fileStore", {
    files: [],
    filesById: {},
    loading: false,
    fullWidth: false,
    Files: {
        files: [],
        filesById: new Map(),
        filesByName: new Map(),
        get files () {
            return this.files;
        },
        get filesById () {
            return this.filesById;
        },
        get filesByName () {
            return this.filesByName;
        },
        /**
     * @param {any[]} files
     */ set files (files){
            this.files = [
                ...files
            ];
            this.updateMaps();
        },
        updateMaps () {
            this.filesById = new Map(this.files.map((file)=>[
                    file.id,
                    file
                ]));
            this.filesByName = new Map(this.files.map((file)=>[
                    file.name,
                    file
                ]));
        },
        addFile (file, position = "bottom") {
            if (!this.filesById.has(file.id)) {
                if (position === "top") this.files.unshift(file);
                else this.files.push(file);
                this.addFileToMaps(file);
            }
        },
        addFiles (newFiles, position = "bottom") {
            const uniqueFiles = newFiles.filter((file)=>!this.filesById.has(file.id));
            if (position === "top") this.files.unshift(...uniqueFiles);
            else this.files.push(...uniqueFiles);
            uniqueFiles.forEach((file)=>this.addFileToMaps(file));
        },
        addFileToMaps (file) {
            this.filesById.set(file.id, file);
            this.filesByName.set(file.name, file);
        },
        removeFile (file) {
            const index = this.files.findIndex((f)=>f.id === file.id);
            if (index !== -1) {
                this.files.splice(index, 1);
                this.removeFileFromMaps(file);
            }
        },
        removeFileFromMaps (file) {
            this.filesById.delete(file.id);
            this.filesByName.delete(file.name);
        },
        getFileByName (name) {
            return this.filesByName.get(name);
        },
        getFileById (id) {
            return this.filesById.get(id);
        }
    },
    moveToFolder: {
        isOpen: false,
        isLoading: false,
        isError: false,
        selectedIds: [],
        selectedFiles: [],
        destinationFolderId: null,
        hoveredFolder: null,
        isDropdownOpen: false,
        searchTerm: "",
        selectedFolderName: "",
        callback: null,
        open (ids, callback) {
            // Convert single ID to array
            if (!Array.isArray(ids)) ids = [
                ids
            ];
            console.debug("Opening move to folder modal:", ids);
            this.selectedIds = ids;
            this.selectedFiles = (0, $dc6El.default).store("fileStore").files.filter((file)=>ids.includes(file.id));
            console.debug("Selected files:", this.selectedFiles);
            this.isOpen = true;
            this.callback = callback;
        },
        close (dontCallback) {
            this.selectedIds = [];
            this.selectedFiles = [];
            this.destinationFolderId = null;
            this.hoveredFolder = null;
            this.isDropdownOpen = false;
            this.searchTerm = "";
            this.selectedFolderName = "";
            this.isError = false;
            this.isOpen = false;
            this.isLoading = false;
            // Execute callback if provided
            if (this.callback && !dontCallback) this.callback();
        },
        toggleDropdown () {
            this.isDropdownOpen = !this.isDropdownOpen;
        }
    },
    moveToFolderConfirm () {
        this.moveToFolder.isLoading = true;
        // Check if destination folder is the same as the current folder
        // Get the folder name from the folders list based on id and compare it with the active name
        const destinationFolderName = (0, $dc6El.default).store("menuStore").folders.find((folder)=>folder.id === this.moveToFolder.destinationFolderId).name;
        if (destinationFolderName === (0, $dc6El.default).store("menuStore").activeFolder) {
            this.moveToFolder.close();
            this.moveToFolder.isLoading = false;
            return;
        }
        // Proceed otherwise
        return this.moveItemsToFolder(this.moveToFolder.selectedIds, this.moveToFolder.destinationFolderId).then(()=>{
            this.moveToFolder.close();
            this.isError = false;
        }).catch((error)=>{
            console.error("Error moving files:", error);
            this.isError = true;
        }).finally(()=>{
            this.moveToFolder.isLoading = false;
        });
    },
    async moveItemsToFolder (itemIds, folderId) {
        console.debug("Moving items to folder:", itemIds, folderId);
        itemIds = Array.isArray(itemIds) ? itemIds : [
            itemIds
        ];
        const formData = {
            action: "move_to_folder",
            imagesToMove: JSON.stringify(itemIds),
            destinationFolderId: folderId
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            console.debug("Moved items to folder:", data1);
            const movedImageIds = data1.movedImages || [];
            const menuStore1 = (0, $dc6El.default).store("menuStore");
            // Update the file stats for each file
            this.files.forEach((file)=>{
                if (movedImageIds.includes(file.id)) {
                    menuStore1.updateFolderStatsFromFile(file, menuStore1.activeFolder, false);
                    menuStore1.updateFolderStatsFromFile(file, menuStore1.getFolderNameById(folderId), true);
                }
            });
            // Remove moved images from the files list
            this.files = this.files.filter((file)=>!movedImageIds.includes(file.id));
            // Refresh the files starting at 0 and up to the original length + 
            this.fetchFiles(this.lastFetchedFolder, true);
        }).catch((error)=>{
            console.error("Error moving items to folder:", error);
        });
    },
    shareMedia: {
        isOpen: false,
        isLoading: false,
        isError: false,
        selectedIds: [],
        selectedFiles: [],
        callback: null,
        open (ids, callback) {
            // Convert single ID to array
            if (!Array.isArray(ids)) ids = [
                ids
            ];
            console.debug("Opening sharing modal:", ids);
            this.selectedIds = ids;
            this.selectedFiles = (0, $dc6El.default).store("fileStore").files.filter((file)=>ids.includes(file.id));
            console.debug("Selected files:", this.selectedFiles);
            this.isOpen = true;
            this.callback = callback;
        },
        close (dontCallback) {
            this.selectedIds = [];
            this.selectedFiles = [];
            this.isError = false;
            this.isOpen = false;
            this.isLoading = false;
            // execute callback if provided
            if (this.callback && !dontCallback) this.callback();
        },
        getFlag () {
            return this.selectedFiles.length > 0 && this.selectedFiles[0].flag === 1;
        }
    },
    shareMediaCreatorConfirm (shareFlag) {
        this.shareMedia.isLoading = true;
        this.shareItemsCreatorPage(shareFlag).then(()=>{
            this.isError = false;
        }).catch((error)=>{
            console.error("Error sharing files:", error);
            this.isError = true;
        }).finally(()=>{
            this.shareMedia.isLoading = false;
        });
    },
    async shareItemsCreatorPage (shareFlag) {
        console.debug("Sharing media on Creators page:", this.shareMedia.selectedIds);
        const itemsToShare = Array.isArray(this.shareMedia.selectedIds) ? this.shareMedia.selectedIds : [
            this.shareMedia.selectedIds
        ];
        const formData = {
            action: "share_creator_page",
            shareFlag: shareFlag,
            imagesToShare: JSON.stringify(itemsToShare)
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            //console.debug('Shared media on Creators page:', data);
            const sharedImageIds = data1.sharedImages || [];
            const menuStore1 = (0, $dc6El.default).store("menuStore");
            // Update the shared flag and count for each file
            this.files.forEach((file)=>{
                if (sharedImageIds.includes(file.id)) {
                    file.flag = shareFlag ? 1 : 0;
                    // We can assume we are in the same folder as the files
                    menuStore1.updateSharedStatsFromFile(file, menuStore1.activeFolder, shareFlag);
                }
            });
        }).catch((error)=>{
            console.error("Error sharing media on Creators page:", error);
        });
    },
    mediaProperties: {
        isOpen: false,
        isLoading: false,
        isError: false,
        targetFile: null,
        closeTimeout: null,
        contentLoaded: false,
        isNostrShareDialogOpen: false,
        isDeleteDialogOpen: false,
        isDeleting: false,
        editTitle: false,
        isSavingTitle: false,
        editDescription: false,
        isSavingDescription: false,
        newTitle: "",
        newDescription: "",
        isSharing: false,
        deleteAssociatedNotes: false,
        // 'share' | 'props' | 'stats' | 'ai_tools'
        currentTab: "share",
        // Callback for any active submenues to be closed
        callback: null,
        // Change folders
        fileMoved: false,
        newParentFolder: "",
        editParentFolder: false,
        savingParentFolder: false,
        parentFolderId: null,
        open (file) {
            // Clear the timeout if it exists
            if (this.closeTimeout) clearTimeout(this.closeTimeout);
            this.currentTab = "share"; // Default tab is 'share', set it before opening
            this.targetFile = file;
            this.isOpen = true;
            this.contentLoaded = false;
            this.newTitle = file.title ?? file.name;
            this.newDescription = file.description;
            this.callback = null;
            if (this.isNostrExtensionEnabled === null) {
                // We need to check only once if the Nostr extension is enabled
                const nostrStore = (0, $dc6El.default).store("nostrStore");
                nostrStore.share.isNostrExtensionEnabled().then((enabled)=>{
                    this.isNostrExtensionEnabled = enabled;
                });
            }
        },
        close () {
            // Prevent close if any actions are taking place
            if (this.isLoading || this.isDeleting || this.isSavingTitle || this.isSavingDescription || this.isSharing) return;
            this.isError = false;
            this.isOpen = false;
            this.isLoading = false;
            this.isDeleteDialogOpen = false;
            this.isDeleting = false;
            this.editingTitle = false;
            this.isSavingTitle = false;
            this.editDescription = false;
            this.isSavingDescription = false;
            this.newTitle = "";
            this.newDescription = "";
            this.isSharing = false;
            this.deleteAssociatedNotes = false;
            this.closeNostrDialog();
            this.fileMoved = false;
            this.newParentFolder = "";
            this.editParentFolder = false;
            this.savingParentFolder = false;
            this.parentFolderId = null;
            this.closeParentFolderEdit();
            // Execute callback if provided
            if (typeof this.callback === "function") this.callback();
            // Delay emptying the target file to allow for the modal to close
            this.closeTimeout = setTimeout(()=>{
                this.targetFile = null;
            }, 1000);
        },
        openParentFolderEdit () {
            const fileStore = (0, $dc6El.default).store("fileStore");
            const menuStore1 = (0, $dc6El.default).store("menuStore");
            this.editParentFolder = true;
            this.parentFolderId = menuStore1.folders.find((folder)=>folder.name === menuStore1.activeFolder).id;
            fileStore.moveToFolder.selectedFolderName = menuStore1.activeFolder;
            fileStore.moveToFolder.destinationFolderId = this.parentFolderId;
            fileStore.moveToFolder.selectedIds = [
                fileStore.mediaProperties.targetFile.id
            ];
        },
        saveParentFolder () {
            const fileStore = (0, $dc6El.default).store("fileStore");
            console.log("Saving parent folder:", this.newParentFolder);
            this.savingParentFolder = true;
            this.newParentFolder = fileStore.moveToFolder.selectedFolderName;
            fileStore.moveToFolderConfirm().then(()=>{
                console.log("Moved to folder:", this.newParentFolder);
                this.fileMoved = true;
                this.savingParentFolder = false;
                this.closeParentFolderEdit();
            }).catch(()=>{
                console.error("Error moving to folder:", this.newParentFolder);
                this.savingParentFolder = false;
            });
        },
        closeParentFolderEdit () {
            const fileStore = (0, $dc6El.default).store("fileStore");
            this.editParentFolder = false;
            this.savingParentFolder = false;
            this.parentFolderId = null;
        },
        openNostrDialog () {
            this.isNostrShareDialogOpen = true;
        },
        closeNostrDialog () {
            this.isNostrShareDialogOpen = false;
            const nostrStore = (0, $dc6El.default).store("nostrStore");
            nostrStore.share.close();
        },
        saveDescription () {
            this.isSavingDescription = true;
            this.targetFile.description = this.newDescription;
            this.saveMediaEdit(this.targetFile).then(()=>{
                this.editDescription = false;
                this.isError = false;
            }).catch((error)=>{
                console.error("Error saving description:", error);
                this.isError = true;
            }).finally(()=>{
                this.isSavingDescription = false;
            });
        },
        saveTitle () {
            this.isSavingTitle = true;
            this.targetFile.title = this.newTitle;
            this.saveMediaEdit(this.targetFile).then(()=>{
                this.editTitle = false;
                this.isError = false;
            }).catch((error)=>{
                console.error("Error saving title:", error);
                this.isError = true;
            }).finally(()=>{
                this.isSavingTitle = false;
            });
        },
        toggleCreatorSharing () {
            this.isSharing = true;
            this.targetFile.flag = this.targetFile.flag ? 0 : 1;
            this.creatorPageShare(this.targetFile).then(()=>{
                this.isError = false;
            }).catch((error)=>{
                console.error("Error sharing media:", error);
                this.isError = true;
                // Revert the flag
                this.targetFile.flag = this.targetFile.flag ? 0 : 1;
            }).finally(()=>{
                this.isSharing = false;
            });
        },
        cancelDescriptionEdit () {
            if (!this.isSavingDescription) {
                this.editDescription = false;
                this.newDescription = this.targetFile.description;
            }
        },
        cancelTitleEdit () {
            if (!this.isSavingTitle) {
                this.editTitle = false;
                this.newTitle = this.targetFile.title ?? this.targetFile.name;
            }
        },
        delete () {
            const id = this.targetFile.id;
            this.isDeleting = true;
            if (this.deleteAssociatedNotes && this.targetFile.associated_notes?.length > 0) {
                const noteIds = this.targetFile.associated_notes.split(",").map((id_ts)=>id_ts.split(":")[0]);
                const nostrStore = (0, $dc6El.default).store("nostrStore");
                nostrStore.deleteEvent(noteIds).then(()=>{
                    console.debug("Deleted associated notes:", noteIds);
                    this.deleteMedia(id).then(()=>{
                        this.isDeleting = false;
                        console.debug("Deleted media and its notes:", id, noteIds);
                        this.close();
                    }).catch((error)=>{
                        console.error("Error deleting media:", error);
                        this.isError = true;
                    }).finally(()=>{
                        this.isDeleting = false;
                        this.deleteAssociatedNotes = false;
                    });
                }).catch((error)=>{
                    console.error("Error deleting associated notes:", error);
                    this.isError = true;
                }).finally(()=>{
                    this.isDeleting = false;
                });
            } else this.deleteMedia(id).then(()=>{
                this.isDeleting = false;
                console.debug("Deleted media:", id);
                this.close();
            }).catch((error)=>{
                console.error("Error deleting media:", error);
                this.isError = true;
            }).finally(()=>{
                this.isDeleting = false;
            });
        },
        deleteMedia (id) {
            // Get the current store
            const fileStore = (0, $dc6El.default).store("fileStore");
            return fileStore.deleteItem(id);
        },
        async saveMediaEdit (file) {
            console.debug("Saving media edit:", file);
            const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
            const formData = {
                action: "update_media_metadata",
                mediaId: file.id,
                title: file.title,
                description: file.description
            };
            return api.post("", formData).then((response)=>response.data).then((data1)=>{
                console.debug("Saved media edit:", data1);
                const fileStore = (0, $dc6El.default).store("fileStore");
                const updatedFile = fileStore.files.find((f)=>f.id === file.id);
                if (updatedFile) {
                    updatedFile.title = file.title;
                    updatedFile.description = file.description;
                }
            });
        },
        async creatorPageShare (file) {
            console.debug("Toggling sharing of the media on Creators page:", file.id);
            const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
            const formData = {
                action: "share_creator_page",
                shareFlag: file?.flag ? "true" : "false",
                imagesToShare: JSON.stringify([
                    file.id
                ])
            };
            return api.post("", formData).then((response)=>response.data).then((data1)=>{
                //console.debug('Shared media on Creators page:', data);
                const sharedImageIds = data1.sharedImages || [];
                const menuStore1 = (0, $dc6El.default).store("menuStore");
                const fileStore = (0, $dc6El.default).store("fileStore");
                // Update the shared flag and count for each file
                fileStore.files.forEach((file)=>{
                    if (sharedImageIds.includes(file.id)) {
                        file.flag = file?.flag ? 1 : 0;
                        // We can assume we are in the same folder as the files
                        menuStore1.updateSharedStatsFromFile(file, menuStore1.activeFolder, file?.flag);
                    }
                });
            });
        }
    },
    deleteConfirmation: {
        isOpen: false,
        isLoading: false,
        isError: false,
        selectedIds: [],
        selectedFiles: [],
        callback: null,
        open (ids, callback) {
            // Convert single ID to array
            if (!Array.isArray(ids)) ids = [
                ids
            ];
            console.debug("Opening delete confirmation:", ids);
            this.selectedIds = ids;
            this.selectedFiles = (0, $dc6El.default).store("fileStore").files.filter((file)=>ids.includes(file.id));
            console.debug("Selected files:", this.selectedFiles);
            this.isOpen = true;
            this.callback = callback;
        },
        close (dontCallback) {
            this.selectedIds = [];
            this.selectedFiles = [];
            this.isError = false;
            this.isOpen = false;
            this.isLoading = false;
            if (this.callback && !dontCallback) this.callback();
        }
    },
    confirmDelete () {
        this.deleteConfirmation.isLoading = true;
        this.deleteItem(this.deleteConfirmation.selectedIds).then(()=>{
            this.deleteConfirmation.close();
            this.isError = false;
        }).catch((error)=>{
            console.error("Error deleting files:", error);
            this.isError = true;
        }).finally(()=>{
            this.deleteConfirmation.isLoading = false;
        });
    },
    async deleteItem (itemIds) {
        console.debug("Deleting image:", itemIds);
        itemIds = Array.isArray(itemIds) ? itemIds : [
            itemIds
        ];
        const formData = {
            action: "delete",
            imagesToDelete: JSON.stringify(itemIds)
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        const menuStore1 = (0, $dc6El.default).store("menuStore");
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            console.debug("Deleted image:", data1);
            const deletedImageIds = data1.deletedImages || [];
            // Update the file stats for each file
            this.files.forEach((file)=>{
                if (deletedImageIds.includes(file.id)) menuStore1.updateFolderStatsFromFile(file, menuStore1.activeFolder, false);
            });
            // Remove deleted images from the grid
            this.files = this.files.filter((f)=>!deletedImageIds.includes(f.id));
            // Refresh the files starting at 0 and up to the original length + 
            this.fetchFiles(this.lastFetchedFolder, true);
        }).catch((error)=>{
            console.error("Error deleting image:", error);
        });
    },
    // Filter: "all", "images", "videos", "audio", 'gifs'
    filters: {
        all: {
            filter: "all",
            name: "All",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true"><path d="M18 22H4a2 2 0 0 1-2-2V6"/><path d="m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"/><circle cx="12" cy="8" r="2"/><rect width="16" height="16" x="6" y="2" rx="2"/></svg>`
        },
        images: {
            filter: "images",
            name: "Images",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>`
        },
        gifs: {
            filter: "gifs",
            name: "GIFs",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true"><path d="m11 16-5 5"/><path d="M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5"/><path d="M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z"/><circle cx="9" cy="9" r="2"/></svg>`
        },
        videos: {
            filter: "videos",
            name: "Videos",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>`
        },
        audio: {
            filter: "audio",
            name: "Audio",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/></svg>`
        },
        documents: {
            filter: "documents",
            name: "Documents",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>`
        },
        archives: {
            filter: "archives",
            name: "Archives",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5"><path d="M10 12v-1"/><path d="M10 18v-2"/><path d="M10 7V6"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"/><circle cx="10" cy="20" r="2"/></svg>`
        },
        others: {
            filter: "others",
            name: "Others",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5"><path d="M20 7h-3a2 2 0 0 1-2-2V2"/><path d="M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"/><path d="M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"/></svg>`
        }
    },
    currentFilter: "all",
    setFilter (filter) {
        this.currentFilter = filter;
        this.fetchFiles(this.lastFetchedFolder, true);
    },
    filterMenuOpen: false,
    fileFetchStart: 0,
    fileFetchLimit: 96,
    fileFetchHasMore: true,
    lastFetchedFolder: "",
    loadingMoreFiles: false,
    refreshFoldersAfterFetch: false,
    async fetchFiles (folder, refresh = false) {
        //console.debug('Fetching files:', folder, start, limit, refresh);
        const uppyStore = (0, $dc6El.default).store("uppyStore");
        if (!folder) {
            this.resetFetchFilesState();
            console.debug("Empty folder:", folder);
            return;
        }
        if (this.lastFetchedFolder !== folder) {
            this.resetFetchFilesState();
            this.lastFetchedFolder = folder;
            this.loading = true;
            console.debug("Folder changed:", folder);
        } else {
            this.loadingMoreFiles = true;
            console.debug("Fetching more files...");
        }
        if (!this.fileFetchHasMore && !refresh) {
            this.loading = false;
            this.loadingMoreFiles = false;
            console.debug("No more files to fetch.");
            return;
        }
        const fetchLimit = refresh ? this.files.length + this.fileFetchLimit : this.fileFetchLimit;
        const params = {
            action: "list_files",
            folder: folder,
            start: refresh ? 0 : this.fileFetchStart,
            limit: fetchLimit,
            filter: this.currentFilter
        };
        //console.debug('Fetching files:', params);
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
        try {
            const response = await api.get("", {
                params: params
            });
            const data1 = response.data;
            if (data1.error) {
                console.error("Error fetching files:", data1.error);
                this.loadingMoreFiles = false;
                throw new Error(data1.error);
            }
            if (data1 && (data1.length > 0 || refresh)) {
                if (!refresh) {
                    const hasDuplicates = data1.some((file)=>this.files.some((f)=>f.id === file.id));
                    if (hasDuplicates) {
                        console.debug("Duplicate files found, refreshing...");
                        await this.fetchFiles(folder, true);
                        return;
                    }
                    this.files = [
                        ...uppyStore.mainDialog.getFilesInFolder(folder) ?? [],
                        ...this.files,
                        ...data1
                    ];
                    this.fileFetchHasMore = data1.length === this.fileFetchLimit;
                    this.fileFetchStart += data1.length;
                } else {
                    // Create a Map of existing files for faster lookup
                    const existingFilesMap = new Map(this.files.map((file)=>[
                            file.id,
                            file
                        ]));
                    // Update the loaded state of files in data based on the existing files
                    data1.forEach((file)=>{
                        const existingFile = existingFilesMap.get(file.id);
                        if (existingFile) file.loaded = existingFile.loaded;
                    });
                    // Replace this.files with the updated data array
                    this.files = [
                        ...uppyStore.mainDialog.getFilesInFolder(folder) ?? [],
                        ...data1
                    ];
                    const expectedLength = fetchLimit;
                    this.fileFetchHasMore = data1.length === expectedLength;
                    this.fileFetchStart = data1.length;
                }
                //console.debug('Parameters:', this.fileFetchStart, this.fileFetchLimit, this.fileFetchHasMore, this.files.length, data.length);
                if (this.fileFetchHasMore) {
                    const lastFileIndex = this.files.length - Math.floor(this.fileFetchLimit * 0.2) - 1;
                    this.files[lastFileIndex].loadMore = true;
                }
            } else {
                this.fileFetchHasMore = false;
                console.debug("No more files to fetch.");
            }
        } catch (error) {
            console.error("Error fetching files:", error);
        } finally{
            this.loading = false;
            this.loadingMoreFiles = false;
            if (this.refreshFoldersAfterFetch) {
                console.debug("Refetching folders...");
                (0, $dc6El.default).store("menuStore").fetchFolders();
                this.refreshFoldersAfterFetch = false;
            }
        }
    },
    async loadMoreFiles () {
        console.debug("Loading more triggered.");
        if (!this.loading && this.fileFetchHasMore && !this.loadingMoreFiles) {
            this.loadingMoreFiles = true;
            // Find the last file object with loadMore property defined and set to true
            // and remove it.
            const lastFileIndex = this.files.findIndex((f)=>f.loadMore);
            if (lastFileIndex > -1) delete this.files[lastFileIndex].loadMore;
            //console.debug('Last file:', this.files[lastFileIndex]);
            await this.fetchFiles(this.lastFetchedFolder).finally(()=>{
                console.debug("Loading more done.");
                this.loadingMoreFiles = false;
            });
        }
    },
    resetFetchFilesState () {
        this.files = [];
        this.filesById = {};
        this.fileFetchStart = 0;
        this.fileFetchHasMore = true;
        this.lastFetchedFolder = "";
        this.loading = false;
        this.loadingMoreFiles = false;
    },
    injectFile (file) {
        console.debug("Injecting file:", file);
        this.files.unshift(file);
    },
    modalFile: {},
    modalFileNext: {},
    modalFilePrevious: {},
    modalOpen: false,
    modalImageUrl: "",
    modalImageSrcset: "",
    modalImageSizes: "",
    modalImageAlt: "",
    modalImageDimensions: "",
    modalImageFilesize: "",
    modalImageTitle: "",
    modalImageDescription: "",
    modalImagePrompt: "",
    modalCloseTimeout: null,
    openModal (file) {
        // Clear any pending timeout
        if (this.modalCloseTimeout) {
            clearTimeout(this.modalCloseTimeout);
            this.modalCloseTimeout = null; // Reset timeout reference
        }
        // Set modal content before opening to prevent flashing
        this.updateModalWithAdjacent(file);
        // Lock body scroll and open modal
        (0, $3fdfb4a389f15bd9$export$6a9f04c98a658ecb)();
        this.modalOpen = true;
    },
    async updateModalWithAdjacent (file) {
        if (!file) return; // Guard clause
        // First update the current file's content
        const { url: url, srcset: srcset, sizes: sizes, title: title, name: name, width: width, height: height, size: size, description: description, ai_prompt: ai_prompt } = file;
        Object.assign(this, {
            modalFile: file,
            modalImageUrl: url,
            modalImageSrcset: srcset,
            modalImageSizes: sizes,
            modalImageAlt: title || name,
            modalImageDimensions: width && height ? `${width}x${height}` : "",
            modalImageFilesize: size,
            modalImageTitle: title || "",
            modalImageDescription: description || "",
            modalImagePrompt: ai_prompt || ""
        });
        // Then handle adjacent files with loadMore consideration
        const nextFile = await this.getNextFileWithLoading(file, false);
        const prevFile = await this.getNextFileWithLoading(file, true);
        this.modalFileNext = nextFile;
        this.modalFilePrevious = prevFile;
    },
    async getNextFileWithLoading (file, reverse) {
        let nextFile = this.getNextFile(file, reverse);
        if (nextFile.loadMore) {
            await this.loadMoreFiles();
            nextFile = this.getNextFile(file, reverse);
        }
        return nextFile;
    },
    closeModal () {
        // Clear any existing timeout first
        if (this.modalCloseTimeout) {
            clearTimeout(this.modalCloseTimeout);
            this.modalCloseTimeout = null;
        }
        // Close modal first
        this.modalOpen = false;
        (0, $3fdfb4a389f15bd9$export$22f1f1f07a1ac788)();
        // Then schedule the cleanup
        this.modalCloseTimeout = setTimeout(()=>{
            if (!this.modalOpen) Object.assign(this, {
                modalFile: {},
                modalFileNext: {},
                modalFilePrevious: {},
                modalImageUrl: "",
                modalImageSrcset: "",
                modalImageSizes: "",
                modalImageAlt: "",
                modalImageDimensions: "",
                modalImageFilesize: "",
                modalImageTitle: "",
                modalImageDescription: "",
                modalImagePrompt: ""
            });
            this.modalCloseTimeout = null; // Clear timeout reference
        }, 350);
    },
    async modalNext () {
        const nextFile = await this.getNextFileWithLoading(this.modalFile, false);
        this.updateModalWithAdjacent(nextFile);
    },
    async modalPrevious () {
        const previousFile = await this.getNextFileWithLoading(this.modalFile, true);
        this.updateModalWithAdjacent(previousFile);
    },
    getNextFile (file, reverse) {
        // Return a file object based on the current file and direction
        const currentIndex = this.files.findIndex((f)=>f.id === file.id);
        let nextIndex;
        if (reverse) {
            // If going in reverse direction
            nextIndex = currentIndex - 1;
            if (nextIndex < 0) // If at the beginning, wrap around to the last file
            nextIndex = this.files.length - 1;
        } else {
            // If going in forward direction
            nextIndex = currentIndex + 1;
            if (nextIndex >= this.files.length) // If at the end, wrap around to the first file
            nextIndex = 0;
        }
        const nextFile = this.files[nextIndex];
        return nextFile || file;
    },
    // Embeddable links and iframe creation code
    embed: {
        getEmbedURL (file) {
            if (!file || !file?.url) return "";
            const { hostname: hostname, pathname: pathname } = new URL(file.url);
            const prefix = hostname.split(".").shift();
            const filename = pathname.slice(1).split(".").slice(0, -1).join(".");
            const extension = pathname.split(".").pop();
            const url = new URL(`https://e.nostr.build/${prefix}_${filename}_${extension}`);
            // Add parameters using URLSearchParams
            url.searchParams.append("t", file?.title || file?.name);
            // Add user nym as a by parameter
            url.searchParams.append("by", (0, $dc6El.default).store("profileStore").profileInfo.name || "Anon");
            if (file?.width && file?.height) {
                url.searchParams.append("w", `${file.width}px`);
                url.searchParams.append("h", `${file.height}px`);
            }
            return url.toString();
        },
        generateImgCode (file) {
            const embedCode = `<img src="${file.url}" alt="${file?.title || file?.name}" width="${file?.width}" height="${file?.height}" loading="lazy">`;
            return embedCode;
        },
        generateResponsiveImgCode (file) {
            const embedCode = `<img src="${file.url}" srcset="${file.srcset}" sizes="${file.sizes}" alt="${file?.title || file?.name}" width="${file?.width}" height="${file?.height}" loading="lazy">`;
            return embedCode;
        },
        copyImgCode (file) {
            const embedCode = this.generateImgCode(file);
            copyToClipboard(embedCode);
        },
        generateIframeCode (file) {
            const iframeUrl = this.getEmbedURL(file);
            const iframeCode = `<iframe src="${iframeUrl}" style="border: 0; width: ${file?.width || "100%"}; height: ${file?.height || "100%"}; min-height: 560px; display: block; aspect-ratio: ${file?.width || "1"}/${file?.height || "1"}" allow="fullscreen; encrypted-media; picture-in-picture" loading="lazy" title="${file?.title || file?.name}"></iframe>`;
            return iframeCode;
        },
        copyIframeCode (file) {
            const iframeCode = this.generateIframeCode(file);
            copyToClipboard(iframeCode);
        }
    },
    // Stats and analytics
    stats: {
        isLoading: false,
        isError: false,
        errorMessage: "",
        statsCache: {},
        // Convert interval string to milliseconds
        intervalToMilliseconds (interval) {
            const units = {
                "m": 60000,
                "h": 3600000,
                "d": 86400000
            };
            const match = interval.match(/^(\d+)([mhd])$/);
            if (!match) throw new Error("Invalid interval format");
            const value = parseInt(match[1], 10);
            const unit = match[2];
            return value * units[unit];
        },
        // Round time to the start of the interval
        toStartOfInterval (time, interval) {
            const date = new Date(time);
            const match = interval.match(/^(\d+)([mhd])$/);
            if (!match) throw new Error("Invalid interval format");
            const value = parseInt(match[1], 10);
            const unit = match[2];
            switch(unit){
                case "m":
                    const minutes = date.getMinutes();
                    date.setMinutes(Math.floor(minutes / value) * value);
                    date.setSeconds(0, 0);
                    break;
                case "h":
                    const hours = date.getHours();
                    date.setHours(Math.floor(hours / value) * value);
                    date.setMinutes(0, 0, 0);
                    break;
                case "d":
                    date.setHours(0, 0, 0, 0);
                    break;
                default:
                    date.setSeconds(0, 0);
                    break;
            }
            return date;
        },
        // Parse data and extract metric names from JSON
        parseData (jsonData, interval) {
            try {
                if (!jsonData || !jsonData.data || !jsonData.meta) throw new Error("Invalid JSON data");
                // Extract metric names from meta, excluding 'time'
                const metrics = jsonData.meta.map((item)=>item.name).filter((name)=>name !== "time");
                // Parse data
                const data1 = jsonData.data.map((item)=>{
                    let time = new Date(item.time * 1000);
                    time = this.toStartOfInterval(time, interval);
                    // Build data object dynamically
                    const dataItem = {
                        time: time
                    };
                    metrics.forEach((metric)=>{
                        const value = item[metric];
                        if (value !== undefined) dataItem[metric] = parseFloat(value) || 0;
                    });
                    return dataItem;
                });
                return {
                    data: data1,
                    metrics: metrics
                };
            } catch (error) {
                console.error("Error parsing data:", error);
                return {
                    data: [],
                    metrics: []
                };
            }
        },
        // Generate time labels aligned with the data intervals
        generateTimeLabels (startDate, endDate, interval) {
            const labels = [];
            const intervalMs = this.intervalToMilliseconds(interval);
            const current = new Date(startDate);
            while(current <= endDate){
                labels.push(new Date(current)); // Clone the date
                current.setTime(current.getTime() + intervalMs);
            }
            return labels;
        },
        // Merge data with labels
        mergeDataWithLabels (labels, data1, metric) {
            const dataMap = new Map();
            data1.forEach((item)=>{
                const timeKey = item.time.getTime();
                dataMap.set(timeKey, item[metric]);
            });
            const mergedData = labels.map((label)=>{
                const timeKey = label.getTime();
                return dataMap.get(timeKey) || 0; // Use 0 if data is missing
            });
            return mergedData;
        },
        // Prepare datasets for Chart.js
        prepareDatasets (labels, data1, metrics) {
            const datasets = metrics.map((metric, index)=>{
                // Calculate the total sum of the data points for the current metric
                const total = this.mergeDataWithLabels(labels, data1, metric).reduce((sum, value)=>sum + value, 0);
                // Return the dataset with the total appended to the label
                return {
                    label: metric.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase()) + ` (${abbreviateNumber(total)})`,
                    data: this.mergeDataWithLabels(labels, data1, metric),
                    borderColor: this.getColor(index),
                    backgroundColor: this.getColor(index, 0.8),
                    fill: true,
                    pointRadius: 1
                };
            });
            return datasets;
        },
        // Colorblind-friendly color palette
        getColor (index, alpha = 1) {
            const colors = [
                "rgba(0, 114, 178, ALPHA)",
                "rgba(230, 159, 0, ALPHA)",
                "rgba(86, 180, 233, ALPHA)",
                "rgba(0, 158, 115, ALPHA)",
                "rgba(240, 228, 66, ALPHA)",
                "rgba(204, 121, 167, ALPHA)",
                "rgba(213, 94, 0, ALPHA)"
            ];
            return colors[index % colors.length].replace("ALPHA", alpha);
        },
        // Fetch and cache stats
        async getStats (mediaId, period = "day", interval = "1h", groupBy = "time") {
            // Check if the stats are already loaded and cached
            const stats = this.statsCache[mediaId];
            const key = `${period}-${interval}-${groupBy}`;
            if (!stats || !stats[key] || !stats[key].data || stats[key].expires < Date.now()) // Fetch the stats and cache them before returning
            await this.fetchStats(mediaId, period, interval, groupBy);
            return this.statsCache[mediaId][key].data;
        },
        async fetchStats (mediaId, period = "day", interval = "1h", groupBy = "time") {
            this.isError = false;
            this.errorMessage = "";
            const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "application/json");
            console.debug("Fetching stats:", mediaId, period, interval, groupBy);
            try {
                const response = await api.get("", {
                    params: {
                        action: "get_media_stats",
                        media_id: mediaId,
                        period: period,
                        interval: interval,
                        group_by: groupBy
                    }
                });
                const data1 = response.data;
                const key = `${period}-${interval}-${groupBy}`;
                const intervalMs = this.intervalToMilliseconds(interval);
                const expires = Date.now() + intervalMs;
                if (!this.statsCache[mediaId]) this.statsCache[mediaId] = {};
                this.statsCache[mediaId][key] = {
                    expires: expires,
                    data: JSON.parse(data1)
                };
            } catch (error) {
                console.error("Error fetching stats:", error);
                this.isError = true;
                this.errorMessage = "Error fetching stats.";
            }
        },
        // Render charts using Chart.js
        async renderCharts (mediaId, element, period = "day", interval = "1h", groupBy = "time") {
            try {
                this.isLoading = true;
                this.isError = false;
                // Get the raw data
                const rawData = await this.getStats(mediaId, period, interval, groupBy);
                // Parse the data and extract metrics
                const { data: data1, metrics: metrics } = this.parseData(rawData, interval);
                // Determine start and end dates
                let endDate = new Date();
                endDate = this.toStartOfInterval(endDate, interval);
                let startDate = new Date(endDate);
                switch(period){
                    case "1h":
                        startDate.setHours(startDate.getHours() - 1);
                        break;
                    case "3h":
                        startDate.setHours(startDate.getHours() - 3);
                        break;
                    case "6h":
                        startDate.setHours(startDate.getHours() - 6);
                        break;
                    case "12h":
                        startDate.setHours(startDate.getHours() - 12);
                        break;
                    case "day":
                        startDate.setDate(startDate.getDate() - 1);
                        break;
                    case "week":
                        startDate.setDate(startDate.getDate() - 7);
                        break;
                    case "month":
                        startDate.setMonth(startDate.getMonth() - 1);
                        break;
                    case "3months":
                        startDate.setMonth(startDate.getMonth() - 3);
                        break;
                    default:
                        startDate.setDate(startDate.getDate() - 1);
                }
                startDate = this.toStartOfInterval(startDate, interval);
                // Generate labels
                const labels = this.generateTimeLabels(startDate, endDate, interval);
                // Prepare datasets
                const datasets = this.prepareDatasets(labels, data1, metrics);
                // Prepare Chart.js data
                const chartData = {
                    labels: labels.map((label)=>label.getTime()),
                    // Take only first two datasets for now
                    datasets: datasets.slice(0, 2)
                };
                // Chart.js configuration
                const config = {
                    type: "bar",
                    data: chartData,
                    options: {
                        parsing: true,
                        responsive: true,
                        interaction: {
                            mode: "nearest"
                        },
                        plugins: {
                            decimation: {
                                enabled: true,
                                algorithm: "lttb",
                                samples: 100
                            },
                            legend: {
                                display: true,
                                labels: {
                                    // Light grey color
                                    color: "rgba(255, 255, 255, 0.8)"
                                }
                            },
                            tooltip: {
                                usePointStyle: true,
                                enabled: true,
                                callbacks: {
                                    labelPointStyle: function(context) {
                                        return {
                                            pointStyle: "circle",
                                            rotation: 0
                                        };
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                type: "timestack",
                                color: "rgba(255, 255, 255, 0.8)",
                                time: {
                                    unit: interval.endsWith("h") ? "hour" : "minute",
                                    displayFormats: {
                                        minute: "MMM d, HH:mm",
                                        hour: "MMM d, HH:mm"
                                    },
                                    tooltipFormat: "MMM d, yyyy HH:mm"
                                },
                                title: {
                                    display: true,
                                    text: "Time",
                                    color: "rgba(255, 255, 255, 0.8)"
                                }
                            },
                            y: {
                                beginAtZero: true,
                                color: "rgba(255, 255, 255, 0.8)",
                                title: {
                                    display: true,
                                    text: "Count",
                                    color: "rgba(255, 255, 255, 0.8)"
                                }
                            }
                        }
                    }
                };
                // If a chart instance already exists on the element, destroy it
                if (element.chartInstance) {
                    console.debug("Destroying existing chart instance.");
                    element.chartInstance.destroy();
                }
                // Get the context from the canvas element
                const ctx = element.getContext("2d");
                // Create a new Chart instance and store it on the element
                element.chartInstance = new (0, $c3a56386499aaa20$export$2e2bcd8739ae039)(ctx, config);
                this.isLoading = false;
            } catch (error) {
                console.error("Error rendering charts:", error);
                this.isLoading = false;
                this.isError = true;
                this.errorMessage = "Error rendering charts.";
            }
        }
    },
    // Video Poster
    async checkAndSetPoster (file, el, cb = 600000 /* 10 minutes */ , bypassCache = false) {
        if (file.posterChecked) return;
        const cacheBust = Math.ceil(Date.now() / cb) * cb;
        const posterUrl = `${file.url}/poster.jpg?_=${cacheBust}`;
        try {
            // Create one-off configured axios instance for this request
            const headers = {
                "Accept": "image/*",
                // Set x-nb-no-redirect to prevent default poster redirect
                "x-nb-no-redirect": "1"
            };
            if (bypassCache) headers["x-nb-bypass-cache"] = "1";
            const posterFetcher = (0, $eb999ef253053d6e$export$2e2bcd8739ae039).create({
                timeout: 10000,
                withCredentials: true,
                headers: headers,
                responseType: "blob",
                maxRedirects: 0,
                keepalive: true
            });
            // Configure retries inline
            (0, $3a262adf5ef57145$export$2e2bcd8739ae039)(posterFetcher, {
                retries: 3,
                retryDelay: (retryNumber = 0)=>{
                    const delayFactor = 300;
                    const delay = 2 ** retryNumber * delayFactor;
                    const randomSum = delay * 0.2 * Math.random();
                    return delay + randomSum;
                },
                retryCondition: (error)=>{
                    return (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isNetworkOrIdempotentRequestError(error) || (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isSafeRequestError(error) || (0, $3a262adf5ef57145$export$2e2bcd8739ae039).isRetryableError(error);
                }
            });
            const response = await posterFetcher.get(posterUrl);
            if (response.status !== 200 || response.request?.responseURL !== posterUrl) throw new Error("Invalid response status or redirect");
            const dataUrl = await new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>resolve(reader.result);
                reader.readAsDataURL(response.data);
            });
            el.poster = dataUrl;
            file.posterChecked = true;
            return true;
        } catch (error) {
            file.posterChecked = true;
            return false;
        }
    }
});
// URL Import Store
(0, $dc6El.default).store("urlImportStore", {
    isLoading: false,
    isError: false,
    errorMessage: "",
    importURL: "",
    importFolder: "",
    clear (callback) {
        this.isLoading = false;
        this.isError = false;
        this.errorMessage = "";
        this.importURL = "";
        this.importFolder = "";
        if (typeof callback === "function") callback();
    },
    setErrorWithTimeout (message) {
        this.isError = true;
        this.errorMessage = message;
        setTimeout(()=>{
            this.isError = false;
            this.errorMessage = "";
        }, 5000);
    },
    async importFromURL () {
        console.debug("Importing from URL:", this.importURL, this.importFolder);
        // Validate URL
        if (!this.importURL.startsWith("http://") && !this.importURL.startsWith("https://")) {
            console.debug("Invalid URL:", this.importURL);
            this.setErrorWithTimeout("URL is empty or invalid.");
            return;
        }
        this.isLoading = true;
        this.isError = false;
        this.errorMessage = "";
        // Stores
        const menuStore1 = (0, $dc6El.default).store("menuStore");
        const fileStore = (0, $dc6El.default).store("fileStore");
        // Store folder name
        const folderName = menuStore1.activeFolder;
        // Check if folderName is default home folder
        const importToHomeFolder = menuStore1.folders.find((folder)=>folder.name === folderName).id === 0;
        const formData = {
            action: "import_from_url",
            url: this.importURL,
            folder: importToHomeFolder ? "" : folderName
        };
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data", 300000); // 5 minutes timeout
        return api.post("", formData).then((response)=>response.data).then((data1)=>{
            if (data1.error) {
                console.error("Error importing from URL:", data1.error);
                this.isLoading = false;
                this.setErrorWithTimeout("Error importing from URL.");
                return;
            }
            console.debug("Import from URL:", data1);
            // Is current active folder a home folder?
            const home = menuStore1.folders.find((folder)=>folder.name === menuStore1.activeFolder).id === 0;
            // Update the folder stats
            menuStore1.updateFolderStatsFromFile(data1, folderName, true);
            // Check if the we are in the same folder as the imported file
            if (menuStore1.activeFolder === folderName || home && importToHomeFolder) // Inject the imported file into the files array
            fileStore.injectFile(data1);
            this.clear();
        }).catch((error)=>{
            console.error("Error importing from URL:", error);
            this.isLoading = false;
            this.setErrorWithTimeout("Error importing from URL.");
        });
    }
});
// Uppy Store
(0, $dc6El.default).store("uppyStore", {
    // Array of filepond instances
    instance: null,
    // Dialog state
    mainDialog: {
        dialogEl: null,
        isOpen: false,
        isLoading: false,
        uploadProgress: null,
        uploadFolder: "",
        isError: false,
        errorMessage: "",
        callback: null,
        open (callback) {
            this.isOpen = true;
            this.callback = callback;
        },
        close (dontCallback) {
            this.isOpen = false;
            //this.isLoading = false; // Should be controlled by Uppy
            this.isError = false;
            this.errorMessage = "";
            if (this.callback && !dontCallback) this.callback();
        },
        toggle () {
            this.isOpen ? this.close() : this.open();
        },
        currentFiles: [],
        currentFilesById: new Map(),
        addFile (file) {
            this.currentFiles.unshift(file);
            // Update currentFilesById Map
            if (this.currentFilesById.has(file.id)) this.currentFilesById.set(file.id, file);
            else this.currentFilesById = new Map([
                ...this.currentFilesById,
                [
                    file.id,
                    file
                ]
            ]);
        },
        removeFile (fileId) {
            const index = this.currentFiles.findIndex((f)=>f.id === fileId);
            if (index !== -1) {
                this.currentFiles.splice(index, 1);
                // Update currentFilesById Map
                this.currentFilesById.delete(fileId);
            }
        },
        getFileById (fileId) {
            return this.currentFilesById.get(fileId);
        },
        clearFiles () {
            this.currentFiles = [];
            this.currentFilesById = new Map();
        },
        getFilesInFolder (folderName) {
            // Check for default home folder
            folderName = (0, $dc6El.default).store("menuStore").folders.find((folder)=>folder.name === folderName).id === 0 ? "" : folderName;
            return this.currentFiles.filter((file)=>file.folder === folderName);
        }
    },
    getAllowedFileTypes (accountLevel = 0) {
        // Return allowed file types
        // Copy of the server-side libs/utils.funcs.php array
        // This is just for client side convenience, it is still enforced server-side
        const mimeTypesImages = {
            "image/jpeg": "jpg",
            "image/jpeg": "jpeg",
            "image/png": "png",
            "image/apng": "apng",
            "image/gif": "gif",
            "image/webp": "webp",
            "image/bmp": "bmp",
            "image/tiff": "tiff",
            "image/heic": "heic",
            "image/heif": "heif",
            "image/avif": "avif",
            "image/jp2": "jp2",
            "image/jpx": "jpx",
            "image/jpm": "jpm",
            "image/jxr": "jxr",
            "image/pipeg": "jfif",
            "image/dng": "dng",
            "image/*": "jpg"
        };
        const mimeTypesAudio = {
            "audio/mpeg": "mp3",
            "audio/ogg": "ogg",
            "audio/wav": "wav",
            "audio/aac": "aac",
            "audio/webm": "weba",
            "audio/flac": "flac",
            "audio/x-aiff": "aif",
            "audio/x-ms-wma": "wma",
            "audio/x-m4a": "m4a",
            "audio/x-m4b": "m4b",
            "audio/mp4": "mp4a",
            "audio/mpegurl": "m3u",
            "audio/x-mpegurl": "m3u",
            "audio/x-ms-wax": "wax",
            "audio/x-realaudio": "ra",
            "audio/x-pn-realaudio": "ram",
            "audio/x-pn-realaudio-plugin": "rmp",
            "audio/x-wav": "wav"
        };
        const mimeTypesVideo = {
            "video/mp4": "mp4",
            "video/webm": "webm",
            "video/ogg": "ogv",
            "video/x-msvideo": "avi",
            "video/x-ms-wmv": "wmv",
            "video/quicktime": "mov",
            "video/mpeg": "mpeg",
            "video/3gpp": "3gp",
            "video/3gpp2": "3g2",
            "video/x-flv": "flv",
            "video/x-m4v": "m4v",
            "video/x-matroska": "mkv",
            "video/x-mpeg2": "mp2v",
            "video/x-m4p": "m4p",
            "video/mp2t": "m2ts",
            "video/MP2T": "ts",
            "video/mp2p": "mp2",
            "video/x-mxf": "mxf",
            "video/x-ms-asf": "asf",
            "video/x-ms-wm": "asf",
            "video/x-pn-realvideo": "rm",
            "video/x-ms-vob": "vob",
            "video/x-f4v": "f4v",
            "video/x-fli": "fli",
            "video/x-m2v": "m2v",
            "video/x-ms-wmx": "wmx",
            "video/x-ms-wvx": "wvx",
            "video/x-sgi-movie": "movie"
        };
        const mimeTypesAddonDocs = {
            "application/pdf": "pdf",
            "image/svg+xml": "svg"
        };
        const mimeTypesAddonExtra = {
            "application/zip": "zip",
            "application/x-tar": "tar"
        };
        // Construct lists of extensions based on account level
        const extsImages = Object.values(mimeTypesImages).map((ext)=>`.${ext}`);
        const extsAudio = Object.values(mimeTypesAudio).map((ext)=>`.${ext}`);
        const extsVideo = Object.values(mimeTypesVideo).map((ext)=>`.${ext}`);
        const extsAddonDocs = Object.values(mimeTypesAddonDocs).map((ext)=>`.${ext}`);
        const extsAddonExtra = Object.values(mimeTypesAddonExtra).map((ext)=>`.${ext}`);
        const mimesImages = Object.keys(mimeTypesImages).map((mime)=>mime);
        const mimesAudio = Object.keys(mimeTypesAudio).map((mime)=>mime);
        const mimesVideo = Object.keys(mimeTypesVideo).map((mime)=>mime);
        const mimesAddonDocs = Object.keys(mimeTypesAddonDocs).map((mime)=>mime);
        const mimesAddonExtra = Object.keys(mimeTypesAddonExtra).map((mime)=>mime);
        switch(accountLevel){
            case 1:
            case 10:
            case 99:
                console.debug("All file types allowed.");
                return [
                    ...mimesImages,
                    ...mimesAudio,
                    ...mimesVideo,
                    ...mimesAddonDocs,
                    ...mimesAddonExtra,
                    ...extsAddonDocs,
                    ...extsAddonExtra
                ];
            case 2:
                console.debug("All file types allowed except for archives.");
                return [
                    ...mimesImages,
                    ...mimesAudio,
                    ...mimesVideo,
                    ...mimesAddonDocs,
                    ...extsAddonDocs
                ];
            default:
                console.debug("Default file types allowed.");
                return [
                    ...mimesImages,
                    ...mimesAudio,
                    ...mimesVideo
                ];
        }
    },
    instantiateUppy (el, dropTarget, onDropCallback, onDragOverCallback, onDragLeaveCallback) {
        this.mainDialog.dialogEl = el;
        console.debug("Instantiating Uppy...");
        // Stores
        const menuStore1 = (0, $dc6El.default).store("menuStore");
        const fileStore = (0, $dc6El.default).store("fileStore");
        const profileStore1 = (0, $dc6El.default).store("profileStore");
        this.instance = new (0, $b16b91c7840d3bff$export$2e2bcd8739ae039)({
            debug: false,
            autoProceed: true,
            allowMultipleUploadBatches: false,
            restrictions: {
                maxFileSize: 4294967296,
                maxTotalFileSize: profileStore1.profileInfo.storageRemaining,
                allowedFileTypes: this.getAllowedFileTypes()
            },
            //maxTotalFileSize: 150 * 1024 * 1024,
            onBeforeFileAdded: (currentFile, files1)=>{
                // Limit the size of the files that are not images, videos, or audio to 1GiB
                const fileType = currentFile.type.split("/")[0]; // Extract the file type from the MIME type
                if (fileType !== "image" && fileType !== "video" && fileType !== "audio") {
                    if (currentFile.size > 1024 ** 3) {
                        this.instance.info(`Skipping file ${currentFile.name} because it's too large`, "error", 500);
                        return false; // Exclude the file
                    }
                }
                /* Probably not needed
        const allowedTypes = ['video', 'audio', 'image'];
        const fileType = currentFile.type.split('/')[0]; // Extract the file type from the MIME type

        if (!allowedTypes.includes(fileType)) {
          // log to console
          this.instance.log(`Skipping file ${currentFile.name} because it's not an allowed file type`);
          // show error message to the user
          this.instance.info(`Skipping file ${currentFile.name} because it's not an allowed file type`, 'error', 500);
          return false; // Exclude the file
        }

        // Prevent SVG files from being uploaded
        if (currentFile.type === 'image/svg+xml' || currentFile.name.endsWith('.svg')) {
          this.instance.info(`Skipping file ${currentFile.name} because SVG files are not allowed`, 'error', 500);
          return false; // Exclude the file
        }

        // Prevent PSD files from being uploaded
        if (currentFile.type === 'image/vnd.adobe.photoshop' || currentFile.name.endsWith('.psd')) {
          this.instance.info(`Skipping file ${currentFile.name} because PSD files are not allowed`, 'error', 500);
          return false; // Exclude the file
        }*/ return true; // Include the file
            }
        })//.use(GoldenRetriever)
        .use((0, $b868dcf7a47332e3$export$2e2bcd8739ae039), {
            target: el,
            inline: true,
            //trigger: '#open-account-dropzone-button',
            showLinkToFileUploadResult: false,
            showProgressDetails: true,
            note: "Images, video and audio only, up to your storage limit, and 4GB per file",
            fileManagerSelectionType: "both",
            proudlyDisplayPoweredByUppy: false,
            theme: "dark",
            closeAfterFinish: false,
            width: "100%",
            height: "100%"
        }).use((0, $a4ffb8658443fda4$export$2e2bcd8739ae039), {
            target: (0, $b868dcf7a47332e3$export$2e2bcd8739ae039)
        }).use((0, $cf91058fd9d7f8ee$export$2e2bcd8739ae039), {
            endpoint: "/api/v2/account/files/uppy",
            method: "post",
            formData: true,
            bundle: false,
            limit: 3,
            shouldRetry: (xhr)=>{
                // Retry on 5xx errors
                return xhr.status >= 500 && xhr.status !== 504 && xhr.status < 600;
            },
            timeout: 60,
            meta: {
                folderName: "",
                folderHierarchy: [],
                noTransform: false
            }
        }).use((0, $48e067fa1f2b2231$export$2e2bcd8739ae039), {
            target: dropTarget,
            onDragLeave: (event)=>{
                if (typeof onDragLeaveCallback === "function") onDragLeaveCallback(event);
            },
            onDragOver: (event)=>{
                if (typeof onDragOverCallback === "function") onDragOverCallback(event);
            },
            onDrop: (event)=>{
                if (typeof onDropCallback === "function") onDropCallback(event);
            }
        }).on("upload-success", (file, response)=>{
            if (Array.isArray(response.body)) {
                const fileResponse = response.body.find((f)=>f.id === file.id);
                if (fileResponse) this.instance.setFileMeta(file.id, {
                    name: fileResponse.name,
                    type: fileResponse.type,
                    size: fileResponse.size
                });
            } else this.instance.setFileMeta(file.id, {
                name: response.body.name,
                type: response.body.type,
                size: response.body.size
            });
        }).on("upload-success", (file, response)=>{
            console.debug("Upload result:", response);
            // Set uploadComplete state for the file
            file.progress.uploadComplete = true;
            //this.instance.removeFile(file.id);
            const fd = response.body.fileData;
            console.debug("File uploaded:", fd);
            // Get folderName from uppy file metadata
            const folderName = JSON.parse(file.meta.folderName);
            // Check if folderName is default home folder
            const fileFolderName = folderName === "" ? menuStore1.folders.find((folder)=>folder.id === 0).name : folderName;
            // Update the file stats for the folder
            menuStore1.updateFolderStatsFromFile(fd, fileFolderName, true);
            // Preload image variants only with image/* MIME type
            if (fd.mime.startsWith("image/")) {
                const urls = [
                    ...Object.values(fd.responsive),
                    fd.thumb,
                    fd.url
                ];
                imageVariantsPrecache(urls).then(()=>{
                    console.debug("Image variants pre-caching completed.");
                // Additional code to run after pre-caching is done
                }).catch((error)=>{
                    console.error("Error during image variants pre-caching:", error);
                // Handle any errors that occurred during pre-caching
                });
            }
            // Inject file into the fileStore files array if activeFolder matches 
            if (menuStore1.activeFolder === fileFolderName) {
                // Remove the file from the currentUploads
                this.mainDialog.removeFile(file.id);
                // Remove the file with file.id from the fileStore.files array
                fileStore.files = fileStore.files.filter((f)=>f.id !== file.id);
                // Inject fd into the fileStore.files array if it doesn't exist
                if (!fileStore.files.some((f)=>f.id === fd.id)) fileStore.injectFile(fd);
            } else // Remove the file from the currentUploads
            this.mainDialog.removeFile(file.id);
        }).on("file-added", (file)=>{
            // Check if the active folder ID is not 0
            const activeFolder = menuStore1.activeFolder;
            const activeFolderId = menuStore1.folders.find((folder)=>folder.name === activeFolder).id;
            const defaultFolder = activeFolderId === 0 ? "" : activeFolder;
            const noTransform = menuStore1.noTransform ?? false;
            console.debug("Active folder (Uppy):", activeFolder, activeFolderId, defaultFolder);
            //console.debug('Added file', file);
            const path = file.data.relativePath ?? file.data.webkitRelativePath;
            let folderHierarchy = [
                defaultFolder
            ];
            let folderName = defaultFolder;
            if (path && activeFolderId === 0) {
                const folderPath = path.replace(/\\/g, "/"); // Normalize backslashes to forward slashes
                const folderPathParts = folderPath.split("/").filter((part)=>part !== "");
                folderHierarchy = folderPathParts.length > 1 ? folderPathParts.slice(0, -1) : [
                    defaultFolder
                ];
                folderName = folderHierarchy.length > 0 ? folderHierarchy[folderHierarchy.length - 1] : defaultFolder;
                this.mainDialog.uploadFolder = folderName;
                // Add folder to the folder list if not already present
                const folderExists = menuStore1.folders.some((folder)=>folder.name === folderName);
                if (!folderExists) {
                    const folder = {
                        id: folderName,
                        name: folderName,
                        icon: folderName.substring(0, 1).toUpperCase(),
                        route: "#",
                        allowDelete: false
                    };
                    // Add the folder to the folders list
                    menuStore1.folders.push(folder);
                    // Sort the folders list
                    menuStore1.folders = menuStore1.folders.sort((a, b)=>a.name.localeCompare(b.name));
                }
            } else this.mainDialog.uploadFolder = defaultFolder;
            console.debug("Folder name", folderName);
            console.debug("Folder hierarchy", folderHierarchy);
            this.instance.setFileMeta(file.id, {
                folderName: JSON.stringify(folderName),
                folderHierarchy: JSON.stringify(folderHierarchy),
                noTransform: noTransform
            });
            console.debug("File added:", file);
            const currentFile = {
                id: file.id,
                name: file.name,
                mime: "uppy/upload",
                media_type: "uppy",
                size: file.size,
                loaded: false,
                folder: folderName,
                uppy: {
                    uploadComplete: false,
                    uploadError: false,
                    errorMessage: "",
                    errorResponse: null,
                    progress: 0,
                    bytesUploaded: 0
                }
            };
            // Add the file to the currentUploads
            this.mainDialog.addFile(currentFile);
            if (folderName === defaultFolder) fileStore.injectFile(currentFile);
        }).on("upload", (data1)=>{
            console.debug("Upload started:", data1);
            this.mainDialog.isLoading = true;
        }).on("complete", (result)=>{
            // Iterate of the successful uploads and see if any of them have folderName metadata
            // that match menuStore.activeFolder
            const isInHomeFolder = menuStore1.folders.find((folder)=>folder.name === menuStore1.activeFolder).id === 0;
            const activeFolderMatch = result.successful.some((file)=>{
                const folderName = JSON.parse(file.meta.folderName);
                return folderName === menuStore1.activeFolder || isInHomeFolder && folderName === "";
            });
            // If the failed upload count is zero, all uploads succeeded
            if (result.failed.length === 0) {
                //location.reload(); // reload the page
                console.debug("Upload complete:", result);
                // Mark dialog as done!
                this.instance.cancelAll();
                // Close the dialog
                this.mainDialog.close();
                // Clear progress
                this.mainDialog.uploadProgress = null;
                // Clear currentFiles
                this.mainDialog.clearFiles();
            } else {
                // Remove successful uploads
                result.successful.forEach((file)=>{
                    this.instance.removeFile(file.id);
                    this.mainDialog.removeFile(file.id);
                });
                // Open the dialog
                this.mainDialog.open();
            }
            // Refresh the files
            if (activeFolderMatch) {
                // We are still in the same folder, so refresh the files
                console.debug("Refreshing files:", menuStore1.activeFolder);
                fileStore.refreshFoldersAfterFetch = true;
                fileStore.fetchFiles(menuStore1.activeFolder, true);
            } else // We are not in the same folder, we may want to preemtively refresh folder list
            menuStore1.fetchFolders();
            // Reset the isLoading state
            this.mainDialog.isLoading = false;
        }).on("progress", (progress)=>{
            // progress: integer (total progress percentage)
            this.mainDialog.uploadProgress = progress + "%";
        }).on("upload-progress", (file, progress)=>{
            // Update the file progress in the fileStore
            const fileData = this.mainDialog.getFileById(file.id);
            const fileProgress = progress.bytesUploaded / progress.bytesTotal;
            if (fileData) {
                fileData.uppy.progress = Math.round(fileProgress * 100);
                fileData.uppy.bytesUploaded = progress.bytesUploaded;
            }
        }).on("upload-error", (file, error, response)=>{
            console.debug("error with file:", file.id);
            console.debug("error message:", error);
            console.debug("error response:", response);
            // Find the file in the fileStore and mark it as errored
            const fileData = this.mainDialog.getFileById(file.id);
            if (fileData) {
                fileData.uppy.uploadError = true;
                fileData.uppy.errorMessage = error.message;
                fileData.uppy.errorResponse = response;
            }
            // If we receive a 401 error, it means the user is not authenticated
            if (response && response.status === 401) {
                // Redirect to login page
                console.debug("User is not authenticated, redirecting to login page...");
                profileStore1.unauthenticated = true;
            }
        }).on("info-visible", ()=>{
            const { info: info } = this.instance.getState();
            // info: {
            //  isHidden: false,
            //  type: 'error',
            //  message: 'Failed to upload',
            //  details: 'Error description'
            // }
            console.debug(`Info: ${info.type} ${info.message} ${info.details}`);
        }).on("file-removed", (file)=>{
            console.debug("File removed:", file);
            // Remove the file from the fileStore
            this.mainDialog.removeFile(file.id);
            // Remove file from the fileStore
            fileStore.files = fileStore.files.filter((f)=>f.id !== file.id);
            // If no more files in uppy reset prgress and close the dialog
            if (this.instance.getFiles().length === 0) {
                this.mainDialog.uploadProgress = null;
                this.mainDialog.isLoading = false;
                this.mainDialog.clearFiles();
            }
        }).on("upload-retry", (fileId)=>{
            console.debug("Retrying upload:", fileId);
            // Reset the uploadError state
            const fileData = this.mainDialog.getFileById(fileId);
            if (fileData) {
                fileData.uppy.uploadError = false;
                fileData.uppy.errorMessage = "";
                fileData.uppy.errorResponse = null;
            }
        }).on("retry-all", ()=>{
            console.debug("Retrying all uploads");
            // Reset the uploadError state for all files
            this.mainDialog.currentFiles.forEach((file)=>{
                file.uppy.uploadError = false;
                file.uppy.errorMessage = "";
                file.uppy.errorResponse = null;
            });
        }).on("thumbnail:generated", (file, preview)=>{
            // This depends on Dashboard plugin
            // Update the file preview in the fileStore
            const fileData = this.mainDialog.getFileById(file.id);
            if (fileData) fileData.uppy.preview = preview;
        });
        console.debug("Uppy instance created:", el.id);
        // Dynamic note
        (0, $dc6El.default).effect(()=>{
            if (this.instance) {
                // Determine if user has less than 4GB remaining storage
                const byteLimit = profileStore1.profileInfo.storageRemaining < 4294967296 ? profileStore1.profileInfo.storageRemaining : 4294967296;
                const allowedFileTypes = this.getAllowedFileTypes(profileStore1.profileInfo.accountLevel);
                let note = "Images, video, audio";
                switch(profileStore1.profileInfo.accountLevel){
                    case 10:
                    case 99:
                        note += ", including documents and archives";
                        break;
                    case 1:
                        note += ", including documents";
                        break;
                }
                note += `, up to your storage limit, and ${formatBytes(byteLimit)} per file`;
                this.instance.setOptions({
                    restrictions: {
                        maxFileSize: byteLimit,
                        maxTotalFileSize: profileStore1.profileInfo.storageRemaining,
                        allowedFileTypes: allowedFileTypes
                    }
                });
                this.instance.getPlugin("Dashboard").setOptions({
                    note: note
                });
            }
        });
    }
});
(0, $dc6El.default).store("GAI", {
    ImageShow: false,
    ImageLoading: false,
    ImageUrl: "",
    ImageTitle: "",
    ImagePrompt: "",
    ImageFilesize: "",
    ImageDimensions: "0x0",
    file: {},
    clearImage () {
        this.ImageShow = false;
        this.ImageUrl = "";
        this.ImageTitle = "";
        this.ImagePrompt = "";
        this.ImageFilesize = "";
        this.ImageDimensions = "0x0";
    },
    async generateImage (title, prompt, selectedModel, negativePrompt = "", aspectRatio = "1:1", stylePreset = "") {
        // Access the form inputs passed as arguments
        console.debug("Title:", title);
        console.debug("Prompt:", prompt);
        console.debug("Selected Model:", selectedModel);
        console.debug("Negative Prompt:", negativePrompt);
        console.debug("Aspect Ratio:", aspectRatio);
        console.debug("Style Preset:", stylePreset);
        // Switch to aiImagesFolderName folder
        menuStore = (0, $dc6El.default).store("menuStore");
        profileStore = (0, $dc6El.default).store("profileStore");
        if (menuStore.activeFolder !== $541ddb8841663b5e$var$aiImagesFolderName) {
            console.debug("Switching to folder:", $541ddb8841663b5e$var$aiImagesFolderName);
            console.debug("Current folder:", menuStore.activeFolder);
            menuStore.setActiveFolder($541ddb8841663b5e$var$aiImagesFolderName);
        }
        // Prepare form data to send to the server
        const formData = {
            title: title,
            prompt: prompt,
            model: selectedModel,
            action: "generate_ai_image",
            negative_prompt: negativePrompt,
            aspect_ratio: aspectRatio,
            style_preset: stylePreset
        };
        // Send the form data to the server
        this.ImageShow = false;
        this.ImageLoading = true;
        const api = getApiFetcher($541ddb8841663b5e$var$apiUrl, "multipart/form-data");
        api.post("", formData, {
            timeout: 60000 // AI model generation can take a while
        }).then((response)=>response.data).then((data1)=>{
            console.debug("Generated image:", data1);
            this.ImageUrl = data1.url;
            this.ImageFilesize = data1.size;
            this.ImageDimensions = `${data1.width}x${data1.height}`;
            this.ImageTitle = title.length > 0 ? title : data1.name;
            this.ImagePrompt = prompt;
            //this.ImageShow = true;
            data1.title = title;
            data1.ai_prompt = prompt;
            // Update the file stats for the folder
            menuStore.updateFolderStatsFromFile(data1, $541ddb8841663b5e$var$aiImagesFolderName, true);
            // Update availableCredits and debitedCredits
            if (selectedModel === "@sd/core") {
                profileStore.profileInfo.availableCredits -= 3;
                profileStore.profileInfo.debitedCredits += 3;
            }
            // Add file to the grid
            (0, $dc6El.default).store("fileStore").injectFile(data1);
            this.file = data1;
        }).catch((error)=>{
            console.error("Error generating image:", error);
            this.ImageLoading = false;
        }).finally(()=>{
            //this.ImageLoading = false;
            console.debug("Image loading:", this.ImageLoading);
        });
    }
});
// Register an AlpineJS effect to warn users about leaving the page or refreshing when uploading files via uppy or URL import
(0, $dc6El.default).effect(()=>{
    const uppyStore = (0, $dc6El.default).store("uppyStore");
    const urlImportStore = (0, $dc6El.default).store("urlImportStore");
    const GAI = (0, $dc6El.default).store("GAI");
    const menuStore1 = (0, $dc6El.default).store("menuStore");
    const fileStore = (0, $dc6El.default).store("fileStore");
    const profileStore1 = (0, $dc6El.default).store("profileStore");
    const isUploading = uppyStore.mainDialog.isLoading;
    const isImporting = urlImportStore.isLoading;
    const isGenerating = GAI.ImageLoading;
    const isUploadingFiles = isUploading || isImporting || isGenerating;
    if (isUploadingFiles) window.onbeforeunload = function(e) {
        e.preventDefault();
        e.returnValue = "Are you sure you want to leave? Your files are still uploading.";
        return e.returnValue;
    };
    else window.onbeforeunload = null;
});
// MUST BE EXECUTED AFTER ALL STORES ARE DEFINED
(0, $dc6El.default).start();

})();
//# sourceMappingURL=account-v2.js.map
